import trainingAdminTranslations from "../app/components/dashboard/training/trainingAdminTranslations";
import { trainingParticipantSv } from "./trainingParticipantTranslations";
export const sv = {


    translation: {
        "trainingAdmin.jsonLanguage": "Okänt språk. Använd nb, en, sv eller pl, och översätt inte till kursens eget språk.",
        "trainingAdmin.jsonLanguageMismatch": "JSON-filen är skriven på ett annat språk än kursen. Ta med en komplett översättning till kursens språk, eller använd ”Ersätt innehåll”.",
        "trainingAdmin.jsonTranslations": "En översättning hänvisar till en sida, ett kort eller ett svarsalternativ som inte finns i kursen.",
        "trainingAdmin.languages": "Språk",
        "trainingAdmin.validationTranslations": "Slutför eller ta bort översättningar som saknar text före publicering.",
        "trainingAdmin.translation.baseTitle": "Kursens språk",
        "trainingAdmin.translation.baseHint": "Språket kursen är skriven på. Deltagarna ser det här språket om kursen inte finns på deras språk.",
        "trainingAdmin.translation.title": "Översättningar",
        "trainingAdmin.translation.hint": "Lägg till de språk kursen ska finnas på. Deltagarna väljer språk högst upp i kursen. Frågor, facit, dokument och bilder är desamma på alla språk, och svaren gäller oavsett språk.",
        "trainingAdmin.translation.missing": "Saknas: {{count}}",
        "trainingAdmin.translation.complete": "Komplett",
        "trainingAdmin.translation.edit": "Redigera",
        "trainingAdmin.translation.ai": "Översätt med AI",
        "trainingAdmin.translation.aiBusy": "Översätter …",
        "trainingAdmin.translation.aiDone": "AI fyllde i {{count}} texter. Läs igenom dem före publicering.",
        "trainingAdmin.translation.add": "Lägg till språk:",
        "trainingAdmin.translation.saveFirst": "Spara kursen innan du använder AI-översättning.",
        "trainingAdmin.translation.editorTitle": "Översättning till {{language}}",
        "trainingAdmin.translation.onlyMissing": "Visa bara texter som saknas",
        "trainingAdmin.translation.nothingMissing": "Alla texter är översatta.",
        "trainingAdmin.translation.done": "Stäng översättningen",
        "trainingAdmin.translation.courseTitle": "Kurstitel",
        "trainingAdmin.translation.courseDescription": "Kursbeskrivning",
        "trainingAdmin.translation.pageTitle": "Sidrubrik",
        "trainingAdmin.translation.cardTitle": "Kortrubrik",
        "trainingAdmin.translation.cardBody": "Innehåll",
        "trainingAdmin.translation.explanation": "Förklaring efter svar",
        "trainingAdmin.translation.imageAlt": "Bildtext (alternativ text)",
        "trainingAdmin.translation.option": "Svarsalternativ",
        "trainingParticipant.languages.title": "Kursen finns på flera språk",
        "trainingParticipant.languages.hint": "Välj språket du vill gå kursen på. Dina svar gäller på alla språk.",
        "trainingParticipant.languages.choose": "Välj språk för kursen",
        "pmStepper.decrease": "Minska",
        "pmStepper.increase": "Öka",
        "hseCompliance.source.manual": "Tillagd",
        "hseCompliance.source.audience": "Målgrupp",
        "hseCompliance.source.training": "Via utbildning",
        "hseCompliance.source.training_named": "Utbildning: {{title}}",
        "hseCompliance.source.creator": "Författare",
        "hseCompliance.status.acknowledged": "Bekräftad",
        "hseCompliance.status.pending": "Väntar",
        "hseCompliance.status.pending_due": "Frist {{date}}",
        "hseCompliance.status.overdue": "Försenad",
        "hseCompliance.status.optional": "Inte obligatorisk",
        "hseCompliance.status.no_access": "Inte tilldelad",
        "hseCompliance.status.exempt": "Författare",
        "hseCompliance.via.training": "via utbildning",
        "hseCompliance.via.carried_forward": "överförd från föregående version",
        "hseCompliance.via.creator": "författare",
        "hseCompliance.due.overdue_flag": "Försenad",
        "hseCompliance.due.soon_flag": "Snart",
        "hseCompliance.postpone.dots_label": "{{used}} av {{max}} uppskjutningar använda",
        "hseCompliance.people.search": "Sök efter person …",
        "hseCompliance.people.empty": "Inga träffar",
        "hseCompliance.people.remove": "Ta bort {{name}}",
        "hseCompliance.people.selected": "{{count}} valda",
        "hseCompliance.audience.all": "Alla anställda",
        "hseCompliance.audience.all_desc": "{{count}} anställda nu – nyanställda får åtkomst automatiskt",
        "hseCompliance.audience.positions": "Utvalda befattningar",
        "hseCompliance.audience.positions_desc": "Följer befattningen – ändras när någon byter befattning",
        "hseCompliance.audience.none": "Endast utvalda personer",
        "hseCompliance.audience.none_desc": "Endast personerna du lägger till och deltagare i utbildning som använder dokumentet",
        "hseCompliance.dialog.menu_label": "Åtkomst och läskrav",
        "hseCompliance.dialog.eyebrow": "Arbetsmiljödokument",
        "hseCompliance.dialog.title": "Åtkomst och läskrav",
        "hseCompliance.dialog.title_bulk": "Åtkomst och läskrav för {{count}} dokument",
        "hseCompliance.dialog.subtitle": "Vem som ska läsa dokumentet och när det måste vara bekräftat",
        "hseCompliance.dialog.subtitle_bulk": "Slå på delarna du vill ändra. Resten behålls per dokument.",
        "hseCompliance.dialog.load_error": "Kunde inte läsa in åtkomst och läskrav",
        "hseCompliance.dialog.save_error": "Kunde inte spara åtkomst och läskrav",
        "hseCompliance.dialog.saved": "Åtkomst och läskrav har sparats",
        "hseCompliance.dialog.saved_bulk": "Sparat för {{count}} dokument",
        "hseCompliance.dialog.save": "Spara",
        "hseCompliance.dialog.save_bulk": "Tillämpa på {{count}} dokument",
        "hseCompliance.dialog.bulk_action": "Åtkomst och läskrav ({{count}})",
        "hseCompliance.dialog.audience_title": "Vem har åtkomst",
        "hseCompliance.dialog.audience_hint": "En regel gäller även nyanställda. Du slipper uppdatera varje dokument.",
        "hseCompliance.dialog.positions_label": "Befattningar",
        "hseCompliance.dialog.positions_empty": "Företaget har inga aktiva befattningar. Lägg till dem under anställda.",
        "hseCompliance.dialog.people_extra_label": "Ytterligare personer",
        "hseCompliance.dialog.people_only_label": "Personer med åtkomst",
        "hseCompliance.dialog.people_add_label": "Lägg till personer",
        "hseCompliance.dialog.people_help": "Ge åtkomst till personer utanför regeln, till exempel inhyrda.",
        "hseCompliance.dialog.people_add_help": "Personerna läggs till på alla valda dokument. Ingen tas bort.",
        "hseCompliance.dialog.reach": "{{count}} av {{total}} anställda får åtkomst (utöver deltagare i utbildning).",
        "hseCompliance.dialog.reach_bulk": "Regeln ger {{count}} anställda åtkomst i dag.",
        "hseCompliance.dialog.requirement_title": "Läskrav",
        "hseCompliance.dialog.requirement_hint": "Obligatoriska dokument får frist, påminnelse och avisering till chef och arbetsmiljöansvarig.",
        "hseCompliance.dialog.required_label": "Måste läsas och bekräftas",
        "hseCompliance.dialog.required_desc": "Alla med åtkomst måste bekräfta «läst och förstått» inom fristen. Genomförd utbildning med dokumentet räknas.",
        "hseCompliance.dialog.not_required_help": "Dokumentet finns tillgängligt som referens. Ingen frist eller påminnelser.",
        "hseCompliance.dialog.deadline_label": "Frist",
        "hseCompliance.dialog.deadline_help": "Från tilldelning – även för nyanställda och nya versioner.",
        "hseCompliance.dialog.postponements_label": "Antal uppskjutningar",
        "hseCompliance.dialog.postponements_help": "Hur många gånger den anställda själv kan skjuta upp.",
        "hseCompliance.dialog.postpone_days_label": "Max per uppskjutning",
        "hseCompliance.dialog.postpone_days_help": "När uppskjutningarna är slut aviseras chef och arbetsmiljöansvarig.",
        "hseCompliance.dialog.days": "dagar",
        "hseCompliance.dialog.training_title": "Via utbildning",
        "hseCompliance.dialog.training_hint": "Utbildning som använder dokumentet ger deltagarna åtkomst, och genomförd utbildning räknas som bekräftad.",
        "hseCompliance.dialog.training_empty": "Ingen aktiv utbildning använder det här dokumentet.",
        "hseCompliance.dialog.fact_readers": "Har åtkomst",
        "hseCompliance.dialog.fact_readers_value": "{{count}} av {{total}}",
        "hseCompliance.dialog.open_employees": "Se rutiner per anställd →",
        "hseCompliance.dialog.change_access": "Ändra åtkomst",
        "hseCompliance.dialog.change_requirement": "Ändra läskrav",
        "hseCompliance.dialog.error_positions": "Välj minst en befattning.",
        "hseCompliance.dialog.error_nothing": "Slå på det du vill ändra.",
        "hseCompliance.notice.exempt_title": "Du är författare",
        "hseCompliance.notice.exempt_desc": "Författaren behöver inte bekräfta sitt eget dokument.",
        "hseCompliance.notice.done_title": "Läst och förstått",
        "hseCompliance.notice.done_direct": "Du bekräftade {{date}}.",
        "hseCompliance.notice.done_training": "Bekräftat genom genomförd utbildning {{date}}. Du behöver inte bekräfta igen.",
        "hseCompliance.notice.done_carried": "Ändringen i den här versionen krävde ingen ny bekräftelse.",
        "hseCompliance.notice.optional_title": "För kännedom",
        "hseCompliance.notice.optional_desc": "Dokumentet behöver inte bekräftas, men du kan gärna bekräfta att du har läst det.",
        "hseCompliance.notice.due_title": "Ska läsas senast {{date}} ({{count}} dagar kvar)",
        "hseCompliance.notice.due_title_one": "Ska läsas senast {{date}} (1 dag kvar)",
        "hseCompliance.notice.overdue_title": "Fristen var {{date}}",
        "hseCompliance.notice.required_desc": "Läs dokumentet och bekräfta att du har läst och förstått det. Chef och arbetsmiljöansvarig aviseras när fristen passeras.",
        "hseCompliance.notice.postponements_left": "{{count}} uppskjutningar kvar",
        "hseCompliance.notice.postponements_left_one": "1 uppskjutning kvar",
        "hseCompliance.notice.postpone": "Skjut upp",
        "hseCompliance.notice.postpone_choose": "Välj antal dagar",
        "hseCompliance.notice.postpone_confirm": "Skjut upp {{count}} dagar",
        "hseCompliance.notice.postpone_confirm_one": "Skjut upp 1 dag",
        "hseCompliance.notice.days": "{{count}} dagar",
        "hseCompliance.notice.days_one": "1 dag",
        "hseCompliance.notice.postponed": "Ny frist: {{date}}",
        "hseCompliance.reminder.label": "Läskrav för arbetsmiljödokument",
        "hseCompliance.reminder.title": "{{count}} rutiner måste läsas och bekräftas",
        "hseCompliance.reminder.title_one": "1 rutin måste läsas och bekräftas",
        "hseCompliance.reminder.overdue_title": "{{count}} rutiner har passerat sista dagen",
        "hseCompliance.reminder.overdue_title_one": "1 rutin har passerat sista dagen",
        "hseCompliance.reminder.next_due": "Nästa sista dag {{date}}",
        "hseCompliance.reminder.was_due": "Sista dagen var {{date}}",
        "hseCompliance.reminder.open_one": "Läs nu",
        "hseCompliance.reminder.open_all": "Visa rutinerna",
        "hseCompliance.reminder.snooze": "Dölj i en timme",
        "hseCompliance.home.none": "Inga rutiner väntar på dig",
        "hseCompliance.home.required": "{{count}} obligatoriska rutiner väntar på dig",
        "hseCompliance.home.required_one": "1 obligatorisk rutin väntar på dig",
        "hseCompliance.home.overdue": "{{count}} har passerat sista dagen",
        "hseCompliance.home.overdue_one": "1 har passerat sista dagen",
        "hseCompliance.home.show_all": "Visa alla ({{count}})",
        "employee_handbook.library.no_chapter": "Utan kapitel",
        "employee_handbook.library.must_read_title": "Måste läsas ({{count}})",
        "employee_handbook.library.must_read_hint": "Obligatoriska rutiner. Läs och bekräfta före sista dagen.",
        "employee_handbook.library.show_all": "Visa alla ({{count}})",
        "employee_handbook.library.search": "Sök på titel, nummer eller kapitel",
        "employee_handbook.library.clear_search": "Rensa sökning",
        "employee_handbook.library.filter_label": "Visa dokument",
        "employee_handbook.library.filter_all": "Alla",
        "employee_handbook.library.filter_required": "Måste läsas",
        "employee_handbook.library.filter_done": "Bekräftade",
        "employee_handbook.library.discipline_label": "Fackområde",
        "employee_handbook.library.discipline_all": "Alla fackområden",
        "employee_handbook.library.toc": "Kapitel",
        "employee_handbook.library.toc_all": "Alla kapitel",
        "employee_handbook.library.results": "{{count}} dokument",
        "employee_handbook.library.results_one": "1 dokument",
        "employee_handbook.library.empty_title": "Inga dokument matchar",
        "employee_handbook.library.empty_desc": "Prova en annan sökning eller rensa filtren.",
        "employee_handbook.library.clear": "Rensa filter",
        "hseCompliance.notice.postpone_error": "Kunde inte skjuta upp fristen",
        "hseCompliance.employees.title": "Rutiner per anställd",
        "hseCompliance.employees.subtitle": "Obligatorisk läsning, frister och åtkomst för varje anställd",
        "hseCompliance.employees.read_overview": "Läst / förstått",
        "hseCompliance.employees.kpi_overdue": "Anställda med försenat",
        "hseCompliance.employees.kpi_overdue_hint": "{{count}} försenade dokument totalt",
        "hseCompliance.employees.kpi_pending": "Väntar på bekräftelse",
        "hseCompliance.employees.kpi_pending_hint": "Inom fristen",
        "hseCompliance.employees.kpi_employees": "Anställda",
        "hseCompliance.employees.kpi_documents": "Godkända rutiner",
        "hseCompliance.employees.search": "Sök efter anställd eller befattning",
        "hseCompliance.employees.filter": "Filter",
        "hseCompliance.employees.filter_all": "Alla",
        "hseCompliance.employees.filter_overdue": "Försenade",
        "hseCompliance.employees.filter_pending": "Väntar",
        "hseCompliance.employees.filter_missing": "Saknar åtkomst",
        "hseCompliance.employees.col_employee": "Anställd",
        "hseCompliance.employees.col_progress": "Obligatorisk läsning",
        "hseCompliance.employees.col_next_due": "Nästa frist",
        "hseCompliance.employees.col_without_access": "Inte tilldelade",
        "hseCompliance.employees.progress_label": "{{done}} av {{total}} bekräftade",
        "hseCompliance.employees.empty_title": "Inga anställda att visa",
        "hseCompliance.employees.empty_desc": "Inga träffar för sökningen eller filtret.",
        "hseCompliance.employees.clear_filters": "Rensa filter",
        "hseCompliance.routines.title": "Rutiner för anställd",
        "hseCompliance.routines.subtitle": "Alla godkända arbetsmiljörutiner",
        "hseCompliance.routines.kpi_overdue": "Försenade",
        "hseCompliance.routines.kpi_pending": "Väntar",
        "hseCompliance.routines.kpi_acknowledged": "Bekräftade",
        "hseCompliance.routines.kpi_no_access": "Inte tilldelade",
        "hseCompliance.routines.search": "Sök i rutiner",
        "hseCompliance.routines.filter": "Filter",
        "hseCompliance.routines.filter_all": "Alla",
        "hseCompliance.routines.filter_no_access": "Inte tilldelade",
        "hseCompliance.routines.filter_pending": "Väntar",
        "hseCompliance.routines.filter_overdue": "Försenade",
        "hseCompliance.routines.filter_acknowledged": "Bekräftade",
        "hseCompliance.routines.manage_hint": "Välj rutiner för att ge åtkomst eller ta bort åtkomst du har lagt till. Åtkomst från målgrupp och utbildning styrs på dokumentet och i utbildningen.",
        "hseCompliance.routines.change_error": "Kunde inte ändra åtkomsten",
        "hseCompliance.routines.granted": "Åtkomst given till {{count}} rutiner",
        "hseCompliance.routines.revoked": "Åtkomst borttagen från {{count}} rutiner",
        "hseCompliance.routines.no_chapter": "Utan kapitel",
        "hseCompliance.routines.former_title": "Tidigare anställd",
        "hseCompliance.routines.former_desc": "Personen har slutat. Historiken visas, men inga nya frister sätts.",
        "hseCompliance.routines.empty_title": "Inga rutiner att visa",
        "hseCompliance.routines.empty_desc": "Inga träffar för sökningen eller filtret.",
        "hseCompliance.routines.select_all": "Välj alla synliga",
        "hseCompliance.routines.select_one": "Välj {{title}}",
        "hseCompliance.routines.col_document": "Rutin",
        "hseCompliance.routines.col_access": "Åtkomst",
        "hseCompliance.routines.col_status": "Status",
        "hseCompliance.routines.col_due": "Frist",
        "hseCompliance.routines.col_action": "Åtgärd",
        "hseCompliance.routines.required": "Obligatorisk",
        "hseCompliance.routines.not_required": "Inte obligatorisk",
        "hseCompliance.routines.no_access": "Ingen åtkomst",
        "hseCompliance.routines.grant": "Ge åtkomst",
        "hseCompliance.routines.add_manual": "Lägg till fast",
        "hseCompliance.routines.remove": "Ta bort",
        "hseCompliance.routines.bulk_grant": "Ge åtkomst ({{count}})",
        "hseCompliance.routines.bulk_remove": "Ta bort åtkomst ({{count}})",
        "hseCompliance.overview.summary_overdue": "Försenade",
        "hseCompliance.overview.overdue_count": "{{count}} försenade",
        "hseCompliance.overview.open_routines": "Se rutiner för anställd",
        "hseCompliance.approve.eyebrow": "Godkänn revision",
        "hseCompliance.approve.title": "Godkänn version {{version}}",
        "hseCompliance.approve.subtitle": "Välj om ändringen kräver att de anställda bekräftar dokumentet igen",
        "hseCompliance.approve.reack_label": "Kräver ny läsbekräftelse",
        "hseCompliance.approve.reack_on": "Alla med läskrav måste läsa och bekräfta den nya versionen inom fristen.",
        "hseCompliance.approve.reack_off": "Mindre ändring: tidigare «läst och förstått» överförs. Endast de som inte hade bekräftat får frist.",
        "featureAnnouncements.eyebrow": "Ny funktion",
        "featureAnnouncements.eyebrow_counter": "Ny funktion · {{current}} av {{total}}",
        "featureAnnouncements.confirm": "Uppfattat",
        "featureAnnouncements.learn_more": "Visa mig",
        "featureAnnouncements.language.title": "Nytt språk: {{language}}",
        "featureAnnouncements.language.subtitle": "Promang finns nu på det här språket. Vill du byta språk?",
        "featureAnnouncements.language.hint": "Du kan byta språk när som helst i användarinställningarna.",
        "featureAnnouncements.language.keep": "Behåll {{language}}",
        "featureAnnouncements.language.switch": "Byt till {{language}}",
        "featureAnnouncements.language.switch_failed": "Det gick inte att spara språkvalet. Försök igen.",
        "agreementWorkflow.typeHint": "Välj avtalstyp och granska standardvärden, avtalstext och villkor.",
        "agreementWorkflow.applyDefaults": "Använd förslagen från typen",
        "agreementWorkflow.preserveEdits": "Fält du ändrat själv behålls när du byter typ eller mall.",
        "agreementWorkflow.draftHint": "Utkast och offerter ingår inte i serviceuppföljning. Avtalet aktiveras när kundens godkännande eller signering registrerats.",
        "agreementWorkflow.saveDraft": "Spara utkast",
        "agreementWorkflow.created": "Avtalsutkastet har skapats.",
        "agreementWorkflow.openAgreement": "Öppna avtalet",
        "agreementWorkflow.createdRefreshFailed": "Avtalet har skapats, men den relaterade vyn kunde inte uppdateras. Öppna avtalet för att fortsätta.",
        "agreementWorkflow.unknown": "Vi kunde inte bekräfta resultatet. Kontrollera avtalsstatus innan du försöker igen.",
        "agreementWorkflow.noticeMonths": "Uppsägningstid (månader)",
        "agreementWorkflow.durationYears": "Avtalstid (år)",
        "agreementWorkflow.agreementText": "Avtalstext",
        "agreementWorkflow.noFollowUp": "Ingen serviceuppföljning",
        "agreementWorkflow.title": "Avtalsfas och godkännande",
        "agreementWorkflow.activeHint": "Avtalet är aktivt och ingår i serviceuppföljningen.",
        "agreementWorkflow.toProposal": "Flytta till offertfas",
        "agreementWorkflow.toDraft": "Återgå till utkast",
        "agreementWorkflow.send": "Skicka offert till kunden",
        "agreementWorkflow.approve": "Registrera godkännande/signering",
        "agreementWorkflow.reject": "Markera avvisat",
        "agreementWorkflow.signingHint": "Avtalet väntar på signering. Återgång till utkast förhindrar att tidigare signering aktiverar avtalet.",
        "agreementWorkflow.approvalHint": "Registrera kundens godkännande eller manuella signering. Startdatum och serviceintervall krävs före aktivering.",
        "agreementWorkflow.approver": "Godkänt/signerat av hos kunden",
        "agreementWorkflow.approvedOn": "Datum för godkännande/signering",
        "agreementWorkflow.methodLabel": "Metod",
        "agreementWorkflow.method.manual_signature": "Manuell signering",
        "agreementWorkflow.method.manual_approval": "Manuellt godkännande",
        "agreementWorkflow.method.posten": "Signerat med Posten",
        "agreementWorkflow.evidence": "Signerad PDF (valfritt)",
        "agreementWorkflow.uploadEvidence": "Ladda upp signerad PDF under Dokument",
        "agreementWorkflow.documentsFailed": "Kunde inte hämta bilagor. Försök öppna dialogen igen.",
        "agreementWorkflow.confirmApproval": "Bekräfta och aktivera avtalet",
        "agreementWorkflow.sendHint": "Det sparade avtalet skickas som PDF. Utskicket aktiverar inte serviceuppföljning.",
        "agreementWorkflow.recipient": "Mottagarens e-post",
        "agreementWorkflow.recipientName": "Mottagarens namn",
        "agreementWorkflow.message": "Meddelande till kunden",
        "agreementWorkflow.sent": "Offerten har skickats.",
        "agreementWorkflow.sendUnknown": "Utskicket är inte bekräftat. Kontrollera e-postloggen och mottagaren innan ett eventuellt nytt utskick.",
        "agreementWorkflow.updated": "Avtalsfasen har uppdaterats.",
        "agreementWorkflow.updatedRefreshFailed": "Ändringen har sparats, men vyn kunde inte uppdateras.",
        "agreementWorkflow.refreshFailed": "Kunde inte kontrollera avtalsstatus. Försök igen.",
        "agreementWorkflow.checkStatus": "Kontrollera status",
        "agreementWorkflow.delivery.sent": "Skickat",
        "agreementWorkflow.delivery.sending": "Utskick påbörjat",
        "agreementWorkflow.delivery.unknown": "Oklart utskick",
        "agreementWorkflow.delivery.not_sent": "Inte skickat",
        "agreementWorkflow.resolveNotSent": "Markera som inte skickat",
        "agreementWorkflow.resolveSent": "Markera som skickat",
        "agreementWorkflow.resolvedNotSent": "Utskicket är markerat som inte skickat. Du kan skicka igen.",
        "agreementWorkflow.resolvedSent": "Utskicket är markerat som skickat. E-posten skickas inte igen.",
        "agreementWorkflow.status.draft": "Utkast",
        "agreementWorkflow.status.proposal": "Offertfas",
        "agreementWorkflow.status.awaiting_signature": "Väntar på signering",
        "agreementWorkflow.status.active": "Aktivt",
        "agreementWorkflow.status.rejected": "Avvisat",
        "agreementWorkflow.typeDefaults": "Förslag vid skapande",

        "labels.printSelected": "Skriv ut etiketter ({{count}})",
        "labels.fields.navn": "Namn",
        "labels.fields.nr": "Nummer",
        "labels.fields.pris": "Pris",
        "labels.fields.beskrivelse": "Beskrivning",
        "labels.fields.merke": "Märke",
        "labels.fields.kategori": "Kategori",
        "labels.fields.lokasjon": "Plats",
        "labels.fields.url": "Länk (QR)",
        "labels.fields.dato": "Datum",
        "labels.fields.kunde": "Kund",
        "labels.fields.adresse": "Adress",
        "labels.fields.modell": "Modell",
        "labels.fields.serienr": "Serienummer",
        "labels.fields.info": "Tilläggsinfo",
        "labels.designer.title": "Skriv ut etikett",
        "labels.designer.loading": "Hämtar data…",
        "labels.designer.prev": "Föregående",
        "labels.designer.next": "Nästa",
        "labels.designer.refresh": "Hämta data igen",
        "labels.designer.close": "Stäng",
        "labels.designer.printer": "Skrivare",
        "labels.designer.media": "Etikettrulle",
        "labels.designer.mediaContinuous": "{{id}} · {{w}} mm löpande",
        "labels.designer.mediaDieCut": "{{id}} · {{w}} × {{h}} mm",
        "labels.designer.length": "Längd i mm",
        "labels.designer.browserPrintHint": "Skrivs ut via webbläsarens utskriftsdialog",
        "labels.designer.autoLayout": "Autolayout",
        "labels.designer.autoLayoutHint": "Skapa standardlayout för den här etikettstorleken",
        "labels.designer.tools": "Element",
        "labels.designer.kind.text": "Text",
        "labels.designer.kind.barcode": "Streckkod",
        "labels.designer.kind.qr": "QR-kod",
        "labels.designer.kind.line": "Linje",
        "labels.designer.grid": "Rutnät",
        "labels.designer.zoomOut": "Zooma ut",
        "labels.designer.zoomFit": "Anpassa",
        "labels.designer.zoomIn": "Zooma in",
        "labels.designer.loadFailed": "Kunde inte hämta data till etiketten.",
        "labels.designer.retry": "Försök igen",
        "labels.designer.empty": "Inget att skriva ut.",
        "labels.designer.feedContinuous": "Löpande tejp · klipps automatiskt",
        "labels.designer.feedDieCut": "Stansad etikett",
        "labels.designer.overridden": "Manuellt åsidosatt",
        "labels.designer.inspector": "Egenskaper",
        "labels.designer.duplicate": "Duplicera",
        "labels.designer.delete": "Ta bort",
        "labels.designer.content": "Innehåll",
        "labels.designer.manual": "Manuellt",
        "labels.designer.fromData": "Från data",
        "labels.designer.dataValue": "Data",
        "labels.designer.reset": "Återställ",
        "labels.designer.template": "Mall",
        "labels.designer.templatePlaceholder": "Mall, t.ex. {navn}",
        "labels.designer.font": "Typsnitt",
        "labels.designer.size": "Storlek i pt",
        "labels.designer.weight": "Vikt",
        "labels.designer.weightNormal": "Normal",
        "labels.designer.weightBold": "Fet",
        "labels.designer.align": "Justering",
        "labels.designer.alignLeft": "Vänster",
        "labels.designer.alignCenter": "Mitten",
        "labels.designer.alignRight": "Höger",
        "labels.designer.shrinkToFit": "Krymp för att passa",
        "labels.designer.showText": "Visa text",
        "labels.designer.code39Info": "Code 39 · {{count}} tecken",
        "labels.designer.code39Dropped": "Code 39 stöder bara A–Z, 0–9, mellanslag, - och . – andra tecken utelämnas.",
        "labels.designer.widthShort": "B",
        "labels.designer.heightShort": "H",
        "labels.designer.geom.x": "X-position i mm",
        "labels.designer.geom.y": "Y-position i mm",
        "labels.designer.geom.w": "Bredd i mm",
        "labels.designer.geom.h": "Höjd i mm",
        "labels.designer.fields": "Datafält",
        "labels.designer.clickToInsert": "Klicka för att infoga",
        "labels.designer.newField": "Infoga {{field}}",
        "labels.designer.overrideCount": "{{count}} manuellt ändrade",
        "labels.designer.dots": "punkter",
        "labels.designer.copies": "Antal",
        "labels.designer.printAll": "Alla ({{count}})",
        "labels.designer.cancel": "Avbryt",
        "labels.designer.print": "Skriv ut",
        "labels.designer.sent": "{{count}} etiketter skickade till utskrift ({{printer}})",
        "labels.designer.printFailed": "Kunde inte öppna utskrift. Försök igen.",
        "labels.designer.newText": "Ny text",
        "inventory.picking.labels_for_lines": "Etiketter för alla artiklar i dokumentet",
        "inventory.picking.quick_print.tooltip": "Skriv ut etikett",
        "inventory.picking.quick_print.document_tooltip": "Dokumentetikett (nummer, kund, adress, typ)",
        "inventoryReceipt.syncTitle": "Lagerbokföring och synkronisering",
        "inventoryReceipt.localPosted": "Lagerfört i Promang",
        "inventoryReceipt.remoteConfirmed": "Mottagningen är också bekräftad i Tripletex. Återstående varor följer samma inköp.",
        "inventoryReceipt.remotePending": "Synkroniseringen med Tripletex är inte bekräftad ännu. Registrera inte mottagningen igen.",
        "inventoryReceipt.resumeHint": "Kontrollen läser status i Tripletex och fortsätter från det senaste bekräftade steget. Ändrade antal, produkter eller lager stoppas för avstämning.",
        "inventoryReceipt.resumeSync": "Kontrollera och slutför synk",
        "inventoryReceipt.checkingSync": "Kontrollerar Tripletex…",
        "inventoryReceipt.resumeFailed": "Synkroniseringen kunde inte bekräftas. Uppdatera status och granska avvikelser i lagerinställningarna. Mottagningen är fortfarande lagerförd lokalt.",
        "inventoryPurchase.sync.not_sent": "Inte synkroniserat",
        "inventory.stock.title": "Lagersaldo",
        "inventory.stock.subtitle": "Lagersaldo och tillgängligt antal per produkt, med lagerfilter och etikettutskrift.",
        "inventory.stock.search": "Sök produkter…",
        "inventory.stock.storage": "Lager",
        "inventory.stock.tracked": "Registrerat antal",
        "inventory.stock.min": "Min",
        "inventory.stock.max": "Max",
        "inventory.stock.legacyWarning": "Saldot bygger på äldre lageruppgifter utan godkänd öppningsbalans. Kontrollera värderingsrapporten före bokföringstolkning.",
        "inventory.stock.selection": "Valda produkter",
        "inventory.stock.selected": "{{count}} produkter valda",
        "inventory.stock.printLabels": "Skriv ut etiketter",
        "inventory.stock.loadFailed": "Kunde inte hämta lagersaldot. Försök igen.",
        "inventory.stock.loading": "Hämtar lagersaldo…",
        "inventory.stock.empty": "Inga produkter hittades",
        "inventory.stock.emptyHint": "Prova en annan sökning eller rensa filtren.",
        "inventory.stock.clearFilters": "Rensa filter",
        "inventory.stock.selectAll": "Välj alla synliga produkter",
        "inventory.stock.selectProduct": "Välj {{product}}",
        "inventory.stock.product": "Produkt",
        "inventory.stock.outgoing": "Utgående",
        "inventory.stock.incoming": "Inkommande",
        "inventory.stock.available": "Tillgängligt",
        "inventory.count.csv.invalid_quantity": "Rad {{row}} har ogiltigt antal. Använd noll eller ett positivt tal med högst fyra decimaler.",
        "inventoryPurchases.title": "Inköp",
        "inventoryPurchases.eyebrow": "Inköp",
        "inventoryPurchases.overview": "Inköpsöversikt",
        "inventoryPurchases.openOrders": "Öppna order",
        "inventoryPurchases.draftOrders": "Utkast",
        "inventoryPurchases.overdueOrders": "Försenade",
        "inventoryPurchases.exVat": "exkl. moms",
        "inventoryPurchases.unknownAmount": "Beloppet är inte komplett",
        "inventoryPurchases.activeOrders": "Aktiva beställningar",
        "inventoryPurchases.notSent": "Inte skickat till leverantör",
        "inventoryPurchases.pastDelivery": "Önskat leveransdatum passerat",
        "inventoryPurchases.statusTabs": "Inköpsstatus",
        "inventoryPurchases.tab.all": "Alla",
        "inventoryPurchases.tab.draft": "Utkast",
        "inventoryPurchases.tab.openTab": "Öppna",
        "inventoryPurchases.tab.received": "Mottagna",
        "inventoryPurchases.project": "Projekt",
        "inventoryPurchases.amount": "Belopp exkl. moms",
        "inventoryPurchases.lineCount": "{{count}} rader",
        "inventoryPurchases.overdue": "Försenad",
        "inventoryPurchase.details": "Detaljer",
        "inventoryPurchase.project": "Projekt",
        "inventoryPurchase.contact": "Kontaktperson hos leverantören",
        "inventoryPurchase.contactHint": "Välj eller skapa kontakt. Utskick använder den här e-postadressen först.",
        "inventoryPurchase.sendToContact": "Leverantörens kontakt",
        "inventoryPurchase.sendToContactNamed": "Kontakt · {{name}}",
        "inventoryPurchase.contactEmailMissing": "Kontaktpersonen saknar e-post.",
        "inventoryPurchase.chooseProject": "Välj projekt",
        "inventoryPurchase.deliveryAddress": "Leveransadress",
        "inventoryPurchase.localAddressHint": "Intern uppgift i Promang. Tripletex använder tills vidare företagets leveransadress.",
        "inventoryPurchase.costCode": "Kostnadskod",
        "inventoryPurchase.localCostCodeHint": "Intern kod i Promang, överförs inte till Tripletex.",
        "inventoryPurchase.summary": "Sammanfattning",
        "inventoryPurchase.netAmount": "Summa exkl. moms",
        "inventoryPurchase.grossAmount": "Totalt inkl. moms",
        "inventoryPurchase.orderLines": "Orderrader",
        "inventoryPurchase.itemNumber": "Art.nr",
        "inventoryPurchase.product": "Produkt",
        "inventoryPurchase.comment": "Kommentar",
        "inventoryPurchase.lineTotal": "Totalt",
        "inventoryPurchase.addProduct": "Lägg till produkt",
        "inventoryPurchase.addFirstProduct": "Lägg till första produkten",
        "inventoryPurchase.emptyLines": "Inga produkter tillagda ännu",
        "inventoryPurchase.send": "Skicka",
        "inventoryPurchase.sending": "Skickar…",
        "inventoryPurchase.sendAsMe": "Jag",
        "inventoryPurchase.lineTitle": "Varunamn",
        "inventoryPurchase.changeProduct": "Byt produkt",
        "inventoryPurchase.unit": "Enhet",
        "inventoryPurchase.saveDraft": "Spara utkast",
        "inventoryPurchase.sendToSupplier": "Skicka till leverantör",
        "inventoryPurchase.sendDialogTitle": "Skicka inköp till leverantör",
        "inventoryPurchase.sendMessageLabel": "Meddelande till leverantör",
        "inventoryPurchase.missingId": "ID saknas",
        "inventoryPurchase.sendFailed": "Något gick fel. Kunde inte skicka inköpet.",
        "inventoryPurchase.sendNeedsSave": "Spara utkastet innan du skickar. Utskick startades inte.",
        "inventoryPurchases.subtitle": "Leverantörsorder, leverans och Tripletex-status samlat på ett ställe.",
        "inventoryPurchases.new": "Nytt inköp",
        "inventoryPurchases.search": "Sök inköp…",
        "inventoryPurchases.filterStatus": "Filtrera på status",
        "inventoryPurchases.loading": "Hämtar inköp…",
        "inventoryPurchases.loadFailed": "Kunde inte hämta inköp. Försök igen.",
        "inventoryPurchases.number": "Inköpsnummer",
        "inventoryPurchases.supplier": "Leverantör",
        "inventoryPurchases.purchaseDate": "Inköpsdatum",
        "inventoryPurchases.deliveryDate": "Leveransdatum",
        "inventoryPurchases.status": "Status",
        "inventoryPurchases.delivery": "Leverantörsleverans",
        "inventoryPurchases.sync": "Tripletex",
        "inventoryPurchases.reference": "Referens",
        "inventoryPurchases.open": "Öppna",
        "inventoryPurchases.empty": "Inga inköp ännu",
        "inventoryPurchases.emptyHint": "Skapa ett inköp för att komma igång.",
        "inventoryPurchases.emptyFiltered": "Inga inköp matchar sökningen eller filtren.",
        "inventoryPurchases.clearFilters": "Rensa filter",
        "inventoryPurchases.status.draft": "Utkast",
        "inventoryPurchases.status.sent": "Skickat",
        "inventoryPurchases.status.confirmed": "Bekräftat",
        "inventoryPurchases.status.received": "Mottaget",
        "inventoryPurchases.status.cancelled": "Avbrutet",
        "inventoryPurchases.createTitle": "Skapa inköp",
        "inventoryPurchases.createHint": "Välj leverantör. Fyll i resten av inköpet på nästa sida.",
        "inventoryPurchases.continue": "Fortsätt",
        "inventoryPurchases.searchSupplier": "Sök leverantör…",
        "inventoryPurchases.noSuppliers": "Inga leverantörer hittades",
        "inventoryPurchases.loadingSuppliers": "Hämtar leverantörer…",
        "inventoryPurchases.supplierLoadFailed": "Kunde inte hämta leverantörer. Försök söka igen.",
        "inventoryPurchases.supplierRequired": "Välj en leverantör innan du skapar inköpet.",
        "inventoryPurchases.createFailed": "Kunde inte skapa inköpet. Kontrollera fälten och försök igen.",
        "inventoryPurchases.createUnknown": "Det är oklart om inköpet skapades. Kontrollera listan innan du försöker igen.",
        "inventoryPurchases.recoveryTitle": "Kontrollera oklart inköp",
        "inventoryPurchases.recoveryHint": "Försöket behåller samma nyckel. Fortsätt samma försök för att undvika dubbletter; ett nytt utkast är möjligt först efter ett definitivt avslag från servern.",
        "inventoryPurchases.pendingAttempt": "Sparat skapandeförsök",
        "inventoryPurchases.pendingSummary": "Leverantör: {{supplier}} · Datum: {{date}} · Referens: {{reference}}",
        "inventoryPurchases.checkBeforeRetry": "Kontrollera inköpslistan innan du skickar samma försök igen.",
        "inventoryPurchases.storageUnavailable": "Webbläsaren kunde inte spara operationsnyckeln. Inköpet skickades inte; försök när sessionslagringen fungerar.",
        "inventoryPurchases.payloadConflict": "Servern avvisade nyckeln för detta innehåll. Försöket är sparat; undersök om inköpet redan finns innan du fortsätter.",
        "inventoryPurchases.checkFailed": "Kunde inte kontrollera inköpslistan. Försök igen; försöket är fortfarande sparat.",
        "inventoryPurchases.listChecked": "Första listsidan har kontrollerats. Träffarna nedan kan vara äldre likadana inköp; avsaknad av en rad bevisar inte att försöket misslyckades. Du kan tryggt fortsätta exakt samma försök.",
        "inventoryPurchases.possibleMatches": "Möjliga träffar på första listsidan",
        "inventoryPurchases.checking": "Kontrollerar…",
        "inventoryPurchases.newAttempt": "Rätta avvisat utkast",
        "inventoryPurchases.retrySame": "Fortsätt samma försök",
        "inventoryPurchases.created": "Inköpet har skapats.",
        "inventoryPurchases.cancel": "Avbryt",
        "inventoryPurchases.create": "Skapa",
        "inventoryPurchases.creating": "Skapar…",
        "inventoryPurchases.checkList": "Kontrollera inköpslistan",
        "inventoryReconciliation.title": "Avstämning mot bokföring",
        "inventoryReconciliation.nowHint": "Lagervärdet ovan visas per nu. Redovisningsavstämningen använder hela vald kalenderperiod; en öppen period kan inte ge en slutlig avvikelse.",
        "inventoryIntegration.receiptUnsupported": "Utgående varumottagningar till Tripletex är inte verifierade och är otillgängliga. Promang bokför mottagning och lager lokalt; inköpsorder synkroniseras separat.",
        "inventoryReconciliation.bookClosing": "Utgående bokfört värde",
        "inventoryReconciliation.bookOpening": "Ingående bokfört värde",
        "inventoryReconciliation.approvedBaselines": "Godkända ingående balanser",
        "inventoryReconciliation.bookProvisional": "Preliminärt värde. Synk eller periodtäckning är ofullständig.",
        "inventoryReconciliation.bookDifference": "Skillnad mot bokfört värde",
        "inventoryReconciliation.bookIncomplete": "Verifierad ingående balans och komplett synk för en stängd period krävs för jämförelse.",
        "inventoryReconciliation.bookAsOf": "Bokfört värde per synk",
        "inventoryReconciliation.addBaseline": "Lägg till ingående redovisningssaldo",
        "inventoryReconciliation.baselineHint": "Godkänn dokumenterad balans per konto före periodstart. Den kan inte ändras efter sparning.",
        "inventoryReconciliation.account": "Konto",
        "inventoryReconciliation.baselineDate": "Balansdatum",
        "inventoryReconciliation.openingBalance": "Ingående balans (NOK)",
        "inventoryReconciliation.evidence": "Underlag / referens",
        "inventoryReconciliation.baselineFailed": "Kunde inte spara balansen. Kontrollera datum, belopp och om en balans redan finns.",
        "inventoryReconciliation.saveBaseline": "Godkänn balans",
        "inventoryReconciliation.hint": "Jämför rörelsen i fysiskt lagervärde med bokförda rörelser på valda lagerkonton för perioden.",
        "inventoryReconciliation.companyWide": "Avstämningen gäller hela företaget oavsett produkt- eller lagerfilter i tabellen.",
        "inventoryReconciliation.accounts": "Lagerkonton",
        "inventoryReconciliation.chooseAccount": "Välj konto",
        "inventoryReconciliation.addAccount": "Lägg till konto",
        "inventoryReconciliation.loadFailed": "Kunde inte hämta avstämningen.",
        "inventoryReconciliation.loading": "Hämtar avstämning…",
        "inventoryReconciliation.physicalMovement": "Lagerrörelse",
        "inventoryReconciliation.ledgerMovement": "Bokförd periodrörelse",
        "inventoryReconciliation.difference": "Periodavvikelse",
        "inventoryReconciliation.notComparable": "Kan inte jämföras",
        "inventoryReconciliation.opening": "Ingående lagervärde",
        "inventoryReconciliation.closing": "Utgående lagervärde",
        "inventoryReconciliation.incomplete": "Jämförelsen kräver fullständig kosthistorik, valda konton och bekräftad bokföringssynk för perioden.",
        "inventoryReconciliation.source": "Källa: lokalt synkade Tripletex-verifikat",
        "inventoryReconciliation.lastCovered": "Senaste täckande synk",
        "inventoryReconciliation.noBookBalance": "Bokförd balans visas inte utan verifierad ingående balans.",
        "inventoryIntegration.title": "Inköpssynk",
        "inventoryIntegration.field": "Fält",
        "inventoryIntegration.sourceSystem": "Källsystem",
        "inventoryIntegration.compare.number": "Ordernummer",
        "inventoryIntegration.compare.supplier": "Leverantörs-ID",
        "inventoryIntegration.compare.date": "Beställningsdatum",
        "inventoryIntegration.compare.deliveryDate": "Leveransdatum",
        "inventoryIntegration.compare.status": "Status / stängd",
        "inventoryIntegration.closed": "Stängd",
        "inventoryIntegration.open": "Öppen",
        "inventoryIntegration.noLines": "Inga produktrader i tillgängliga data.",
        "inventoryIntegration.hint": "Promang ansvarar för lager och inköp. Följ övergången mot Tripletex och ärenden som behöver granskas.",
        "inventoryIntegration.loadFailed": "Kunde inte hämta synkstatus. Försök igen.",
        "inventoryIntegration.mutationFailed": "Åtgärden kunde inte bekräftas. Uppdatera status före ett nytt försök.",
        "inventoryIntegration.conflictChanged": "Inköpet eller Tripletex-ordern har ändrats. Granska de uppdaterade värdena innan du bekräftar ditt val igen.",
        "inventoryIntegration.queued": "Synk köad. Uppdatera senare för bekräftat resultat.",
        "inventoryIntegration.loading": "Hämtar synkstatus…",
        "inventoryIntegration.mode": "Driftläge",
        "inventoryIntegration.mode.off": "Synk av",
        "inventoryIntegration.mode.bridge": "Tvåvägsövergång",
        "inventoryIntegration.mode.local_only": "Bara Promang",
        "inventoryIntegration.remoteCapability": "Tripletex logistik",
        "inventoryIntegration.capability.available": "Tillgänglig",
        "inventoryIntegration.capability.missing": "Ingen åtkomst",
        "inventoryIntegration.capability.unchecked": "Inte kontrollerad",
        "inventoryIntegration.pending": "Väntar på bekräftelse",
        "inventoryIntegration.needsReview": "Behöver granskas",
        "inventoryIntegration.logisticsMissing": "Tripletex Logistik Bas är otillgänglig. Lokalt lager och inköp i Promang fortsätter.",
        "inventoryIntegration.lastVerified": "Senast verifierad",
        "inventoryIntegration.syncNow": "Starta avstämning",
        "inventoryIntegration.conflicts": "Synkkonflikter",
        "inventoryIntegration.conflict": "Konflikt",
        "inventoryIntegration.review": "Granska",
        "inventoryIntegration.reviewHint": "Jämför beställningen i båda systemen innan du väljer version. Servern kontrollerar fjärrversionen igen.",
        "inventoryIntegration.reason": "Orsak",
        "inventoryIntegration.remoteVersion": "Tripletex-version",
        "inventoryIntegration.resolution": "Val",
        "inventoryIntegration.choose": "Välj åtgärd",
        "inventoryIntegration.keepLocal": "Behåll Promang-versionen",
        "inventoryIntegration.acceptRemote": "Använd Tripletex-versionen",
        "inventoryIntegration.applyResolution": "Bekräfta val",
        "inventoryPurchase.conflict": "Inköpet har ändrats på annat håll. Osparat arbete finns kvar; ladda om och jämför innan du fortsätter.",
        "inventoryPurchase.unknownSave": "Resultatet av sparningen är okänt. Osparat arbete finns kvar; kontrollera inköpet före ett nytt försök.",
        "inventoryPurchase.finishHeaderFirst": "Vänta tills inköpsändringarna har sparats innan du ändrar produktrader.",
        "inventoryPurchase.markSentManually": "Markera skickad manuellt",
        "inventoryPurchase.markingSent": "Markerar som skickad...",
        "inventoryPurchase.markSentFailed": "Kunde inte markera inköpet som skickat.",
        "inventoryPurchase.markConfirmedFailed": "Kunde inte markera inköpet som bekräftat.",
        "inventoryPurchase.markSentSuccess": "Inköpet är markerat som skickat manuellt.",
        "inventoryPurchase.markConfirmedSuccess": "Inköpet är markerat som bekräftat.",
        "inventoryPurchase.confirmed": "Bekräftad",
        "inventoryPurchase.goodsReceipt": "Varumottagning",
        "inventoryPurchase.tripletexSync": "Tripletex-synk",
        "inventoryPurchase.delivery.queued": "Leverans väntar",
        "inventoryPurchase.deliveryQueued": "Leveransen är köad. Kontrollera status innan den räknas som levererad.",
        "inventoryPurchase.sendQueueHint": "Utsändningen läggs i kö. Leverans till leverantören är bekräftad först när transportstatus visar att den godkänts.",
        "inventoryPurchase.delivery.accepted": "Transport bekräftade leverans",
        "inventoryPurchase.delivery.manual": "Markerad skickad manuellt",
        "inventoryPurchase.delivery.unknown": "Leveransresultat okänt",
        "inventoryPurchase.delivery.failed": "Leverans misslyckades",
        "inventoryPurchase.sync.queued": "Väntar",
        "inventoryPurchase.sync.processing": "Synkroniserar",
        "inventoryPurchase.sync.synced": "Synkroniserad",
        "inventoryPurchase.sync.unknown": "Okänt resultat",
        "inventoryPurchase.sync.conflict": "Konflikt",
        "inventoryPurchase.sync.failed": "Misslyckades",
        "inventoryPurchase.sync.unsupported": "Otillgänglig",
        "inventoryPurchase.addProducts": "Lägg till produktrader",
        "inventoryPurchase.addProductsHint": "Sök först bland leverantörens produkter. Om ingen passar visas försäljningsprodukter som kopplas till leverantören när du sparar. Välj produkter, antal och pris här.",
        "supplierProducts.title": "Leverantörsprodukter",
        "supplierProducts.description": "Artikelnummer, namn och inköpspris hos varje leverantör.",
        "supplierProducts.add": "Koppla leverantör",
        "supplierProducts.supplier": "Leverantör",
        "supplierProducts.chooseSupplier": "Välj leverantör",
        "supplierProducts.itemNumber": "Leverantörens artikelnummer",
        "supplierProducts.productTitle": "Leverantörens produktnamn",
        "supplierProducts.purchasePrice": "Inköpspris",
        "supplierProducts.empty": "Inga leverantörsprodukter är kopplade till denna produkt.",
        "supplierProducts.loadFailed": "Det gick inte att hämta leverantörsprodukter.",
        "supplierProducts.saveFailed": "Det gick inte att spara leverantörsprodukten.",
        "supplierProducts.linked": "Leverantörsprodukt",
        "supplierProducts.willLink": "Försäljningsprodukt · kopplas vid sparande",
        "supplierProducts.salesProduct": "Försäljningsprodukt",
        "supplierProducts.supplierDescription": "Produkter kopplade till denna leverantör. Öppna försäljningsprodukten för att ändra artikelnummer, namn och inköpspris.",
        "supplierProducts.search": "Sök leverantörsprodukter…",
        "supplierProducts.emptySupplier": "Inga produkter är kopplade till denna leverantör ännu.",
        "inventoryPurchase.chooseProducts": "Välj produkter",
        "inventoryPurchase.quantity": "Antal",
        "inventoryPurchase.price": "Kostpris",
        "inventoryPurchase.actions": "Åtgärder",
        "inventoryPurchase.remove": "Ta bort",
        "inventoryPurchase.noProducts": "Inga produkter valda ännu.",
        "inventoryPurchase.close": "Stäng",
        "inventoryPurchase.saving": "Sparar…",
        "inventoryPurchase.retrySame": "Kontrollera resultat med samma nyckel",
        "inventoryPurchase.addSelected": "Lägg till {{count}} rader",
        "inventoryPurchase.quantityInvalid": "Alla rader måste ha antal större än noll.",
        "inventoryPurchase.addFailed": "Kunde inte lägga till produktrader.",
        "inventoryPurchase.unknownAdd": "Resultatet är okänt. Rader och operationsnyckel finns kvar. Kontrollera med samma nyckel före ändringar.",
        "inventoryPurchase.linesAdded": "Produktrader tillagda.",
        "inventoryPurchase.title": "Inköp",
        "inventoryPurchase.loading": "Laddar…",
        "inventoryPurchase.loadError": "Kunde inte hämta inköpet",
        "inventoryPurchase.notFound": "Inköpet hittades inte",
        "inventoryPurchase.back": "Tillbaka",
        "inventoryPurchase.purchaseDate": "Inköpsdatum",
        "inventoryPurchase.deliveryDate": "Leveransdatum",
        "inventoryPurchase.sendDate": "Sänddatum",
        "inventoryPurchase.reference": "Referens",
        "inventoryPurchase.removeConfirm": "Är du säker på att du vill ta bort den här raden?",
        "inventoryPurchase.lineRemoved": "Rad borttagen",
        "inventoryPurchase.removeFailed": "Kunde inte ta bort raden",
        "inventoryPurchase.markingConfirmed": "Markerar som bekräftad…",
        "inventoryPurchase.status.draft": "Utkast",
        "inventoryPurchase.status.sent": "Skickad",
        "inventoryPurchase.status.confirmed": "Bekräftad",
        "inventoryPurchase.status.received": "Mottagen",
        "inventoryPurchase.status.cancelled": "Avbruten",
        "inventoryValuation.title": "Lagervärde",
        "inventoryOpening.title": "Ingående lagerbalans",
        "inventoryOpening.emptyCounts": "Godkända fullständiga inventeringar innehåller inga produkter. En nollöppning är giltig när alla lager och inventeringar har intygats.",
        "inventoryOpening.countDayOpen": "Inventeringsdagen har inte avslutats i Europe/Oslo. Vänta till nästa dag innan den ingående balansen godkänns.",
        "inventoryOpening.allStorages": "Alla lager som kräver full inventering",
        "inventoryOpening.inactive": "Inaktivt",
        "inventoryOpening.hint": "Godkänn en full inventering från föregående dag för varje lager innan lagervärdet kan vara komplett.",
        "inventoryOpening.approved": "Ingående lagerbalans är godkänd från {{date}}.",
        "inventoryOpening.open": "Förbered ingående balans",
        "inventoryOpening.irreversible": "Detta bokför ingående lager och kan inte ändras efter godkännande. Granska inventering, kostnad och underlag noga.",
        "inventoryOpening.effectiveDate": "Gäller från datum",
        "inventoryOpening.method": "Kostnadsmetod",
        "inventoryOpening.chooseMethod": "Välj kostnadsmetod",
        "inventoryOpening.weightedAverage": "Vägt genomsnitt",
        "inventoryOpening.loading": "Kontrollerar godkända inventeringar…",
        "inventoryOpening.previewFailed": "Kunde inte hämta inventeringar för valt datum.",
        "inventoryOpening.countDate": "Full inventering måste vara godkänd {{date}}",
        "inventoryOpening.rows": "{{count}} inventeringsrader",
        "inventoryOpening.missingStorages": "Godkänd full inventering saknas för lager",
        "inventoryOpening.legacyPartialUsed": "Minst en godkänd räkning var sparad som partiell (äldre standard). Den används som lagrets räkning för detta datum.",
        "inventoryOpening.latestApproved": "Senaste godkända räkning för {{storage}} är {{date}} ({{coverage}}). Sätt «Gäller från» till dagen efter räkningsdatumet.",
        "inventoryOpening.coverageFull": "full",
        "inventoryOpening.coveragePartial": "partiell",
        "inventoryOpening.invalidCounts": "Alla rader är inte godkända i inventeringar",
        "inventoryOpening.duplicateProducts": "Samma produkt förekommer flera gånger i ett lager. Rätta inventeringen först.",
        "inventoryOpening.unknownCosts": "{{count}} rader saknar kostnad. Värdet är ofullständigt tills kostnadsunderlag dokumenterats.",
        "inventoryOpening.quantity": "Antal",
        "inventoryOpening.costStatus": "Kostnadsstatus",
        "inventoryOpening.unitCost": "Enhetskostnad (NOK)",
        "inventoryOpening.evidence": "Kostnadsunderlag / referens",
        "inventoryOpening.known": "Dokumenterad",
        "inventoryOpening.certify": "Jag bekräftar att alla lager inventerades fullt föregående dag och att varje rad och kostnadsunderlag har granskats.",
        "inventoryOpening.costEvidenceRequired": "Varje värderad rad med positivt antal behöver giltig enhetskostnad och underlag.",
        "inventoryOpening.approveFailed": "Kunde inte godkänna ingående lagerbalans.",
        "inventoryOpening.unknownOutcome": "Resultatet är okänt. Kontrollera status innan nytt försök.",
        "inventoryOpening.checkStatus": "Kontrollera status",
        "inventoryOpening.approve": "Godkänn ingående balans",
        "inventoryValuation.currentPeriod": "Denna månad",
        "inventoryValuation.openReport": "Öppna rapport",
        "inventoryValuation.totalValue": "Totalt lagervärde",
        "inventoryValuation.unvaluedQuantity": "Antal utan kostnad",
        "inventoryValuation.valuedSubtotal": "Värderad delsumma",
        "inventoryValuation.openingMissing": "Ingående lagerbalans och kostnadsmetod har inte godkänts. Lagervärdet är ofullständigt.",
        "inventoryReceipt.postedImmutable": "En bokförd mottagning kan inte ändras. Använd en dokumenterad korrigering.",
        "inventoryReceipt.storageLoadFailed": "Kunde inte hämta lager. Försök igen innan varumottagningen sparas.",
        "inventoryReceipt.saveFailed": "Kunde inte spara varumottagningen.",
        "inventoryReceipt.unknownOutcome": "Resultatet är okänt. Kontrollera mottagningen med samma operationsnyckel innan du ändrar den.",
        "inventoryReceipt.remaining": "Återstår",
        "inventoryReceipt.receiveRemaining": "Ta emot resten",
        "inventoryReceipt.saving": "Sparar…",
        "inventoryReceipt.retrySame": "Kontrollera resultat med samma nyckel",
        "inventoryReceipt.quantityInvalid": "Antal måste vara 0 eller ett positivt tal med högst fyra decimaler.",
        "inventoryReceipt.addProduct": "Lägg till minst en mottagningsrad innan du sparar.",
        "inventoryCost.title": "Kostnadsjusteringar",
        "inventoryCost.hint": "Dokumentera en senare leverantörsfaktura mot en bokförd varumottagning. Lagervärdet räknas om utan att inköpsordern ändras.",
        "inventoryCost.new": "Ny kostnadsjustering",
        "inventoryCost.loading": "Hämtar kostnadsdata…",
        "inventoryCost.historyFailed": "Kunde inte hämta kostnadsjusteringar.",
        "inventoryCost.empty": "Inga kostnadsjusteringar registrerade.",
        "inventoryCost.receipt": "Varumottagning",
        "inventoryCost.invoice": "Leverantörsfaktura",
        "inventoryCost.unitCost": "Ny enhetskostnad",
        "inventoryCost.approved": "Godkänd",
        "inventoryCost.formHint": "Välj en bokförd varumottagning och ange dokumenterad kostnad från leverantörsfakturan. Detta kan inte ångras genom att redigera inköpsordern.",
        "inventoryCost.searchReceipt": "Sök varumottagning",
        "inventoryCost.searchPlaceholder": "Produkt, artikelnummer eller mottagningsnummer",
        "inventoryCost.receiptsFailed": "Kunde inte hämta varumottagningar. Försök söka igen.",
        "inventoryCost.openingRequired": "Godkänn ingående lagerbalans före en kostnadsjustering.",
        "inventoryCost.noReceipts": "Inga bokförda varumottagningar hittades.",
        "inventoryCost.product": "Produkt",
        "inventoryCost.quantity": "Antal",
        "inventoryCost.previous": "Föregående",
        "inventoryCost.next": "Nästa",
        "inventoryCost.selected": "Vald mottagningsrörelse #{{id}}",
        "inventoryCost.evidence": "Motivering och dokumentation",
        "inventoryCost.error.invalid": "Kontrollera mottagning, belopp, fakturareferens och dokumentation. Ingen justering registrerades.",
        "inventoryCost.error.forbidden": "Du har inte längre rätt att registrera en kostnadsjustering.",
        "inventoryCost.error.noRemaining": "Mottagningen är helt förbrukad. Fakturaskillnaden måste hanteras i bokföringen och kan inte läggas till kvarvarande lagervärde.",
        "inventoryCost.error.unknown": "Resultatet är okänt. Kontrollera med samma operationsnyckel; fälten är låsta för att undvika dubbletter.",
        "inventoryCost.error.conflict": "Konflikt vid sparande. Kontrollera justeringen innan du fortsätter.",
        "inventoryCost.startNewAfterConflict": "Avsluta konflikten och starta ett nytt försök",
        "inventoryCost.saved": "Kostnadsjusteringen har godkänts.",
        "inventoryCost.impact": "Effekt på kvarvarande lagervärde",
        "inventoryCost.impactUnknown": "Okänd eftersom tidigare kostnad saknades",
        "inventoryCost.close": "Stäng",
        "inventoryCost.saving": "Sparar…",
        "inventoryCost.retry": "Kontrollera med samma nyckel",
        "inventoryCost.save": "Godkänn justering",
        "inventoryValuation.eyebrow": "Lager och bokföring",
        "inventoryValuation.hint": "Antal och anskaffningsvärde för vald period, beräknat från bokförda rörelser.",
        "inventoryValuation.now": "Nu",
        "inventoryValuation.refresh": "Uppdatera",
        "inventoryValuation.export": "Exportera",
        "inventoryValuation.printPdf": "Skriv ut PDF",
        "inventoryValuation.printing": "Skapar PDF…",
        "inventoryValuation.printFailed": "Kunde inte skapa PDF. Försök igen.",
        "inventoryValuation.exporting": "Exporterar…",
        "inventoryValuation.download": "Ladda ner CSV",
        "inventoryValuation.checkExport": "Kontrollera export",
        "inventoryValuation.retryExport": "Kontrollera med samma nyckel",
        "inventoryValuation.exportUnknown": "Exportresultatet är okänt. Kontrollera med samma operationsnyckel.",
        "inventoryValuation.exportQueued": "Exporten behandlas. Kontrollera status innan nedladdning.",
        "inventoryValuation.exportStatus.queued": "Exporten väntar.",
        "inventoryValuation.exportStatus.processing": "Exporten behandlas.",
        "inventoryValuation.exportStatus.completed": "Exporten är klar för nedladdning.",
        "inventoryValuation.exportStatus.failed": "Exporten misslyckades. Kontrollera status före ett nytt försök.",
        "inventoryValuation.exportStatus.unknown": "Resultatet är okänt. Kontrollera med samma nyckel.",
        "inventoryValuation.search": "Sök produkt eller nummer",
        "inventoryValuation.storage": "Lager",
        "inventoryValuation.forbidden": "Du har inte tillgång till lagervärden.",
        "inventoryValuation.loadFailed": "Kunde inte hämta lagervärden. Försök igen.",
        "inventoryValuation.incomplete": "Historiken är inte komplett för perioden. Tidigaste tillförlitliga datum: {{date}}.",
        "inventoryValuation.opening": "Ingående värde",
        "inventoryValuation.incoming": "In, inklusive flytt",
        "inventoryValuation.outgoing": "Ut, inklusive flytt",
        "inventoryValuation.closing": "Utgående värde",
        "inventoryValuation.method": "Kostmetod",
        "inventoryValuation.unvalued": "Antal utan kostpris",
        "inventoryValuation.asOf": "Beräknat",
        "inventoryValuation.rows": "Lagervärdesrader",
        "inventoryValuation.loading": "Hämtar lagervärden…",
        "inventoryValuation.product": "Produkt",
        "inventoryValuation.openingQuantity": "Ingående antal",
        "inventoryValuation.receivedQuantity": "Mottaget",
        "inventoryValuation.issuedQuantity": "Uttaget",
        "inventoryValuation.closingQuantity": "Utgående antal",
        "inventoryValuation.missingCost": "Kostpris saknas",
        "inventoryValuation.incompleteAmount": "Inte beräknat",
        "inventoryValuation.estimated": "Uppskattat",
        "inventoryValuation.empty": "Inga varor för vald period och filter.",
        "inventoryValuation.movements": "Rörelser",
        "inventoryValuation.movementsFailed": "Kunde inte hämta rörelser.",
        "inventoryValuation.clearFilters": "Rensa filter",
        "inventoryValuation.estimatesWarning": "{{count}} lagerrader har uppskattad kostnad ({{opening}} från ingående balans, {{period}} från perioden). Beloppen är preliminära; avvikelser mot bokföringen är inte slutliga.",
        "inventoryValuation.movementsShown": "Visar {{shown}} av {{total}} rörelser",
        "inventoryValuation.loadMoreMovements": "Visa fler rörelser",
        "inventoryValuation.movement": "Rörelse",
        "inventoryValuation.openSource": "Öppna källa",
        "inventoryValuation.noMovements": "Inga rörelser under perioden.",
        "dashboardDesign.writeUpdate": "Skriv en uppdatering",
        "dashboardDesign.updatePrompt": "Vad händer? Använd @ för att nämna eller / för att länka en modul",
        "dashboardDesign.mentionEmployee": "Nämn en anställd",
        "dashboardDesign.dayOverview": "Dagens översikt",
        "dashboardDesign.dayTasks": "Alla uppdrag för dagen",
        "dashboardDesign.agendaDescription": "Arbetsorder, aktiviteter, projekt och avtal på ett ställe.",
        "dashboardDesign.calendarHint": "Öppna kalendern för full översikt och planering.",
        "dashboardDesign.viewCalendar": "Visa kalender",
        "dashboardDesign.timeRegistration": "Tidsregistrering",
        "dashboardDesign.hoursHint": "Registrera och justera dina arbetstimmar.",
        "dashboardDesign.openHours": "Registrera timmar",
        "dashboardDesign.registeredDay": "Registrerat på vald dag",
        "dashboardDesign.emptyHours": "Inga timmar registrerade ännu.",
        "dashboardDesign.noProject": "Utan projekt",
        "dashboardDesign.handbook": "Personalhandbok",
        "dashboardDesign.handbookHint": "Din handbok, kollegor och incidentrapportering.",
        "dashboardDesign.openHandbook": "Öppna handboken",
        "dashboardDesign.handbookDetails": "Rutiner, dokumentation och gemensamma arbetssätt.",
        "dashboardDesign.colleagues": "Kollegor",
        "dashboardDesign.colleagueDetails": "Hitta kollegor och deras kontaktuppgifter.",
        "dashboardDesign.tools": "Verktyg",
        "dashboardDesign.toolsDetails": "Se dina tilldelade verktyg.",
        "dashboardDesign.incident": "Rapportera incident",
        "dashboardDesign.incidentDetails": "Rapportera en arbetsmiljöhändelse eller avvikelse.",
        "dashboardDesign.driving": "Körjournal",
        "dashboardDesign.drivingHint": "Ditt aktuella fordon och snabb åtkomst till fordonsval.",
        "dashboardDesign.adminHint": "Snabb åtkomst till administration.",
        "dashboardDesign.employees": "Anställda",
        "dashboardDesign.employeesHint": "Hantera användare, roller och åtkomst.",
        "dashboardDesign.loadingVehicle": "Laddar fordon",
        "dashboardDesign.noVehicle": "Inget fordon valt",
        "dashboardDesign.noDriver": "Inte registrerad som förare",
        "dashboardDesign.selectVehicle": "Öppna körjournalen och välj fordon",
        "dashboardDesign.noDriverProfile": "Ingen förarprofil tillgänglig",
        "dashboardDesign.dayAssignments": "Dagens uppdrag",
        "dashboardDesign.daySummary": "{{count}} uppdrag · {{hours}} t planerat",
        "dashboardDesign.hourLines": "{{count}} rader",
        "dashboardDesign.distanceToday": "{{distance}} km körda idag",
        "dashboardDesign.title": "Dashboard",
        "dashboardDesign.subtitleAdmin": "Översikt över dagens uppdrag, uppgifter som kräver åtgärd och ekonomi.",
        "dashboardDesign.subtitlePersonal": "Dina uppdrag, timmar och uppgifter för dagen.",
        "dashboardDesign.registerHours": "Registrera timmar",
        "dashboardDesign.newWorkOrder": "Ny arbetsorder",
        "dashboardDesign.newIncident": "Registrera händelse",
        "dashboardDesign.keyFigures": "Dagens nyckeltal",
        "dashboardDesign.assignments": "Dina uppdrag",
        "dashboardDesign.plannedHours": "{{hours}} t planerat",
        "dashboardDesign.service": "Service",
        "dashboardDesign.workOrders": "Arbetsorder",
        "dashboardDesign.hours": "Timmar",
        "dashboardDesign.yourDay": "Dina uppdrag på vald dag",
        "dashboardDesign.yourHours": "Dina registrerade timmar",
        "dashboardDesign.setup": "Slutför inställningarna",
        "dashboardDesign.setupCount": "{{areas}} områden behöver ses över · {{count}} punkter",
        "dashboardDesign.hide": "Dölj",
        "dashboardDesign.showAll": "Visa alla",
        "dashboardDesign.filterDay": "Filtrera dagens uppdrag",
        "dashboardDesign.all": "Alla",
        "dashboardDesign.date": "Välj datum",
        "dashboardDesign.eventsError": "Kunde inte hämta uppdragen.",
        "dashboardDesign.hoursError": "Kunde inte hämta timmarna.",
        "dashboardDesign.retry": "Försök igen",
        "dashboardDesign.loading": "Laddar…",
        "dashboardDesign.noEvents": "Inga uppdrag registrerade denna dag",
        "dashboardDesign.noFilterEvents": "Inga uppdrag matchar filtret",
        "dashboardDesign.weekHours": "Dina timmar denna vecka",
        "dashboardDesign.weekTotal": "{{hours}} t registrerade denna vecka",
        "dashboardDesign.admin": "Administration",
        "dashboardDesign.theme": "Utseende",
        "dashboardDesign.light": "Ljust tema",
        "dashboardDesign.dark": "Mörkt tema",
        "dashboardDesign.visibleTo": "Synligt för: {{audience}}",
        "dashboardDesign.attention": "Kräver åtgärd",
        "dashboardDesign.statsError": "Kunde inte hämta uppföljningspunkterna.",
        "dashboardDesign.economy": "Ekonomi",
        "dashboardDesign.details": "Visa detaljer",
        "recipients.label": "E-postadress",
        "recipients.count": "{{count}} mottagare",
        "recipients.me": "Jag",
        "recipients.channel.private_email": "Privat e-post",
        "recipients.channel.work_email": "Jobb-e-post",
        "recipients.group.customer": "Kundens kontakter",
        "recipients.group.team": "Kontakt hos oss",
        "recipients.group.other": "Andra kontakter",
        "recipients.placeholder": "Sök kontakt eller ange e-postadress",
        "recipients.placeholderMore": "namn@exempel.se",
        "recipients.manual": "Manuell",
        "recipients.remove": "Ta bort {{email}}",
        "recipients.showContacts": "Visa kontakter",
        "recipients.add": "Lägg till {{email}}",
        "recipients.help": "Välj i listan eller skriv en adress och tryck Enter. Separera flera med kommatecken.",
        "recipients.singleHelp": "Välj i listan eller skriv en adress och tryck Enter. Den här sändningen har en mottagare.",
        "recipients.singleOnly": "Välj en e-postadress för den här sändningen.",
        "recipients.extraLimit": "Du kan välja flera projektkontakter och en annan eller manuell adress.",
        "recipients.invalid": "Kontrollera adressen: {{value}}",
        "recipients.finishInput": "Välj en kontakt eller slutför adressen med Enter innan du skickar.",
        "recipients.loading": "Hämtar kontakter…",
        "recipients.loadFailed": "Vissa kontakter kunde inte hämtas. Du kan fortfarande ange en adress manuellt.",
        "recipients.retry": "Försök igen",
        "recipients.empty": "Inga kontakter hittades. Ange en fullständig e-postadress för att lägga till manuellt.",
        "recipients.moreResults": "Visar upp till 30 träffar per grupp. Sök för att hitta fler.",
        "recipients.keyMove": "↑↓ navigera",
        "recipients.keySelect": "Enter välj / lägg till",
        "recipients.keyClose": "Esc stäng",

        "hse.sja.fields.required": "Fyll i detta fält.",
        "hse.sja.fields.choose_score": "Välj värde (1–5)",
        "hse.sja.fields.hazard": "Fara",
        "hse.sja.fields.add_hazard": "Lägg till fara",
        "hse.sja.fields.remove_hazard": "Ta bort fara",
        "hse.sja.fields.remove_step": "Ta bort arbetssteg",
        "hse.sja.fields.existing_measures": "Befintliga åtgärder",
        "hse.sja.fields.additional_measures": "Ytterligare åtgärder",
        "hse.sja.fields.score": "Risk: {{likelihood}} × {{consequence}} = {{score}}",
        "hse.sja.fields.fix_errors": "Kontrollera de markerade fälten innan du sparar.",
        "hse.sja.fields.save_unknown": "Det gick inte att bekräfta att ändringarna sparats. Behåll sidan öppen och kontrollera SJA-listan i en ny flik innan du försöker igen.",

        "deviation.health.title": "Avvikelsemeddelanden – leveransstatus",
        "deviation.health.trigger": "Inställningen väljer utskickssätt. Öppna en avvikelse, välj Skicka meddelande och mottagare för att starta utskicket. Nya avvikelser skickas inte automatiskt.",
        "deviation.health.unverified": "Konfigurationen har kontrollerats utan att skicka e-post. Leverans till mottagare och drift av det schemalagda jobbet har inte bekräftats.",
        "deviation.health.mail_unconfigured": "E-postutskick är avstängt eller saknar en konfigurerad e-postanslutning. Be administratören kontrollera företagets e-postanslutning och serverns e-postinställningar.",
        "deviation.health.digest_overdue": "Samlingsutskick väntar mer än två timmar efter planerad sändning. Be driftansvarig kontrollera schemalagt jobb och köarbetare.",
        "deviation.health.digest_failed": "Ett eller flera samlingsutskick har misslyckats. Kontrollera avvikelsens sändningslogg och e-postanslutningen före nytt försök.",
        "deviation.health.digest_inactive": "Ventande samlingsutskick finns, men samlingsutskick är inte längre valt. De skickas inte automatiskt som enskilda meddelanden.",
        "deviation.health.digest_scheduler": "Samlingsutskick kräver att driftansvarig schemalägger deviations:daily_digest varje timme och kör en köarbetare för mailers. Sidan kan inte bekräfta att jobbet körs.",
        "deviation.health.counts": "Samlingsutskick: {{pending}} väntar · {{overdue}} försenade · {{failed}} misslyckade",

        "trainingAdmin.healthTitle": trainingAdminTranslations.sv["trainingAdmin.healthTitle"],
        "trainingAdmin.healthNeedsFix": trainingAdminTranslations.sv["trainingAdmin.healthNeedsFix"],
        "trainingAdmin.healthSummary": trainingAdminTranslations.sv["trainingAdmin.healthSummary"],
        "trainingAdmin.healthSummaryHint": trainingAdminTranslations.sv["trainingAdmin.healthSummaryHint"],
        "trainingAdmin.healthShow": trainingAdminTranslations.sv["trainingAdmin.healthShow"],
        "trainingAdmin.healthBlocked": trainingAdminTranslations.sv["trainingAdmin.healthBlocked"],
        "trainingAdmin.healthDetails": trainingAdminTranslations.sv["trainingAdmin.healthDetails"],
        "trainingAdmin.healthHelp": trainingAdminTranslations.sv["trainingAdmin.healthHelp"],
        "trainingAdmin.healthChecking": trainingAdminTranslations.sv["trainingAdmin.healthChecking"],
        "trainingAdmin.healthClear": trainingAdminTranslations.sv["trainingAdmin.healthClear"],
        "trainingAdmin.healthProblem": trainingAdminTranslations.sv["trainingAdmin.healthProblem"],
        "trainingAdmin.healthDocument": trainingAdminTranslations.sv["trainingAdmin.healthDocument"],
        "trainingAdmin.healthImage": trainingAdminTranslations.sv["trainingAdmin.healthImage"],
        "trainingAdmin.healthRecheck": trainingAdminTranslations.sv["trainingAdmin.healthRecheck"],
        "trainingParticipant.dependencyTitle": trainingParticipantSv["trainingParticipant.dependencyTitle"],
        "trainingParticipant.dependencyHelp": trainingParticipantSv["trainingParticipant.dependencyHelp"],
        "trainingParticipant.dependencyOwner": trainingParticipantSv["trainingParticipant.dependencyOwner"],
        "trainingAdmin.jsonTools": trainingAdminTranslations.sv["trainingAdmin.jsonTools"],
        "trainingAdmin.jsonContent": trainingAdminTranslations.sv["trainingAdmin.jsonContent"],
        "trainingAdmin.jsonAi": trainingAdminTranslations.sv["trainingAdmin.jsonAi"],
        "trainingAdmin.jsonScope": trainingAdminTranslations.sv["trainingAdmin.jsonScope"],
        "trainingAdmin.jsonCopy": trainingAdminTranslations.sv["trainingAdmin.jsonCopy"],
        "trainingAdmin.jsonReload": trainingAdminTranslations.sv["trainingAdmin.jsonReload"],
        "trainingAdmin.jsonExample": trainingAdminTranslations.sv["trainingAdmin.jsonExample"],
        "trainingAdmin.jsonImport": trainingAdminTranslations.sv["trainingAdmin.jsonImport"],
        "trainingAdmin.jsonReplace": trainingAdminTranslations.sv["trainingAdmin.jsonReplace"],
        "trainingAdmin.jsonAppend": trainingAdminTranslations.sv["trainingAdmin.jsonAppend"],
        "trainingAdmin.jsonReplaceHint": trainingAdminTranslations.sv["trainingAdmin.jsonReplaceHint"],
        "trainingAdmin.jsonAppendHint": trainingAdminTranslations.sv["trainingAdmin.jsonAppendHint"],
        "trainingAdmin.jsonReview": trainingAdminTranslations.sv["trainingAdmin.jsonReview"],
        "trainingAdmin.jsonReviewSummary": trainingAdminTranslations.sv["trainingAdmin.jsonReviewSummary"],
        "trainingAdmin.jsonReferences": trainingAdminTranslations.sv["trainingAdmin.jsonReferences"],
        "trainingAdmin.jsonApply": trainingAdminTranslations.sv["trainingAdmin.jsonApply"],
        "trainingAdmin.jsonApplied": trainingAdminTranslations.sv["trainingAdmin.jsonApplied"],
        "trainingAdmin.jsonReadOnly": trainingAdminTranslations.sv["trainingAdmin.jsonReadOnly"],
        "trainingAdmin.jsonAiHint": trainingAdminTranslations.sv["trainingAdmin.jsonAiHint"],
        "trainingAdmin.jsonCopyAi": trainingAdminTranslations.sv["trainingAdmin.jsonCopyAi"],
        "trainingAdmin.jsonCopied": trainingAdminTranslations.sv["trainingAdmin.jsonCopied"],
        "trainingAdmin.jsonClipboardFailed": trainingAdminTranslations.sv["trainingAdmin.jsonClipboardFailed"],
        "trainingAdmin.jsonInvalid": trainingAdminTranslations.sv["trainingAdmin.jsonInvalid"],
        "trainingAdmin.jsonUnsupported": trainingAdminTranslations.sv["trainingAdmin.jsonUnsupported"],
        "trainingAdmin.jsonSize": trainingAdminTranslations.sv["trainingAdmin.jsonSize"],
        "trainingAdmin.jsonIdentity": trainingAdminTranslations.sv["trainingAdmin.jsonIdentity"],
        "trainingAdmin.jsonAnswers": trainingAdminTranslations.sv["trainingAdmin.jsonAnswers"],
        "trainingAdmin.jsonDependency": trainingAdminTranslations.sv["trainingAdmin.jsonDependency"],
        "trainingAdmin.jsonReference": trainingAdminTranslations.sv["trainingAdmin.jsonReference"],
        "trainingAdmin.jsonAudienceInvalid": trainingAdminTranslations.sv["trainingAdmin.jsonAudienceInvalid"],
        "trainingAdmin.jsonPositionsFailed": trainingAdminTranslations.sv["trainingAdmin.jsonPositionsFailed"],
        "trainingAdmin.jsonPositionsLoading": trainingAdminTranslations.sv["trainingAdmin.jsonPositionsLoading"],
        "trainingAdmin.jsonPositionsIncluded": trainingAdminTranslations.sv["trainingAdmin.jsonPositionsIncluded"],
        "trainingAdmin.jsonDocumentsLoading": trainingAdminTranslations.sv["trainingAdmin.jsonDocumentsLoading"],
        "trainingAdmin.jsonDocumentsFailed": trainingAdminTranslations.sv["trainingAdmin.jsonDocumentsFailed"],
        "trainingAdmin.jsonDocumentsIncluded": trainingAdminTranslations.sv["trainingAdmin.jsonDocumentsIncluded"],
        "trainingAdmin.jsonDocumentsEmpty": trainingAdminTranslations.sv["trainingAdmin.jsonDocumentsEmpty"],
        "trainingAdmin.jsonIncludeExcerpts": trainingAdminTranslations.sv["trainingAdmin.jsonIncludeExcerpts"],
        "trainingAdmin.jsonIncludeExcerptsHelp": trainingAdminTranslations.sv["trainingAdmin.jsonIncludeExcerptsHelp"],
        "trainingAdmin.jsonDocumentUnknown": trainingAdminTranslations.sv["trainingAdmin.jsonDocumentUnknown"],
        "trainingAdmin.documentAccessHint": trainingAdminTranslations.sv["trainingAdmin.documentAccessHint"],
        "trainingAdmin.jsonPositionsEmpty": trainingAdminTranslations.sv["trainingAdmin.jsonPositionsEmpty"],
        "trainingAdmin.jsonAudienceChanges": trainingAdminTranslations.sv["trainingAdmin.jsonAudienceChanges"],
        "trainingAdmin.jsonAudienceUnchanged": trainingAdminTranslations.sv["trainingAdmin.jsonAudienceUnchanged"],
        "trainingAdmin.deliveries": trainingAdminTranslations.sv["trainingAdmin.deliveries"],
        "trainingAdmin.deliveryPending": trainingAdminTranslations.sv["trainingAdmin.deliveryPending"],
        "trainingAdmin.deliverySending": trainingAdminTranslations.sv["trainingAdmin.deliverySending"],
        "trainingAdmin.deliverySent": trainingAdminTranslations.sv["trainingAdmin.deliverySent"],
        "trainingAdmin.deliveryFailed": trainingAdminTranslations.sv["trainingAdmin.deliveryFailed"],
        "trainingAdmin.deliveryUnknown": trainingAdminTranslations.sv["trainingAdmin.deliveryUnknown"],
        "trainingAdmin.deliveryCancelled": trainingAdminTranslations.sv["trainingAdmin.deliveryCancelled"],
        "trainingAdmin.deliveryDigest": trainingAdminTranslations.sv["trainingAdmin.deliveryDigest"],
        "trainingAdmin.recipient": trainingAdminTranslations.sv["trainingAdmin.recipient"],
        "trainingAdmin.scheduledAt": trainingAdminTranslations.sv["trainingAdmin.scheduledAt"],
        "trainingAdmin.sentAt": trainingAdminTranslations.sv["trainingAdmin.sentAt"],
        "trainingAdmin.deliveryPolicy": trainingAdminTranslations.sv["trainingAdmin.deliveryPolicy"],
        "trainingAdmin.deliveryNoRetry": trainingAdminTranslations.sv["trainingAdmin.deliveryNoRetry"],
        "trainingAdmin.deliveryFailureHint": trainingAdminTranslations.sv["trainingAdmin.deliveryFailureHint"],

        "trainingAdmin.dueBefore": trainingAdminTranslations.sv["trainingAdmin.dueBefore"],
        "trainingAdmin.archive": trainingAdminTranslations.sv["trainingAdmin.archive"],
        "trainingAdmin.archived": trainingAdminTranslations.sv["trainingAdmin.archived"],
        "trainingAdmin.archiveInfo": trainingAdminTranslations.sv["trainingAdmin.archiveInfo"],
        "trainingParticipant.reminders": trainingParticipantSv["trainingParticipant.reminders"],
        "trainingParticipant.reminderCount": trainingParticipantSv["trainingParticipant.reminderCount"],
        "trainingParticipant.snoozeReminders": trainingParticipantSv["trainingParticipant.snoozeReminders"],

        "trainingAdmin.receipt": trainingAdminTranslations.sv["trainingAdmin.receipt"],
        "trainingAdmin.receiptKind": trainingAdminTranslations.sv["trainingAdmin.receiptKind"],
        "trainingAdmin.cardKey": trainingAdminTranslations.sv["trainingAdmin.cardKey"],
        "trainingAdmin.sourceRevision": trainingAdminTranslations.sv["trainingAdmin.sourceRevision"],
        "trainingAdmin.acknowledged": trainingAdminTranslations.sv["trainingAdmin.acknowledged"],
        "trainingAdmin.createdEvent": trainingAdminTranslations.sv["trainingAdmin.createdEvent"],
        "trainingAdmin.savedEvent": trainingAdminTranslations.sv["trainingAdmin.savedEvent"],
        "trainingAdmin.copiedEvent": trainingAdminTranslations.sv["trainingAdmin.copiedEvent"],
        "trainingAdmin.publishedEvent": trainingAdminTranslations.sv["trainingAdmin.publishedEvent"],
        "trainingAdmin.assignedEvent": trainingAdminTranslations.sv["trainingAdmin.assignedEvent"],
        "trainingAdmin.startedEvent": trainingAdminTranslations.sv["trainingAdmin.startedEvent"],
        "trainingAdmin.answeredEvent": trainingAdminTranslations.sv["trainingAdmin.answeredEvent"],
        "trainingAdmin.documentOpenedEvent": trainingAdminTranslations.sv["trainingAdmin.documentOpenedEvent"],
        "trainingAdmin.completedEvent": trainingAdminTranslations.sv["trainingAdmin.completedEvent"],
        "trainingAdmin.extendedEvent": trainingAdminTranslations.sv["trainingAdmin.extendedEvent"],
        "trainingAdmin.archivedEvent": trainingAdminTranslations.sv["trainingAdmin.archivedEvent"],

        "trainingAdmin.title": trainingAdminTranslations.sv["trainingAdmin.title"],
        "trainingAdmin.intro": trainingAdminTranslations.sv["trainingAdmin.intro"],
        "trainingAdmin.guides": trainingAdminTranslations.sv["trainingAdmin.guides"],
        "trainingAdmin.reports": trainingAdminTranslations.sv["trainingAdmin.reports"],
        "trainingAdmin.audit": trainingAdminTranslations.sv["trainingAdmin.audit"],
        "trainingAdmin.newGuide": trainingAdminTranslations.sv["trainingAdmin.newGuide"],
        "trainingAdmin.edit": trainingAdminTranslations.sv["trainingAdmin.edit"],
        "trainingAdmin.revise": trainingAdminTranslations.sv["trainingAdmin.revise"],
        "trainingAdmin.copy": trainingAdminTranslations.sv["trainingAdmin.copy"],
        "trainingAdmin.deactivate": trainingAdminTranslations.sv["trainingAdmin.deactivate"],
        "trainingAdmin.reactivate": trainingAdminTranslations.sv["trainingAdmin.reactivate"],
        "trainingAdmin.deactivateInfo": trainingAdminTranslations.sv["trainingAdmin.deactivateInfo"],
        "trainingAdmin.reactivateInfo": trainingAdminTranslations.sv["trainingAdmin.reactivateInfo"],
        "trainingAdmin.copyInfo": trainingAdminTranslations.sv["trainingAdmin.copyInfo"],
        "trainingAdmin.saved": trainingAdminTranslations.sv["trainingAdmin.saved"],
        "trainingAdmin.published": trainingAdminTranslations.sv["trainingAdmin.published"],
        "trainingAdmin.updated": trainingAdminTranslations.sv["trainingAdmin.updated"],
        "trainingAdmin.saving": trainingAdminTranslations.sv["trainingAdmin.saving"],
        "trainingAdmin.loadError": trainingAdminTranslations.sv["trainingAdmin.loadError"],
        "trainingAdmin.reload": trainingAdminTranslations.sv["trainingAdmin.reload"],
        "trainingAdmin.refreshWarning": trainingAdminTranslations.sv["trainingAdmin.refreshWarning"],
        "trainingAdmin.unknown": trainingAdminTranslations.sv["trainingAdmin.unknown"],
        "trainingAdmin.checkStatus": trainingAdminTranslations.sv["trainingAdmin.checkStatus"],
        "trainingAdmin.conflict": trainingAdminTranslations.sv["trainingAdmin.conflict"],
        "trainingAdmin.loadServer": trainingAdminTranslations.sv["trainingAdmin.loadServer"],
        "trainingAdmin.useServer": trainingAdminTranslations.sv["trainingAdmin.useServer"],
        "trainingAdmin.serverVersion": trainingAdminTranslations.sv["trainingAdmin.serverVersion"],
        "trainingAdmin.unsaved": trainingAdminTranslations.sv["trainingAdmin.unsaved"],
        "trainingAdmin.discard": trainingAdminTranslations.sv["trainingAdmin.discard"],
        "trainingAdmin.keepEditing": trainingAdminTranslations.sv["trainingAdmin.keepEditing"],
        "trainingAdmin.leaveQuestion": trainingAdminTranslations.sv["trainingAdmin.leaveQuestion"],
        "trainingAdmin.saveDraft": trainingAdminTranslations.sv["trainingAdmin.saveDraft"],
        "trainingAdmin.publish": trainingAdminTranslations.sv["trainingAdmin.publish"],
        "trainingAdmin.publishConfirm": trainingAdminTranslations.sv["trainingAdmin.publishConfirm"],
        "trainingAdmin.publishInfo": trainingAdminTranslations.sv["trainingAdmin.publishInfo"],
        "trainingAdmin.about": trainingAdminTranslations.sv["trainingAdmin.about"],
        "trainingAdmin.content": trainingAdminTranslations.sv["trainingAdmin.content"],
        "trainingAdmin.audience": trainingAdminTranslations.sv["trainingAdmin.audience"],
        "trainingAdmin.followup": trainingAdminTranslations.sv["trainingAdmin.followup"],
        "trainingAdmin.review": trainingAdminTranslations.sv["trainingAdmin.review"],
        "trainingAdmin.name": trainingAdminTranslations.sv["trainingAdmin.name"],
        "trainingAdmin.purpose": trainingAdminTranslations.sv["trainingAdmin.purpose"],
        "trainingAdmin.minutes": trainingAdminTranslations.sv["trainingAdmin.minutes"],
        "trainingAdmin.owner": trainingAdminTranslations.sv["trainingAdmin.owner"],
        "trainingAdmin.selectOwner": trainingAdminTranslations.sv["trainingAdmin.selectOwner"],
        "trainingAdmin.revision": trainingAdminTranslations.sv["trainingAdmin.revision"],
        "trainingAdmin.changeNote": trainingAdminTranslations.sv["trainingAdmin.changeNote"],
        "trainingAdmin.addPage": trainingAdminTranslations.sv["trainingAdmin.addPage"],
        "trainingAdmin.page": trainingAdminTranslations.sv["trainingAdmin.page"],
        "trainingAdmin.pageTitle": trainingAdminTranslations.sv["trainingAdmin.pageTitle"],
        "trainingAdmin.addCard": trainingAdminTranslations.sv["trainingAdmin.addCard"],
        "trainingAdmin.card": trainingAdminTranslations.sv["trainingAdmin.card"],
        "trainingAdmin.cardTitle": trainingAdminTranslations.sv["trainingAdmin.cardTitle"],
        "trainingAdmin.cardType": trainingAdminTranslations.sv["trainingAdmin.cardType"],
        "trainingAdmin.body": trainingAdminTranslations.sv["trainingAdmin.body"],
        "trainingAdmin.contentType": trainingAdminTranslations.sv["trainingAdmin.contentType"],
        "trainingAdmin.acknowledgementType": trainingAdminTranslations.sv["trainingAdmin.acknowledgementType"],
        "trainingAdmin.singleType": trainingAdminTranslations.sv["trainingAdmin.singleType"],
        "trainingAdmin.multipleType": trainingAdminTranslations.sv["trainingAdmin.multipleType"],
        "trainingAdmin.documentType": trainingAdminTranslations.sv["trainingAdmin.documentType"],
        "trainingAdmin.required": trainingAdminTranslations.sv["trainingAdmin.required"],
        "trainingAdmin.options": trainingAdminTranslations.sv["trainingAdmin.options"],
        "trainingAdmin.addOption": trainingAdminTranslations.sv["trainingAdmin.addOption"],
        "trainingAdmin.correct": trainingAdminTranslations.sv["trainingAdmin.correct"],
        "trainingAdmin.explanation": trainingAdminTranslations.sv["trainingAdmin.explanation"],
        "trainingAdmin.moveUp": trainingAdminTranslations.sv["trainingAdmin.moveUp"],
        "trainingAdmin.moveDown": trainingAdminTranslations.sv["trainingAdmin.moveDown"],
        "trainingAdmin.remove": trainingAdminTranslations.sv["trainingAdmin.remove"],
        "trainingAdmin.dependency": trainingAdminTranslations.sv["trainingAdmin.dependency"],
        "trainingAdmin.imageAlt": trainingAdminTranslations.sv["trainingAdmin.imageAlt"],
        "trainingAdmin.saveBeforeImage": trainingAdminTranslations.sv["trainingAdmin.saveBeforeImage"],
        "trainingAdmin.imageReady": trainingAdminTranslations.sv["trainingAdmin.imageReady"],
        "trainingAdmin.document": trainingAdminTranslations.sv["trainingAdmin.document"],
        "trainingAdmin.documentSearch": trainingAdminTranslations.sv["trainingAdmin.documentSearch"],
        "trainingAdmin.noDocuments": trainingAdminTranslations.sv["trainingAdmin.noDocuments"],
        "trainingAdmin.boundVersion": trainingAdminTranslations.sv["trainingAdmin.boundVersion"],
        "trainingAdmin.readRequired": trainingAdminTranslations.sv["trainingAdmin.readRequired"],
        "trainingAdmin.allUsers": trainingAdminTranslations.sv["trainingAdmin.allUsers"],
        "trainingAdmin.positions": trainingAdminTranslations.sv["trainingAdmin.positions"],
        "trainingAdmin.namedUsers": trainingAdminTranslations.sv["trainingAdmin.namedUsers"],
        "trainingAdmin.audienceHint": trainingAdminTranslations.sv["trainingAdmin.audienceHint"],
        "trainingAdmin.searchPeople": trainingAdminTranslations.sv["trainingAdmin.searchPeople"],
        "trainingAdmin.requirement": trainingAdminTranslations.sv["trainingAdmin.requirement"],
        "trainingAdmin.immediate": trainingAdminTranslations.sv["trainingAdmin.immediate"],
        "trainingAdmin.deadline": trainingAdminTranslations.sv["trainingAdmin.deadline"],
        "trainingAdmin.optional": trainingAdminTranslations.sv["trainingAdmin.optional"],
        "trainingAdmin.newUsersOnly": trainingAdminTranslations.sv["trainingAdmin.newUsersOnly"],
        "trainingAdmin.newUsersOnlyHint": trainingAdminTranslations.sv["trainingAdmin.newUsersOnlyHint"],
        "trainingAdmin.newUsersImmediateWarning": trainingAdminTranslations.sv["trainingAdmin.newUsersImmediateWarning"],
        "trainingAdmin.deadlineType": trainingAdminTranslations.sv["trainingAdmin.deadlineType"],
        "trainingAdmin.fixedDate": trainingAdminTranslations.sv["trainingAdmin.fixedDate"],
        "trainingAdmin.relativeDays": trainingAdminTranslations.sv["trainingAdmin.relativeDays"],
        "trainingAdmin.dueAt": trainingAdminTranslations.sv["trainingAdmin.dueAt"],
        "trainingAdmin.dueDays": trainingAdminTranslations.sv["trainingAdmin.dueDays"],
        "trainingAdmin.snooze": trainingAdminTranslations.sv["trainingAdmin.snooze"],
        "trainingAdmin.immediateWarning": trainingAdminTranslations.sv["trainingAdmin.immediateWarning"],
        "trainingAdmin.overdueWarning": trainingAdminTranslations.sv["trainingAdmin.overdueWarning"],
        "trainingAdmin.emailOptIn": trainingAdminTranslations.sv["trainingAdmin.emailOptIn"],
        "trainingAdmin.emailHint": trainingAdminTranslations.sv["trainingAdmin.emailHint"],
        "trainingAdmin.cadence": trainingAdminTranslations.sv["trainingAdmin.cadence"],
        "trainingAdmin.daily": trainingAdminTranslations.sv["trainingAdmin.daily"],
        "trainingAdmin.weekly": trainingAdminTranslations.sv["trainingAdmin.weekly"],
        "trainingAdmin.events": trainingAdminTranslations.sv["trainingAdmin.events"],
        "trainingAdmin.completed": trainingAdminTranslations.sv["trainingAdmin.completed"],
        "trainingAdmin.overdue": trainingAdminTranslations.sv["trainingAdmin.overdue"],
        "trainingAdmin.blocked": trainingAdminTranslations.sv["trainingAdmin.blocked"],
        "trainingAdmin.preview": trainingAdminTranslations.sv["trainingAdmin.preview"],
        "trainingAdmin.desktop": trainingAdminTranslations.sv["trainingAdmin.desktop"],
        "trainingAdmin.mobile": trainingAdminTranslations.sv["trainingAdmin.mobile"],
        "trainingAdmin.previewHint": trainingAdminTranslations.sv["trainingAdmin.previewHint"],
        "trainingAdmin.impact": trainingAdminTranslations.sv["trainingAdmin.impact"],
        "trainingAdmin.reviewImpact": trainingAdminTranslations.sv["trainingAdmin.reviewImpact"],
        "trainingAdmin.affectedUsers": trainingAdminTranslations.sv["trainingAdmin.affectedUsers"],
        "trainingAdmin.withoutPosition": trainingAdminTranslations.sv["trainingAdmin.withoutPosition"],
        "trainingAdmin.changedCards": trainingAdminTranslations.sv["trainingAdmin.changedCards"],
        "trainingAdmin.carriedCards": trainingAdminTranslations.sv["trainingAdmin.carriedCards"],
        "trainingAdmin.removedCards": trainingAdminTranslations.sv["trainingAdmin.removedCards"],
        "trainingAdmin.dependencyProblems": trainingAdminTranslations.sv["trainingAdmin.dependencyProblems"],
        "trainingAdmin.acknowledgeImpact": trainingAdminTranslations.sv["trainingAdmin.acknowledgeImpact"],
        "trainingAdmin.saveForReview": trainingAdminTranslations.sv["trainingAdmin.saveForReview"],
        "trainingAdmin.emptyGuides": trainingAdminTranslations.sv["trainingAdmin.emptyGuides"],
        "trainingAdmin.emptyHint": trainingAdminTranslations.sv["trainingAdmin.emptyHint"],
        "trainingAdmin.noResults": trainingAdminTranslations.sv["trainingAdmin.noResults"],
        "trainingAdmin.status": trainingAdminTranslations.sv["trainingAdmin.status"],
        "trainingAdmin.draft": trainingAdminTranslations.sv["trainingAdmin.draft"],
        "trainingAdmin.active": trainingAdminTranslations.sv["trainingAdmin.active"],
        "trainingAdmin.inactive": trainingAdminTranslations.sv["trainingAdmin.inactive"],
        "trainingAdmin.notStarted": trainingAdminTranslations.sv["trainingAdmin.notStarted"],
        "trainingAdmin.inProgress": trainingAdminTranslations.sv["trainingAdmin.inProgress"],
        "trainingAdmin.snoozed": trainingAdminTranslations.sv["trainingAdmin.snoozed"],
        "trainingAdmin.exempt": trainingAdminTranslations.sv["trainingAdmin.exempt"],
        "trainingAdmin.withdrawn": trainingAdminTranslations.sv["trainingAdmin.withdrawn"],
        "trainingAdmin.user": trainingAdminTranslations.sv["trainingAdmin.user"],
        "trainingAdmin.guide": trainingAdminTranslations.sv["trainingAdmin.guide"],
        "trainingAdmin.progress": trainingAdminTranslations.sv["trainingAdmin.progress"],
        "trainingAdmin.actions": trainingAdminTranslations.sv["trainingAdmin.actions"],
        "trainingAdmin.perGuide": trainingAdminTranslations.sv["trainingAdmin.perGuide"],
        "trainingAdmin.perUser": trainingAdminTranslations.sv["trainingAdmin.perUser"],
        "trainingAdmin.exportCsv": trainingAdminTranslations.sv["trainingAdmin.exportCsv"],
        "trainingAdmin.exportPdf": trainingAdminTranslations.sv["trainingAdmin.exportPdf"],
        "trainingAdmin.details": trainingAdminTranslations.sv["trainingAdmin.details"],
        "trainingAdmin.giveExemption": trainingAdminTranslations.sv["trainingAdmin.giveExemption"],
        "trainingAdmin.extendDeadline": trainingAdminTranslations.sv["trainingAdmin.extendDeadline"],
        "trainingAdmin.reason": trainingAdminTranslations.sv["trainingAdmin.reason"],
        "trainingAdmin.exemptionInfo": trainingAdminTranslations.sv["trainingAdmin.exemptionInfo"],
        "trainingAdmin.at": trainingAdminTranslations.sv["trainingAdmin.at"],
        "trainingAdmin.actor": trainingAdminTranslations.sv["trainingAdmin.actor"],
        "trainingAdmin.event": trainingAdminTranslations.sv["trainingAdmin.event"],
        "trainingAdmin.attempt": trainingAdminTranslations.sv["trainingAdmin.attempt"],
        "trainingAdmin.response": trainingAdminTranslations.sv["trainingAdmin.response"],
        "trainingAdmin.correctResult": trainingAdminTranslations.sv["trainingAdmin.correctResult"],
        "trainingAdmin.incorrectResult": trainingAdminTranslations.sv["trainingAdmin.incorrectResult"],
        "trainingAdmin.carried": trainingAdminTranslations.sv["trainingAdmin.carried"],
        "trainingAdmin.previous": trainingAdminTranslations.sv["trainingAdmin.previous"],
        "trainingAdmin.next": trainingAdminTranslations.sv["trainingAdmin.next"],
        "trainingAdmin.cancel": trainingAdminTranslations.sv["trainingAdmin.cancel"],
        "trainingAdmin.close": trainingAdminTranslations.sv["trainingAdmin.close"],
        "trainingAdmin.confirm": trainingAdminTranslations.sv["trainingAdmin.confirm"],
        "trainingAdmin.readOnly": trainingAdminTranslations.sv["trainingAdmin.readOnly"],
        "trainingAdmin.priceOnRequest": trainingAdminTranslations.sv["trainingAdmin.priceOnRequest"],
        "trainingAdmin.commercialActivation": trainingAdminTranslations.sv["trainingAdmin.commercialActivation"],
        "trainingAdmin.responsibleReports": trainingAdminTranslations.sv["trainingAdmin.responsibleReports"],
        "trainingAdmin.validationTitle": trainingAdminTranslations.sv["trainingAdmin.validationTitle"],
        "trainingAdmin.validationCards": trainingAdminTranslations.sv["trainingAdmin.validationCards"],
        "trainingAdmin.validationAnswer": trainingAdminTranslations.sv["trainingAdmin.validationAnswer"],
        "trainingAdmin.validationAudience": trainingAdminTranslations.sv["trainingAdmin.validationAudience"],
        "trainingAdmin.validationDocument": trainingAdminTranslations.sv["trainingAdmin.validationDocument"],
        "trainingAdmin.validationImage": trainingAdminTranslations.sv["trainingAdmin.validationImage"],
        "trainingAdmin.validationReason": trainingAdminTranslations.sv["trainingAdmin.validationReason"],
        "trainingParticipant.title": trainingParticipantSv["trainingParticipant.title"],
        "trainingAdmin.snoozeBeforeDeadline": trainingAdminTranslations.sv["trainingAdmin.snoozeBeforeDeadline"],
        "trainingAdmin.mandatorySnooze": trainingAdminTranslations.sv["trainingAdmin.mandatorySnooze"],
        "trainingAdmin.mandatorySnoozeHint": trainingAdminTranslations.sv["trainingAdmin.mandatorySnoozeHint"],
        "trainingParticipant.mandatoryDeferHint": trainingParticipantSv["trainingParticipant.mandatoryDeferHint"],
        "trainingParticipant.mandatoryDeferValidation": trainingParticipantSv["trainingParticipant.mandatoryDeferValidation"],
        "trainingParticipant.adminDefer": trainingParticipantSv["trainingParticipant.adminDefer"],
        "trainingParticipant.adminDeferShort": trainingParticipantSv["trainingParticipant.adminDeferShort"],
        "trainingParticipant.adminDeferHint": trainingParticipantSv["trainingParticipant.adminDeferHint"],
        "trainingParticipant.adminDeferProgress": trainingParticipantSv["trainingParticipant.adminDeferProgress"],
        "trainingParticipant.adminDeferChoiceHint": trainingParticipantSv["trainingParticipant.adminDeferChoiceHint"],
        "trainingParticipant.adminDeferValidation": trainingParticipantSv["trainingParticipant.adminDeferValidation"],
        "trainingParticipant.creatorApproved": trainingParticipantSv["trainingParticipant.creatorApproved"],
        "trainingParticipant.creatorApprovalStatement": trainingParticipantSv["trainingParticipant.creatorApprovalStatement"],
        "trainingParticipant.requiredDialogTitle": trainingParticipantSv["trainingParticipant.requiredDialogTitle"],
        "trainingParticipant.requiredDialogIntro": trainingParticipantSv["trainingParticipant.requiredDialogIntro"],
        "trainingParticipant.goToTraining": trainingParticipantSv["trainingParticipant.goToTraining"],
        "trainingParticipant.openGuide": trainingParticipantSv["trainingParticipant.openGuide"],
        "trainingParticipant.showRequirements": trainingParticipantSv["trainingParticipant.showRequirements"],
        "trainingParticipant.intro": trainingParticipantSv["trainingParticipant.intro"],
        "trainingParticipant.gateIntro": trainingParticipantSv["trainingParticipant.gateIntro"],
        "trainingParticipant.requiredCount": trainingParticipantSv["trainingParticipant.requiredCount"],
        "trainingParticipant.completedCount": trainingParticipantSv["trainingParticipant.completedCount"],
        "trainingParticipant.assignments": trainingParticipantSv["trainingParticipant.assignments"],
        "trainingParticipant.history": trainingParticipantSv["trainingParticipant.history"],
        "trainingParticipant.group.required": trainingParticipantSv["trainingParticipant.group.required"],
        "trainingParticipant.group.deadline": trainingParticipantSv["trainingParticipant.group.deadline"],
        "trainingParticipant.group.optional": trainingParticipantSv["trainingParticipant.group.optional"],
        "trainingParticipant.group.recommended": trainingParticipantSv["trainingParticipant.group.recommended"],
        "trainingParticipant.group.completed": trainingParticipantSv["trainingParticipant.group.completed"],
        "trainingParticipant.status.not_started": trainingParticipantSv["trainingParticipant.status.not_started"],
        "trainingParticipant.status.assigned": trainingParticipantSv["trainingParticipant.status.assigned"],
        "trainingParticipant.status.in_progress": trainingParticipantSv["trainingParticipant.status.in_progress"],
        "trainingParticipant.status.completed": trainingParticipantSv["trainingParticipant.status.completed"],
        "trainingParticipant.status.passed": trainingParticipantSv["trainingParticipant.status.passed"],
        "trainingParticipant.status.snoozed": trainingParticipantSv["trainingParticipant.status.snoozed"],
        "trainingParticipant.status.overdue": trainingParticipantSv["trainingParticipant.status.overdue"],
        "trainingParticipant.status.exempt": trainingParticipantSv["trainingParticipant.status.exempt"],
        "trainingParticipant.status.withdrawn": trainingParticipantSv["trainingParticipant.status.withdrawn"],
        "trainingParticipant.status.blocked_dependency": trainingParticipantSv["trainingParticipant.status.blocked_dependency"],
        "trainingParticipant.progress": trainingParticipantSv["trainingParticipant.progress"],
        "trainingParticipant.due": trainingParticipantSv["trainingParticipant.due"],
        "trainingParticipant.snoozedUntil": trainingParticipantSv["trainingParticipant.snoozedUntil"],
        "trainingParticipant.start": trainingParticipantSv["trainingParticipant.start"],
        "trainingParticipant.continue": trainingParticipantSv["trainingParticipant.continue"],
        "trainingParticipant.view": trainingParticipantSv["trainingParticipant.view"],
        "trainingParticipant.snooze": trainingParticipantSv["trainingParticipant.snooze"],
        "trainingParticipant.snoozeHint": trainingParticipantSv["trainingParticipant.snoozeHint"],
        "trainingParticipant.remindAt": trainingParticipantSv["trainingParticipant.remindAt"],
        "trainingParticipant.saveReminder": trainingParticipantSv["trainingParticipant.saveReminder"],
        "trainingParticipant.snoozeValidation": trainingParticipantSv["trainingParticipant.snoozeValidation"],
        "trainingParticipant.subscriptionInactive": trainingParticipantSv["trainingParticipant.subscriptionInactive"],
        "trainingParticipant.noAssignments": trainingParticipantSv["trainingParticipant.noAssignments"],
        "trainingParticipant.noHistory": trainingParticipantSv["trainingParticipant.noHistory"],
        "trainingParticipant.guide": trainingParticipantSv["trainingParticipant.guide"],
        "trainingParticipant.revisionLabel": trainingParticipantSv["trainingParticipant.revisionLabel"],
        "trainingParticipant.completedAt": trainingParticipantSv["trainingParticipant.completedAt"],
        "trainingParticipant.receipt": trainingParticipantSv["trainingParticipant.receipt"],
        "trainingParticipant.loading": trainingParticipantSv["trainingParticipant.loading"],
        "trainingParticipant.saving": trainingParticipantSv["trainingParticipant.saving"],
        "trainingParticipant.saved": trainingParticipantSv["trainingParticipant.saved"],
        "trainingParticipant.savedRefreshFailed": trainingParticipantSv["trainingParticipant.savedRefreshFailed"],
        "trainingParticipant.loadFailed": trainingParticipantSv["trainingParticipant.loadFailed"],
        "trainingParticipant.revisionChanged": trainingParticipantSv["trainingParticipant.revisionChanged"],
        "trainingParticipant.accessChanged": trainingParticipantSv["trainingParticipant.accessChanged"],
        "trainingParticipant.unknownOutcome": trainingParticipantSv["trainingParticipant.unknownOutcome"],
        "trainingParticipant.sameAttempt": trainingParticipantSv["trainingParticipant.sameAttempt"],
        "trainingParticipant.statusFailed": trainingParticipantSv["trainingParticipant.statusFailed"],
        "trainingParticipant.checkStatus": trainingParticipantSv["trainingParticipant.checkStatus"],
        "trainingParticipant.retrySame": trainingParticipantSv["trainingParticipant.retrySame"],
        "trainingParticipant.refresh": trainingParticipantSv["trainingParticipant.refresh"],
        "trainingParticipant.back": trainingParticipantSv["trainingParticipant.back"],
        "trainingParticipant.next": trainingParticipantSv["trainingParticipant.next"],
        "trainingParticipant.close": trainingParticipantSv["trainingParticipant.close"],
        "trainingParticipant.finish": trainingParticipantSv["trainingParticipant.finish"],
        "trainingParticipant.revision": trainingParticipantSv["trainingParticipant.revision"],
        "trainingParticipant.pageCount": trainingParticipantSv["trainingParticipant.pageCount"],
        "trainingParticipant.revisionProgress": trainingParticipantSv["trainingParticipant.revisionProgress"],
        "trainingParticipant.carried": trainingParticipantSv["trainingParticipant.carried"],
        "trainingParticipant.multipleHint": trainingParticipantSv["trainingParticipant.multipleHint"],
        "trainingParticipant.singleHint": trainingParticipantSv["trainingParticipant.singleHint"],
        "trainingParticipant.readDocument": trainingParticipantSv["trainingParticipant.readDocument"],
        "trainingParticipant.moreInformation": trainingParticipantSv["trainingParticipant.moreInformation"],
        "trainingParticipant.confirmContent": trainingParticipantSv["trainingParticipant.confirmContent"],
        "trainingParticipant.answerPassed": trainingParticipantSv["trainingParticipant.answerPassed"],
        "trainingParticipant.answerIncorrect": trainingParticipantSv["trainingParticipant.answerIncorrect"],
        "trainingParticipant.checkAnswer": trainingParticipantSv["trainingParticipant.checkAnswer"],
        "trainingParticipant.confirm": trainingParticipantSv["trainingParticipant.confirm"],
        "trainingParticipant.completed": trainingParticipantSv["trainingParticipant.completed"],
        "trainingParticipant.completionStatement": trainingParticipantSv["trainingParticipant.completionStatement"],
        "trainingParticipant.emptyGuide": trainingParticipantSv["trainingParticipant.emptyGuide"],
        "trainingParticipant.previewNotice": trainingParticipantSv["trainingParticipant.previewNotice"],
        "trainingParticipant.previewImage": trainingParticipantSv["trainingParticipant.previewImage"],
        "trainingParticipant.imageFailed": trainingParticipantSv["trainingParticipant.imageFailed"],
        "trainingParticipant.document": trainingParticipantSv["trainingParticipant.document"],
        "trainingParticipant.backToGuide": trainingParticipantSv["trainingParticipant.backToGuide"],
        "trainingParticipant.documentRevision": trainingParticipantSv["trainingParticipant.documentRevision"],
        "trainingParticipant.documentFailed": trainingParticipantSv["trainingParticipant.documentFailed"],
        "trainingParticipant.textAlternative": trainingParticipantSv["trainingParticipant.textAlternative"],
        "trainingParticipant.documentPages": trainingParticipantSv["trainingParticipant.documentPages"],
        "trainingParticipant.readUnderstood": trainingParticipantSv["trainingParticipant.readUnderstood"],
        "trainingParticipant.confirmReading": trainingParticipantSv["trainingParticipant.confirmReading"],
        "trainingParticipant.previewConfirm": trainingParticipantSv["trainingParticipant.previewConfirm"],
        "trainingParticipant.cardNumber": trainingParticipantSv["trainingParticipant.cardNumber"],
        "trainingParticipant.carriedReceipt": trainingParticipantSv["trainingParticipant.carriedReceipt"],
        "trainingParticipant.confirmedReceipt": trainingParticipantSv["trainingParticipant.confirmedReceipt"],
        "trainingParticipant.recovery": trainingParticipantSv["trainingParticipant.recovery"],
        "trainingParticipant.adminRecovery": trainingParticipantSv["trainingParticipant.adminRecovery"],
        "trainingParticipant.checkingRequirements": trainingParticipantSv["trainingParticipant.checkingRequirements"],
        "trainingParticipant.gateFailed": trainingParticipantSv["trainingParticipant.gateFailed"],
        "trainingParticipant.gateRecovery": trainingParticipantSv["trainingParticipant.gateRecovery"],

        "serviceReminders.title": "Automatiska bokningspåminnelser",
        "serviceReminders.intro": "Välj när och hur kunden ska påminnas. Alla kanaler är avstängda som standard.",
        "serviceReminders.visit": "Före bekräftad service",
        "serviceReminders.visitHint": "Påminn kunden om ett kommande bekräftat servicebesök.",
        "serviceReminders.visitDays": "dagar före avtalat datum",
        "serviceReminders.confirmation": "Väntar på bekräftelse",
        "serviceReminders.confirmationHint": "Följ upp en skickad bokning som kunden ännu inte har bekräftat.",
        "serviceReminders.confirmationDays": "dagar efter att bokningen skickades",
        "serviceReminders.sms": "SMS",
        "serviceReminders.email": "E-post",
        "serviceReminders.once": "En påminnelse per bokning och kanal. Ombokning kan ge en ny påminnelse. Inget skickas på eller efter besöksdagen.",
        "serviceReminders.save": "Spara påminnelser",
        "serviceReminders.invalidDays": "Ange ett helt antal dagar från 1 till 365.",
        "serviceReminders.unknown": "Vi kunde inte bekräfta sparandet. Hämta sparade inställningar innan du försöker igen.",
        "serviceReminders.reload": "Hämta sparade inställningar",
        "serviceReminders.disabledHint": "Ingen vald kanal betyder att påminnelsen är avstängd.",
        "serviceReminders.history": "Bokningspåminnelse",
        "serviceReminders.state.sent": "Skickad",
        "serviceReminders.state.sending": "Sändning startad – resultat inte bekräftat",
        "serviceReminders.state.unknown": "Oklart – skickas inte igen utan säker bekräftelse",
        "serviceReminders.state.retrying": "Inte skickad – nytt försök planerat",
        "serviceReminders.state.connection_required": "Kontrollera anslutningen till företagets inkorg",
        "serviceReminders.state.lookup_unavailable": "Leveransstatus är tillfälligt otillgänglig",
        "serviceReminders.state.failed": "Inte skickad – automatiska försök avslutade",
        "serviceReminders.state.skipped": "Inte skickad",
        "histories.action.service_appointment_reminder": "Bokningspåminnelse",
        "collaboration.changed.order": "Ordern har nya ändringar",
        "collaboration.changed.meeting_minutes_meeting": "Mötet har nya ändringar",
        "collaboration.changed.project_plan": "Projektplanen har nya ändringar",
        "collaboration.changed.calculation": "Kalkylen har nya ändringar",
        "collaboration.title": "Samarbete",
        "collaboration.live": "Realtid ansluten",
        "collaboration.offline": "Realtid är otillgänglig – kontrollera senaste versionen före sparande",
        "collaboration.viewing": "visar",
        "collaboration.editing": "redigerar",
        "collaboration.away": "inaktiv",
        "collaboration.changed": "Rapporten har nya ändringar",
        "collaboration.reviewNeeded": "Kontrollera senaste versionen innan du försöker igen",
        "collaboration.keepDraft": "Ditt utkast finns kvar. Kontrollera senaste versionen innan du fortsätter spara.",
        "collaboration.minimize": "Minimera avisering",
        "collaboration.reload": "Hämta senaste versionen",
        "collaboration.discardWarning": "Omladdning tar bort osparade ändringar på sidan och i öppna dialoger. Kopiera text du vill behålla innan du fortsätter.",
        "collaboration.keepEditing": "Behåll utkastet",
        "collaboration.confirmReload": "Kasta utkast och ladda om",
        "collaboration.section.overview": "Översikt",
        "collaboration.section.info": "Information",
        "collaboration.section.report": "Rapporttext",
        "collaboration.section.checklist": "Checklista",
        "collaboration.section.items": "Artiklar",
        "collaboration.section.hours": "Timmar",
        "collaboration.section.variables": "Variabler",
        "collaboration.section.price": "Prisrader",
        "collaboration.section.team": "Ansvariga",
        "collaboration.section.status": "Status",
        "collaboration.section.agenda": "Agenda",
        "collaboration.section.plan": "Plan",
        "collaboration.section.resources": "Resurser",
        "reportWizard.details": "Uppgifter",
        "reportWizard.review": "Granska",
        "reportWizard.eyebrow": "Ny servicerapport",
        "reportWizard.subtitle": "Välj typ, fyll i uppgifterna och kontrollera innan rapporten skapas.",
        "reportWizard.section.parties": "Kund och projekt",
        "reportWizard.section.partiesHint": "Vem rapporten gäller och var den hör hemma.",
        "reportWizard.section.job": "Uppdrag",
        "reportWizard.section.jobHint": "Datum, anläggning och checklista för uppdraget.",
        "reportWizard.section.text": "Beskrivningar",
        "reportWizard.section.textHint": "Text kunden ser och interna anteckningar.",
        "reportWizard.section.addressHint": "Var jobbet utförs. Standard är kundens adress.",
        "reportWizard.section.billingHint": "Valfritt. Fakturamottagare och projektekonomi.",
        "pickers.system.placeholder": "Välj anläggning",
        "pickers.system.needsCustomer": "Välj kund först",
        "pickers.system.search": "Sök produkt, serienummer eller placering",
        "pickers.system.empty": "Kunden har inga anläggningar ännu",
        "pickers.system.create": "Ny anläggning",
        "pickers.address.placeholder": "Välj uppdragsadress",
        "pickers.address.search": "Sök namn eller adress",
        "pickers.address.filterCompany": "Företaget",
        "pickers.address.filterProject": "Projekt",
        "pickers.address.filterCustomer": "Kundens",
        "pickers.address.filterAll": "Alla",
        "pickers.address.empty": "Inga adresser i detta urval",
        "pickers.address.create": "Ny adress",
        "pickers.address.companyPostal": "Postadress",
        "pickers.address.companyPhysical": "Besöksadress",
        "pickers.address.companyPostalAndPhysical": "Post- och besöksadress",
        "pickers.search": "Sök …",
        "pickers.clear": "Rensa val",
        "pickers.clearSearch": "Rensa sökning",
        "pickers.filters": "Filter",
        "pickers.empty": "Inga träffar",
        "pickers.emptyQuery": "Inga träffar för ”{{query}}”",
        "pickers.loadFailed": "Kunde inte hämta listan.",
        "pickers.retry": "Försök igen",
        "pickers.moreResults": "Visar de {{count}} första. Sök för att begränsa.",
        "pickers.hintMove": "↑↓ flytta",
        "pickers.hintSelect": "↵ välj",
        "pickers.hintClose": "esc stäng",
        "pickers.customer.placeholder": "Välj kund",
        "pickers.customer.search": "Sök namn, kundnummer eller adress",
        "pickers.customer.filterAll": "Alla",
        "pickers.customer.filterCompany": "Företag",
        "pickers.customer.filterPrivate": "Privat",
        "pickers.customer.create": "Ny kund",
        "pickers.project.placeholder": "Välj projekt",
        "pickers.project.search": "Sök namn eller projektnummer",
        "pickers.project.filterCustomer": "Kundens",
        "pickers.project.filterActive": "Aktiva",
        "pickers.project.filterInactive": "Avslutade",
        "pickers.project.empty": "Inga projekt i detta urval",
        "pickers.contact.placeholder": "Välj kontakt",
        "pickers.contact.search": "Sök namn, e-post eller telefon",
        "pickers.contact.filterCustomer": "Kundens",
        "pickers.contact.filterAll": "Alla",
        "pickers.contact.empty": "Inga kontakter i detta urval",
        "pickers.contact.create": "Ny kontakt",
        "pickers.folder.label": "Mapp",
        "pickers.folder.placeholder": "Välj mapp",
        "pickers.folder.needsProject": "Välj projekt först",
        "pickers.folder.search": "Sök i mappar",
        "pickers.folder.empty": "Projektet har inga mappar",
        "reportWizard.invoiceCustomer": "Fakturakund",
        "reportWizard.intro": "Skapa rapport steg för steg",
        "reportWizard.typeHint": "Välj rapporttyp för uppdraget och granska de rekommenderade inställningarna.",
        "reportWizard.typeRange": "Visar {{from}}–{{to}} av {{total}} typer",
        "reportWizard.previousTypes": "Föregående typer",
        "reportWizard.nextTypes": "Nästa typer",
        "reportWizard.selectedType": "Vald typ: {{title}}",
        "reportWizard.searchTypes": "Sök rapporttyp",
        "reportWizard.noResults": "Inga träffar. Prova en annan sökning.",
        "reportWizard.loadFailed": "Kunde inte hämta alternativen.",
        "reportWizard.template": "Använd som mall",
        "reportWizard.suggestion": "Visa som förslag",
        "reportWizard.recommended": "Rekommenderade inställningar",
        "reportWizard.applyDefaults": "Använd rekommenderade inställningar",
        "reportWizard.preserveEdits": "Fyller fält du inte har ändrat. Egen text och egna val behålls.",
        "reportWizard.noChecklist": "Ingen förvald checklista",
        "reportWizard.searchChecklist": "Sök checklistemall",
        "reportWizard.internalDescription": "Intern beskrivning",
        "reportWizard.customerVisible": "Synlig för kunden.",
        "reportWizard.internalOnly": "Endast synlig internt.",
        "reportWizard.applied": "Rekommenderade inställningar används",
        "reportWizard.manual": "Egna inställningar",
        "reportWizard.billingOptions": "Fakturering och projektekonomi",
        "reportWizard.reviewHint": "Kontrollera innehållet. Rapporten skapas först när du bekräftar nedan.",
        "reportWizard.afterCreate": "Efter skapandet kan du fylla i checklistan och lägga till timmar, artiklar, prisrader och dokument i rapporten.",
        "reportWizard.create": "Skapa rapport",
        "reportWizard.unknown": "Vi kunde inte bekräfta om rapporten skapades. Kontrollera rapportlistan innan du försöker igen.",
        "reportWizard.unknownType": "Vi kunde inte bekräfta sparandet. Stäng och ladda rapporttypen igen innan du försöker igen.",
        "reportWizard.refreshFailed": "Rapporten är skapad, men kopplingen eller uppdateringen av vyn kunde inte bekräftas. Skapa inte igen.",
        "reportWizard.saved": "Rapporten är skapad.",
        "reportWizard.openReport": "Öppna rapport",
        "reportWizard.settingsHint": "Dessa fält används när nya rapporter skapas. Befintliga rapporter ändras inte. Typbeskrivningen ovan är endast vägledning.",
        "reportWizard.application": "Använd vid skapande",
        "reportWizard.defaultChecklist": "Rekommenderad checklistemall",
        "reportWizard.enableChecklist": "Aktivera Checklista nedan för att använda mallen när rapporten skapas.",
        "reportWizard.defaultDescription": "Standardbeskrivning i rapport",
        "reportWizard.defaultInternalDescription": "Standard intern beskrivning",
        "reportWizard.module.checklist": "Checklista",
        "reportWizard.module.items": "Artiklar",
        "reportWizard.module.hours": "Timmar",
        "reportWizard.module.variables": "Variabler",
        "reportWizard.module.system": "Anläggning",
        "reportWizard.module.agreement": "Avtal",
        "reportWizard.type": "Rapporttyp",
        "reportWizard.next": "Nästa",
        "reportWizard.orderDate": "Orderdatum",
        "reportWizard.useCustomerAddress": "Använd kundens adress",
        "reportWizard.deliveryAddress": "Uppdragsadress",
        "reportWizard.system": "Anläggning",
        "reportWizard.loading": "Laddar …",
        "reportWizard.retry": "Försök igen",









































        "serviceSettings.title": "Serviceinställningar",
        "serviceSettings.hour_product": "Standardprodukt för servicetimmar",
        "serviceSettings.product": "Produkt",
        "serviceSettings.search_label": "Sök",
        "serviceSettings.previous": "Föregående",
        "serviceSettings.next": "Nästa",
        "serviceSettings.name": "Namn",
        "serviceSettings.interval": "Intervall",
        "serviceSettings.report_type": "Rapporttyp",
        "serviceSettings.agreement_type": "Avtalstyp",
        "serviceSettings.agreement_start_date": "Avtalsstart",
        "serviceSettings.title_no_ampersand": "Titeln får inte innehålla tecknet «&»",
        "serviceSettings.description": "Beskrivning",
        "serviceSettings.conditions": "Villkor",
        "serviceSettings.active": "Aktiv",
        "serviceSettings.system": "Anläggning",
        "serviceSettings.simple_report": "Enkel rapport",
        "serviceSettings.agreement": "Avtal",
        "serviceSettings.items": "Varor",
        "serviceSettings.checklist": "Checklista",
        "serviceSettings.hours": "Timmar",
        "serviceSettings.variables": "Variabler",
        "itemListDetail.change_product": "Byt produkt",
        "serviceSettings.eyebrow": "Service / inställningar",
        "serviceSettings.intro": "Anpassa avtal, rapporter och standardval för en tydligare servicevardag.",
        "serviceSettings.types": "Typer och rapportguider",
        "serviceSettings.general": "Allmänt",
        "serviceSettings.agreement_hint": "Villkor och rapportval som används när du skapar serviceavtal.",
        "serviceSettings.report_hint": "Välj innehåll och funktioner för varje rapporttyp.",
        "serviceSettings.variable_hint": "Namnge mätningar och andra variabler som används i rapporterna.",
        "serviceSettings.search": "Sök efter typ…",
        "serviceSettings.no_results": "Inga träffar",
        "serviceSettings.search_hint": "Prova ett annat sökord.",
        "serviceSettings.empty": "Inga typer ännu",
        "serviceSettings.empty_hint": "Lägg till den första typen för att komma igång.",
        "serviceSettings.load_failed": "Kunde inte hämta inställningarna.",
        "serviceSettings.save_failed": "Kunde inte spara. Kontrollera fälten och försök igen.",
        "serviceSettings.unknown": "Det gick inte att bekräfta att ändringarna sparades. Ladda om sidan och kontrollera resultatet innan du försöker igen.",
        "serviceSettings.saved_type": "”{{title}}” har sparats.",
        "serviceSettings.create_reports": "Skapa rapporter vid utförande",
        "serviceSettings.mission_hint": "Skapa både rapport och order när avtalet utförs. Avstängt skapas endast en order.",
        "serviceSettings.report_content": "Rapportens innehåll och tillgänglighet",
        "serviceSettings.notifications": "Rapportaviseringar",
        "serviceSettings.notifications_hint": "Ange vem som ska meddelas när en rapport färdigställs.",
        "serviceSettings.email": "E-post för färdigställda rapporter",
        "serviceSettings.product_hint": "Produkten som används som standard vid registrering av servicetimmar.",
        "serviceSettings.conditions_hint": "Standardvillkor som även följer med i e-post vid avtalsbekräftelse.",
        "serviceSettings.unsaved": "Du har osparade ändringar.",
        "serviceSettings.save_hint": "Ändringar sparas när du väljer Spara inställningar.",
        "serviceSettings.save": "Spara inställningar",
        "serviceSettings.no_access": "Du har inte tillgång till serviceinställningarna.",
        "itemListDetail.pick_date": "Plockdatum",
        "itemListDetail.save_date": "Spara datum",
        "itemListDetail.heading": "Materialförbrukning",
        "itemListDetail.eyebrow": "Projekt / material",
        "itemListDetail.back": "Tillbaka till projekt",
        "itemListDetail.refresh": "Uppdatera",
        "itemListDetail.pdf": "Ladda ner PDF",
        "itemListDetail.pdf_failed": "Kunde inte hämta PDF. Försök igen.",
        "itemListDetail.pdf_ready": "PDF är klar för nedladdning.",
        "itemListDetail.load_failed": "Kunde inte hämta listan. Välj Uppdatera för att försöka igen.",
        "itemListDetail.loading": "Laddar…",
        "itemListDetail.add": "Lägg till produkter",
        "itemListDetail.edit": "Redigera",
        "itemListDetail.title": "Produkt / titel",
        "itemListDetail.description": "Beskrivning",
        "itemListDetail.quantity": "Antal",
        "itemListDetail.purchase_price": "Inköpspris exkl. moms",
        "itemListDetail.sales_price": "Försäljningspris exkl. moms",
        "itemListDetail.discount": "Rabatt (%)",
        "itemListDetail.surcharge": "Påslag (%)",
        "itemListDetail.price_options": "Fler prisalternativ",
        "itemListDetail.product_id": "Produkt-ID",
        "itemListDetail.status": "Status",
        "itemListDetail.approval_comment": "Kommentar",
        "itemListDetail.line": "Rad {{number}}",
        "itemListDetail.lines": "Produktrader",
        "itemListDetail.total_purchase": "Inköpssumma exkl. moms",
        "itemListDetail.total_sales": "Försäljningsvärde exkl. moms före justeringar",
        "itemListDetail.line_total": "Inköpssumma",
        "itemListDetail.products": "Produkter",
        "itemListDetail.filter": "Sök i materialförbrukningen…",
        "itemListDetail.empty": "Inga produkter att visa.",
        "itemListDetail.edit_line": "Redigera {{title}}",
        "itemListDetail.remove_line": "Ta bort {{title}}",
        "itemListDetail.edit_hint": "Redigera produkt, antal och inköpspris med pennan på varje rad. Ändringar registreras i historiken.",
        "itemListDetail.locked_hint": "Listan är låst. Admin kan öppna inskickad eller godkänd materialförbrukning igen. Fakturerade listor förblir låsta.",
        "itemListDetail.action_reopen": "Öppna materialförbrukning igen",
        "itemListDetail.action_submit": "Skicka för godkännande",
        "itemListDetail.action_approve": "Godkänn",
        "itemListDetail.action_reject": "Avvisa",
        "itemListDetail.action_invoice": "Markera manuellt fakturerad",
        "itemListDetail.action_delete": "Radera varulistan",
        "itemListDetail.action_remove": "Ta bort produkt",
        "itemListDetail.confirm": "Bekräfta",
        "itemListDetail.confirm_hint": "Bekräfta åtgärden för ”{{title}}”.",
        "itemListDetail.reopen_hint": "Listan öppnas för redigering och måste skickas för nytt godkännande. Tidigare godkännande och återöppningen visas i historiken.",
        "itemListDetail.completed": "Åtgärden är slutförd.",
        "itemListDetail.find_product": "Hitta produkt",
        "itemListDetail.search_hint": "Namn, produktnummer eller QR-kod",
        "itemListDetail.scan": "Skanna QR-kod",
        "itemListDetail.stop_camera": "Stoppa kameran",
        "itemListDetail.camera_failed": "Kunde inte öppna kameran. Kontrollera kameraåtkomst eller använd sökfältet.",
        "itemListDetail.searching": "Söker efter produkter…",
        "itemListDetail.search_failed": "Produktsökningen misslyckades.",
        "itemListDetail.results": "{{count}} produkter hittades",
        "itemListDetail.select": "Välj",
        "itemListDetail.manual": "Lägg till manuell rad",
        "itemListDetail.remove": "Ta bort",
        "itemListDetail.save": "Spara",
        "itemListDetail.saving": "Sparar…",
        "itemListDetail.saved": "Sparat",
        "itemListDetail.save_failed": "Kunde inte spara. Kontrollera fälten.",
        "itemListDetail.invalid": "Ange produkt/titel. Antal måste vara större än 0 och priser/rabatt/påslag måste vara 0 eller positiva tal.",
        "itemListDetail.discard": "Kasta osparade ändringar?",
        "itemListDetail.unknown": "Resultatet är okänt. Behåll värdena, stäng dialogen och uppdatera listan för att kontrollera resultatet innan du försöker igen.",
        "itemListDetail.refresh_failed": "Ändringen har sparats men listan kunde inte uppdateras. Stäng dialogen och välj Uppdatera.",
        "itemListDetail.progress": "{{count}} av {{total}} rader sparade",
        "itemListDetail.product_change_hint": "Produktbyte behåller antal och priser. Justera vid behov; produktregistret ändras inte.",
        "itemListDetail.history": "Historik",
        "itemListDetail.history_hint": "Registrerade ändringar med användare, tidpunkt och värden före/efter. Äldre ändringar som inte loggades visas inte.",
        "itemListDetail.history_failed": "Kunde inte hämta historiken.",
        "itemListDetail.history_empty": "Inga loggade ändringar ännu.",
        "itemListDetail.system": "System",
        "itemListDetail.event_create": "Lista skapad",
        "itemListDetail.event_update": "Lista ändrad",
        "itemListDetail.event_destroy": "Lista raderad",
        "itemListDetail.event_add_item": "Produkt tillagd",
        "itemListDetail.event_update_item": "Produktrad ändrad",
        "itemListDetail.event_remove_item": "Produkt borttagen",
        "itemListDetail.event_approve": "Godkänd",
        "itemListDetail.event_reject": "Avvisad",
        "itemListDetail.event_submit_for_approval": "Skickad för godkännande",
        "itemListDetail.event_mark_invoiced_manually": "Markerad manuellt fakturerad",
        "itemListDetail.event_reopen": "Öppnad för redigering",
        "service.agreements.subs.facility_select": "Välj registrerad anläggning",
        "service.agreements.subs.facility_manual": "Ange manuellt",
        "service.agreements.subs.filter_manual": "Manuell filtertext",
        "service.agreements.subs.filter_products": "Produkter som rader",
        "service.agreements.subs.find_filter_product": "Sök och lägg till filterprodukt",
        "service.agreements.subs.filters_empty": "Sök efter en produkt för att lägga till en filterrad.",
        "service.agreements.subs.use_suggestion": "Använd förslag: {{suggestion}}",
        "service.agreements.subs.address_loading": "Hämtar anläggningens adress…",
        "service.agreements.subs.address_failed": "Kunde inte hämta anläggningens adress.",
        "itemListDetail.bulk_add": "Lägg till produkter i bulk",
        "itemListDetail.add_selected": "Lägg till valda ({{count}})",
        "itemListDetail.scan_no_exact_match": "Ingen exakt träff på skannad kod. Använd Sök manuellt.",
        "product.selector.dialog_title": "Välj produkt",
        "product.selector.dialog_title_multiple": "Välj produkter",
        "service.agreements.subs.quantity": "Antal",
        "service.agreements.subs.quantity_invalid": "Antal måste vara större än 0 och högst 10 000.",
        "service.agreements.subs.save_unknown": "Sparandet kunde inte bekräftas. Stäng dialogen och ladda om listan för att kontrollera resultatet innan du försöker igen.",
  "service.agreements.filters.active": "Aktiva avtal",
  "service.agreements.filters.service_soon": "Service snart",
  "relatedEntries.search": "Sök i listan…",
  "relatedEntries.preview": "Förhandsvisa",
  "relatedEntries.previewEntry": "Förhandsvisa #{{number}}",
  "relatedEntries.filters": "Filter",
  "relatedEntries.clear": "Rensa filter",
  "relatedEntries.newest": "Senaste först",
  "relatedEntries.loading": "Laddar…",
  "relatedEntries.loadFailed": "Kunde inte hämta listan.",
  "relatedEntries.retry": "Försök igen",
  "relatedEntries.empty": "Inga träffar",
  "relatedEntries.emptyHint": "Prova en annan sökning eller ändra filtren.",
  "relatedEntries.loadMore": "Visa fler",
  "relatedEntries.select": "Välj #{{number}}",
  "relatedEntries.created": "Skapad",
  "relatedEntries.date": "Datum",
  "relatedEntries.agreed": "Avtalat datum",
  "relatedEntries.delivery": "Leveransdatum",
  "relatedEntries.due": "Förfallodatum",
  "relatedEntries.nextService": "Nästa service",
  "relatedEntries.project": "Projekt",
  "relatedEntries.customer": "Kund",
  "relatedEntries.address": "Adress",
  "relatedEntries.description": "Beskrivning",
  "relatedEntries.viewFullDescription": "Visa hela beskrivningen",
  "relatedEntries.viewFullDescriptionEntry": "Visa hela beskrivningen för #{{number}}",
  "relatedEntries.descriptionDialogTitle": "Rapportbeskrivning",
  "relatedEntries.descriptionDialogEyebrow": "Rapport #{{number}}",
  "relatedEntries.assigned": "Ansvarig",
  "relatedEntries.type": "Typ",
  "relatedEntries.serial": "Serienummer",
  "relatedEntries.reports": "Rapporter",
  "relatedEntries.orders": "Ordrar",
  "relatedEntries.workOrders": "Arbetsordrar",
  "relatedEntries.agreements": "Avtal",
  "relatedEntries.projects": "Projekt",
  "relatedEntries.cases": "Ärenden",
  "relatedEntries.facilities": "Anläggningar",
        "hourBilling.workspace": "Tidavstämning",
        "hourBilling.refresh": "Uppdatera",
        "hourBilling.searchHours": "Sök anställd, projekt eller beskrivning…",
        "hourBilling.selectInTable": "Välj tider i tabellen",
        "hourBilling.tableHint": "Markera enskilda tider eller hela sidan. Urvalet återställs när du byter sida eller filter.",
        "hourBilling.clearSelection": "Rensa urval",
        "hourBilling.selectPage": "Välj alla på denna sida",
        "hourBilling.selectEntry": "Välj tidrapport",
        "hourBilling.employeeDate": "Anställd / datum",
        "hourBilling.project": "Projekt",
        "hourBilling.actions": "Åtgärd",
        "hourBilling.editEntry": "Stäm av",
        "hourBilling.emptyHint": "Listan visar inhyrda timmar utan full fakturatäckning. Prova att ändra sökning eller filter.",
        "hourBilling.search_orders": "Sök ordernummer, referens eller kommentar…",
        "hourBilling.search_invoices": "Sök fakturanummer, leverantör, verifikation eller beskrivning…",
        "hourBilling.searching": "Söker bland alla tillgängliga träffar…",
        "hourBilling.searchResults": "{{count}} träffar visas",
        "hourBilling.noChoices": "Inga passande träffar. Prova en annan sökning.",
        "hourBilling.searchFailed": "Sökningen kunde inte slutföras.",
        "hourBilling.moreChoices": "Visa fler träffar",
        "hourBilling.applySelection": "Ändringarna gäller alla valda tider.",
        "hourBilling.customerSection": "Kundfakturering",
        "hourBilling.costSection": "Inhyrning och kostnadstäckning",
        "hourBilling.salarySection": "Lön och egna anställda",
        "hourBilling.reloadStatus": "Hämta senaste status",
        "hourBilling.unknownSave": "Det gick inte att bekräfta sparandet. Hämta senaste status innan du gör fler ändringar.",
        "hourBilling.hours": "timmar",
        "announcements.communication": "Kommunikation",
        "announcements.headline": "Håll alla uppdaterade",
        "announcements.intro": "Samla viktig information, rutiner och nyheter. Välj vem som ska se meddelandet och hur det ska nå fram.",
        "announcements.scheduled": "Planerat",
        "announcements.expired": "Utgånget",
        "announcements.all": "Alla",
        "announcements.search": "Sök meddelanden…",
        "announcements.filter": "Filtrera på publiceringsstatus",
        "announcements.noDate": "Inte angivet",
        "announcements.empty": "Det första meddelandet börjar här",
        "announcements.emptyHint": "Skriv en uppdatering till kollegorna, en intern rutin eller en nyhet till webbplatsen.",
        "announcements.noMatches": "Inga matchande meddelanden",
        "announcements.searchHint": "Prova ett annat sökord eller statusfilter.",
        "announcements.preview": "Förhandsvisning",
        "announcements.channelApp": "App / webbplats",
        "announcements.channelEmail": "E-post",
        "announcements.edit": "Redigera meddelande",
        "announcements.message": "Skriv meddelandet",
        "announcements.messageHint": "En tydlig rubrik och kort text gör informationen lätt att hitta.",
        "announcements.titlePlaceholder": "Vad vill du dela?",
        "announcements.bodyPlaceholder": "Skriv det mottagarna behöver veta…",
        "announcements.in_appHint": "Visas för vald målgrupp när den är publicerad och inom perioden.",
        "announcements.email_enabledHint": "Välj mottagare och bekräfta utskick efter att du sparat. Att spara skickar ingen e-post.",
        "announcements.visibility": "Publicering och period",
        "announcements.publishToggle": "Publicera meddelandet",
        "announcements.visibilityHint": "Av betyder utkast. Med ett framtida startdatum visas meddelandet från den tidpunkten. E-post skickas genom ett separat val.",
        "announcements.saveHint": "E-post skickas i ett separat steg",
        "announcements.discard": "Kasta osparade ändringar i meddelandet?",
        "announcements.searchRecipients": "Sök mottagare…",
        "announcements.selectVisible": "Välj alla tillgängliga i sökningen",
        "announcements.noRecipients": "Inga mottagare i sökningen",
        "announcements.selected": "{{count}} mottagare valda",
        "announcements.confirmTitle": "Bekräfta e-postutskick",
        "announcements.confirmHint": "Skicka det sparade meddelandet till {{count}} valda mottagare. Ett framtida startdatum schemalägger utskicket. Redan registrerade mottagare får inte meddelandet igen.",
        "announcements.confirmSend": "Bekräfta utskick",
        "announcements.sending": "Registrerar utskick…",
        "announcements.sendFailed": "Utskicket kunde inte bekräftas. Uppdatera leveransstatus innan du försöker igen.",
        "hourBilling.open": "Fakturering / avstämning",
        "hourBilling.selectFirst": "Markera en eller flera tidposter för att markera som fakturerade eller stämma av.",
        "hourBilling.unchanged": "Behåll oförändrat",
        "hourBilling.customer_invoiced": "Fakturerat kund",
        "hourBilling.hired_invoiced": "Inhyrning fakturerad",
        "hourBilling.billing_order_id": "Koppla till order",
        "hourBilling.supplierinvoice_id": "Leverantörsfaktura",
        "hourBilling.salary_voucher_id": "Löneverifikation",
        "hourBilling.bulkHint": "Välj bara fälten som ska ändras. Alla valda tider sparas tillsammans. Godkännande påverkas inte.",
        "hourBilling.commonOptions": "Visar kopplingar som passar alla valda tider. Fakturakoppling kräver inhyrda timmar; justera täckning per registrering. Befintliga kopplingar ersätts bara när du väljer ett nytt värde.",
        "hourBilling.selection": "{{count}} valda registreringar",
        "hourBilling.entries": "Tidregistreringar",
        "hourBilling.current": "Aktuell status",
        "hourBilling.notInvoiced": "Inte fakturerat kund",
        "hourBilling.invoiceRef": "Faktura #{{id}} · {{hours}} t täckta",
        "hourBilling.saveSelected": "Spara valda tider",
        "hourBilling.discard": "Kasta osparade ändringar?",
        "hourBilling.conflict": "En registrering har ändrats sedan dialogen öppnades. Inget sparades. Hämta senaste versionen och välj ändringarna igen.",
        "hourBilling.selectEntries": "Välj tider för avstämning",
        "hourBilling.visiblePeriod": "Välj bland registreringarna i aktuell period och filter.",
        "hourBilling.selectAll": "Välj alla visade",
        "hourBilling.limit": "Välj högst 100 registreringar åt gången.",
        "common.retry": "Försök igen",
        "common.save": "Spara",
        "project.billing_plan.save_settings_failed": "Kunde inte bekräfta att inställningarna sparades.",
        "announcements.openPublic": "Öppna offentlig meddelandesida",
        "announcements.title": "Meddelanden och nyhetsbrev",
        "announcements.previousMessage": "Föregående meddelande",
        "announcements.deactivated": "Inaktiverat",
        "announcements.deactivate": "Inaktivera meddelande",
        "announcements.reactivate": "Aktivera igen",
        "announcements.stopHint": "Avsluta meddelandet i förtid utan att radera innehållet.",
        "announcements.inactiveHint": "Meddelandet är inaktiverat. Innehåll och datum har behållits.",
        "announcements.deactivateHint": "Meddelandet döljs och väntande e-post avbryts. Skickad eller påbörjad e-post kan inte återkallas. Öppna dashboard uppdateras inom en minut; offentliga sidor vid nästa inläsning.",
        "announcements.reactivateHint": "Ursprungliga publiceringsval och datum gäller igen. Utgångna meddelanden behöver ett nytt slutdatum för att visas. Avbruten e-post skickas inte automatiskt igen.",
        "announcements.confirmDeactivate": "Ja, inaktivera",
        "announcements.confirmReactivate": "Ja, aktivera igen",
        "announcements.deactivatedResult": "Meddelandet är inaktiverat. Väntande e-post har avbrutits.",
        "announcements.reactivatedResult": "Meddelandet har aktiverats igen med ursprungliga publiceringsval och datum.",
        "announcements.activationNotApplied": "Aktuell status är oförändrad. Du kan försöka igen.",
        "announcements.activationFailed": "Åtgärden avvisades. Kontrollera behörighet och uppdatera sidan.",
        "announcements.activationUnknown": "Resultatet kunde inte bekräftas. Kontrollera status innan du försöker igen.",
        "announcements.checkStatus": "Kontrollera status",
        "announcements.nextMessage": "Nästa meddelande",
        "announcements.new": "Nytt meddelande",
        "announcements.body": "Innehåll",
        "announcements.audience": "Målgrupp",
        "announcements.admin": "Bara admin",
        "announcements.users": "Alla användare",
        "announcements.public": "Offentligt på webbplatsen",
        "announcements.in_app": "Visa i app / på webbplats",
        "announcements.email_enabled": "Aktivera e-post",
        "announcements.published": "Publicerat",
        "announcements.draft": "Utkast",
        "announcements.starts_at": "Från (valfritt)",
        "announcements.ends_at": "Till (valfritt)",
        "announcements.publicHint": "Offentliga meddelanden är tillgängliga för den anslutna webbplatsen. Lägg inte intern information här.",
        "announcements.recipients": "Valda e-postmottagare",
        "announcements.emailHint": "Spara först. Sändningen använder en ögonblicksbild och skickas en gång per mottagare. Startdatum schemalägger leverans. Okända utfall skickas inte igen automatiskt.",
        "announcements.send": "Skicka / schemalägg e-post till valda",
        "announcements.refresh": "Uppdatera leveransstatus",
        "announcements.queued": "E-post är köad. Se leveransstatus nedan.",
        "announcements.saved": "Meddelandet är sparat.",
        "announcements.loadFailed": "Kunde inte hämta meddelanden.",
        "announcements.saveFailed": "Kunde inte spara. Utkastet finns kvar.",
        "announcements.delivery.pending": "Väntar",
        "announcements.delivery.sending": "Sändning pågår – kontrollera vid lång väntan",
        "announcements.delivery.sent": "Skickat",
        "announcements.delivery.unknown": "Okänt utfall – kontrollera e-postloggen",
        "announcements.delivery.failed": "Misslyckades",
        "announcements.delivery.cancelled": "Avbrutet",
        "documentUpload.attachments.pick": "Lägg till dokument eller bild",
        "documentUpload.attachments.add": "Lägg till",
        "statusAttachments.attachmentPost": "Uppdatering med bilagor",
        "statusAttachments.backgroundHint": "Bilagor laddas upp i bakgrunden efter publicering. Håll Promang öppet tills uppladdningen är klar.",
        "statusPhotos.photoPost": "Bilduppdatering",
        "statusPhotos.destination": "Uppdatering #{{id}}",
        "statusPhotos.backgroundHint": "Bilder laddas upp i bakgrunden efter publicering. Håll Promang öppet tills uppladdningen är klar.",
        "accounting.project_summary.methodology.labor_primary_mixed": "Bokförda lönekostnader plus uppskattning för timmar utan verifikations- eller fakturatäckning. Stäm av timmar mot rätt löneverifikation.",
        "project.summary.labor_source_mixed": "Bokförd lön och uppskattning för ej avstämda timmar",
        "project.summary.load_failed": "Kunde inte ladda projektsammanfattningen",
        "project.copy.success": "Kopierat till urklipp",
        "project.copy.failed": "Kunde inte kopiera",
        "accounting.project_summary.labor_source_mixed": "Bokförd lön och uppskattning för ej avstämda timmar",
        "accounting.project_summary.invoiced_ex_vat": "Summa kundfakturor, exkl. moms",
        "accounting.project_summary.not_invoiced": "Ej fakturerat",
        "accounting.project_summary.profit_vs_contract": "Resultat mot kontraktssumma",
        "accounting.project_summary.profit_vs_invoiced": "Resultat mot fakturerat",
        "accounting.project_summary.margin_vs_contract": "Marginal mot kontraktssumma",
        "accounting.project_summary.margin_vs_invoiced": "Marginal mot fakturerat",
        "accounting.summary.labor_source_mixed": "Bokförd lön och uppskattning för ej avstämda timmar",
        "accounting.ledger.vouchers_truncated":
          "Senaste huvudbokssynken stoppade vid sidtaket. Siffrorna kan vara ofullständiga tills du synkar en kortare period.",
        "hourBilling.title": "Fakturering och kostnadsavstämning",
        "hourBilling.customer": "Fakturerat kund",
        "hourBilling.hired": "Inhyrd",
        "hourBilling.supplierInvoiced": "Inhyrning fakturerad",
        "hourBilling.reminder": "Saknar fakturatäckning",
        "hourBilling.order": "Koppla till order",
        "hourBilling.orderHint": "En fakturerad order markerar automatiskt tiden som fakturerad till kund.",
        "hourBilling.invoice": "Leverantörsfaktura (förslag från projekt/leverantör)",
        "hourBilling.invoiceHint": "Kopplingen täcker kostnad oberoende av markeringarna ovan. Återstående timmar behåller uppskattad kostnad.",
        "hourBilling.coveredHours": "Timmar på faktura",
        "hourBilling.rate": "Timpris exkl. moms",
        "hourBilling.salaryVoucher": "Avstämt mot löneverifikation",
        "hourBilling.salaryHint": "Välj bara verifikationen som faktiskt täcker dessa timmar. Bokföringsdatum fastställer inte intjänandeperioden.",
        "hourBilling.none": "Ingen koppling",
        "hourBilling.loadFailed": "Kunde inte hämta timuppföljning.",
        "hourBilling.saveFailed": "Kunde inte spara timuppföljningen. Utkastet finns kvar.",
        "hourBilling.saved": "Faktureringsuppföljning sparad.",
        "hourBilling.followup": "Fakturauppföljning timmar",
        "hourBilling.followupHint": "Inhyrda timmar utan full fakturatäckning. Öppna en tid för förslag och avstämning.",
        "hourBilling.noReminders": "Alla inhyrda timmar har fakturatäckning.",
        "service.agreements.subs.edit": "Redigera inkluderad anläggning",
        "service.agreements.subs.saved": "Anläggningen har uppdaterats.",
        "service.agreements.subs.save_failed": "Kunde inte spara anläggningen.",
        "customer.systems.linked_customer": "Kopplad kund",
        "customer.systems.move_hint": "Välj en annan kund för att flytta anläggningen, eller ta bort kunden. Tidigare rapporter och historik behålls.",
        "customer.systems.save_failed": "Kunde inte spara anläggningen.",
        "customer.systems.connections_history": "Kopplingar och historik",
        "customer.systems.load_failed": "Kunde inte hämta anläggningsdata.",
        "customer.systems.no_customer": "Ingen kopplad kund",
        "customer.systems.history_limit": "Visar de 100 senaste posterna och kopplingarna du har tillgång till.",
        "customer.systems.all_title": "Anläggningar",
        "deliveryRegistry.title": "Leveransadresser",
        "deliveryRegistry.save": "Spara",
        "deliveryRegistry.register": "Adressregister",
        "deliveryRegistry.intro": "Hantera leveransadresser registrerade på företaget. Hitta, skapa och underhåll adresser som används i Promang.",
        "deliveryRegistry.search": "Sök på namn, adress, postnummer eller ort",
        "deliveryRegistry.new": "Ny leveransadress",
        "deliveryRegistry.edit": "Redigera adress",
        "deliveryRegistry.editHint": "Ändringar uppdaterar samma adress där den används. Kontrollera namn och land innan du sparar.",
        "deliveryRegistry.newHint": "Skapa en leveransadress för företaget. Adressen blir tillgänglig i Promangs adressväljare.",
        "deliveryRegistry.name": "Namn / mottagare",
        "deliveryRegistry.address": "Adress",
        "deliveryRegistry.address2": "Adressrad 2",
        "deliveryRegistry.postal": "Postnummer",
        "deliveryRegistry.place": "Ort",
        "deliveryRegistry.country": "Land",
        "deliveryRegistry.optional": "(valfritt)",
        "deliveryRegistry.selectCountry": "Välj land",
        "deliveryRegistry.required": "Fältet måste fyllas i.",
        "deliveryRegistry.validCountry": "Välj en giltig landskod.",
        "deliveryRegistry.loading": "Hämtar adresser…",
        "deliveryRegistry.loadFailed": "Kunde inte hämta adresserna.",
        "deliveryRegistry.results": "{{count}} adresser hittades",
        "deliveryRegistry.empty": "Inga adresser hittades",
        "deliveryRegistry.emptyHint": "Prova en annan sökning, ta bort ett filter eller skapa en adress.",
        "deliveryRegistry.refresh": "Uppdatera",
        "deliveryRegistry.complete": "Komplett",
        "deliveryRegistry.incomplete": "Uppgifter saknas",
        "deliveryRegistry.unnamed": "Adress utan namn",
        "deliveryRegistry.previous": "Föregående",
        "deliveryRegistry.next": "Nästa",
        "deliveryRegistry.page": "Sida {{page}} av {{pages}}",
        "deliveryRegistry.discard": "Kasta osparade adressändringar?",
        "deliveryRegistry.saved": "Adressen har sparats.",
        "deliveryRegistry.saving": "Sparar…",
        "deliveryRegistry.saveFailed": "Adressen kunde inte sparas. Dina ändringar finns kvar.",
        "deliveryRegistry.unknown": "Resultatet är okänt. Kontrollera status innan du fortsätter.",
        "deliveryRegistry.createUnknown": "Resultatet är okänt. Stäng dialogen och uppdatera listan för att kontrollera om adressen skapats innan du försöker igen.",
        "deliveryRegistry.conflict": "Adressen har ändrats sedan du öppnade den. Hämta den senaste versionen och kontrollera innan du sparar.",
        "deliveryRegistry.reload": "Hämta senaste versionen",
        "deliveryRegistry.checkStatus": "Kontrollera status",
        "deliveryRegistry.refreshWarning": "Adressen har sparats, men listan kunde inte uppdateras. Stäng dialogen och uppdatera översikten.",
        "customer.systems.register": "Anläggningsregister",
        "customerSettings.title": "Kundinställningar",
        "customerSettings.eyebrow": "Kunder",
        "customerSettings.intro": "Hantera företagets anläggnings- och frakttyper. Ändringarna används i befintliga kund-, anläggnings- och orderflöden.",
        "customerSettings.systems": "Anläggningstyper",
        "customerSettings.systems_hint": "Typer som används när anläggningar skapas och filtreras.",
        "customerSettings.shipping": "Frakttyper",
        "customerSettings.shipping_hint": "Leveransval, priser och tillgänglighet för order och offerter.",
        "customerSettings.add": "Lägg till",
        "customerSettings.loading": "Hämtar inställningar…",
        "customerSettings.load_failed": "Kunde inte hämta inställningarna.",
        "customerSettings.empty": "Inga typer har skapats ännu.",
        "customerSettings.name": "Namn",
        "customerSettings.description": "Beskrivning",
        "customerSettings.active": "Aktiv",
        "customerSettings.inactive": "Inaktiv",
        "customerSettings.public": "Offentligt tillgänglig",
        "customerSettings.free": "Fri frakt",
        "customerSettings.flat": "Fast pris",
        "customerSettings.calculate": "Beräkna fraktpris",
        "customerSettings.price": "Pris exkl. moms",
        "customerSettings.price_value": "{{value}} exkl. moms",
        "customerSettings.free_over_ordertotal": "Fri frakt över orderbelopp",
        "customerSettings.shipping_help": "Inaktiva frakttyper finns kvar i inställningarna och kan aktiveras igen. Belopp anges exklusive moms.",
        "customerSettings.save": "Spara",
        "customerSettings.saving": "Sparar…",
        "customerSettings.saved": "Inställningen har sparats.",
        "customerSettings.save_failed": "Kunde inte spara. Kontrollera fälten och försök igen.",
        "customerSettings.title_required": "Ange ett namn.",
        "customerSettings.invalid_price": "Belopp måste vara tal som är 0 eller större.",
        "customerSettings.unknown": "Sparandet kunde inte bekräftas. Stäng och uppdatera översikten för att kontrollera resultatet innan du försöker igen.",
        "customerSettings.discard": "Kasta osparade ändringar?",
        "customerSettings.no_access": "Du har inte åtkomst till kundinställningar.",
        "customer.systems.type_filter": "Anläggningstyp",
        "customer.systems.previous": "Föregående",
        "customer.systems.next": "Nästa",
        "customer.systems.register_intro": "Hitta anläggningar, kunder och historik på ett ställe. Sök på modell, tillverkare, serienummer eller artikelnummer.",
        "customer.systems.searching": "Söker efter anläggningar…",
        "customer.systems.search_complete": "Sökning klar · {{count}} anläggningar på sida {{page}}",
        "customer.systems.results": "{{count}} anläggningar hittades",
        "customer.systems.page": "Sida {{page}} av {{pages}}",
        "customer.systems.no_matches": "Inga anläggningar matchar sökningen.",
        "customer.systems.search_help": "Prova ett annat sökord eller ta bort ett filter.",
        "customer.systems.types_failed": "Anläggningstyperna kunde inte hämtas. Du kan fortfarande söka.",
        "customer.systems.refresh": "Uppdatera",
        "customer.systems.serial_label": "Serienummer",
        "customer.systems.not_set": "Ej angivet",
        "customer.systems.open_details": "Öppna anläggning och historik",
        "customer.systems.merge_intro": "Hitta anläggningen du vill behålla. Sök bland företagets anläggningar och kontrollera valet före sammanslagning.",
        "customer.systems.merge_from": "Anläggningen som tas bort",
        "customer.systems.merge_keep": "Anläggningen som behålls",
        "customer.systems.clear_target": "Ta bort vald målanläggning",
        "customer.systems.merge_review": "Rapport- och serviceavtalskopplingar flyttas från «{{source}}» till «{{target}}». Källan tas bort från översikten. Kontrollera att detta är samma fysiska anläggning.",
        "customer.systems.duplicates_count": "Andra anläggningar med serienumret: {{count}}",
        "customer.systems.duplicates_hint": "Möjliga dubbletter. Kontrollera kund, adress och att detta är samma fysiska anläggning. Uppgifterna på anläggningen som behålls ändras inte.",
        "customer.systems.duplicates_recommend": "Föreslås att behålla: {{title}} (#{{id}})",
        "customer.systems.duplicates_reason": "Förslaget har flest ifyllda grunduppgifter. Vid lika antal föreslås lägsta ID.",
        "customer.systems.duplicates_review": "Granska sammanslagning med #{{id}}",
        "customer.systems.duplicates_more": "{{count}} fler träffar. Sök på serienumret i dialogen för att se fler.",
        "customer.systems.merge_unknown": "Resultatet är inte bekräftat. Kontrollera status innan du fortsätter; sammanslagningen kan redan vara klar.",
        "customer.systems.check_merge": "Kontrollera status",
        "customer.systems.refresh_warning": "Ändringen har sparats, men översikten kunde inte uppdateras. Ladda listan igen.",
        "customer.systems.search": "Sök på serienummer, modell, artikelnummer eller leveransadress",
        "customer.systems.all_types": "Alla typer",
        "customer.systems.history_action.create": "Skapad",
        "customer.systems.history_action.update": "Uppdaterad",
        "customer.systems.history_action.move": "Kund ändrad",
        "customer.systems.history_action.merge": "Anläggningar sammanslagna",
        "project.item_list.saving_quantity": "Sparar antal…",
        "statistics.date_from": "Från datum",
        "statistics.date_to": "Till datum",
        "statistics.apply": "Visa period",
        "statistics.all_time": "Hela perioden",
        "statistics.date_hint": "Filtrerar på datumet ärendet skapades. Båda datumen ingår.",
        "statistics.invalid_period": "Från-datum måste vara före eller lika med till-datum.",
        "statistics.load_error": "Kunde inte hämta statistik.",
        "statistics.cases_by_label": "Ärenden per etikett",
        "statistics.no_labels_with_cases": "Inga etiketter med ärenden ännu",
        "project.item_list.reopen": "Öppna för redigering",
        "project.item_list.reopening": "Öppnar varulistan för redigering…",
        "project.item_list.pdf_loading": "Skapar PDF…",
        "offers.workspace.add_suggestions": "Lägg till valda förslag som offertrader",
        "offers.workspace.suggestions_added": "Förslagen har lagts till. Kontrollera mängder och ange priser.",

        "offers.workspace.check_calculation": "Kalkylen innehåller beräkningsfel som måste rättas.",
        "offers.workspace.conversion": "Från offert till projekt",
        "offers.workspace.conversion_hint": "Ett projekt skapas med offertens kund och kontaktuppgifter. Aktiviteter och order skapas när underlaget stöder det. Avtalat pris och order använder accepterad revision när den finns.",
        "offers.workspace.conversion_confirm": "Skapa projekt",

        "offers.workspace.conflict": "Offerten har ändrats av någon annan",
        "offers.workspace.conflict_hint": "Ändringar i olika fält slås samman. Välj värde när samma fält har ändrats.",
        "offers.workspace.mine": "Mitt värde",
        "offers.workspace.theirs": "Senast sparade värde",
        "offers.workspace.merge": "Slå samman och spara",
        "offers.workspace.conflict_use_server": "Använd senaste sparade versionen",

        "offers.workspace.extract": "Läs text från PDF",
        "offers.workspace.extracting": "Läser sidor …",
        "offers.workspace.extract_failed": "Kunde inte hämta PDF-text. Skannade dokument behöver OCR; du kan klistra in texten.",
        "offers.workspace.template_tests": "Testa kalkylmallen",
        "offers.workspace.template_tests_hint": "Spara indata med förväntat pris. Testerna använder aktuell beräkningslogik utan att ändra offerten.",
        "offers.workspace.template_tests_empty": "Inga sparade tester ännu.",
        "offers.workspace.test_name": "Exempelnamn",
        "offers.workspace.expected": "Förväntat pris",
        "offers.workspace.save_test": "Spara test med dessa indata",

        "offers.workspace.advanced": "Visa fler fält",
        "offers.workspace.purchase_price": "Kostnad per enhet",
        "offers.workspace.alternative_group": "Alternativgrupp",
        "offers.workspace.price_source": "Priskälla",
        "offers.workspace.price_dated_at": "Prisdatum",
        "offers.workspace.discard_draft": "Kasta osparad rad",
        "offers.workspace.outgoing": "Bilagor till kunden",
        "offers.workspace.outgoing_hint": "Välj filer som ska skickas med offerten. Övriga filer är arbetsmaterial. Högst 20 MB totalt.",
        "offers.workspace.outgoing_count": "Valda kundbilagor: {{count}}",
        "offers.workspace.delivery_queued": "Offerten väntar på utskick",
        "offers.workspace.delivery_processing": "Offerten skickas",
        "offers.workspace.delivery_sent": "Offerten har skickats",
        "offers.workspace.delivery_failed": "Utskicket misslyckades. Kontrollera leveransen innan du skickar igen.",
        "offers.workspace.delivery_finalization_failed": "E-post har skickats, men arkiveringen misslyckades. Skicka inte igen.",
        "offers.workspace.delivery_draft_creation_failed": "Offerten har skickats. Nästa utkast kunde inte skapas. Skicka inte igen.",

        "offers.workspace.area_price": "Pris och kalkyl",
        "offers.workspace.area_document": "Kunddokument",
        "offers.workspace.area_activity": "Aktivitet",

        "offers.workspace.start": "Välj utgångspunkt",
        "offers.workspace.start_quick": "Snabb offert",
        "offers.workspace.start_quick_hint": "Ange rader och priser. Klar i några steg.",
        "offers.workspace.start_quick_detail": "Öppnar kundvy / offertlinjer. Bäst när du redan vet priserna och inte behöver kalkyl med timmar, material och påslag.",
        "offers.workspace.start_template": "Använd kalkylmall",
        "offers.workspace.start_template_hint": "Återanvänd kunskap och anpassa mängderna.",
        "offers.workspace.start_template_detail": "Öppnar kalkyl och mallväljaren direkt. Du kopierar en företagsmall (ev. med guide) och anpassar mängder — mallen ändras inte.",
        "offers.workspace.start_detailed": "Detaljerad kalkyl",
        "offers.workspace.start_detailed_hint": "Bygg upp fack, material, timmar och påslag.",
        "offers.workspace.start_detailed_detail": "Öppnar en tom kalkylarbetsyta. Bygg rader, produkter, timmar och struktur från grunden — utan mall.",
        "offers.workspace.start_selected_label": "Vald start",
        "offers.create.start_heading": "Hur vill du starta?",
        "offers.create.start_intro": "Alla tre skapar samma typ av offert. Skillnaden är var du börjar arbeta — du kan alltid byta flik senare.",
        "offers.workspace.add_line": "Lägg till rad",
        "offers.workspace.move_line": "Flytta rad",
        "offers.workspace.add_product": "Lägg till produkt",
        "offers.workspace.add_selected_products": "Lägg till valda produkter",
        "offers.workspace.paste": "Klistra in från kalkylblad",
        "offers.workspace.paste_hint": "Tre kolumner: beskrivning, mängd och enhetspris.",
        "offers.workspace.paste_error": "Varje rad behöver beskrivning, mängd och pris, separerade med tabulator.",
        "offers.workspace.bulk_discount": "Rabatt på valda rader (%)",
        "offers.workspace.apply": "Använd ändringarna",
        "offers.workspace.select": "Välj rad",
        "offers.workspace.duplicate": "Duplicera rad",
        "offers.workspace.cancel": "Avbryt",
        "offers.workspace.retry": "Försök spara igen",
        "offers.workspace.save_saved": "Alla ändringar sparade",
        "offers.workspace.save_pending": "Ändringar väntar på att sparas",
        "offers.workspace.save_saving": "Sparar ändringar …",
        "offers.workspace.save_error": "Ändringarna är inte sparade. Försök igen innan du fortsätter.",
        "offers.workspace.regenerate_hint": "Kalkylrader uppdateras. Manuella rader behålls. Kontrollera kundanpassningar innan du fortsätter.",
        "offers.workspace.empty_title": "Vad ska du leverera?",
        "offers.workspace.empty_hint": "Lägg till första raden eller klistra in en prislista. Du kan lägga till detaljerad kalkyl senare.",
        "offers.workspace.customer_total": "Offertpris exkl. moms · utan valfria tillägg",
        "offers.workspace.inclusion": "Ingår i offerten",
        "offers.workspace.included": "Inkluderad",
        "offers.workspace.optional": "Valfritt tillägg",
        "offers.workspace.excluded": "Utesluten",
        "offers.workspace.review": "Kontroll och utskick",
        "offers.workspace.review_hint": "Kontrollera pris, innehåll och mottagare före utskick.",
        "offers.workspace.check_customer": "Välj kund för offerten.",
        "offers.workspace.check_empty": "Lägg till minst en inkluderad rad.",
        "offers.workspace.check_description": "En eller flera rader saknar beskrivning.",
        "offers.workspace.check_price": "En eller flera inkluderade rader har nollpris.",
        "offers.workspace.check_quantity": "Mängden måste vara större än noll.",
        "offers.workspace.check_expired": "Offertens giltighetsdatum har passerat.",
        "offers.workspace.check_margin": "Kostnaderna överstiger offertpriset.",
        "offers.workspace.check_alternatives": "En alternativgrupp har mer än ett inkluderat val.",
        "offers.send.missing_id": "Offer-ID saknas. Spara offerten innan utskick.",
        "offers.workspace.cover.title": "Försättsblad",
        "offers.workspace.cover.subtitle": "Konfigurera försättsbladet för offert-PDF:en.",
        "offers.workspace.cover.active": "Aktiv",
        "offers.workspace.cover.inactive": "Inaktiv",
        "offers.workspace.cover.field_title": "Titel",
        "offers.workspace.cover.title_placeholder": "Ange titel för försättsblad…",
        "offers.workspace.cover.title_hint": "Titeln visas på PDF-försättsbladet",
        "offers.workspace.cover.description": "Beskrivning",
        "offers.workspace.cover.description_placeholder": "Ange beskrivning för försättsblad…",
        "offers.workspace.cover.image": "Försättsbild",
        "offers.workspace.cover.selected_image": "Vald försättsbild: {{title}}",
        "offers.workspace.cover.no_image_title": "Ingen titel",
        "offers.workspace.cover.image_first_hint": "Den första bilden du laddar upp används som försättsbild",
        "offers.workspace.cover.image_pdf_hint": "Bilden fyller försättsbladet i PDF:en",
        "offers.workspace.cover.inactive_hint": "Aktivera försättsbladet för att konfigurera innehållet.",
        "offers.workspace.fix": "Öppna",
        "offers.workspace.ready": "Inga brister hittades i radkontrollen.",
        "offers.workspace.explain": "Varför detta pris?",
        "offers.workspace.scenario": "Vad händer om?",
        "offers.workspace.scenario_hint": "Prova ändringar utan att ändra offerten. Beräkningen gäller total försäljning och kostnad.",
        "offers.workspace.sales_change": "Ändring av försäljningspris (%)",
        "offers.workspace.cost_change": "Kostnadsändring (%)",
        "offers.workspace.cost": "Kostnad",
        "offers.workspace.margin": "Täckningsbidrag",
        "offers.workspace.cost_unknown": "Kostnadsunderlaget är inte tillgängligt.",
        "offers.workspace.reset": "Återställ scenario",
        "offers.workspace.preview": "Öppna PDF",
        "offers.workspace.send": "Skicka offert",
        "offers.workspace.layout": "Dokumentformat",
        "offers.workspace.layout_simple": "Enkelt offertblad",
        "offers.workspace.layout_document": "Utformat offertdokument",
        "offers.simpleDocument.info_title": "Offertinfo",
        "offers.simpleDocument.info_hint": "Enkelt offertblad utan försättsblad, brev och blockstruktur. Samma innehåll som PDF — enkelt.",
        "offers.simpleDocument.meta_customer": "Kund",
        "offers.simpleDocument.meta_project": "Projekt",
        "offers.simpleDocument.meta_reference": "Referens",
        "offers.simpleDocument.meta_offer_date": "Offertdatum",
        "offers.simpleDocument.meta_valid_to": "Giltig till",
        "offers.simpleDocument.meta_contact": "Kontakt",
        "offers.simpleDocument.upgrade": "Bygg fullständigt offertdokument",
        "offers.simpleDocument.upgrading": "Byter…",
        "offers.simpleDocument.upgrade_success": "Dokumentbyggaren är klar",
        "offers.simpleDocument.upgrade_failed": "Kunde inte byta till fullständigt dokument",
        "offers.documentBuilder.switch_to_simple": "Byt till enkelt offertblad",
        "offers.documentBuilder.switching_to_simple": "Byter…",
        "offers.documentBuilder.switch_to_simple_confirm": "Byta till enkelt offertblad? Blockstrukturen (försättsblad, brev och sektioner) raderas och kan inte ångras.",
        "offers.documentBuilder.switch_to_simple_success": "Enkelt offertblad är aktivt",
        "offers.documentBuilder.switch_to_simple_failed": "Kunde inte byta till enkelt blad",
        "offers.workspace.undo": "Ångra",
        "offers.workspace.redo": "Gör om",
        "offers.workspace.density": "Täthet",
        "offers.workspace.normal": "Normal",
        "offers.workspace.compact": "Kompakt",
        "offers.workspace.ai_source": "Analysen behöver dokumenttext. Att välja en fil läser inte innehållet. Klistra in relevant text med sidhänvisningar.",
        "offers.workspace.title": "Beskrivning",
        "offers.workspace.description": "Detaljbeskrivning",
        "offers.workspace.quantity": "Mängd",
        "offers.workspace.sales_price": "Enhetspris",
        "offers.workspace.surcharge": "Påslag",
        "offers.workspace.unit_id": "Enhet",
        "offers.workspace.offer_group_id": "Grupp",
        "offers.workspace.pricing_role": "Prisroll",
        "offers.workspace.visible_to_customer": "Synlig för kund",
        "offers.workspace.deleted": "Raderad rad",
        "offers.workspace.unsaved_leave": "Du har osparade ändringar. Vill du lämna sidan utan att spara?",
        "offers.workspace.discount": "Rabatt (%)",
        "offers.workspace.total": "Summa",
        "offers.workspace.unit": "Enhet",
        "offers.workspace.remove_line": "Ta bort rad",
        "offers.workspace.customer_email_missing": "Kundens e-post saknas",
        "offers.workspace.contact_email_missing": "Kontaktens e-post saknas",

            "loading.boot.initializing": "Förbereder arbetsytan",
            "loading.boot.syncing": "Synkroniserar dina moduler",
            "loading.boot.linking": "Upprättar säker anslutning",
            "loading.boot.finalizing": "Slutför — nästan klart",

            "drawings.viewer.see_3d": "Visa 3D",
            "drawings.viewer.see_3d_short": "3D",
            "drawings.viewer.see_3d_no_project": "Ritningen måste tillhöra ett projekt för att öppnas i 3D.",
            "drawings.viewer.open_place_in_3d": "Öppna platsen i 3D",
            "drawings.viewer.open_place_in_3d_error": "Det gick inte att öppna platsen i 3D.",
            "drawings.viewer.open_place_in_3d_no_alignment": "Ritningen är inte inpassad mot modellen ännu. Använd ”Passa in 3D” först.",
            "drawings.viewer.align_3d": "Koppla ritning",
            "drawings.viewer.align_3d_title": "Koppla ritning till modell",
            "drawings.viewer.align_3d_help": "Välj två punkter på ritningen där du känner till IFC-koordinaterna. Promang räknar ut skala, rotation och förskjutning från dessa.",
            "drawings.viewer.align_3d_pick_hint": "Öppnar 3D-vyn. Välj våningsplan, klicka på ritningen och sedan samma ställe i modellen.",
            "drawings.viewer.align_3d_pick_second": "Klicka på punkt 2 på ritningen.",
            "drawings.viewer.align_3d_point": "Punkt {{number}}",
            "drawings.viewer.align_3d_ifc_x": "IFC X",
            "drawings.viewer.align_3d_ifc_y": "IFC Y",
            "drawings.viewer.align_3d_z_offset": "Z-förskjutning",
            "drawings.viewer.align_3d_storey": "Våningsnamn i modellen",
            "drawings.viewer.align_3d_save": "Spara inpassning",
            "drawings.viewer.align_3d_saved": "Inpassning mot 3D sparad",
            "drawings.viewer.align_3d_error": "Det gick inte att spara inpassningen mot 3D.",

            "ifc_viewer.models": "Modeller",
            "ifc_viewer.upload": "Ladda upp IFC",
            "ifc_viewer.uploading": "Laddar upp…",
            "ifc_viewer.no_models": "Inga IFC-modeller ännu. Ladda upp en .ifc-fil för att komma igång.",
            "ifc_viewer.toggle_visibility": "Visa eller dölj {{name}} i den här vyn",
            "ifc_viewer.visible_for_everyone": "Synlig för alla",
            "ifc_viewer.hidden_badge": "Dold",
            "ifc_viewer.show_for_everyone": "Visa {{name}} för alla",
            "ifc_viewer.hide_for_everyone": "Dölj {{name}} för andra",
            "ifc_viewer.model_shown": "Modellen är synlig för alla.",
            "ifc_viewer.model_hidden": "Modellen är dold för andra.",
            "ifc_viewer.model_hide_error": "Det gick inte att spara synligheten.",
            "ifc_viewer.link_drawing": "Koppla ritning",
            "ifc_viewer.link_drawing_hint": "Välj ritning och våning. Arket visas i 3D — dra det över planet.",
            "ifc_viewer.link_drawing_title": "Koppla ritning till modell",
            "ifc_viewer.link_drawing_pick_help": "Välj ritning och en våning med geometri från huset (ARK). Tomma våningar visas inte. Arket visas sedan i 3D-visaren — dra, rotera och skala det över planet.",
            "ifc_viewer.link_drawing_drawing": "Ritning",
            "ifc_viewer.link_drawing_pick_drawing": "Välj ritning …",
            "ifc_viewer.link_drawing_storey": "Våning i ARK",
            "ifc_viewer.link_drawing_no_storeys": "Inga våningar med geometri i huset ännu. Ladda modellerna först.",
            "ifc_viewer.link_drawing_continue": "Visa ritning i 3D",
            "ifc_viewer.link_drawing_overlay_help": "Dra ritningen över planet. Blå hörn ändrar skala, det orange handtaget roterar. Modellen står still.",
            "ifc_viewer.link_drawing_overlay_note": "Kameran är i fågelperspektiv på våningen. Höger mus / hjul flyttar och zoomar kameran. Sparandet använder samma likhetstransform som Se 3D.",
            "ifc_viewer.link_drawing_opacity": "Genomskinlighet",
            "ifc_viewer.link_drawing_rotate_left": "Rotera 90° vänster",
            "ifc_viewer.link_drawing_rotate_right": "Rotera 90° höger",
            "ifc_viewer.link_drawing_reset": "Återställ placering",
            "ifc_viewer.link_drawing_advanced": "Avancerat: två klickpar i stället",
            "ifc_viewer.link_drawing_back_overlay": "Tillbaka till att dra ritningen i 3D",
            "ifc_viewer.link_drawing_click_pdf": "Klicka på punkt {{number}} på ritningen.",
            "ifc_viewer.link_drawing_click_ifc": "Klicka på samma ställe i 3D-modellen (punkt {{number}}).",
            "ifc_viewer.link_drawing_v1_note": "Avancerat: två klickpar (PDF + 3D). Standard är att dra arket i visaren.",
            "ifc_viewer.link_drawing_pdf_error": "Det gick inte att ladda ritningen.",
            "ifc_viewer.link_drawing_pdf_missing": "Ritningen har ingen PDF. Ladda upp en PDF på ritningen först.",
            "ifc_viewer.link_drawing_pdf_fetch_error": "Kunde inte hämta PDF-filen. Kontrollera att ritningen har en fil och att du är inloggad.",
            "ifc_viewer.link_drawing_pdf_raster_error": "Kunde inte läsa PDF-sidan. Prova en annan ritning eller ladda upp PDF:en igen.",
            "ifc_viewer.link_drawing_pair": "Punkt {{number}}: PDF {{pdfX}}/{{pdfY}} → IFC {{ifcX}} / {{ifcY}}",
            "ifc_viewer.link_drawing_pdf_pending": "Punkt {{number}} på ritningen ({{x}}/{{y}}) — klicka i 3D.",
            "ifc_viewer.link_drawing_save": "Spara koppling",
            "ifc_viewer.link_drawing_saved": "Ritningen är kopplad till modellen.",
            "ifc_viewer.link_drawing_error": "Det gick inte att spara kopplingen.",
            "ifc_viewer.delete_model": "Ta bort {{name}}",
            "ifc_viewer.axis.x": "X",
            "ifc_viewer.axis.y": "Y",
            "ifc_viewer.axis.z": "Z",
            "ifc_viewer.axis.rotX": "Rot X",
            "ifc_viewer.axis.rotY": "Rot Y",
            "ifc_viewer.axis.rotZ": "Rot Z",
            "ifc_viewer.transform_aria": "Justera {{axis}} för {{name}}",
            "ifc_viewer.fit_view": "Centrera vy",
            "ifc_viewer.iframe_title": "Promang IFC Viewer",
            "ifc_viewer.back_to_drawing": "Tillbaka till ritningen",
            "ifc_viewer.loading": "Laddar…",
            "ifc_viewer.empty_viewer": "Ladda upp minst en IFC-modell för att visa i 3D.",
            "ifc_viewer.selected_element": "Valt element",
            "ifc_viewer.close_selection": "Stäng",
            "ifc_viewer.selection.name": "Namn",
            "ifc_viewer.selection.type": "Typ",
            "ifc_viewer.selection.global_id": "GlobalId",
            "ifc_viewer.discipline_label": "Disciplin",
            "ifc_viewer.discipline.ARK": "ARK – arkitekt",
            "ifc_viewer.discipline.RIB": "RIB – konstruktion",
            "ifc_viewer.discipline.RIV": "RIV – VVS",
            "ifc_viewer.discipline.RIE": "RIE – el",
            "ifc_viewer.discipline.LAND": "LAND – landskap",
            "ifc_viewer.discipline.OTHER": "Övrigt",
            "ifc_viewer.house_label": "Hus",
            "ifc_viewer.no_house": "Utan hus",
            "ifc_viewer.filter_house": "Filtrera på hus",
            "ifc_viewer.all_houses": "Alla hus",
            "ifc_viewer.focus_from_drawing": "Plats från ritning",
            "ifc_viewer.no_access": "Du har inte behörighet till IFC Viewer.",
            "ifc_viewer.error_viewer_unavailable": "IFC Viewer-tjänsten är för närvarande inte tillgänglig.",
            "ifc_viewer.error_no_ready_models": "Ingen av de uppladdade IFC-modellerna kunde öppnas. Kontrollera att uppladdningen är klar, eller försök ladda upp igen.",
            "ifc_viewer.error_session": "Det gick inte att starta 3D-vyn.",
            "ifc_viewer.error_load": "Det gick inte att ladda IFC-modeller.",
            "ifc_viewer.error_viewer_generic": "Något gick fel i 3D-vyn.",
            "ifc_viewer.error_viewer_down": "IFC Viewer är nere. Det gick inte att nå vyn.",
            "ifc_viewer.error_viewer_timeout": "Det gick inte att starta 3D-vyn. Försök igen.",
            "ifc_viewer.error_model_failed": "IFC-filen kunde inte laddas. Kontrollera filen, eller ladda upp den igen.",
            "ifc_viewer.retry": "Försök igen",
            "ifc_viewer.error_upload": "Uppladdning av IFC-fil misslyckades.",
            "ifc_viewer.error_delete": "Det gick inte att ta bort modellen.",
            "ifc_viewer.tools": "Verktyg",
            "ifc_viewer.tools_open": "Öppna verktyg",
            "ifc_viewer.tools_close": "Stäng verktyg",
            "ifc_viewer.upload_dialog_title": "Ladda upp IFC-modell",
            "ifc_viewer.upload_drop_hint": "Dra och släpp .ifc-filer här",
            "ifc_viewer.upload_choose_files": "Välj filer",
            "ifc_viewer.upload_selected": "Valda filer ({{count}})",
            "ifc_viewer.upload_remove_file": "Ta bort {{name}}",
            "ifc_viewer.upload_name_label": "Visningsnamn (valfritt)",
            "ifc_viewer.upload_confirm": "Ladda upp",
            "ifc_viewer.confirm_replace_model": "Det finns redan en modell \"{{name}}\" för detta hus och denna disciplin. Ersätta den med den nya uppladdningen?",
            "ifc_viewer.model_replaced": "Modellen ersattes.",
            "ifc_viewer.placement_kept": "Placeringen från föregående {{discipline}} är behållen.",
            "ifc_viewer.discipline_required": "Välj disciplin…",
            "ifc_viewer.house_optional": "valfritt",
            "ifc_viewer.house_whole_project": "Utan hus / hela projektet",
            "ifc_viewer.auto_align": "Auto-inpassning",
            "ifc_viewer.auto_align_hint":
              "Flyttar senare modeller i X/Y så att de lägger sig på ARK (eller första modellen om ARK saknas).",
            "ifc_viewer.auto_align_done": "{{count}} modeller inpassade mot den första",
            "ifc_viewer.auto_align_unavailable":
              "Auto-inpassning kräver minst två modeller i vyn.",
            "ifc_viewer.auto_align_on_upload":
              "{{count}} nya modeller lades på den första modellen",
            "ifc_viewer.remerge": "Slå ihop på nytt",
            "ifc_viewer.remerge_hint":
              "Läser IFC-koordinater och lägger alla modeller på ARK (eller första modellen om ARK saknas).",
            "ifc_viewer.remerge_done":
              "{{count}} modeller slogs ihop mot den första",
            "ifc_viewer.remerge_saved": "Sammanslagning sparad",
            "ifc_viewer.remerge_save_failed":
              "Kunde inte spara sammanslagningen. Försök igen innan du laddar om sidan.",
            "ifc_viewer.remerge_house": "Slå ihop mot huset",
            "ifc_viewer.remerge_house_hint":
              "Flyttar RIV och andra fack så att fotavtrycket träffar huset (ARK). Inga koordinater att skriva.",
            "ifc_viewer.place_model": "Placera modell",
            "ifc_viewer.place_model_hint":
              "Klicka på en punkt på den felplacerade modellen, sedan samma ställe på huset.",
            "ifc_viewer.place_include_z": "Ta med höjd",
            "ifc_viewer.place_unavailable":
              "Placering kräver minst två modeller i vyn.",
            "ifc_viewer.place_done": "Modellen är placerad",
            "ifc_viewer.reload_models": "Ladda om modeller",
            "ifc_viewer.reload_models_done": "Modellerna har laddats om",
            "ifc_viewer.open_models": "Öppna modellista",
            "ifc_viewer.close_models": "Stäng modellista",
            "ifc_viewer.confirm_delete_model": "Ta bort {{name}}? Detta går inte att ångra.",
            "ifc_viewer.nudge_minus": "Flytta {{axis}} negativt",
            "ifc_viewer.nudge_plus": "Flytta {{axis}} positivt",
            "ifc_viewer.rotate_left": "Rotera −90°",
            "ifc_viewer.rotate_right": "Rotera +90°",
            "ifc_viewer.reset_transform": "Återställ",
            "ifc_viewer.reset_transform_hint":
              "Tillbaka till modellens egna koordinater",
            "ifc_viewer.save_transforms": "Spara inpassning",
            "ifc_viewer.saving_transforms": "Sparar…",
            "ifc_viewer.transforms_saved": "Inpassningen är sparad",
            "ifc_viewer.error_save_transforms": "Det gick inte att spara inpassningen.",
            "ifc_viewer.storey_filter": "Våning",
            "ifc_viewer.all_storeys": "Alla våningar",
            "ifc_viewer.empty_storey": "tom",
            "ifc_viewer.link_storeys": "Koppla våningar",
            "ifc_viewer.link_storeys_title": "Koppla våningar till {{name}}",
            "ifc_viewer.link_storeys_hint":
              "Systemet föreslår koppling mot husets våningar (samma namn, annars närmaste höjd). Du kan ändra varje rad. 3D-vyn visar ett snitt i vald våning — skjut med reglagen eller skriv meter.",
            "ifc_viewer.link_storeys_col_model": "Våning i {{name}}",
            "ifc_viewer.link_storeys_col_proposal": "Förslag",
            "ifc_viewer.link_storeys_col_datum": "Välj {{name}}-våning",
            "ifc_viewer.link_storeys_unlink": "Länka inte",
            "ifc_viewer.link_storeys_save": "Spara",
            "ifc_viewer.link_storeys_skip": "Hoppa över",
            "ifc_viewer.link_storeys_saved": "Våningskopplingen är sparad",
            "ifc_viewer.link_storeys_proposal_name": "Samma namn",
            "ifc_viewer.link_storeys_proposal_elevation": "Närmaste höjd",
            "ifc_viewer.link_storeys_proposal_none": "Ingen träff",
            "ifc_viewer.link_storeys_empty_target": "{{name}} (tom)",
            "ifc_viewer.link_storeys_align": "Skjut mot huset",
            "ifc_viewer.link_storeys_align_hint":
              "Huvudvyn visar huset och den här modellen uppifrån, med horisontellt snitt i vald våning. Dra reglagen eller skriv meter (t.ex. 12,4) — inte millimeter. Höjd är ±80 m.",
            "ifc_viewer.link_storeys_nudge_x": "Sidledes",
            "ifc_viewer.link_storeys_nudge_y": "Djup",
            "ifc_viewer.link_storeys_nudge_z": "Höjd",
            "ifc_viewer.link_storeys_nudge_meters": "{{axis}} i meter",
            "ifc_viewer.link_storeys_reset_nudge": "Återställ",
            "ifc_viewer.link_storeys_unavailable": "Ladda modellerna först",
            "ifc_viewer.apply_upright": "Rätta upp",
            "ifc_viewer.upright_saved": "Upprätning sparad",
            "ifc_viewer.upright_save_failed":
              "Kunde inte spara upprätningen. Försök igen innan du laddar om sidan.",
            "ifc_viewer.nav_hint":
              "Vänster: rotera · Höger: panorera · Hjul: zooma · G: gå · M: mått · L: laser · B: box · X: röntgen · Ctrl+Z: ångra",
            "ifc_viewer.undo": "Ångra",
            "ifc_viewer.redo": "Gör om",
            "ifc_viewer.undo_hint": "Ångra dölj / isolera (Ctrl+Z)",
            "ifc_viewer.redo_hint": "Gör om dölj / isolera (Ctrl+Y)",
            "ifc_viewer.view_iso": "Iso",
            "ifc_viewer.view_top": "Topp",
            "ifc_viewer.view_front": "Front",
            "ifc_viewer.view_side": "Sida",
            "ifc_viewer.section": "Snitt",
            "ifc_viewer.section_on": "På",
            "ifc_viewer.section_off": "Av",
            "ifc_viewer.section_invert": "Vänd sida",
            "ifc_viewer.section_axis.x": "X",
            "ifc_viewer.section_axis.y": "Y",
            "ifc_viewer.section_axis.z": "Höjd",
            "ifc_viewer.isolate_model": "Isolera {{name}}",
            "ifc_viewer.isolate_model_hint":
              "Visa {{name}} i full färg; andra modeller blir genomskinliga",
            "ifc_viewer.isolate_model_action": "Isolera modell",
            "ifc_viewer.isolate_model_action_hint":
              "Full färg; andra modeller blir ~20 % genomskinliga",
            "ifc_viewer.isolated": "Isolerad",
            "ifc_viewer.section_model": "Snitt",
            "ifc_viewer.section_model_hint": "Aktivera snitt genom den här modellen",
            "ifc_viewer.hide_model": "Dölj modell",
            "ifc_viewer.show_model": "Visa modell",
            "ifc_viewer.fit_this_model": "Centrera denna",
            "ifc_viewer.clear_isolate": "Ta bort isolering",
            "ifc_viewer.menu_isolate": "Isolera",
            "ifc_viewer.menu_section": "Snitt",
            "ifc_viewer.menu_section_hint": "Snitt genom den här modellens mitt-höjd",
            "ifc_viewer.menu_hide": "Dölj",
            "ifc_viewer.menu_show": "Visa",
            "ifc_viewer.menu_fit": "Centrera",
            "ifc_viewer.menu_clear_isolate": "Ta bort isolering",
            "ifc_viewer.menu_close": "Stäng",
            "ifc_viewer.menu_close_hint": "Stäng menyn",
            "ifc_viewer.show_all_models": "Visa alla modeller",
            "ifc_viewer.isolate_element": "Isolera",
            "ifc_viewer.hide_element": "Dölj",
            "ifc_viewer.show_all_elements": "Visa alla",
            "ifc_viewer.walk": "Gå",
            "ifc_viewer.walk_hint": "Förstaperson: WASD, mus för att se, Q/E upp och ner",
            "ifc_viewer.measure": "Mått",
            "ifc_viewer.measure_point": "Punkt till punkt",
            "ifc_viewer.measure_point_hint": "Avstånd mellan två klick",
            "ifc_viewer.measure_planar": "2D-snitt",
            "ifc_viewer.measure_planar_hint": "Mät i horisontalplan eller aktivt snitt",
            "ifc_viewer.laser": "Laser",
            "ifc_viewer.laser_hint": "Laser med 3 axlar (X/Y/Z) från en punkt",
            "ifc_viewer.clear_measures": "Ta bort mått",
            "ifc_viewer.clear_measures_title": "Ta bort alla mått och lasrar",
            "ifc_viewer.clear_last_measure": "Ta bort senaste",
            "ifc_viewer.cut_box": "Box",
            "ifc_viewer.xray": "Röntgen",
            "ifc_viewer.isolate_type": "Isolera typ",
            "ifc_viewer.hide_type": "Dölj typ",
            "ifc_viewer.selection.object_type": "ObjectType",
            "ifc_viewer.selection.tag": "Tag",

            "user_profile.title": "Användarprofil",
            "user_profile.empty_value": "Ej angivet",
            "user_profile.load_failed": "Kunde inte ladda profilen",
            "user_profile.load_failed_body": "Försök att ladda om sidan.",
            "user_profile.no_changes": "Inga ändringar att spara",
            "user_profile.ignored_fields_notice": "Vissa fält sparades inte eftersom de är låsta",
            "user_profile.email_locked_hint": "Inloggnings-e-post kan inte ändras här.",
            "user_profile.private_email_hint": "Valfri privat adress. Visas i e-postväljaren vid dokumentutsändning.",
            "user_profile.field_locked_hint": "Detta fält är låst och kan endast ändras av en administratör.",
            "user_profile.add_field": "Lägg till {{field}}",
            "user_profile.validation.name_required": "Namn krävs",
            "user_profile.field.name": "Namn",
            "user_profile.field.email": "Jobb-e-post",
            "user_profile.field.private_email": "Privat e-post",
            "user_profile.field.mobile": "Privat mobil",
            "user_profile.field.mobile_work": "Jobbmobil",
            "user_profile.field.address": "Adress",
            "user_profile.field.postal": "Postnr.",
            "user_profile.field.place": "Ort",
            "user_profile.field.birth_date": "Födelsedatum",
            "user_profile.field.social_security": "Personnummer",
            "user_profile.field.account_number": "Kontonummer",
            "user_profile.section.contact": "Kontaktinformation",
            "user_profile.section.address": "Adress",
            "user_profile.section.personal_details": "Personuppgifter",
            "user_profile.section.personal_details_hint": "Känsliga fält styrs av din behörighet.",
            "user_profile.section.children": "Barn",
            "user_profile.section.next_of_kin": "Anhöriga",
            "user_profile.related_records.add": "Lägg till",
            "user_profile.related_records.edit": "Redigera",
            "user_profile.related_records.delete": "Ta bort",
            "user_profile.related_records.actions": "Åtgärder",
            "user_profile.related_records.active_count": "aktiva",
            "user_profile.related_records.deactivated": "Inaktiverad",
            "user_profile.related_records.deactivate_confirm": "Är du säker på att du vill inaktivera den här posten? Den visas fortfarande men markeras som inaktiverad.",
            "user_profile.related_records.validation.name_required": "Namn krävs",
            "user_profile.related_records.dialog.create_title": "Lägg till post",
            "user_profile.related_records.dialog.edit_title": "Redigera post",
            "user_profile.related_records.dialog.save": "Spara",
            "user_profile.related_records.dialog.saving": "Sparar…",
            "user_profile.related_records.dialog.cancel": "Avbryt",
            "user_profile.related_records.save_success": "Posten sparades",
            "user_profile.related_records.save_failed": "Kunde inte spara posten",
            "user_profile.related_records.deactivate_success": "Posten inaktiverades",
            "user_profile.related_records.deactivate_failed": "Kunde inte inaktivera posten",
            "user_profile.children.empty_title": "Inga barn tillagda",
            "user_profile.children.empty_desc": "Använd plusknappen för att lägga till barn.",
            "user_profile.children.field.name": "Namn",
            "user_profile.children.field.birth_date": "Födelsedatum",
            "user_profile.children.field.sole_custody": "Ensam vårdnad",
            "user_profile.children.field.extended_rights": "Utökad rätt",
            "user_profile.children.validation.birth_date_required": "Födelsedatum krävs",
            "user_profile.next_of_kin.empty_title": "Inga anhöriga tillagda",
            "user_profile.next_of_kin.empty_desc": "Använd plusknappen för att lägga till anhörig.",
            "user_profile.next_of_kin.field.name": "Namn",
            "user_profile.next_of_kin.field.relationship_type": "Relation",
            "user_profile.next_of_kin.field.phone_number": "Telefon",
            "user_profile.next_of_kin.field.address": "Adress",
            "user_profile.next_of_kin.validation.relationship_required": "Relation krävs",
            "user_profile.next_of_kin.relationship.placeholder": "Välj relation",
            "user_profile.next_of_kin.relationship.SPOUSE": "Make/maka",
            "user_profile.next_of_kin.relationship.PARTNER": "Partner",
            "user_profile.next_of_kin.relationship.PARENT": "Förälder",
            "user_profile.next_of_kin.relationship.CHILD": "Barn",
            "user_profile.next_of_kin.relationship.SIBLING": "Syskon",
            "user_profile.banner.employee_title": "Du är registrerad som anställd",
            "user_profile.banner.employee_body": "Du har tillgång till anställningsinformation och lönebesked.",
            "user_profile.banner.hired_title": "Du är registrerad som inhyrd",
            "user_profile.banner.hired_body": "Du är inhyrd och har ingen anställning i detta företag.",
            "user_profile.tab.profile": "Profil",
            "user_profile.tab.email": "E-post",
            "user_profile.tab.employment": "Anställning",
            "user_profile.email.signature_title": "E-postsignatur",
            "user_profile.email.signature_help":
              "Signaturen läggs till när du skickar e-post till kunden — inte medan du skriver utkastet.",
            "user_profile.email.signature_placeholder": "Vänliga hälsningar …",
            "user_profile.email.save": "Spara signatur",
            "user_profile.employment.not_employee_title": "Ingen anställning",
            "user_profile.employment.not_employee_body": "Inhyrda användare har ingen anställning.",
            "user_profile.employment.none_title": "Anställning saknas",
            "user_profile.employment.none_body": "Ingen anställning har skapats för dig ännu.",
            "user_profile.employment.title": "Anställningsinformation",
            "user_profile.employment.read_only_hint": "Denna information är endast för visning.",
            "user_profile.employment.working_posistion": "Befattning",
            "user_profile.employment.employee_number": "Anställningsnummer",
            "user_profile.employment.employment_starts": "Anställningsdatum",
            "user_profile.employment.agreement_type": "Avtalstyp",
            "user_profile.employment.workplace": "Arbetsplats",
            "user_profile.employment.wages": "Lön",
            "user_profile.employment.worktime": "Arbetstid",
            "user_profile.employment.signed_at": "Signerat datum",
            "user_profile.employment.signed_place": "Signerad ort",
            "user_profile.employment.contract_title": "Anställningsavtal",
            "user_profile.employment.contract_signed": "Anställningsavtalet är signerat",
            "user_profile.employment.download_contract": "Ladda ner signerat avtal",
            "user_profile.employment.contract_unsigned_title": "Ej signerat",
            "user_profile.employment.contract_unsigned_body": "Anställningsavtalet har inte signerats ännu.",
            "user_profile.quicklinks.payslips_title": "Lönebesked",
            "user_profile.quicklinks.payslips_body": "Visa och ladda ner dina lönebesked",
            "user_profile.quicklinks.handbook_title": "Personalhandbok",
            "user_profile.quicklinks.handbook_body": "Rutiner, riktlinjer och dokument",
            "user_profile.handbook.documents_hint": "KS/HMS-dokument att läsa",
            "user_profile.handbook.chapters_hint": "Kapitel i personalhandboken",
            "user_profile.handbook.forms_hint": "Formulär du kan fylla i",
            "user_profile.handbook.events_hint": "Registrerade händelser",
            "user_profile.confirm.title": "Bekräfta ändringar",
            "user_profile.confirm.intro": "Granska ändringarna innan du sparar.",
            "user_profile.confirm.children_changed": "Ändringar för barn",
            "user_profile.confirm.kin_changed": "Ändringar för anhöriga",
            "user_profile.confirm.confirm_button": "Bekräfta och spara",
            "user_profile.history.title": "Ändringshistorik",
            "user_profile.history.open": "Historik",
            "user_profile.history.no_changes": "Inga ändringar registrerade",
            "user_profile.history.empty_title": "Ingen historik",
            "user_profile.history.empty_body": "Det finns inga ändringar att visa ännu.",
            "user_profile.history.action_revert": "Återställd",
            "user_profile.history.action_update": "Uppdaterad",
            "user_profile.history.reverted_from": "Återställd från version #{{id}}",
            "user_profile.history.restore": "Återställ denna version",
            "loading.boot.secure_session": "säker session",
            "common.tabs.more": "Fler",
            "employeeSelector.hired_badge": "Inhyrd",
            "company.users.user_type.label": "Användartyp",
            "company.users.user_type.employee": "Anställd",
            "company.users.user_type.hired": "Inhyrd (extern)",
            "company.users.user_type.supplier": "Leverantör (inhyrd från)",
            "company.users.user_type.select_supplier": "Välj leverantör",
            "company.users.user_type.supplier_required": "Välj en leverantör för inhyrda användare",
            "user_employment.hired_no_employment_title": "Inhyrd användare",
            "user_employment.hired_no_employment": "Den här användaren är inhyrd och kan inte ha en anställning. Ändra användartypen till Anställd för att skapa en anställning.",
            "user_employment.tab": "Anställning",
            "user_work_schedule.tab": "Tidsplan",
            "user_work_schedule.label": "Arbetsschema (timmar)",
            "user_work_schedule.none": "Ingen vald",
            "user_work_schedule.assign_title": "Välj arbetsschema",
            "user_work_schedule.assign_hint": "Används för tidregistrering, planerad tid och frånvaro. För anställda skalas timmar med tjänstgöringsgrad.",
            "user_work_schedule.manage_link": "Hantera arbetscheman →",
            "user_work_schedule.overview_title": "Översikt",
            "user_work_schedule.overview_subtitle": "Timmar per veckodag (justerat för tjänstgöringsgrad där det gäller)",
            "user_work_schedule.overview_empty": "Inget arbetsschema valt ännu.",
            "user_work_schedule.overview_empty_hint": "Välj ett schema ovan för att se veckoöversikt och helgdagar.",
            "user_work_schedule.info_title": "Arbetsschema per användare",
            "user_work_schedule.info_employee": "För anställda lagras schemat på anställningen. Tjänstgöringsgrad från lön påverkar planerade timmar.",
            "user_work_schedule.info_hired": "För inhyrda användare lagras schemat direkt på användaren i företaget (100 % av schemat).",
            "user_work_schedule.not_available_title": "Arbetsschema inte tillgängligt",
            "user_work_schedule.not_available_description": "Användaren måste vara anställd eller inhyrd innan arbetsschema kan kopplas. Skapa anställning eller sätt användartyp till Inhyrd.",
            "user_work_schedule.saved": "Arbetsschema sparat",
            "user_work_schedule.save_error": "Kunde inte spara arbetsschema",
            "company.users.visibility.tag": "Dold i väljare",
            "company.users.visibility.tag_hint": "Saknar inställning som gör att användaren inte visas i väljare",
            "company.users.visibility.inactive": "Inaktiv",
            "company.users.visibility.not_in_dropdown": "Visas inte i listor (aktivera \"Visa i lista\")",
            "company.users.visibility.missing_supplier": "Saknar leverantör (inhyrd)",
            "company.users.visibility.not_employed": "Inte anställd eller inhyrd",
            "company.users.visibility.no_roles": "Inga roller tilldelade",
            "company.users.visibility.notice_title": "Den här användaren är inte helt synlig",
            "company.users.visibility.notice_intro": "Följande saknas eller måste läggas till innan användaren visas överallt (t.ex. i personal-/resursväljarna):",
            "company.users.visibility.inactive_hint": "Aktivera användaren under Detaljer.",
            "company.users.visibility.not_in_dropdown_hint": "Aktivera \"Visa i lista\" under Detaljer så att användaren visas i väljarna.",
            "company.users.visibility.missing_supplier_hint": "Välj leverantören som användaren är inhyrd från under Detaljer.",
            "company.users.visibility.not_employed_hint": "Skapa en anställning (Employment-fliken) eller sätt användartypen till Inhyrd med leverantör.",
            "company.users.visibility.no_roles_hint": "Tilldela minst en roll under Roller-fliken.",
            "company.users.visibility.missing_work_schedule": "Saknar arbetsschema (tidsplan)",
            "company.users.visibility.missing_work_schedule_hint": "Välj arbetsschema under Tidsplan-fliken.",
            "tripletex_sync.title_default": "Tripletex-synkronisering",
            "tripletex_sync.retry": "Synkronisera till Tripletex igen",
            "tripletex_sync.retrying": "Synkroniserar…",
            "tripletex_sync.retry_queued": "Synkronisering till Tripletex har köats igen.",
            "tripletex_sync.retry_failed": "Kunde inte köa synkronisering till Tripletex.",
            "tripletex_sync.open_customer": "Öppna kund",
            "tripletex_sync.badge.column": "Tripletex",
            "tripletex_sync.badge.synced": "Synkroniserad",
            "tripletex_sync.badge.not_synced": "Ej synkroniserad",
            "tripletex_sync.badge.blocked": "Blockerad",
            "tripletex_sync.badge.error": "Synk misslyckades",
            "tripletex_sync.badge.pending": "Väntar",
            "tripletex_sync.dialog.open": "Öppna Tripletex-synk",
            "tripletex_sync.dialog.synced_body": "Projektet är synkat med Tripletex.",
            "table_view.no_value": "Inget värde",
            "table_view.empty_title": "Inget hittades",
            "table_view.empty_subtitle": "Försök att justera filtren eller sökningen.",
            "table_view.loading_more": "Laddar fler…",
            "table_view.rows_shown": "{{count}} rader visas",
            "table_view.columns": "Kolumner",
            "table_view.show_reorder_columns": "Visa och ordna om kolumner",
            "table_view.locked": "låst",
            "table_view.view_name_prompt": "Namn på vy",
            "table_view.new_view": "Ny vy",
            "table_view.unsaved_changes": "Osparade ändringar",
            "table_view.update_view": "Uppdatera denna vy",
            "table_view.save_as_new": "Spara som ny vy…",
            "table_view.delete_view": "Ta bort vy",
            "table_view.view_tabs": "Vyer",
            "Assigned": "Tilldelad",
            "Delete": "Radera",
            "Priority": "Prioritet",
            "Number": "Nummer",
            "Case": "Ärende",
            "Details": "Detaljer",
            "History": "Historik",
            "Due date": "Förfallodatum",
            "Saved": "Sparat",
            "Could not save changes": "Kunde inte spara ändringar",
            "Mangler tittel": "Saknar titel",
            "Ikke tildelt": "Ej tilldelad",
            "Overview": "Översikt",
            "Customer / Project": "Kund / Projekt",
            "Deviation": "Avvikelse",
            "Deviations": "Avvikelser",
            "Statuses": "Statusar",
            "Deviation Types": "Avvikelsetyper",
            "Priorities": "Prioriteringar",
            "Checklist": "Checklista",
            "Sjekklister": "Checklistor",
            "Uten tittel": "Utan titel",
            "Type mangler": "Typ saknas",
            "Ikke knyttet": "Inte kopplad",
            "Avvik": "Avvikelse",
            "Appointment": "Bokning",
            "project_selector.favorites": "Favoriter",
            "project_selector.suggested": "Föreslagna projekt",
            "project_selector.search_results": "Sökresultat",
            "project_selector.projects": "Projekt",
            "project_selector.no_projects_found": "Inga projekt hittades",
            "project_selector.no_projects_to_show": "Inga projekt att visa",
            "project_selector.offer": "Anbud",
            "project_selector.sub_of": "Under",
            "folder_selector.none": "Inget valt",
            "folder_selector.project_required": "Projekt-ID krävs",
            "folder_selector.scope_kind": "Projekt",
            "folder_selector.search_placeholder": "Sök mappar…",
            "folder_selector.new_folder": "Ny mapp",
            "folder_selector.new_folder_default": "Ny mapp",
            "folder_selector.new_subfolder": "Ny undermapp",
            "folder_selector.rename": "Byt namn",
            "folder_selector.delete": "Radera",
            "folder_selector.delete_title": "Radera «{{name}}»?",
            "folder_selector.delete_desc": "Filer flyttas till överordnad mapp (eller projektets rot) och raderas inte. Detta kan inte ångras.",
            "folder_selector.delete_desc_children": "Detta raderar även {{count}} undermappar. Filer flyttas till överordnad mapp (eller projektets rot) och raderas inte.",
            "folder_selector.empty": "Inga mappar ännu — skapa en för att komma igång.",
            "folder_selector.no_match": "Inga mappar matchar «{{query}}».",
            "folder_selector.select_hint": "Välj en mapp",
            "folder_selector.selected_count": "mapp(ar) valda",
            "folder_selector.clear": "Rensa",
            "folder_selector.select": "Välj",
            "folder_selector.expand": "Expandera",
            "folder_selector.collapse": "Minimera",
            "folder_selector.deselect": "Avmarkera",
            "folder_selector.create_failed": "Kunde inte skapa mapp",
            "folder_selector.rename_failed": "Kunde inte byta namn",
            "folder_selector.delete_failed": "Kunde inte radera mapp",
            "folder_selector.move_failed": "Kunde inte flytta mapp",
            "project_list.scope.projects": "Projekt",
            "project_list.scope.offers": "Anbud",
            "project_list.scope.all": "Alla",
            "project_list.filter.placeholder_status": "Status",
            "project_list.filter.placeholder_manager": "Projektledare",
            "project_list.filter.placeholder_tags": "Statustaggar",
            "project_list.column.status_tags": "Statustagg",
            "project_list.status_tags.save_error": "Kunde inte spara statustagg",
            "project.status_tags.title": "Statustaggar",
            "project.status_tags.hint": "Lägg till eller ändra utan att öppna redigering.",
            "project.status_tags.empty": "Inga statustaggar",
            "project.status_tags.save_error": "Kunde inte spara statustagg",
            "case_list.filter.tags": "Etiketter",
            "case_list.search_placeholder": "Sök ärenden (t.ex. ärendenummer)…",
            "case_list.filter_title": "Filtrera ärenden",
            "report_list.search_placeholder": "Sök rapporter…",
            "report_list.filter_title": "Filtrera rapporter",
            "report_list.filter.placeholder_customer": "Kund",
            "report_list.filter.placeholder_project": "Projekt",
            "report_list.filter.placeholder_type": "Rapporttyp",
            "report_list.filter.placeholder_date": "Datumintervall",
            "customer_list.search_placeholder": "Sök kunder…",
            "customer_list.filter_title": "Filtrera kunder",
            "customer_list.filter.placeholder_email": "E-post",
            "customer_list.filter.placeholder_address": "Adress",
            "customer_list.filter.placeholder_sync": "Synkstatus",
            "customer_list.filter.placeholder_tags": "Etiketter",
            "customer_list.filter.placeholder_type": "Kundtyp",
            "customer_list.filter.placeholder_region": "Region",
            "contact_list.search_placeholder": "Sök kontakter…",
            "contact_list.filter_title": "Filtrera kontakter",
            "contact_list.filter.placeholder_customer": "Kund",
            "contact_list.filter.placeholder_company": "Företag",
            "contact_list.filter.placeholder_role": "Roll",
            "contact_list.filter.placeholder_tags": "Etiketter",
            "contact_list.filter.placeholder_sync": "Synkstatus",
            "contact_list.filter.placeholder_status": "Status",
            "project_list.badge.offer": "Anbud",
            "project_list.badge.subproject": "Delprojekt",
            "project_list.sub_of": "Hör till",
            "project_list.financials.contract_sum": "Kontraktssumma",
            "project_list.financials.invoiced": "Fakturerat",
            "project_list.financials.costs": "Kostnader",
            "project_list.financials.result_margin": "Resultat / marginal",
            "project_list.financials.remaining": "Kvarstående",
            "project.parent_project": "Överordnat projekt",
            "project.parent_project.none": "Inget överordnat projekt",
            "Case guide": "Caseguide",
            "Guider": "Guider",
            "Guider tilgjengelig": "Guider tillgängliga",
            "guider": "guider",
            "Velg hvilken guide du vil bruke for etterspurt info.": "Välj vilken guide du vill använda för begärd information.",
            "Velg hvilken guide du vil starte for denne saken.": "Välj vilken guide du vill starta för detta ärende.",
            "Dupliser guide": "Duplicera guide",
            "kopi": "kopia",
            "Uten navn": "Utan namn",
            "Rapportguide": "Rapportguide",
            "Rapportguider": "Rapportguider",
            "Opprett og rediger guidede flyter for rapportarbeid.": "Skapa och redigera guidade flöden för rapportarbete.",
            "Guideomfang": "Guideomfång",
            "Velg om du vil redigere generelle rapportguider eller guider for en spesifikk rapporttype.": "Välj om du vill redigera generella rapportguider eller guider för en specifik rapporttyp.",
            "Tilbake til serviceinnstillinger": "Tillbaka till serviceinställningar",
            "Generelle rapportguider": "Generella rapportguider",
            "Opprett og rediger guidede flyter for rapportarbeid på egen side.": "Skapa och redigera guidade rapportflöden på en egen sida.",
            "Åpne rapportguider": "Öppna rapportguider",
            "Caseguider": "Caseguider",
            "Opprett og rediger guidede flyter for saker.": "Skapa och redigera guidade flöden för ärenden.",
            "Guideomfang case": "Guideomfång (ärendetyp)",
            "Velg case type for å redigere guideflyten.": "Välj ärendetyp för att redigera guideflödet.",
            "Case guides scope intro":
              "Välj om du vill redigera generella caseguider (alla typer) eller guider för en specifik ärendetyp — samma mönster som rapportguider.",
            "Generelle caseguider": "Generella caseguider",
            "Generell caseguide": "Generell",
            "Case guide scope general hint": "Guider som gäller alla ärendetyper.",
            "Case guide scope type hint":
              "Visar guider för denna ärendetyp plus eventuella generella guider. Typspecifika guider listas först.",
            "Tilbake til caseinnstillinger": "Tillbaka till ärendeinställningar",
            "Åpne caseguider": "Öppna caseguider",
            "Opprett og rediger guidede flyter for saker på egen side.": "Skapa och redigera guidade ärendeflöden på en egen sida.",
            "Ingen case typer er opprettet ennå.": "Inga ärendetyper har skapats ännu.",
            "Caseguide-bygger på egen side": "Caseguide-byggaren öppnas på en egen sida.",
            "Åpne guidebygger": "Öppna guidebyggaren",
            "Case guide options connect to effect nodes":
              "Svarsalternativ har bara etikett och värde. Använd Koppla på ett alternativ och länka till en effektnod på arbetsytan (etiketter, prioritet, datum osv.).",
            "Velg rapportguide": "Välj rapportguide",
            "Velg guiden som passer best med oppdraget.": "Välj guiden som passar uppdraget bäst.",
            "Velg guide": "Välj guide",
            "Ny rapportguide": "Ny rapportguide",
            "Ny guide": "Ny guide",
            "Generell": "Generell",
            "Generell rapportguide": "Generell rapportguide",
            "Kan brukes på alle rapporttyper": "Kan användas på alla rapporttyper",
            "spørsmål": "frågor",
            "Avslutt etter dette svaret": "Avsluta efter detta svar",
            "Guide builder": "Guidebyggare",
            "Effekter": "Effekter",
            "Effekt": "Effekt",
            "Effect-node": "Effektnod",
            "Guide flow palette effect id line": "Lägger en nod på arbetsytan med effekt-id:",
            "Guide flow effect editor palette link": "Samma palettblock / effekt-id",
            "Guide flow option connection": "Detta svar leder till",
            "Rapporttekst": "Rapporttext",
            "Intern tekst": "Intern text",
            "Case oppfølging": "Case-uppföljning",
            "Sjekkliste": "Checklista",
            "Videre": "Vidare",
            "Avslutt etter denne effekten": "Avsluta efter denna effekt",
            "Rediger effekt": "Redigera effekt",
            "Opprett spørsmål som noder og koble svar til neste spørsmål.": "Skapa frågor som noder och koppla svar till nästa fråga.",
            "Dra inn eller klikk for å opprette.": "Dra in eller klicka för att skapa.",
            "Guide flow": "Guideflöde",
            "guide.flow.json_dialog_title": "Guideflöde — JSON och AI-instruktion",
            "guide.flow.json_tab": "JSON",
            "guide.flow.ai_guide_tab": "Instruktion till AI",
            "guide.flow.json_hint":
              "Kanter byggs om automatiskt från `next_node_id` på svar och effekter. Klistra in eller redigera JSON och tillämpa.",
            "guide.flow.copy_json": "Kopiera JSON",
            "guide.flow.apply_json": "Applicera på arbetsytan",
            "guide.flow.reload_from_canvas": "Läs om från arbetsytan",
            "guide.flow.reload_from_canvas_success": "Textfältet uppdaterades från arbetsytan.",
            "guide.flow.copy_json_success": "JSON kopierad till urklipp.",
            "guide.flow.clipboard_failed": "Kunde inte använda urklipp.",
            "guide.flow.json_invalid": "Ogiltig JSON eller flöde: {{message}}",
            "guide.flow.json_applied": "Guideflödet uppdaterades.",
            "guide.flow.copy_ai_guide": "Kopiera AI-instruktion",
            "guide.flow.ai_guide_copied": "AI-instruktion kopierad.",
            "guide.flow.ai_empty": "AI returnerade tom flödes-JSON.",
            "guide.flow.ai_applied": "Guideflöde uppdaterat från AI.",
            "guide.flow.open_json": "JSON",
            "guide.flow.open_json_tooltip": "Visa, kopiera, klistra in eller redigera guideflödet som JSON",
            "guide.flow.generate_with_ai": "Generera med AI",
            "guide.flow.ai_guide_intro":
              "Klistra in i externa AI-verktyg eller använd Promangs inbyggda generator. Tekniska nycklar matchar `settings.flow` i API:et.",

            "Velg neste spørsmål for valgt svar.": "Välj nästa fråga för valt svar.",
            "Koble svar til neste spørsmål ved å bruke Koble-knappen på et svar.": "Koppla svar till nästa fråga med Koppla-knappen på ett svar.",
            "Nytt spørsmål": "Ny fråga",
            "Koble": "Koppla",
            "Koble om": "Koppla om",
            "Slett kobling": "Ta bort koppling",
            "Sett som start": "Sätt som start",
            "Rediger spørsmål": "Redigera fråga",
            "Svarvalg": "Svarsalternativ",
            "Velg en node for å redigere.": "Välj en nod för att redigera.",
            "Dato": "Datum",
            "Tid": "Tid",
            "Guidet rapport": "Guidad rapport",
            "Ingen rapportguide er tilgjengelig": "Ingen rapportguide är tillgänglig",
            "Rapportguide lagret": "Rapportguide sparad",
            "Guiden kan fylle rapporttekst og lagrer svar for administrasjon.": "Guiden kan fylla rapporttext och sparar svar för administration.",
            "Lagre rapporttypen før du konfigurerer guide.": "Spara rapporttypen innan du konfigurerar guide.",
            "Konfigurer spørsmål som kan fylle rapporttekst og lagre svar for administrasjon.": "Konfigurera frågor som kan fylla rapporttext och spara svar för administration.",
            "Ta med svar i rapporttekst": "Ta med svar i rapporttext",
            "Rapporttekst ved valg": "Rapporttext vid val",
            "Intern tekst ved valg": "Intern text vid val",
            "Case oppfølging tittel": "Case-uppföljning titel",
            "Case oppfølging tekst": "Case-uppföljning text",
            "Krever tiltak": "Kräver åtgärd",
            "Reklamasjon": "Reklamation",
            "Ingen sjekkliste": "Ingen checklista",
            "Opprett sjekkliste": "Skapa checklista",
            "Opprett oppfølger": "Skapa uppföljare",
            "Oppfølger beskrivelse": "Uppföljarens beskrivning",
            "Oppfølger intern beskrivelse": "Uppföljarens interna beskrivning",
            "Ingen sjekkliste på oppfølger": "Ingen checklista på uppföljare",
            "Opprett avtale på oppfølger": "Skapa avtal på uppföljare",
            "Bruk samme avtaledato og tid som nåværende rapport": "Använd samma avtalsdatum och tid som nuvarande rapport",
            "Guidet case-opprettelse": "Guidad ärendeskapning",
            "Etterspørre info": "Begär information",
            "Etterspurt info": "Begärd information",
            "Guidet opprettelse": "Guidad skapning",
            "Spørsmål": "Fråga",
            "Steg": "Steg",
            "Oppsummering": "Sammanfattning",
            "guide.case_view_summary": "Visa sammanfattning",
            "guide.case_summary_review_intro": "Kontrollera svaren innan du använder guiden.",
            "guide.case_chain_effect_title": "Starta en annan caseguide",
            "guide.case_chain_effect_help":
              "När denna guide har tillämpats på ärendet öppnas den valda guiden automatiskt (denna guide slutförs först).",
            "guide.case_chain_pick_guide": "Nästa guide",
            "guide.case_chain_none": "— ingen —",
            "guide.case_chain_started": "Öppnar nästa guide…",
            "guide.case_chain_summary_hint":
              "När du har använt guiden startas en annan guide automatiskt på samma ärende.",
            "Ingen guide-spørsmål er konfigurert.": "Inga guidefrågor är konfigurerade.",
            "Guiden foreslår": "Guiden föreslår",
            "etiketter": "etiketter",
            "Bruk guide": "Använd guide",
            "Åpne guide": "Öppna guide",
            "Tilbake": "Tillbaka",
            "Neste": "Nästa",
            "Besvart": "Besvarad",
            "Automatiske etiketter brukt": "Automatiska etiketter använda",
            "Automatiske etiketter lagt til": "Automatiska etiketter tillagda",
            "Antall": "Antal",
            "Denne case typen krever guide før opprettelse": "Denna ärendetyp kräver guiden innan skapande",
            "Fyll ut guide": "Fyll i guide",
            "Fyll ut guiden før saken opprettes": "Fyll i guiden innan ärendet skapas",
            "besvarte etterspurt info": "besvarade begärd information",
            "fullførte guide": "slutförde guide",
            "Konfigurer spørsmål, valg og automatiske etiketter for denne case typen.": "Konfigurera frågor, val och automatiska etiketter för denna ärendetyp.",
            "Lagre case type før du konfigurerer guide.": "Spara ärendetypen innan du konfigurerar guiden.",
            "Guide title": "Guidetitel",
            "Guide description": "Guidebeskrivning",
            "Legg til spørsmål": "Lägg till fråga",
            "Lagre guide": "Spara guide",
            "Spørsmålstekst": "Frågetext",
            "Påkrevd": "Obligatorisk",
            "Valg": "Val",
            "Valg 1": "Val 1",
            "Valg label": "Valtext",
            "Verdi": "Värde",
            "Fjern valg": "Ta bort val",
            "Automatiske etiketter": "Automatiska etiketter",
            "Legg til valg": "Lägg till val",
            "Select case type": "Välj ärendetyp",
            "Case Type": "Ärendetyp",
            "No results": "Inga träffar",
            "Select case type first": "Välj ärendetyp först",
            "No guide configured for this case type": "Ingen guide är konfigurerad för denna ärendetyp",
            "Ny case": "Nytt ärende",
            "Velg case type først. Guiden hjelper deg å stille riktige spørsmål og foreslår etiketter automatisk.": "Välj ärendetyp först. Guiden hjälper dig att ställa rätt frågor och föreslår etiketter automatiskt.",
            "Title and case type are required": "Titel och ärendetyp är obligatoriskt",
            "Case type is required": "Ärendetyp är obligatoriskt",
            "Velg case type først. Tittel genereres automatisk med AI etter opprettelse.": "Välj ärendetyp först. Titeln genereras automatiskt med AI efter skapande.",
            "Guide åpnes etter opprettelse": "Guiden öppnas efter skapande",
            "Etter opprettelse": "Efter skapande",
            "Velg case type først. Hvis typen har en guide kan du besvare den før saken opprettes.": "Välj ärendetyp först. Om typen har en guide kan du besvara den innan ärendet skapas.",
            "Valgfri guide for denne case typen": "Valfri guide för denna ärendetyp",
            "Type": "Typ",
            "Detaljer": "Detaljer",
            "Opprett": "Skapa",
            "Velg type": "Välj typ",
            "Saksdetaljer": "Ärendedetaljer",
            "Guide besvart": "Guide besvarad",
            "Klar til opprettelse": "Klar att skapa",
            "Se guide igjen": "Visa guide igen",
            "Start guide": "Starta guide",
            "Hva slags case oppretter du?": "Vilken typ av ärende skapar du?",
            "Case typen styrer hvilke spørsmål og automatiske forslag som vises.": "Ärendetypen styr vilka frågor och automatiska förslag som visas.",
            "Guide": "Guide",
            "Ikke brukt": "Inte använd",
            "Ja": "Ja",
            "Nei": "Nej",
            "templates.title": "Mallar",
            "templates.new": "Ny mall",
            "templates.edit": "Redigera mall",
            "templates.empty": "Inga mallar hittades.",
            "templates.search_placeholder": "Sök i mallar...",
            "templates.editor_placeholder": "Skriv mallens innehåll...",
            "templates.editor_hint": "Skapa återanvändbart rich text-innehåll och koppla det till en kategori.",
            "templates.form.title": "Malldetaljer",
            "templates.form.subtitle": "Ge mallen en tydlig titel, kategori och rich text-innehåll.",
            "templates.insert.append": "Klistra in tillsammans med befintlig text",
            "templates.insert.replace": "Ersätt hela texten",
            "templates.insert.use": "Använd mall",
            "templates.hero.kicker": "Innehållsbibliotek",
            "templates.hero.subtitle": "Organisera återanvändbara textmallar i kategorier och infoga dem från rich text-redigerare.",
            "templates.filters.heading": "Sök och filter",
            "templates.filters.description": "Sök i mallar eller filtrera på kategori.",
            "templates.categories.title": "Kategorier",
            "templates.categories.all": "Alla mallar",
            "templates.categories.new": "Ny kategori",
            "templates.categories.edit": "Redigera kategori",
            "templates.categories.name": "Namn",
            "templates.categories.parent": "Överordnad kategori",
            "templates.categories.no_parent": "Ingen överordnad kategori",
            "templates.categories.description": "Beskrivning",
            "templates.categories.uncategorized": "Inte kategoriserad",
            "templates.section.kicker": "Mallar",
            "templates.section.title": "Alla mallar",
            "templates.section.subtitle": "Välj en kategori för att se mallarna som är kopplade till den.",
            "templates.section.category_title": "Mallar i kategorin",
            "templates.section.category_subtitle": "Mallar kopplade till vald kategori.",
            "company.settings.tabs.company": "Företag",
            "company.settings.tabs.employment_agreement": "Anställningsavtal",
            "company.settings.tabs.employee_positions": "Företagsbefattningar",
            "company.integrations.title": "Integrationer",
            "company.integrations.subtitle": "Tjänster, API-appar och webhooks för företaget",
            "company.integrations.tabs.services": "Tjänster",
            "company.integrations.tabs.apps": "API-appar",
            "company.integrations.tabs.webhooks": "Webhooks",
            "company.integrations.status.connected": "Ansluten",
            "company.integrations.status.missing": "Saknar inställning",
            "company.integrations.events": "Händelser",
            "company.integrations.show": "Visa",
            "company.integrations.hide": "Dölj",
            "company.integrations.copy": "Kopiera",
            "company.integrations.copied": "Kopierat",
            "company.integrations.sync_tripletex": "Synka Tripletex med Promang",
            "company.integrations.delete_tripletex_subscriptions": "Ta bort Tripletex-prenumerationer",
            "company.integrations.delete_tripletex_body": "Är du säker på att du vill ta bort Tripletex-prenumerationerna?",
            "company.integrations.sync_products_title": "Produktsynk",
            "company.integrations.sync_products_body": "Är du säker på att du vill synka produkter nu?",
            "company.integrations.sync_success": "Synken lyckades",
            "company.integrations.tripletex.title": "Tripletex API",
            "company.integrations.tripletex.description": "Koppla Promang till Tripletex",
            "company.integrations.bring.title": "Bring API",
            "company.integrations.bring.description": "Koppla Promang till Bring",
            "company.integrations.stripe.title": "Stripe API",
            "company.integrations.stripe.description": "Koppla Promang till Stripe",
            "company.integrations.automile.title": "Automile API",
            "company.integrations.automile.description": "Koppla Promang till Automile",
            "company.integrations.google_maps.title": "Google Maps API",
            "company.integrations.google_maps.description": "Koppla Promang till Google Maps",
            "company.integrations.webshop.title": "Webshop",
            "company.integrations.webshop.description": "Koppla Promang till webshoppen",
            "company.integrations.phonero.title": "Phonero API",
            "company.integrations.phonero.description": "Koppla Promang till Phonero för samtal",
            "company.integrations.fields.tripletex_employee_token": "Tripletex anställd-token",
            "company.integrations.fields.tripletex_hour_sync_if_approved_only": "Synka bara godkända timmar",
            "company.integrations.fields.bring_api_uid": "Bring API UID",
            "company.integrations.fields.bring_api_key": "Bring API-nyckel",
            "company.integrations.fields.bring_main_customer_number": "Bring huvudkundnummer",
            "company.integrations.fields.stripe_webhook_secret": "Stripe webhook-secret",
            "company.integrations.fields.stripe_webhook_url": "Stripe webhook-URL",
            "company.integrations.fields.stripe_secret_key": "Stripe hemlig nyckel",
            "company.integrations.fields.automile_client_id": "Automile klient-ID",
            "company.integrations.fields.automile_client_secret": "Automile klient-secret",
            "company.integrations.fields.automile_username": "Automile användarnamn",
            "company.integrations.fields.automile_password": "Automile lösenord",
            "company.integrations.fields.google_maps_api_key": "Google Maps API-nyckel",
            "company.integrations.fields.store_checkout_active": "Webshop-kassa aktiv",
            "company.integrations.fields.webshop_products_url": "Webshop produkt-URL",
            "company.integrations.fields.webshop_order_cancel_url": "Avbruten order-URL",
            "company.integrations.fields.webshop_order_success_url": "Lyckad order-URL",
            "company.integrations.fields.phonero_username": "Phonero användarnamn",
            "company.integrations.fields.phonero_password": "Phonero lösenord",
            "company.integrations.fields.phonero_customer_id": "Phonero kundnummer",
            "company.oauth_apps.intro": "Skapa OAuth-klienter som externa appar använder för att anropa Promang API. Företaget äger appen och kan rulla nycklar.",
            "company.oauth_apps.new": "Ny API-app",
            "company.oauth_apps.name": "Namn",
            "company.oauth_apps.redirect": "Redirect URI",
            "company.oauth_apps.scopes": "Scopes",
            "company.oauth_apps.create": "Skapa app",
            "company.oauth_apps.created": "API-app skapad",
            "company.oauth_apps.empty": "Inga API-appar ännu.",
            "company.oauth_apps.secret_once": "Spara uid och secret nu. Secret visas bara den här gången.",
            "company.oauth_apps.roll": "Rulla nycklar",
            "company.oauth_apps.rolled": "Nycklar rullade",
            "company.oauth_apps.delete": "Ta bort",
            "company.oauth_apps.deleted": "App borttagen",
            "company.oauth_apps.deleted_badge": "Borttagen",
            "company.oauth_apps.confirm_name": "Bekräfta namn",
            "company.oauth_apps.load_failed": "Kunde inte ladda API-appar",
            "company.oauth_apps.create_failed": "Kunde inte skapa API-app",
            "company.oauth_apps.roll_failed": "Kunde inte rulla nycklar",
            "company.oauth_apps.delete_failed": "Kunde inte ta bort app",
            "company.oauth_apps.delete_name_mismatch": "Skriv appnamnet för att ta bort",
            "cases.weply.type": "Weply",
            "cases.weply.other_fields": "Andra fält",
            "cases.weply.session": "Samtal",
            "company.webhooks.weply_title": "Koppla ett externt system",
            "company.webhooks.weply_step1": "Skapa en inkommande webhook och välj vilka moduler den ska få åtkomst till.",
            "company.webhooks.weply_step2": "I det externa systemet: slå på utgående webhook eller integration.",
            "company.webhooks.weply_step3": "Klistra in Promang-URL:en som mottagare.",
            "company.webhooks.weply_step4": "Sätt header X-Promang-Webhook-Secret till nyckeln från Promang.",
            "company.webhooks.connect_title": "Så kopplar du ett externt system",
            "company.webhooks.connect_step1": "Skapa en inkommande webhook och välj vilka moduler den ska få åtkomst till.",
            "company.webhooks.connect_step2": "I det externa systemet: slå på utgående webhook eller integration.",
            "company.webhooks.connect_step3": "Klistra in Promang-URL:en som mottagare.",
            "company.webhooks.connect_step4": "Sätt header X-Promang-Webhook-Secret till nyckeln från Promang.",
            "company.webhooks.provider_lead": "Lead / chatt",
            "company.webhooks.guide_title": "Vad kan webhooks användas till?",
            "company.webhooks.guide_intro": "Webhooks kopplar Promang till andra system. Inkommande tar emot data och skapar poster i modulerna du ger åtkomst till. Utgående skickar händelser från Promang till en URL ni äger.",
            "company.webhooks.guide_inbound": "Ett externt system POST:ar till Promang-URL:en. Med åtkomst kan webhooken skapa kund, kontakt och ärende (meddelandet visas som ett eget kort på ärendet). Samma samtal (session) blir en uppföljning på befintligt ärende.",
            "company.webhooks.guide_outbound": "När kund eller kontakt skapas, uppdateras eller raderas skickar Promang ett signerat JSON-anrop till mål-URL:en.",
            "company.webhooks.supported_now": "Stöds nu",
            "company.webhooks.coming_soon": "Kommer senare",
            "company.webhooks.modules_label": "Moduler webhooken har åtkomst till",
            "company.webhooks.modules_help": "Välj vad denna webhook får skapa (in) eller skicka (ut). Ärende och kontakt kräver kund.",
            "company.webhooks.labels_label": "Etiketter på nya ärenden",
            "company.webhooks.labels_help": "Välj företagets ärendeetiketter som ska sättas automatiskt när webhooken skapar ett ärende. Skapa etiketten först, till exempel «Lead».",
            "company.webhooks.custom_fields_help": "Alla fält utom transkript/meddelande (namn, e-post, telefon, User Agent, Agent Name …) sparas som anpassade fält på ärendet.",
            "company.webhooks.labels_manage": "Hantera etiketter",
            "company.webhooks.labels_pick": "Välj etiketter",
            "company.webhooks.modules_blank": "Välj minst en modul.",
            "company.webhooks.module.customer": "Kund",
            "company.webhooks.module.contact": "Kontakt",
            "company.webhooks.module.case": "Ärende",
            "company.webhooks.module.project": "Projekt",
            "company.webhooks.module.order": "Order",
            "company.webhooks.module.report": "Servicerapport",
            "company.webhooks.new": "Ny webhook",
            "company.webhooks.name": "Namn",
            "company.webhooks.provider": "Leverantör",
            "company.webhooks.generic": "Generisk",
            "company.webhooks.direction": "Riktning",
            "company.webhooks.inbound": "Inkommande",
            "company.webhooks.outbound": "Utgående",
            "company.webhooks.target_url": "Mål-URL",
            "company.webhooks.create": "Skapa webhook",
            "company.webhooks.created": "Webhook skapad",
            "company.webhooks.empty": "Inga webhooks ännu.",
            "company.webhooks.secret_once": "Spara URL och nyckel nu. Nyckeln visas bara den här gången.",
            "company.webhooks.header": "Header",
            "company.webhooks.roll": "Rulla nyckel",
            "company.webhooks.rolled": "Nyckel rullad",
            "company.webhooks.enable": "Aktivera",
            "company.webhooks.disable": "Inaktivera",
            "company.webhooks.test": "Testa",
            "company.webhooks.log": "Logg",
            "company.webhooks.delete": "Ta bort",
            "company.webhooks.deleted": "Webhook borttagen",
            "company.webhooks.load_failed": "Kunde inte ladda webhooks",
            "company.webhooks.create_failed": "Kunde inte skapa webhook",
            "company.webhooks.update_failed": "Kunde inte uppdatera webhook",
            "company.webhooks.roll_failed": "Kunde inte rulla nyckel",
            "company.webhooks.delete_failed": "Kunde inte ta bort webhook",
            "company.webhooks.test_queued": "Test är köad",
            "company.webhooks.test_failed": "Test misslyckades",
            "company.webhooks.deliveries_failed": "Kunde inte ladda leveranslogg",
            "company.employee_positions.help": "Gemensam befattningskatalog för företaget. Används i uppgiftsmallar och anställningar.",
            "company.employee_positions.saved": "Företagsbefattningar sparade",
            "company.employee_positions.employment_link": "Koppla befattningar till anställda under Användare → Anställning.",
            "company.employee_positions.employment_link_action": "Gå till användare",
            "company.employment_agreement.title": "Standard avtalstext",
            "company.employment_agreement.description": "Denna text läggs in som gemensam avtalstext i PDF:en för anställningsavtal.",
            "company.employment_agreement.placeholder": "Skriv standardtext för anställningsavtal...",
            "pagination.previous": "Föregående",
            "pagination.next": "Nästa",
            "pagination.showing": "Visar {{current}} av {{total}}",
            "pagination.loadMore": "Ladda mer",
            "payslips.kicker": "Tripletex lön",
            "payslips.title": "Lön",
            "payslips.mine_title": "Mina lönespecifikationer",
            "payslips.admin_title": "Lönespecifikationer",
            "payslips.stats_title": "Statistik",
            "payslips.description": "Se lönespecifikationer som gjorts tillgängliga från Tripletex utan att logga in i Tripletex.",
            "payslips.admin_description": "Hantera och filtrera lönespecifikationer för anställda. Kräver rollen Lön Admin (företagsadministratörer ser bara egna lönespecifikationer utan denna roll).",
            "payslips.stats_description": "Översikt över lönespecifikationer som ingår i summorna nedan (egna om du inte har Lön Admin).",
            "payslips.admin_forbidden": "Du behöver rollen Lön Admin för att hantera alla lönespecifikationer för företaget. Be en administratör tilldela Lön Admin för detta företag.",
            "payslips_admin": "Lön Admin",
            "payslips.role_view_override_warning":
              "Rollvy-simulering är aktiv — den ändrar bara menyer/UI. API:et använder fortfarande dina riktiga roller. Stäng av rollvy (DevOps-menyn) så att behörighet stämmer.",
            "payslips.loading": "Laddar lönespecifikationer...",
            "payslips.empty": "Inga lönespecifikationer är tillgängliga ännu.",
            "payslips.error": "Kunde inte hämta lönespecifikationer.",
            "payslips.period": "Period",
            "payslips.employee": "Anställd",
            "payslips.voucher_date": "Verifikationsdatum",
            "payslips.available_date": "Tillgänglig",
            "payslips.gross_amount": "Brutto",
            "payslips.amount": "Netto",
            "payslips.actions": "Åtgärder",
            "payslips.open": "Öppna",
            "payslips.opening": "Öppnar...",
            "payslips.sync_now": "Synkronisera nu",
            "payslips.syncing": "Synkroniserar...",
            "payslips.pdf_failed": "Kunde inte öppna lönespecifikationen. Försök igen.",
            "payslips.sync_failed": "Kunde inte starta lönesynk. Försök igen.",
            "payslips.employee_filter": "Anställd",
            "payslips.stats_count": "Lönespecifikationer",
            "payslips.stats_gross": "Brutto totalt",
            "payslips.stats_net": "Netto totalt",
            "payslips.stats_average_net": "Snitt netto",
            "listbox.none": "Inte valt",
            "user_info.address": "Adress",
            "user_info.address_hint": "Sparas på användarprofilen och används som adressunderlag i anställningsflödet.",
            "user_employment.option_not_selected": "Inte valt",
            "user_employment.section_basic": "Anställningsunderlag",
            "user_employment.section_basic_hint": "Grunddata för anställningsförhållandet och anställningsavtalet.",
            "user_employment.employee_number": "Anställningsnummer",
            "user_employment.employment_starts": "Anställning startar",
            "user_employment.employment_ends": "Slutdatum",
            "report.previous_work.title": "Tidigare arbete",
            "report.previous_work.hint": "Kort översikt hos kunden",
            "report.previous_work.empty": "Inga tidigare rapporter hittades.",
            "report.previous_work.fallback": "Rapport {{number}}",
            "report.previous_work.open": "Visa tidigare arbete",
            "report.previous_work.dialog_title": "Tidigare arbete",
            "report.previous_work.ai_title": "AI-översikt",
            "report.previous_work.ai_generating": "Uppdaterar…",
            "report.previous_work.ai_error": "Kunde inte hämta översikten.",
            "report.previous_work.ai_empty": "Ingen AI-översikt ännu.",
            "report.previous_work.show_less": "Visa mindre",
            "report.previous_work.show_more": "Visa mer",
            "report.previous_work.see_more": "Visa mer",
            "report.previous_work.see_report": "Visa rapport",
            "report.previous_work.see_checklist": "Visa checklista",
            "report.previous_work.images": "Bilder",
            "report.previous_work.report_label": "Rapport {{number}}",
            "report.previous_work.different_facility": "Annan anläggning",
            "report.previous_work.different_facility_hint": "Detta arbete gäller en annan anläggning hos kunden.",
            "report.previous_work.jobs_heading": "Tidigare jobb",
            "report.previous_work.load_error": "Kunde inte ladda tidigare arbete.",
            "report.previous_work.back_to_overview": "Tillbaka till översikt",
            "report.previous_work.crumb_overview": "Översikt",
            "report.previous_work.crumb_report": "Rapport {{number}}",
            "report.previous_work.crumb_checklist": "Checklista {{number}}",
            "report.previous_work.facility_history_title": "Historik för anläggning",
            "report.previous_work.facility_history_empty": "Inga tidigare rapporter på den här anläggningen.",
            "report.previous_work.panel_load_error": "Kunde inte ladda innehållet.",
            "report.previous_work.open_full_report": "Öppna hela rapporten",
            "report.previous_work.no_checklist": "Ingen checklista på den här rapporten.",
            "report.previous_work.checklist_ok": "Godkänd",
            "report.previous_work.checklist_deviation": "Avvikelse",
            "report.active_agreement.chip": "Aktivt serviceavtal {{number}}",
            "module_overview.tab.reports": "Rapporter",
            "module_overview.tab.agreements": "Serviceavtal",
            "module_overview.tab.orders": "Ordrar",
            "module_overview.tab.projects": "Projekt",
            "module_overview.hide_details": "Dölj detaljer",
            "module_overview.show_details": "Visa detaljer",
            "module_overview.select_tab": "Välj flik",
            "module_overview.go_to_customer": "Gå till kund",
            "module_overview.filter_reports": "Filtrera rapporter",
            "module_overview.filter_agreements": "Filtrera avtal",
            "module_overview.filter_projects": "Filtrera projekt",
            "module_overview.search_projects": "Sök projekt…",
            "customer.systems.tab": "Anläggning",
            "customer.systems.overview_title": "Kundens anläggningar",
            "customer.systems.overview_hint": "Anläggningar och system kopplade till kunden.",
            "customer.systems.add": "Lägg till anläggning",
            "customer.systems.add_from_case": "Lägg till anläggning",
            "customer.systems.empty": "Inga anläggningar registrerade ännu.",
            "customer.systems.no_meta": "Ingen placering eller serienummer",
            "customer.systems.other_comment": "Annan kommentar",
            "customer.systems.history": "Historik",
            "customer.systems.spare_parts": "Reservdelar",
            "customer.systems.no_product_selected": "Välj en produkt först.",
            "customer.systems.select_existing": "Välj befintlig anläggning",
            "customer.systems.select_existing_hint": "Koppla en anläggning som redan finns hos kunden.",
            "customer.systems.create_new": "Skapa ny anläggning",
            "customer.systems.choose": "Välj",
            "customer.systems.detach": "Koppla från",
            "customer.systems.missing_customer": "Saknar kund — kan inte visa anläggningar.",
            "customer.systems.dialog.view_title": "Anläggning",
            "customer.systems.dialog.edit_title": "Redigera anläggning",
            "customer.systems.dialog.create_title": "Ny anläggning",
            "customer.systems.mode.existing": "Välj befintlig",
            "customer.systems.mode.create": "Skapa ny",
            "customer.systems.search_existing": "Sök anläggningar…",
            "customer.systems.no_existing_match": "Inga anläggningar matchar sökningen.",
            "customer.systems.existing_count": "{{count}} anläggningar registrerade hos kunden",
            "customer.systems.open_product": "Öppna produkt",
            "customer.systems.form.equipment": "Utrustning",
            "customer.systems.form.location": "Placering",
            "customer.systems.form.dates": "Årtal",
            "customer.systems.form.notes": "Anteckningar",
            "customer.systems.card_title": "Anläggning",
            "customer.systems.status.linked": "Kopplad",
            "customer.systems.status.missing": "Saknas",
            "customer.systems.status.required": "Obligatorisk",
            "customer.systems.status.not_required": "Inte obligatorisk",
            "customer.systems.address": "Adress",
            "customer.systems.not_linked": "Inte kopplad",
            "customer.systems.attach": "Koppla anläggning",
            "customer.systems.select_product": "Välj en produkt",
            "customer.systems.none_selected": "Ingen vald",
            "customer.systems.merge": "Koppla dubblett",
            "customer.systems.merge_title": "Koppla anläggning mot en annan",
            "customer.systems.merge_hint": "Allt på «{{name}}» flyttas till den valda anläggningen. Denna anläggning tas bort.",
            "customer.systems.merge_choose_target": "Välj anläggning som ska behållas",
            "customer.systems.merge_confirm": "Koppla och ta bort",
            "customer.systems.merge_cancel": "Avbryt",
            "customer.systems.merge_working": "Kopplar…",
            "customer.systems.merge_success": "Anläggningarna är kopplade",
            "customer.systems.merge_error": "Kunde inte koppla anläggningarna",
            "case.transfer.action": "Överför ärende",
            "case.transfer.title": "Överför ärende",
            "case.transfer.intro": "Flytta information till ett annat ärende i samma företag.",
            "case.transfer.same_customer_heading": "Öppna ärenden hos samma kund",
            "case.transfer.no_same_customer": "Inga andra öppna ärenden hos den här kunden.",
            "case.transfer.no_customer_hint": "Ärendet har ingen kund, så du måste söka i hela företaget.",
            "case.transfer.search_heading": "Sök i företaget",
            "case.transfer.search_button": "Sök efter ärende",
            "case.transfer.confirm_title": "Bekräfta överföring",
            "case.transfer.confirm_summary": "Överför från {{source}} till {{target}}.",
            "case.transfer.confirm_effects": "Källärendet stängs och markeras som överfört.",
            "case.transfer.different_customer_warning": "Målärendet tillhör en annan kund.",
            "case.transfer.note_label": "Anteckning",
            "case.transfer.note_placeholder": "Valfri anteckning till överföringen…",
            "case.transfer.confirm_button": "Överför",
            "case.transfer.success": "Ärendet har överförts.",
            "case.transfer.error": "Kunde inte överföra ärendet.",
            "case.transfer.banner_out": "Överfört till",
            "case.transfer.banner_in": "Mottaget från",
            "case.transfer.tag_out": "Överfört",
            "case.transfer.tag_in": "Mottagen överföring",
            "case.transfer.tag_in_count": "Mottagen överföring ({{count}})",
            "case.siblings.title": "{{count}} andra öppna ärenden hos kunden",
            "case.siblings.hint": "Kontrollera om ärendet redan följs upp någon annanstans.",
            "case.siblings.more": "{{count}} ärenden till",
            "case.siblings.tag": "{{count}} öppna ärenden",
            "case.relations.tags_label": "Relaterade ärenden",
            "absence.overview.title": "Frånvaro — översikt",
            "absence.overview.employee": "Anställd",
            "absence.stats.load_failed": "Något gick fel när statistiken skulle laddas",
            "work_stats.loading": "Hämtar arbetssiffror…",
            "cases.create.dialog_title": "Nytt ärende",
            "cases.create.dialog_hint": "Fyll i det som behövs för att skapa. Du redigerar ärendet efteråt på ärendesidan.",
            "cases.create.type_required": "Ärendetyp krävs",
            "cases.create.description_placeholder": "Kort beskrivning…",
            "employment.end_date.badge": "Slutar {{date}}",
            "employment.end_date.ended_badge": "Slutade {{date}}",
            "employment.end_date.until": "till {{date}}",
            "employment.end_date.plan_blocked": "{{name}} slutade {{date}} och kan inte planeras på eller efter den dagen.",
            "employment.end_date.hours_blocked": "Kan inte registrera timmar efter slutdatum ({{date}}).",
            "user_employment.social_security": "Personnummer",
            "user_employment.working_posistion": "Befattning",
            "user_employment.employee_position_none": "Ingen befattning vald",
            "user_employment.workplace": "Arbetsplats",
            "user_employment.agreement_type": "Avtalstyp",
            "user_employment.agreement_type_permanent": "Fast",
            "user_employment.agreement_type_temporary": "Tillfällig",
            "user_employment.agreement_type_hourly": "Tim-/behovsanställd",
            "user_employment.agreement_type_seasonal": "Säsong",
            "user_employment.agreement_type_other": "Annat",
            "user_employment.section_worktime": "Arbetstid",
            "user_employment.section_worktime_hint": "Tidsintervall som kan användas i anställningsavtalet.",
            "user_employment.worktime_regular_from": "Ordinarie från",
            "user_employment.worktime_regular_too": "Ordinarie till",
            "user_employment.worktime_weekend_from": "Helg från",
            "user_employment.worktime_weekend_too": "Helg till",
            "user_employment.worktime_regular_range": "Ordinarie arbetstid",
            "user_employment.worktime_weekend_range": "Helgarbete",
            "user_employment.section_wages": "Lön och tillägg",
            "user_employment.section_wages_hint": "Avtalade lönevillkor. Lönetabellen nedan behålls för historik och tidsberäkningar.",
            "user_employment.wages": "Lön",
            "user_employment.wages_unit": "Lön per",
            "user_employment.wage_unit_hour": "Timme",
            "user_employment.wage_unit_month": "Månad",
            "user_employment.wage_unit_year": "År",
            "user_employment.wage_unit_fixed": "Fast avtalat",
            "user_employment.overtime_pay": "Övertidsersättning",
            "user_employment.dismissal": "Uppsägningstid",
            "user_employment.wage_other_addition": "Övriga tillägg",
            "user_employment.wage_weekend_and_night_addition": "Helg-/natttillägg",
            "user_employment.collective_agreement": "Kollektivavtal",
            "user_employment.section_contract_text": "Avtalstext",
            "user_employment.section_contract_text_hint": "Textfält som används som underlag för anställningsavtal och intern dokumentation.",
            "user_employment.employment_instructions": "Befattningsinstruktion",
            "user_employment.employment_allowance": "Ersättning",
            "user_employment.notes": "Anteckningar",
            "user_employment.other": "Annat",
            "user_employment.section_signature": "Signatur och betalning",
            "user_employment.section_signature_hint": "Signerings- och betalningsunderlag för anställningsavtalet.",
            "user_employment.signed_place": "Signeringsort",
            "user_employment.signed_at": "Signeringsdatum",
            "user_employment.account_number": "Kontonummer",
            "user_employment.hourly_costs_title": "Timpriser och kostnader",
            "user_employment.section_contract_actions": "Anställningsavtal",
            "user_employment.section_contract_actions_hint": "Utskrift och signering använder avtalsunderlaget när PDF/signering finns tillgängligt.",
            "user_employment.contract_actions_notice_title": "Redo för nästa fas",
            "user_employment.contract_actions_notice": "Dataunderlaget kan nu fyllas i. Utskrift av anställningsavtal och Posten-signering kopplas på i separat implementation.",
            "user_employment.print_contract": "Skriv ut anställningsavtal",
            "user_employment.print_contract_unavailable": "PDF-rutt för anställningsavtal är inte ansluten ännu.",
            "user_employment.send_to_signing": "Skicka för signering",
            "user_employment.signing_unavailable": "Posten-signering implementeras av separat agent.",
            "user_employment.contract_title": "Anställningsavtal",
            "user_employment.contract_description": "Anställningsavtal för digital signering",
            "user_employment.preview_contract_draft": "Förhandsvisa utkast till anställningsavtal",
            "user_employment.download_contract_draft_pdf": "Ladda ner PDF-utkast",
            "user_employment.draft_pdf_download_failed": "Kunde inte ladda ner PDF-utkast.",
            "user_employment.contract_draft_label": "Utkast",
            "user_employment.contract_draft_for": "För {{name}}",
            "user_employment.draft_notice_title": "Kontrollera före signering",
            "user_employment.draft_notice": "Detta är en förhandsvisning baserad på sparade och ifyllda fält i formuläret. Spara ändringar innan du skickar för signering.",
            "user_employment.employee_name": "Arbetstagare",
            "signing.title": "Digital signering",
            "signing.description": "Skicka dokumentet till Posten Signering och följ signeringsstatus.",
            "signing.new_request": "Ny signeringsförfrågan",
            "signing.empty": "Inga signeringsförfrågningar har skapats ännu.",
            "signing.sender_reference": "Referens",
            "signing.signer_name": "Signerarnamn",
            "signing.national_identity_number": "Personnummer / D-nummer",
            "signing.email": "E-post",
            "signing.mobile": "Mobil",
            "signing.identity_warning": "Använd personnummer/D-nummer när det finns. E-post/SMS-signering är giltig, men Promang måste då verifiera att rätt person signerade.",
            "signing.send": "Skicka för signering",
            "signing.created": "Signeringsförfrågan skapad",
            "signing.refreshed": "Signeringsstatus uppdaterad",
            "signing.refresh_status": "Uppdatera status",
            "signing.download_signed": "Ladda ner signerad PDF",
            "signing.errors.load_failed": "Kunde inte hämta signeringsförfrågningar.",
            "signing.errors.create_failed": "Kunde inte skapa signeringsförfrågan.",
            "signing.errors.poll_failed": "Kunde inte uppdatera signeringsstatus.",
            "signing.errors.dispatch_unconfirmed": "Signeringen kunde inte bekräftas. Starta en ny förfrågan.",
            "signing.errors.activation_failed": "Avtalet kunde inte aktiveras från det signerade dokumentet.",
            "signing.errors.download_failed": "Kunde inte ladda ner signerat dokument.",
            "signing.status.draft": "Utkast",
            "signing.status.queued": "I kö",
            "signing.status.sent": "Skickad",
            "signing.status.in_progress": "Pågår",
            "signing.status.completed": "Slutförd",
            "signing.status.failed": "Misslyckades",
            "signing.status.rejected": "Avvisad",
            "signing.status.expired": "Utgången",
            "signing.status.cancelled": "Avbruten",
            "signing.status.waiting": "Väntar",
            "signing.status.available": "Tillgänglig",
            "signing.status.signed": "Signerad",
            "webpage.editor.open_live": "Visa live",
            "webpage.editor.open_live_title": "Öppna sidan i webbutiken (ny flik)",
            "webpage.editor.open_live_title_unpublished":
              "Öppna webbutiks-URL:en. Publicera sidan så att kunder kan se innehållet.",
            "webpage.editor.import_blocks": "JSON / AI",
            "webpage.editor.import_tooltip": "Klistra in JSON-block eller kopiera AI-instruktion",
            "webpage.editor.import_dialog_title": "Importera block eller AI-guide",
            "webpage.editor.import_tab_paste": "Klistra in JSON",
            "webpage.editor.import_tab_guide": "AI-instruktion (kopiera)",
            "webpage.editor.import_hint":
              "JSON som { \"blocks\": [ ... ] }, rå array eller content.blocks. ```json ... ``` fungerar.",
            "webpage.editor.import_replace": "Ersätt alla block",
            "webpage.editor.import_append": "Lägg till längst ner",
            "webpage.editor.import_sample": "Infoga exempel",
            "webpage.editor.import_apply": "Bygg block",
            "webpage.editor.import_success": "Importerade {{count}} block. Glöm inte att spara sidan.",
            "webpage.editor.import_error_empty": "Ingen text att läsa.",
            "webpage.editor.import_error_invalid_json": "Ogiltig JSON.",
            "webpage.editor.import_error_no_blocks_array": "Förväntade blocks-array, rå array eller content.blocks.",
            "webpage.editor.import_error_no_valid_blocks": "Inga giltiga block (type måste vara text, image, header, section, button eller columns).",
            "webpage.editor.import_error_unknown": "Import misslyckades.",
            "webpage.editor.ai_guide_intro":
              "Kopiera texten nedan till din AI som systemprompt. Modellen ska svara med ren JSON utan markdown.",
            "webpage.editor.copy_ai_guide": "Kopiera AI-instruktion",
            "webpage.editor.ai_guide_copied": "Instruktion kopierad till urklipp",
            "webpage.editor.ai_guide_copy_failed": "Kunde inte kopiera (webbläsarrättigheter)",
            "webpage.editor.generate_with_ai": "Generera med ChatGPT",
            "webpage.editor.ai_apply_success": "AI lade till {{count}} block i editorn. Glöm inte att spara sidan.",
            "webpage.editor.ai_parse_error": "AI returnerade inte giltig sida-JSON. Försök igen eller klistra in JSON under fliken Klistra in JSON.",
            "histories.title": "Historik",
            "histories.subtitle": "Aktivitet och ändringar",
            "histories.last_updated": "Senast uppdaterad",
            "histories.last_edited": "Senast redigerad",
            "histories.by_prefix": "av",
            "histories.no_data": "Ingen data ännu",
            "histories.filter_action": "Filtrera på åtgärd",
            "histories.filter_all": "Alla",
            "histories.empty_filter": "Inga händelser för detta filter.",
            "histories.load_more": "Ladda mer",
            "histories.loading_more": "Laddar …",
            "histories.close": "Stäng",
            "histories.system_user": "Systemet",
            "histories.unknown_user": "Okänd",
            "histories.sync_changes_heading": "Synkmetadata",
            "histories.action.tripletex_retry": "köade ett nytt Tripletex-synkförsök för",
            "histories.tripletex_retry_pending": "Ett nytt synkförsök har köats. Detta bekräftar inte att synkroniseringen är slutförd.",
            "histories.action.tripletex_sync_attempt": "försökte Tripletex-synk för",
            "histories.action.tripletex_sync": "slutförde Tripletex-synk för",
            "histories.action.tripletex_sync_skipped": "skippade Tripletex-synk för",
            "histories.action.request_agreed_overtime": "begärde avtalad övertid på",
            "histories.action.confirm_agreed_overtime": "bekräftade avtalad övertid på",
            "histories.action.reject_agreed_overtime": "avslog avtalad övertid på",
            "histories.action.lock": "låste",
            "histories.action.unlock": "låste upp",
            "histories.action.not_approved_notification": "skickade e-post: inte godkänd för",
            "histories.action.approved_notification": "skickade e-post: godkänd för",
            "histories.action.send_email": "skickade protokoll till",
            "histories.outbound.not_approved": "Skickad e-post: inte godkänd",
            "histories.outbound.approved": "Skickad e-post: godkänd",
            "histories.deviation_scope.deviation": "Avvikelse · tidslinje",
            "histories.deviation_scope.project": "Projekt · tidslinje",
            "histories.deviation_scope.customer": "Kund · tidslinje",
            "deviation.work_order.label": "Arbetsorder",
            "deviation.work_order.link_dialog_title": "Koppla arbetsorder",
            "deviation.work_order.section_title": "Kopplad arbetsorder",
            "deviation.work_order.link_submit": "Spara",
            "deviation.work_order.link_open": "Koppla arbetsorder",
            "deviation.work_order.open_linked": "Öppna arbetsorder",
            "deviation.work_order.unlink": "Ta bort koppling",
            "deviation.work_order.change": "Byt",
            "deviation.work_order.mode_existing": "Välj befintlig",
            "deviation.work_order.mode_create": "Skapa ny",
            "deviation.work_order.existing_intro":
              "Endast arbetsorder utan annat kopplat avvik visas. Den arbetsorder som redan är kopplad till detta avvik kan väljas eller tas bort.",
            "deviation.work_order.create_intro":
              "Skapa en ny arbetsorder — den kopplas till detta avvik när du sparar.",
            "deviation.work_order.create_button": "Skapa arbetsorder",
            "deviation.work_order.linked_after_create":
              "Arbetsorder skapad och kopplad till avvikelsen",
            "deviation.work_order.link_failed_after_create":
              "Arbetsorder skapades men kunde inte kopplas till avvikelsen. Öppna avvikelsen och koppla arbetsordern manuellt.",
            "deviation.work_order.suggested_wo_title_full":
              "Avvikelse {{number}} · {{title}}",
            "deviation.work_order.suggested_wo_title_number_only":
              "Avvikelse {{number}}",
            "deviation.work_order.toast_saved": "Arbetsorder uppdaterad",
            "deviation.toast.save_failed": "Kunde inte spara",
            "deviation.toast.load_failed": "Kunde inte ladda avvikelsen",
            "deviation.toast.item_deleted": "Inlägget raderades",
            "deviation.form.description_required": "Beskrivning krävs",
            "deviation.form.consequence_required": "Konsekvens krävs",
            "deviation.form.date": "Avvikelsedatum",
            "deviation.form.reference": "Referens",
            "deviation.form.severity": "Allvarlighetsgrad",
            "deviation.print.report": "Skriv ut rapport",
            "deviation.print.download": "Ladda ner",
            "deviation.status_updates_title": "Uppdatering",
            "deviation.drawing_documents_description":
              "Bilder och ritningssnapshots kopplade till avvikelsen (samma pin-grupper som i Ritningar).",
            "deviation.perform_work.title": "Utför arbete",
            "deviation.perform_work.intro":
              "Skapa en arbetsorder kopplad till avvikelsen. Välj när arbetet ska utföras – utan tung administration.",
            "deviation.perform_work.deviation_label": "Avvikelse",
            "deviation.perform_work.date_label": "Utförandedatum",
            "deviation.perform_work.date_today": "I dag",
            "deviation.perform_work.date_tomorrow": "I morgon",
            "deviation.perform_work.date_custom": "Valt datum",
            "deviation.perform_work.date_pick": "Datum",
            "deviation.perform_work.date_preview": "Arbetsordern sätts till {{date}}.",
            "deviation.perform_work.submit": "Utför arbete",
            "deviation.perform_work.submitting": "Skapar…",
            "deviation.perform_work.success": "Arbetsorder skapad och kopplad till avvikelsen",
            "deviation.perform_work.error": "Kunde inte skapa arbetsorder från avvikelsen",
            "deviation.form.work_order_heading": "Arbetsorder från avvikelse",
            "deviation.form.work_order_mode_none": "Inte kopplad",
            "deviation.form.work_order_mode_existing": "Välj befintlig",
            "deviation.form.work_order_mode_create": "Skapa ny",
            "deviation.form.work_order_create_timing_intro": "Hur ska uppdraget starta?",
            "deviation.form.work_order_perform_now": "Arbete görs nu",
            "deviation.form.work_order_plan_later": "Arbete ska planeras",
            "deviation.form.work_order_perform_now_help":
              "Arbetsorder skapas från avvikelsens rubrik och beskrivning, kopplas till avvikelsen, och ett kalender-/uppdragsevenemang skapas för vald utförare – nu, i 2 timmar.",
            "deviation.form.work_order_plan_later_help":
              "Avvikelsen sparas. Du fortsätter för att skapa arbetsorder; den kopplas till avvikelsen när du sparar den nya ordern.",
            "deviation.form.executor_label": "Utföraren av uppdraget",
            "deviation.form.executor_pick": "Välj utförare",
            "deviation.form.executor_hint": "Händelsen knyts till den här användaren.",
            "deviation.form.executor_dialog_help":
              "Personen som ska stå för uppdraget när arbete görs nu.",
            "deviation.form.need_project_customer_for_work_order":
              "Välj projekt och kund för avvikelsen innan du skapar eller skjuter upp arbetsorder här.",
            "deviation.form.work_order_create_failed": "Kunde inte skapa arbetsorder.",
            "deviation.form.event_creation_failed":
              "Arbetsorden skapades men händelsen kunde inte skapas automatiskt — lägg till den manuellt på arbetsordern.",
            "deviation.form.work_order_and_event_saved":
              "Arbetsorder och händelse skapades och kopplades till avvikelsen.",
            "deviation.form.saved": "Sparat",
            "deviation.form.save_failed": "Något gick fel vid sparning.",
            "deviation.form.default_wo_title": "Avvikelse – arbetsorder",
            "deviation.settings.hub_tab": "Avvikelseavisering",
            "deviation.settings.title": "Avvikelseavisering",
            "deviation.settings.hub_intro":
              "Välj om avvikelseaviseringar skickas direkt eller samlas i ett e-postmeddelande per dag. Du kan också styra om avsändaren får kopia.",
            "deviation.settings.load_failed": "Kunde inte läsa inställningar för avvikelseavisering",
            "deviation.settings.saved": "Inställningar sparade",
            "deviation.settings.save_failed": "Kunde inte spara inställningar för avvikelseavisering",
            "deviation.settings.send_mode.title": "Utskick",
            "deviation.settings.send_mode.description": "Bestäm när e-post om avvikelser skickas till mottagarna.",
            "deviation.settings.send_mode.immediate": "Skicka direkt",
            "deviation.settings.send_mode.immediate_help": "Mottagarna får e-post så snart avvikelsen skickas.",
            "deviation.settings.send_mode.digest": "Samling",
            "deviation.settings.send_mode.digest_help":
              "Avvikelser samlas per mottagare och skickas en gång per dag efter valt klockslag (Europe/Oslo). Nya avvikelser efter dagens utskick väntar till nästa dag.",
            "deviation.settings.digest_hour": "Skicka samling kl. (Europe/Oslo)",
            "deviation.settings.copy_sender.title": "Kopia till avsändaren",
            "deviation.settings.copy_sender.description": "Välj om den som skickar avvikelsen också ska få e-post.",
            "deviation.settings.copy_sender.toggle": "Skicka kopia till avsändaren",
            "deviations.list.notified_none": "Inga utskick gjorda",
            "deviations.list.notified_compact_suffix": " (+{{count}})",
      
            "Dashboard": "Dashboard",
            "Overview of your workspace": "Översikt över ditt arbetsområde",
            "Collapse": "Dölj",
            "Expand": "Visa",
            "case": "Ärende",
            "Resource Hub": "Resurscenter",
            "resource_hub.faq.linked_records_title": "Länkade resurser",
            "resource_hub.faq.linked_records_help":
              "Koppla inlägget till andra poster (HMS/KS-dokument, fordon, produkt, rapport, kund, projekt). Välj typ och sök fram posten — du behöver inte skriva in numeriskt ID. För HMS/KS: skriv minst två tecken i sökfältet.",
            "resource_hub.faq.linked_records_add": "Lägg till länk",
            "resource_hub.faq.linked_records_type": "Resurstyp",
            "resource_hub.faq.linked_records_id": "ID",
            "resource_hub.faq.linked_records_pick": "Sök och välj …",
            "resource_hub.faq.linked_records_existing": "Titel (sparad)",
            "resource_hub.faq.link_type.hse_document": "HMS / KS-dokument",
            "resource_hub.faq.link_type.vehicle": "Fordon",
            "resource_hub.faq.link_type.product": "Produkt",
            "resource_hub.faq.link_type.report": "Rapport",
            "resource_hub.faq.link_type.customer": "Kund",
            "resource_hub.faq.link_type.project": "Projekt",
            "resource_hub.faq.linked_records_placeholder_type": "Välj typ",
            "service.agreements.list.title": "Serviceavtal",
            "service.agreements.list.hero_kicker": "Service",
            "service.agreements.list.subtitle":
              "Sök, filtrera på vy och hantera återkommande serviceavtal.",
            "service.agreements.list.meta.total": "Avtal",
            "service.agreements.list.meta.new": "Nya",
            "service.agreements.list.new": "Nytt avtal",
            "service.agreements.list.filters_heading": "Filter",
            "service.agreements.list.filters_description":
              "Förfina listan med sök och fördefinierade vyer.",
            "service.agreements.list.search_placeholder": "Sök avtal …",
            "service.agreements.list.sort_label": "Sortering",
            "service.agreements.list.per_page": "Per sida",
            "service.agreements.list.table_kicker": "Lista",
            "service.agreements.list.table_title": "Avtal",
            "service.agreements.list.table_description":
              "Markera rader för massåtgärder i verktygsfältet ovan.",
            "service.agreements.list.empty": "Inga serviceavtal hittades.",
            "service.agreements.list.empty_cancelled":
              "Inga annullerade avtal hittades.",
            "service.agreements.list.load_error":
              "Kunde inte hämta serviceavtal.",
            "service.agreements.list.retry": "Försök igen",
            "service.agreements.filter.view": "Vy",
            "service.agreements.filter.kind": "Avtalstyp",
            "service.agreements.filter.kind_framework": "Ramavtal",
            "service.agreements.filter.kind_service": "Serviceavtal",
            "service.agreements.view.service_soon": "Service snart (5 dagar)",
            "service.agreements.view.active": "Aktiva",
            "service.agreements.view.cancelled": "Annullerade",
            "service.agreements.view.cancelled_hint":
              "Öppna ett annullerat avtal för att återaktivera det.",
            "service.agreements.form.errors_summary":
              "Formuläret har fel — rätta dem innan sparning.",
            "service.agreements.create_reports.title":
              "Skapa uppdrag för {{count}} valda anläggningar",
            "service.agreements.create_reports.settings_heading":
              "Inställningar för uppdrag",
            "service.agreements.create_reports.settings_body":
              "Detta skapar {{count}} uppdrag för valda anläggningar med inställningarna nedan. Misslyckas en anläggning sparas inga (all-or-nothing).",
            "service.agreements.create_reports.single_report_label":
              "En gemensam rapport (checklistepunkter per anläggning)",
            "service.agreements.create_reports.single_report_help":
              "På: en rapport med checklistepunkter för varje vald anläggning. Av: separata rapporter per anläggning.",
            "service.agreements.create_reports.checklist_type": "Checklistetyp",
            "service.agreements.create_reports.checklist_type_help":
              "Valfri checklistetyp skapar checklistor automatiskt för rapporterna.",
            "service.agreements.create_reports.description_label":
              "Beskrivningsmall",
            "service.agreements.create_reports.description_placeholder":
              "Valfri beskrivning för uppdragen…",
            "service.agreements.create_reports.description_help":
              "Beskrivningen används för alla skapade uppdrag.",
            "service.agreements.create_reports.single_mode_heading":
              "En-rapports-läge",
            "service.agreements.create_reports.single_mode_body":
              "Checklistepunkter skapas per vald anläggning med formatet «{{reportType}}: [Anläggning] - [Adress]».",
            "service.agreements.create_reports.report_type_fallback": "Rapporttyp",
            "service.agreements.create_reports.submit":
              "Skapa {{count}} uppdrag",
            "service.agreements.sort.next_service_asc":
              "Nästa service — tidigast först",
            "service.agreements.sort.next_service_desc":
              "Nästa service — senast först",
            "service.agreements.sort.created_desc": "Skapad — nyast först",
            "service.agreements.sort.created_asc": "Skapad — äldst först",
            "service.agreements.table.col_title": "Titel",
            "service.agreements.table.col_type": "Typ",
            "service.agreements.table.col_project": "Projekt",
            "service.agreements.table.col_customer": "Kund",
            "service.agreements.table.col_delivery": "Leveransadress",
            "service.agreements.table.col_next": "Nästa service",
            "service.agreements.table.col_interval": "Intervall",
            "service.agreements.table.col_status": "Status",
            "service.agreements.table.col_days": "Dagar till service",
            "service.agreements.table.missing_address": "Ingen leveransadress",
            "service.agreements.table.col_next_job": "Nästa uppdrag",
            "service.agreements.next_job.section_title": "Nästa uppdrag",
            "service.agreements.next_job.next_on": "Nästa uppdrag ska utföras",
            "service.agreements.next_job.days_until":
              "Det är {{count}} dagar till nästa uppdrag.",
            "service.agreements.next_job.in_progress": "Uppdrag pågår",
            "service.agreements.actions.missing_type":
              "Typ saknas; avtalet kan inte utföras",
            "service.agreements.actions.create_report": "Skapa ny rapport",
            "service.agreements.actions.create_order": "Skapa order",
            "service.agreements.actions.go_to_report": "Öppna rapport",
            "service.agreements.actions.hint_create_report":
              "En ny rapport skapas. När uppdraget är klart sätts nästa servicedatum utifrån slutförandedatum.",
            "service.agreements.actions.hint_create_order":
              "En ny order skapas och nästa servicedatum sätts automatiskt.",
            "service.agreements.actions.prompt_report_title": "Skapa ny rapport",
            "service.agreements.actions.prompt_report_body":
              "Vill du skapa en ny rapport för detta serviceavtal?",
            "service.agreements.actions.prompt_order_title": "Skapa ny order",
            "service.agreements.actions.prompt_order_body":
              "Vill du skapa en ny order för detta serviceavtal?",
            "service.agreements.actions.err_no_agreement":
              "Kan inte skapa utan serviceavtal",
            "service.agreements.actions.err_active_report_report":
              "Kan inte skapa rapport medan en rapport redan är aktiv",
            "service.agreements.actions.err_active_report_order":
              "Kan inte skapa order medan en rapport redan är aktiv",
            "service.agreements.actions.err_no_customer_report":
              "Kan inte skapa rapport utan kund",
            "service.agreements.actions.err_no_customer_order":
              "Kan inte skapa order utan kund",
            "service.agreements.actions.err_invalid_address":
              "Kan inte skapa order eller rapport utan giltig leveransadress med land.",
            "service.agreements.actions.err_cancelled":
              "Annullerade avtal kan inte skapa uppdrag eller ordrar.",
            "service.agreements.actions.err_no_orderlines":
              "Kan inte skapa order utan orderrader. Lägg till rader under orderrader-fliken.",
            "service.agreements.actions.creating": "Skapar…",
            "service.agreements.actions.cancelled": "Annullerad",
            "service.agreements.actions.reactivated": "Avtalet är aktivt igen.",
            "service.agreements.actions.cancel_failed": "Kunde inte annullera serviceavtalet.",
            "service.agreements.actions.load_failed": "Kunde inte läsa in serviceavtalet.",
            "service.agreements.actions.reactivate_failed": "Kunde inte återaktivera serviceavtalet.",
            "service.agreements.actions.cancel": "Annullera",
            "service.agreements.actions.reactivate": "Återaktivera",
            "service.agreements.actions.cancel_prompt_title": "Annullera serviceavtal",
            "service.agreements.actions.cancel_prompt_body":
              "Är du säker på att du vill annullera detta serviceavtal?",
            "service.agreements.actions.reactivate_prompt_title": "Återaktivera serviceavtal",
            "service.agreements.actions.reactivate_prompt_body":
              "Är du säker på att du vill aktivera detta serviceavtal igen?",
            "service.agreements.header.status": "Status",
            "service.agreements.header.notes": "Anteckningar",
            "service.agreements.header.history": "Historik",
            "service.agreements.actions.export_pdf": "Exportera PDF",
            "service.agreements.actions.pdf_exporting": "Skapar PDF…",
            "service.agreements.actions.pdf_failed": "Kunde inte skapa PDF",
            "service.agreements.documents.pdf_only": "Endast PDF-filer är tillåtna",
            "service.agreements.multi_edit.title":
              "Massredigera {{count}} avtal",
            "service.agreements.multi_edit.subtitle":
              "Endast avtalsfält ändras. Uppdrag och produkter påverkas inte.",
            "service.agreements.multi_edit.selected_heading": "Valda avtal",
            "service.agreements.multi_edit.fields_heading": "Fält som ändras",
            "service.agreements.multi_edit.field.interval": "Serviceintervall",
            "service.agreements.multi_edit.field.unchanged": "Oförändrat",
            "service.agreements.multi_edit.unchanged_hint":
              "Tomma fält förblir oförändrade på alla valda avtal.",
            "service.agreements.multi_edit.confirm_title": "Bekräfta massredigering",
            "service.agreements.multi_edit.confirm_body":
              "Du håller på att uppdatera {{count}} avtal. Ändringen kan inte ångras automatiskt.",
            "service.agreements.multi_edit.back": "Tillbaka",
            "service.agreements.multi_edit.saving": "Sparar avtal…",
            "service.agreements.multi_edit.success": "Avtalen uppdaterades.",
            "service.agreements.multi_edit.success_detail":
              "Uppdaterade {{ok}} av {{total}} (misslyckades: {{fail}}).",
            "service.agreements.multi_edit.error.save":
              "Kunde inte spara massredigeringen. Urvalet behålls.",
            "service.agreements.multi_edit.error.empty_selection":
              "Inga avtal är valda.",
            "service.agreements.multi_edit.error.no_fields":
              "Välj minst ett fält som ska ändras.",
            "service.agreements.tabs.details": "Detaljer",
            "service.agreements.tabs.edit": "Redigera",
            "service.agreements.tabs.documents": "Dokument",
            "service.agreements.tabs.signing": "Signering",
            "service.agreements.tabs.orderlines": "Orderrader",
            "service.agreements.tabs.reports": "Uppdrag",
            "service.agreements.tabs.orders": "Ordrar",
            "service.agreements.signing.document_title": "Serviceavtal {{number}}",
            "service.agreements.signing.non_sensitive_title": "Serviceavtal",
            "service.agreements.subs.designation_required": "Beteckning krävs",
            "service.agreements.badge.framework": "Ramavtal",
            "service.agreements.badge.service": "Serviceavtal",
            "service.agreements.address.incomplete_banner":
              "Leveransadressen är ofullständig. Fullständig adress med land krävs innan order och rapport kan skapas.",
            "service.agreements.table.incomplete_address": "Saknar land",
            "delivery_address.country": "Land",
            "delivery_address.country_required": "Land krävs",
            "delivery_address.country_hint":
              "Krävs för Tripletex-fraktsedel och order.",
            "delivery_address.edit": "Redigera adress",
            "delivery_address.edit_title": "Redigera leveransadress",
            "delivery_address.edit_load_error": "Kunde inte läsa leveransadressen.",
            "service.agreements.form.section_type": "Avtalstyp",
            "service.agreements.form.section_type_help":
              "Ett ramavtal kan omfatta flera anläggningar.",
            "service.agreements.form.is_framework": "Detta är ett ramavtal",
            "service.agreements.form.is_framework_help":
              "Använd ramavtal när flera anläggningar täcks av samma avtal.",
            "service.agreements.form.vat_included": "Priser inklusive moms",
            "service.agreements.form.section_parties": "Parter",
            "service.agreements.form.invoice_to_project": "Fakturera till projektkund",
            "service.agreements.form.customer": "Kund",
            "service.agreements.form.invoice_customer": "Fakturakund",
            "service.agreements.form.project": "Projekt",
            "service.agreements.form.system": "Anläggning",
            "service.agreements.form.customer_required": "Kund krävs",
            "service.agreements.form.order_date_required": "Orderdatum krävs",
            "service.agreements.form.type_required": "Typ krävs",
            "service.agreements.form.save_failed": "Kunde inte spara avtalet. Försök igen.",
            "service.agreements.modal.create": "Skapa serviceavtal",
            "service.agreements.modal.update": "Uppdatera serviceavtal",
            "service.reports.edit.actions": "Åtgärder",
            "company.users.roles.has_access": "Har åtkomst",
            "service.agreements.form.section_period": "Avtalsperiod",
            "service.agreements.form.section_period_help":
              "Från startdatum med valfri längd, uppsägning och automatisk förlängning.",
            "service.agreements.form.order_date": "Orderdatum",
            "service.agreements.form.start_date": "Avtalet startar",
            "service.agreements.form.duration_years": "Längd (år)",
            "service.agreements.form.notice_months": "Uppsägning (månader)",
            "service.agreements.form.period_end": "Slutdatum",
            "service.agreements.form.auto_renew": "Automatisk förlängning med 1 år",
            "service.agreements.form.section_discount": "Rabatavtal",
            "service.agreements.form.section_discount_help":
              "Avtalsrabatt för reservdelar, tjänster eller generellt.",
            "service.agreements.form.discount_percent": "Generell rabatt %",
            "service.agreements.form.discount_parts": "Rabatt reservdelar %",
            "service.agreements.form.discount_services": "Rabatt tjänster %",
            "service.agreements.form.section_prices": "Priser",
            "service.agreements.form.offer_price": "Belopp per intervall",
            "service.agreements.form.hourly_rate": "Timpris",
            "service.agreements.form.callout_fee": "Utryckning",
            "service.agreements.form.parts_markup": "Påslag material %",
            "service.agreements.form.subcontractor_markup": "Påslag underleverantör %",
            "service.agreements.form.section_address": "Leveransadress",
            "service.agreements.form.section_address_help":
              "Fullständig adress med land. Krävs före order och rapport.",
            "service.agreements.form.delivery_address": "Leveransadress",
            "service.agreements.form.section_contacts": "Kontaktpersoner",
            "service.agreements.form.section_contacts_help":
              "Flera kontakter hos kund och leverantör. Markera en huvudkontakt för signering.",
            "service.agreements.form.section_text": "Avtalstext",
            "service.agreements.form.short_description": "Kort beskrivning",
            "service.agreements.form.agreement_text": "Avtalets innehåll",
            "service.agreements.form.agreement_text_placeholder":
              "Beskriv vad avtalet omfattar …",
            "service.agreements.form.conditions": "Villkor",
            "service.agreements.form.conditions_placeholder":
              "KPI-reglering, tillträde, arbetsmiljö, ansvar …",
            "service.agreements.contacts.empty": "Inga kontaktpersoner är tillagda ännu.",
            "service.agreements.contacts.contact_required": "Välj en kundkontakt",
            "service.agreements.contacts.employee_required": "Välj en anställd",
            "service.agreements.contacts.party.customer": "Kund",
            "service.agreements.contacts.party.supplier": "Leverantör",
            "service.agreements.contacts.primary": "Huvudkontakt",
            "service.agreements.contacts.employee": "Anställd",
            "service.agreements.contacts.contact": "Kontakt",
            "service.agreements.contacts.role": "Roll / titel",
            "service.agreements.contacts.role_placeholder": "VD, ordförande …",
            "service.agreements.contacts.add_customer": "Lägg till kundkontakt",
            "service.agreements.contacts.add_supplier": "Lägg till leverantörkontakt",
            "service.agreements.info.overview": "Översikt",
            "service.agreements.info.overview_help": "Parter, typ och ramavtal.",
            "service.agreements.info.type": "Typ",
            "service.agreements.info.contacts": "Kontaktpersoner",
            "service.agreements.info.description": "Beskrivning",
            "service.agreements.info.agreement_text": "Avtalstext",
            "service.agreements.info.discount": "Rabatavtal",
            "service.agreements.info.interval": "Intervall",
            "service.agreements.info.next_date": "Nästa service",
            "service.agreements.info.days_until": "Dagar till nästa",
            "service.agreements.info.last_service": "Föregående service",
            "service.agreements.info.vat_included": "Inkl. moms",
            "service.agreements.form.section_type_hint":
              "Avtalstypen styrer bland annat om uppdrag skapas som rapport (mission).",
            "service.agreements.form.vat_included_hint":
              "Markera om beloppen i avtalet inkluderar moms.",
            "service.agreements.form.interval_hint":
              "Styr nästa servicedatum. Vid intervall per orderrad gäller det rader som följer avtalet.",
            "service.agreements.form.duration_years_hint":
              "Avtalsperiod i hela år, tillsammans med uppsägning och automatisk förlängning.",
            "service.agreements.form.notice_months_hint":
              "Hur många månader före utgång avtalet måste sägas upp.",
            "service.agreements.form.auto_renew_hint":
              "När perioden är slut förlängs avtalet automatiskt med ett år om det inte sagts upp.",
            "service.agreements.form.section_discount_hint":
              "Sammanfattningsrabatt överst, och egna rabattsatser per kategori, produkt eller fritext under.",
            "service.agreements.form.discount_percent_hint":
              "Generell rabattsats för avtalet. Använd raderna under för mer precisa satser.",
            "service.agreements.form.section_prices_help":
              "Avtalade priser med eget intervall. Orderrader under fliken kopieras fortfarande till rapport och order.",
            "service.agreements.form.section_prices_hint":
              "Prisrader är avtalspriser. De kopieras inte automatiskt till order.",
            "service.agreements.form.offer_price_hint":
              "Totalt belopp per serviceintervall. Använd prisrader om du har flera belopp med olika intervall.",
            "service.agreements.form.hourly_rate_hint": "Avtalat timpris för servicearbete.",
            "service.agreements.form.callout_fee_hint": "Fast belopp för utryckning.",
            "service.agreements.form.parts_markup_hint": "Påslag i procent på material och reservdelar.",
            "service.agreements.form.subcontractor_markup_hint":
              "Påslag i procent på underleverantörer och inköpta tjänster.",
            "service.agreements.price_lines.help":
              "Flera prisrader med olika intervall, till exempel årlig filterservice och kvartalsvis tillsyn.",
            "service.agreements.price_lines.hint":
              "Detta är avtalets kontraktspriser. De visas i PDF och ersätter inte orderrader som kopieras till rapport/order.",
            "service.agreements.price_lines.empty": "Inga prisrader är tillagda ännu.",
            "service.agreements.price_lines.line": "Prisrad",
            "service.agreements.price_lines.title": "Beskrivning",
            "service.agreements.price_lines.amount": "Belopp",
            "service.agreements.price_lines.interval": "Intervall",
            "service.agreements.price_lines.product": "Produkt (valfritt)",
            "service.agreements.price_lines.description": "Tilläggsbeskrivning",
            "service.agreements.form.interval_mode": "Intervall gäller",
        "service.agreements.form.interval_mode_agreement": "Hela avtalet",
        "service.agreements.form.interval_mode_per_line": "Per orderrad",
        "service.agreements.form.interval_mode_hint": "Hela avtalet: ett intervall styr nästa servicedatum. Per rad: varje orderrad har eget nästa datum, och ett besök tar med alla rader som förfaller inom 30 dagar.",
        "service.agreements.info.line_next": "Nästa",
        "service.agreements.info.line_last": "Senast",
        "service.agreements.info.line_next_visit": "Nästa besök",
        "service.agreements.info.line_in_active_report": "I pågående uppdrag",
        "service.agreements.lines.title": "Tjänster och produkter",
        "service.agreements.lines.subtitle": "Det som ingår i avtalet. Raderna visas i avtalet och PDF:en och kopieras till uppdrag och order när ”Med i uppdrag/order” är på.",
        "service.agreements.lines.product": "Produkt",
        "service.agreements.lines.pick_product": "Välj produkt …",
        "service.agreements.lines.item_number": "Art.nr.",
        "service.agreements.lines.change": "Byt",
        "service.agreements.lines.choose": "Välj",
        "service.agreements.lines.service_placeholder": "T.ex. Årlig kontroll av ventilation",
        "service.agreements.lines.quantity": "Antal",
        "service.agreements.lines.unit_price": "Styckpris",
        "service.agreements.lines.discount": "Rabatt %",
        "service.agreements.lines.total": "Summa",
        "service.agreements.lines.description": "Beskrivning",
        "service.agreements.lines.add_description": "Lägg till beskrivning",
        "service.agreements.lines.add_service": "Lägg till tjänst",
        "service.agreements.lines.add_product": "Lägg till produkt",
        "service.agreements.lines.move_up": "Flytta upp",
        "service.agreements.lines.move_down": "Flytta ner",
        "service.agreements.lines.remove": "Ta bort rad",
        "service.agreements.lines.empty_title": "Inga rader ännu",
        "service.agreements.lines.empty_body": "Lägg till tjänsterna och produkterna som avtalet omfattar.",
        "service.agreements.lines.sum_jobs": "Med i uppdrag/order",
        "service.agreements.lines.sum_all": "Summa avtal exkl. moms",
        "service.agreements.lines.error_product": "Välj en produkt eller byt till tjänst.",
        "service.agreements.lines.error_title": "Beskriv tjänsten.",
        "service.agreements.lines.error_quantity": "Antal måste vara större än 0.",
        "service.agreements.lines.error_price": "Pris måste vara ett tal, 0 eller mer.",
        "service.agreements.lines.error_discount": "Rabatt måste vara mellan 0 och 100.",
        "Monthly": "Månadsvis",
        "Yearly (12 months)": "Årlig (12 månader)",
        "Half Yearly (6 months)": "Halvårsvis (6 månader)",
        "Quarterly (3 months)": "Kvartalsvis (3 månader)",
        "Every 8 Months": "Var 8:e månad",
        "Every 10 Months": "Var 10:e månad",
        "Every 2 Years": "Vartannat år",
        "Every 3 Years": "Vart 3:e år",
        "Every 4 Years": "Vart 4:e år",
        "Every 5 Years": "Vart 5:e år",
        "service.agreements.lines.mode_agreement_hint": "Ett intervall för hela avtalet. Rader kan ändå visa eget intervall i avtalet.",
        "service.agreements.lines.mode_per_line_hint": "Varje rad har eget nästa datum. Ett besök tar med rader som förfaller inom 30 dagar, och bara de kopieras till uppdrag och order.",
        "service.agreements.lines.type": "Typ",
        "service.agreements.lines.type_product": "Produkt",
        "service.agreements.lines.type_service": "Tjänst",
        "service.agreements.lines.service_title": "Tjänst",
        "service.agreements.lines.interval": "Intervall",
        "service.agreements.lines.follows_agreement": "Följer avtalet",
        "service.agreements.lines.next_service_date": "Nästa service",
        "service.agreements.lines.next_service_date_hint": "Beräknas automatiskt. Ändra bara för att flytta raden.",
        "service.agreements.lines.next_service_date_new": "Tomt: sätts från avtalets startdatum.",
        "service.agreements.lines.include_in_jobs": "Med i uppdrag/order",
        "service.agreements.lines.include_in_jobs_hint": "Av: visas i avtalet och PDF, men kopieras inte till uppdrag eller faktura.",
        "service.agreements.lines.contract_only": "Endast i avtalet",
        "service.agreements.lines.form_pointer": "Tjänster, produkter och priser läggs in under fliken Orderrader, där du också väljer intervall per rad.",
            "service.agreements.price_lines.add": "Lägg till prisrad",
            "service.agreements.price_lines.title_required": "Beskrivning krävs",
            "service.agreements.price_lines.amount_invalid": "Belopp måste vara ett tal",
            "service.agreements.price_lines.quantity_invalid": "Antal måste vara ett tal",
            "service.agreements.discount_lines.label_required": "Beskrivning krävs",
            "service.agreements.discount_lines.percent_required": "Rabattprocent krävs",
            "service.agreements.discount_lines.percent_invalid": "Rabattprocent måste vara ett tal",
            "service.agreements.discount_lines.category_required": "Välj en produktkategori",
            "service.agreements.discount_lines.product_required": "Välj en produkt",
            "service.agreements.discount_lines.help":
              "Rabattsats per produktkategori, enskild produkt eller som fritext.",
            "service.agreements.discount_lines.hint":
              "Välj kategori eller produkt från registret, eller skriv in vad rabatten gäller.",
            "service.agreements.discount_lines.empty": "Inga rabattsatser är tillagda ännu.",
            "service.agreements.discount_lines.label": "Gäller (fritext)",
            "service.agreements.discount_lines.percent": "Rabatt %",
            "service.agreements.discount_lines.category": "Produktkategori",
            "service.agreements.discount_lines.product": "Produkt",
            "service.agreements.discount_lines.add": "Lägg till rabattsats",
            "service.agreements.discount_lines.kind.manual": "Fritext",
            "service.agreements.discount_lines.kind.category": "Kategori",
            "service.agreements.discount_lines.kind.product": "Produkt",
            "service.agreements.guide.title": "Guide för serviceavtal",
            "service.agreements.guide.open": "Guide",
            "service.agreements.guide.tab": "Så använder du avtalet",
            "service.agreements.guide.items.kind.title": "Serviceavtal eller ramavtal",
            "service.agreements.guide.items.kind.body":
              "Ramavtal används när flera anläggningar hos kunden täcks. Markera ramavtal och lägg till inkluderade anläggningar.",
            "service.agreements.guide.items.interval.title": "Intervall och nästa service",
            "service.agreements.guide.items.interval.body":
              "Avtalets intervall styr nästa servicedatum och när uppdrag skapas. Prisrader kan ha andra intervall utan att ändra detta.",
            "service.agreements.guide.items.price_lines.title": "Prisrader",
            "service.agreements.guide.items.price_lines.body":
              "Avtalade belopp med eget intervall, till exempel årligt avtalspris och kvartalsvis tillsyn. Visas i PDF.",
            "service.agreements.guide.items.discount_lines.title": "Rabattsatser",
            "service.agreements.guide.items.discount_lines.body":
              "Sätt rabatt på kategori, produkt eller som fritext. Sammanfattningsfälten är generell rabatt på delar och tjänster.",
            "service.agreements.guide.items.address.title": "Leveransadress",
            "service.agreements.guide.items.address.body":
              "Fullständig adress med land krävs innan order och rapport kan skapas.",
            "service.agreements.guide.items.contacts.title": "Kontaktpersoner",
            "service.agreements.guide.items.contacts.body":
              "Lägg till flera kontakter hos kund och leverantör. Huvudkontakt används för signering i PDF.",
            "service.agreements.guide.items.orderlines.title": "Orderrader",
            "service.agreements.guide.items.orderlines.body":
              "Fliken Orderrader är operativt innehåll som kopieras till rapport och order. Det är inte samma sak som avtalspriserna.",
            "service.agreements.setup.tab": "Kom igång",
            "service.agreements.setup.blocked":
              "Du kan inte skapa avtal innan minst en avtalstyp finns under Service → Inställningar.",
            "service.agreements.setup.intro":
              "Kontrollera att inställningar är på plats innan du skapar avtal. Avtalstyper krävs. Rapporttyper rekommenderas.",
            "service.agreements.setup.open_settings": "Öppna inställningar",
            "service.agreements.setup.open_guide": "Öppna setup-guide",
            "service.agreements.setup.count": "{{count}} registrerade",
            "service.agreements.setup.steps.agreement_types.title": "Avtalstyper",
            "service.agreements.setup.steps.agreement_types.body":
              "Minst en avtalstyp måste finnas. Typen väljs på avtalet och kan styra om uppdrag är rapport (mission).",
            "service.agreements.setup.steps.report_types.title": "Rapporttyper",
            "service.agreements.setup.steps.report_types.body":
              "Rekommenderas: skapa rapporttyper som används när serviceuppdrag skapas från avtalet.",
            "service.agreements.setup.steps.linked_report_type.title": "Koppla rapporttyp till avtalstyp",
            "service.agreements.setup.steps.linked_report_type.body":
              "Avtalstyper markerade som uppdrag (mission) bör ha en rapporttyp, annars kan nya uppdrag sakna mall.",
            "service.agreements.next_date.section_title": "Nästa servicedatum",
            "service.agreements.next_date.section_help":
              "Flytta datumet framåt eller bakåt, eller ändra intervallet som beräknar nästa service.",
            "service.agreements.next_date.section_hint":
              "Detta påverkar nästa uppdrag. Prisradernas intervall ändras inte här.",
            "service.agreements.next_date.edit_date": "Redigera datum",
            "service.agreements.next_date.edit_interval": "Redigera intervall",
            "service.agreements.next_date.edit_date_title": "Redigera nästa servicedatum",
            "service.agreements.next_date.edit_interval_title": "Redigera intervall för nästa service",
            "service.agreements.next_job.section_hint":
              "Skapa rapport eller order för nästa service. Kräver giltig leveransadress med land.",
            "service.agreements.subs.title": "Inkluderade anläggningar",
            "service.agreements.subs.help":
              "Anläggningar som omfattas av avtalet, med placering, typ och filter.",
            "service.agreements.subs.add": "Lägg till anläggning",
            "service.agreements.subs.adding": "Lägger till …",
            "service.agreements.subs.added": "Anläggning tillagd",
            "service.agreements.subs.add_failed": "Kunde inte lägga till anläggning",
            "service.agreements.subs.fetch_failed": "Kunde inte hämta anläggningar",
            "service.agreements.subs.delete": "Ta bort anläggning",
            "service.agreements.subs.deleted": "Anläggning borttagen",
            "service.agreements.subs.delete_failed": "Kunde inte ta bort anläggning",
            "service.agreements.subs.delete_confirm":
              "Vill du ta bort den här anläggningen från avtalet?",
            "service.agreements.subs.select_all": "Välj alla",
            "service.agreements.subs.create_jobs": "Skapa uppdrag ({{count}})",
            "service.agreements.subs.reports_created": "Skapade {{count}} uppdrag",
            "service.agreements.subs.reports_failed": "Kunde inte skapa uppdrag",
            "service.agreements.subs.empty":
              "Inga anläggningar är inkluderade ännu.",
            "service.agreements.subs.col_location": "Placering",
            "service.agreements.subs.col_equipment": "Anläggning",
            "service.agreements.subs.col_designation": "Benämning",
            "service.agreements.subs.col_filter": "Filter",
            "service.agreements.subs.name_optional": "Namn (valfritt)",
            "service.agreements.subs.use_customer_address": "Använd kundens adress",
            "service.agreements.subs.use_system_address": "Använd anläggningens adress",
            "service.agreements.subs.use_system_address_named": "Använd anläggningens adress ({{address}})",
            "service.agreements.subs.system_address_missing": "Anläggningen har ingen egen leveransadress ännu.",
            "service.report.correction.title": "Måste åtgärdas",
            "service.report.correction.subtitle": "Rapporten godkändes inte. Åtgärda punkterna nedan och slutför rapporten igen.",
            "service.report.correction.items_heading": "Punkter att åtgärda",
            "service.report.correction.fallback_body": "Rapporten godkändes inte och måste korrigeras. Kontakta kontoret om du är osäker på vad som ska åtgärdas.",
            "service.report.correction.open_section": "Öppna sektion",
            "service.report.order_dialog.title_create": "Skapa order från rapport",
            "service.report.order_dialog.title_additional": "Skapa ytterligare order",
            "service.report.product_line_dialog.title": "Produktrad",
            "service.report.product_line_dialog.delete_line": "Ta bort rad",
            "service.report.product_line_dialog.delete_tooltip": "Ta bort rad",
            "service.report.product_line_dialog.delete_confirm_title":
              "Ta bort denna rad permanent?",
            "service.report.product_line_dialog.delete_confirm_hint":
              "Detta kan inte ångras.",
            "service.report.product_line_dialog.delete_cancel": "Avbryt",
            "service.report.product_line_dialog.delete_confirm": "Ta bort",
            "service.report.product_line_dialog.delete_working": "Tar bort…",
            "service.report.product_line_dialog.back_tooltip": "Tillbaka till produktrad",
            "service.report.order_dialog.dialog_eyebrow": "Order",
            "service.report.order_dialog.section_invoice": "Kund och faktura",
            "service.report.order_dialog.section_km": "Milersättning",
            "service.report.order_dialog.section_price_lines": "Avtalade prisrader",
            "service.report.order_dialog.section_order_group": "Ordergruppering",
            "service.report.order_dialog.price_lines_intro":
              "Följande prisrader läggs automatiskt till i ordern:",
            "service.report.order_dialog.price_lines_included_hours": "Inkluderade timmar:",
            "service.report.order_dialog.price_lines_footer_note":
              "Dessa prisrader omfattar {{hours}} h som faktureras via prisraderna, inte separat.",
            "service.report.order_dialog.generate_invoice": "Generera med ChatGPT",
            "service.report.order_dialog.generating_invoice": "Genererar…",
            "service.report.order_dialog.orders_heading": "Ordrar på denna rapport",
            "service.report.order_dialog.open_order": "Öppna order {{number}}",
            "service.report.order_dialog.create": "Skapa order",
            "service.report.order_dialog.create_another": "Skapa ny order",
            "service.report.order_dialog.follow_up_notice_title": "Tilläggsorder",
            "service.report.order_dialog.follow_up_notice_body":
              "Överenskomna prisrader lades på första ordern från rapporten och läggs inte in automatiskt på nya ordrar. Du kan fakturera nya timmar, körning och orderrader som inte redan är fakturerade.",
            "service.report.order_dialog.hours_rounding_label": "Avrundning av fakturerade timmar",
            "service.report.order_dialog.hours_rounding_actual":
              "Faktisk registrerad tid (ingen avrundning)",
            "service.report.order_dialog.hours_rounding_ceil_half":
              "Avrunda uppåt till närmaste halvtimme (0,5 h)",
            "service.report.order_dialog.hours_rounding_nearest_half": "Avrunda till närmaste halvtimme",
            "service.report.order_dialog.hours_rounding_ceil_hour": "Avrunda uppåt till hela timmar",
            "service.report.order_dialog.hours_rounding_nearest_hour": "Avrunda till närmaste hela timme",
            "service.report.order_dialog.hours_rounding_hint":
              "Standard är faktisk tid. Välj avrundning endast när faktureringsregler kräver det (uppåt halvtimme motsvarar gamla kryssrutan).",
            "service.report.order_dialog.hour_lines_label": "Orderrader för timmar",
            "service.report.order_dialog.hour_lines_each":
              "En rad per tidregistrering (rekommenderas för översikt)",
            "service.report.order_dialog.hour_lines_grouped":
              "Slå ihop per aktivitet (en rad per aktivitet)",
            "service.report.order_dialog.hour_lines_hint":
              "Fler registreringar på samma aktivitet blir en rad vid ihopslagning. Fast aktivitetsavgift (budget_fee) förblir en rad per aktivitet.",
            "service.report.order_dialog.section_order_lines": "Orderrader (varuförbrukning)",
            "service.report.order_dialog.section_order_lines_subtitle":
              "{{selected}} av {{total}} rader med förbrukning",
            "service.report.order_dialog.section_hours_subtitle":
              "{{selected}} av {{total}} h",
            "service.report.order_dialog.section_hours_subtitle_manual":
              "Manuella timmar eller välj registreringar nedan",
            "service.report.order_dialog.toggle_order_lines_aria": "Fakturera orderrader",
            "service.report.order_dialog.toggle_hours_aria": "Fakturera timmar",
            "service.report.order_dialog.invoice_order_lines_switch":
              "Fakturera orderrader ({{selected}} av {{total}} med förbrukning valda)",
            "service.report.order_dialog.pick_order_lines":
              "Välj orderrader att fakturera (endast produkter med förbrukning):",
            "service.report.order_dialog.no_consumption_lines":
              "Inga orderrader med förbrukning registrerade",
            "service.report.order_dialog.add_tilleggsarbeider_group_label":
              "Egen orderradgrupp «Tilleggsarbeider»",
            "service.report.order_dialog.add_tilleggsarbeider_group_hint":
              "Stäng av för att lägga timmar och tillhörande rader i huvudgruppen (samma som fakturatitel/text). Användbart när du bara vill ha produktrader utan extra grupp.",
            "service.report.order_dialog.section_hours": "Timmar (tilläggsarbete)",
            "service.report.order_dialog.invoice_hours_switch":
              "Fakturera timmar ({{selected}} av {{total}} h valda)",
            "service.report.order_dialog.invoice_hours_switch_manual":
              "Fakturera timmar (manuellt eller från lista)",
            "service.report.order_dialog.hours_manual_notice_title": "Inga fakturerbara tidregistreringar",
            "service.report.order_dialog.hours_manual_notice_body":
              "All tid kan ligga i avtalade prisrader, eller inga timmar är registrerade. Låt fakturering vara på och fyll i manuellt antal timmar nedan för att lägga standard timprodukt på ordern.",
            "service.report.order_dialog.pick_billable_hours":
              "Välj timmar att fakturera (endast tilläggsarbete):",
            "service.report.order_dialog.hours_settings_heading": "Tidsinställningar",
            "service.report.order_dialog.manual_hours_label":
              "Manuellt antal timmar (åsidosätter valda timmar om ifyllt)",
            "service.report.order_dialog.manual_hours_placeholder":
              "Krävs vid enbart manuell fakturering — annars valfritt",
            "service.report.order_dialog.hours_discount_label": "Rabatt (%)",
            "service.report.order_dialog.hours_preview_heading": "Förhandsvisning",
            "service.report.order_dialog.hours_preview_quantity": "Antal timmar: {{hours}}",
            "service.report.order_dialog.hours_preview_discount": "Rabatt: {{pct}}%",
            "Close": "Stäng",
            "Notes": "Noteringar",
            "Stripe Session": "Stripe Session",
            "Payment Status": "Betalningsstatus",
            "Payment Method": "Betalningsmetod",
            "Order Lines": "Orderlinjer",
            "Comment": "Kommentar",
            "Our Employee Contact": "Vår Anställd Kontakt",
            "Department": "Avdelning",
            "Active": "Aktiv",
            "Employee": "Anställd",
            "Customer Contact": "Kund Kontakt",
            "Contact": "Kontakt",
            "Not chosen": "Inte vald",
            "Address": "Address",
            "None": "Saknas",
            "New": "Ny",
            "More": "Mer",
            "Order Confirmation Sent": "Orderbekräftelse skickad",
            "Ready to be picked": "Klar att plockas",
            "Picked": "Plockad",
            "Packed": "Packad",
            "Ready to be shipped": "Klar att skickas",
            "Ready to be invoiced": "Klar att faktureras",
            "Invoiced": "Fakturerad",
            "Cancelled": "Avbruten",
            "Accomplished": "Slutförd",
            "Ongoing": "Pågående",
            "number.from": "Från",
            "number.to": "Till",
            "updated": "Uppdaterat",
            "item_number": "Artikkelnummer",
            "title": "Titel",
            "short_description": "Kort beskrivning",
            "purchase_price": "Inköpspris",
            "sales_price": "Försäljningspris",
        "product.add": "Lägg till produkt",
        "product.update": "Updatera produkt",
        "product.model_year": "Modellår",
        "product.replaced_by_product": "Ersatt av produkt",
        "product.replaced_by.banner_title": "Den här produkten har ersatts",
        "product.replaced_by.banner_description":
          "Använd ersättningsprodukten för aktuell information, pris och lager.",
        "product.replaced_by.open_replacement": "Öppna ersättningsprodukt",
        "product.selector.open_product": "Öppna produkt",
        "product.selector.replaced_label": "Ersatt",
        "product.selector.search_placeholder": "Sök produkter …",
        "product.selector.empty_flat_list":
          "Sök eller bläddra i listan. Använd tratten för att filtrera aktiva, utgångna eller lager.",
        "customer.system.product_search_placeholder":
          "Sök anläggningar (produkter med reservdelar) …",
        "product.selector.filter_system_products": "System (produkter med reservdelar)",
        "product.selector.toggle_filters": "Visa filter",
            "image.change": "Byt bild",
            "Welcome to Promang": "Welcome to React and react-i18next",
            "Sign in to your account": "Logga inn",
            "product.brands": "Märke",
            "product.brand": "Produkt Merke",
            "Spare parts": "Reservdelar",
            "Categories": "Kategorier",
            "Accessories": "Tilbehör",
            "Unit": "Enhet",
            "customer.type": "Kundtyp",
            "customer.name.required": "Kundnamn krävs",
            "Contact information": "Kontaktinformation",
            "company.outbound_mail.title": "Utgående e-post (Microsoft)",
            "company.outbound_mail.description": "Välj vilken delad företagsinkorg Promang ska skicka från (Microsoft 365). Tomt eller utan Microsoft: använd Promangs standardavsändare.",
            "company.outbound_mail.mailbox_label": "Skicka systemmejl från delad inkorg",
            "company.outbound_mail.promang_default": "Promang standard (inte Microsoft)",
            "company.outbound_mail.case_email_hint": "Ärende-e-post till medarbetare skickas från användarens eget Microsoft-konto när det är kopplat under användarinställningar — inte från denna delade inkorg.",
        "company.inbound_email.title": "Inkommande post / kundservice",
        "company.inbound_email.description":
          "När post@ eller kundservice tar emot e-post kan Promang skapa ärende, kund och skicka tack med ärendenummer. Finjustera per inkorg under Microsoft-inkorgar.",
        "company.inbound_email.enabled": "Behandla inkommande e-post",
        "company.inbound_email.auto_create_case": "Skapa ärende automatiskt",
        "company.inbound_email.auto_create_customer": "Skapa kund om ingen träff",
        "company.inbound_email.auto_reply": "Skicka autosvar med ärendenummer",
        "company.inbound_email.reuse_open_case": "Återanvänd öppet ärende för samma kund",
        "company.inbound_email.match_phone": "Sök kund på mobilnummer",
        "company.inbound_email.match_name": "Sök kund på namn (endast unik träff)",
        "company.inbound_email.ignore_own_domain": "Hoppa över e-post från eget företagsdomän",
        "company.inbound_email.from_domains_ignore": "Ignorera avsändardomäner (kommaseparerat)",
        "company.inbound_email.subject_contains_ignore": "Ignorera ämnesord (kommaseparerat)",
        "company.inbound_email.mailbox_hint": "Koppla delade inkorgar och slå på bakgrundsbehandling här:",
        "company.inbound_email.mailbox_link": "Delade inkorgar",
        "company.inbound_email.fallback_heading": "När e-post inte kan behandlas automatiskt",
        "company.inbound_email.fallback_description":
          "Välj vart oklassificerad inkommande post ska skickas, och vad som händer med kopior av e-post Promang själv har skickat till kunden (till exempel bekräftelse av uppdrag).",
        "company.inbound_email.unknown_fallback_to": "Vidarebefordra okänd post till",
        "company.inbound_email.unknown_fallback_placeholder": "handlaggare@foretag.se",
        "company.inbound_email.unknown_fallback_hint":
          "Används när Promang inte kan klassificera, koppla till ett ärende eller på annat sätt hantera meddelandet. Tomt fält: meddelandet blir kvar i inkorgen (ingenting raderas).",
        "company.inbound_email.system_copy_action": "E-post Promang har skickat (kopia i postlådan)",
        "company.inbound_email.system_copy_action_none": "Gör ingenting (inget nytt ärende)",
        "company.inbound_email.system_copy_action_archive": "Arkivera direkt",
        "company.inbound_email.system_copy_action_forward": "Vidarebefordra till vald adress",
        "company.inbound_email.system_copy_hint":
          "Känns igen som Promang-utskick (header, avsändare och kända mallar). Autosvar skickas inte. Standard är att inte skapa ärende.",
        "company.inbound_email.system_copy_forward_to": "Vidarebefordra Promang-kopia till",
        "company.inbound_email.system_copy_forward_placeholder": "chef@foretag.se",
  "case.mail_thread.missing_thread_title": "Hittar inte den tidigare e-posttråden",
  "case.mail_thread.missing_thread_choice": "E-postmeddelandet har inte skickats. Vill du skicka till {{to}} som en ny tråd? Den gamla tråden finns kvar på ärendet.",
  "case.mail_thread.send_new_thread": "Skicka som ny tråd",
  "case.mail_thread.thread_number": "Tråd {{number}}",
  "case.mail_thread.active_thread": "Aktiv tråd",
  "case.mail_thread.previous_send_confirmed": "Ett tidigare e-postmeddelande har bekräftats skickat. Detta utkast har inte skickats.",
  "case.mail_thread.send_blocked": "En annan sändning från ärendet är inte klarlagd. Detta e-postmeddelande har inte skickats. Kontrollera status innan du försöker igen.",
  "case.mail_thread.send_storage_failed": "Kan inte spara sändningsstatus i webbläsaren. Tillåt lokal lagring innan du skickar.",
  "case.mail_thread.send_unknown": "Det är oklart om e-postmeddelandet skickades. Kontrollera status innan du skickar igen. Om status förblir okänd, kontrollera Skickat i Outlook och kontakta administratören.",
  "case.mail_thread.check_send_status": "Kontrollera sändningsstatus",
  "case.mail_thread.sent_refresh_failed": "E-postmeddelandet har skickats, men vyn kunde inte uppdateras. Ladda om ärendet.",
        "case.mail_thread.open": "Mailtråd",
        "case.mail_thread.dialog_title": "Mailtråd",
        "case.mail_thread.empty": "Inga e-postmeddelanden i tråden ännu.",
        "case.mail_thread.load_failed": "Kunde inte hämta e-posttråden.",
        "case.mail_thread.candidates_failed": "Kunde inte hämta e-post från inkorgen.",
        "case.mail_thread.link_title": "Koppla e-posttråd",
        "case.mail_thread.link_action": "Koppla till ärendet",
        "case.mail_thread.linked": "E-posttråden är kopplad till ärendet.",
        "case.mail_thread.link_failed": "Kunde inte koppla e-posttråden.",
        "case.mail_thread.no_candidates": "Hittade inga e-postmeddelanden i den delade inkorgen.",
        "case.mail_thread.reply_title": "Svara kund på e-post",
        "case.mail_thread.compose_title": "Ny e-post till kund",
        "case.mail_thread.to": "Till",
        "case.mail_thread.subject": "Ämne",
        "case.mail_thread.body_placeholder": "Skriv e-posten här. Mallar och formatering kan användas.",
        "case.mail_thread.pick_template": "Välj mall",
        "case.mail_thread.format_ai": "Formatera text",
        "case.mail_thread.ai_working": "Formaterar …",
        "case.mail_thread.ai_needs_text": "Skriv lite text innan du formaterar.",
        "case.mail_thread.ai_failed": "Kunde inte formatera texten.",
        "case.mail_thread.send": "Skicka",
        "case.mail_thread.sending": "Skickar …",
        "case.mail_thread.sent": "E-posten har skickats.",
        "case.mail_thread.send_failed": "Kunde inte skicka e-posten.",
        "case.mail_thread.send_failed_http": "Kunde inte skicka e-posten ({{status}}).",
        "case.mail_thread.open_message": "Öppna e-post",
        "case.mail_thread.html_iframe_title": "E-postinnehåll",
        "case.mail_thread.latest_first": "Nyaste e-posten överst",
        "case.mail_thread.body_loading": "Hämtar e-postinnehåll …",
        "case.quick_tools.title": "Snabbverktyg",
        "case.mail_thread.missing_recipient": "Ange kundens e-postadress.",
        "case.mail_thread.missing_body": "Skriv e-posten innan du skickar.",
        "case.mail_thread.default_subject": "Förfrågan",
        "case.mail_thread.signature_hint":
          "Din signatur läggs till när du klickar på Skicka, inte i utkastet.",
        "case.mail_thread.signature_banner_title": "Lägg till e-postsignatur",
        "case.mail_thread.signature_banner_body":
          "Du måste lägga in signatur under Profil → E-post innan kundmejlet ser färdigt ut.",
        "case.mail_thread.signature_banner_cta": "Öppna E-post-fliken",
        "case.unread_mail.tag": "Oläst svar från kund",
        "case.labels.clear_all": "Ta bort alla",
        "case.labels.add": "Lägg till",
        "case.labels.add_label": "Lägg till etikett",
        "case.labels.remove": "Ta bort {{name}}",
        "case.labels.search_or_create": "Sök eller skapa etikett…",
        "case.labels.search": "Sök etikett…",
        "case.labels.create": "Skapa «{{name}}»",
        "case.labels.create_failed": "Kunde inte skapa etiketten",
        "case.labels.no_matches": "Inga träffar",
        "case.labels.selected_count": "{{count}} valda",
        "case.labels.none_selected": "Inga valda",
        "case.labels.keyboard_hint": "↑↓ välj · Enter · Esc",
        "case.unread_mail.item_label": "Ny e-post",
        "case.unread_mail.glow_aria": "Senaste inkommande e-post",
            "company.userRoles.helpLabel.scope": "Inkluderar:",
            "company.userRoles.helpLabel.admin": "Administratörer bör tänka på:",
            "company.userRoles.sections.actions": "Åtgärder",
            "company.userRoles.sections.submodules": "Undermoduler",
            "company.userRoles.accessIntro":
              "Hjälptexten under varje roll beskriver åtkomsten och vad du bör överväga innan du tilldelar rättigheter.",
            "company.userRoles.tab": "Roller",
            "company.userRoles.searchPlaceholder": "Sök i moduler och roller …",
            "company.userRoles.templates.title": "Rollmallar",
            "company.userRoles.templates.intro":
              "Välj en mall för att snabbt tilldela en uppsättning roller till en ny anställd. Du kan finjustera efteråt.",
            "company.userRoles.templates.applied":
              "Mall tillämpad. Kom ihåg att spara.",
            "company.userRoles.projectsAccess.title": "Projektåtkomst",
            "company.userRoles.projectsAccess.intro":
              "Styr om användaren har full åtkomst till alla projekt, eller endast till valda projekt.",
            "company.userRoles.projectsAccess.adminToggle":
              "Projektadministratör – alla projekt",
            "company.userRoles.projectsAccess.adminHelp":
              "Full åtkomst till alla företagsprojekt, inklusive arbetsorder och planering. Ger inte företagsadministration, användare eller roller.",
            "company.userRoles.projectsAccess.selectedLabel":
              "Full åtkomst på valda projekt",
            "company.userRoles.projectsAccess.selectedHelp":
              "Användaren får full åtkomst endast på de projekt du väljer här (utöver projekt där användaren är deltagare).",
            "company.userRoles.projectsAccess.searchPlaceholder":
              "Sök efter projekt eller projektnummer …",
            "company.userRoles.projectsAccess.noProjects":
              "Inga projekt hittades.",
            "company.userRoles.projectsAccess.saveMissingRole":
              "Kunde inte spara projektadministratörsåtkomst eftersom rollkatalogen inte är redo. Försök igen om en stund.",
            "company.userRoles.noMatches":
              "Inga moduler eller roller matchar din sökning.",
            "company.userRoles.summary.none": "Ingen åtkomst",
            "company.userRoles.summary.on": "Aktiverad",
            "company.userRoles.summary.selected": "{{count}} valda",
            "company.userRoles.categories.admin": "Administration",
            "company.userRoles.categories.projects": "Projekt och arbetsordrar",
            "company.userRoles.categories.time": "Timmar, frånvaro och kalender",
            "company.userRoles.categories.service": "Service",
            "company.userRoles.categories.quality": "Kvalitet och HMS",
            "company.userRoles.categories.fleet": "Fordon och körning",
            "company.userRoles.categories.drawings": "Ritningar och BIM",
            "company.userRoles.categories.customers": "Kunder och kommunikation",
            "company.userRoles.categories.sales": "Försäljning, lager och produkter",
            "company.userRoles.categories.other": "Övriga moduler",
            "drawings": "Ritningar",
            "drawings_edit": "Ritningar – redigering",
            "company.users.page_title": "Användare",
            "company.users.subtitle_selected": "{{count}} valda",
            "company.users.hero.kicker": "Företag",
            "company.users.hero.title": "Användare och åtkomst",
            "company.users.hero.subtitle":
              "Hantera personer, roller, inbjudningar och filter på ett ställe — i linje med dashboardöversikten.",
            "company.users.stats.total": "Totalt",
            "company.users.stats.on_page": "På den här sidan",
            "company.users.stats.selected": "Valda",
            "company.users.section.kicker": "Katalog",
            "company.users.section.title": "Användarlista",
            "company.users.section.subtitle":
              "Sök, förfina med filter och öppna en profil för att redigera detaljer.",
            "company.users.section.meta_line": "{{total}} användare · sida {{page}}",
            "company.users.search_placeholder": "Sök användare…",
            "company.users.filters_heading": "Filter",
            "company.users.filters_description":
              "Sök och avgränsa listan med alternativen nedan.",
            "company.users.filter_title": "Filtrera användare",
            "company.users.filter.active": "Aktiva användare",
            "company.users.filter.employee": "Medarbetare",
            "company.users.filter.show_in_dropdown": "Visa i listruta",
            "company.users.new_user": "Ny användare",
            "company.users.calendar": "Kalender",
            "company.users.loading": "Laddar användare…",
            "company.users.table.status_inactive": "Inaktiv",
            "company.users.table.status_pending": "Väntar",
            "company.users.table.status_active": "Aktiv",
            "company.users.table.empty_title": "Inga användare hittades",
            "company.users.table.empty_hint":
              "Prova att justera sökning eller filter för att se fler träffar.",
            "company.users.table.row_kicker": "Användare",
            "company.users.table.unnamed": "Namnlös",
            "company.users.table.calendar": "Kalender",
            "company.users.profile.read_only_title": "Användarinformation är skrivskyddad",
            "company.users.profile.read_only_multi_company":
              "Den här användaren är kopplad till flera företag. Profilen (namn, foto, kontaktuppgifter m.m.) kan bara redigeras från dennes primära företag för att undvika motstridiga ändringar. Byt till det företaget i arbetsytan, eller ange rätt primärföretag för användaren.",
            "company.users.table.edit": "Redigera",
            "company.users.table.settings": "Profil",
            "company.users.table.view": "Öppna",
            "company.users.table.selected_of_total":
              "{{selected}} av {{total}} valda",
            "company.users.table.user_count": "{{count}} användare",
            "company.users.table.n_selected": "{{count}} valda",
            "company.users.invitation.expired":
              "Den här användaren har en utgången inbjudningslänk.",
            "company.users.invitation.resend_button": "Skicka inbjudan igen",
            "company.users.invitation.resending": "Skickar inbjudan...",
            "company.users.invitation.resend_success":
              "Inbjudan skickades igen.",
            "company.users.invitation.resend_error":
              "Kunde inte skicka inbjudan igen.",
            "company.users.password.section_title": "Lösenord och inbjudan",
            "company.users.password.section_subtitle":
              "Skicka länk för att ange lösenord, eller ange lösenord direkt. Historik visas nedan.",
            "company.users.password.send_link": "Skicka länk för att ange lösenord",
            "company.users.password.sending": "Skickar länk…",
            "company.users.password.send_success": "Länk för att ange lösenord har skickats.",
            "company.users.password.send_error": "Kunde inte skicka länk för att ange lösenord.",
            "company.users.password.set_password": "Ange lösenord",
            "company.users.password.set_subtitle":
              "Ange ett tillfälligt lösenord för användaren. Dela det säkert utanför Promang.",
            "company.users.password.new_password": "Nytt lösenord",
            "company.users.password.confirm_password": "Bekräfta lösenord",
            "company.users.password.cancel": "Avbryt",
            "company.users.password.save": "Spara lösenord",
            "company.users.password.saving": "Sparar…",
            "company.users.password.set_success": "Lösenordet har uppdaterats.",
            "company.users.password.set_error": "Kunde inte uppdatera lösenordet.",
            "company.users.password.too_short": "Lösenordet måste vara minst 8 tecken.",
            "company.users.password.mismatch": "Lösenorden matchar inte.",
            "company.users.password.last_sent": "Senaste e-post skickad: {{at}}",
            "company.users.password.never_sent": "Ingen lösenords- eller inbjudnings-e-post har loggats ännu.",
            "company.users.password.history_title": "Historik",
            "company.users.password.history_empty": "Inga händelser registrerade.",
            "company.users.password.source_create": "Inbjudan vid skapande",
            "company.users.password.source_resend": "Inbjudan skickad igen",
            "company.users.password.source_admin_send": "Lösenordslänk skickad av admin",
            "company.users.password.source_tripletex_sync": "Lösenordslänk från Tripletex-synk",
            "company.users.password.source_admin_password_set": "Lösenord angivet av admin",
            "company.users.password.source_unknown": "Okänd händelse",
            "driving": "Körning (hela flottan)",
            "driving_trips": "Resor och incheckat fordon",
            "driving_drivers": "Förare",
            "driving_vehicles": "Fordon (körmodul)",
            "vehicles": "Fordon",
            "Postal Address": "Postadress",
            "Physical Address": "Besöksadress",
            "Edit": "Redigera",
            "Back": "Tillbaka",
            "Customer Number": "Kundnummer",
            "Name": "Namn",
            "Email": "E-post",
            "pmField.email.invalid": "Ange en giltig e-postadress.",
            "pmField.email.sameAsName": "E-post och namn får inte vara lika. Använd namnfältet för namn och e-postfältet för e-post.",
            "pmField.email.nameLooksLikeEmail": "Det här ser ut som en e-postadress. Använd e-postfältet för e-post.",
            "Mobile": "Mobil",
            "Inactive": "Inaktiv",
            "All": "Alla",
            "Kontakter": "Kontakter",
            "Contact info": "Kontaktinfo",
            "Sync": "Synk",
            "Date": "Datum",
            "Confirmed": "Bekräftad",
            "Confirmed date": "Bekräftat datum",
            "Via SMS": "Via SMS",
            "Manually": "Manuellt",
            "Ikke avtalt": "Inte bokad",
            "Products": "Produkter",
            "Purchase Price": "Inköpspris",
            "Sales Price": "Försäljningspris",
            "Leverandør": "Leverantör",
            "Lager status": "Lagerstatus",
            "Org. Nummer": "Org. Nummer",
            "Address 2": "Adress 2",
            "Postal": "Postnummer",
            "Place": "Plats",
            "Yes": "Ja",
            "No": "Nej",
            "Copied to clipboard": "Kopierat till urklipp",
            "Agreement Start Date": "Avtalets startdatum",
            "Agreement Type": "Avtalstyp",
            "Checklist created successfully": "Checklista skapad",
            "Choose who should own this deviation": "Välj vem som ska äga denna avvikelse",
            "Consequence": "Konsekvens",
            "Could not save": "Kunde inte spara",
            "Create Deviation": "Skapa avvikelse",
            "Deleted": "Raderad",
            "Deviation Type": "Avvikelsetyp",
            "Edit Deviation": "Redigera avvikelse",
            "Edit Mode": "Redigeringsläge",
            "Edit Vehicle": "Redigera fordon",
            "Failed to create checklist": "Kunde inte skapa checklista",
            "Interval": "Intervall",
            "Interval is required": "Intervall krävs",
            "service.agreement.validation.interval_required": "Intervall krävs",
            "Last Ride": "Senaste körning",
            "No email": "Ingen e-post",
            "Norwegian": "Norska",
            "Print Label": "Skriv ut etikett",
            "Report Type": "Rapporttyp",
            "Responsible User": "Ansvarig användare",
            "Responsible for follow-up": "Ansvarig för uppföljning",
            "Search employees": "Sök anställda",
            "Select Deviation Type": "Välj avvikelsetyp",
            "Select Responsible User": "Välj ansvarig användare",
            "Select Severity": "Välj allvarlighetsgrad",
            "Selected": "Vald",
            "Title is required": "Titel krävs",
            "View Mode": "Visningsläge",
            "meeting_minutes.view_mode": "Visningsläge",
            "meeting_minutes.edit_mode": "Redigeringsläge",
            "Work Order": "Arbetsorder",
            "Failed to copy": "Kunde inte kopiera",
            "Copy to clipboard": "Kopiera till urklipp",
            "Warehouse Status Type": "Lagerstatus Typ",
            "Account Code": "MVA Kod",
            "Product Type": "Produkt Typ",
            "Status": "Status",
            "Product Settings": "Produkt Innställningar",
            "Product Main Image": "Produktens Huvudbild",
            "Product Description": "Produkt Beskrivning",
            "Shipping": "Frakt",
            "active": "Aktiv",
            "Spare Part": "Reservdel",
            "Warehouse": "På lager",
            "Online Store": "Nätbutik",
            "Short Description": "Kort Beskrivning",
            "Title": "Titel",
            "Item Number": "Artikelnummer",
            "Product Information": "Produktinformation",
            "order_date": "Order Datum",
            "order_number": "Order Nummer",
            "Customer": "Kund",
            "Our Contact": "Vår kontakt",
            "Description": "Beskrivning",
            "Select a": "Välj en",
            "Reference": "Referens",
            "Delivery Information": "Leverans information",
            "Delivery Date": "Leverans Datum",
            "Delivery Address": "Leverans Adress",
            "missing_system": "System fattas",
            "missing_report": "Rapport fattas",
            "missing_customer": "Kund fattas",
            "missing_order": "Order fattas",
            "missing_order_lines": "Orderlinjer fattas",
            "item_consumption_not_handled":
              "Varuförbrukning måste vara «använt på uppdrag» eller «inte använt». «Taget med i bilen» är endast tillfälligt.",
            "item_consumption_handled": "Varuförbrukning är färdigbehandlad",
            "service.report.finish.item_consumption_not_handled":
              "Varuförbrukning måste sättas till «använt på uppdrag» eller «inte använt» innan rapporten kan färdigställas. «Taget med i bilen» är endast tillfälligt.",
            "missing_hours": "Timmar fattas",
            "RESPONSIBLE": "Ansvarig",
            "RESPONSIBLE_EXECUTOR": "Ansvarig utförare",
            "EXECUTOR": "Utförare",
            "OBSERVER": "Observatör",
            "note": "Anteckning",
            "work_order": "Arbetsorder",
            "Work Orders": "Arbetsorder",
            "Work Order List": "Arbetsorder - Lista",
            "New Work Order": "Ny Arbetsorder",
            "Search work orders...": "Sök i arbetsorder...",
            "Filter Work Orders by Status": "Filtrera arbetsorder efter status",
            "Finished": "Färdig",
            "Order Date": "Beställningsdatum",
            "Due Date": "Förfallodatum",
            "Event Period": "Händelseperiod",
            "Responsible": "Ansvarig",
            "Executor": "Utförare",
            "Work Order #": "Arbetsorder #",
            "work_orders.pagination_summary":
              "Sida {{page}} av {{totalPages}} ({{total}} totalt)",
            "work_orders.delete_confirm":
              "Detta raderar arbetsordern permanent. Timmar som är kopplade till den kopplas loss. Detta kan inte ångras.",
            "work_orders.delete_success": "Arbetsorder raderad",
            "work_orders.delete_failed": "Kunde inte radera arbetsordern",
            "work_orders.back_to_view": "Tillbaka till visning",
            "work_orders.details_section_title": "Detaljer",
            "work_orders.edit_details": "Redigera",
            "work_order.redesign.status.draft": "Utkast",
            "work_order.redesign.status.scheduled": "Planerad",
            "work_order.redesign.status.progress": "Pågår",
            "work_order.redesign.status.done": "Slutförd",
            "work_order.redesign.urgent": "Brådskande",
            "work_order.redesign.print": "Skriv ut",
            "work_order.redesign.finish": "Slutför",
            "work_order.redesign.field_log": "Fältlogg",
            "work_order.redesign.field_log_sub": "Öppna en dialog för att registrera",
            "work_order.redesign.hours": "Timmar",
            "work_order.redesign.materials": "Materialåtgång",
            "work_order.redesign.material_lines": "rader",
            "work_order.redesign.notes": "Anteckningar & foton",
            "work_order.redesign.notes_meta": "Arbetsanteckningar och dokumentation",
            "work_order.redesign.open": "Öppna",
            "work_order.redesign.budget_hours_unit": "h budget",
            "work_order.redesign.what_to_do": "Vad ska göras",
            "work_order.redesign.no_description": "Ingen beskrivning tillagd.",
            "work_order.redesign.ready_title": "Klar att slutföra?",
            "work_order.redesign.all_met": "Alla krav uppfyllda.",
            "work_order.redesign.items_left": "{{count}} kvar.",
            "work_order.redesign.req_crew": "Personal tilldelad",
            "work_order.redesign.req_hours": "Timmar registrerade",
            "work_order.redesign.req_desc": "Beskrivning tillagd",
            "work_order.redesign.req_items": "Materialåtgång registrerad",
            "work_order.redesign.mark_complete": "Markera som slutförd",
            "work_order.redesign.completed": "Slutförd",
            "work_order.redesign.details": "Detaljer",
            "work_order.redesign.detail_project": "Projekt",
            "work_order.redesign.detail_customer": "Kund",
            "work_order.redesign.due": "Förfaller",
            "work_order.redesign.crew": "Personal",
            "work_order.redesign.assigned_count": "{{count}} tilldelade",
            "work_order.redesign.no_crew": "Ingen personal ännu",
            "work_orders.calendar_filter": "Arbetsorder",
            "work_orders.project_activity.section_title": "Projektaktivitet",
            "work_orders.project_activity.help":
              "Koppla en projektaktivitet som inte redan är knuten någon annanstans, eller skapa en ny på detta projekt. När du sparar arbetsordern kopplas aktiviteten till denna order.",
            "work_orders.project_activity.new_title_label": "Titel för ny aktivitet",
            "work_orders.project_activity.copy_from_title": "Kopiera från titel",
            "work_orders.project_activity.new_title_placeholder":
              "t.ex. Installation fas 2",
            "work_orders.project_activity.create_button": "Skapa och välj",
            "work_orders.project_activity.creating": "Skapar…",
            "work_orders.project_activity.created_toast": "Projektaktivitet skapad",
            "work_orders.project_activity.create_error":
              "Kunde inte skapa projektaktivitet",
            "work_orders.project_activity.linked_label": "Projektaktivitet",
            "work_orders.billing_ready.action": "Klar för fakturering",
            "work_orders.billing_ready.eyebrow": "Fakturaunderlag",
            "work_orders.billing_ready.title": "Förbered fakturainformation",
            "work_orders.billing_ready.title_edit": "Uppdatera fakturaunderlag",
            "work_orders.billing_ready.intro":
              "Spara fakturatext och vad som ska faktureras (timmar och förbruk). Du kan bara markera arbetsordern klar för fakturering, eller skapa en debiteringsorder direkt för att gå vidare till fakturering.",
            "work_orders.billing_ready.section_invoice": "Fakturautkast",
            "work_orders.billing_ready.section_hours": "Timmar för fakturering",
            "work_orders.billing_ready.section_hours_subtitle":
              "Valt {{selected}} h av {{total}} h",
            "work_orders.billing_ready.section_items": "Orderrader (förbrukning)",
            "work_orders.billing_ready.section_items_subtitle":
              "{{selected}} av {{total}} rader valda",
            "work_orders.billing_ready.section_group": "Ordgruppering (senare)",
            "work_orders.billing_ready.add_tilleggsarbeider_hint":
              "När order senare skapas från arbetsordern kan timmar och material samlas i en egen grupp på debiteringsordern.",
            "work_orders.billing_ready.toggle_hours_aria": "Inkludera timmar i underlaget",
            "work_orders.billing_ready.toggle_items_aria": "Inkludera orderrader i underlaget",
            "work_orders.billing_ready.no_billable_hours": "Inga timmar är kopplade till arbetsordern.",
            "work_orders.billing_ready.no_usage_items": "Inga förbrukningsrader med använt antal.",
            "work_orders.billing_ready.submit": "Spara och markera klar för fakturering",
            "work_orders.billing_ready.success": "Markerad klar för fakturering och påminnelse skickad till utförare",
            "work_orders.billing_ready.failed": "Kunde inte spara fakturaunderlag",
            "work_orders.billing_ready.submit_create_order": "Skapa debiteringsorder",
            "work_orders.billing_ready.success_order": "Debiteringsorder skapad",
            "work_orders.billing_ready.failed_order": "Kunde inte skapa debiteringsorder",
            "work_orders.billing_ready.open_order": "Öppna debiteringsorder",
            "work_orders.billing_ready.sales_income_in_project_notice_title":
              "Inte fakturerbar som egen försäljningsorder",
            "work_orders.billing_ready.sales_income_in_project_notice":
              "Arbetsordern är markerad med att försäljningsintäkt ingår i projektet. Använd projektfakturering; markering som klar för fakturering och att skapa försäljningsorder från arbetsordern är inte tillgängligt.",
            "work_orders.filter_executor": "Utförande",
            "work_orders.bulk_create.toolbar": "{{count}} markerade",
            "work_orders.bulk_create.open": "Skapa debiteringsordrar…",
            "work_orders.bulk_create.clear": "Rensa markering",
            "work_orders.bulk_create.title": "Skapa debiteringsordrar från arbetsordrar",
            "work_orders.bulk_create.summary": "Du är på väg att skapa en eller flera debiteringsordrar från {{count}} arbetsorder(r).",
            "work_orders.bulk_create.hint":
              "Standardregler gäller: alla timmar och förbrukningsrader som kan faktureras tas med per arbetsorder. För full kontroll (avrundning, manuella timmar, radval), använd fakturadialogen på varje arbetsorder.",
            "work_orders.bulk_create.strategy_label": "Hur ska ordrarna grupperas?",
            "work_orders.bulk_create.strategy_per_wo": "En debiteringsorder per arbetsorder",
            "work_orders.bulk_create.strategy_customer": "Slå ihop per kund (en order per kund)",
            "work_orders.bulk_create.strategy_project": "Slå ihop per projekt (en order per projekt)",
            "work_orders.bulk_create.submit": "Skapa ordrar",
            "work_orders.bulk_create.success": "Skapade {{count}} debiteringsorder(r)",
            "work_orders.bulk_create.failed": "Kunde inte skapa debiteringsordrar",
            "work_orders.bulk_create.select_row": "Markera arbetsorder för massfakturering",
            "work_orders.bulk_create.select_page": "Markera alla arbetsordrar på sidan som kan faktureras",
            "work_orders.checklist.enable_switch": "Använd checklista för denna arbetsorder",
            "work_orders.checklist.section_title": "Checklista",
            "work_orders.checklist.save_to_enable_title": "Spara arbetsordern",
            "work_orders.checklist.save_to_enable_body":
              "Spara dina ändringar för att aktivera checklistan och skapa eller redigera rader.",
            "work_orders.checklist.missing_title": "Ingen checklista ännu",
            "work_orders.checklist.missing_body": "Skapa en checklista genom att välja mall eller börja tom.",
            "work_orders.checklist.choose": "Välj checklista",
            "work_orders.checklist.delete": "Ta bort checklista",
            "work_orders.checklist.delete_confirm_title": "Ta bort checklista?",
            "work_orders.checklist.delete_confirm_body": "Detta kan inte ångras. Checklistan och svaren tas bort.",
            "work_orders.checklist.loading": "Laddar checklista…",
            "work_orders.checklist.load_error": "Kunde inte ladda checklistan.",
            "work_orders.checklist.load_error_title": "Checklistan kunde inte laddas",
            "work_orders.checklist.load_error_hint":
              "Försök igen eller öppna arbetsordern från projektöversikten.",
            "work_orders.checklist.created": "Checklista skapad",
            "work_orders.checklist.create_error": "Kunde inte skapa checklista",
            "work_orders.checklist.deleted": "Checklista borttagen",
            "work_orders.checklist.delete_error": "Kunde inte ta bort checklista",
            "work_orders.checklist.save_error": "Kunde inte spara checklista",
            "work_orders.checklist.read_only_hint":
              "Du kan se arbetsorderns checklista i skrivskyddat läge på checklistsidan.",
            "work_orders.checklist.page_subtitle": "Checklista",
            "work_orders.checklist.page_heading": "Arbetsorder checklista",
            "work_orders.checklist.back_to_work_order": "Tillbaka till arbetsorder",
            "work_orders.checklist.disabled_title": "Checklista är inte aktiverad",
            "work_orders.checklist.disabled_body":
              "Aktivera «Använd checklista» på redigeringssidan för att använda avsnittet.",
            "work_orders.checklist.read_only_banner":
              "Skrivskyddat: du har inte behörighet att redigera checklistan.",
            "work_orders.checklist.create_from_edit": "Skapa en checklista från redigeringssidan för arbetsorder.",
            "work_orders.checklist.load_work_order_error": "Kunde inte ladda arbetsorder",
            "work_orders.checklist.card_title": "Checklista",
            "work_orders.checklist.card_desc_with_checklist":
              "Visa och fyll i checklistan på checklistsidan.",
            "work_orders.checklist.card_desc_no_checklist":
              "Skapa en checklista på redigeringssidan (välj mall eller börja tom).",
            "work_orders.checklist.unit": "punkter",
            "work_orders.checklist.mobile_nav": "Checklista",
            "work_orders.list_meta_total": "Totalt: {{count}}",
            "work_orders.table_no_title": "Ingen titel",
            "work_order.view.mobileNav.ariaLabel":
              "Snabbval för tidregistrering och varuförbrukning på arbetsorder",
            "work_order.admin.title": "Admin",
            "work_order.admin.edit": "Redigera arbetsorder",
            "work_order.admin.edit_desc": "Öppna fullständigt redigeringsformulär",
            "work_order.admin.approve": "Godkänn arbetsorder",
            "work_order.admin.approve_desc": "Godkänn eller avvisa (samordnare)",
            "work_order.admin.open_project": "Öppna projekt",
            "work_order.admin.open_customer": "Öppna kund",
            "work_order.admin.item_consumption": "Varuförbrukning",
            "work_order.admin.item_consumption_desc":
              "Registrera material och förbrukad kvantitet",
            "work_order.admin.billing_desc":
              "Förbered fakturaunderlag eller skapa kundorder",
            "work_order.admin.finish": "Slutför arbetsorder",
            "work_order.admin.finish_desc":
              "Gå igenom checklista och markera som slutförd",
            "work_order.admin.mentions": "@Omnämnanden",
            "work_order.admin.mentions_desc":
              "Anteckningar och resurser som refererar till denna arbetsorder",
            "work_order.admin.mentions_dialog_title":
              "Omnämnanden av arbetsordern",
            "work_order.admin.no_mentions": "Inga omnämnanden hittades.",
            "work_order.admin.set_status": "Ange status (admin)",
            "work_order.admin.set_status_desc":
              "Korrigera status för äldre fall, till exempel redan fakturerat utanför Promang.",
            "work_order.admin_set_status.title": "Ange status på arbetsorder",
            "work_order.admin_set_status.intro":
              "Använd när ordern fakturerats eller slutförts utanför det normala flödet. Skapar ingen kundorder.",
            "work_order.admin_set_status.status_label": "Status",
            "work_order.admin_set_status.mark_completed": "Markera som slutförd",
            "work_order.admin_set_status.submit": "Spara",
            "work_order.admin_set_status.success": "Status uppdaterad.",
            "work_order.admin_set_status.error": "Det gick inte att uppdatera status.",
            "work_order.status.draft": "Utkast",
            "work_order.status.ongoing": "Pågår",
            "work_order.status.finished": "Slutförd",
            "work_order.status.processing": "Under behandling",
            "work_order.status.processed": "Behandlad",
            "work_order.status.cancelled": "Avbruten",
            "work_order.status.ready_invoice": "Klar för fakturering",
            "work_order.status.invoiced": "Fakturerad",
            "work_order.status.rejected": "Avvisad",
            "work_order.status.approved": "Godkänd",
            "work_order.status.updated": "Uppdaterad",
            "work_order.completion.check_participant_notes":
              "Uppdatering / anteckningar från deltagare",
            "work_order.completion.title": "Slutförande",
            "work_order.completion.status_not_applicable":
              "Slutförande är inte tillgängligt för denna status.",
            "work_order.completion.heading_done": "Arbetsorder slutförd",
            "work_order.completion.heading_pending": "Slutför arbetsorder",
            "work_order.completion.sub_done":
              "Arbetsordern har markerats som slutförd.",
            "work_order.completion.sub_blocked":
              "Vissa krav måste uppfyllas innan du kan slutföra.",
            "work_order.completion.sub_ready":
              "Alla obligatoriska krav är uppfyllda; du kan slutföra när du är redo.",
            "work_order.completion.label_status": "Status",
            "work_order.completion.label_progress": "Beredskap",
            "work_order.completion.value_done": "Slutförd",
            "work_order.completion.no_checks": "—",
            "work_order.completion.cta_view": "Visa slutförandedetaljer",
            "work_order.completion.cta_finish": "Slutför",
            "work_order.event.dialog_create": "Skapa händelse",
            "work_order.event.dialog_edit": "Redigera händelse",
            "work_order.event.toast_created": "Händelse skapad",
            "work_order.event.toast_updated": "Händelse uppdaterad",
            "work_order.event.toast_deleted": "Händelse raderad",
            "work_order.event.delete_failed": "Kunde inte radera händelsen",
            "work_order.event.delete_event": "Radera",
            "work_order.event.saving": "Sparar…",
            "work_order.event.submit_create": "Skapa",
            "work_order.event.submit_update": "Uppdatera",
            "work_order.event.field_title": "Titel",
            "work_order.event.field_title_placeholder": "Händelsetitel",
            "work_order.event.field_description": "Beskrivning",
            "work_order.event.field_description_placeholder": "Beskriv händelsen…",
            "work_order.event.field_start": "Starttid",
            "work_order.event.field_end": "Sluttid",
            "work_order.event.field_location": "Plats",
            "work_order.event.field_location_placeholder": "Var ska händelsen äga rum?",
            "work_order.event.location_prefilled":
              "Leveransadress från arbetsordern är förifylld (kan redigeras).",
            "work_order.event.all_day": "Hela dagen",
            "work_order.event.attendees_title": "Deltagare i händelsen",
            "work_order.event.attendees_hint":
              "Alla på arbetsordern föreslås. Avmarkera dem som inte ska delta. Du kan lägga till fler nedan.",
            "work_order.event.add_attendee": "Lägg till deltagare",
            "work_order.event.add_confirm": "Lägg till",
            "work_order.event.select_user": "Välj användare",
            "work_order.event.loading_users": "Laddar användare…",
            "work_order.event.no_attendees_from_wo":
              "Inga deltagare på arbetsordern. Använd «Lägg till deltagare» för att bjuda in.",
            "work_order.event.from_work_order": "Från arbetsorder",
            "work_order.event.remove_attendee": "Ta bort",
            "work_order.event.role_participant": "Deltagare",
            "work_order.event.error_need_event_owner":
              "Arbetsordern måste ha en användare som kan äga kalenderhändelsen (ansvarig utförare, ordreansvarig eller skapare) innan du kan skapa en händelse.",
            "work_order.event.notice_no_event_owner_title": "Saknar ägare för händelsen",
            "work_order.event.notice_no_event_owner_description":
              "Lägg till ansvarig utförare eller ordreansvarig på arbetsordern, eller se till att den har en skapare, så att händelsen kan kopplas till en användare. Du kan fortfarande redigera en befintlig händelse.",
            "work_order.participants.title": "Deltagare",
            "work_order.participants.description":
              "Vem som ingår i arbetsordern (roller och status).",
            "work_order.participants.draft_hint":
              "Spara arbetsordern först för att hantera deltagare som i ett projekt (egna dialogrutor).",
            "work_order.participants.add": "Lägg till deltagare",
            "work_order.participants.add_first": "Lägg till första deltagare",
            "work_order.participants.none": "Inga deltagare ännu.",
            "work_order.participants.user": "Användare",
            "work_order.participants.role": "Roll",
            "work_order.participants.status": "Status",
            "work_order.participants.edit": "Redigera",
            "work_order.participants.delete": "Ta bort",
            "work_order.participants.delete_confirm":
              "Ta bort denna deltagare från arbetsordern?",
            "work_order.participants.delete_error": "Kunde inte ta bort deltagare",
            "work_order.participants.error_loading":
              "Kunde inte ladda deltagare",
            "work_order.participants.save_error": "Kunde inte spara deltagare",
            "work_order.participants.created": "Deltagare tillagd",
            "work_order.participants.updated": "Deltagare uppdaterad",
            "work_order.participants.updating": "Uppdaterar…",
            "work_order.participants.adding": "Lägger till…",
            "work_order.plan_modal.section_title": "Planering",
            "work_order.plan_modal.section_subtitle":
                "Planera utförare och tider för arbetsordern i projektplanen.",
            "work_order.plan_modal.schedule_new": "Planera",
            "work_order.plan_modal.schedule_edit": "Redigera planering",
            "work_order.plan_modal.empty": "Ingen planering ännu. Skapa en plan med utförare och tid.",
            "work_order.plan_modal.title_create": "Planera arbetsorder",
            "work_order.plan_modal.title_edit": "Redigera planering",
            "work_order.plan_modal.work_order": "Arbetsorder",
            "work_order.plan_modal.plan_title": "Plantitel",
            "work_order.plan_modal.plan_title_placeholder": "Titel på uppgiften i planen",
            "work_order.plan_modal.planning_type_section": "Planeringstyp",
            "work_order.plan_modal.planning_type_resources": "Knyt resurser",
            "work_order.plan_modal.planning_type_dates_only": "Endast datum",
            "work_order.plan_modal.planning_type_resources_help":
                "Välj utförare och tid per dag. Resurserna visas i resursplanen.",
            "work_order.plan_modal.planning_type_dates_only_help":
                "Ange endast start- och slutdatum nu – resurser kan knytas till planen senare.",
            "work_order.plan_modal.dates_only_remove_warning":
                "Planen har redan resurser. Om du sparar som \"Endast datum\" tas resurserna bort från planen.",
            "work_order.plan_modal.validation_missing_dates": "Välj minst en dag för planen",
            "work_order.plan_modal.pick_days_hint": "Välj dagar för planen",
            "work_order.plan_modal.executing_section": "Utförare",
            "work_order.plan_modal.executing_help":
                "Välj vem som ska utföra arbetet.",
            "work_order.plan_modal.executing_help_multi":
                "Välj en eller flera utförare. Varje får uppdrag på valda dagar.",
            "work_order.plan_modal.select_all_participants": "Välj alla deltagare på AO",
            "work_order.plan_modal.select_all_employees": "Gäller alla anställda",
            "work_order.plan_modal.clear_employees": "Rensa alla",
            "work_order.plan_modal.tab_all": "Alla",
            "work_order.plan_modal.mode_shared": "Samma plan för alla",
            "work_order.plan_modal.mode_per_user": "Egen plan per användare",
            "work_order.plan_modal.apply_days_to_all": "Använd valda dagar för alla",
            "work_order.plan_modal.apply_days_to_all_help":
                "Kopierar de synliga valda dagarna till alla valda resurser och byter till \"Samma plan för alla\".",
            "work_order.plan_modal.apply_days_to_all_toast":
                "Valda dagar gäller nu för alla resurser",
            "work_order.plan_modal.remove_day": "Ta bort dag från plan",
            "work_order.plan_modal.all_employees_hint":
                "\"Samma plan för alla\" används bara när resurserna har samma dagar — eller när du aktivt väljer det / \"Använd valda dagar för alla\". När dagarna skiljer per resurs startar nya personer tomma.",
            "work_order.plan_modal.selected_employees_count": "{{count}} utförare valda",
        "work_order.plan_modal.new_resource_pick_days":
              "Ny resurs tillagd – välj dagar för denna person",
        "work_order.plan_modal.new_resources_pick_days":
              "Nya resurser tillagda – välj dagar för dessa personer",
            "work_order.plan_modal.conflicts_title": "Resurskonflikter ({{count}})",
            "work_order.plan_modal.conflicts_help":
                "Klicka på en konflikt för att gå till datumet och justera eller ta bort dagen.",
            "work_order.plan_modal.conflicts_jump": "Gå till datum",
            "work_order.plan_modal.days_section": "Dagar",
            "work_order.plan_modal.days_help":
                "Välj dagar i veckovyn. Befintliga planerade dagar behålls när du byter vecka — du kan lägga till fler dagar i en annan vecka.",
            "work_order.plan_modal.multi_week_nav_hint":
                "Använd pilarna i kalendern för att lägga till dagar i andra veckor. Tid per dag visar alla valda datum.",
            "work_order.plan_modal.per_day_other_weeks": "Andra veckor ({{count}})",
            "work_order.plan_modal.per_day_this_week": "Denna vecka",
            "work_order.plan_modal.other_week_badge": "annan vecka",
            "work_order.plan_modal.selected_days_count": "{{count}} dag(ar) valda",
            "work_order.plan_modal.per_day_section": "Tid per dag",
            "work_order.plan_modal.per_day_help": "Ange från/till och timmar för varje vald dag.",
            "work_order.plan_modal.time_from": "Från",
            "work_order.plan_modal.time_to": "Till",
            "work_order.plan_modal.hours_short": "t",
            "work_order.plan_modal.default_hours_label": "Standardtimmar (nya dagar)",
            "work_order.plan_modal.apply_hours_all_days": "Använd standardtimmar på alla valda dagar",
            "work_order.plan_modal.schedule_help_calendar":
                "Du kan också dra ett tidsintervall i kalendern — endast den dag du drar på uppdateras.",
            "work_order.plan_modal.schedule_help_multi":
                "Dra ett tidsintervall i kalendern, eller justera från/till per dag nedan.",
            "work_order.plan_modal.drag_days_hint": "på en dag i kalendern för att sätta tid den dagen.",
            "work_order.plan_modal.clear_days": "Ta bort dagar",
            "work_order.plan_modal.clear_time": "Ta bort tid",
            "work_order.plan_modal.same_time_all_days": "samma tid alla dagar",
            "work_order.plan_modal.varied_times": "Olika tider per dag",
            "work_order.plan_modal.assignment_count": "{{count}} uppdrag",
            "work_order.plan_modal.days_short": "dagar",
            "work_order.plan_modal.participant": "Deltagare på AO",
            "work_order.plan_modal.estimated_hours_section": "Uppskattad tid",
            "work_order.plan_modal.estimated_hours_help":
                "Används som standardlängd när du lägger till nya dagar.",
            "work_order.plan_modal.estimated_hours_from_wo":
                "Förslag från arbetsorder: {{hours}} timmar",
            "work_order.plan_modal.schedule_section": "Kalender",
            "work_order.plan_modal.schedule_help":
                "Dra i kalendern för att välja tid.",
            "work_order.plan_modal.pick_time_hint": "Välj dagar och ange från/till per dag",
            "work_order.plan_modal.validation_missing":
                "Välj utförare, minst en dag och från/till för varje dag",
            "work_order.plan_modal.validation_missing_user_days":
                "Alla valda utförare måste ha minst en dag — eller använd \"Använd valda dagar för alla\"",
            "work_order.plan_modal.toast_created": "Planering skapad",
            "work_order.plan_modal.toast_updated": "Planering uppdaterad",
        "work_order.plan_modal.saving": "Laddar…",
            "work_order.plan_modal.add_plan": "Lägg till ny plan",
            "work_order.plan_modal.plans_section_subtitle":
                "Lägg till en eller flera planer – t.ex. en plan denna vecka och en annan längre fram. Varje plan kan gälla specifika anställda eller alla.",
            "work_order.plan_modal.plan_index": "Plan {{number}}",
            "work_order.plan_modal.plans_count": "{{count}} planer",
            "work_order.plan_modal.empty_multi":
                "Inga planer ännu. Lägg till en plan med utförare och tid – du kan lägga till flera planer för olika veckor.",
            "work_order.project_plan.open_project_plan": "Öppna projektplan",
            "work_order.project_plan.untitled": "Utan titel",
            "work_order.project_plan.badge_draft": "Utkast",
            "work_order.project_plan.status_draft": "Utkast",
            "project.plan.crew.title": "Resurser",
            "project.plan.crew.subtitle": "{{count}} personer i perioden",
            "project.plan.crew.empty": "Inga resurser i vald period",
            "project.plan.crew.absent_days": "Frånvaro {{days}} dag(ar)",
            "project.plan.crew.absent_with_type": "{{type}} · {{days}} dag(ar)",
            "project.plan.crew.not_counted_summary": "Inte medräknade i planerade timmar: {{names}}",
            "project.plan.crew.not_counted_badge": "Inte medräknad",
            "project.plan.crew.not_counted_no_schedule": "0 t — saknar arbetstid, inte medräknad",
            "project.plan.crew.not_counted_sick": "0 t — sjukskrivning räknas inte",
            "project.plan.crew.open_user_short": "Öppna användare",
            "project.plan.crew.open_user": "Öppna {{name}} i en ny flik",
            "project.plan.crew.open_user": "Öppna {{name}} i en ny flik",
            "project.plan.absences.title": "Frånvaro",
            "project.plan.resource_bar.clear_selection": "Rensa filter",
            "project.plan.create_plan": "Ny plan",
            "project.plan.edit_plan": "Redigera plan",
            "project.plan.schedule_plan": "Lägg på kalender",
        "project.plan.draft_drop_missing":
              "Kunde inte hitta utkastet. Uppdatera sidan och försök igen.",
            "project.plan.toolbar.breadcrumb": "Projektplan",
            "project.plan.toolbar.new_task": "Ny uppgift",
            "project.plan.toolbar.new_absence": "+ Frånvaro",
            "project.plan.toolbar.schedule_activity": "Planera aktivitet",
            "project.plan.day_action.title": "Lägg till",
            "project.plan.day_action.subtitle": "{{date}}",
            "project.plan.day_action.add_aria": "Lägg till den {{date}}",
            "project.plan.day_action.new_plan": "Ny plan",
            "project.plan.day_action.activity": "Aktivitet",
            "project.plan.day_action.task": "Uppgift",
            "project.plan.day_action.absence": "Frånvaro",
            "project.plan.absence.title": "Registrera frånvaro",
            "project.plan.absence.help":
              "Välj anställd, frånvarotyp och period. Endast administratör kan registrera frånvaro härifrån.",
            "project.plan.absence.employee": "Anställd",
            "project.plan.absence.pick_employee": "Välj anställd",
            "project.plan.absence.type": "Frånvarotyp",
            "project.plan.absence.pick_type": "Välj frånvarotyp",
            "project.plan.absence.date_from": "Från datum",
            "project.plan.absence.date_to": "Till datum",
            "project.plan.absence.approve_now": "Godkänn frånvaron direkt",
            "project.plan.absence.approve_now_help":
              "Frånvaron markeras som godkänd direkt efter sparning.",
            "project.plan.absence.save": "Registrera frånvaro",
            "project.plan.absence.date_order_error": "Till-datum kan inte vara före från-datum",
            "project.plan.absence.save_error": "Kunde inte registrera frånvaro",
            "project.plan.absence.approve_error": "Frånvaron sparades, men godkännandet misslyckades",
            "project.plan.absence.toast_created": "Frånvaro är registrerad",
            "project.plan.absence.toast_created_approved": "Frånvaro är registrerad och godkänd",
            "project.plan.resource_day.title": "Resurs",
            "project.plan.resource_day.untitled": "Utan titel",
            "project.plan.resource_day.employee": "Anställd",
            "project.plan.resource_day.edit": "Redigera",
            "project.plan.resource_day.delete": "Ta bort denna dag",
            "project.plan.resource_day.delete_confirm":
              "Ta bort {{name}} från {{date}}? Endast denna dag tas bort.",
            "project.plan.resource_day.delete_toast": "Resursdagen är borttagen",
            "project.plan.resource_day.delete_error": "Kunde inte ta bort resursdagen",
            "project.plan.resource_row.add_day_hint": "Klicka för att lägga till denna dag för resursen",
            "project.plan.schedule_confirm": "Lägg på kalender",
            "project.plan.schedule_activity.pick_title": "Välj projektaktivitet",
            "project.plan.schedule_activity.pick_help":
              "Välj aktiviteten att planera. Beskrivning är valfri — titeln hämtas från aktiviteten.",
            "project.plan.schedule_activity.pick_required": "Välj en aktivitet",
            "project.plan.schedule_activity.continue": "Fortsätt till planering",
            "project.plan.schedule_activity.crew_section": "Personal",
            "project.plan.schedule_activity.days_section": "Dagar",
            "project.plan.schedule_activity.budget_hours_hint": "Budget: {{hours}} t (standard)",
            "project.plan.schedule_activity.save": "Spara plan",
            "project.plan.schedule_activity.toast_created": "Aktiviteten lades på kalendern",
            "project.plan.schedule_activity.toast_updated": "Planeringen uppdaterades",
            "project.plan.toolbar.week": "Vecka",
            "project.plan.toolbar.fortnight": "2 veckor",
            "project.plan.toolbar.month": "Månad",
            "project.plan.toolbar.today": "Idag",
            "project.plan.toolbar.density": "Täthet",
            "project.plan.toolbar.density_compact": "Kompakt",
            "project.plan.toolbar.density_comfortable": "Normal",
            "project.plan.toolbar.density_spacious": "Rymlig",
            "project.plan.stats.events": "Händelser",
            "project.plan.stats.scheduled_hours": "Planerade timmar",
            "project.plan.stats.crew": "Personal",
            "project.plan.stats.unscheduled": "Oplanerat",
            "project.plan.schedule.title_create": "Lägg plan på kalender",
            "project.plan.schedule.title_edit": "Redigera kalenderplan",
            "project.plan.schedule.open_work_order_edit": "Öppna arbetsorder (redigera)",
            "project.plan.schedule.open_project_activity": "Öppna projektaktivitet",
            "project.plan.schedule.create_work_order_later": "Skapa arbetsorder senare",
            "project.plan.schedule.edit_project_event": "Redigera planhändelse",
            "project.plan.schedule.edit_project_event_hint":
                "Titel, beskrivning, länkar och resurser utanför veckoplaneringen.",
            "project.plan.schedule.activity_title_create": "Planera projektaktivitet",
            "project.plan.schedule.activity_title_edit": "Redigera planering (aktivitet)",
            "project.plan.schedule.activity_plan_hint":
                "Enklare planering utan arbetsorder. Du kan skapa AO vid behov.",
            "project.event.create": "Skapa händelse",
            "project.event.edit": "Redigera händelse",
            "project.event.title": "Titel",
            "project.event.title_required": "Titel krävs",
            "project.event.title_placeholder": "Ange händelsetitel",
            "project.event.description": "Beskrivning",
            "project.event.description_placeholder": "Ange händelsebeskrivning",
            "project.event.start_date": "Startdatum",
            "project.event.start_date_required": "Startdatum krävs",
            "project.event.end_date": "Slutdatum",
            "project.event.end_date_invalid": "Slutdatum måste vara efter startdatum",
            "project.event.days": "Dagar",
            "project.event.days_placeholder": "Antal dagar",
            "project.event.project": "Projekt",
            "project.event.work_order": "Arbetsorder",
            "project.event.resources": "Resurser (personal)",
            "project.event.add_resource": "Lägg till resurs",
            "project.event.add_resource_one_day": "Lägg till personal (startdatum)",
            "project.event.no_resources": "Inga resurser tillagda. Lägg till personal som ska arbeta med denna händelse.",
            "project.event.resource": "Resurs",
            "project.event.resource_employee": "Personal",
            "project.event.resource_start_time": "Starttid",
            "project.event.resource_end_time": "Sluttid",
            "project.event.save_error": "Ett fel uppstod vid sparande av händelsen. Försök igen.",
            "project.event.work_orders_linked": "Kopplade arbetsordrar",
            "project.event.select_work_orders": "Välj arbetsordrar",
            "project.event.activities_linked": "Kopplade aktiviteter",
            "project.event.select_activities": "Välj aktiviteter",
            "project.event.sync_resource_dates": "Synkronisera resursdatum med händelsen",
            "project.event.conflict_warning": "Resurskonflikt — kontrollera tider",
            "project.event.conflict_plan": "Plan: {{title}} ({{time}})",
            "project.event.conflict_calendar": "Kalender: {{title}} ({{time}})",
            "project.event.resource_hours": "Timmar",
            "project.event.resource_hours_unit": "t",
            "project.event.resource_hours_manual": "Manuellt antal timmar",
            "project.event.resource_hours_pick_start": "Välj starttid för att beräkna timmar",
            "project.plan.toolbar.project_task": "Uppgift / projekt",
            "project.plan.toolbar.prev": "Föregående period",
            "project.plan.toolbar.next": "Nästa period",
            "project.plan.toolbar.week_range": "Vecka {{week}} · {{range}}",
            "project.plan.toolbar.fortnight_range": "Vecka {{weekFrom}}–{{weekTo}} · {{range}}",
            "project.plan.schedule.week_short": "V. {{week}}",
            "project.plan.sidebar.title": "Projekt",
            "project.plan.sidebar.active": "aktiva",
            "project.plan.sidebar.search_placeholder": "Sök projekt, kund eller kod…",
            "project.plan.sidebar.all_projects": "Alla projekt",
            "project.plan.unscheduled.title": "Oplanerat",
            "project.plan.no_draft_plans": "Inga utkast att planera",
            "project.plan.unscheduled.drag_hint": "Dra till kalendern för att planera",
            "project.plan.multi_link_hint": "Du kan koppla flera. En markeras som primär.",
            "project.plan.primary_link": "Primär",
            "project.plan.set_primary": "Sätt som primär",
            "project.plan.no_work_orders_yet": "Inga arbetsordrar kopplade ännu",
            "project.plan.include_work_order_description": "Inkludera beskrivning från arbetsorder",
            "project.plan.no_activities_yet": "Inga aktiviteter kopplade ännu",
            "project.plan.save_plan": "Spara plan",
            "project.plan.multi_select_selected": "{{count}} valda",
            "project.plan.add_selected": "Lägg till valda ({{count}})",
            "project.plan.view_period": "Periodvy",
            "project.plan.view_day": "Dagsvy",
            "project.plan.settings.display": "Visning",
            "project.plan.settings.display_subtitle": "Välj hur projektplanen visas",
            "project.plan.settings.resource_plan": "Resursplan",
            "project.plan.settings.resource_plan_subtitle": "Öppna resursplan och kapacitet för valt projekt",
            "project.plan.settings.open_resource_plan": "Öppna resursplan",
            "project.plan.settings.select_project": "Välj ett projekt för att öppna resursplanen",
            "project.plan.resource_bar.title": "Resurser denna dag",
            "project.plan.resource_bar.subtitle": "Klicka för att filtrera kalendern",
            "project.plan.resource_bar.subtitle_date": "{{date}} — klicka för att filtrera",
            "project.plan.resource_bar.empty": "Inga resurser denna dag",
            "project.plan.resource_bar.planned_hours": "{{hours}} t planerat",
            "project.plan.day_view.employee": "Personal",
            "project.plan.day_view.empty": "Inga planerade uppgifter denna dag",
            "project.plan.day_view.hint": "Dra resurser från personallistan för att tilldela",
            "nav.documentation": "Dokumentation",
            "calendar.quick_views.aria": "Snabbvyer",
            "calendar.quick_views.calendar": "Kalender",
            "calendar.quick_views.project_plan": "Projektplan",
            "calendar.quick_views.crew": "Personal",
            "calendar.quick_views.resource_plan": "Resursplan",
            "calendar.plan_event.title": "Planuppgift",
            "calendar.plan_event.status_completed": "Slutförd",
            "calendar.plan_event.status_assigned": "Planerad",
            "calendar.plan_event.project_context_title": "Projekt",
            "calendar.plan_event.project_no_description": "Ingen projektbeskrivning",
            "calendar.plan_event.task_description": "Uppgift / aktivitet",
            "calendar.plan_event.open_project": "Öppna projekt",
            "calendar.plan_event.open_work_order": "Öppna arbetsorder",
            "calendar.plan_event.open_project_activity": "Öppna aktivitet i projekt",
            "calendar.plan_event.related_report": "Relaterad rapport",
            "calendar.plan_event.mark_my_task_complete": "Markera min uppgift som klar",
            "calendar.plan_event.register_hours": "Registrera timmar",
            "calendar.plan_event.open_project_plan": "Öppna projektplan",
            "calendar.plan_event.load_error": "Kunde inte ladda planhändelser",
            "calendar.plan_event.complete_validation.activity_status": "Välj status för alla aktiviteter",
            "calendar.plan_event.complete_validation.description": "Beskrivning krävs",
            "calendar.plan_event.complete_validation.photos": "Ladda upp minst ett foto per arbetsorder",
            "calendar.plan_event.completed": "Uppgiften markerades som klar",
            "calendar.plan_event.complete_error": "Kunde inte slutföra uppgiften",
            "calendar.plan_event.complete_dialog.title": "Slutför planuppgift",
            "calendar.plan_event.complete_dialog.simple_confirm": "Bekräfta att du har slutfört din del av uppgiften.",
            "calendar.plan_event.complete_dialog.intro": "Uppdatera status, beskrivning och dokumentation innan du slutför.",
            "calendar.plan_event.complete_dialog.activities": "Aktiviteter",
            "calendar.plan_event.complete_dialog.work_orders": "Arbetsordrar",
            "calendar.plan_event.complete_dialog.work_order_outcome.ongoing": "Pågår",
            "calendar.plan_event.complete_dialog.work_order_outcome.finished": "Klar",
            "calendar.plan_event.photos": "Bilder",
            "calendar.plan_event.complete_dialog.photos_count": "bilder",
            "calendar.plan_event.complete_dialog.work_description": "Arbetsbeskrivning",
            "calendar.plan_event.complete_dialog.work_description_placeholder": "Beskriv utfört arbete…",
            "calendar.plan_event.complete_dialog.work_description_hint": "Beskriv vad som gjorts — synligt i rapport och historik.",
            "calendar.plan_event.complete_dialog.submit": "Slutför och spara",
            "report.participants.title": "Tillagda utförare",
            "report.participants.subtitle":
              "Extra fältpersonal och observatörer (alla syns i kalendern). Ansvarig utförare från avtalet anges under Utförare på avtalet.",
            "report.participants.add": "Lägg till",
            "report.participants.add_first": "Lägg till första",
            "report.participants.none": "Inga extra utförare utöver avtalet.",
            "report.participants.user": "Användare",
            "report.participants.role": "Roll",
            "report.participants.status": "Status",
            "report.participants.choose_role": "Välj roll",
            "report.participants.choose_status": "Välj status",
            "report.participants.edit": "Redigera",
            "report.participants.delete": "Ta bort",
            "report.participants.delete_confirm":
              "Ta bort den här personen från rapporten?",
            "report.participants.delete_error": "Kunde inte ta bort",
            "report.participants.save_error": "Kunde inte spara",
            "report.participants.created": "Tillagd",
            "report.participants.updated": "Uppdaterad",
            "report.participants.updating": "Uppdaterar…",
            "report.participants.adding": "Lägger till…",
            "report.participants.error_is_executing_employee":
              "Den här användaren är redan ansvarig utförare i avtalet. Välj någon annan eller ändra utförare i avtalet först.",
            "Use card view": "Använd kortvy",
            "Switch to card overview layout": "Byt till kortöversikt",
            "Switch to compact table layout": "Byt till tabellvy",
            "contact": "Kontakt",
            "service_agreement": "Serviceavtal",
            "order": "Order",
            "product": "Produkt",
            "folder": "Mapp",
      
            // Control Panel / Sentralbord translations
            "control.panel": "Kontrollpanel",
            "control.panel.overview":
              "Dashboard för systemintegrationer och övervakning",
            "overview": "Översikt",
            "queues": "Köer",
            "calls": "Samtalhistorik",
            "persons": "Personer",
            "settings": "Inställningar",
            "Bruker som håndterer egenmelding": "Användare som hanterar frånvaro",
            "Velg administrator": "Välj administratör",
            "Velg en administrator som skal håndtere egenmeldinger": "Välj en administratör som ska hantera frånvaro",
            "control.panel.overview.title": "Kontrollpanel Översikt",
            "control.panel.overview.description":
              "Dashboard för alla integrationer och system",
            "current.phone.status": "Aktuell Telefonstatus",
            "phone.status": "Telefonstatus",
            "phone.details.status": "Telefonstatus detaljer",
            "connected.to.phonero": "Ansluten till Phonero",
            "not.connected.to.phonero": "Inte ansluten till Phonero-system",
            "change.status": "Ändra Status",
            "not.connected.to.phone.system": "Inte ansluten till telefonsystem",
            "phonero.status": "Phonero Status",
            "not.configured": "Inte konfigurerad",
            "view.details": "Se detaljer",
            "system.status": "Systemstatus",
            "all.systems.operational": "Alla system operativa",
            "last.updated": "Senast uppdaterad",
            "quick.actions": "Snabbval",
            "configure": "Konfigurera",
            "phonero.queues": "Phonero Köer",
            "monitor.manage.queues": "Övervaka och hantera samtaleköer",
            "call.log": "Samtalhistorik",
            "view.call.history": "Se samtalhistorik och detaljer",
            "phonero.persons": "Phonero Personer",
            "manage.persons.phone": "Hantera personer och deras telefoninställningar",
            "control.panel.settings": "Kontrollpanel Inställningar",
            "configure.control.panel": "Konfigurera kontrollpanel och integrationer",
            "integrations": "Integrationer",
            "manage.all.integrations": "Hantera alla systemintegrationer",
            "phone.integration": "Telefonintegration",
      
            // Phonero presence statuses
            "presence.available": "Tillgänglig",
            "presence.busy": "Upptagen",
            "presence.away": "Borta",
            "presence.unknown": "Okänd",
            "presence.connected": "Ansluten till Phonero",
            "presence.not.available": "Tillgänglighetsstatus inte tillgänglig",
            "presence.failed.to.load": "Kunde inte ladda tillgänglighetsdata",
            "presence.updated.successfully": "Tillgänglighet uppdaterad",
            "presence.failed.to.update": "Kunde inte uppdatera tillgänglighet",
            "presence.cannot.update":
              "Kan inte uppdatera tillgänglighet - användare hittades inte i Phonero",
            "Nytt system": "Nytt system",
            // Events sidebar and scheduling
            "Events": "Händelser",
            "Your schedule for the selected day": "Ditt schema för vald dag",
            "Loading events...": "Laddar händelser...",
            "No events to show": "Inga händelser att visa",
            "Event": "Händelse",
            "Conflict": "Konflikt",
            "item_list_handling.pick_progress_short": "{{picked}}/{{total}} plockade",
            "item_list_handling.pick_progress_tooltip": "Hanteringslista: {{picked}} av {{total}} rader plockade. Liststatus: {{status}}.",
            "Planned time": "Planerad tid",
            "Start": "Start",
            "End": "Slut",
            "Location": "Plats",
            "Assumed 60 min duration for conflict check": "Antagen varaktighet 60 min för konfliktkontroll",
            "Executing Employee": "Utförare",
            "Agreement date": "Avtalsdatum",
            "Fixed time": "Fast tid",
            "Timeframe from": "Tidsram från",
            "Timeframe to": "Tidsram till",
            "Appointment confirmation required": "Bekräftelse av avtal krävs",
            "Send email to customer": "Skicka e-post till kund",
            "Phone number": "Telefonnummer",
            "Email address": "E-postadress",
            "Manually confirm agreement": "Bekräfta avtal manuellt",
            "Send confirmation reminder": "Skicka bekräftelsepåminnelse",
      
            // Customer Handler translations
            "customer.handler": "Kundebehandleren",
            "customer.handler.description": "Sök efter kunder, skapa samtal och administrera kundkommunikation",
            "customer.handler.selected.section": "Vald kund",
            "customer.handler.related.information": "Relaterad information",
            "customer.handler.open.customer.profile": "Öppna kundprofil",
            "customer.handler.open.customer.profile.hint": "Öppnar kundprofilen i en ny flik",
            "customer.handler.no.contact.info": "Ingen adress, e-post eller mobil registrerad",
            "customer.handler.edit.customer": "Redigera kund",
            "customer.handler.edit.communication": "Redigera",
            "customer.handler.communication.subject": "Ämne",
            "customer.handler.communication.body": "Innehåll",
            "customer.handler.communication.update.success": "Kommunikation uppdaterad",
            "search.customer": "Sök kund",
            "search.by.mobile.or.address": "Sök efter mobilnummer eller adress",
            "search.by.mobile.or.address.hint": "Ange mobilnummer eller adress för att söka",
            "searching": "Söker...",
            "search": "Sök",
            "search.results": "Sökresultat",
            "search.failed": "Sökningen misslyckades",
            "search.failed.server.error": "Serverfel uppstod",
            "search.failed.server.error.message": "Ett fel uppstod under sökningen. Försök igen. Skapa inte en ny kund om du tror att kunden redan finns.",
            "search.failed.unexpected.response": "Oväntat svar från servern",
            "search.error.title": "Sökfel",
            "search.error.hint": "Försök söka igen. Om problemet kvarstår, kontakta support. Skapa inte en duplicerad kund.",
            "create.conversation": "Skapa samtal",
            "name.or.mobile.required": "Namn eller mobilnummer krävs",
            "unknown.customer": "Okänd kund",
            "conversation.saved": "Samtal sparad",
            "conversation.saved.and.handled": "Samtal sparad och hanterad",
            "failed.to.create.customer": "Kunde inte skapa kund",
            "communication.added": "Kommunikation tillagd",
            "failed.to.add.communication": "Kunde inte lägga till kommunikation",
            "communication.marked.processed": "Kommunikation markerad som hanterad",
            "communication.marked.unprocessed": "Kommunikation markerad som ohanterad",
            "failed.to.update.communication": "Kunde inte uppdatera kommunikation",
            "no.communications.selected": "Inga kommunikationer valda",
            "communications.linked.to.case": "Kommunikationer kopplade till ärende",
            "failed.to.link.communications": "Kunde inte koppla kommunikationer",
            "selected.communications": "Valda kommunikationer",
            "link.to.case": "Koppla till ärende",
            "see.more": "Se mer",
            "mark.as.processed": "Markera som hanterad",
            "channel": "Kanal",
            "direction": "Riktning",
            "sent.at": "Skickad",
            "start.time": "Starttid",
            "end.time": "Sluttid",
            "related": "Relaterad",
            "processed": "Hanterad",
            "unprocessed": "Ohanterad",
            "created.by": "Skapad av",
            "street.address": "Gatuadress",
            "postal.code": "Postnummer",
            "city": "Stad",
            "conversation.date": "Samtalsdatum",
            "conversation.time": "Samtalstid",
            "conversation.note.placeholder": "Lägg till anteckning om samtalet...",
            "save": "Spara",
            "handle": "Hantera",
            "selected.customer": "Vald kund",
            "loading": "Laddar...",
            "loading.customer": "Laddar kund...",
            "communications": "Kommunikationer",
            "inbound": "Inkommande",
            "outbound": "Utgående",
            "no.communications": "Inga kommunikationer hittades",
            "no.cases": "Inga ärenden hittades",
            "upcoming.events": "Kommande händelser",
            "no.events": "Inga händelser hittades",
            "add.communication": "Lägg till kommunikation",
            "pending": "Väntar",
            "handled": "Hanterad",
            "Communication": "Kommunikation",
            "Message": "Meddelande",
            "Channel": "Kanal",
            "Direction": "Riktning",
            "link.to.case.choice.description": "Vill du länka till ett befintligt ärende eller skapa ett nytt?",
            "link.to.existing.case": "Länka till befintligt ärende",
            "link.to.existing.case.description": "Sök och välj ett befintligt ärende",
            "create.new.case": "Skapa nytt ärende",
            "create.new.case.description": "Skapa ett nytt ärende och länka kommunikationer",
            "search.case": "Sök ärende",
            "search.case.placeholder": "Sök efter ärendenummer, titel eller kund...",
            "no.cases.found": "Inga ärenden hittades",
            "cases": "Ärenden",
            "customer.cases": "Kundens ärenden",
            "linking.communications": "Länkar kommunikationer...",
            "treatment.section": "Behandlingssektion",
            "treatment.section.description": "Alla kommunikationer som kräver behandling",
            "search.communications": "Sök kommunikationer...",
            "all.statuses": "Alla statusar",
            "all.channels": "Alla kanaler",
            "phone": "Telefon",
            "email": "E-post",
            "sms": "SMS",
            "showing": "Visar",
            "of": "av",
            "customer.lock.badge": "Låst",
            "customer.lock.banner_title": "Kunden {{name}} är låst",
            "customer.lock.banner_reason": "Orsak: {{reason}}",
            "customer.lock.banner_meta": "Låst av {{who}} {{when}}",
            "customer.lock.no_reason": "Ingen orsak angiven",
            "customer.lock.unknown_user": "Okänd",
            "customer.lock.open_profile": "Öppna kundprofil",
            "customer.lock.lock_title": "Lås kund",
            "customer.lock.unlock_title": "Lås upp kund",
            "customer.lock.lock_action": "Lås kund",
            "customer.lock.unlock_action": "Lås upp",
            "customer.lock.reason_label": "Varför låses kunden?",
            "customer.lock.reason_required": "Du måste ange en orsak",
            "customer.lock.unlock_help": "Kunden kan användas för nya rapporter, projekt och ordrar igen.",
            "customer.lock.unlock_note": "Anteckning (valfritt)",
            "customer.lock.current_reason": "Nuvarande orsak: {{reason}}",
            "customer.lock.lock_success": "Kunden är låst",
            "customer.lock.unlock_success": "Kunden är upplåst",
            "customer.lock.save_failed": "Kunde inte uppdatera lås",
            "customer.lock.create_blocked": "Kunden är låst. Du kan inte skapa nya poster eller flytta befintliga hit.",
            "customer.lock.reason_too_long": "Orsaken får inte vara längre än {{max}} tecken",
            "customer.lock.note_too_long": "Anteckningen får inte vara längre än {{max}} tecken",
            "customer.communication.export_pdf": "Exportera PDF",
            "customer.communication.pdf_loading": "Skapar PDF…",
            "customer.communication.pdf_failed": "Kunde inte skapa PDF",
            "customer.loaded": "Kund laddad",
            "customer.not.found": "Kund hittades inte",
            "failed.to.load.communications": "Kunde inte ladda kommunikationer",
            "failed.to.load.customer": "Kunde inte ladda kund",
      
            // Inventory Count translations (Swedish)
            "inventory.counts.title": "Lagerräkningar",
            "inventory.counts.description": "Hantera lagerräkningar och lagerkontroll",
            "inventory.count.title": "Lagerräkning",
            "inventory.count.create": "Ny räkning",
            "inventory.count.count_number": "Räkningsnummer",
            "inventory.count.date": "Datum",
            "inventory.count.status": "Status",
            "inventory.count.status.draft": "Utkast",
            "inventory.count.status.pending_approval": "Väntar på godkännande",
            "inventory.count.status.approved": "Godkänd",
            "inventory.count.status.completed": "Slutförd",
            "inventory.count.add_item": "Lägg till rad",
            "inventory.count.select_product": "Välj produkt",
            "inventory.count.scan_qr": "Skanna QR-kod",
            "inventory.count.import_csv": "Importera CSV/Excel",
            "inventory.count.selected_products": "Valda produkter",
            "inventory.count.item_number": "Artikelnr",
            "inventory.count.remove": "Ta bort",
            "inventory.count.note_optional": "Anteckning (valfritt)",
            "inventory.count.note_placeholder": "Lägg till anteckning...",
            "inventory.count.reset": "Återställ",
            "inventory.count.add_products": "Lägg till produkter",
            "inventory.count.add_product": "Lägg till produkt",
            "inventory.count.add_scanned_product": "Lägg till skannat produkt",
            "inventory.count.scan_another": "Skanna ett annat",
            "inventory.count.select_products": "Välj produkter",
            "inventory.count.products_selected": "{{count}} produkt(er) valda",
            "inventory.count.qr.required": "Ange eller skanna en QR-kod",
            "inventory.count.qr.placeholder": "Ange produktnummer eller skanna QR-kod",
            "inventory.count.product.already_selected": "Produkten är redan vald",
            "inventory.count.product.added": "Produkt tillagd",
            "inventory.count.product.not_found": "Produkt hittades inte. Försök manuell sökning.",
            "inventory.count.product.search_error": "Kunde inte söka efter produkt",
            "inventory.count.product.select_required": "Välj minst en produkt",
            "inventory.count.items": "Rader",
            "inventory.count.product": "Produkt",
            "inventory.count.quantity": "Mängd",
            "inventory.count.purchase_price": "Inköpspris",
            "inventory.count.total": "Totalt",
            "inventory.count.note": "Anteckning",
            "inventory.count.total_items": "Antal rader",
            "inventory.count.total_quantity": "Total mängd",
            "inventory.count.no_items": "Inga rader",
            "inventory.count.no_items_description": "Lägg till rader för att starta räkningen",
            "inventory.count.item.added": "Rad tillagd",
            "inventory.count.item.add_error": "Kunde inte lägga till rad",
            "inventory.count.item.updated": "Rad uppdaterad",
            "inventory.count.item.update_error": "Kunde inte uppdatera rad",
            "inventory.count.item.deleted": "Rad borttagen",
            "inventory.count.item.delete_error": "Kunde inte ta bort rad",
            "inventory.count.item.delete_confirm": "Är du säker på att du vill ta bort denna rad?",
            "inventory.count.quantity_required": "Mängd måste vara större än 0",
            "inventory.count.csv.import_title": "Importera rader från CSV/Excel",
            "inventory.count.csv.drop_here": "Släpp fil här",
            "inventory.count.csv.drop_or_select": "Dra och släpp en fil här, eller klicka för att välja",
            "inventory.count.csv.supported_formats": "CSV, XLS, XLSX",
            "inventory.count.csv.file_selected": "Fil vald",
            "inventory.count.csv.change_file": "Byt fil",
            "inventory.count.csv.column_mapping": "Kolummmappning",
            "inventory.count.csv.field.product_id": "Produkt ID",
            "inventory.count.csv.field.item_number": "Artikelnr",
            "inventory.count.csv.field.title": "Titel",
            "inventory.count.csv.field.quantity": "Mängd",
            "inventory.count.csv.field.purchase_price": "Inköpspris",
            "inventory.count.csv.field.note": "Anteckning",
            "inventory.count.csv.not_mapped": "Inte mappad",
            "inventory.count.csv.preview": "Förhandsvisning",
            "inventory.count.csv.first_rows": "första raderna",
            "inventory.count.csv.import": "Importera",
            "inventory.count.csv.importing": "Importerar...",
            "inventory.count.csv.import_success": "Importerade {{count}} rader",
            "inventory.count.csv.import_error": "Kunde inte importera rader",
            "inventory.count.csv.bulk_create_error": "Kunde inte skapa produkter i bulk",
            "inventory.count.csv.mapping_required": "Vänligen mappa minst Produkt ID eller Artikelnr",
            "inventory.count.csv.missing_products_title": "Produkter hittades inte",
            "inventory.count.csv.missing_products_message": "{{count}} produkt(er) hittades inte i systemet. Välj åtgärd för varje:",
            "inventory.count.csv.action": "Åtgärd",
            "inventory.count.csv.add_as_new": "Lägg till som ny produkt",
            "inventory.count.csv.skip": "Hoppa över",
            "inventory.count.csv.continue_import": "Fortsätt import",
            "inventory.count.csv.processing_items": "Bearbetar {{current}} av {{total}} produkter",
            "inventory.count.csv.processing": "Bearbetar...",
            "inventory.count.csv.partial_import_success": "Importerade {{imported}} rader, {{missing}} produkter hittades inte",
            "inventory.count.csv.no_items_to_import": "Inga rader att importera",
            "inventory.count.csv.no_headers": "Kunde inte upptäcka CSV-rubriker",
            "inventory.count.csv.read_error": "Fel vid läsning av fil",
            "inventory.count.csv.processing_error": "Fel vid bearbetning av fil",
            "inventory.count.csv.product_not_found": "Produkt hittades inte",
            "inventory.count.csv.product_search_error": "Fel vid sökning efter produkt",
            "inventory.count.csv.product_id_required": "Produkt ID eller Artikelnr krävs",
            "inventory.count.csv.no_valid_items": "Inga giltiga rader hittades i filen",
            "inventory.count.duplicate.title": "Produkt finns redan i listan",
            "inventory.count.duplicate.message": "Denna produkt finns redan i räkningslistan. Vill du lägga till ytterligare en rad?",
            "inventory.count.duplicate.added_at": "Tillagd",
            "inventory.count.duplicate.confirm": "Lägg till rad",
            "inventory.counts.search_placeholder": "Sök i lagerräkningar...",
            "inventory.counts.filter_title": "Filtrera på status",
            "inventory.count.new_title": "Ny lagerräkning",
            "inventory.count.title_required": "Titel krävs",
            "inventory.count.date_required": "Datum krävs",
            "inventory.count.storage_required": "Lager krävs",
            "inventory.count.storage": "Lager",
            "inventory.count.coverage": "Täckning",
            "inventory.count.coverage_full": "Full inventering av lagret",
            "inventory.count.coverage_partial": "Partiell räkning",
            "inventory.count.coverage_help": "Full inventering krävs för ingående lagervärde. Nya räkningar med valt lager sparas som fulla. Godkända partiella räkningar kan markeras som fulla här.",
            "inventory.count.mark_coverage_full": "Markera som full inventering",
            "inventory.count.mark_coverage_partial": "Markera som partiell",
            "inventory.count.coverage_set_full": "Räkningen är markerad som full täckning",
            "inventory.count.coverage_set_partial": "Räkningen är markerad som partiell",
            "inventory.count.coverage_update_error": "Kunde inte uppdatera täckning",
            "inventory.count.missing_cost_warning_title": "Kostpris saknas på räkningen",
            "inventory.count.missing_cost_warning_body": "{{count}} rad(er) med antal saknar kostpris. Fyll i inköpspris eller välj från prishistorik före godkännande av lagervärde.",
            "inventory.count.missing_cost_line": "Kostpris saknas",
            "inventory.count.load_price_history": "Hämta prishistorik",
            "inventory.count.retry_price_history": "Försök prishistorik igen",
            "inventory.count.price_history": "Historisk kostpris",
            "inventory.count.use_history_for_count_date": "Använd pris för inventeringsdatum",
            "inventory.count.price_history_load_error": "Kunde inte hämta prishistorik",
            "inventory.count.price_history_empty": "Hittade ingen historisk kostpris för inventeringsdatumet",
            "inventory.count.select_storage": "Välj lager",
            "inventory.count.create_success": "Lagerräkning skapad",
            "inventory.count.create_error": "Kunde inte skapa lagerräkning",
            "inventory.count.approve": "Godkänn",
            "inventory.count.unapprove": "Avgodkänn",
            "inventory.count.approve_all": "Godkänn alla",
            "inventory.count.unapprove_all": "Avgodkänn alla",
            "inventory.count.approve_all_success": "{{count}} rader godkända",
            "inventory.count.approve_all_error": "Kunde inte godkänna alla rader",
            "inventory.count.all_items_already_approved": "Alla rader är redan godkända",
            "inventory.count.approved": "Godkänd",
            "inventory.count.approved_at": "Godkänd",
            "inventory.count.approved_by": "Godkänd av",
            "inventory.count.approve_success": "Räkning godkänd",
            "inventory.count.approve_error": "Kunde inte godkänna räkning",
            "inventory.count.unapprove_success": "Räkning avgodkänd",
            "inventory.count.unapprove_error": "Kunde inte avgodkänna räkning",
            "inventory.count.copy": "Kopiera räkning",
            "inventory.count.no_title": "Ingen titel",
            "inventory.count.could_not_load": "Kunde inte ladda lagerräkningar",
            "inventory.count.no_counts_found": "Inga lagerräkningar hittades",
            "inventory.count.create_new": "Skapa en ny lagerräkning",
            "selected": "vald",
            "Select": "Välj",
            "Select all": "Välj alla",
            "Updated": "Uppdaterad",
            "Created": "Skapad",
            "inventory.count.copy_from_previous": "Kopiera från tidigare räkning",
            "inventory.count.copy_all_products": "Kopiera alla produkter från lager",
            "inventory.count.select_count_to_copy": "Välj räkning att kopiera",
            "inventory.count.copy_success": "Räkning kopierad",
            "inventory.count.copy_error": "Kunde inte kopiera räkning",
            "inventory.count.copy_products_success": "Produkter kopierade",
            "inventory.count.copy_products_error": "Kunde inte kopiera produkter",
            "inventory.count.approved_items": "Godkända rader",
            "inventory.count.approve_count": "Godkänn räkning",
            "inventory.count.date_updated": "Datum uppdaterat",
            "inventory.count.date_update_error": "Kunde inte uppdatera datum",
            "inventory.count.storage_updated": "Lager uppdaterat",
            "inventory.count.storage_update_error": "Kunde inte uppdatera lager",
            "inventory.count.no_storage": "Inget lager",
            "inventory.count.export_pdf": "Exportera PDF",
            "inventory.count.export_csv": "Exportera CSV/Excel",
            "inventory.count.export_pdf_success": "PDF exporterad",
            "inventory.count.export_pdf_error": "Kunde inte exportera PDF",
            "inventory.count.export_csv_success": "CSV exporterad",
            "inventory.count.export_csv_error": "Kunde inte exportera CSV",
            "product.stock_report.title": "Lagerrapport",
            "product.stock_report.description": "Komplett översikt över alla lagerrörelser (in/ut) och var produkten är registrerad (lagerräkning, korrektion, order, rapport, etc.)",
            "product.stock_report.count_sets_hint": "Godkänd lagerräkning sätter nytt saldo för produkten på lagret. Räknat antal summeras inte ovanpå föregående saldo.",
            "product.stock_report.quantity_set": "Sätt till {{quantity}}",
            "product.stock_report.quantity_set_delta": "Justering {{quantity}}",
            "product.stock_report.quantity_not_counted": "Inte räknad",
            "product.stock_report.date": "Datum",
            "product.stock_report.type": "Typ",
            "product.stock_report.transaction_title": "Titel",
            "product.stock_report.quantity": "Antal",
            "product.stock_report.storage": "Lager",
            "product.stock_report.status": "Status",
            "product.stock_report.approved": "Godkänd",
            "product.stock_report.pending": "Väntar",
            "product.stock_report.no_transactions": "Inga transaktioner",
            "product.stock_report.no_transactions_description": "Inga lagerrörelser hittades för denna produkt",
            "Processing...": "Bearbetar...",
            
            // Offer Calculation translations (Swedish)
            "offer.calculation.title": "Kalkyler / Offer Items",
            "offer.calculation.subtitle": "Hantera kalkyler och offer items",
            "offer.calculation.new": "Ny kalkyl",
            "offer.calculation.create.dialog_title": "Ny kalkyl",
            "offer.calculation.create.dialog_hint": "Välj kalkylupplägg och ange titel innan du öppnar byggaren. Upplägget låses efter skapande.",
            "offer.calculation.create.mode_subtitle": "Välj om kalkylen ska använda rader eller modulbyggaren.",
            "offer.calculation.create.title_label": "Titel",
            "offer.calculation.create.title_required": "Titel krävs",
            "offer.calculation.create.description_label": "Beskrivning",
            "offer.calculation.create.cancel": "Avbryt",
            "offer.calculation.create.submit": "Skapa och öppna",
        "offer.calculation.create.use_template": "Använd befintlig mall",
        "offer.calculation.create.use_template_hint": "Kopiera innehållet från en företagsmall till en ny kalkyl. Valfri TPL-guide körs när mallen kräver det.",
            "offer.calculation.search_placeholder": "Sök i kalkyler...",
            "offer.calculation.name": "Namn",
            "offer.calculation.type": "Typ",
            "offer.calculation.status": "Status",
            "offer.calculation.total": "Totalt",
            "offer.calculation.actions": "Åtgärder",
            "offer.calculation.view": "Visa",
            "offer.calculation.edit": "Redigera",
            "offer.calculation.delete": "Ta bort",
            "offer.calculation.delete_confirm": "Är du säker på att du vill ta bort denna kalkylen?",
            "offer.calculation.no_results": "Inga kalkyler hittades",
            "offer.calculation.active": "Aktiv",
            "offer.calculation.inactive": "Inaktiv",
            "offer.calculation.type.standard": "Standard",
            "offer.calculation.type.product": "Produkt",
            "offer.calculation.type.hours": "Timmar",
            "offer.calculation.type.car_allowance": "Bilgodtgörelse",
            "offer.calculation.type.nested": "Nästad",
            "offer.calculation.line": "rad",
            "offer.calculation.lines": "rader",
            "offer.calculation.delete_success": "Kalkyl borttagen",
            "offer.calculation.delete_error": "Kunde inte ta bort kalkyl",
            "offer.calculation.untitled": "Utan titel",
            "offer.calculation.mode.title": "Välj kalkylupplägg",
            "offer.calculation.mode.subtitle": "Välj om denna kalkyl ska använda vanliga rader eller modulbyggaren. Detta låses efter att kalkylen har sparats.",
            "offer.calculation.mode.lines_title": "Radkalkyl",
            "offer.calculation.mode.lines_hint": "Använd befintlig radbaserad kalkyl med produkter, timmar och manuella rader.",
            "offer.calculation.mode.modules_title": "Modulbyggare",
            "offer.calculation.mode.modules_hint": "Bygg ett visuellt flöde med produkter, timmar, formler och pilar.",
            "offer.calculation.mode.locked_hint": "Kalkylupplägg är låst efter skapande för att undvika att rader och modulbyggare blandas.",
            "offer.calculation.settings.open": "Inställningar",
            "offer.calculation.settings.title": "Kalkylinställningar",
            "offer.calculation.settings.subtitle": "Titel, kalkylupplägg och visning.",
            "offer.calculation.settings.done": "Klar",
            "offer.calculation.settings.unsaved": "Osparade ändringar",
            "offer.calculation.settings.save_hint": "Spara med sparraden längst ned på sidan.",
            "offer.calculation.builder.section_title": "Kalkylbyggare",
            "offer.calculation.builder.section_hint": "Behåll befintliga rader, eller bygg en visuell modulbaserad kalkyl som kan kopplas till backend senare.",
            "offer.calculation.builder.section_hint_lines": "Denna kalkyl är radbaserad. Använd rader, produkter, timmar och manuella rader.",
            "offer.calculation.builder.section_hint_modules": "Denna kalkyl använder modulbyggaren. Bygg flödet visuellt och testa det i användarvyn.",
            "offer.calculation.builder.tab_lines": "Rader",
            "offer.calculation.builder.tab_modules": "Modulbyggare",
            "offer.calculation.builder.tab_insert": "Infogningsvy",
            "offer.calculation.builder.tab_history": "Historik",
            "offer.calculation.builder.history_hint": "Öppna mallversioner för att se tidigare sparade utgåvor och återställa vid behov.",
            "offer.calculation.page.kicker": "Offerterkalkyl",
            "offer.calculation.page.subtitle": "Bygg, testa och använd kalkyler i en fullbreddsyta med rader, moduler och en separat inklistringsvy.",
            "offer.calculation.insert.title": "Infogningsvy",
            "offer.calculation.insert.subtitle": "Så här känns kalkylen när den klistras in i offerter, moduler eller andra flöden.",
            "offer.calculation.insert.inputs_title": "Justerbara fält",
            "offer.calculation.insert.inputs_hint": "Endast olåsta fält kan ändras här, till exempel kilometer, procent och fördelning.",
            "offer.calculation.insert.flow_title": "Så hänger kalkylen ihop",
            "offer.calculation.insert.flow_hint": "Rutor och kopplingar visas som en readonly-karta medan siffrorna uppdateras live.",
            "offer.calculation.insert.fields_tab": "Justera fält",
            "offer.calculation.insert.map_tab": "Karta",
            "offer.calculation.insert.offer_dialog_title": "Anpassa kalkylen innan den läggs till offerten",
            "offer.calculation.insert.offer_cancel": "Avbryt",
            "offer.calculation.insert.offer_add": "Lägg till i offert",
            "offer.calculation.insert.adjust_fields": "Justera fält",
            "offer.calculation.insert.edit_lines": "Redigera kalkyl",
            "offer.calculation.insert.adjustable_fields": "Justerbara fält",
            "offer.calculation.insert.adjustable_fields_hint": "Denna kalkyl använder modulbyggaren. Öppna justering för att ändra antal, kilometer, procent och andra öppna fält.",
            "offer.calculation.module.palette_title": "Moduler",
            "offer.calculation.module.globals.title": "Globala parametrar",
            "offer.calculation.module.globals.hint": "Värden för hela modulen. Kryssa i «Fråga vid användning» för mallguiden.",
            "offer.calculation.module.globals.ask_on_use": "Fråga vid användning",
            "offer.calculation.module.globals.value": "Värde",
            "offer.calculation.module.globals.add": "Lägg till parameter",
            "offer.calculation.module.globals.remove": "Ta bort",
            "offer.calculation.module.globals.key_placeholder": "nyckel (t.ex. unit_count)",
            "offer.calculation.module.globals.label_placeholder": "Visningsnamn",
            "offer.calculation.module.tabs.label": "Modulbyggarflikar",
            "offer.calculation.module.tabs.content": "Innehåll",
            "offer.calculation.module.tabs.questions": "Frågor",
            "offer.calculation.module.tabs.rules": "Regler",
            "offer.calculation.module.tabs.offer_text": "Offerttext",
            "offer.calculation.module.tabs.test": "Test",
            "offer.calculation.module.offer_text.hint": "Text som följer med mallen. Kundtext kan också styras av presentationsregler.",
            "offer.calculation.module.offer_text.customer_note": "Kundtext (modul)",
            "offer.calculation.module.offer_text.title_field": "Kalkyltitel",
            "offer.calculation.module.offer_text.description_field": "Kalkylbeskrivning",
            "offer.calculation.module.rules.title": "Regler",
            "offer.calculation.module.rules.hint": "Enkla om/så-regler: när en global har ett värde, slå noder av/på.",
            "offer.calculation.module.rules.add": "Lägg till regel",
            "offer.calculation.module.rules.pick_global": "Välj parameter…",
            "offer.calculation.module.rules.pick_node": "Välj nod…",
            "offer.calculation.module.rules.equals_placeholder": "är lika med…",
            "offer.calculation.module.rules.disable_node": "Stäng av nod",
            "offer.calculation.module.rules.enable_node": "Slå på nod",
            "offer.calculation.module.rules.summary": "Om {{global}} = «{{equals}}» → {{action}} ({{node}})",
            "offer.calculation.module.palette_hint": "Klicka för att lägga till på ytan.",
            "offer.calculation.module.add": "Lägg till",
            "offer.calculation.module.canvas_title": "Modulkarta",
            "offer.calculation.module.canvas_hint": "Dra på kartan. Dubbelklicka ett kort för att öppna inställningar.",
            "offer.calculation.module.connecting_hint": "Välj nästa ruta för att skapa en koppling.",
            "offer.calculation.module.reset_example": "Återställ till exempel",
            "offer.calculation.module.zoom_out": "Zooma ut",
            "offer.calculation.module.zoom_in": "Zooma in",
            "offer.calculation.module.reset_view": "Återställ vy",
            "offer.calculation.module.json.open_dialog": "JSON / AI",
            "offer.calculation.module.json.dialog_title": "JSON och AI för modulbyggaren",
            "offer.calculation.module.json.tab_json": "Klistra in JSON",
            "offer.calculation.module.json.tab_ai_guide": "AI-instruktioner",
            "offer.calculation.module.json.hint": "Klistra in JSON från ChatGPT eller annan AI, eller redigera den aktuella modulgrafen. Stöder full module_graph eller { \"nodes\": [...], \"edges\": [...] }. Att använda JSON uppdaterar bara redigeraren — du måste fortfarande spara kalkylen.",
            "offer.calculation.module.json.replace": "Ersätt hela grafen",
            "offer.calculation.module.json.append": "Lägg till på ytan",
            "offer.calculation.module.json.copy_json": "Kopiera JSON",
            "offer.calculation.module.json.reload_from_editor": "Läs in från redigeraren",
            "offer.calculation.module.json.insert_sample": "Infoga exempel",
            "offer.calculation.module.json.apply": "Använd JSON",
            "offer.calculation.module.json.applied": "{{count}} noder importerade",
            "offer.calculation.module.json.copy_success": "JSON kopierad",
            "offer.calculation.module.json.reload_success": "JSON inläst från redigeraren",
            "offer.calculation.module.json.clipboard_failed": "Kunde inte kopiera till urklipp",
            "offer.calculation.module.json.ai_guide_intro": "Kopiera instruktionerna nedan till ChatGPT, Claude eller annan AI. Klistra sedan in JSON-svaret i fliken «Klistra in JSON».",
            "offer.calculation.module.json.copy_ai_guide": "Kopiera AI-instruktioner",
            "offer.calculation.module.json.ai_guide_copied": "AI-instruktioner kopierade",
            "offer.calculation.module.json.generate_with_ai": "Generera med AI",
            "offer.calculation.module.json.ai_parse_error": "Kunde inte läsa AI-svaret som modulgraf-JSON",
            "offer.calculation.module.json.ai_apply_success": "{{count}} noder tillagda från AI",
            "offer.calculation.module.json.error_empty": "JSON-fältet är tomt",
            "offer.calculation.module.json.error_invalid_json": "Ogiltig JSON — kontrollera syntaxen",
            "offer.calculation.module.json.error_invalid_graph": "Hittade ingen giltig modulgraf i JSON",
            "offer.calculation.module.json.error_no_nodes": "Hittade inga noder i JSON",
            "offer.calculation.module.json.error_missing_id": "En eller flera noder saknar id",
            "offer.calculation.module.json.error_unknown_type": "Okänd nodtyp i JSON",
            "offer.calculation.module.json.error_missing_edge_target": "En pil pekar på en nod som inte finns",
            "offer.calculation.module.json.error_unsafe_formula": "Formeln är ogiltig eller använder funktioner som inte stöds",
            "offer.calculation.module.json.error_circular": "Grafen har en cirkulär referens",
            "offer.calculation.module.result_title": "Resultat",
            "offer.calculation.module.result_hint": "Summa exkl. moms. Förhandsvisning uppdateras medan du redigerar; spara för servertotal.",
            "offer.calculation.module.editor_title": "Redigera vald modul",
            "offer.calculation.module.selected_title": "Vald modul",
            "offer.calculation.module.settings.values": "Värden",
            "offer.calculation.module.selected_empty": "Klicka en modul på kartan för att redigera titel, belopp och kopplingar.",
            "offer.calculation.module.editor_hint_computed": "Beräknas automatiskt från modulerna som pekar in.",
            "offer.calculation.module.editor_hint_editable": "Ändringar uppdaterar delsumma och total direkt.",
            "offer.calculation.module.editor_mode.simple": "Enkel",
            "offer.calculation.module.editor_mode.advanced": "Avancerad",
            "offer.calculation.module.duplicate": "Duplicera",
            "offer.calculation.module.copy_suffix": "(kopia)",
            "offer.calculation.module.auto": "auto",
            "offer.calculation.module.meta.percent": "Påslag {{percent}} %",
            "offer.calculation.module.meta.divisor": "Fördelas på {{divisor}}",
            "offer.calculation.module.meta.fixed": "Fast belopp",
            "offer.calculation.module.meta.service_hours": "Fast belopp · {{hours}} t × {{rate}}",
            "offer.calculation.module.meta.product_lines": "{{count}} rader",
            "offer.calculation.module.meta.formula": "Egendefinierad",
            "offer.calculation.module.meta.subtotal": "Delsumma",
            "offer.calculation.module.meta.total": "Slutpunkt",
            "offer.calculation.module.meta.note": "Utan belopp",
            "offer.calculation.module.edge_title": "Redigera pil",
            "offer.calculation.module.breakdown_title": "Fördelning",
            "offer.calculation.module.connect": "Koppla",
            "offer.calculation.module.connect_here": "Koppla hit",
            "offer.calculation.module.remove": "Ta bort",
            "offer.calculation.module.remove_edge": "Ta bort pil",
            "offer.calculation.module.locked": "Låst",
            "offer.calculation.module.unlocked": "Öppen",
            "offer.calculation.module.enabled": "Aktiv",
            "offer.calculation.module.disabled": "Inaktiv",
            "offer.calculation.module.operation.add": "Lägg till",
            "offer.calculation.module.operation.subtract": "Dra av",
            "offer.calculation.module.scope.all": "Hela jobbet",
            "offer.calculation.module.scope.work": "Endast jobb",
            "offer.calculation.module.scope.driving": "Endast körning",
            "offer.calculation.module.scope.selected": "Valda moduler",
            "offer.calculation.module.field.title": "Titel",
            "offer.calculation.module.field.insert_order": "Ordning i anpassa-mall",
            "offer.calculation.module.field.insert_order_hint": "Lämna tomt för automatisk ordning (hierarki uppifrån och ner). Lägre tal visas först.",
            "offer.calculation.module.field.amount": "Belopp",
            "offer.calculation.module.field.enabled": "Status",
            "offer.calculation.module.field.quantity": "Antal",
            "offer.calculation.module.field.unit_price": "Enhetspris",
            "offer.calculation.module.field.product_name": "Produktnamn",
            "offer.calculation.module.field.hours": "Timmar",
            "offer.calculation.module.field.estimated_hours": "Uppskattad tidsåtgång",
            "offer.calculation.module.field.hourly_rate": "Timpris",
            "offer.calculation.module.field.cost_hourly_rate": "Kostnad per timme",
            "offer.calculation.module.field.percent": "Procent",
            "offer.calculation.module.field.percent_mode": "Typ",
            "offer.calculation.module.percent_mode.markup": "Påslag",
            "offer.calculation.module.percent_mode.discount": "Rabatt",
            "offer.calculation.module.field.scope": "Gäller",
            "offer.calculation.module.field.divisor": "Fördela på",
            "offer.calculation.module.field.expression": "Formel",
            "offer.calculation.module.field.note": "Notering",
            "offer.calculation.module.field.operation": "Operation",
            "offer.calculation.module.formula.assistant_title": "Formelhjälp",
            "offer.calculation.module.formula.assistant_subtitle": "Välj en färdig mall, eller klicka på variabler och funktioner. Du behöver inte komma ihåg Excel-syntax.",
            "offer.calculation.module.formula.templates": "Färdiga mallar",
            "offer.calculation.module.formula.variables": "Infoga värde",
            "offer.calculation.module.formula.functions": "Smarta funktioner",
            "offer.calculation.module.formula.example_title": "Tips",
            "offer.calculation.module.formula.example_text": "`input` är summan från pilarna in till {{title}}. Börja med en mall och justera siffrorna.",
            "offer.calculation.module.formula.variable.input": "Summa från inkommande pilar",
            "offer.calculation.module.formula.variable.quantity": "Eget antal",
            "offer.calculation.module.formula.variable.price": "Eget pris",
            "offer.calculation.module.formula.variable.percent": "Egen procent",
            "offer.calculation.module.formula.function.sum": "Summera flera tal",
            "offer.calculation.module.formula.function.round": "Runda till heltal",
            "offer.calculation.module.formula.function.min": "Maxpristak",
            "offer.calculation.module.formula.function.max": "Minimipris",
            "offer.calculation.module.formula.function.if": "Om-så-annars",
            "offer.calculation.module.formula.template.same": "Använd summan som den är",
            "offer.calculation.module.formula.template.fixed_add": "Lägg till fast belopp",
            "offer.calculation.module.formula.template.fixed_subtract": "Dra av fast belopp",
            "offer.calculation.module.formula.template.ten_percent": "Lägg på 10 %",
            "offer.calculation.module.formula.template.custom_percent": "Lägg på egen %",
            "offer.calculation.module.formula.template.input_times_quantity": "Multiplicera inkommande med antal",
            "offer.calculation.module.formula.template.quantity_price": "Antal gånger pris",
            "offer.calculation.module.formula.template.split_two": "Dela på 2",
            "offer.calculation.module.formula.template.round": "Runda totalen",
            "offer.calculation.module.formula.template.if": "Om beloppet är över 0",
            "offer.calculation.module.formula.node_refs": "Andra moduler",
            "offer.calculation.module.formula.globals": "Globala värden",
            "offer.calculation.module.node.service": "Tjänst",
            "offer.calculation.module.node.service_hint": "Fast belopp som kan låsas, t.ex. lägenhet. Uppskattad tidsåtgång och timpris räknas in i totala timmar.",
            "offer.calculation.module.node.quantity": "Antal x pris",
            "offer.calculation.module.node.quantity_hint": "Antal multiplicerat med enhetspris, t.ex. kilometer.",
            "offer.calculation.module.node.product_price": "Produktpris",
            "offer.calculation.module.node.product_price_hint": "Produktnamn, antal och pris i en modul.",
            "offer.calculation.module.node.product_catalog": "Produktlista",
            "offer.calculation.module.node.product_catalog_hint": "Lägg till produkter från produktregistret eller manuella produktrader.",
            "offer.calculation.module.node.labor_hours": "Timfält",
            "offer.calculation.module.node.labor_hours_hint": "Timmar multiplicerat med timpris, t.ex. tilläggsarbete eller servicearbete.",
            "offer.calculation.module.node.percentage": "Procent",
            "offer.calculation.module.node.percentage_hint": "Påslag eller rabatt på inkommande moduler.",
            "offer.calculation.module.node.distribution": "Fördelning",
            "offer.calculation.module.node.distribution_hint": "Fördela inkommande belopp på X.",
            "offer.calculation.module.node.formula": "Specialformel",
            "offer.calculation.module.node.formula_hint": "T.ex. multiplicera delsummering med antal: koppla in → sätt antal. Formel: input × quantity.",
            "offer.calculation.module.node.subtotal": "Delsummering",
            "offer.calculation.module.node.subtotal_hint": "Samlar flera inkommande moduler till en delsumma.",
            "offer.calculation.module.node.total": "Total",
            "offer.calculation.module.node.total_hint": "Slutpunkt för kalkylen.",
            "offer.calculation.module.node.note": "Notering",
            "offer.calculation.module.node.note_hint": "Förklarande ruta utan belopp.",
            "offer.calculation.module.product.title": "Produkter",
            "offer.calculation.module.product.hint": "Välj produkter från registret eller lägg till egna produktrader.",
            "offer.calculation.module.product.add_from_catalog": "Lägg till från produktregister",
            "offer.calculation.module.product.add_manual": "Manuell rad",
            "offer.calculation.module.product.empty": "Inga produkter har lagts till ännu.",
            "offer.calculation.module.product.manual_title": "Manuell produkt",
            "offer.calculation.module.product.include": "Ta med",
            "offer.calculation.module.product.exclude": "Uteslut",
            "offer.calculation.module.product.total": "Produkttotal",
            "offer.calculation.module.product.cancel": "Avbryt",
            "offer.calculation.module.product.add_selected": "Lägg till valda",
            "offer.calculation.product_list.title": "Produktlista",
            "offer.calculation.product_list.hint": "Lägg till produkter från registret, eller manuella rader som du kopplar till en produkt. När mallen används väljer användaren vilka som ska vara med.",
            "offer.calculation.product_list.label": "Listnamn",
            "offer.calculation.product_list.mode_single": "Välj ett (t.ex. aggregat)",
            "offer.calculation.product_list.mode_multi": "Välj flera (t.ex. tillbehör)",
            "offer.calculation.product_list.ask_on_use": "Fråga vid användning av mall",
            "offer.calculation.product_list.module_ask_hint": "När aktiverat frågar mallguiden vilka produkter från katalogen som ska tas med.",
            "offer.calculation.product_list.add_products": "Lägg till produkter",
            "offer.calculation.product_list.add_manual": "Manuell rad",
            "offer.calculation.product_list.manual_title": "Ny produktrad",
            "offer.calculation.product_list.line_title": "Radtitel",
            "offer.calculation.product_list.unlinked": "Inte kopplad till produkt — använd «Koppla till produkt» för att hämta pris.",
            "offer.calculation.product_list.link_product": "Koppla till produkt",
            "offer.calculation.product_list.relink_product": "Byt kopplad produkt",
            "offer.calculation.product_list.relink_product_short": "Byt produkt",
            "offer.calculation.product_list.link_confirm": "Koppla",
            "offer.calculation.product_list.update_prices": "Uppdatera priser från produkt",
            "offer.calculation.product_list.update_price": "Uppdatera pris från produkt",
            "offer.calculation.product_list.price_dated": "Pris hämtat",
            "offer.calculation.product_list.empty": "Inga produkter i listan ännu. Lägg till från registret eller som manuell rad.",
            "offer.calculation.product_list.default_selected": "Standard",
            "offer.calculation.product_list.required": "Obligatorisk",
            "offer.calculation.product_list.remove": "Ta bort",
            "offer.calculation.product_list.wizard_single_hint": "Välj en produkt som ska användas på raden.",
            "offer.calculation.product_list.wizard_multi_hint": "Bocka för produkterna som ska tas med.",
            
            // Accounting Summary translations (Swedish)
            "accounting.summary.title": "Räkenskapsöversikt",
            "accounting.summary.eyebrow": "Räkenskap",
            "accounting.summary.tap_hint": "Tryck för att se fler siffror och välja period",
            "accounting.summary.profit_explanation": "Vinst = intäkter − kostnader. Marginalen visar vinsten som andel av intäkterna.",
            "accounting.summary.income_explanation": "Intäkter är fakturerad omsättning från kundfakturor under vald period.",
            "accounting.summary.costs": "Kostnader",
            "accounting.summary.income": "Intäkter",
            "accounting.summary.profit": "Vinst",
            "accounting.summary.profit_margin": "marginal",
            "accounting.summary.projects": "Projekt",
            "accounting.summary.labor": "Lönekostnader",
            "accounting.summary.labor_source_voucher": "verifikationer",
            "accounting.summary.labor_source_hours": "timmar",
            "accounting.summary.voucher_expenses": "Tripletex-kostnader (rörelse)",
        "accounting.summary.voucher_expenses_methodology": "Tripletex-verifikationer på rörelsekostnadskonton 4000–4999 och 6000–7999 (exkl. moms). Balans-, intäkts- och lönekonton (5000–5999) undantas.",
        "accounting.summary.supplier_invoices_methodology": "Bokförda leverantörsfakturor på rörelsekostnadskonton (4000–4999 och 6000–7999) under vald period. Hoppas över när huvudbok redan finns för året.",
        "accounting.summary.item_lists_methodology": "Material och förbrukning från godkända varulistor med «inkludera i beräkning» under valt år. Visas på företagsnivå men räknas inte in i kostnadstotalen (lagerinköp ligger redan i leverantörsfaktura / huvudbok).",
        "accounting.summary.item_lists_excluded_hint": "Varulistor ingår inte i kostnadstotalen på företagsnivå — undviker dubbelräkning mot leverantörsfaktura/huvudbok. På projektnivå räknas de fortfarande med.",
        "accounting.summary.calc_guide.json.download": "Ladda ner JSON-guide",
        "accounting.summary.calc_guide.json.copy": "Kopiera JSON-guide",
        "accounting.summary.calc_guide.json.downloaded": "Beräkningsguide nedladdad.",
        "accounting.summary.calc_guide.json.copied": "Beräkningsguide kopierad till urklipp.",
        "accounting.summary.calc_guide.json.error": "Kunde inte hämta beräkningsguide.",
        "accounting.summary.calc_guide.profit.title": "Så beräknas vinst",
        "accounting.summary.calc_guide.profit.body": "Vinst = totala intäkter − totala kostnader.\n\nMarginalen är vinst som procent av intäkterna.\n\nIntäkter kommer från kundfakturor (exkl. moms). Kostnader är lön + Tripletex rörelsekostnader + leverantörsfakturor (när huvudbok inte är synkad). Varulistor ingår inte i kostnadstotalen på företagsnivå.",
        "accounting.summary.calc_guide.profit.info_aria": "Information om vinst",
        "accounting.summary.calc_guide.income.title": "Så beräknas intäkter",
        "accounting.summary.calc_guide.income.body": "Totala intäkter = summa kundfakturor under valt år, belopp exkl. moms (amount − vat).\n\nDatum: invoice_date om satt, annars created_at.\n\nObs: Resultatrapporten kan i stället använda Tripletex-konton 3000–3999 när huvudbok är synkad. Räkenskapsöversikten använder fortfarande kundfakturor.",
        "accounting.summary.calc_guide.income.info_aria": "Information om intäkter",
        "accounting.summary.calc_guide.costs.title": "Så beräknas totala kostnader",
        "accounting.summary.calc_guide.costs.body": "Totala kostnader =\n• Lön (konton 5000–5999, eller timestimat)\n• Tripletex-kostnader (konton 4000–4999 + 6000–7999)\n• Leverantörsfakturor (endast månader utan rörelsekostnadsverifikat i huvudbok)\n\nGodkända varulistor visas separat och räknas inte in här — lagerinköp täcks redan av leverantörsfaktura/huvudbok.\n\nBalanskonton (t.ex. 1xxx/2xxx) räknas inte med.",
        "accounting.summary.calc_guide.costs.info_aria": "Information om kostnader",
        "accounting.summary.calc_guide.labor.title": "Så beräknas lön",
        "accounting.summary.calc_guide.labor.body": "När löneverifikat synkats från Tripletex summeras posteringar på konton 5000–5999 under valt år (exkl. moms).\n\nOm inga sådana verifikat finns används estimat: godkända och behandlade timmar × effektiv timtaxa / företagssats.",
        "accounting.summary.calc_guide.labor.info_aria": "Information om lön",
        "accounting.summary.calc_guide.supplier_invoices.title": "Så beräknas leverantörsfakturor",
        "accounting.summary.calc_guide.supplier_invoices.body": "Summa leverantörsfakturaposteringar på rörelsekostnadskonton (4000–4999 och 6000–7999) under valt år.\n\nNär Tripletex-huvudbok redan är synkad för perioden sätts raden till 0 — kostnaderna ligger då under Tripletex-kostnader.",
        "accounting.summary.calc_guide.supplier_invoices.info_aria": "Information om leverantörsfakturor",
        "accounting.summary.calc_guide.item_lists.title": "Så beräknas varulistor",
        "accounting.summary.calc_guide.item_lists.body": "Summa antal × inköpspris för godkända varulistor med inkludera-i-beräkning, godkända under valt år.\n\nFörbrukningslistor ökar beloppet; retur/hantering minskar det.\n\nPå företagsnivå räknas inte varulistor in i kostnadstotalen (dubbelräkning mot lagerinköp). På projektnivå räknas de fortfarande med i materialkostnad.",
        "accounting.summary.calc_guide.item_lists.info_aria": "Information om varulistor",
        "accounting.summary.calc_guide.voucher_expenses.title": "Så beräknas Tripletex-kostnader",
        "accounting.summary.calc_guide.voucher_expenses.body": "Summa synkade verifikationsposteringar under valt år på konton:\n• 4000–4999 (varukostnad)\n• 6000–7999 (övriga rörelsekostnader)\n\nBelopp är exkl. moms. Krediteringar (negativa belopp) minskar summan.\n\nUndantas: lön (5000–5999), intäkter (3000–3999), moms (27*), bank/skulder (1920*/2400) och balanskonton.",
        "accounting.summary.calc_guide.voucher_expenses.info_aria": "Information om Tripletex-kostnader",
        "accounting.summary.calc_guide.expected_report_income.title": "Så beräknas förväntad uppdragsintäkt",
        "accounting.summary.calc_guide.expected_report_income.body": "Förväntad intäkt/kostnad från servicerapporter och arbetsorder som inte är behandlade eller fakturerade under valt år.\n\nDetta ingår inte i huvudresultatet (vinst), utan visas separat som potential.",
        "accounting.summary.calc_guide.expected_report_income.info_aria": "Information om förväntad uppdragsintäkt",
            "accounting.summary.material": "Materialkostnader",
            "accounting.summary.supplier_invoices": "Leverantörsfakturor",
            "accounting.summary.item_lists": "Varlistor",
            "accounting.summary.customer_invoices": "Kundfakturor",
            "accounting.summary.reports": "Rapporter",
            "accounting.summary.total": "Totalt",
            "accounting.summary.calculated_at": "Beräknad",
            "accounting.summary.cached": "Cachad",
            "accounting.summary.load_error": "Kunde inte ladda räkenskapsöversikt",
            "accounting.summary.monthly_overview": "Månadsöversikt",
            "accounting.summary.chart_description": "Staplar: intäkter & kostnader · Linje: månadsresultat (intäkter − kostnader)",
            "accounting.summary.no_monthly_data": "Ingen månadsdata tillgänglig",
            "accounting.summary.months.january": "Jan",
            "accounting.summary.months.february": "Feb",
            "accounting.summary.months.march": "Mar",
            "accounting.summary.months.april": "Apr",
            "accounting.summary.months.may": "Maj",
            "accounting.summary.months.june": "Jun",
            "accounting.summary.months.july": "Jul",
            "accounting.summary.months.august": "Aug",
            "accounting.summary.months.september": "Sep",
            "accounting.summary.months.october": "Okt",
            "accounting.summary.months.november": "Nov",
            "accounting.summary.months.december": "Dec",
            "accounting.summary.expected_report_income": "Förväntad intäkt från uppdrag",
            "accounting.summary.expected_income": "Förväntad intäkt",
            "accounting.summary.expected_costs": "Förväntade kostnader",
            "accounting.summary.expected_profit": "Förväntad vinst",
        "accounting.projects_expected.title": "Uppdrag förväntad intäkt",
        "accounting.projects_expected.subtitle": "Förväntad intäkt från obehandlade rapporter och arbetsordrar, grupperad efter projekt eller uppdrag",
        "accounting.projects_expected.description": "Förväntad intäkt och kostnad kommer från rapporter och arbetsordrar som inte är behandlade eller fakturerade. Material räknas bara för plockade rader (eller rader med hoppa över plock). Välj vy per projekt eller per enskild rapport/arbetsorder. Lönekostnader och leverantörskostnader är faktiska kostnader registrerade på projektet (bara i projektvyn).",
        "accounting.projects_expected.search_placeholder": "Sök projektnamn eller nummer…",
        "accounting.projects_expected.search_placeholder_assignment": "Sök rapport, arbetsorder, projekt…",
        "accounting.projects_expected.view_by_project": "Per projekt",
        "accounting.projects_expected.view_by_assignment": "Per rapport/uppdrag",
        "accounting.projects_expected.table_title_assignment": "Per rapport och arbetsorder",
        "accounting.projects_expected.assignment": "Rapport / arbetsorder",
        "accounting.projects_expected.type_report": "Rapport",
        "accounting.projects_expected.type_work_order": "Arbetsorder",
        "accounting.projects_expected.expected_income_short": "Intäkt",
        "accounting.projects_expected.expected_costs_short": "Kostnad",
        "accounting.projects_expected.date": "Datum",
        "accounting.projects_expected.no_assignments": "Inga obehandlade rapporter eller arbetsordrar matchar filtren.",
        "accounting.projects_expected.loading": "Laddar översikt…",
        "accounting.projects_expected.load_error": "Kunde inte ladda översikt",
        "accounting.projects_expected.table_title": "Per projekt",
        "accounting.projects_expected.project": "Projekt",
        "accounting.projects_expected.assignments": "Uppdrag",
        "accounting.projects_expected.reports_count": "{{count}} rapport",
        "accounting.projects_expected.reports_count_plural": "{{count}} rapporter",
        "accounting.projects_expected.work_orders_count": "{{count}} arbetsorder",
        "accounting.projects_expected.work_orders_count_plural": "{{count}} arbetsordrar",
        "accounting.projects_expected.expected_income": "Förväntad intäkt (rapport/arbetsorder)",
        "accounting.projects_expected.expected_income_hint": "Summa från obehandlade rapporter och arbetsordrar på projektet. Material bara för plockade varor (inte oplockat lager).",
        "accounting.projects_expected.expected_costs": "Förväntad kostnad (rapport/arbetsorder)",
        "accounting.projects_expected.expected_profit": "Förväntat resultat",
        "accounting.projects_expected.labor_costs": "Lönekostnader (faktiska)",
        "accounting.projects_expected.supplier_costs": "Leverantörskostnader (faktiska)",
        "accounting.projects_expected.hours": "Timmar",
        "accounting.projects_expected.net": "Netto",
        "accounting.projects_expected.no_projects": "Inga projekt med obehandlade rapporter eller arbetsordrar matchar filtren.",
        "accounting.projects_expected.totals_reports": "Rapporter",
        "accounting.projects_expected.totals_work_orders": "Arbetsordrar",
        "Saving...": "Sparar…",
        "accounting.ledger.calculations": "Beräkningar",
        "accounting.ledger.count": "{{count}} rader",
        "accounting.ledger.expense_total": "Kostnad totalt",
        "accounting.ledger.last_sync_attempt": "Senaste synk-forsök: {{date}}",
        "accounting.ledger.last_synced": "Sist synkronisert {{date}}",
        "accounting.ledger.ledger_types": "Huvudbokstyper",
        "accounting.ledger.load_error": "Kunde inte laddae huvudbokdata",
        "accounting.ledger.loading": "Laddar huvudbokdata…",
        "accounting.ledger.next_page": "Neste",
        "accounting.ledger.no_vouchers": "Inga verifikation samsvarer med filtrene.",
        "accounting.ledger.page_of": "Sida {{page}} av {{total}}",
        "accounting.ledger.postings": "Poster",
        "accounting.ledger.prev_page": "Forrige",
        "accounting.ledger.promang_supplier_invoices": "Promang leverantörsfakturor",
        "accounting.ledger.salary_total": "Lönekostnad totalt",
        "accounting.ledger.search_placeholder": "Sök verifikationsnummer eller beskrivning…",
        "accounting.ledger.source_local": "Lagret lokalt (inte live Tripletex)",
        "accounting.ledger.sync_required_hint": "Huvudbokdata er inte synkronisert ennå. Be en administrator kjöre Tripletex huvudbok-synk.",
        "accounting.ledger.sync_via_integrations": "Aktiver «Huvudbok och verifikation» i Firmainnstillinger → Integrasjoner → Synkroniser med Tripletex, eller kjör rake api:jobs:run_company_ledger_sync[company_id,year].",
        "accounting.ledger.tripletex_expenses": "Tripletex-kostnader (eks. mva)",
        "accounting.ledger.tripletex_salary": "Tripletex-lönn (eks. mva)",
        "accounting.ledger.voucher_date": "Datum",
        "accounting.ledger.voucher_number": "Verifikationsnr.",
        "accounting.ledger.voucher_type": "Typ",
        "accounting.ledger.voucher_types": "Verifikationstyper",
        "accounting.ledger.vouchers_table": "Verifikationer",
        "accounting.menu.ledger": "Huvudbok och verifikation",
        "accounting.menu.result_report": "Resultatrapport",
        "accounting.project_summary.contract_agreement_price": "Avtalspris",
        "accounting.project_summary.contract_sum": "Kontraktsumma",
        "accounting.project_summary.costs_section": "Kostnader",
        "accounting.project_summary.debug_export.button": "Exportera debug-data",
        "accounting.project_summary.debug_export.error": "Kunde inte exporterae debug-data",
        "accounting.project_summary.debug_export.loading": "Exporterar…",
        "accounting.project_summary.description": "Välj et projekt för att se kontraktsumma, intäkter, lönnskostnader (lönnsverifikation eller timer), materiell, leverandörfakturaer och resultat.",
        "accounting.project_summary.expected_module_income": "Forventet intäkt från moduler",
        "accounting.project_summary.income_section": "Intäkter",
        "accounting.project_summary.income_total": "Fakturert + förväntad",
        "accounting.project_summary.invoiced": "Fakturerat",
        "accounting.project_summary.labor_costs": "Lönn",
        "accounting.project_summary.last_updated": "Senast uppdaterad",
        "accounting.project_summary.load_error": "Kunde inte laddae projektbokföring",
        "accounting.project_summary.material_costs": "Materiell / varelister",
        "accounting.project_summary.methodology.material_costs": "Materiell (vareforbruk) summerar flera källor: godkända varulistor, övriga orderrader på fakturerade ordrar, lageruttag (plockat/använt), rapportvaror och arbetsordervaror (ej fakturerade). Fakturakopior från varulista→order (inventory_billing_copy) räknas inte igen när listan redan ingår. Jämför därför inte talet direkt med inköpssumman på en enda varulista.",
        "accounting.project_summary.modules_section": "Moduler",
        "accounting.project_summary.open_project": "Öppna projekt",
        "accounting.project_summary.print.button": "Skriv ut",
        "accounting.project_summary.select_project": "Projekt",
        "accounting.project_summary.select_project_hint": "Välj et projekt för att se bokföringssummameringen",
        "accounting.project_summary.select_project_placeholder": "Välj projekt…",
        "accounting.project_summary.subtitle": "Komplett ökonomisk översikt for ett projekt",
        "accounting.project_summary.supplier_invoices": "Leverandörfakturaer",
        "accounting.project_summary.title": "Projektbokföring",
        "accounting.project_summary.total_costs": "Totale kostnader",
        "accounting.project_summary.voucher_expenses": "Andre verifikationskostnader",
        "accounting.result_report.account_detail.click_hint": "Klikk för att sjå verifikation och posteringar bak belöpet",
        "accounting.result_report.account_name": "Namn",
        "accounting.result_report.account_number": "Konto",
        "accounting.result_report.amount": "Belöp",
        "accounting.result_report.debug_export.button": "Exportera debug-data",
        "accounting.result_report.debug_export.error": "Kunde inte exporterae debug-data",
        "accounting.result_report.debug_export.loading": "Exporterar…",
        "accounting.result_report.load_error": "Kunde inte laddae resultatrapport",
        "accounting.result_report.loading": "Laddar resultatrapport…",
        "accounting.result_report.methodology_link": "Les metode och kontokartlegging",
        "accounting.result_report.no_rows": "Inga kontoposteringar i valt periode.",
        "accounting.result_report.operating_result": "Driftsresultat",
        "accounting.result_report.result_before_tax": "Resultat för skatt",
        "accounting.result_report.table_title": "Resultatrapport {{year}}",
        "accounting.result_report.total_costs": "Driftskostnader totalt",
        "accounting.result_report.total_income": "Driftsintäkter totalt",
        "project.billing_plan.contract_sum": "Kontraktsumma",
        "project.billing_plan.remaining_amount": "Innestående belöp",
        "project.summary.agreed_price": "Avtalt pris",
        "project.summary.contract_agreement_price": "Avtalspris",
        "project.summary.contract_sum": "Kontraktsumma",
        "project.summary.cost_breakdown": "Kostnadsfordeling",
        "project.summary.cost_rate": "Kostnadsgrad",
        "project.summary.costs": "Kostnader",
        "project.summary.error.title": "Fel ved laddaing",
        "project.summary.expected_module_costs": "Forventet modulkostnader",
        "project.summary.expected_module_income": "Forventet intäkt från moduler",
        "project.summary.has_order": "Har ordre",
        "project.summary.hours": "Timer",
        "project.summary.hours_short": "t",
        "project.summary.income": "Intäkter",
        "project.summary.invoiced": "Fakturerat",
        "project.summary.invoiced_amount": "Fakturert belöp",
        "project.summary.invoicing_rate": "Faktureringsgrad",
        "project.summary.labor_costs": "Lönnskostnader",
        "project.summary.last_updated": "Senast uppdaterad",
        "project.summary.margin": "Margin",
        "project.summary.material": "Materialer",
        "project.summary.material_costs": "Vareforbruk",
        "project.summary.material_costs_hint": "Inte bara varulistans inköpssumma — se info för källor.",
        "project.summary.material_costs_info_aria": "Så beräknas vareforbruk",
        "project.summary.module_breakdown": "Modulöversikt",
        "project.summary.module_breakdown_description": "Översikt over alle moduler som påvirker projektsummameringen",
        "project.summary.module_type.item_list": "Vareliste",
        "project.summary.module_type.report": "Rapport",
        "project.summary.module_type.work_order": "Arbeidsordre",
        "project.summary.no_costs": "Inga kostnader registrert ennå",
        "project.summary.no_data.description": "Projektsummamering vil bli generert når data er tilgjengelig",
        "project.summary.no_data.title": "Inga data tilgjengelig",
        "project.summary.not_included_in_total": "inte inkludert i total",
        "project.summary.overview": "Översiktlig bokföring",
        "project.summary.price_lines": "prislinjer",
        "project.summary.profit": "Resultat",
        "project.summary.remaining": "Gjenstående",
        "project.summary.supplier_invoices": "Leverandörfakturaer",
        "project.summary.total_costs": "Totale kostnader",
        "project.summary.voucher_expenses": "Andre verifikationskostnader",
      
            // Phonero presence descriptions
            "Free": "Ledig",
            "Meeting": "Möte",
            "Lunch": "Lunch",
            "Vacation": "Semester",
            "Busy": "Upptagen",
            "Way": "På väg",
            "Gone for the day": "Klar för dagen",
      
            // Live Calls translations
            "Live Calls (Not synched yet)": "Live Samtal (Inte synkroniserade ännu)",
            "Latest calls from Phonero API (not yet synced to database)":
              "Senaste samtal från Phonero API (inte synkroniserade till databas ännu)",
            "Refreshing...": "Uppdaterar...",
            "Refresh": "Uppdatera",
            "Loading live calls...": "Laddar live samtal...",
            "No unsynced live calls found":
              "Inga osynkroniserade live samtal hittades",
      
            // Manual Call translations
            "Add Manual Call": "Lägg till manuellt samtal",
            "From Number (Customer)": "Från nummer (Kund)",
            "Date & Time": "Datum & Tid",
            "Duration (seconds)": "Varaktighet (sekunder)",
            "Note": "Anteckning",
            "Cancel": "Avbryt",
            "Create Call": "Skapa samtal",
            "Creating...": "Skapar...",
            "Manual call created successfully": "Manuellt samtal skapat",
            "Manual call added successfully": "Manuellt samtal tillagt",
            "Manual": "Manuell",
            "Select Date": "Välj datum",
            "Choose date": "Välj datum",
            "report": "Rapport",
            "report.create": "Skapa rapport",
            "report.update": "Uppdatera rapport",
            "report.type": "Rapporttyp",
            "report.date": "Rapportdatum",
            "report.description": "Rapportbeskrivning",
            "report.agreement.update": "Uppdatera rapportavtal",
            "report.agreement.new": "Nytt rapportavtal",
            "report.agreement.modal_intro":
              "Fyll i när arbetet är planerat och om kunden ska få ett meddelande.",
            "report.agreement.title": "Tidsbokning / avtal",
            "report.agreement.subtitle": "Tid, utförare och kundavisering",
            "report.agreement.setup_title": "Ingen avtalad tid sparad ännu",
            "report.agreement.setup_body": "Ange datum, tid, vem som utför arbetet och skicka vid behov SMS eller e-post till kunden.",
            "report.agreement.setup_cta": "Lägg till avtal",
            "report.agreement.section.schedule": "Tid och utförare",
            "report.agreement.section.schedule_help":
              "Vem som utför arbetet, avtalsdatum och tidsperiod.",
            "report.agreement.section.notify": "Kundavisering",
            "report.agreement.section.notify_help":
              "Välj om kunden ska meddelas via SMS eller e-post och vem som tar emot det.",
            "report.agreement.send_to_customer": "Skicka avtal till kund",
            "report.agreement.send_to_customer_hint_on": "SMS och/eller e-post kan användas när det är aktiverat nedan.",
            "report.agreement.send_to_customer_hint_off": "Tiden sparas bara i Promang; kunden meddelas inte.",
            "report.agreement.executing_you": "Du (inloggad användare)",
            "report.agreement.select_executing": "Välj medarbetare",
            "report.agreement.change_executing": "Byt…",
            "report.agreement.confirm_hint_required":
              "Avtalet skickas till kunden som måste bekräfta via SMS eller e-post.",
            "report.agreement.confirm_hint_optional":
              "Tidsinformation skickas till kunden; bekräftelse krävs inte och avtalet bekräftas automatiskt.",
            "report.agreement.validation.date_required": "Datum krävs",
            "report.agreement.validation.executing_required": "Utförare krävs",
            "report.agreement.validation.phone_for_sms": "Telefonnummer krävs när SMS är på",
            "report.agreement.validation.email_for_email": "Giltig e-post krävs när e-post är på",
            "report.agreement.status.confirmed": "Avtalet är bekräftat",
            "report.agreement.status.not_confirmed": "Avtalet är inte bekräftat",
            "report.agreement.status.sms_sent": "SMS har skickats",
            "report.agreement.status.sms_not_sent": "SMS har inte skickats",
            "report.agreement.status.sms_confirmed": "Bekräftat via SMS",
            "report.agreement.status.email_sent": "E-post har skickats",
            "report.agreement.status.email_not_sent": "E-post har inte skickats",
            "report.agreement.status.none": "Inget avtal",
            "drawings.viewer.mobile.nav_aria": "Ritningsmeny",
            "drawings.viewer.mobile.tools": "Verktyg",
            "drawings.viewer.mobile.more": "Mer",
            "drawings.viewer.mobile.switch_drawing": "Byt ritning",
            "drawings.viewer.mobile.no_sibling_drawings": "Inga andra ritningar i det här projektet.",
            "drawings.viewer.mobile.no_project_drawings": "Den här ritningen är inte kopplad till ett projekt, och inga andra ritningar hittades. Gå till ritningslistan för att byta.",
            "drawings.viewer.mobile.no_project_switch_hint": "Ritningen är inte kopplad till ett projekt. Välj en annan tillgänglig ritning, eller öppna ritningslistan.",
            "drawings.viewer.mobile.to_drawings_list": "Till ritningslistan",
            "drawings.viewer.mobile.select_pan_toggle": "Växla mellan Välj och Panorera",
            "drawings.viewer.mobile.close": "Stäng",
            "drawings.viewer.mobile.zoom": "Zoom",
            "drawings.viewer.mobile.pinch_hint": "Nyp på ritningen för att zooma, eller använd knapparna − / +.",
            "drawings.viewer.mobile.menu": "Ritningar",
            "drawings.viewer.mobile.search_placeholder": "Sök ritning, hus eller våning",
            "drawings.viewer.mobile.no_search_results": "Inga ritningar matchar sökningen.",
            "drawings.viewer.mobile.select_short": "Välj",
            "drawings.viewer.mobile.pan_short": "Pan",
            "drawings.viewer.mobile.add_short": "Ny",
            "drawings.viewer.zoom_in": "Zooma in",
            "drawings.viewer.zoom_out": "Zooma ut",
            "drawings.viewer.fit_to_screen": "Anpassa till skärm",
            "drawings.viewer.prev_page": "Föregående sida",
            "drawings.viewer.next_page": "Nästa sida",
            "drawings.viewer.tool.select": "Välj",
            "drawings.viewer.tool.pan": "Panorera",
            "drawings.viewer.calibrate": "Kalibrera",
            "drawings.viewer.calibrate_title": "Kalibrera mätning",
            "drawings.viewer.calibrate_help": "Rita en referenslinje på ritningen med känd längd, och skriv in längden i millimeter. Har du redan mätt används senaste mätlinjen automatiskt.",
            "drawings.viewer.calibrate_draw_line": "Rita en referenslinje på ritningen med mätverktyget.",
            "drawings.viewer.calibrate_using_existing": "Använder befintlig mätlinje som referens.",
            "drawings.viewer.calibrate_line_length": "Referenslinje",
            "drawings.viewer.calibrate_known_mm": "Känd längd (mm)",
            "drawings.viewer.calibrate_current_scale": "Nuvarande skala",
            "drawings.viewer.calibrate_new_scale": "Ny skala",
            "drawings.viewer.calibrate_save": "Spara kalibrering",
            "drawings.viewer.calibrate_saved": "Mätningsskala sparad",
            "drawings.viewer.calibrate_error_no_line": "Rita en referenslinje med mätverktyget innan du sparar.",
            "drawings.viewer.calibrate_error_no_length": "Ange den kända längden i millimeter.",
            "drawings.viewer.calibrate_error_invalid": "Ogiltig kalibrering. Kontrollera linje och längd.",
            "drawings.list": "Ritningar",
            "drawings.list.projects": "Projekt",
            "drawings.list_ui.add": "Lägg till",
            "drawings.list_ui.all_drawings": "Alla ritningar",
            "drawings.list_ui.legend": "Förklaring",
            "drawings.list_ui.pick_project_title": "Vilket projekt arbetar du med?",
            "drawings.list_ui.pick_project_help": "Ritningar tillhör alltid ett projekt. Välj ett en gång — det sparas resten av sessionen.",
            "drawings.list_ui.pick_project_search": "Sök projekt på nummer, namn eller kund",
            "drawings.list_ui.pick_project_empty": "Inga projekt hittades",
            "drawings.list_ui.pick_project_footer": "Nyligen använda projekt visas först. Du kan byta projekt när som helst från headern.",
            "drawings.list_ui.cancel_switch": "Avbryt byte",
            "drawings.list_ui.switch_project": "Byt",
            "drawings.list_ui.go_to_project": "Gå till projekt",
            "drawings.list_ui.summary": "{{count}} ritningar i projektet",
            "drawings.list_ui.manage_structure": "Hantera struktur",
            "drawings.list_ui.open_user_guide": "Användarguide",
            "drawings.list_ui.open_structure": "Hus och våningar",
            "drawings.list_ui.tab_all": "Alla ritningar",
            "drawings.list_ui.tab_needs_review": "Behöver granskning",
            "drawings.list_ui.tab_revisions": "Revisioner",
            "drawings.list_ui.tab_archive": "Arkiv",
            "drawings.list_ui.tab_coming_soon": "Kommer snart",
            "drawings.list_ui.search_placeholder": "Sök ritningar, hus, våningar",
            "drawings.list_ui.filter_all_types": "Alla",
            "drawings.list_ui.scope_floor": "Vald våning",
            "drawings.list_ui.scope_house": "Valt hus",
            "drawings.list_ui.result_count": "{{count}} träffar",
            "drawings.list_ui.empty_title": "Inga ritningar här ännu",
            "drawings.list_ui.empty_hint": "Lägg till en ritning för detta filter, eller välj en annan våning.",
            "drawings.list_ui.empty_cta": "Lägg till ritning här",
            "drawings.list_ui.updated_unknown": "Uppdaterad okänt",
            "drawings.list_ui.updated_today": "Uppdaterad idag",
            "drawings.list_ui.updated_yesterday": "Uppdaterad igår",
            "drawings.list_ui.updated_days": "Uppdaterad för {{count}} dagar sedan",
            "drawings.create_drawer.create": "Skapa ritning",
            "drawings.create_drawer.create_another": "Skapa och lägg till fler",
            "drawings.create_drawer.context_fallback": "Ny ritning",
            "drawings.create_drawer.pdf_hint": "Titel, hus och våning läses från filnamnet när det är möjligt",
            "drawings.create_drawer.title_placeholder": "t.ex. Hus 1 — Våning 2 ventilation",
            "drawings.create_drawer.location": "Plats",
            "drawings.create_drawer.location_hint": "Förfylld från ditt filter",
            "drawings.create_drawer.floor_required": "Välj våning, eller använd Övriga för ritningar utan våning",
            "drawings.structure.new_house_placeholder_short": "Husnamn",
            "drawings.structure.new_floor_placeholder_short": "Våningsnamn",
            "drawings.new": "Ny ritning",
            "drawings.viewer.modules": "Moduler",
            "drawings.viewer.modules_short": "Moduler",
            "drawings.viewer.deviations": "Avvikelser",
            "drawings.viewer.deviations_short": "Avvik",
            "drawings.viewer.checklists": "Checklistor",
            "drawings.viewer.checklists_short": "Check",
            "drawings.viewer.details": "Ritningsdetaljer",
            "drawings.viewer.details_short": "Detaljer",
            "drawings.viewer.structure_short": "Struktur",
            "drawings.viewer.live_drawing": "Live",
            "drawings.viewer.revision": "Rev. {{name}}",
            "drawings.viewer.updated_on": "uppdaterad {{date}}",
            "drawings.house": "Hus",
            "drawings.floor": "Våning",
            "drawings.structure.title": "Struktur",
            "drawings.structure.andre": "Övriga",
            "drawings.structure.andre_hint_short": "Utan våning",
            "drawings.structure.filter_andre": "Filtrerat på Övriga (utan våning)",
            "drawings.structure.help": "Skapa hus och våningar för projektet. Tilldela ritningar till våning, eller använd Övriga för ritningar utan våning.",
            "drawings.document": "Ritningsdokument",
            "drawings.document.required": "Ritningsdokument krävs",
            "drawings.document.replace": "Ersätt PDF",
            "drawings.document.upload_pdf": "Ladda upp ritnings-PDF",
            "drawings.document.pdf_only_hint": "Släpp fil här eller välj PDF",
            "drawings.document.choose_file": "Välj fil",
            "drawings.document.pdf_required": "Endast PDF-filer kan användas som ritning",
            "drawings.document.pdf_read_error": "Kunde inte läsa PDF:en. Prova en annan fil.",
            "drawings.document.checking_pages": "Kontrollerar antal sidor…",
            "drawings.document.multi_page_warning":
              "Denna PDF har {{count}} sidor. Endast 1 sida per ritning stöds — välj vilken sida som ska användas.",
            "drawings.document.use_this_page": "Använd sida {{page}}",
            "drawings.document.single_page_hint":
              "Endast den valda sidan laddas upp. Övriga sidor i original-PDF:en används inte.",
            "drawings.document.extracting_page": "Extraherar sida…",
            "drawings.document.extract_error": "Kunde inte extrahera sidan från PDF:en",
            "drawings.document.uploading": "Laddar upp…",
            "drawings.document.uploaded": "PDF uppladdad",
            "drawings.document.upload_error": "Kunde inte ladda upp PDF",
            "drawings.created": "Ritning skapad",
            "drawings.replaced": "Ritningen ersattes",
            "drawings.floor_replace_hint":
              "Samma våning och typ kan bara ha en ritning. Du måste bekräfta innan en befintlig ritning ersätts.",
            "drawings.floor_kind_hint":
              "Samma våning kan ha flera ritningar (t.ex. arkitekt och ventilation). Samma våning + samma typ kräver bekräftelse före ersättning.",
            "drawings.andre_hint":
              "«Övriga» är ritningar utan våning (t.ex. kök). De visas i en egen grupp i strukturen.",
            "drawings.floor_kind_conflict":
              "Det finns redan en ritning för denna våning och typ. Välj en annan typ, eller öppna den befintliga ritningen.",
            "drawings.kind": "Ritningstyp",
            "drawings.kind_hint": "Välj typ för ritningen. Typen används tillsammans med våning för att undvika dubbletter.",
            "drawings.kind.arkitekt": "Arkitekt",
            "drawings.kind.ventilasjon": "Ventilation",
            "drawings.kind.kjokken": "Kök",
            "drawings.kind.annet": "Övrigt",
            "drawings.replace_confirm.title": "Ersätt befintlig ritning?",
            "drawings.replace_confirm.message":
              "Du håller på att ersätta «{{title}}» ({{house}} · våning {{floor}} · {{kind}}).\n\nPDF/dokumentet ersätts. Detta kan inte enkelt ångras.",
            "drawings.replace_confirm.confirm": "Ersätt ritning",
            "drawings.replace_confirm.cancel": "Avbryt",
            "drawings.replace_confirm.invalid_target":
              "Kunde inte ersätta ritningen eftersom referensen till befintlig ritning saknas.",
            "drawings.updated": "Ritning uppdaterad",
            "drawings.create_error": "Kunde inte skapa ritning",
            "drawings.update_error": "Kunde inte uppdatera ritning",
            "drawings.update_partial": "{{done}} sparade. {{remaining}} återstår — kontrollera innan nytt försök.",
            "drawings.load_error": "Kunde inte ladda ritning",
            "drawings.observation.page": "Sida",
            "drawings.observation.add": "Lägg till",
            "drawings.observation.type.checklist": "Checklista",
            "drawings.observation.type.checklist_desc": "Ny från mall eller koppla befintlig",
            "drawings.observation.checklist_project_required": "Koppla ett projekt till ritningen för att lägga till checklista.",
            "drawings.observation.checklist_project_copy": "Checklistor tillhör projektet. Du kan fästa dem på ritningen med en pin, eller låta dem stå som projektchecklistor utan pin.",
            "drawings.observation.checklist_placed": "Checklista placerad på ritning",
            "drawings.observation.checklist_mode.new": "Ny från mall",
            "drawings.observation.checklist_mode.link": "Koppla befintlig",
            "drawings.observation.checklist_type_placeholder": "Välj checklistyp",
            "drawings.observation.checklist_types_loading": "Laddar typer…",
            "drawings.observation.checklist_items_selected": "{{count}} punkter valda",
            "drawings.observation.checklist_title_placeholder": "Valfri titel för checklistan",
            "drawings.observation.checklist_search_placeholder": "Sök i projektchecklistor",
            "drawings.observation.checklist_link_empty": "Inga tillgängliga checklistor att koppla.",
            "drawings.observation.field.checklist_type": "Checklistyp",
            "drawings.observation.field.house": "Hus",
            "drawings.observation.field.apartment": "Lägenhetsnummer",
            "drawings.observation.checklist_house_placeholder": "T.ex. Hus A",
            "drawings.observation.checklist_apartment_placeholder": "T.ex. H0101",
            "drawings.observation.field.existing_checklist": "Befintlig checklista",
            "drawings.observation.field.link_checklist": "Koppla till checklista",
            "drawings.observation.checklist_none": "Ingen checklista",
            "drawings.observation.field.search": "Sök",
            "drawings.observation.field.marker_shape": "Markörform",
            "drawings.observation.marker.arrow": "Pil",
            "drawings.observation.marker.circle": "Cirkel",
            "drawings.observation.marker.rectangular": "Rektangel",
            "drawings.observation.current_drawing_hint": "Placeras på aktuell ritning: {{title}} (sida {{page}})",
            "drawings.observation.sketch.toggle": "Markering / skiss på snapshot",
            "drawings.observation.sketch.toggle_hint": "Efter att du klickar på ritningen kan du rita frihand, pil, cirkel, rektangel eller text på snapshot-området.",
            "drawings.observation.sketch.title": "Skiss på snapshot",
            "drawings.observation.sketch.help": "Rita markeringar på utsnittet. Välj text för att flytta, eller dubbelklicka för att redigera. Markeringarna finns kvar tills du trycker Klar, Hoppa över eller Avbryt.",
            "drawings.observation.sketch.pen": "Frihand",
            "drawings.observation.sketch.arrow": "Pil",
            "drawings.observation.sketch.circle": "Cirkel",
            "drawings.observation.sketch.rectangular": "Rektangel",
            "drawings.observation.sketch.text": "Text",
            "drawings.observation.sketch.text_prompt": "Skriv textmarkering",
            "drawings.observation.sketch.undo": "Ångra",
            "drawings.observation.sketch.redo": "Gör om",
            "drawings.observation.sketch.clear": "Töm",
            "drawings.observation.sketch.skip": "Hoppa över",
            "drawings.observation.sketch.done": "Använd skiss",
            "drawings.observation.relocate": "Flytta",
            "drawings.observation.relocate_hint": "Klicka på ritningen för att sätta ny position.",
            "drawings.observation.relocate_saved": "Ny position satt — kom ihåg att spara ändringar.",
            "drawings.observation.sync_pending_badge": "Sparar",
            "drawings.observation.sync_error_badge": "Ej sparad",
            "drawings.observation.retry_save": "Spara igen",
            "drawings.observation.retry_needs_photo": "Foto saknas lokalt. Lägg till foto igen för att spara.",
            "drawings.observation.create_error": "Kunde inte skapa observation",
            "drawings.observation.capture_bind_error":
              "Kunde inte koppla snapshot till avvikelsen. Observationen placerades inte.",
            "drawings.observation.deviation_placed": "Avvikelse placerad på ritning",
            "drawings.observation.photo_placed": "Foto placerat på ritning",
            "drawings.observation.note_placed": "Anteckning placerad på ritning",
            "drawings.observation.project_required": "Koppla ett projekt till ritningen för att skapa avvikelser.",
            "drawings.observation.field.title": "Titel",
            "drawings.observation.field.category": "Kategori",
            "drawings.observation.field.severity": "Allvarlighetsgrad",
            "drawings.observation.field.description": "Beskrivning",
            "drawings.observation.field.explanation": "Förklaring",
            "drawings.observation.field.consequence": "Eventuella konsekvenser",
            "drawings.observation.deviation_explanation_placeholder":
              "Förklaring av avvikelsen – vad hände, var och när.",
            "drawings.observation.deviation_consequence_placeholder":
              "Eventuella konsekvenser eller risk om avvikelsen inte åtgärdas.",
            "drawings.observation.deviation_docs": "Dokument på ritning",
            "drawings.observation.deviation_docs_empty":
              "Inga dokument ännu. Använd kameran för att lägga till bild med pin och snapshot.",
            "drawings.observation.field.status": "Status",
            "drawings.observation.field.project": "Projekt",
            "drawings.observation.field.place": "Plats",
            "drawings.observation.field.created_by": "Skapad av",
            "drawings.observation.field.created_at": "Datum",
            "drawings.observation.severity.minor": "Mindre",
            "drawings.observation.severity.major": "Allvarlig",
            "drawings.observation.severity.critical": "Kritisk",
            "drawings.observation.view_details": "Visa detaljer",
            "drawings.observation.snapshot_title": "Ritningssnapshot",
            "drawings.observation.open_deviation": "Öppna avvikelse",
            "drawings.observation.go_to_deviation": "Gå till avvikelse",
            "drawings.observation.open_deviation_page": "Öppna avvikelsesida",
            "drawings.observation.tab.details": "Detaljer",
            "drawings.observation.tab.comments": "Kommentarer",
            "drawings.observation.field.consequence_type": "Konsekvenstyp",
            "drawings.observation.consequence_type_placeholder": "Välj konsekvenstyp",
            "drawings.observation.consequence_type.Economic": "Ekonomisk",
            "drawings.observation.consequence_type.Progress": "Framsteg",
            "drawings.observation.consequence_type.Safety": "Säkerhet",
            "drawings.observation.consequence_type.Environment": "Miljö",
            "drawings.observation.consequence_type.Quality": "Kvalitet",
            "drawings.observation.consequence_type.Authority": "Myndighet",
            "drawings.observation.consequence_type.Other": "Annat",
            "drawings.observation.sketch.select": "Välj",
            "drawings.viewer.open_deviation_dialog": "Visa detaljer",
            "drawings.viewer.deviation_status.open": "Öppen",
            "drawings.viewer.deviation_status.in_progress": "Pågår",
            "drawings.viewer.deviation_status.closed": "Stängd",
            "drawings.viewer.deviation_status.unknown": "Okänd",
            "drawings.viewer.checklist_add": "Lägg till checklista",
            "drawings.viewer.checklist_fill": "Fyll i",
            "drawings.viewer.checklist_attach_photo": "Bifoga foto",
            "drawings.viewer.checklist_upload_new_photo": "Ladda upp nytt foto",
            "drawings.viewer.checklist_attach_existing": "Koppla foto",
            "drawings.viewer.checklist_existing_photos": "Befintliga foton",
            "drawings.viewer.checklist_existing_photos_empty": "Inga foton på ritningen eller projektet ännu.",
            "drawings.viewer.checklist_photo_linked": "Fotot är kopplat till checklistan",
            "drawings.viewer.checklist_fill_subtitle": "Fyll i punkter direkt från ritningen",
            "drawings.viewer.checklist_fill_load_error": "Kunde inte ladda checklistan",
            "drawings.viewer.checklist_item_docs": "Dokument / pin",
            "drawings.viewer.checklist_item_doc": "Dokument",
            "drawings.viewer.checklist_item_docs_empty": "Inga dokument ännu — använd kameran för att placera en pin på ritningen.",
            "drawings.viewer.checklist_item_pinned": "Pin på ritning",
            "drawings.viewer.checklist_pin_group": "Pin {{n}}",
            "drawings.viewer.checklist_unpinned_docs": "Utan pin",
            "drawings.viewer.checklist_pin_completed": "Slutförd",
            "drawings.viewer.checklist_pin_approved_count": "{{count}} godkända",
            "drawings.viewer.checklist_pin_deviation_count": "{{count}} avvikelser",
            "drawings.viewer.checklist_pin_item_label": "Checklistpunkt",
            "drawings.viewer.checklist_pin_checklist_label": "Checklista",
            "drawings.viewer.deviation_pin_label": "Avvikelse",
            "drawings.viewer.deviation_pin_short": "Avvik",
            "drawings.viewer.deviation_pin_number": "Avvikelse {{number}}",
            "drawings.viewer.checklist_item_fallback": "Checklistpunkt",
            "drawings.viewer.checklist_status.approved": "Godkänd",
            "drawings.viewer.checklist_status.deviation": "Avvikelse",
            "drawings.viewer.checklist_status.na": "Ej tillämpligt",
            "drawings.viewer.checklist_status.pending": "Väntar",
            "drawings.viewer.checklist_status.not_approved": "Ej godkänd",
            "drawings.viewer.reopen_checklist": "Öppna checklista igen",
            "drawings.viewer.reopen_deviation": "Öppna avvikelse igen",
            "drawings.viewer.dismiss_pin_focus": "Stäng",
            "drawings.viewer.show_pin_on_drawing": "Visa på ritning",
            "drawings.viewer.checklist_link": "Koppla till ritning",
            "drawings.viewer.checklists_project_copy": "Checklistor tillhör projektet. Fäst dem på ritningen vid behov — eller skapa en ny.",
            "drawings.module.checklist": "Checklista",
        "drawings.delete_confirm": "Är du säker på att du vill radera den här ritningen?",
        "drawings.delete_error": "Kunde inte radera den här ritningen.",
        "drawings.deleted": "Ritningen har raderats.",
        "drawings.module.add": "Lägg till modul",
        "drawings.module.color": "Färg",
        "drawings.module.delete": "Radera modul",
        "drawings.module.delete_confirm": "Är du säker på att du vill radera den här modulen?",
        "drawings.module.pen": "Penna",
        "drawings.no_changes": "Inga ändringar att spara",
        "drawings.observation.deviation_title_placeholder": "Titel på avvikelsen",
        "drawings.observation.dialog_title": "Lägg till observation",
        "drawings.observation.document_missing": "Dokumentet hittades inte.",
        "drawings.observation.field.caption": "Bildtext",
        "drawings.observation.field.note": "Anteckning",
        "drawings.observation.field.photo": "Foto",
        "drawings.observation.field.pin_color": "Nålfärg",
        "drawings.observation.include_snapshot_in_print": "Inkludera ögonblicksbild i utskrift",
        "drawings.observation.note_empty": "Anteckningen är tom.",
        "drawings.observation.note_placeholder": "Skriv en anteckning…",
        "drawings.observation.optional": "Valfritt",
        "drawings.observation.photo_caption_placeholder": "Bildtext (valfritt)",
        "drawings.observation.photo_default_title": "Foto",
        "drawings.observation.photo_drop": "Släpp foto här",
        "drawings.observation.photo_drop_hint": "eller klicka för att välja en fil",
        "drawings.observation.place_hint": "Klicka på ritningen för att placera nålen",
        "drawings.observation.place_on_drawing": "Placera på ritningen",
        "drawings.observation.placement_banner": "Välj plats på ritningen",
        "drawings.observation.snapshot_print_saved": "Ögonblicksbilden sparades för utskrift.",
        "drawings.observation.type.deviation": "Avvikelse",
        "drawings.save_changes": "Spara ändringar",
        "drawings.viewer.create_version": "Skapa version",
        "drawings.viewer.editing_version": "Redigerar version",
        "drawings.viewer.loading_pdf": "Laddar ritning…",
        "drawings.viewer.location_saved": "Platsen sparades.",
        "drawings.viewer.no_modules": "Inga moduler",
        "drawings.viewer.open_checklist": "Öppna checklista",
        "drawings.viewer.pdf_error": "Kunde inte ladda PDF.",
        "drawings.viewer.pin_deviation_hint": "Placera nålen för avvikelsen på ritningen.",
        "drawings.viewer.unsaved": "Osparade ändringar",
        "drawings.viewer.version_created": "Versionen skapades.",
        "drawings.viewer.version_name_prompt": "Namnge versionen",
            "report.view.mobileNav.ariaLabel": "Snabbval för rapportavsnitt",
            "report.view.backToReport": "Tillbaka till rapport",
            "report.view.mobileNav.details": "Detaljer",
            "report.view.mobileNav.items": "Varuförbrukning",
            "report.view.mobileNav.variables": "Variabler",
            "report.view.mobileNav.checklist": "Checklista",
            "report.view.mobileNav.report": "Rapport",
            "report.view.mobileNav.timeRegistration": "Tidregistrering",
            "report.edit.menu_title": "Redigera information",
            "report.edit.unsaved": "Osparade ändringar",
            "report.edit.all_saved": "Allt är sparat",
            "report.edit.autosaved": "Ändringar sparas automatiskt",
            "report.edit.section.info": "Information",
            "report.edit.section.info_desc": "Titel, typ, beskrivning",
            "report.edit.section.checklist": "Checklista",
            "report.edit.section.checklist_desc": "Punkter, ordning, typ",
            "report.edit.section.price": "Prisrader",
            "report.edit.section.price_desc": "Varor, timmar och priser",
            "report.edit.section.team": "Ansvariga",
            "report.edit.section.team_desc": "Utförare och roller",
            "report.edit.section.status": "Rapportstatus & inställningar",
            "report.edit.section.status_desc": "Status, avisering, synlighet",
            "report.edit.info.heading": "Grundläggande information",
            "report.edit.info.subheading": "Typ och beskrivningar styr vad teknikern och kunden ser.",
            "report.edit.info.type": "Rapporttyp",
            "report.edit.info.executor": "Huvudutförare",
            "report.edit.info.order_date": "Orderdatum",
            "report.edit.info.address": "Adress",
            "report.edit.info.site": "Kundens anläggning",
            "report.edit.info.description": "Uppdragsbeskrivning",
            "report.edit.info.description_hint": "synlig för kund · stödjer formatering",
            "report.edit.info.internal": "Intern beskrivning",
            "report.edit.info.internal_hint": "endast internt",
            "report.edit.info.customer": "Kund",
            "report.edit.info.contact": "Kontaktperson",
            "report.edit.info.project": "Projekt",
            "report.edit.info.folder": "Projektmapp",
            "report.edit.info.report_number": "Rapportnummer",
            "report.edit.info.use_customer_address": "Använd kundens adress",
            "report.edit.info.documents": "Dokument",
            "report.edit.info.view_documents": "Visa dokument",
            "report.edit.info.economy": "Ekonomi och fakturering",
            "report.edit.info.invoice_to_project_customer": "Fakturera till projektkund",
            "report.edit.info.invoice_to_project_customer_desc": "Fakturan skickas till projektets kund",
            "report.edit.info.other_invoice_customer": "Annan fakturakund",
            "report.edit.info.other_invoice_customer_desc": "Välj en annan kund för fakturering",
            "report.edit.info.invoice_customer": "Fakturakund",
            "report.edit.info.cost_included_in_project": "Kostnad inkluderad i projekt",
            "report.edit.info.cost_included_in_project_desc": "Kostnader räknas in i projektet",
            "report.edit.info.sales_income_included_in_project": "Försäljningsintäkt inkluderad i projekt",
            "report.edit.info.sales_income_included_in_project_desc": "Intäkt räknas in i projektet",
            "report.edit.info.do_not_expect_income": "Förvänta inte intäkt",
            "report.edit.info.do_not_expect_income_desc": "Markera rapporten som utan förväntad intäkt",
            "report.edit.confirm_close.title": "Spara ändringar?",
            "report.edit.confirm_close.text": "Du har osparade ändringar. Vill du spara innan du stänger?",
            "report.edit.confirm_close.keep_editing": "Fortsätt redigera",
            "report.edit.confirm_close.discard": "Förkasta",
            "report.edit.confirm_close.save": "Spara",
            "report.edit.checklist.hint": "Dra i handtaget för att ändra ordning. Ange typ och markera vad som krävs.",
            "report.edit.checklist.none": "Rapporten är inte kopplad till en checklista ännu.",
            "report.edit.checklist.open": "Öppna checklista",
            "report.edit.checklist.select": "Välj checklista",
            "report.edit.checklist.created": "Checklista skapad",
            "report.edit.checklist.create_error": "Kunde inte skapa checklista",
            "report.edit.checklist.delete": "Ta bort checklista",
            "report.edit.checklist.delete_confirm":
              "Detta kan inte ångras. Är du säker på att du vill ta bort checklistan?",
            "report.edit.checklist.deleted": "Checklista borttagen",
            "report.edit.checklist.delete_error": "Kunde inte ta bort checklista",
            "report.edit.price.hint": "Varor, timmar och tjänster som faktureras kunden. Summor uppdateras automatiskt.",
            "report.edit.team.hint": "Vem som är ansvarig och vem som utför uppdraget. Roller styr åtkomst.",
            "report.edit.status.heading": "Rapportstatus",
            "report.edit.status.subheading": "Styr uppdragets framsteg.",
            "report.edit.status.under_process": "Under behandling",
            "report.edit.status.processed": "Behandlad",
            "report.edit.status.closed": "Stängd",
            "report.edit.status.finished": "Slutförd",
            "report.edit.status.finished_desc": "Rapporten slutförs vid sparande.",
            "report.edit.status.finished_date": "Slutfört datum",
            "report.edit.status.invoiced": "Fakturerad",
            "report.edit.status.invoiced_desc": "Markera rapporten som fakturerad.",
            "report.edit.status.settings": "Inställningar",
            "report.view.summary.customer": "Kund",
            "report.view.sectionReport.title": "Rapport",
            "report.view.sectionReport.description": "Alla servicerapporter ska innehålla en beskrivning som kan användas som underlag för fakturatext.",
            "report.view.sectionReport.cardSubtitle": "fakturatext",
            "report.view.sectionReport.unit": "rapport",
            "report.view.sectionReport.statusFinished": "Klar",
            "report.view.sectionReport.statusNotRequired": "Krävs inte",
            "report.view.sectionReport.statusMissing": "Saknas",
            "report.view.sectionGuide.title": "Guider",
            "report.view.sectionGuide.description": "Strukturerade guider och historik för denna rapport",
            "report.view.sectionGuide.unitRuns": "körningar",
            "report.view.sectionGuide.statusNone": "Ej påbörjad",
            "report.view.sectionGuide.statusHasRuns": "{{count}} genomförda",
            "report.view.guideHistory.title": "Guidehistorik",
            "report.view.guideHistory.empty": "Inga guider har slutförts på denna rapport ännu.",
            "report.view.guideHistory.startGuide": "Starta guide",
            "report.view.guideHistory.close": "Stäng",
            "report.view.guideHistory.completedAt": "Slutförd",
            "report.view.guideHistory.by": "Av",
            "report.view.guideHistory.unknownUser": "Okänd användare",
            "report.view.guideHistory.answers": "Svar",
            "report.view.guideHistory.tagsApplied": "Etiketter tillagda ({{count}})",
            "report.view.mobileNav.guide": "Guide",
            "report.view.priceCalculated.title": "Ett pris har beräknats för detta uppdrag",
            "report.view.priceCalculated.subtitle": "Senast sparade kalkyl visar vad kunden ska betala för hela jobbet (fastpris + tillägg).",
            "report.view.priceCalculated.open": "Öppna kalkyl",
            "report.view.priceCalculated.exVat": "Exkl. moms",
            "report.view.priceCalculated.incVat": "Inkl. moms",
            "report.redesign.project": "Projekt",
            "report.redesign.active": "Aktivt",
            "report.redesign.executor": "Utförande",
            "report.redesign.technician": "Servicetekniker",
            "report.redesign.report_type": "Rapporttyp",
            "report.redesign.oppdrag": "Uppdrag",
            "report.redesign.edit": "Redigera",
            "report.redesign.description": "Uppdragsbeskrivning",
            "report.redesign.no_description": "Ingen beskrivning tillagd",
            "report.redesign.internal": "Intern beskrivning",
            "report.redesign.internal_hint": "ej synlig för kund",
            "report.redesign.no_internal": "Ingen intern beskrivning",
            "report.redesign.appointment.title": "Avtal med kund",
            "report.redesign.appointment.confirmed": "Avtalat",
            "report.redesign.appointment.not_confirmed": "Inte avtalat",
            "report.redesign.appointment.empty": "Ange tidpunkt, utförare och avisering till kund",
            "report.redesign.appointment.set": "Boka tid",
            "report.redesign.finalize.title": "Slutför rapport",
            "report.redesign.finalize.done_title": "Rapport slutförd",
            "report.redesign.finalize.desc": "Slutför alla obligatoriska steg så kan rapporten skickas till kund.",
            "report.redesign.finalize.done_desc": "Rapporten är slutförd och skickad till kund.",
            "report.redesign.finalize.progress": "Framsteg",
            "report.redesign.finalize.done_short": "Slutförd",
            "report.redesign.finalize.view": "Visa slutförd rapport",
            "report.redesign.price.title": "Beräknat pris för uppdraget",
            "report.redesign.price.ex_vat": "Exkl. moms",
            "report.redesign.price.inc_vat": "Inkl. moms",
            "report.redesign.price.open": "Öppna priskalkylator",
            "report.redesign.address.title": "Leveransadress",
            "report.redesign.address.none": "Ingen adress registrerad",
            "report.redesign.address.open_maps": "Visa leveransadress på karta",
            "report.redesign.module.optional": "Valfri",
            "report.redesign.module.items_sub": "material",
            "report.redesign.module.variables_sub": "registrerat",
            "report.redesign.module.checklist_sub": "punkter",
            "report.redesign.module.guide_sub": "slutfört",
            "report.redesign.module.report_sub": "bilagor",
            "report.redesign.badge.confirmed": "Bekräftad",
            "report.redesign.badge.not_confirmed": "Ej bekräftad",
            "report.redesign.badge.not_agreed": "Ingen tid avtalad",
            "report.redesign.badge.must_rectify": "Måste åtgärdas",
            "report.redesign.badge.invoiced": "Fakturerad",
            "report.redesign.economy.title": "Ekonomisk översikt",
            "report.redesign.economy.sub_expected": "Kostnader och förväntad intäkt för uppdraget",
            "report.redesign.economy.sub_actual": "Kostnader och faktisk intäkt för uppdraget",
            "report.redesign.economy.costs": "Kostnader",
            "report.redesign.economy.income_expected": "Förväntad intäkt",
            "report.redesign.economy.income_actual": "Faktisk intäkt",
            "report.redesign.economy.order_items_cost": "Orderrader (kostpris)",
            "report.redesign.economy.order_items_income": "Orderrader (försäljningspris)",
            "report.redesign.economy.item_consumption": "Materialförbrukning",
            "report.redesign.economy.item_sales": "Försäljningspris varor (exkl. rabatt)",
            "report.redesign.economy.hours_cost": "Timkostnad",
            "report.redesign.economy.hours_income": "Ordinarie timpris",
            "report.redesign.economy.car_allowance": "Bilersättning",
            "report.redesign.economy.agreed_price": "Avtalat pris",
            "report.redesign.economy.additional_hours": "Tilläggsarbete (timmar)",
            "report.redesign.economy.total_cost": "Summa kostnader",
            "report.redesign.economy.total_income": "Summa intäkt",
            "report.redesign.economy.profit": "Vinst",
            "report.redesign.economy.margin": "Vinstmarginal",
            "report.redesign.economy.hours": "Totalt timmar",
            "report.redesign.economy.distance": "Körsträcka",
            "report.redesign.economy.items_count": "Antal varor",
            "report.redesign.economy.in_project_title": "Kostnader och intäkter ingår i projekt",
            "report.redesign.economy.in_project_body": "Denna rapports kostnader och intäkter ingår i projektsummeringen och visas inte separat här.",
            "report.additional_work_calculator.sectionTitle": "Beräkna tilläggsarbete",
            "report.additional_work_calculator.sectionSubtitle": "Kalkyl för tillägg utöver fastpris",
            "report.additional_work_calculator.sectionBody": "Öppna kalkylen för att justera timmar, material och nytt uppmöte.",
            "report.additional_work_calculator.open": "Öppna kalkyl",
            "report.additional_work_calculator.dialogTitle": "Kalkyl — vad ska kunden betala?",
            "report.additional_work_calculator.loading": "Hämtar prisestimat…",
            "report.additional_work_calculator.heroLabel": "Vad kunden betalar (hela jobbet)",
            "report.additional_work_calculator.exVat": "Exkl. moms",
            "report.additional_work_calculator.incVat": "Inkl. moms",
            "report.additional_work_calculator.exVatShort": "exkl.",
            "report.additional_work_calculator.incVatShort": "inkl.",
            "report.additional_work_calculator.extraHours": "Extratimmar",
            "report.additional_work_calculator.hoursLabel": "Antal timmar",
            "report.additional_work_calculator.newVisit": "Nytt uppmöte / körning",
            "report.additional_work_calculator.newVisitHelp": "Avstånd och priser följer samma underlag som prisestimatet.",
            "report.additional_work_calculator.includeVisit": "Inkludera kostnad för nytt uppmöte",
            "report.additional_work_calculator.estimateKm": "Avstånd från prisestimat: {{km}} km (ca.)",
            "report.additional_work_calculator.estimateKmPrice": "Kilometerpris kund: {{price}} /km exkl. moms",
            "report.additional_work_calculator.estimateMin": "Minimibelopp körning: {{min}} — vid låg km används fast taxa {{fixed}}",
            "report.additional_work_calculator.underMinHint": "Vid systemavstånd under minimibelopp används fast taxa.",
            "report.additional_work_calculator.modeSystem": "Använd km från system",
            "report.additional_work_calculator.modeCustom": "Egna km",
            "report.additional_work_calculator.modeMinimum": "Endast minimum / fast taxa",
            "report.additional_work_calculator.customKm": "Antal kilometer",
            "report.additional_work_calculator.productsTitle": "Material (ej fastprisrader)",
            "report.additional_work_calculator.noProducts": "Inga rader utanför fastpris på rapporten.",
            "report.additional_work_calculator.lineHint": "Ändringar här påverkar bara kalkylen — inte rapportraderna.",
            "report.additional_work_calculator.qty": "Antal",
            "report.additional_work_calculator.unitPrice": "Pris/st exkl.",
            "report.additional_work_calculator.exclude": "Uteslut från beräkning",
            "report.additional_work_calculator.includeAgain": "Ta med igen",
            "report.additional_work_calculator.detailsToggle": "Mer för företaget (kostnad, marginal, fastpris)",
            "report.additional_work_calculator.hourlyCustomer": "Timpris kund (exkl.)",
            "report.additional_work_calculator.hourlyCustomerHelp": "Timpris som kunden debiteras.",
            "report.additional_work_calculator.hourlyCost": "Timpris kostnad (exkl.)",
            "report.additional_work_calculator.hourlyCostHelp": "Intern kostnad per timme.",
            "report.additional_work_calculator.fallbackHourly": "Standardpris används.",
            "report.additional_work_calculator.fallbackCost": "Standardpris används.",
            "report.additional_work_calculator.rowLaborCust": "Arbete (kund)",
            "report.additional_work_calculator.rowLaborCost": "Arbete (kostnad)",
            "report.additional_work_calculator.rowMaterialCust": "Material (kund)",
            "report.additional_work_calculator.rowMaterialCost": "Material (kostnad)",
            "report.additional_work_calculator.rowVisitCust": "Uppmöte (kund)",
            "report.additional_work_calculator.rowVisitCost": "Uppmöte (kostnad)",
            "report.additional_work_calculator.rowFixed": "Fastprisrader (kund, exkl.)",
            "report.additional_work_calculator.rowTotalCost": "Summa kostnad företag (exkl.)",
            "report.additional_work_calculator.rowMargin": "Marginal (exkl.)",
            "report.additional_work_calculator.historyToggle": "Sparade kalkyler ({{count}})",
            "report.additional_work_calculator.restore": "Återställ",
            "report.additional_work_calculator.close": "Stäng",
            "report.additional_work_calculator.save": "Spara kalkyl",
            "report.additional_work_calculator.saveAsNew": "Spara som ny kalkyl",
            "report.additional_work_calculator.saveOverwrite": "Skriv över senaste",
            "report.additional_work_calculator.saveOverwriteHint":
              "Ersätter den senast sparade kalkylen. Äldre historik behålls.",
            "report.additional_work_calculator.newCalculation": "Ny kalkyl",
            "report.additional_work_calculator.newCalculationHint":
              "Nollställer formuläret från rapport och prisestimat (senaste sparning påverkar inte).",
            "report.additional_work_calculator.saving": "Sparar…",
            "report.additional_work_calculator.toastSaved": "Kalkyl sparad",
            "report.additional_work_calculator.toastSavedNew": "Ny kalkyl sparad",
            "report.additional_work_calculator.toastSavedOverwrite": "Senaste kalkylen uppdaterad",
            "report.additional_work_calculator.toastSaveError": "Kunde inte spara kalkyl",
            "report.additional_work_calculator.toastRestored": "Värden från sparad kalkyl har laddats",
            "report.additional_work_calculator.addFromCatalog": "Lägg till produkt",
            "report.additional_work_calculator.addManualLine": "Tom rad",
            "report.additional_work_calculator.addProductsTitle": "Välj produkter till kalkylen",
            "report.additional_work_calculator.addSelectedProducts": "Lägg till i kalkyl",
            "report.additional_work_calculator.toastProductsAdded": "{{count}} produkt(er) tillagda i kalkylen",
            "report.additional_work_calculator.lineTitle": "Beskrivning / artikel",
            "report.additional_work_calculator.lineHintCustom": "Endast i kalkylen — skapar inte rapportrad.",
            "report.additional_work_calculator.unitCost": "Kost/st exkl.",
            "report.additional_work_calculator.removeLine": "Ta bort rad",
            "report.additional_work_calculator.loadFromReport": "Ladda kalkyl från rapport",
            "report.additional_work_calculator.loadFromReportHint":
              "Listan visar endast rapporter med sparad priskalkyl. Välj rapport — senast sparade kalkyl används. Rader från källrapporten kopplas inte till denna rapport.",
            "report.additional_work_calculator.reportSelectorLabel": "Rapport med priskalkyl",
            "report.additional_work_calculator.selectorCalcSummary": "Senast sparad: {{ex}} exkl. / {{inc}} inkl.",
            "report.additional_work_calculator.loadFromReportDialogTitle": "Ladda kalkyl från annan rapport",
            "report.additional_work_calculator.loadFromReportBody":
              "Ange rapport-ID (samma som i URL eller rapportkort). Varorader från den rapporten kopplas inte hit — de ingår bara i kalkylen här.",
            "report.additional_work_calculator.reportIdLabel": "Rapport-ID",
            "report.additional_work_calculator.loadFromReportApply": "Ladda",
            "report.additional_work_calculator.loadFromReportCancel": "Avbryt",
            "report.additional_work_calculator.loadFromReportLoading": "Hämtar…",
            "report.additional_work_calculator.loadFromReportIdRequired": "Ange rapport-ID",
            "report.additional_work_calculator.loadFromReportIdInvalid": "Ogiltigt rapport-ID",
            "report.additional_work_calculator.loadFromReportSame": "Välj en annan rapport än denna",
            "report.additional_work_calculator.toastLoadedFromReport": "Kalkyl laddad från rapport {{number}}",
            "report.additional_work_calculator.toastNoCalculatorOnReport": "Den rapporten har ingen sparad kalkyl",
            "report.additional_work_calculator.toastLoadReportError": "Kunde inte hämta rapport eller kalkyl",
            "report.additional_work_calculator.addToConsumption": "Lägg till i varuförbrukning",
            "report.additional_work_calculator.addToConsumptionWorking": "Lägger till…",
            "report.additional_work_calculator.addToConsumptionHint":
              "Skapar eller uppdaterar en rapportrad (samma som varuförbrukning). Priser från kalkylen skrivs till raden när de skiljer sig.",
            "report.additional_work_calculator.toastAddedToConsumption": "Tillagd i varuförbrukning",
            "report.additional_work_calculator.toastAddToConsumptionNeedQty": "Ange antal större än noll",
            "report.additional_work_calculator.toastAddToConsumptionNeedTitle": "Ange beskrivning för manuell rad",
            "report.additional_work_calculator.toastAddToConsumptionUnlinked":
              "Artikeln lades till, men kalkylen kunde inte kopplas till raden automatiskt — uppdatera eller justera i varuförbrukning.",
            "report.additional_work_calculator.toastAddToConsumptionPriceSyncError":
              "Rad skapad, men priserna från kalkylen kunde inte synkas",
            "report.additional_work_calculator.toastAddToConsumptionError": "Kunde inte lägga till i varuförbrukning",
            "report.additional_work_calculator.discountLabel": "Rabatt timmar / körning",
            "report.additional_work_calculator.discountHint":
              "Belopp exkl. moms som dras från extratimmar och nytt uppmöte/körning (inte material eller fastpris). Får inte överstiga summan av dessa.",
            "report.additional_work_calculator.discountFieldLabel": "Rabatt timmar/körning (kr exkl. moms)",
            "report.additional_work_calculator.lineDiscountLabel": "Rad rabatt (exkl.)",
            "report.additional_work_calculator.lineDiscountHint":
              "Rabatt exkl. moms på denna materialrad. Får inte överstiga radens belopp (antal × pris/st).",
            "report.additional_work_calculator.rowSubtotal": "Delsumma före rabatter (ex.)",
            "report.additional_work_calculator.rowDiscount": "Rabatt (ex.)",
            "report.additional_work_calculator.rowDiscountMaterials": "Materialrabatt (ex.)",
            "report.additional_work_calculator.rowDiscountHoursVisit": "Timmar/körning rabatt (ex.)",
            "report.additional_work_calculator.rowMaterialCustGross": "Material före rabatt (kund, exkl.)",
            "report.additional_work_calculator.detailsToggleCustomer": "Prisdetaljer (kund, ex.)",
            "report.additional_work_calculator.rowTotalCustomerExVat": "Summa kund (ex.)",
            "report.additional_work_calculator.excludeShort": "Uteslut",
            "report.additional_work_calculator.includeShort": "Ta med",
            "report.additional_work_calculator.addToConsumptionShort": "Varuförbrukning",
            "report.additional_work_calculator.addPriceLines": "Lägg till prislinje",
            "report.additional_work_calculator.addPriceLinesHint":
              "Skapar en avtalad prislinje med avtalat arbete inkl. uppmöte: summan av extratimmar och uppmöte/körning (exkl. moms, före rabatt timmar/körning). Kopplar första projektaktivitet som har aktivitetspost, annars första aktiviteten på projektet. Justera under Prislinjer.",
            "report.additional_work_calculator.priceLineWorkIncludingVisitTitle":
              "Avtalat arbete inkl. uppmöte (kalkyl)",
            "report.additional_work_calculator.toastPriceLinesNothing":
              "Ange extratimmar och/eller aktivera nytt uppmöte med belopp större än noll.",
            "report.additional_work_calculator.toastPriceLinesAdded": "{{count}} prislinje(r) tillagda",
            "report.additional_work_calculator.toastPriceLinesError": "Kunde inte skapa prislinje",
            "report.sectionCard.viewOnlyHint": "Endast visning (klicka för att se)",
            "report.sectionCard.progress": "Framsteg",
            "report.sectionDialog.reportTitle": "Rapportinnehåll",
            "report.sectionDialog.reportDescription": "Skriv rapportinnehåll",
            "report.sectionDialog.reportContentLabel": "Rapport",
            "report.sectionDialog.reportContentHint": "Alla servicerapporter ska innehålla en beskrivning som kan användas som underlag för fakturatext.",
            "report.sectionDialog.internalReportLabel": "Intern rapport",
            "report.sectionDialog.internalReportHint": "Endast synlig för anställda internt — delas inte med kunden.",
            "report.sectionDialog.placeholderReport": "Skriv rapportinnehåll här…",
            "report.sectionDialog.placeholderInternal": "Skriv intern rapport här…",
            "report.sectionDialog.formatting": "Formaterar…",
            "report.sectionDialog.formatWithAi": "Formatera med ChatGPT",
            "report.sectionDialog.autoSaveHint": "Ändringar sparas automatiskt.",
            "report.sectionDialog.saving": "Sparar…",
            "report.sectionDialog.saved": "Sparat",
            "report.sectionDialog.autoSaveError": "Kunde inte spara rapporttext",
            "report.sectionDialog.close": "Stäng",
            "report.agreement.section.followup": "Uppföljning till kund",
            "report.agreement.section.followup_help":
              "Skicka påminnelse, skicka avtalet igen (SMS) eller skicka uppdaterat avtal efter att det bekräftats.",
            "report.agreement.section.manual_confirm": "Bekräfta avtal manuellt",
            "report.agreement.section.manual_confirm_help":
              "Använd när kunden redan bekräftat utanför Promang. Du får bekräfta innan det sparas.",
            "report.agreement.section.cancel_agreement": "Avboka avtal",
            "report.agreement.section.cancel_agreement_help":
              "Välj typ av avbokning eller orsak. «Uppdrag avbokat» avslutar utan motivering och utan meddelande om ny tid. SMS till kunden kan stängas av/på nedan innan du bekräftar.",
            "report.agreement.cancel_sms_hint":
              "Om aktiverat kan SMS skickas när avbokningen skickas (beroende på inställningar).",
            "report.agreement.prompt.reminder_title": "Skicka bekräftelsepåminnelse?",
            "report.agreement.prompt.reminder_body":
              "Kontrollera att du inte redan skickat en påminnelse för detta avtal.",
            "report.agreement.prompt.resend_title": "Skicka avtalet igen?",
            "report.agreement.prompt.resend_body":
              "Kontrollera att du inte redan skickat ett nytt meddelande till kunden.",
            "report.agreement.prompt.updated_appointment_title":
              "Skicka uppdaterat avtal?",
            "report.agreement.prompt.updated_appointment_body":
              "Samma datum och tid skickas som tidigare; beskrivning m.m. kan ha uppdaterats.",
            "report.agreement.prompt.confirm_manual_title":
              "Registrera manuell bekräftelse?",
            "report.agreement.prompt.confirm_manual_body":
              "Avtalet markeras som bekräftat ({{method}}). Vill du fortsätta?",
            "report.agreement.prompt.cancel_agreement_title": "Avboka avtalet?",
            "report.agreement.prompt.cancel_agreement_body":
              "Orsak: {{reason}}. Detta avbokar tidsbokningen i Promang. Vill du fortsätta?",
            "send-sms.customer": "Skicka SMS till kund",
            "cancel.reason": "Orsak till avbokning",
            "cancel.reason.required": "Orsak till avbokning krävs",
            "cancel.reason.employee_sickness": "Servicetekniker sjuk",
            "cancel.reason.customer_sickness": "Kund sjuk",
            "cancel.reason.not_confirmed": "Inte bekräftat av kund",
            "cancel.reason.not_suited": "Tid passade inte kunden",
            "cancel.reason.assignment_cancelled": "Uppdrag avbokat",
            "cancel.reason.not_chosen": "Inte vald",
            "report.agreement.edit": "Redigera avtal",
            "report.agreement.time_range": "Tidsperiod",
            "report.agreement.redesign.executing_section": "Utförare",
            "report.agreement.redesign.executing_help": "Välj vem som ska utföra arbetet.",
            "report.agreement.redesign.search_employee": "Sök efter person…",
            "report.agreement.redesign.avail_free": "Ledig",
            "report.agreement.redesign.avail_partial": "Delvis",
            "report.agreement.redesign.avail_busy": "Upptagen",
            "report.agreement.redesign.avail_absence": "Frånvaro",
            "report.agreement.redesign.no_employees": "Inga träffar.",
            "report.agreement.redesign.executing_locked_hint": "Du är tilldelad som utförare.",
            "report.agreement.redesign.schedule_section": "Avtalsdatum och tid",
            "report.agreement.redesign.schedule_help": "Dra ett tidsblock i kalendern till höger, eller justera genom att dra avtalet.",
            "report.agreement.redesign.drag_hint": "Dra i kalendern till höger för att sätta tid.",
            "report.agreement.redesign.drag_hint_bold": "Dra och släpp",
            "report.agreement.redesign.drag_hint_suffix": "för att skapa avtalet.",
            "report.agreement.redesign.drag_tip": "Tips: Dra blocket för att flytta det, eller dra nederkant för att ändra längd.",
            "report.agreement.redesign.settings_section": "Inställningar",
            "report.agreement.redesign.fixed_time_on_hint": "På: ankomst vid vald tidpunkt.",
            "report.agreement.redesign.fixed_time_off_hint": "Av: ankomst inom vald tidsperiod.",
            "report.agreement.redesign.clear_time": "Ta bort",
            "report.agreement.redesign.jobs_this_week": "{{count}} jobb denna vecka",
            "report.agreement.redesign.prev_week": "Föregående vecka",
            "report.agreement.redesign.next_week": "Nästa vecka",
            "report.agreement.redesign.today": "Idag",
            "report.agreement.redesign.legend_existing": "Befintliga",
            "report.agreement.redesign.legend_absence": "Frånvaro",
            "report.agreement.redesign.legend_new": "Nytt avtal",
            "report.agreement.redesign.absence_short": "Frånvaro",
            "report.agreement.redesign.channels": "Kanaler",
            "report.agreement.redesign.preview": "Förhandsvisning",
            "report.agreement.redesign.preview_empty": "Kunde inte hämta förhandsvisning.",
            "report.agreement.redesign.skip_notify": "Spara utan avisering",
            "report.agreement.redesign.send_agreement": "Skicka avtal",
            "report.agreement.redesign.pick_time_hint": "Välj tid i kalendern →",
            "report.agreement.redesign.conflict_hint": "Konflikt med befintligt avtal — du kan fortsätta ändå.",
            "report.agreement.redesign.next_notify": "Nästa: Avisering",
            "report.agreement.redesign.step_schedule": "Tid och utförare",
            "report.agreement.redesign.step_notify": "Kundavisering",
            "report.variables.update": "Uppdatera variabler",
            "report.price_lines.title": "Prislinjer",
            "report.price_lines.description": "Hantera prislinjer och avtalade priser",
            "report.price_lines.add": "Lägg till prislinje",
            "report.price_lines.empty": "Inga prislinjer tillagda",
            "report.price_lines.line": "Prislinje",
            "report.price_lines.title_field": "Titel",
            "report.price_lines.activity_item": "Aktivitet",
            "report.price_lines.no_activity": "Ingen aktivitet",
            "report.price_lines.description_field": "Beskrivning",
            "report.price_lines.is_agreed_price": "Avtalad prislinje",
            "report.price_lines.agreed_price": "Avtalat pris",
            "report.price_lines.agreed_price_excl_vat": "Avtalat pris (exkl. moms)",
            "report.price_lines.agreed_price_incl_vat": "Avtalat pris (inkl. moms)",
            "report.price_lines.vat_type": "Moms Typ",
            "report.price_lines.no_vat_type": "Ingen Moms Typ",
            "report.price_lines.select_vat_type": "Välj Moms Typ",
            "report.price_lines.select_vat_type_description": "Välj en moms typ för denna prisrad",
            "report.price_lines.search_vat_types": "Sök efter moms typer...",
            "report.price_lines.no_vat_types_found": "Inga moms typer hittades",
            "report.price_lines.no_vat_types_available": "Inga moms typer tillgängliga",
            "report.price_lines.select_activity": "Välj Aktivitet",
            "report.price_lines.project_activity": "Projektaktivitet",
            "report.price_lines.select_project_activity": "Välj projektaktivitet",
            "report.price_lines.select_project_first": "Välj ett projekt först",
            "report.price_lines.remove_activity": "Ta Bort Aktivitet",
            "report.price_lines.agreed_hours": "Avtalade timmar",
            "project_activity.label": "Projektaktivitet",
            "project_activity.select": "Välj projektaktivitet",
            "project_activity.dialog_title": "Välj projektaktivitet",
            "project_activity.search_placeholder": "Sök projektaktiviteter…",
            "project_activity.empty": "Inga projektaktiviteter hittades",
            "project_activity.select_project_first": "Välj projekt först",
            "project_activity.load_error": "Kunde inte ladda projektaktiviteter",
            "project_activity.clear_selection": "Rensa val",
            "project_activity.none": "Ingen projektaktivitet",
            "project_activity.missing": "Ingen projektrad",
            "hours.period_table.project_and_line": "Projekt / projektrad",
            "Loading": "Laddar",
            "hours.registration_warning.title": "Varning: Timmar överskrider beräknat",
            "hours.registration_warning.message": "Du håller på att registrera {newHours} timmar på aktiviteten \"{activityTitle}\". Detta kommer att bringa totalt registrerade timmar till {totalAfterRegistration} timmar, vilket överskrider de beräknade {estimatedHours} timmarna. Nu registrerat: {registeredHours} timmar.",
            "hours.registration_warning.question": "Är du säker på att du vill registrera dessa timmar på denna aktivitet?",
            "hours.registration_warning.confirm": "Ja, jag är säker",
            "hours.registration_warning.cancel": "Nej, korrigera",
            "hours.registration_warning.this_activity": "denna aktivitet",
            "hours.form_tab_details": "Detaljer",
            "hours.form.public_holiday_title": "Röd dag",
            "hours.form.public_holiday_body": "{{name}} är en helgdag. Normal arbetstid är 0 timmar denna dag, men du kan fortfarande registrera timmar vid behov.",
            "absence.form.public_holiday_title": "Röd dag",
            "absence.form.public_holiday_body": "Frånvaro kan inte registreras på röda dagar. Perioden inkluderar: {{names}}.",
            "absence.form.public_holiday_blocked": "Frånvaro kan inte registreras på röda dagar ({{names}}).",
            "absence.edit.title_new": "Ny frånvaro",
            "absence.edit.title_edit": "Redigera frånvaro",
            "absence.edit.close": "Stäng",
            "absence.edit.employee": "Anställd",
            "absence.edit.select_employee": "Välj anställd",
            "absence.edit.employee_admin_only": "Synlig endast för administratörer",
            "absence.edit.absence_type": "Frånvarotyp",
            "absence.edit.select_absence_type": "Välj frånvarotyp",
            "absence.edit.type_search": "Sök frånvarotyp",
            "absence.edit.type_empty": "Inga frånvarotyper hittades",
            "absence.edit.loading": "Laddar …",
            "absence.edit.type_balance": "Använt {{used}} · {{remaining}} dagar kvar",
            "absence.edit.type_hours_left": "{{hours}} timmar kvar",
            "absence.edit.select_employee_first": "Välj anställd först",
            "absence.edit.select_absence_type_first": "Välj frånvarotyp först",
            "absence.edit.period": "Period",
            "absence.edit.description": "Beskrivning",
            "absence.edit.max_days_hint_one": "Högst 1 dag för denna frånvarotyp",
            "absence.edit.max_days_hint_other": "Högst {{count}} dagar för denna frånvarotyp",
            "absence.edit.comp_time_hint": "Kompledighet baseras på faktiska intjänade timmar, inte ett maximalt antal dagar",
            "absence.edit.sick_leave_hint": "Sjukskrivning baseras på läkarintyg och har ingen begränsning på antalet dagar",
            "absence.edit.read_only_title": "Godkänd frånvaro",
            "absence.edit.read_only_body": "Denna frånvaro är godkänd och kan inte redigeras.",
            "absence.edit.documents_title": "Bilagor",
            "absence.edit.documents_subtitle": "Endast PDF-filer är tillåtna",
            "absence.edit.documents_add": "Lägg till fil",
            "absence.edit.documents_remove": "Ta bort fil",
            "absence.edit.documents_uploaded": "Bilagor uppladdade",
            "absence.edit.documents_upload_failed": "Kunde inte ladda upp bilagor",
            "absence.edit.export_pdf": "Exportera PDF",
            "absence.edit.exporting": "Exporterar …",
            "absence.edit.approve": "Godkänn",
            "absence.edit.delete": "Ta bort",
            "absence.edit.cancel": "Avbryt",
            "absence.edit.save": "Spara",
            "absence.edit.saving": "Sparar …",
            "absence.edit.create": "Skapa frånvaro",
            "absence.edit.update": "Spara ändringar",
            "absence.edit.error_title": "Fel vid sparande av frånvaro",
            "absence.edit.saved": "Frånvaron sparades",
            "absence.edit.saved_title": "Frånvaro registrerad",
            "absence.edit.saved_body": "Frånvaron är registrerad och skickas till behandling.",
            "absence.edit.saved_body_with_documents": "Frånvaron är registrerad och skickas till behandling. Bilagor har laddats upp.",
            "absence.edit.register_new": "Registrera ny frånvaro",
            "absence.edit.status": "Status",
            "absence.edit.pending_approval": "Skickas till behandling",
            "absence.edit.load_failed": "Kunde inte ladda frånvaron",
            "absence.edit.load_error": "Något gick fel när frånvaron laddades",
            "absence.edit.user_required": "En anställd måste väljas",
            "absence.edit.user_required_save": "Du måste välja en anställd innan du kan spara frånvaron",
            "absence.edit.user_id_required": "user_id krävs för att skapa/uppdatera frånvaro",
            "absence.edit.unknown_save_error": "Okänt fel vid sparande av frånvaron",
            "absence.edit.pdf_must_save": "Frånvaron måste sparas innan PDF kan exporteras",
            "absence.edit.pdf_must_approve": "Frånvaron måste godkännas innan PDF kan exporteras",
            "absence.edit.pdf_invalid": "PDF-filen är för liten eller ogiltig",
            "absence.edit.pdf_exported": "PDF exporterades",
            "absence.edit.pdf_failed": "Kunde inte exportera PDF",
            "absence.edit.delete_failed": "Något gick fel när frånvaron togs bort",
            "absence.edit.delete_confirm": "Är du säker på att du vill ta bort frånvaron?",
            "absence.edit.approve_title": "Godkänn frånvaro",
            "absence.edit.approved_label": "Godkänd",
            "absence.edit.denied_label": "Ej godkänd",
            "absence.edit.note": "Anteckning",
            "absence.edit.approved_by": "Godkänd av {{name}}",
            "generalNavMenu.newAbsence": "Lägg till frånvaro",
            "hours.approved_edit_notice_title": "Godkänd timme",
            "hours.approved_edit_notice_body":
              "Timmen är godkänd. Som företagsadministratör kan du ändå redigera den; godkännandestatus behålls. Lön eller Tripletex bör kontrolleras manuellt efter ändringar.",
            "hours.bulk_reassign.project_field": "Projekt",
            "hours.bulk_reassign.title": "Flytta timmar till annat projekt / aktivitet",
            "hours.bulk_reassign.intro": "Du redigerar {{count}} timmar. Välj målprojekt och projektaktivitet (rad).",
            "hours.bulk_reassign.project_required": "Projekt krävs",
            "hours.bulk_reassign.activity_required": "Projektaktivitet krävs",
            "hours.bulk_reassign.submit": "Verkställ för valda timmar",
            "hours.bulk_reassign.saving": "Sparar…",
            "hours.bulk_reassign.success": "Uppdaterade {{count}} timmar.",
            "hours.bulk_reassign.partial": "Uppdaterade {{updated}}; {{failed}} misslyckades — se listan.",
            "hours.bulk_reassign.error": "Kunde inte flytta timmar",
            "hours.bulk_reassign.open": "Flytta valda…",
            "hours.split.open": "Dela upp timmar",
            "hours.split.open_hint": "Fördela den här registreringen på flera projektaktiviteter. Summan måste stämma med totalt.",
            "hours.split.title": "Dela upp timmar",
            "hours.split.intro": "Fördela timmarna på flera aktiviteter. Summan av raderna måste vara lika med totalt antal timmar.",
            "hours.split.total_label": "Totalt",
            "hours.split.unit": "t",
            "hours.split.sum_live": "Fördelat {{allocated}} / Totalt {{total}}",
            "hours.split.remaining": "{{hours}} t återstår",
            "hours.split.over_allocated": "{{hours}} t för mycket",
            "hours.split.mismatch_hint": "Summan måste vara lika med totalt innan du kan spara.",
            "hours.split.col_project": "Projekt",
            "hours.split.col_activity": "Aktivitet",
            "hours.split.col_time": "Timmar",
            "hours.split.col_description": "Beskrivning",
            "hours.split.description_placeholder": "Valfritt",
            "hours.split.add_row": "Lägg till rad",
            "hours.split.remove_row": "Ta bort rad",
            "hours.split.row_n": "Rad {{n}}",
            "hours.split.submit": "Spara fördelning",
            "hours.split.saving": "Sparar…",
            "hours.split.success": "Timmarna delades upp på {{count}} rader.",
            "hours.split.error": "Kunde inte dela upp timmar",
            "hours.approval.filter_project": "Projekt",
            "hours.approval.all_projects": "Alla projekt",
            "hours.approval.clear_project_filter": "Rensa projekt",
            "hours.approval.selection_summary.title": "Sammanfattning av val",
            "hours.approval.selection_summary.subtitle":
              "«Registrerat» och periodtal kommer från listan för valt datumintervall och filter (samma urval som tabellen).",
            "hours.approval.selection_summary.total_selected": "Valt: {{hours}} t · {{entries}} poster",
            "hours.approval.selection_summary.period_totals": "I perioden (inläst): {{hours}} t · {{entries}} poster",
            "hours.approval.selection_summary.by_date": "Per datum",
            "hours.approval.selection_summary.day_row": "{{date}}: {{selected}} t valt av {{registered}} t registrerat",
            "hours.approval.selection_summary.other_days": "Andra dagar med registreringar: {{days}} dagar · {{hours}} t",
            "hours.approval.selection_summary.clear": "Rensa val",
            "hours.approval.selection_summary.unknown_user": "Okänd användare",
            "hours.approval.bulk.select_required": "Välj timmar att behandla",
            "hours.approval.bulk.approve_note": "Massgodkänd",
            "hours.approval.bulk.reject_note": "Massavvisad",
            "hours.approval.bulk.success_approved": "{{count}} timme(ar) godkända",
            "hours.approval.bulk.success_rejected": "{{count}} timme(ar) inte godkända",
            "hours.approval.bulk.partial": "{{done}} bekräftat behandlade. {{remaining}} återstår — kontrollera status innan nytt försök.",
            "hours.approval.bulk_unapprove.action": "Återkalla godkännande för valda",
            "hours.approval.bulk_unapprove.no_approved": "Ingen av de valda timmarna är godkända.",
            "hours.approval.bulk_unapprove.success": "Godkännande återkallat för {{count}} timmar.",
            "hours.approval.bulk_unapprove.error": "Kunde inte återkalla godkännande för alla valda timmar",
            "hours.approval.bulk_unapprove.partial": "{{done}} återkallade. {{remaining}} återstår — kontrollera status innan nytt försök.",
            "hours.approval.bulk_unapprove.process_note": "Massåterkallet godkännande",
            "project.time_registration.bulk_reassign": "Flytta valda timmar…",
            "project.time_registration.select_hour": "Välj timme för massflytt",
            "hours.resource_plan.title": "Resursplan och tillgänglighet",
            "hours.resource_plan.subtitle": "Se vem som är planerad, tillgänglig, frånvarande eller instämplad på de faktiska dagarna.",
            "hours.resource_plan.date_from": "Från datum",
            "hours.resource_plan.date_to": "Till datum",
            "hours.resource_plan.access_title": "Åtkomst för anställda",
            "hours.resource_plan.access_body": "Användare med åtkomst till Timmar kan se operativ kollegestatus utan administratörsrättigheter.",
            "hours.resource_plan.load_error": "Kunde inte ladda resursplan",
            "hours.resource_plan.stats.employees": "Anställda",
            "hours.resource_plan.stats.available_days": "Tillgängliga dagsrader",
            "hours.resource_plan.stats.clocked_in": "Instämplade",
            "hours.resource_plan.stats.scheduled_hours": "Planerade timmar",
            "hours.resource_plan.days_title": "Dagar i perioden",
            "hours.resource_plan.days_subtitle": "Välj en dag för detaljerad medarbetaröversikt.",
            "hours.resource_plan.day_stats": "{{available}} av {{employees}} tillgängliga",
            "hours.resource_plan.no_day": "Ingen dag vald",
            "hours.resource_plan.employee_overview": "Medarbetare, planerad tid och status för vald dag.",
            "hours.resource_plan.empty": "Inga anställda hittades för vald period.",
            "hours.resource_plan.unknown_employee": "Okänd medarbetare",
            "hours.resource_plan.table.employee": "Medarbetare",
            "hours.resource_plan.table.status": "Status",
            "hours.resource_plan.table.department": "Avdelning",
            "hours.resource_plan.table.scheduled": "Arbetsplan",
            "hours.resource_plan.table.shift": "Pass",
            "hours.resource_plan.table.note": "Notering",
            "hours.resource_plan.status.clocked_in": "På jobbet nu",
            "hours.resource_plan.status.available": "Tillgänglig",
            "hours.resource_plan.status.planned": "Planerad",
            "hours.resource_plan.status.absent": "Frånvaro",
            "hours.resource_plan.status.unavailable": "Inte tillgänglig",
            "hours.resource_plan.status.off": "Ledig",
            "crew.panel.title": "Bemanning och pass",
            "crew.panel.subtitle": "Dagens plan, frånvaro och stämpling (kräver modul «Mannskap och vaktplan» i företaget)",
            "crew.panel.loading": "Laddar bemanning…",
            "crew.panel.error": "Kunde inte ladda bemanning",
            "crew.panel.no_project": "Välj projekt för att se bemanning",
            "crew.panel.shifts": "Pass",
            "crew.panel.absences": "Frånvaro idag",
            "crew.panel.open_punches": "Pågående stämpling",
            "crew.panel.clock_in": "Stämpla in",
            "crew.panel.clock_out": "Stämpla ut",
            "crew.panel.checklists": "Checklistor",
            "crew.panel.seed_checklists": "Skapa standard checklisttyper",
            "crew.panel.hours": "Tidlista",
            "crew.panel.open_full": "Öppna modul",
            "crew.page.kicker": "Planering",
            "crew.page.title": "Bemanning och pass",
            "crew.page.subtitle": "Planera pass, hantera tillgänglighet, stämpling, kiosk och ledaröversikt",
            "crew.tabs.shifts": "Passplan",
            "crew.tabs.mine": "Mina pass",
            "crew.tabs.availability": "Tillgänglighet",
            "crew.tabs.punch": "Stämpling",
            "crew.tabs.kiosk": "Kiosk",
            "crew.tabs.leader": "Ledare",
            "crew.tabs.leader_alerts": "Efterlevnad och varningar",
            "crew.tabs.payroll": "Löneunderlag",
            "crew.stats.shifts": "Pass",
            "crew.stats.assignments": "Uppdrag",
            "crew.stats.open_punches": "Öppna stämplingar",
            "crew.stats.alerts": "Varningar",
            "crew.filters.title": "Planeringsfilter",
            "crew.filters.subtitle": "Välj projekt, period och aktiv dag för veckovyn.",
            "crew.filters.project": "Projekt",
            "crew.filters.date": "Datum",
            "crew.filters.period": "Period",
            "crew.filters.period_from": "Period från",
            "crew.filters.period_to": "Period till",
            "crew.filters.active_day": "Aktiv dag",
            "crew.filters.density": "Visning",
            "crew.filters.days": "dagar",
            "crew.filters.this_week": "Denna vecka",
            "crew.filters.next_week": "Nästa vecka",
            "crew.filters.this_month": "Denna månad",
            "crew.density.cozy": "Luftig",
            "crew.density.compact": "Kompakt",
            "crew.shift.new": "Nytt pass",
            "crew.shift.edit": "Redigera pass",
            "crew.shift.copy": "Kopiera pass",
            "crew.shift.copy_short": "Kopiera",
            "crew.shift.new_short": "Nytt pass",
            "crew.shift.step_info": "Info",
            "crew.shift.step_days_time": "Dagar och tid",
            "crew.shift.next_days_time": "Nästa: dagar och tid",
            "crew.shift.back_info": "Tillbaka till info",
            "crew.shift.title": "Titel",
            "crew.shift.title_hint": "Kort namn som gör passet lätt att känna igen, t.ex. ”Lördag kväll foodtruck”.",
            "crew.shift.title_placeholder": "T.ex. Lördag kväll foodtruck",
            "crew.shift.role": "Roll",
            "crew.shift.role_hint": "Vad personen ska göra på passet, t.ex. passledare, kök, kassa, servering eller städning. Använd ”passledare” när personen även ska följa upp checklistor vid start/slut.",
            "crew.shift.role_placeholder": "T.ex. Passledare",
            "crew.shift.role_suggestions": "Välj rollförslag eller skriv manuellt",
            "crew.shift.roles.shift_lead": "Passledare",
            "crew.shift.roles.cashier": "Kassa",
            "crew.shift.roles.kitchen": "Kök",
            "crew.shift.roles.service": "Servering",
            "crew.shift.roles.runner": "Runner",
            "crew.shift.roles.cleanup": "Städning",
            "crew.shift.roles.closing": "Stängning",
            "crew.shift.starts_at": "Start",
            "crew.shift.ends_at": "Slut",
            "crew.shift.project": "Projekt",
            "crew.shift.project_hint": "Kopplar passet till rätt projekt. Detta används senare vid stämpling och tidregistrering så att timmar hamnar på rätt projekt.",
            "crew.shift.location": "Plats",
            "crew.shift.location_hint": "Var passet utförs, t.ex. foodtruck-namn, adress, evenemang eller avdelning.",
            "crew.shift.location_placeholder": "T.ex. Foodtruck Centrum",
            "crew.shift.break_minutes": "Paus (min)",
            "crew.shift.break_minutes_hint": "Planerad paus som dras från planerade timmar.",
            "crew.shift.slots": "Platser",
            "crew.shift.slots_hint": "Hur många personer som behövs på passet.",
            "crew.shift.assignment_mode": "Tilldelning",
            "crew.shift.assignment_mode_hint": "Direkt tilldelning ger passet till vald anställd. Öppet passerbjudande låter anställda svara på erbjudandet.",
            "crew.shift.assignment_direct": "Direkt tilldelning",
            "crew.shift.assignment_open": "Öppet passerbjudande",
            "crew.shift.response_deadline": "Svarfrist",
            "crew.shift.response_deadline_hint": "Valfritt. Obesvarade erbjudanden döljs för anställda efter fristen.",
            "crew.shift.leader_checklist_required": "Kräv ledarchecklistor",
            "crew.shift.leader_checklist_required_hint": "Skapar obligatoriska uppstarts- och avslutschecklistor för passet. Användbart för passledare i foodtruck, serveringsenhet och serviceteam.",
            "crew.shift.handover_note": "Överlämningsnotering",
            "crew.shift.handover_note_hint": "Viktig information nästa ledare eller pass bör se.",
            "crew.shift.assigned_employee": "Anställd på passet",
            "crew.shift.assigned_employee_hint": "Valfritt. Välj en anställd här för att lägga personen direkt på alla valda dagar.",
            "crew.shift.month": "Månad",
            "crew.shift.month_hint": "Välj månaden du vill planera. Kryssa i dagarna i kalendern nedan.",
            "crew.shift.from_time": "Från kl.",
            "crew.shift.from_time_hint": "Starttid som används för alla valda dagar.",
            "crew.shift.to_time": "Till kl.",
            "crew.shift.to_time_hint": "Sluttid som används för alla valda dagar. Om slut är före start räknas det som nattpass till nästa dag.",
            "crew.shift.single_day": "En dag",
            "crew.shift.period_days": "Flera dagar",
            "crew.shift.period_from": "Period från",
            "crew.shift.period_to": "Period till",
            "crew.shift.weekdays": "Välj veckodagar",
            "crew.shift.create_plan": "Skapa passplan",
            "crew.shift.copy_plan": "Kopiera passplan",
            "crew.shift.copy_assignments_hint": "{{count}} personal kopieras från originalpasset om du inte väljer en annan anställd.",
            "crew.shift.overview_month": "Månad",
            "crew.shift.overview_period": "Period",
            "crew.shift.days_with_shifts": "Dagar med pass",
            "crew.shift.missing_days": "Dagar utan plan",
            "crew.shift.planned_hours": "Planerade timmar",
            "crew.shift.month_overview": "Månadsöversikt",
            "crew.shift.month_overview_hint": "Gröna dagar har passplan. Ljusa dagar saknar plan.",
            "crew.shift.day_has_shifts": "{{count}} pass",
            "crew.shift.day_missing": "Saknar plan",
            "crew.shift.day_by_day": "Dag för dag",
            "crew.shift.day_shift_count": "{{count}} pass",
            "crew.shift.selected_day_timeline": "Tidslinje för vald dag",
            "crew.shift.no_shifts_selected_day": "Inga pass på vald dag.",
            "crew.shift.add_shift_hint": "Välj en dag i veckan eller skapa ett nytt pass för att fylla planen.",
            "crew.shift.no_role": "Ingen roll",
            "crew.shift.no_days_selected": "Inga dagar valda i perioden",
            "crew.shift.ends_after_start": "Slut måste vara efter start",
            "crew.shift.no_crew_added": "Ingen personal tillagd / passerbjudande skickat",
            "crew.shift.publish": "Publicera",
            "crew.shift.cancel": "Avbryt",
            "crew.shift.cancel_reason": "Orsak till avbokning",
            "crew.assignment.add": "Lägg till personal",
            "crew.assignment.add_short": "Lägg till personal",
            "crew.assignment.accept": "Acceptera",
            "crew.assignment.decline": "Avböj",
            "crew.availability.starts_at": "Från",
            "crew.availability.ends_at": "Till",
            "crew.availability.add_day": "Välj dag",
            "crew.availability.add_day_button": "Lägg till dag",
            "crew.availability.add_weekdays": "Lägg till vardagar",
            "crew.availability.month": "Månad",
            "crew.availability.remove_day": "Ta bort dag",
            "crew.availability.no_days_selected": "Inga dagar valda",
            "crew.availability.selected_days": "Valda dagar",
            "crew.availability.selected_short": "Vald",
            "crew.availability.saved_short": "Sparad",
            "crew.availability.from_time": "Från kl.",
            "crew.availability.to_time": "Till kl.",
            "crew.availability.status": "Status",
            "crew.availability.available": "Tillgänglig",
            "crew.availability.unavailable": "Inte tillgänglig",
            "crew.availability.monthly_overview": "Tillgänglighet per månad",
            "crew.availability.month_stats": "{{days}} dagar · {{hours}} timmar tillgängliga",
            "crew.availability.loading": "Laddar…",
            "crew.availability.no_entries": "Ingen tillgänglighet sparad för vald period.",
            "crew.punch.clocked_in": "Du är instämplad",
            "crew.punch.choose_shift": "Välj pass för instämpling, eller stämpla in utan pass.",
            "crew.punch.clock_in_without_shift": "Stämpla in utan pass",
            "crew.punch.history": "Stämplingshistorik",
            "crew.punch.history_date": "Datum",
            "crew.punch.history_in": "In",
            "crew.punch.history_out": "Ut",
            "crew.punch.history_hours": "Timmar",
            "crew.punch.history_status": "Status",
            "crew.punch.deviation_note": "Avvikelse / notering",
            "crew.punch.deviation_note_placeholder": "Avvikelse, saknad checklistepunkt eller notering till nästa ledare...",
            "crew.punch.open": "Öppen",
            "crew.punch.closed": "Stängd",
            "crew.punch.no_history": "Inga stämplingar i perioden.",
            "crew.kiosk.title": "Kiosk / PIN",
            "crew.kiosk.help": "Använd en gemensamt inloggad enhet och personlig PIN för anställda.",
            "crew.kiosk.open": "Öppna PIN-verifiering",
            "crew.kiosk.employee_number": "Anställningsnummer",
            "crew.kiosk.pin": "PIN",
            "crew.kiosk.verify": "Verifiera",
            "crew.kiosk.verify_title": "Verifiera PIN",
            "crew.kiosk.pin_admin_title": "Hantera anställds PIN",
            "crew.kiosk.save_pin": "Spara PIN",
            "crew.kiosk.clear_pin": "Radera PIN",
            "crew.payroll.planned": "Planerat",
            "crew.payroll.actual": "Faktiskt",
            "crew.empty.shifts": "Inga pass i vald period.",
            "crew.empty.assignments": "Inga passerbjudanden eller tilldelningar.",
            "crew.empty.alerts": "Inga varningar.",
            "crew.empty.payroll": "Inget löneunderlag i perioden.",
            "crew.checklists.handover_title": "Checklisteöverlämning",
            "crew.checklists.mark_completed": "Markera klar",
            "crew.checklists.no_runs": "Inga obligatoriska passchecklistor i perioden.",
            "crew.checklists.kind.start": "Uppstart",
            "crew.checklists.kind.end": "Avslut",
            "crew.checklists.status.pending": "Väntar",
            "crew.checklists.status.in_progress": "Pågår",
            "crew.checklists.status.completed": "Klar",
            "crew.alerts.time_punch_deviation_note": "Avvikelse/notering från stämpling",
            "crew.alerts.required_shift_checklist_pending": "Obligatorisk checklista är inte klar",
            "crew.alerts.long_open_punch": "Lång öppen stämpling",
            "crew.alerts.planned_shift_missing_break": "Planerat pass saknar paus",
            "crew.alerts.high_hours_last_12_months": "Höga faktiska timmar senaste 12 månaderna",
            "crew.toast.saved": "Sparat",
            "crew.toast.assignment_saved": "Personal tillagd",
            "crew.toast.pin_verified": "PIN verifierad",
            "crew.toast.pin_saved": "PIN sparad",
            "crew.toast.pin_cleared": "PIN raderad",
            "crew.toast.published": "Pass publicerat",
            "crew.toast.cancelled": "Pass avbrutet",
            "crew.toast.accepted": "Pass accepterat",
            "crew.toast.declined": "Pass avböjt",
            "crew.toast.availability_saved": "Tillgänglighet sparad",
            "crew.toast.clocked_in": "Instämplad",
            "crew.toast.clocked_out": "Utstämplad",
            "crew.toast.checklists_seeded": "Checklisttyper skapade",
            "crew.toast.checklist_completed": "Checklista markerad som klar",
            "crew.weekdays.monday": "Mån",
            "crew.weekdays.tuesday": "Tis",
            "crew.weekdays.wednesday": "Ons",
            "crew.weekdays.thursday": "Tor",
            "crew.weekdays.friday": "Fre",
            "crew.weekdays.saturday": "Lör",
            "crew.weekdays.sunday": "Sön",
            "hours.sheet.add_hour": "Lägg till timme",
            "hours.sheet.edit_hour": "Redigera timme",
            "hours.sheet.new_hour": "Ny timme",
            "hours.sheet.stats_title": "Statistik",
            "hours.sheet.stats_selected_period": "Vald period (listan)",
            "hours.sheet.stats_calendar_month": "Kalendermånad",
            "hours.sheet.stats_weeks_heading": "Veckor",
            "hours.sheet.stats_this_week": "Denna vecka",
            "hours.sheet.stats_prev_week": "Föregående vecka",
            "hours.sheet.stats_normal_suffix": "normal (schema)",
            "hours.sheet.stats_no_schedule": "Ingen arbetstidsplan är kopplad till anställningen — normaltimmar och procent visas inte.",
            "hours.sheet.stats_loading_extra": "Hämtar månads- och veckototaler…",
            "hours.sheet.stats_compact_month": "Mån.",
            "hours.sheet.stats_show_more": "Mer",
            "hours.sheet.stats_show_less": "Mindre",
            "hours.sheet.stats_overview_title": "Översikt",
            "hours.sheet.stats_close": "Stäng",
            "hours.sheet.eyebrow": "Tidregistrering",
            "hours.sheet.scope_aria": "Välj vy",
            "hours.sheet.employee_search": "Sök anställd …",
            "hours.sheet.employee_empty": "Inga träffar",
            "hours.sheet.employee_none": "Ingen vald",
            "hours.sheet.employee_role_fallback": "Anställd",
            "hours.sheet.week_label": "Vecka {{week}}",
            "hours.sheet.day_none": "inga timmar",
            "hours.sheet.day_partial": "delvis",
            "hours.sheet.day_complete": "slutförd",
            "hours.sheet.entry_count": "{{count}} poster · {{projects}} projekt",
            "hours.sheet.export_aria": "Exportera tidrapport",
            "hours.sheet.export_pdf": "PDF",
            "hours.sheet.export_excel": "Excel",
            "hours.sheet.export_pdf_loading": "Skapar PDF…",
            "hours.sheet.export_excel_loading": "Skapar Excel…",
            "hours.sheet.export_pdf_success": "Tidrapport nedladdad som PDF",
            "hours.sheet.export_excel_success": "Tidrapport nedladdad som Excel",
            "hours.sheet.export_error": "Kunde inte exportera tidrapporten",
            "outbound_communications.title": "E-postlogg",
            "outbound_communications.search": "Sök",
            "outbound_communications.search_placeholder": "Sök i ämne, mottagare eller innehåll",
            "outbound_communications.load_error": "Kunde inte läsa e-postloggen",
            "outbound_communications.not_found": "E-posten hittades inte",
            "outbound_communications.no_subject": "(ingen titel)",
            "outbound_communications.system": "System",
            "outbound_communications.col_sent": "Skickad",
            "outbound_communications.col_subject": "Ämne",
            "outbound_communications.col_from": "Från",
            "outbound_communications.col_to": "Till",
            "outbound_communications.col_sent_by": "Skickad av",
            "outbound_communications.col_type": "Typ",
            "outbound_communications.col_customer": "Kund",
            "outbound_communications.export_pdf": "Exportera PDF",
            "outbound_communications.pdf_loading": "Skapar PDF…",
            "outbound_communications.pdf_failed": "Kunde inte exportera PDF",
            "outbound_communications.export_success": "PDF öppnad",
            "outbound_communications.select_all": "Välj alla",
            "outbound_communications.back": "Tillbaka till e-postloggen",
            "outbound_communications.attachments": "Bilagor",
            "documentationSend.export_title": "Exportera PDF",
            "documentationSend.export_intro": "Välj vad som ska ingå när du exporterar \"{{title}}\".",
            "documentationSend.export_include_signature": "Inkludera signaturfält",
            "documentationSend.export_include_send_log": "Inkludera sändningslogg",
            "documentationSend.export_download": "Ladda ner PDF",
            "documentationSend.export_send_log_only": "Exportera endast sändningslogg",
            "documentationSend.export_send_log": "Exportera sändningslogg",
            "documentationSend.export_failed": "Kunde inte exportera PDF",
            "documentationSend.export_empty_log": "Inga utskick att exportera ännu.",
            "documentationSend.exporting": "Skapar PDF…",
            "documentationSend.sent_short": "Skickad",
            "documentationSend.not_sent_yet": "Inte skickad ännu",
            "documentationSend.sent_badge": "Skickad {{date}}",
            "documentationSend.email_required": "E-post krävs",
            "documentationSend.invalid_email": "Ogiltig e-post",
            "documentationSend.failed": "Kunde inte skicka",
            "documentationSend.history_persist_failed":
              "E-posten skickades, men sändningsloggen kunde inte sparas. Uppdatera sidan och kontrollera historiken innan du skickar igen.",
            "documentationSend.intro": "Skicka \"{{title}}\" som PDF.",
            "documentationSend.send_to": "Skicka till",
            "documentationSend.message": "Meddelande",
            "documentationSend.message_placeholder": "Valfritt meddelande till mottagaren",
            "documentationSend.view_email": "Öppna i e-postloggen",
            "documentationSend.history_title": "Sändningslogg",
            "hours.sheet.of_normal": "av {{hours}}t normal",
            "hours.sheet.of_normal_short": "av {{hours}}t",
            "hours.sheet.new_entry_day": "Ny post för denna dag",
            "hours.sheet.week_matrix_sub": "{{projects}} projekt · {{activities}} aktiviteter",
            "hours.sheet.sum_day": "Summa dag",
            "hours.sheet.period_sub": "{{entries}} poster · {{days}} dagar med timmar",
            "hours.sheet.period_avg": "snitt {{hours}}t per aktiv dag",
            "hours.sheet.preset_this_month": "Denna månad",
            "hours.sheet.preset_last_month": "Föregående månad",
            "hours.sheet.preset_quarter": "Kvartal",
            "hours.sheet.period_meta": "{{days}} dagar · {{count}} med poster",
            "hours.sheet.hours_left": "{{hours}}t kvar",
            "hours.sheet.prev_week_short": "Föregående vecka {{hours}}t",
            "hours.sheet.stats_list_hint": "Listan under",
            "hours.sheet.project_split": "Fördelning per projekt",
            "hours.sheet.unsynced_title": "{{count}} poster inte synkade",
            "hours.sheet.unsynced_body": "Vissa timmar har inte skickats till lön. Bearbeta dem innan veckan stängs.",
            "hours.sheet.unsynced_see": "Visa post",
            "hours.sheet.unsynced_process": "Bearbeta nu",
            "hours.sheet.week_progress_title": "Vecka {{week}} — framsteg mot normaltid",
            "hours.sheet.week_progress_body": "{{hours}} timmar återstår innan normaltid nås.",
            "hours.sheet.hide_banner": "Dölj",
            "hours.quick.title": "Snabbregistrering",
            "hours.quick.week_subtitle": "Vecka {{week}} · {{range}}",
            "hours.quick.mode_aria": "Välj tidregistreringsläge",
            "hours.quick.mode_form": "Formulär",
            "hours.quick.mode_quick": "Snabb",
            "hours.quick.prev_week": "Föregående vecka",
            "hours.quick.next_week": "Nästa vecka",
            "hours.quick.copy_last_week": "Kopiera föregående vecka",
            "hours.quick.saving": "Sparar…",
            "hours.quick.saved": "✓ Sparat",
            "hours.quick.save_idle": "Klar",
            "hours.quick.save_error": "Kunde inte spara timmar",
            "quality.checklist.type.fieldResponseRules": "Fältets beteende för varje svar",
            "quality.checklist.type.fieldMode.hidden": "Dolt, inget krav",
            "quality.checklist.type.fieldMode.optional": "Synligt, valfritt",
            "quality.checklist.type.fieldMode.required": "Synligt, obligatoriskt",
            "quality.checklist.gaps.fields": "Obligatoriska fält saknas",
            "project.billing_plan.retention_completed_explanation": "Innestående beräknas från utfört belopp på raden i faktureringsplanen.",
            "project.billing_plan.retention_enable": "Använd procentuellt innestående",
            "project.billing_plan.retention_percentage": "Procentandel (%)",
            "project.billing_plan.retention_percentage_hint": "Ange en procentandel från 0 till 100.",
            "hours.quick.outcome_unknown": "Sparandet kunde inte bekräftas. Läs in sparade timmar innan du försöker igen. Detta ersätter utkastet i rutnätet.",
            "hours.quick.reload_saved": "Läs in sparade timmar",
            "hours.quick.save_error_short": "Sparfel",
            "hours.quick.batch_fallback": "Batch-sparning är tillfälligt otillgänglig — sparar celler en och en.",
            "hours.quick.loading": "Laddar vecka…",
            "hours.quick.col_project": "Projekt",
            "hours.quick.col_activity": "Aktivitet",
            "hours.quick.col_sum": "Summa",
            "hours.quick.no_project": "Välj projekt",
            "hours.quick.pick_activity": "Välj aktivitet",
            "hours.quick.description": "Beskrivning",
            "hours.quick.description_placeholder": "Vad arbetade du med?",
            "hours.quick.description_done": "Klar",
            "hours.quick.fill_handle": "Dra för att fylla",
            "hours.quick.remove_row": "Ta bort rad",
            "hours.quick.new_row": "Ny rad",
            "hours.quick.search_placeholder": "Sök projekt eller aktivitet…",
            "hours.quick.suggestions_hits": "Träffar",
            "hours.quick.suggestions_recent": "Favoriter och nyligen använda",
            "hours.quick.no_suggestions": "Inga förslag",
            "hours.quick.add_via_selectors": "Eller välj projekt",
            "hours.quick.browse_projects": "Bläddra bland projekt",
            "hours.quick.pick_project": "Välj projekt",
            "hours.quick.pick_activity_for_project": "Välj aktivitet…",
            "hours.quick.search_projects": "Sök projekt…",
            "hours.quick.search_activities": "Sök aktivitet…",
            "hours.quick.picker_search": "Sök…",
            "hours.quick.no_projects": "Inga projekt",
            "hours.quick.no_activities": "Inga aktiviteter",
            "hours.quick.tag_in_grid": "I rutnätet",
            "hours.quick.row_already_exists": "Raden finns redan — fokuserade den i rutnätet",
            "hours.quick.add_row_hint": "Samma projekt med annan aktivitet blir en ny rad.",
            "hours.quick.tag_recent": "Nyligen",
            "hours.quick.tag_project": "Projekt",
            "hours.quick.norm_title": "Vecka mot normaltid",
            "hours.quick.norm_of": "av {{hours}} t",
            "hours.quick.norm_unknown": "utan normaltid",
            "hours.quick.norm_on_target": "På normaltid",
            "hours.quick.norm_over": "+{{hours}} t över",
            "hours.quick.norm_left": "{{hours}} t kvar",
            "hours.quick.keyboard_hint": "Tab / Shift+Tab: nästa / föregående fält · F2: anteckning · Piltangenter för att flytta · Enter ner · Shift+PageUp/Down byter vecka · dra hörnet för att fylla",
            "hours.quick.flush_now": "Spara nu",
            "hours.quick.cancel": "Avbryt",
            "hours.quick.conflict_hint": "Flera timmar samma dag — dubbelklicka för att öppna formulär",
            "hours.mobile.add": "Ny tid",
            "hours.mobile.stats": "Statistik",
            "hours.mobile.navAriaLabel": "Timnavigering",
            "report.price_lines.updated": "Prislinje uppdaterad",
            "report.price_lines.created": "Prislinje skapad",
            "report.price_lines.deleted": "Prislinje raderad",
            "report.price_lines.save_error": "Kunde inte spara prislinje",
            "report.price_lines.delete_error": "Kunde inte radera prislinje",
            "report.price_lines.edit": "Redigera prislinje",
            "report.copy.price_lines_option": "Prislinjer",
            "report.copy.variables_option": "Variabler",
            "report.sequel.copy_variables_switch": "Kopiera från huvudrapport",
            "report.sequel.copy_variables_hint_on":
              "Variabler kopieras från huvudrapporten, inkl. grupper, typgrupper, värden och mätningar.",
            "report.sequel.copy_variables_hint_off": "Inga variabler kopieras.",
            "report.sequel.copy_variables_none_available":
              "Inga variabelrader eller grupper på huvudrapporten — inget att kopiera.",
            "report.sequel.copy_price_lines_switch": "Kopiera från huvudrapport",
            "report.sequel.copy_price_lines_hint_on":
              "Prislinjer kopieras från huvudrapporten ({{count}} rader).",
            "report.sequel.copy_price_lines_hint_off": "Inga prislinjer kopieras.",
            "report.sequel.copy_price_lines_none_available": "Inga prislinjer på huvudrapporten.",
            "report.price_lines.updating": "Uppdaterar...",
            "report.price_lines.adding": "Lägger till...",
            "report.price_lines.delete_confirm": "Är du säker på att du vill ta bort denna prislinjen?",
            "report.price_lines.delete": "Ta bort prislinje",
            "report.price_lines.error_loading": "Fel vid laddning av prislinjer",
            "report.price_lines.add_first": "Lägg till första prislinjen",
            "report.price_lines.title_required": "Titel krävs",
            "report.price_lines.validation.agreed_price_or_hours":
                "Ange avtalat pris (exkl. eller inkl. moms) eller avtalade timmar, eller stäng av «Avtalad prisrad».",
            "report.price_lines.server_errors_title": "Kunde inte spara — se meddelandena nedan",
            "report.price_lines.field_errors_hint": "Fält med fel är markerade.",
            "report.details.description": "Grundläggande rapportinformation",
            "report.items.description": "Hantera varor och konsumtion",
            "report.activities.description": "Hantera aktiviteter och timmar",
            "report.checklist.description": "Slutför checklistpunkter",
            "report.checklist.loading": "Laddar checklista…",
            "report.checklist.load_error": "Kunde inte ladda checklista",
            "report.checklist.load_error_title": "Checklistan kunde inte laddas",
            "report.checklist.load_error_hint":
              "Gå till ett annat steg och tillbaka, eller stäng och öppna dialogrutan igen. Om problemet kvarstår, försök igen senare.",
            "quality.checklist.view.completionTitle": "Slutför checklista",
            "quality.checklist.field.house": "Hus",
            "quality.checklist.field.apartment": "Lägenhetsnummer",
            "quality.checklist.view.completionDescription":
              "När alla rader är godkända eller markerade som avvikelse kan du slutföra checklistan. Osparade ändringar sparas när du fortsätter.",
            "quality.checklist.view.completionButton": "Slutför checklista",
            "quality.checklist.view.completionSaving": "Sparar…",
            "quality.checklist.view.completionDoneTitle": "Checklistan är slutförd",
            "quality.checklist.view.completionDoneDescription":
              "Checklistan är markerad som färdig.",
            "quality.checklist.gaps.complete": "{{resolved}} av {{total}} punkter ifyllda",
            "quality.checklist.gaps.remaining": "{{count}} punkter kvar",
            "quality.checklist.gaps.toggle": "Visa återstående punkter",
            "quality.checklist.gaps.untitled": "Utan titel",
            "quality.checklist.gaps.unanswered": "Inte besvarad",
            "quality.checklist.gaps.documents": "Saknar dokumentation",
            "quality.checklist.gaps.missing": "Saknas",
            "quality.checklist.gaps.statusDone": "Klar",
            "quality.checklist.gaps.statusOpen": "Öppen",
            "quality.checklist.selector.context_heading": "Checklistdetaljer",
            "quality.checklist.selector.context_date_required": "Datum krävs",
            "quality.checklist.selector.context_customer_required": "Kund måste väljas",
            "quality.checklist.selector.context_project_required": "Projekt måste väljas",
            "quality.checklist.selector.context_responsible_required": "Ansvarig måste väljas",
            "quality.checklist.type.titleLabel": "Titel",
            "quality.checklist.type.activeLabel": "Aktiv",
            "quality.checklist.type.introLabel": "Introduktion till denna checklisttyp",
            "quality.checklist.type.defaultActions": "Tillgängliga svar",
            "quality.checklist.type.defaultActionsHint":
              "Vilka utfall som ska visas som knappar på checklistrader. Punkter kan begränsa listan vidare.",
            "quality.checklist.type.pointsHeading": "Checklistpunkter",
            "quality.checklist.type.pointsSubheading":
              "Lägg till rubrik, vägledning för kund/användare och vilka svar som gäller för varje punkt.",
            "quality.checklist.type.documentsRequired": "Dokumentation krävs",
            "quality.checklist.type.pointLabel": "Punkt {{n}}",
            "quality.checklist.type.pointTitle": "Punktets namn",
            "quality.checklist.type.guidanceLabel": "Vägledning",
            "quality.checklist.type.guidanceHint":
              "Visas för den som fyller i checklistan. Fritextsvar anges i fältet nedan vid ifyllnad.",
            "quality.checklist.type.pointActions": "Svar för denna punkt",
            "quality.checklist.type.pointActionsHint":
              "Stäng av svar som inte ska visas bara för denna punkt. Standard följer checklisttypen.",
            "quality.checklist.type.addRow": "Ny punkt",
            "quality.checklist.type.deleteRowConfirm": "Ta bort denna punkt?",
            "quality.checklist.type.customFieldsTitle": "Anpassade fält",
            "quality.checklist.type.customFieldsHint":
                "Lägg till inmatningsfält som måste fyllas i vid genomförande av denna punkt (t.ex. uppmätt ström, återvinningsgrad).",
            "quality.checklist.type.customFieldLabel": "Etikett",
            "quality.checklist.type.customFieldType": "Typ",
            "quality.checklist.type.customFieldUnit": "Enhet",
            "quality.checklist.type.customFieldPlaceholder": "Platshållartext",
            "quality.checklist.type.customFieldRequired": "Obligatorisk",
            "quality.checklist.type.customFieldAdd": "Lägg till fält",
            "quality.checklist.type.customFieldTypes.text": "Text",
            "quality.checklist.type.customFieldTypes.number": "Tal",
            "quality.checklist.type.customFieldTypes.textarea": "Lång text",
            "quality.checklist.type.json.open_dialog": "JSON / AI",
            "quality.checklist.type.json.dialog_title": "JSON och AI för checklisttyp",
            "quality.checklist.type.json.tab_json": "Klistra in JSON",
            "quality.checklist.type.json.tab_ai_guide": "AI-instruktioner",
            "quality.checklist.type.json.hint": "Klistra in JSON från ChatGPT eller annan AI, eller redigera befintlig typ. Stöder { \"items\": [...] } eller full typ med title, description och default_response_actions.",
            "quality.checklist.type.json.replace_items": "Ersätt alla punkter",
            "quality.checklist.type.json.append_items": "Lägg till längst ned",
            "quality.checklist.type.json.copy_json": "Kopiera JSON",
            "quality.checklist.type.json.reload_from_editor": "Ladda om från editor",
            "quality.checklist.type.json.insert_sample": "Infoga exempel",
            "quality.checklist.type.json.apply": "Använd JSON",
            "quality.checklist.type.json.applied": "{{count}} punkter importerade",
            "quality.checklist.type.json.copy_success": "JSON kopierad",
            "quality.checklist.type.json.reload_success": "JSON laddad om från editor",
            "quality.checklist.type.json.clipboard_failed": "Kunde inte kopiera till urklipp",
            "quality.checklist.type.json.ai_guide_intro": "Kopiera instruktionerna nedan till ChatGPT, Claude eller annan AI. Klistra sedan in JSON-svaret under fliken Klistra in JSON.",
            "quality.checklist.type.json.copy_ai_guide": "Kopiera AI-instruktioner",
            "quality.checklist.type.json.ai_guide_copied": "AI-instruktioner kopierade",
            "quality.checklist.type.json.generate_with_ai": "Generera med AI",
            "quality.checklist.type.json.ai_parse_error": "Kunde inte läsa AI-svar som JSON",
            "quality.checklist.type.json.ai_apply_success": "{{count}} punkter tillagda från AI",
            "quality.checklist.type.json.error_empty": "JSON-fältet är tomt",
            "quality.checklist.type.json.error_invalid_json": "Ogiltig JSON — kontrollera syntax",
            "quality.checklist.type.json.error_no_items_array": "Ingen items-array hittades i JSON",
            "quality.checklist.type.json.error_no_valid_items": "Inga giltiga punkter efter import",
            "quality.checklist.actions.performed": "Utförd",
            "quality.checklist.actions.approved": "Godkänd",
            "quality.checklist.actions.na": "Ej aktuellt",
            "quality.checklist.actions.deviation": "Avvikelse",
            "quality.checklist.item.title": "Titel",
            "quality.checklist.item.guidanceTitle": "Vägledning",
            "quality.checklist.item.completionNote": "Anteckningar / observerat",
            "quality.checklist.item.deviationNoteRequired": "Lägg till en kort förklaring av avvikelsen.",
            "quality.checklist.item.responseLabel": "Utfall",
            "quality.checklist.item.customFieldsTitle": "Mätningar / data",
            "quality.checklist.item.customFieldRequired": "Detta fält är obligatoriskt",
            "quality.checklist.item.customFieldsRequiredBeforeOutcome":
                "Fyll i obligatoriska fält innan du väljer utfall.",
            "quality.checklist.item.uploadImageDirect": "Ladda upp bilder",
            "quality.checklist.item.uploadImageDirectShort": "Kamera",
            "quality.checklist.item.uploadImageDestination": "Checklistepunkt: {{title}}",
            "quality.checklist.item.uploadImagesOnly": "Endast bildfiler kan laddas upp här.",
            "quality.checklist.item.uploadImagePreviewTitle": "Förhandsgranskning före uppladdning",
            "quality.checklist.item.uploadImagePreviewHint":
                "{{count}} bild(er) klara. Ta bort det du inte vill ha och bekräfta för att ladda upp i bakgrunden.",
            "quality.checklist.item.uploadImageRemove": "Ta bort bild",
            "quality.checklist.item.uploadImageAddMore": "Lägg till fler",
            "quality.checklist.item.uploadImageConfirm": "Ladda upp {{count}} bild(er)",
            "quality.checklist.item.saving": "Sparar…",
            "quality.checklist.item.savePending": "Ändringar väntar…",
            "quality.checklist.item.saved": "Sparad",
            "quality.checklist.item.saveError": "Sparning misslyckades",
            "quality.checklist.item.saveFailed": "Kunde inte spara ändring",
            "quality.checklist.item.close": "Stäng",
            "quality.checklist.item.savingClose": "Sparar…",
            "report.type.required": "Rapporttyp krävs",
            "work Order": "Arbeidsordre",
            "service Agreement": "Serviceavtal",
            "project": "Prosjekt",
            "project_plan": "Projektplan",
            "projects_plan": "Projektplan",
            "projects_accounting": "Projektredovisning",
            "project.details": "Projektdetaljer",
            "project.manager": "Projektledare",
            "project.participants.delete_error": "Kunde inte ta bort deltagare",
            "project.required.banner_title": "Projektet saknar obligatoriska fält",
            "project.required.banner_description": "Dessa fält måste fyllas i innan du kan spara ändringar eller lägga till deltagare:",
            "project.required.edit_here": "Redigera här",
            "project.required.field.name": "Projektnamn",
            "project.required.field.project_manager": "Projektledare",
            "project.required.field.start_date": "Startdatum",
            "project.view.customer": "Kund",
            "project.view.copy_title": "Kopiera till urklipp",
            "project.view.mobileActions.ariaLabel": "Snabbåtgärder för projekt",
            "project.view.quickActions.title": "Snabbåtgärder",
            "project.view.quickActions.ariaLabel": "Snabbåtgärder för projekt",
            "project.actions.new_deviation": "Ny avvikelse",
            "project.actions.new_deviation_short": "Avvikelse",
            "project.actions.new_deviation_description": "Skapa en ny avvikelse för detta projekt",
            "project.actions.new_checklist_short": "Checklista",
            "project.actions.print_label": "Skriv ut etikett",
            "project.actions.service_report": "Servicerapport",
            "project.actions.service_report_short": "Rapport",
            "project.checklist.create": "Skapa checklista",
            "project.checklist.create_description":
              "Skapa en ny checklista för detta projekt",
            "project.checklist.default_title":
              "Projektchecklista #{{number}}{{suffix}}",
            "project.checklist.generic_title": "Checklista #{{number}} ({{date}})",
            "project.checklist.title_required": "Titel krävs",
            "project.checklist.create_failed": "Kunde inte skapa checklista",
            "project.checklist.create_success": "Checklista skapad",
            "project.checklist.id_missing": "Hittade inte checklista-ID",
            "project.tabs.updates": "Uppdatering",
            "project.actions.service_report_description": "Skapa en servicerapport",
            "project.actions.work_order": "Arbetsorder",
            "project.actions.work_order_short": "Arbetsorder",
            "project.actions.work_order_description": "Skapa en ny arbetsorder",
            "project.actions.new_folder": "Ny mapp",
            "project.actions.new_folder_short": "Mapp",
            "project.actions.new_folder_description": "Skapa en ny mapp för detta projekt",
            "project.actions.register_hours": "Registrera timmar",
            "project.actions.register_hours_short": "Timmar",
            "project.actions.register_hours_description": "Gå till tidsregistrering för projektet",
            "project.overview.export_pdf": "Exportera PDF",
            "project.overview.export_pdf_loading": "Exporterar…",
            "project.overview.export_pdf_success": "PDF exporterad",
            "project.overview.export_pdf_error": "Kunde inte exportera PDF",
            "project.overview.details_subtitle": "Fakta och specifikationer",
            "project.overview.fact.start": "Start",
            "project.overview.fact.end": "Slut",
            "project.overview.fact.department": "Avdelning",
            "project.overview.fact.category": "Kategori",
            "project.overview.fact.description": "Beskrivning",
            "project.overview.fact.number": "Projektnr.",
            "project.overview.fact.customer": "Kund",
            "project.overview.fact.manager": "Projektledare",
            "project.overview.facts.title": "Projektdetaljer",
            "project.overview.start_missing": "Startdatum saknas",
            "project.overview.end_unset": "Inte satt",
            "project.overview.hours_progress": "Timförbrukning",
            "project.overview.hours_unit": "timmar",
            "project.overview.no_budget_hours": "Inga budgettimmar satta",
            "project.overview.stats.hours": "Timmar",
            "project.overview.stats.view_time_overview": "Visa tidsöversikt",
            "project.overview.stats.load_error": "Projektets nyckeltal kunde inte hämtas.",
            "project.overview.stats.deviations": "Avvikelser",
            "project.overview.stats.open_deviations": "Öppna avvikelser",
            "project.overview.stats.work_orders": "Arbetsorder",
            "project.overview.stats.checklists": "Checklistor",
            "project.overview.stats.note.critical": "{{count}} kritiska",
            "project.overview.stats.note.ongoing": "{{count}} pågår",
            "project.overview.stats.note.checklist_pct": "{{pct}} % slutfört",
            "project.overview.stats.note.budget_pct": "{{pct}} % av budget",
            "project.overview.stats.note.no_budget": "Ingen budget",
            "project.overview.stats.note.none": "Inget registrerat",
            "project.overview.activity.title": "Senaste aktivitet",
            "project.overview.activity.see_all": "Se allt →",
            "project.overview.activity.empty": "Ingen aktivitet ännu",
            "project.overview.activity.fallback": "Uppdatering",
            "project.overview.address.title": "Leveransadress",
            "project.overview.address.subtitle": "Projektets leveransplats",
            "project.overview.address.view_map": "Öppna i karta",
            "project.overview.address.map": "Karta",
            "project.overview.address.edit": "Redigera adress",
            "project.overview.address.address": "Adress",
            "project.overview.address.city": "Ort",
            "project.overview.address.postal": "Postnummer",
            "project.overview.address.country": "Land",
            "project.overview.address.contact": "Kontaktperson",
            "project.overview.address.missing": "Adress inte satt",
            "project.overview.address.missing_city": "Ort inte satt",
            "project.overview.team.title": "Team",
            "project.overview.team.manage": "Administrera",
            "project.overview.team.project_manager": "Projektledare",
            "project.overview.team.empty": "Inga deltagare ännu",
            "project.palette.trigger": "Sök",
            "project.palette.placeholder": "Sök i projektet eller kör en åtgärd…",
            "project.palette.actions_heading": "Åtgärder",
            "project.palette.searching": "Söker…",
            "project.palette.no_results": "Inga träffar för «{{query}}»",
            "project.palette.module.document": "Dokument",
            "project.palette.module.folder": "Mappar",
            "project.palette.module.deviation": "Avvikelser",
            "project.palette.module.checklist": "Checklistor",
            "project.palette.module.report": "Rapporter",
            "project.palette.module.work_order": "Arbetsorder",
            "project.palette.module.action": "Åtgärder",
            "project.fab.open": "Ny",
            "project.fab.close": "Stäng",
            "project.view.mobileNav.ariaLabel": "Projektnavigering",
            "project.view.mobileNav.project": "Projekt",
            "project.view.mobileNav.tabs": "Flikar",
            "project.view.mobileNav.workOrders": "Arbetsorder",
            "project.view.mobileNav.drawings": "Ritningar",
            "project.view.mobileNav.folders": "Mappar",
            "project.view.mobileNav.takePhoto": "Ta foto",
            "project.view.mobileNav.contactsTitle": "Projektkontakter",
            "project.view.mobileNav.more": "Mer",
            "project.view.mobileActions.openActions": "Öppna snabbåtgärder",
            "project.view.mobileActions.closeActions": "Stäng snabbåtgärder",
            "project.view.mobileActions.actionsTitle": "Snabbåtgärder",
            "project.view.mobileActions.tabsTitle": "Projektflikar",
            "document_archive.tab": "Arkiv",
            "document_archive.brand": "Arkiv",
            "document_archive.project": "Projekt",
            "document_archive.project_archive": "Projektarkiv",
            "document_archive.all_files": "Alla filer",
            "document_archive.recent": "Senaste",
            "document_archive.folders": "Mappar",
            "document_archive.files": "Filer",
            "document_archive.upload": "Ladda upp",
            "document_archive.new_folder": "Ny mapp",
            "document_archive.search_placeholder": "Sök filer och mappar",
            "document_archive.modified": "Ändrad",
            "document_archive.grid": "Rutnät",
            "document_archive.list": "Lista",
            "document_archive.col_name": "Namn",
            "document_archive.col_modified": "Ändrad",
            "document_archive.col_size": "Storlek",
            "document_archive.open": "Öppna",
            "document_archive.share": "Dela",
            "document_archive.location": "Plats",
            "document_archive.status": "Status",
            "document_archive.select_file": "Välj en fil för att se detaljer",
            "document_archive.file_details": "Fildetaljer",
            "document_archive.empty_files": "Inga filer i den här mappen ännu.",
            "document_archive.no_folders": "Inga mappar ännu",
            "document_archive.files_count": "{{count}} filer",
            "document_archive.result_line": "{{files}} filer · {{folders}} mappar",
            "document_archive.storage_hint": "{{files}} filer i {{folders}} mappar",
            "document_archive.load_error": "Kunde inte läsa in dokument",
            "document_archive.missing_file": "Filen har ingen nedladdningslänk",
            "document_archive.link_copied": "Länk kopierad",
            "document_archive.copy_failed": "Kunde inte kopiera länken",
            "document_archive.download": "Ladda ner",
            "document_archive.download_failed": "Kunde inte ladda ner filen",
            "document_archive.delete": "Ta bort",
            "document_archive.delete_title": "Ta bort fil?",
            "document_archive.delete_confirm": "Ta bort «{{name}}»? Detta går inte att ångra.",
            "document_archive.deleted": "Filen togs bort",
            "document_archive.delete_failed": "Kunde inte ta bort filen",
            "document_archive.deleting": "Tar bort…",
            "document_archive.share_unavailable": "Delning är inte implementerad ännu",
            "document_archive.edit_title": "Redigera titel",
            "document_archive.title_required": "Titel krävs",
            "document_archive.title_saved": "Titel sparad",
            "document_archive.title_save_failed": "Kunde inte spara titeln",
            "document_archive.save": "Spara",
            "document_archive.saving": "Sparar…",
            "document_archive.cancel": "Avbryt",
            "document_archive.folder_title": "Namn",
            "document_archive.folder_title_placeholder": "Mappnamn",
            "document_archive.folder_title_required": "Namn krävs",
            "document_archive.folder_description": "Beskrivning",
            "document_archive.folder_description_placeholder": "Valfritt",
            "document_archive.folder_create_root": "Skapar en mapp i projektarkivet",
            "document_archive.folder_create_subfolder": "Skapar en undermapp i den aktuella mappen",
            "document_archive.create_folder": "Skapa mapp",
            "document_archive.creating": "Skapar…",
            "document_archive.folder_create_error": "Kunde inte skapa mappen",
            "document_archive.folder_menu": "Mappåtgärder",
            "document_archive.rename_folder": "Byt namn",
            "document_archive.folder_access": "Behörighet",
            "document_archive.folder_renamed": "Mappnamn sparat",
            "document_archive.folder_rename_failed": "Kunde inte byta namn på mappen",
            "document_archive.delete_folder": "Radera mapp",
            "document_archive.delete_folder_title": "Radera mapp?",
            "document_archive.delete_folder_confirm": "Radera «{{name}}»? Filer flyttas till {{destination}} och raderas inte.",
            "document_archive.delete_folder_confirm_children": "Radera «{{name}}» och {{count}} undermappar? Filer flyttas till {{destination}} och raderas inte.",
            "document_archive.folder_delete_root": "projektets rot",
            "document_archive.folder_deleted": "Mappen raderad",
            "document_archive.folder_delete_failed": "Kunde inte radera mappen",
            "document_archive.access": "Åtkomst",
            "document_archive.access_project": "Alla med projektåtkomst",
            "document_archive.access_project_hint": "Alla som kan öppna projektet kan se mappen och filerna.",
            "document_archive.access_admins": "Endast projektadmin och systemadmin",
            "document_archive.access_admins_hint": "Bara projektadmin och systemadmin kan se mappen och filerna.",
            "document_archive.access_inherited": "Undermappar ärver åtkomst från en låst överordnad mapp.",
            "document_archive.access_saved": "Mappåtkomst sparad",
            "document_archive.access_save_failed": "Kunde inte spara mappåtkomst",
            "document_archive.page_kicker": "Arkiv",
            "document_archive.page_title": "Arkiv",
            "document_archive.back_to_project": "Tillbaka till projektet",
            "document_archive.no_access": "Du har inte åtkomst till detta arkiv",
            "document_archive.not_found": "Kunde inte läsa in projektet",
            "document_archive.upload_dialog_title": "Uppladdning",
            "document_archive.upload_add_more": "Lägg till fler filer",
            "document_archive.upload_remove": "Ta bort",
            "document_archive.upload_title_placeholder": "Titel (valfritt)",
            "document_archive.upload_overall": "Totalt",
            "document_archive.upload_status": "Laddar upp {{current}} av {{total}}",
            "document_archive.upload_done": "Uppladdning klar",
            "document_archive.upload_start": "Ladda upp",
            "document_archive.upload_uploading": "Laddar upp…",
            "document_archive.upload_close": "Stäng",
            "project.edit": "Redigera projekt",
            "project.switcher.search": "Sök på namn, nummer eller kund",
            "project.switcher.recent": "Senaste",
            "project.switcher.all": "Alla projekt",
            "project.switcher.projects": "Projekt",
            "project.switcher.results": "{{count}} träffar",
            "project.switcher.empty": "Inga projekt matchar «{{query}}»",
            "project.switcher.current": "Nuvarande",
            "project.switcher.navigate": "↑↓ navigera",
            "project.switcher.open_key": "↵ öppna",
            "project.switcher.all_projects": "Alla projekt →",
            "project.switcher.switch": "Byt projekt",
            "project.switcher.loading": "Laddar projekt…",
            "project.item_list.summary_title": "Varlistor — sammanfattning",
            "project.item_list.summary_total_quantity": "Total kvantitet (netto)",
            "project.item_list.summary_total_purchase": "Totalt inköp",
            "project.item_list.summary_total_sales": "Totalt försäljning",
            "project.item_list.view_items_summary": "Vis varusammanfattning",
            "project.item_list.items_summary_page_title": "Varlistor — sammanfattning",
            "project.item_list.items_summary_subtitle":
              "Kvantiteter och priser över alla listor i detta projekt",
            "project.item_list.items_summary_intro":
              "Rader slås ihop per artikelnummer (produkter utan nummer grupperas per produkt). Returlister minskar nettokvantitet och belopp.",
            "project.item_list.items_summary_table_item_number": "Art.nr",
            "project.summary.invoiced_ex_vat_basis": "fakturerat (exkl. moms)",
            "project.summary.invoiced_ex_vat": "Summa kundfakturor, exkl. moms",
            "project.summary.not_invoiced": "Ej fakturerat",
            "project.summary.profit_vs_contract": "Resultat mot kontraktssumma",
            "project.summary.profit_vs_invoiced": "Resultat mot fakturerat",
            "project.summary.margin_vs_contract": "Marginal mot kontraktssumma",
            "project.summary.margin_vs_invoiced": "Marginal mot fakturerat",
            "project.summary.margin_on_invoiced_hint": "Baserat på fakturerat exkl. moms",
            "project.summary.of": "av",
            "project.summary.invoicing_rate_no_contract": "Ej definierat utan kontraktssumma",
            "project.summary.cost_rate_on_invoiced_hint": "mot fakturerat exkl. moms",
            "project.invoices.totals.invoiced_ex_vat": "Totalt fakturerat (exkl. moms)",
            "project.invoices.pagination.showing": "Visar {{from}}–{{to}} av {{total}}",
            "project.invoices.pagination.load_more": "Ladda fler fakturor",
            "project.invoices.pagination.loading_more": "Laddar…",
            "project.invoices.pagination.loaded_of_total": "{{loaded}} av {{total}} fakturor visade",
            "project.invoices.pagination.all_loaded": "Alla {{total}} fakturor är inlästa",
            "project.invoices.create_disabled_hint": "Det går inte att skapa faktura här ännu",
            "project.invoices.pagination.prev": "Föregående",
            "project.invoices.pagination.next": "Nästa",

            // Project tasks (Swedish)
            "project.tasks.tab_title": "Uppgifter",
            "project.tasks.title": "Projektuppgifter",
            "project.tasks.subtitle":
              "Uppgifter kopplade till detta projekt. Visas även i din Todo-inkorg.",
            "project.tasks.new_task": "Ny uppgift",
            "project.tasks.load_template": "Ladda mall",
            "project.tasks.show_finished": "Visa slutförda",
            "project.tasks.empty": "Inga uppgifter på detta projekt ännu.",
            "project.tasks.no_open": "Inga öppna uppgifter.",
            "project.tasks.finished_heading": "Slutförda",
            "project.tasks.filter_by_due": "Filtrera på förfallodatum",
            "project.tasks.bucket_all": "Alla",
            "project.tasks.bucket_overdue": "Förfallna",
            "project.tasks.bucket_today": "I dag",
            "project.tasks.bucket_soon": "Kommande",
            "project.tasks.bucket_later": "Längre fram",
            "project.tasks.bucket_no_due": "Utan förfallodatum",
            "project.tasks.due": "Förfaller",
            "project.tasks.shared": "Delad",
            "project.tasks.blocked": "Blockerad",
            "project.tasks.blocked_hint":
              "Den kopplade checklistan måste slutföras innan uppgiften kan slutföras.",
            "project.tasks.finish": "Slutför",
            "project.tasks.finished": "Slutförd",
            "project.tasks.mark_finished": "Markera som slutförd",
            "project.tasks.reopen": "Återöppna",
            "project.tasks.finish_failed": "Kunde inte ändra uppgiftens status.",
            "project.tasks.bulk_apply": "Uppdatera valda",
            "project.tasks.bulk_need_change": "Välj nytt datum eller ansvarig innan du uppdaterar.",
            "project.tasks.bulk_done": "Uppgifterna är uppdaterade.",
            "project.tasks.bulk_failed": "Kunde inte uppdatera uppgifterna.",
            "project.tasks.selected_count": "{{count}} valda",
            "project.tasks.load_failed": "Kunde inte ladda uppgifter.",
            "project.tasks.created": "Uppgift skapad.",
            "project.tasks.create_failed": "Kunde inte skapa uppgift.",
            "project.tasks.title_required": "Titel krävs.",
            "project.tasks.create": "Skapa",
            "project.tasks.edit": "Redigera",
            "project.tasks.edit_task": "Redigera uppgift",
            "project.tasks.save": "Spara",
            "project.tasks.updated": "Uppgift uppdaterad.",
            "project.tasks.update_failed": "Kunde inte uppdatera uppgift.",
            "project.tasks.field_recurrence": "Upprepning",
            "project.tasks.field_title": "Titel",
            "project.tasks.field_description": "Beskrivning",
            "project.tasks.field_due_date": "Förfallodatum",
            "project.tasks.field_priority": "Prioritet",
            "project.tasks.priority_none": "Ingen",
            "project.tasks.priority_low": "Låg",
            "project.tasks.priority_medium": "Medel",
            "project.tasks.priority_high": "Hög",
            "project.tasks.field_checklist": "Koppla till checklista",
            "project.tasks.checklist_none": "Ingen checklista",
            "project.tasks.checklist_gate_hint":
              "Uppgiften kan slutföras först när checklistan är slutförd eller godkänd.",
            "project.tasks.field_assignees": "Mottagare",
            "project.tasks.add_assignees": "Lägg till mottagare",
            "project.tasks.on_today_plan": "Lägg till i dagens plan",
            "project.tasks.no_templates": "Inga aktiva uppgiftsmallar.",
            "project.tasks.apply": "Ladda",
            "project.tasks.template_applied": "Laddade {{count}} uppgift(er) från mall.",
            "project.tasks.template_failed": "Kunde inte ladda mall.",
            "project.tasks.template_item_count": "{{count}} uppgifter",
            "task.referenceBlocked.checklist":
              "Uppgiften kan inte slutföras förrän den kopplade checklistan är slutförd eller godkänd.",
            "projectTaskTemplate.title": "Projektuppgiftsmallar",
            "projectTaskTemplate.subtitle":
              "Återanvändbara uppsättningar av uppgifter som kan laddas på projekt.",
            "projectTaskTemplate.new_set": "Ny malluppsättning",
            "projectTaskTemplate.set_title": "Titel",
            "projectTaskTemplate.set_description": "Beskrivning",
            "projectTaskTemplate.set_category": "Kategori",
            "projectTaskTemplate.set_active": "Aktiv",
            "projectTaskTemplate.items": "Uppgifter i uppsättningen",
            "projectTaskTemplate.add_item": "Lägg till uppgift",
            "projectTaskTemplate.item_title": "Titel",
            "projectTaskTemplate.item_due_offset": "Förfaller (dagar från projektstart)",
            "projectTaskTemplate.item_recurrence": "Upprepning",
            "projectTaskTemplate.item_shared": "Delad",
            "projectTaskTemplate.spawn_checklist": "Skapa checklista",
            "projectTaskTemplate.select_checklist_type": "Välj checklisttyp",
            "projectTaskTemplate.edit": "Redigera",
            "projectTaskTemplate.edit_set": "Redigera malluppsättning",
            "projectTaskTemplate.save": "Spara",
            "projectTaskTemplate.saved": "Malluppsättning sparad.",
            "projectTaskTemplate.save_failed": "Kunde inte spara malluppsättning.",
            "projectTaskTemplate.delete": "Ta bort",
            "projectTaskTemplate.delete_confirm": "Ta bort denna malluppsättning?",
            "projectTaskTemplate.deleted": "Malluppsättning borttagen.",
            "projectTaskTemplate.empty": "Inga malluppsättningar ännu.",
            "projectTaskTemplate.load_failed": "Kunde inte ladda malluppsättningar.",
            "projectTaskTemplate.json.open_dialog": "JSON / AI",
            "projectTaskTemplate.json.dialog_title": "Mall-JSON och AI-instruktioner",
            "projectTaskTemplate.json.tab_json": "Klistra in JSON",
            "projectTaskTemplate.json.tab_ai_guide": "AI-instruktioner",
            "projectTaskTemplate.json.hint": "Klistra in JSON från AI eller kopiera aktuell mall. Använd Ersätt eller Lägg till.",
            "projectTaskTemplate.json.copy_json": "Kopiera JSON",
            "projectTaskTemplate.json.copy_success": "JSON kopierad",
            "projectTaskTemplate.json.reload_from_editor": "Ladda från editorn",
            "projectTaskTemplate.json.reload_success": "JSON laddad från editorn",
            "projectTaskTemplate.json.insert_sample": "Infoga exempel",
            "projectTaskTemplate.json.apply": "Använd i editorn",
            "projectTaskTemplate.json.applied": "{{count}} uppgifter inlagda",
            "projectTaskTemplate.json.replace_items": "Ersätt alla uppgifter",
            "projectTaskTemplate.json.append_items": "Lägg till längst ner",
            "projectTaskTemplate.json.clipboard_failed": "Kunde inte kopiera till urklipp",
            "projectTaskTemplate.json.ai_guide_intro": "Kopiera instruktionerna nedan till ChatGPT, Claude eller annan AI. Klistra sedan in JSON-svaret under fliken Klistra in JSON.",
            "projectTaskTemplate.json.copy_ai_guide": "Kopiera AI-instruktioner",
            "projectTaskTemplate.json.ai_guide_copied": "AI-instruktioner kopierade",
            "projectTaskTemplate.json.generate_with_ai": "Generera med AI",
            "projectTaskTemplate.json.ai_parse_error": "Kunde inte läsa AI-svar som JSON",
            "projectTaskTemplate.json.ai_apply_success": "{{count}} uppgifter inlagda från AI",
            "projectTaskTemplate.json.error_empty": "JSON är tom",
            "projectTaskTemplate.json.error_invalid_json": "Ogiltig JSON",
            "projectTaskTemplate.json.error_no_items_array": "JSON saknar items-array",
            "projectTaskTemplate.json.error_no_valid_items": "Inga giltiga uppgifter i JSON",

            // Project HSE handbook (Swedish)
            "project.hse_handbook.tab_title": "HMS-handbok",
            "project.hse_handbook.title": "HMS-handbok för projekt",
            "project.hse_handbook.subtitle":
              "Hämta in HMS-dokument, checklistor och formulär för detta projekt.",
            "project.hse_handbook.section_documents": "Dokument",
            "project.hse_handbook.section_checklists": "Checklistor",
            "project.hse_handbook.section_forms": "Formulär",
            "project.hse_handbook.section_crew": "Manskapslista",
            "project.hse_handbook.add_document": "Lägg till dokument",
            "project.hse_handbook.import_template": "Importera mall",
            "project.hse_handbook.print": "Skriv ut handbok",
            "project.hse_handbook.printing": "Handboken skrivs ut …",
            "project.hse_handbook.print_failed": "Kunde inte skriva ut handboken",
            "project.hse_handbook.open_personal_handbook": "Personalhandbok",
            "project.hse_handbook.view": "Visa",
            "project.hse_handbook.remove": "Ta bort",
            "project.hse_handbook.remove_confirm": "Ta bort detta dokument från handboken?",
            "project.hse_handbook.removed": "Dokument borttaget från handboken",
            "project.hse_handbook.remove_failed": "Kunde inte ta bort dokumentet",
            "project.hse_handbook.create_copy": "Skapa projektkopia",
            "project.hse_handbook.create_checklist": "Skapa checklista",
            "project.hse_handbook.checklist_created": "Checklista skapad",
            "project.hse_handbook.checklist_failed": "Kunde inte skapa checklista",
            "project.hse_handbook.fill_form": "Fyll i formulär",
            "project.hse_handbook.form_created": "Formulär skapat",
            "project.hse_handbook.form_failed": "Kunde inte skapa formulär",
            "project.hse_handbook.override_created": "Projektkopia skapad",
            "project.hse_handbook.override_failed": "Kunde inte skapa projektkopia",
            "project.hse_handbook.project_copy": "Projektkopia",
            "project.hse_handbook.added": "{{count}} dokument tillagda",
            "project.hse_handbook.add_failed": "Kunde inte lägga till dokument",
            "project.hse_handbook.add_selected": "Lägg till ({{count}})",
            "project.hse_handbook.imported": "{{count}} dokument importerade",
            "project.hse_handbook.import_failed": "Kunde inte importera dokument",
            "project.hse_handbook.import_all_confirm":
              "Importera alla godkända HMS-dokument, checklistor och formulär till projektet?",
            "project.hse_handbook.load_failed": "Kunde inte ladda handboken",
            "project.hse_handbook.empty_section": "Inga dokument i denna sektion ännu.",
            "project.hse_handbook.no_content": "Inget innehåll registrerat.",
            "project.hse_handbook.no_available_documents": "Inga tillgängliga dokument.",
            "project.hse_handbook.already_added": "Redan tillagd",
            "project.hse_handbook.no_crew": "Inget manskap registrerat på projektet.",
            "project.hse_handbook.crew_name": "Namn",
            "project.hse_handbook.crew_role": "Roll",
            "project.hse_handbook.crew_email": "E-post",
            "project.hse_handbook.crew_status": "Status",
            "project.hse_handbook.crew_on_site": "På plats",
            "project.hse_handbook.crew_planned": "Planerad",
            "project.hse_handbook.crew_scheduled": "Planerad",
            "project.hse_handbook.crew_assigned": "Tilldelad",

            "project.activities.tab_title": "Aktiviteter",
            "project.activities.tab_hint":
              "Lämna titelfältet (Tab eller klick utanför) för att spara en ny rad. Nästa nummer sätts automatiskt; Tripletex-rader hanteras i bakgrunden.",
            "project.activities.search_label": "Sök",
            "project.activities.search_placeholder":
              "Sök titel, nummer, beskrivning…",
            "project.activities.filter_label": "Filter",
            "project.activities.filter_all": "Alla",
            "project.activities.filter_standard": "Endast standard",
            "project.activities.filter_additional": "Endast tilläggsarbete",
            "project.activities.add_quick": "Ny rad",
            "project.activities.draft_title_placeholder":
              "Titel — Tab för att spara och lägga till nästa",
            "project.activities.deleted": "Aktivitet borttagen",
            "project.activities.title": "Aktiviteter",
            "project.activities.description":
              "Rader som används för timmar och prisuppskattningar. Hantera dem under fliken Aktiviteter på projektet.",
            "project.activities.description_field": "Beskrivning",
            "project.activities.activity_line": "Tripletex-aktivitetsrad",
            "project.activities.activity_line_hint":
              "Valfritt. Kopplar raden till en projektaktivitetsrad i Tripletex.",
            "project.activities.is_additional": "Tillägg",
            "project.activities.title_required": "Titel krävs",
            "project.activities.delete_error": "Kunde inte ta bort aktivitet",
            "project.activities.add": "Lägg till aktivitet",
            "project.activities.add_first": "Lägg till första aktivitet",
            "project.activities.edit": "Redigera aktivitet",
            "project.activities.delete": "Ta bort aktivitet",
            "project.activities.delete_confirm":
              "Är du säker på att du vill ta bort denna aktivitet?",
            "project.activities.none": "Inga aktiviteter tillagda ännu.",
            "project.activities.activity": "Aktivitet",
            "project.activities.number": "Nummer",
            "project.activities.budget_hours": "Budgettimmar",
            "project.activities.budget_fee": "Budgetarvode",
            "project.activities.invoiceable": "Fakturerbar",
            "project.activities.error_loading": "Fel vid inläsning av aktiviteter",
            "project.activities.updated": "Aktivitet uppdaterad",
            "project.activities.created": "Aktivitet tillagd",
            "project.activities.save_error": "Kunde inte spara aktivitet",
            "project.activities.activity_required": "Aktivitet krävs",
            "project.activities.title_field": "Titel",
            "project.activities.start_date": "Startdatum",
            "project.activities.end_date": "Slutdatum",
            "project.activities.budget_fee_rate": "Budgetarvodesgrad",
            "project.activities.inactive": "Inaktiv",
            "project.activities.updating": "Uppdaterar…",
            "project.activities.adding": "Lägger till…",
            "project.activities.summary_title": "Översikt",
            "project.activities.summary_hours": "Timmar (rapporterat / budget)",
            "project.activities.summary_activities_done": "Slutförda aktiviteter",
            "project.activities.summary_budget_fee": "Summa budgetarvode",
            "project.activities.summary_budget_fee_hint": "Summa av budgetarvode på alla aktiviteter (referens).",
            "project.activities.hours_unit": "h",
            "project.activities.hours_unit_short": "h",
            "project.activities.of_total_budget_hours": "av budgeterade timmar (projekt)",
            "project.activities.completed_label": "slutförda",
            "project.activities.currency_nok": "NOK",
            "project.activities.mode_view": "Visningsläge",
            "project.activities.mode_edit": "Redigeringsläge",
            "project.activities.status_label": "Status",
            "project.activities.status.open": "Öppen",
            "project.activities.status.in_progress": "Pågår",
            "project.activities.status.completed": "Slutförd",
            "project.activities.status.on_hold": "Pausad",
            "project.activities.edit_dialog_title": "Aktivitet",
            "project.activities.progress_section": "Framsteg",
            "project.activities.logged_vs_budget": "{{logged}} h rapporterat · {{budget}} h budget",
            "project.activities.of_budget_hours": "av aktivitetens budgettimmar",
            "project.activities.linked_work_orders": "{{count}} kopplad(e) arbetsorder(r)",
            "project.activities.linked_work_orders_label": "Arbetsordrar på aktiviteten",
            "project.activities.no_description": "Ingen beskrivning.",
            "project.activities.period": "Period",
            "project.activities.new_work_order": "Ny arbetsorder",
            "project.activities.open_work_orders_tab": "Öppna fliken Arbetsordrar",
            "project.activities.open_time_tab": "Öppna tidsregistrering",
            "project.activities.logged_short": "Rapporterat",
            "project.activities.status_progress_title": "Status och framsteg",
            "project.activities.save": "Spara",
            "project.activities.saving": "Sparar…",
            "project.activities.actions": "Åtgärder",
            "project.activities.deleted_toast": "Borttagen",
            "project.plan.title": "Projektplan",
            "project.plan.preview.title": "Projektplan",
            "project.plan.preview.subtitle": "Kommande händelser",
            "project.plan.preview.go_to_full_plan": "Full plan →",
            "project.plan.preview.time_prefix": "Kl.",
            "project.plan.preview.loading": "Laddar händelser...",
            "project.plan.preview.error": "Fel vid laddning av händelser",
            "project.plan.preview.no_events": "Inga kommande händelser",
            "project.plan.preview.untitled_event": "Händelse utan titel",
            "project.plan.preview.resource": "resurs",
            "project.plan.preview.resources": "resurser",
            "project.plan.preview.view_all": "Visa alla {{count}} händelser",
            "project.plan.subtitle": "Planera och hantera projekthändelser",
            "project.plan.select_project": "Välj projekt",
            "project.plan.select_project_first": "Välj ett projekt först",
        "project.plan.pick_project_title": "Välj projekt",
        "project.plan.pick_project_hint": "Välj ett projekt för att fortsätta",
            "project.plan.project": "Projekt",
            "project.plan.no_events": "Inga händelser i denna period",
        "project.plan.drop_lane_hint": "Släpp plan här",
            "project.plan.total": "Totalt",
            "project.plan.loading": "Laddar händelser...",
            "project.plan.week": "Vecka",
            "project.plan.resource_capacity": "Resurskapacitet",
            "project.plan.resource_capacity_subtitle":
              "Jämför resursplanen från Timmar med planerade projekthändelser och arbetsordrar i vald period.",
            "project.plan.loading_resource_plan": "Laddar resursplan...",
            "project.plan.capacity.events": "Händelser",
            "project.plan.capacity.available": "Tillgängliga",
            "project.plan.capacity.assigned": "Allokerade",
            "project.plan.capacity.scheduled_hours": "Arbetsplantimmar",
            "project.plan.capacity.free_hours": "Lediga timmar",
            "project.plan.capacity.assigned_of_available": "{{assigned}} av {{available}} resurser använda",
            "project.plan.capacity.free_hours_value": "{{hours}} t ledigt",
            "project.plan.capacity.events_value": "{{count}} händelse(r)",
            "project.time_overview.tab": "Tidsöversikt",
            "project.time_overview.list_title": "Tidsöversikt — {{title}}",
            "project.time_overview.loading": "Laddar tidsöversikt…",
            "project.time_overview.load_error": "Kunde inte läsa in timmarna för perioden.",
            "project.time_overview.ui.search_filter": "Sök {{label}}",
            "project.time_overview.ui.no_matches": "Inga träffar",
            "project.time_overview.ui.reset": "Återställ",
            "project.time_overview.ui.search_chip": "Sök: {{query}}",
            "project.time_overview.ui.status_pending": "Väntar på godkännande",
            "project.time_overview.ui.status_approved": "Godkänd",
            "project.time_overview.ui.status_rejected": "Avvisad",
            "project.time_overview.ui.status_processed": "Behandlad",
            "project.time_overview.ui.supplier": "Underleverantör",
            "project.time_overview.ui.employees": "Egna anställda",
            "project.time_overview.ui.project": "Projekt",
            "project.time_overview.ui.department": "Avdelning",
            "project.time_overview.ui.without_project": "Utan projekt",
            "project.time_overview.ui.without_department": "Utan avdelning",
            "project.time_overview.ui.estimated_sales": "Uppskattad försäljning",
            "project.time_overview.ui.estimated_cost": "Uppskattad kostnad",
            "project.time_overview.ui.unknown_user": "Okänd användare",
            "project.time_overview.ui.show_calculation": "Visa beräkning",
            "project.time_overview.ui.hide_calculation": "Dölj beräkning",
            "project.time_overview.ui.total_hours": "Totalt timmar",
            "project.time_overview.ui.missing_hour_cost_count": "Saknar timkostnad",
            "project.time_overview.ui.detailed_per_employee": "Detaljerad beräkning per anställd",
            "project.time_overview.ui.estimated_cost_upper": "UPPSKATTAD KOSTNAD",
            "project.time_overview.ui.estimated_sales_upper": "UPPSKATTAD FÖRSÄLJNING",
            "project.time_overview.ui.estimated_from_rates": "Timkostnad × timer i urvalet",
            "project.time_overview.ui.estimated_from_sales_rates": "Timpris × timer i urvalet",
            "hours.company_overview": "Tidsöversikt",
            "hours.company_overview.subtitle":
              "Alla timmar i vald månad. Filtrera på projekt, aktivitet, anställda och avdelning. Uppskattad kostnad och försäljning.",
            "project.time_overview.ui.with_order": "Med order",
            "project.time_overview.ui.without_order": "Utan order",
            "project.time_overview.ui.with_invoice": "Med leverantörsfaktura",
            "project.time_overview.ui.without_full_invoice": "Utan full fakturatäckning",
            "project.time_overview.ui.eyebrow": "// PROJEKT · TIDSKONTROLL",
            "project.time_overview.ui.description": "Godkänn timmar, koppla dem till order och leverantörsfakturor och se projektets förbrukning.",
            "project.time_overview.ui.switch_project": "Byt projekt",
            "project.time_overview.ui.export_csv": "Exportera CSV",
            "project.time_overview.ui.export_pdf": "Exportera PDF",
            "project.time_overview.ui.export_pdf_busy": "Skapar PDF…",
            "project.time_overview.ui.pdf_selection_changed": "Tidslistan har ändrats sedan den laddades. Uppdatera listan och försök igen.",
            "project.time_overview.ui.pdf_refresh_list": "Uppdatera listan",
            "project.time_overview.ui.pdf_too_many": "Urvalet är för stort för PDF (max {{max}} poster). Välj ett mindre urval.",
            "project.time_overview.ui.pdf_invalid": "Servern returnerade inte en giltig PDF. Försök igen.",
            "project.time_overview.ui.pdf_forbidden": "Du har inte behörighet att exportera timmarna i detta projekt.",
            "project.time_overview.ui.pdf_failed": "Kunde inte skapa PDF. Försök igen.",
            "project.time_overview.ui.pdf_empty": "Inga timmar att exportera i urvalet.",
            "project.time_overview.ui.pdf_filename_prefix": "timmar",
            "project.time_overview.ui.new_entry": "Ny registrering",
            "project.time_overview.ui.time_budget": "TIMBUDGET",
            "project.time_overview.ui.budget_used": "Använd timbudget",
            "project.time_overview.ui.percent_used": "{{percent}} % använt",
            "project.time_overview.ui.budget_remaining": "KVAR AV BUDGETEN",
            "project.time_overview.ui.over_budget": "{{hours}} t över budget",
            "project.time_overview.ui.available_budget": "Tillgängliga budgettimmar",
            "project.time_overview.ui.registered_selected": "REGISTRERAT I URVALET",
            "project.time_overview.ui.entry_people_count": "{{entries}} registreringar · {{people}} personer",
            "project.time_overview.ui.team": "TEAM",
            "project.time_overview.ui.active_members": "aktiva projektdeltagare",
            "project.time_overview.ui.awaiting_approval": "VÄNTAR PÅ GODKÄNNANDE",
            "project.time_overview.ui.entries_waiting": "{{count}} registreringar väntar",
            "project.time_overview.ui.without_order_upper": "UTAN ORDER",
            "project.time_overview.ui.entries_count": "{{count}} registreringar",
            "project.time_overview.ui.supplier_upper": "UNDERLEVERANTÖR",
            "project.time_overview.ui.hours_without_full_invoice": "{{hours}} t utan full fakturatäckning",
            "project.time_overview.ui.hours_per_order": "TIMMAR PER ORDER · VALD PERIOD",
            "project.time_overview.ui.select_order_hint": "Välj en order för att filtrera registreringarna",
            "project.time_overview.ui.in_period": "under perioden",
            "project.time_overview.ui.hours_waiting": "{{hours}} t väntar",
            "project.time_overview.ui.order_budget_used": "Använd budget för {{order}}",
            "project.time_overview.ui.order_budget_total": "{{used}} av {{budget}} t totalt · {{percent}} %",
            "project.time_overview.ui.search_hours": "Sök bland timmar",
            "project.time_overview.ui.search_placeholder": "Sök kommentarer, order, anställda",
            "project.time_overview.ui.filters": "Filter",
            "project.time_overview.ui.activity": "Aktivitet",
            "project.time_overview.ui.order": "Order",
            "project.time_overview.ui.employee": "Anställd",
            "project.time_overview.ui.status": "Status",
            "project.time_overview.ui.type": "Typ",
            "project.time_overview.ui.link": "Koppling",
            "project.time_overview.ui.remove_filter": "Ta bort filter: {{label}}",
            "project.time_overview.ui.reset_all": "Återställ alla · {{filtered}} av {{total}} registreringar",
            "project.time_overview.ui.unknown_employee": "Okänd anställd",
            "project.time_overview.ui.without_activity": "Utan aktivitet",
            "project.time_overview.ui.without_date": "Utan datum",
            "project.time_overview.ui.not_linked": "Inte kopplad",
            "project.time_overview.ui.select_group": "Välj grupp {{title}}",
            "project.time_overview.ui.show_more": "Visa {{count}} fler registreringar",
            "project.time_overview.ui.time_view": "Tidsvy",
            "project.time_overview.ui.entries": "Registreringar",
            "project.time_overview.ui.matrix": "Matris",
            "project.time_overview.ui.supplier_invoice": "Leverantörsfaktura",
            "project.time_overview.ui.groups": "GRUPPER",
            "project.time_overview.ui.date": "Datum",
            "project.time_overview.ui.none": "Ingen",
            "project.time_overview.ui.expand_all": "Expandera alla",
            "project.time_overview.ui.collapse_all": "Fäll ihop alla",
            "project.time_overview.ui.normal_rows": "Normala rader",
            "project.time_overview.ui.compact_rows": "Kompakta rader",
            "project.time_overview.ui.selected_hours": "{{count}} valda · {{hours}} t",
            "project.time_overview.ui.select_for_bulk": "Välj registreringar för massåtgärder",
            "project.time_overview.ui.approve_selected": "Godkänn valda ({{count}})",
            "project.time_overview.ui.reject_selected": "Avvisa valda ({{count}})",
            "project.time_overview.ui.select_all": "Välj alla registreringar i urvalet",
            "project.time_overview.ui.date_upper": "DATUM",
            "project.time_overview.ui.employee_upper": "ANSTÄLLD",
            "project.time_overview.ui.project_upper": "PROJEKT",
            "project.time_overview.ui.activity_upper": "AKTIVITET",
            "project.time_overview.ui.order_upper": "ORDER",
            "project.time_overview.ui.invoice_upper": "LEV.FAKTURA",
            "project.time_overview.ui.hours_upper": "TIMMAR",
            "project.time_overview.ui.status_upper": "STATUS",
            "project.time_overview.ui.actions_upper": "ÅTGÄRDER",
            "project.time_overview.ui.sum_entries": "SUMMA · {{count}} REGISTRERINGAR",
            "project.time_overview.ui.rows": "RADER",
            "project.time_overview.ui.hide_weekends": "Dölj helger",
            "project.time_overview.ui.show_weekends": "Visa helger",
            "project.time_overview.ui.weeks": "Veckor",
            "project.time_overview.ui.days": "Dagar",
            "project.time_overview.ui.matrix_hint": "{{period}} · klicka på en cell för att se registreringarna",
            "project.time_overview.ui.sum": "SUMMA",
            "project.time_overview.ui.no_hours_period": "Inga timmar under perioden.",
            "project.time_overview.ui.invoice_intro": "Projektets registrerade leverantörsfakturor och fakturatäckning för timmar under vald period. Välj timmar i Registreringar för att koppla eller stämma av.",
            "project.time_overview.ui.invoice_intro_readonly": "Projektets registrerade leverantörsfakturor. Timkopplingar kräver åtkomst till timavstämning.",
            "project.time_overview.ui.project_invoice_amount": "Projektbelopp exkl. moms: {{amount}}",
            "project.time_overview.ui.no_linked_hours_period": "Inga kopplade timmar under vald period",
            "project.time_overview.ui.hour_links_restricted": "Timkopplingar kräver åtkomst till timavstämning",
            "project.time_overview.ui.no_supplier_invoices": "Inga leverantörsfakturor eller underleverantörstimmar i urvalet.",
            "project.time_overview.ui.no_supplier_invoices_readonly": "Inga leverantörsfakturor registrerade för projektet.",
            "project.time_overview.ui.invoice_readonly_error": "Det gick inte att hämta leverantörsfakturorna. Försök igen.",
            "project.time_overview.ui.costs_load_error": "Timkostnaderna kunde inte beräknas. Försök igen i tidsöversikten.",
            "project.time_overview.ui.loading_invoices": "Hämtar projektets leverantörsfakturor…",
            "project.time_overview.ui.invoice_approved_local": "Godkänd i Promang",
            "project.time_overview.ui.invoice_rejected_local": "Avvisad i Promang",
            "project.time_overview.ui.invoice_no_local_approval": "Inget internt godkännande registrerat",
            "project.time_overview.ui.invoice_details_error": "Fakturadetaljerna kunde inte hämtas. Timkopplingar och täckning visas fortfarande.",
            "project.time_overview.ui.not_linked_invoice": "Inte kopplad till leverantörsfaktura",
            "project.time_overview.ui.invoice_number": "Faktura {{number}}",
            "project.time_overview.ui.supplier_invoice_number": "Leverantörsfaktura #{{number}}",
            "project.time_overview.ui.invoice_date": "Datum {{date}}",
            "project.time_overview.ui.hours_logged": "{{hours}} t registrerade",
            "project.time_overview.ui.hours_covered": "{{hours}} t täckta av faktura",
            "project.time_overview.ui.hours_uncovered": "{{hours}} t utan fakturatäckning",
            "project.time_overview.ui.show_hours_by_employee_order": "Visa timmar per anställd och order",
            "project.time_overview.ui.logged_upper": "REGISTRERAT",
            "project.time_overview.ui.covered_upper": "TÄCKT",
            "project.time_overview.ui.view_invoice": "Visa faktura",
            "project.time_overview.ui.no_supplier_hours": "Inga underleverantörstimmar under perioden.",
            "project.time_overview.ui.bulk_unknown_outcome": "Utfallet för den senaste registreringen är okänt. Kontrollera status innan du försöker igen.",
            "project.time_overview.ui.bulk_remaining": "{{done}} bekräftat behandlade. {{remaining}} återstår. {{error}}",
            "project.time_overview.ui.bulk_approved": "{{count}} registreringar godkända.",
            "project.time_overview.ui.bulk_rejected": "{{count}} registreringar avvisade.",
            "project.time_overview.ui.approve_selected_hours": "Godkänn valda timmar",
            "project.time_overview.ui.reject_selected_hours": "Avvisa valda timmar",
            "project.time_overview.ui.bulk_processing": "{{count}} registreringar behandlas. Godkända eller avvisade registreringar ingår inte.",
            "project.time_overview.ui.rejection_reason": "Orsak till avslag",
            "project.time_overview.ui.close": "Stäng",
            "project.time_overview.ui.cancel": "Avbryt",
            "project.time_overview.ui.processing": "Behandlar…",
            "project.time_overview.ui.reject_hours": "Avvisa timmar",
            "project.time_overview.ui.approve_hours": "Godkänn timmar",
            "project.time_overview.ui.week_number": "Vecka {{number}}",
            "project.time_overview.ui.filter_dialog": "{{label}}-filter",
            "project.time_overview.ui.hour_unit": "t",
            "project.time_overview.ui.hours": "Timmar",
            "project.time_overview.ui.description_column": "Beskrivning",
            "project.time_overview.empty": "Inga timmar hittades för detta projekt",
            "project.time_overview.total_hours": "Totalt",
            "project.time_overview.summary_total": "Totalt",
            "project.time_overview.ungrouped": "Utan grupp",
            "project.time_overview.unapproved_secondary":
              "{{count}} inte godkända ({{hours}} t)",
            "project.time_registration.loading": "Laddar tidsregistreringar…",
            "project.time_registration.list_title": "Tidsregistrering — {{title}}",
            "project.time_registration.filter": "Filter",
            "project.time_registration.all_hours": "Alla timmar",
            "project.time_registration.date_from": "Från datum",
            "project.time_registration.date_to": "Till datum",
            "project.time_registration.empty":
              "Inga tidsregistreringar hittades för detta projekt",
            "project.time_registration.registrations": "registreringar",
            "project.time_registration.no_activity": "Ingen aktivitet",
            "project.time_registration.approved_section": "Godkända timmar",
            "project.time_registration.approved_section_hint":
              "Dessa timmar är godkända och ingår i summor och timkostnader ovan.",
            "project.time_registration.excluded_section":
              "Ej godkända eller väntar på godkännande",
            "project.time_registration.excluded_section_hint":
              "Timmar som inte är godkända räknas inte med i summor eller timkostnader.",
            "project.time_registration.no_approved_in_range":
              "Inga godkända timmar i vald period.",
            "project.time_registration.total_approved_hours": "Godkända (i summa)",
            "project.time_registration.total_excluded_hours": "Utanför summa",
            "project.time_registration.summary_approved_label":
              "Totalt godkända timmar (summering)",
            "project.time_registration.summary_excluded_note":
              "{{hours}} timmar är inte godkända och räknas inte med.",
            "project.time_registration.badge_approved": "Godkänd",
            "project.time_registration.badge_rejected": "Ej godkänd",
            "project.time_registration.badge_pending": "Väntar på godkännande",
            "project.time_registration.approve": "Godkänn",
            "project.time_registration.reject": "Avvisa",
            "project.time_registration.open_hour": "Redigera timme",
            "project.time_registration.process_dialog": "Hantera timme",
            "absence": "Fravær",
            "Week": "Uke",
            "Day": "Dag",
            "Filters": "Filter",
            "Project Filter": "Projektfilter",
            "Activity Filter": "Aktivitetsfilter",
            "All Projects": "Alla projekt",
            "All Activities": "Alla aktiviteter",
            "Clear Filters": "Rensa filter",
            "No hours recorded for this day":
              "Inga timmar registrerade för denna dag",
            "entries": "poster",
            "Loading hours...": "Laddar timmar...",
            "already_registered_hours_for_event": "Redan registrerade timmar på denna händelse",
            "dashboard_report.status.planned": "Planerad",
            "dashboard.stats.eyebrow": "Dashboard",
            "dashboard.stats.title": "Statusöversikt",
            "dashboard.stats.tap_hint": "Tryck för att se alla siffror och detaljer",
            "dashboard.stats.detail_title": "Statusöversikt",
            "dashboard.stats.detail_intro": "Översikt över öppna uppgifter och nyckeltal. Tryck på ett kort för att gå till modulen.",
            "dashboard.stats.reports": "Rapporter",
            "dashboard.stats.report_agreements": "Rapportavtal",
            "dashboard.stats.cases": "Ärenden",
            "dashboard.stats.deviations": "Avvikelser",
            "dashboard.stats.projects": "Projekt",
            "dashboard.stats.kilometers": "Kilometer",
            "dashboard.stats.reports_not_finished": "Inte färdigställd",
            "dashboard.stats.reports_finished": "Färdigställd",
            "dashboard.stats.reports_agreement_not_confirmed": "Inte bekräftad",
            "dashboard.stats.reports_not_approved": "Inte godkänd",
            "dashboard.stats.cases_open": "Under behandling",
            "dashboard.stats.deviations_open": "Väntar på hantering",
            "dashboard.stats.deviations_assigned": "Tilldelad dig",
            "dashboard.stats.projects_open": "Pågående",
            "dashboard.stats.this_month": "Denna månad",

            "company_guide.badge": "Företagsguide",
            "company_guide.hours.title": "Tidsregistrering, frånvaro och arbetsschema",
            "company_guide.hours.subtitle":
              "Checklista för administratörer med Timmar-modulen (visas i användarguiden för timmar).",
            "company_guide.hours.progress_label": "Status",
            "company_guide.hours.progress_loading": "Laddar…",
            "company_guide.hours.progress_error": "Kunde inte hämta status. Uppdatera sidan.",
            "company_guide.hours.progress_summary_ok": "{{done}} av {{total}} rekommenderade steg är på plats.",
            "company_guide.hours.progress_summary_warnings":
              "{{done}} av {{total}} rekommenderade steg är på plats. {{warnings}} punkt(er) behöver fortfarande uppmärksamhet.",
            "company_guide.hours.footer_hint":
              "Legacy Activity/ActivityItem används främst mot Tripletex-synk, inte som primär tidsregistrering i Promang.",
            "company_guide.hours.footer_link_settings": "Öppna Timmar → Inställningar",
            "company_guide.hours.link.scroll_to_explanation": "Läs förklaringen nedan",
            "company_guide.hours.link.settings_section": "Öppna i inställningar",
            "company_guide.hours.link.work_schedule": "Öppna schema",
            "company_guide.hours.task.registration_model.title": "Tidsregistrering och projektrader",
            "company_guide.hours.task.registration_model.info":
              "Projekttimmar kräver project_activity på projektet. Activity/ActivityItem är legacy i gränssnittet och används för Tripletex-synk.",
            "company_guide.hours.task.absence_types.title": "Frånvarotyper",
            "company_guide.hours.task.absence_types.ok": "{{count}} frånvarotyp(er) definierade.",
            "company_guide.hours.task.absence_types.warn":
              "Skapa frånvarotyper som matchar ert arbetssätt (semester, sjuk, kompledighet …).",
            "company_guide.hours.task.absence_types.unknown": "Kunde inte verifiera frånvarotyper automatiskt.",
            "company_guide.hours.task.handlers.title": "Ansvar för timmar och frånvaro",
            "company_guide.hours.task.handlers.ok": "Handläggare för timmar och frånvaro är satta.",
            "company_guide.hours.task.handlers.warn":
              "Ange vem som hanterar tidrapporter och egna frånvaromeldingar.",
            "company_guide.hours.task.work_schedule.title": "Arbetsschema och sysselsättningsgrad",
            "company_guide.hours.task.work_schedule.info":
              "Se till att varje anställd har arbetsschema som stämmer med tjänsten; det påverkar planerade timmar och frånvaro.",
            "company_guide.hours.task.work_schedule.ok": "Arbetsscheman finns och anställda är kopplade.",
            "company_guide.hours.task.work_schedule.warn_none": "Skapa minst ett företagsarbetsschema.",
            "company_guide.hours.task.work_schedule.warn_unassigned":
              "{{count}} aktiv(a) anställd(a) saknar arbetsschema.",
            "company_guide.hours.link.work_schedule_admin": "Hantera arbetsscheman",

            "company_guide.company.badge": "Företagsguide",
            "company_guide.company.heading": "Grundläggande företagsinställningar",
            "company_guide.company.subtitle":
              "Logotyp, kontakt, adresser och villkorslänkar ger trygghet i kunddialog, offerter och webbhandel.",
            "company_guide.company.progress_label": "Status",
            "company_guide.company.progress_loading": "Laddar…",
            "company_guide.company.progress_error": "Kunde inte hämta företagsdata. Uppdatera sidan.",
            "company_guide.company.progress_ok": "{{done}} av {{total}} rekommenderade punkter är på plats.",
            "company_guide.company.progress_warnings":
              "{{done}} av {{total}} rekommenderade punkter är på plats. {{warnings}} behöver åtgärd.",
            "company_guide.company.footer_hint":
              "Ändringar görs under Företag → Inställningar. Checklistan uppdateras när du sparar.",
            "company_guide.company.link.settings": "Öppna företagsinställningar",
            "company_guide.company.task.name.title": "Företagsnamn",
            "company_guide.company.task.name.warn": "Företagsnamn bör fyllas i.",
            "company_guide.company.task.name.ok": "Företagsnamn verkar vara ifyllt.",
            "company_guide.company.task.logo.title": "Logotyp",
            "company_guide.company.task.logo.warn": "Lägg till logotyp för dokument, offerter och kundvy.",
            "company_guide.company.task.logo.ok": "Logotyp är registrerad.",
            "company_guide.company.task.contact.title": "Kontaktinformation",
            "company_guide.company.task.contact.warn": "Ange minst en av e-post, telefon eller mobil.",
            "company_guide.company.task.contact.ok": "Minst en kontaktkanal är satt.",
            "company_guide.company.task.address.title": "Adress",
            "company_guide.company.task.address.warn": "Lägg in företags- eller postadress.",
            "company_guide.company.task.address.ok": "Adress är registrerad.",
            "company_guide.company.task.sales_conditions_url.title": "Försäljningsvillkor (URL)",
            "company_guide.company.task.sales_conditions_url.warn":
              "Länk till försäljningsvillkor saknas — viktigt för offerter och webbhandel.",
            "company_guide.company.task.sales_conditions_url.ok": "Länk till försäljningsvillkor är satt.",
            "company_guide.company.task.vat.title": "Moms / org.nr",
            "company_guide.company.task.vat.warn": "Organisationsnummer / moms bör fyllas i.",
            "company_guide.company.task.vat.ok": "Org.nr / moms är registrerat.",

            "dashboard.company_guide.alert_company_title": "Företagsprofil behöver uppmärksamhet",
            "dashboard.company_guide.alert_company_subtitle":
              "{{count}} punkt(er) i företagsguiden bör åtgärdas.",
            "dashboard.company_guide.alert_hours_title": "Timinställningar behöver uppmärksamhet",
            "dashboard.company_guide.alert_hours_subtitle":
              "{{count}} punkt(er) i timguiden bör åtgärdas.",
            "dashboard.company_guide.alert_hse_title": "HMS-upplägg behöver uppmärksamhet",
            "dashboard.company_guide.alert_hse_subtitle":
              "{{count}} punkt(er) i HMS-guiden bör åtgärdas.",
            "dashboard.company_guide.alert_offers_title": "Offertinställningar behöver uppmärksamhet",
            "dashboard.company_guide.alert_offers_subtitle":
              "{{count}} rekommenderad funktion i offertmodulen är avstängd.",
            "dashboard.company_guide.alert_cta": "Öppna guide och checklista",

            "user_guide.hub.card.company.title": "Företag och inställningar",
            "user_guide.hub.card.company.description":
              "Logotyp, kontakt, adresser, försäljningsvillkor och annat som bör finnas på plats.",

            "user_guide.company.back_to_hub": "Tillbaka till användarguiden",
            "user_guide.company.badge": "Företag",
            "user_guide.company.title": "Företagsinställningar och profil",
            "user_guide.company.intro":
              "Rätt företagsinformation spelar roll för kunder, offerter och integrationer. Som administratör bör du gå igenom checklistan nedan och fylla luckor.",
            "user_guide.company.section.why.title": "Varför detta är viktigt",
            "user_guide.company.section.why.p1":
              "Logotyp och kontaktuppgifter förväntas där ni möter kunder och leverantörer.",
            "user_guide.company.section.why.p2":
              "Adress och försäljningsvillkor krävs ofta i avtal, webbhandel och dokumentexport.",
            "user_guide.company.section.where.title": "Var du gör ändringar",
            "user_guide.company.section.where.p1":
              "Gå till Företag → Inställningar. Använd länkarna i checklistan för att hoppa till rätt avsnitt.",

            "user_guide.hub.card.profile.title": "Min profil och personuppgifter",
            "user_guide.hub.card.profile.description":
              "Mobilnummer, anhörig, personnummer, kontonummer och barn — det som bör finnas på plats.",

            "user_guide.profile.back_to_hub": "Tillbaka till användarguiden",
            "user_guide.profile.badge": "Min profil",
            "user_guide.profile.title": "Personuppgifter och profil",
            "user_guide.profile.intro":
              "Vissa funktioner kräver att du fyller i personuppgifter. Rätt mobilnummer, anhörig, personnummer och kontonummer gör att lön, frånvaro, HMS och kontakt fungerar som de ska. Gå igenom checklistan nedan och fyll luckor.",
            "user_guide.profile.heading": "Dina personuppgifter",
            "user_guide.profile.subtitle":
              "Gäller både anställda och inhyrda. Fyll i fälten nedan så fungerar Promang optimalt för dig.",
            "user_guide.profile.progress_label": "Status",
            "user_guide.profile.progress_loading": "Laddar…",
            "user_guide.profile.progress_error": "Kunde inte hämta profildata. Uppdatera sidan.",
            "user_guide.profile.progress_ok": "{{done}} av {{total}} obligatoriska punkter är på plats.",
            "user_guide.profile.progress_warnings":
              "{{done}} av {{total}} obligatoriska punkter är på plats. {{warnings}} behöver åtgärd.",
            "user_guide.profile.footer_hint":
              "Ändringar görs under Min profil. Checklistan uppdateras när du sparar.",
            "user_guide.profile.link.profile": "Öppna min profil",
            "user_guide.profile.task.mobile.title": "Mobilnummer",
            "user_guide.profile.task.mobile.warn": "Lägg in mobilnummer så kollegor och system når dig.",
            "user_guide.profile.task.mobile.ok": "Mobilnummer är registrerat.",
            "user_guide.profile.task.next_of_kin.title": "Anhörig",
            "user_guide.profile.task.next_of_kin.warn":
              "Lägg in minst en anhörig — viktigt vid händelser och nödsituationer.",
            "user_guide.profile.task.next_of_kin.ok": "Anhörig är registrerad.",
            "user_guide.profile.task.social_security.title": "Personnummer",
            "user_guide.profile.task.social_security.warn":
              "Personnummer krävs för anställningsavtal, lön och rapportering.",
            "user_guide.profile.task.social_security.ok": "Personnummer är registrerat.",
            "user_guide.profile.task.account_number.title": "Kontonummer",
            "user_guide.profile.task.account_number.warn":
              "Lägg in kontonummer för utbetalning av lön och utlägg.",
            "user_guide.profile.task.account_number.ok": "Kontonummer är registrerat.",
            "user_guide.profile.task.email_signature.title": "E-postsignatur",
            "user_guide.profile.task.email_signature.warn":
              "Lägg in signatur under Profil → E-post. Den infogas när du skickar e-post till kunden.",
            "user_guide.profile.task.email_signature.ok": "E-postsignatur är registrerad.",
            "user_guide.profile.task.children.title": "Barn (valfritt)",
            "user_guide.profile.task.children.info":
              "Valfritt. Lägg in barn om du vill att de ska vara registrerade (t.ex. för vårddagar).",
            "user_guide.profile.task.children.ok": "Barn är registrerade.",
            "user_guide.profile.section.why.title": "Varför detta är viktigt",
            "user_guide.profile.section.why.p1":
              "Mobilnummer och anhörig gör att vi snabbt når dig eller dina närmaste om något händer på jobbet.",
            "user_guide.profile.section.why.p2":
              "Personnummer och kontonummer krävs för anställningsavtal, lön och utbetalningar.",
            "user_guide.profile.section.where.title": "Var du gör ändringar",
            "user_guide.profile.section.where.p1":
              "Gå till Min profil. Använd länkarna i checklistan för att hoppa till rätt ställe.",

            "dashboard.user_guide.alert_profile_title": "Din profil saknar uppgifter",
            "dashboard.user_guide.alert_profile_subtitle":
              "{{count}} punkt(er) i din profil bör fyllas i.",
            "dashboard.user_guide.alert_cta": "Öppna guide och checklista",

            "user_employment.work_schedule_label": "Arbetsschema (timmar)",
            "user_employment.work_schedule_hint":
              "Används för tidregistrering, planerad tid och frånvaro. Skapa scheman under Timmar → Arbetsscheman.",
            "user_employment.work_schedule_none": "Inget valt",

            "work_schedules_admin.title": "Arbetsscheman",
            "work_schedules_admin.intro":
              "Skapa och underhåll scheman (timmar per veckodag). Nya anställda får senast skapade schema som standard om inget annat tilldelas.",
            "work_schedules_admin.summary_title": "Översikt",
            "work_schedules_admin.summary_plans": "{{count}} arbetsschema i företaget.",
            "work_schedules_admin.summary_unassigned_ok": "Alla aktiva anställda har arbetsschema.",
            "work_schedules_admin.summary_unassigned_warn":
              "{{count}} aktiv(a) anställd(a) saknar arbetsschema — tilldela under användarprofilen.",
            "work_schedules_admin.assign_hint": "Tilldela på anställd:",
            "work_schedules_admin.assign_link": "Användare / anställda",
            "work_schedules_admin.new": "Nytt arbetsschema",
            "work_schedules_admin.edit": "Redigera",
            "work_schedules_admin.delete": "Ta bort",
            "work_schedules_admin.save": "Spara",
            "work_schedules_admin.saving": "Sparar…",
            "work_schedules_admin.cancel": "Avbryt",
            "work_schedules_admin.field_name": "Namn (valfritt)",
            "work_schedules_admin.field_name_placeholder": "T.ex. Kontor 7,5h",
            "work_schedules_admin.empty": "Inga arbetsscheman ännu — skapa ett för att komma igång.",
            "work_schedules_admin.unnamed": "Utan namn",
            "work_schedules_admin.confirm_delete": "Ta bort «{{name}}»? Kan inte tas bort om det används.",
            "work_schedules_admin.created": "Arbetsschema skapat",
            "work_schedules_admin.saved": "Arbetsschema sparat",
            "work_schedules_admin.deleted": "Arbetsschema borttaget",
            "work_schedules_admin.load_error": "Kunde inte hämta arbetsscheman",
            "work_schedules_admin.save_error": "Kunde inte spara",
            "work_schedules_admin.delete_error": "Kunde inte ta bort",
            "work_schedules_admin.back_guide": "Tillbaka till användarguide (timmar)",
            "work_schedules_admin.day.monday": "Måndag",
            "work_schedules_admin.day.tuesday": "Tisdag",
            "work_schedules_admin.day.wednesday": "Onsdag",
            "work_schedules_admin.day.thursday": "Torsdag",
            "work_schedules_admin.day.friday": "Fredag",
            "work_schedules_admin.day.saturday": "Lördag",
            "work_schedules_admin.day.sunday": "Söndag",

            "work_schedule_view.page_title": "Schema",
            "work_schedule_view.fallback_title": "Arbetsschema",
            "work_schedule_view.subtitle": "Timmar per veckodag justerade för sysselsättningsgrad",
            "work_schedule_view.empty": "Inget arbetsschema är kopplat till din anställning ännu.",
            "work_schedule_view.empty_hint":
              "Be en administratör skapa ett schema och tilldela det på din användar-/anställningsprofil.",
            "work_schedule_view.link_users": "Gå till användare",
            "work_schedule_view.day_off": "Ledig",
            "work_schedule_view.hours_value": "{{hours}} timmar",
            "work_schedule_view.day.monday": "Måndag",
            "work_schedule_view.day.tuesday": "Tisdag",
            "work_schedule_view.day.wednesday": "Onsdag",
            "work_schedule_view.day.thursday": "Torsdag",
            "work_schedule_view.day.friday": "Fredag",
            "work_schedule_view.day.saturday": "Lördag",
            "work_schedule_view.day.sunday": "Söndag",
            "work_schedule_view.holidays_title": "Röda dagar",
            "work_schedule_view.holidays_subtitle": "Norska helgdagar som minskar förväntad arbetstid",
            "work_schedule_view.holidays_empty": "Inga helgdagar i vald period.",
            "hours.monthly_overview.gross_normal": "Brutto normaltid",
            "hours.monthly_overview.holiday_deduction": "Avdrag helgdagar",
            "hours.monthly_overview.absence_deduction": "Avdrag frånvaro",
            "Lønnsgrunnlag": "Löneunderlag",
            "hours.payroll_basis.title": "Löneunderlag",
            "hours.payroll_basis.subtitle":
              "Löneunderlag per anställd för vald månad. Endast godkända timmar ingår i summer och export.",
            "hours.payroll_basis.period": "Period",
            "hours.payroll_basis.export_pdf": "Exportera PDF",
            "hours.payroll_basis.export_zip": "Exportera ZIP",
            "hours.payroll_basis.export_redownload": "Ladda ner igen",
            "hours.payroll_basis.export_coming_soon": "Export kommer i nästa steg",
            "hours.payroll_basis.export_started": "Export startad — väntar på ZIP…",
            "hours.payroll_basis.export_running": "Exporterar…",
            "hours.payroll_basis.export_status": "Exportstatus: {{status}}",
            "hours.payroll_basis.export_ready": "ZIP är klar och laddas ner.",
            "hours.payroll_basis.export_done_no_url": "Export klar, men nedladdningslänk saknas.",
            "hours.payroll_basis.export_failed": "Kunde inte exportera löneunderlag.",
            "hours.payroll_basis.export_timeout": "Exporten tog för lång tid. Försök igen.",
            "hours.payroll_basis.export_dialog_title": "Exportera löneunderlag",
            "hours.payroll_basis.export_dialog_body":
              "Detta är ett utkast. Välj om du vill slutföra före export, eller ladda ner ZIP utan att låsa perioden.",
            "hours.payroll_basis.export_dialog_finalize": "Slutför och exportera",
            "hours.payroll_basis.export_dialog_finalize_hint":
              "Sätter status till slutförd, sedan exporterad när ZIP är klar. Anteckningar och summor låses.",
            "hours.payroll_basis.export_dialog_draft": "Exportera utkast",
            "hours.payroll_basis.export_dialog_draft_hint":
              "Laddar ner ZIP märkt UTKAST. Status förblir utkast — du kan fortsätta redigera.",
            "hours.payroll_basis.export_dialog_cancel": "Avbryt",
            "hours.payroll_basis.action_create": "Skapa utkast",
            "hours.payroll_basis.action_refresh": "Uppdatera utkast",
            "hours.payroll_basis.action_finalize": "Slutför",
            "hours.payroll_basis.action_reopen": "Återöppna för redigering",
            "hours.payroll_basis.reopen_dialog_title": "Ångra slutförande?",
            "hours.payroll_basis.reopen_dialog_body":
              "Perioden blir utkast igen och kan ändras. Du kan uppdatera anteckningar, hämta nya siffror och slutföra igen när du är klar.",
            "hours.payroll_basis.reopen_dialog_confirm": "Återöppna för redigering",
            "hours.payroll_basis.reopen_dialog_cancel": "Avbryt",
            "hours.payroll_basis.reopen_running": "Återöppnar…",
            "hours.payroll_basis.status.draft": "Utkast",
            "hours.payroll_basis.status.finalized": "Slutförd",
            "hours.payroll_basis.status.exported": "Exporterad",
            "hours.payroll_basis.read_only_title": "Skrivskyddad",
            "hours.payroll_basis.read_only_body":
              "Underlaget är slutfört eller exporterat. Du kan se summor, anställda och anteckningar, och ladda ner ZIP igen. För att lägga till mer info: återöppna för redigering.",
            "hours.payroll_basis.history_title": "Tidigare perioder",
            "hours.payroll_basis.toast_created": "Löneunderlag skapat.",
            "hours.payroll_basis.toast_refreshed": "Löneunderlag uppdaterat.",
            "hours.payroll_basis.toast_note_saved": "Anteckning sparad.",
            "hours.payroll_basis.toast_general_notes_saved": "Allmänna anteckningar sparade.",
            "hours.payroll_basis.toast_finalized": "Löneunderlag är slutfört.",
            "hours.payroll_basis.toast_reopened":
              "Löneunderlaget är återöppnat som utkast och kan redigeras.",
            "hours.payroll_basis.error_title": "Något gick fel",
            "hours.payroll_basis.error_generic":
              "Ett oväntat fel uppstod. Försök igen, eller kontakta support om problemet kvarstår.",
            "hours.payroll_basis.error_load": "Kunde inte ladda löneunderlag.",
            "hours.payroll_basis.error_load_title": "Kunde inte ladda löneunderlag",
            "hours.payroll_basis.error_refresh": "Kunde inte skapa/uppdatera utkast.",
            "hours.payroll_basis.error_refresh_locked":
              "Perioden är låst eller kan inte uppdateras.",
            "hours.payroll_basis.error_note": "Kunde inte spara anteckning.",
            "hours.payroll_basis.error_general_notes": "Kunde inte spara allmänna anteckningar.",
            "hours.payroll_basis.error_finalize": "Kunde inte slutföra.",
            "hours.payroll_basis.error_reopen": "Kunde inte återöppna löneunderlaget.",
            "hours.payroll_basis.error_forbidden": "Du har inte åtkomst till löneunderlag.",
            "hours.payroll_basis.error_dismiss": "Stäng felmeddelande",
            "hours.payroll_basis.error_retry": "Försök igen",
            "hours.payroll_basis.api_unavailable_title": "API är inte tillgängligt",
            "hours.payroll_basis.api_unavailable_body":
              "Löneunderlags-endpointen är inte tillgänglig (404/501). Sidan är redo — försök igen när API är ute.",
            "hours.payroll_basis.api_unavailable_toast":
              "Löneunderlags-API är inte tillgängligt.",
            "hours.payroll_basis.empty_draft_title": "Inget utkast för perioden",
            "hours.payroll_basis.empty_draft_body":
              "Välj år och månad, och tryck «Skapa utkast» för att hämta godkända timmar, övertid och frånvaro per anställd.",
            "hours.payroll_basis.scaffold_title": "Under uppbyggnad",
            "hours.payroll_basis.scaffold_body":
              "Den här sidan är redo för vidare utveckling av löneunderlag (anställdtabell, summer och export). Periodväljaren är aktiv; full funktion kommer snart.",
            "hours.payroll_basis.table_title": "Anställda",
            "hours.payroll_basis.table_subtitle": "Period: {{period}}",
            "hours.payroll_basis.table_subtitle_empty": "Välj år och månad",
            "hours.payroll_basis.empty_title": "Inga anställda i utkastet",
            "hours.payroll_basis.empty_body":
              "Skapa eller uppdatera utkast för att fylla tabellen med timmar för perioden.",
            "hours.payroll_basis.col_employee": "Anställd",
            "hours.payroll_basis.col_department": "Avdelning",
            "hours.payroll_basis.col_normal": "Normaltid",
            "hours.payroll_basis.col_registered": "Registrerat",
            "hours.payroll_basis.col_approved": "Godkänd",
            "hours.payroll_basis.col_unapproved": "Ej godkänd",
            "hours.payroll_basis.col_absence": "Frånvaro",
            "hours.payroll_basis.col_overtime": "Övertid",
            "hours.payroll_basis.col_docs": "Dokumentation",
            "hours.payroll_basis.col_note": "Anteckning",
            "hours.payroll_basis.note_placeholder":
              "T.ex. Ändring av timlön från … · Semesterersättning betalas för vecka …",
            "hours.payroll_basis.note_empty_preview": "Ingen anteckning ännu",
            "hours.payroll_basis.note_add": "Skriv anteckning",
            "hours.payroll_basis.note_edit": "Redigera anteckning",
            "hours.payroll_basis.note_save": "Spara anteckning",
            "hours.payroll_basis.note_saving": "Sparar…",
            "hours.payroll_basis.note_cancel": "Avbryt",
            "hours.payroll_basis.note_dialog_title": "Anteckning för anställd",
            "hours.payroll_basis.note_dialog_employee": "Anställd: {{name}}",
            "hours.payroll_basis.general_notes_title": "Allmänna anteckningar",
            "hours.payroll_basis.general_notes_subtitle":
              "Anteckningar för hela perioden / alla anställda / lön generellt. Stödjer formatering (fetstil, listor, rubriker).",
            "hours.payroll_basis.general_notes_placeholder":
              "T.ex. Ändring av timlön från … · Semesterersättning betalas för vecka … · Allmänna lönejusteringar för perioden…",
            "hours.payroll_basis.general_notes_empty": "Inga allmänna anteckningar för perioden.",
            "hours.payroll_basis.general_notes_save": "Spara anteckningar",
            "hours.payroll_basis.docs_yes": "Ja",
            "hours.payroll_basis.docs_no": "Nej",
            "hours.payroll_basis.unapproved_badge": "{{count}} ej godkända",
            "hours.payroll_basis.summary_approved": "Godkända timmar",
            "hours.payroll_basis.summary_overtime": "Bekräftad OT",
            "hours.payroll_basis.summary_absence": "Frånvaro",
            "hours.payroll_basis.summary_unapproved": "Ej godkänd",
            "hours.payroll_basis.summary_unapproved_hint":
              "Synlig för uppföljning — ingår inte i lönesummor.",
            "hours.payroll_basis.footer_totals": "Summa (endast godkända i lön)",
            "hours.payroll_basis.footer_docs": "{{count}} med dokumentation",
            "hours.payroll_basis.legend":
              "Röda rader har ej godkända timmar. De visas, men summeras inte i löneunderlag eller ZIP-export.",
            "project.plan.holidays.title": "Röda dagar",

            "hour_settings.page.subtitle":
              "Frånvaro, godkännandeflöde, lönelås och övriga inställningar för tid (projekttimmar bygger på project_activity på projektet).",
            "hour_settings.guide.title": "Kom igång med timmar",
            "hour_settings.guide.intro":
              "Samma steg som på instrumentpanelen. Tidsregistrering bygger på projekt och project_activity; listorna över generella aktiviteter här är valfri administration och inget uppstartssteg.",
            "hour_settings.guide.step.project_activity":
              "Projekttimmar: säkerställ project_activity (och projekt) där personal ska föra tid — det är vad nuvarande Promang kräver för projektregistrering.",
            "hour_settings.guide.step.absence_types": "Frånvarotyper: skapa och underhåll de typer ni använder.",
            "hour_settings.guide.step.handlers":
              "Sätt administratör för timmar och för egna frånvaromeldingar.",
            "hour_settings.guide.step.payroll_lock":
              "Överväg låsning av lönperiod och utbetalningsdag när rutiner finns.",
            "hour_settings.guide.step.time_documents":
              "Valfritt — dokumentation på fristående tidrader utan kopplad servicerapport eller arbetsorder.",
            "hour_settings.guide.step.work_schedule":
              "Skapa arbetsscheman under Timmar → Arbetsscheman och koppla dem till anställda (användarprofiler).",
            "hour_settings.guide.back_dashboard": "Tillbaka till startsidan",
            "hour_settings.guide.open_user_guide": "Användarguide: timmar och frånvaro",

            "hour_settings.time_documents.section_title": "Bilagor på tidrader",
            "hour_settings.time_documents.section_description":
              "Tillåt att bifoga bilder/filer till frittstående tidrader när raden inte är kopplad till servicerapport eller arbetsorder.",
            "hour_settings.time_documents.enabled": "Tillåt dokumentation (bilder/filer) via tidregistrering",

            "hour_settings.agreed_overtime.section_title": "Avtalad övertid",
            "hour_settings.agreed_overtime.section_description":
              "Låt anställda begära avtalad övertid vid registrering. Admin eller användaren som hanterar tid måste bekräfta innan det räknas som OT.",
            "hour_settings.agreed_overtime.enabled": "Tillåt avtalad övertid",
            "hour_settings.agreed_overtime.enabled_help":
              "När detta är aktivt kan anställda kryssa i avtalad övertid och ange antal OT-timmar (hela beloppet eller en del).",

            "hours.agreed_overtime.section_title": "Avtalad övertid",
            "hours.agreed_overtime.checkbox_label": "Avtalad övertid",
            "hours.agreed_overtime.checkbox_help":
              "Kryssa i om hela eller delar av denna registrering är avtalad övertid. Bekräftelse krävs innan det räknas.",
            "hours.agreed_overtime.hours_label": "Antal OT-timmar",
            "hours.agreed_overtime.hours_hint": "Kan vara hela beloppet eller en del (max lika med registrerad tid).",
            "hours.agreed_overtime.hours_required": "Ange antal OT-timmar",
            "hours.agreed_overtime.hours_invalid": "OT-timmar måste vara större än 0 och inte mer än registrerad tid",
            "hours.agreed_overtime.badge_pending": "Avtalad OT — väntar",
            "hours.agreed_overtime.badge_confirmed": "Avtalad OT — bekräftad",
            "hours.agreed_overtime.process_dialog_title": "Behandla tid",
            "hours.agreed_overtime.process_help": "Begärd OT: {{hours}} t av {{time}} t registrerat.",
            "hours.agreed_overtime.note_label": "Anteckning till OT-behandling",
            "hours.agreed_overtime.note_placeholder": "Valfri anteckning…",
            "hours.agreed_overtime.confirm": "Bekräfta OT",
            "hours.agreed_overtime.reject": "Avvisa OT",
            "hours.agreed_overtime.confirm_success": "Avtalad övertid är bekräftad",
            "hours.agreed_overtime.confirm_failed": "Kunde inte bekräfta avtalad övertid",
            "hours.agreed_overtime.reject_success": "Avtalad övertid är avvisad",
            "hours.agreed_overtime.reject_failed": "Kunde inte avvisa avtalad övertid",
            "hours.agreed_overtime.waiting_for_handler":
              "Väntar på bekräftelse från administratör eller användaren som hanterar tid.",

            "hour.time_documents.title": "Dokumentation",
            "hour.time_documents.subtitle": "Bilder och filer kopplade till denna timrad.",
            "hour.time_documents.help_save_first": "Spara tidraden innan du kan bifoga filer.",
            "hour.time_documents.pending_hint":
              "Lägg till filer här. De laddas upp automatiskt när tidraden sparas.",
            "hour.time_documents.pending_add": "Lägg till filer",
            "hour.time_documents.pending_count": "{{count}} fil(er) väntar på uppladdning",
            "hour.time_documents.pending_remove": "Ta bort",
            "hour.time_documents.pending_file_type_denied": "Filtypen är inte tillåten.",
            "hour.time_documents.pending_upload_done": "Bilagor har laddats upp",
            "hour.time_documents.pending_upload_failed":
              "Timraden sparades, men uppladdning av bilagor misslyckades. Stäng och öppna timraden igen för att försöka på nytt.",
            "hour.time_documents.blocked_linked":
              "Dokumentation är inte möjlig när timraden kopplats till rapport eller arbetsorder.",
            "hour.time_documents.blocked_lock": "Perioden är låst; bilagor kan inte ändras.",

            "documentUpload.bar.ariaLabel": "Förlopp för dokumentuppladdning",
            "documentUpload.bar.uploading": "Laddar upp dokument",
            "documentUpload.bar.failed": "Uppladdningen misslyckades",
            "documentUpload.bar.destination": "Till",
            "documentUpload.bar.fileOf": "{{current}} av {{total}}",
            "documentUpload.bar.dismiss": "Dölj uppladdningsstatus",
            "documentUpload.bar.minimize": "Minimera",
            "documentUpload.bar.expand": "Visa uppladdningsstatus",
            "documentUpload.bar.close": "Stäng",
            "documentUpload.bar.uploadingShort": "Laddar upp",
            "documentUpload.bar.jobSingular": "uppladdning",
            "documentUpload.bar.jobPlural": "uppladdningar",
            "documentUpload.viewer.showing": "Visar {{from}}–{{to}} av {{total}}",
            "documentUpload.bar.continueHint":
              "Uppladdningen fortsätter högst upp på sidan — du kan stänga det här fönstret och fortsätta arbeta.",
            "documentUpload.preview.title": "Förhandsgranskning och uppladdning",
            "documentUpload.preview.addMore": "Lägg till fler bilder",
            "documentUpload.preview.close": "Stäng",
            "documentUpload.preview.confirm": "Ladda upp",
            "documentUpload.preview.uploading": "Laddar upp…",
            "documentUpload.preview.removeFile": "Ta bort fil",
            "documentUpload.preview.folderLabel": "Mapp",
            "documentUpload.preview.folderSelectedHint": "Dokument laddas upp till vald mapp.",
            "documentUpload.preview.drawingLabel": "Ritning (valfritt)",
            "documentUpload.preview.linkedDrawing": "Kopplad ritning #{{id}}",
            "documentUpload.preview.linkedDrawingHint": "Checklistan är kopplad till denna ritning — placera bara pinnen.",
            "documentUpload.preview.enableSketch": "Markering / skiss på ritning",
            "documentUpload.preview.enableSketchHint": "Valfritt: rita markering på ritningen efter att pinnen är placerad.",
            "documentUpload.preview.enableSketchHintFullCanvas": "Valfritt: efter att du klickar på ritningen öppnas skiss i egen dialog.",
            "documentUpload.preview.fullCanvasPlacementHint": "Pinnen placeras på den faktiska ritningen (full Ritningar-viewer).",
            "documentUpload.preview.selectDrawingFirst": "Välj ritning innan du placerar pinnen.",
            "documentUpload.preview.positionPlacedOnDrawing": "Position satt på ritningen",
            "documentUpload.preview.sketchAttached": "Skiss tillagd",
            "documentUpload.preview.sketchCaptureFailed": "Kunde inte starta skiss — pin sparas utan markering.",
            "documentUpload.preview.drawingPlaceholder": "Välj ritning…",
            "documentUpload.preview.drawingPositionLabel": "Position på ritning",
            "documentUpload.preview.drawingPosition": "Position: X: {{x}}, Y: {{y}}",
            "documentUpload.preview.pickDrawingPosition": "Välj position på ritning",
            "documentUpload.preview.changeDrawingPosition": "Ändra position",
            "documentUpload.preview.drawingPositionDialogTitle": "Välj position på ritning",
            "documentUpload.preview.drawingClickHint": "Klicka på ritningen för att välja position",
            "documentUpload.preview.drawingLoading": "Laddar ritning…",
            "documentUpload.preview.drawingLoadFailed": "Kunde inte ladda ritning",
            "documentUpload.preview.confirmDrawingPosition": "Bekräfta position",
            "documentUpload.preview.drawingDialogTitle": "Välj ritning",
            "documentUpload.preview.drawingSearchPlaceholder": "Sök ritningar…",
            "documentUpload.preview.drawingEmpty": "Inga ritningar hittades",
            "documentUpload.direct.buttonShort": "Kamera",
            "documentUpload.direct.tooltip": "Ladda upp bilder",
            "documentUpload.direct.imagesOnly": "Endast bildfiler kan laddas upp här.",
            "documentUpload.dropzone.viewImages": "Visa bilder",
            "documentUpload.dropzone.viewImagesCount": "Visa bilder ({{count}})",
            "documentUpload.dropzone.loading": "Laddar…",
            "documentUpload.dropzone.ariaLabel": "Visa eller hantera bilder",
            "documentUpload.destination.checklist_item": "Checklistepunkt",
            "documentUpload.destination.report": "Servicerapport",
            "documentUpload.destination.project": "Projekt",
            "documentUpload.destination.hour": "Tidsregistrering",
            "documentUpload.destination.meeting_minute": "Mötesprotokoll",
            "documentUpload.destination.vehicle_service": "Fordonsservice",

            "user_guide.hub.badge": "Användarguide",
            "user_guide.hub.title": "Så använder du Promang",
            "user_guide.hub.subtitle":
              "Steg-för-steg-guider för administratörer och personal. Innehållet uppdateras i appen — teknisk utvecklardokumentation finns separat.",
            "user_guide.hub.card.hours.title": "Timmar, frånvaro och arbetsschema",
            "user_guide.hub.card.hours.description":
              "Uppstart: frånvarotyper, ansvariga, lönelås, påminnelser och arbetsschema.",
            "user_guide.hub.card.hse.title": "HMS, mål och skyddsombud",
            "user_guide.hub.card.hse.description":
              "Sätt HMS-ansvarig, skyddsombud, riskhantering och årets mål.",
            "user_guide.hse.title": "HMS-upplägg",
            "user_guide.hse.badge": "Företag",
            "user_guide.hse.back_to_hub": "Tillbaka till guider",
            "user_guide.hse.purpose": "Kontrollera att företaget har skyddsombud, HMS-ansvarig och mål för året. Då fungerar aviseringar och godkännande som de ska.",
            "user_guide.hse.section.roles.title": "Roller",
            "user_guide.hse.section.roles.p1": "HMS-ansvarig äger åtgärder och genomgång. Skyddsombudet är den lagstadgade kontakten för arbetsmiljön.",
            "user_guide.hse.section.roles.p2": "Sätt båda under HMS och KS → Inställningar. Suppleanter är valfria.",
            "user_guide.hse.section.goals.title": "Mål",
            "user_guide.hse.section.goals.p1": "Använd mallar och brickor i stället för långa tabeller. Godkänn när ledningen är överens.",
            "user_guide.hse.section.goals.p2": "En åtgärd kan kopplas till ett fokusområde, men det är valfritt.",
            "user_guide.hse.section.risk.title": "Risk",
            "user_guide.hse.section.risk.p1": "Börja med en övergripande riskbedömning för året. Bedöm sedan varje risk och koppla åtgärder. Registret visar alla risker.",
            "user_guide.hse.section.related.title": "Relaterade sidor",
            "user_guide.hse.section.related.settings": "HMS-inställningar",
            "user_guide.hse.section.related.goals": "Mål",
            "user_guide.hse.section.related.risk": "Riskbedömningar",
            "company_guide.hse.title": "HMS-status",
            "company_guide.hse.subtitle": "Rekommenderade steg innan modulen används fullt ut.",
            "company_guide.hse.progress_error": "Kunde inte hämta HMS-status. Försök att uppdatera sidan.",
            "company_guide.hse.link.settings": "Öppna inställningar",
            "company_guide.hse.link.goals": "Öppna mål",
            "company_guide.hse.task.responsible.title": "HMS-ansvarig",
            "company_guide.hse.task.responsible.warn": "Sätt vem som äger HMS i företaget.",
            "company_guide.hse.task.responsible.ok": "HMS-ansvarig är satt.",
            "company_guide.hse.task.safety_rep.title": "Skyddsombud",
            "company_guide.hse.task.safety_rep.warn": "Sätt skyddsombud (suppleanter är valfria).",
            "company_guide.hse.task.safety_rep.ok": "Skyddsombud är satt.",
            "company_guide.hse.task.verneombud.title": "Skyddsombud",
            "company_guide.hse.task.verneombud.warn": "Sätt skyddsombud (suppleanter är valfria).",
            "company_guide.hse.task.verneombud.ok": "Skyddsombud är satt.",
            "company_guide.hse.task.risk.title": "Riskansvar",
            "company_guide.hse.task.risk.warn": "Sätt vem som äger risk, eller använd HMS-ansvarig.",
            "company_guide.hse.task.risk.ok": "Riskansvar är på plats.",
            "company_guide.hse.task.categories.title": "Riskkategorier",
            "company_guide.hse.task.categories.info": "Aktivera minst en riskkategori.",
            "company_guide.hse.task.categories.ok": "Riskkategorier är klara.",
            "company_guide.hse.task.goals.title": "Årets mål",
            "company_guide.hse.task.goals.warn": "Lägg in minst ett mål för innevarande år.",
            "company_guide.hse.task.goals.ok": "Årets mål är inlagda.",
            "company_guide.hse.task.goals.info": "Skapa och godkänn mål för året när ni är redo.",
            "company_guide.hse.task.ai.title": "AI-förslag",
            "company_guide.hse.task.ai.info": "Valfritt: slå på förslag när en nyckel är satt.",
            "company_guide.hse.task.ai.warn": "AI är på, men nyckeln saknas.",
            "user_guide.hub.card.offers.title": "Offerter och kalkyl",
            "user_guide.hub.card.offers.description":
              "Slå på checklista, godkännande, kalkyl och dokumentbyggare för företaget.",

            "user_guide.offers.back_to_hub": "Tillbaka till användarguiden",
            "user_guide.offers.badge": "Offerter",
            "user_guide.offers.title": "Offerter, kalkyl och dokument",
            "user_guide.offers.purpose":
              "Så här sätter du upp offertmodulen: vilka flikar som visas, hur kalkylen summeras och hur offertdokumentet byggs. Rekommenderade val är markerade i inställningarna.",
            "user_guide.offers.checklist.badge": "Uppstart",
            "user_guide.offers.checklist.heading": "Status för uppsättning (offerter)",
            "user_guide.offers.checklist.subtitle":
              "Rekommenderade funktioner som bör slås på så att checklista, godkännande och kalkyl visas på offerten.",
            "user_guide.offers.checklist.open_settings": "Öppna inställningar",
            "user_guide.offers.checklist.flag_on": "På",
            "user_guide.offers.checklist.flag_off": "Av — rekommenderas att slå på",
            "user_guide.offers.checklist.all_ok": "Rekommenderade offertinställningar är på plats.",
            "user_guide.offers.checklist.load_error.title": "Kunde inte läsa inställningar",
            "user_guide.offers.checklist.load_error.description": "Försök igen från offertinställningar.",
            "user_guide.offers.section.workflow.title": "Arbetsflöde",
            "user_guide.offers.section.workflow.p1":
              "Revisioner ger intern kontroll och godkännande före utskick. Checklista är en egen flik för kvalitetssäkring.",
            "user_guide.offers.section.workflow.p2":
              "«Kräv checklista före utskick» bör slås på först när checklistan faktiskt används, annars blockeras utskick.",
            "user_guide.offers.section.calculation.title": "Kalkyl",
            "user_guide.offers.section.calculation.p1":
              "Kalkylen är intern estimering (kostnad, timmar, påslag och täckningsbidrag). Offertlinjer är det kunden ser.",
            "user_guide.offers.section.calculation.li1":
              "Kalkyl v2 ger noggrannare summor i översikt och sidhuvud.",
            "user_guide.offers.section.calculation.li2":
              "Timrader: fyll i timmar och timpris (inte bara antal) så att summa timmar och timkostnad stämmer.",
            "user_guide.offers.section.calculation.li3":
              "Strukturgrupper till vänster är kapitel. Håll muspekaren över ett namn för att se hela titeln.",
            "user_guide.offers.section.document.title": "Dokument och förbehåll",
            "user_guide.offers.section.document.p1":
              "Dokumentbyggaren används för textblock i själva offerten. Förbehåll läggs som ett textblock under Dokument — det är den rekommenderade placeringen mot kund.",
            "user_guide.offers.section.related.title": "Nyttiga genvägar",
            "user_guide.offers.section.related.link_list": "Offertlista",
            "user_guide.offers.section.related.link_settings": "Inställningar för offerter",
            "user_guide.hub.card.drawings.title": "Ritningar, hus och våningar",
            "user_guide.hub.card.drawings.description":
              "Välj projekt, skapa hus och våningar, och ladda upp PDF-ritningar.",
            "user_guide.hub.footer_note": "Behöver du mer svar? Prova resurscentrets FAQ.",


            "user_guide.drawings.back_to_hub": "Tillbaka till användarguiden",
            "user_guide.drawings.badge": "Ritningar",
            "user_guide.drawings.title": "Ritningar, hus och våningar",
            "user_guide.drawings.purpose":
              "Så sätter du upp hus och våningar i ett projekt och laddar upp PDF-ritningar. Ritningar tillhör alltid ett projekt. En ritning är en PDF-sida.",
            "user_guide.drawings.open_module": "Öppna Ritningar",
            "user_guide.drawings.section.project.title": "1. Öppna Ritningar och välj projekt",
            "user_guide.drawings.section.project.li1": "Gå till Ritningar i menyn till vänster.",
            "user_guide.drawings.section.project.li2":
              "Välj projektet du ska arbeta med (sök på nummer, namn eller kund om listan är lång).",
            "user_guide.drawings.section.project.li3":
              "Valt projekt kommer ihåg under sessionen. Byt med Byt i headern när du behöver ett annat projekt.",
            "user_guide.drawings.section.project.shot": "Välj projekt innan du arbetar med ritningar",
            "user_guide.drawings.section.list.title": "2. Ritningslistan",
            "user_guide.drawings.section.list.p1":
              "När projektet är valt ser du strukturen till vänster (hus och våningar) och ritningarna till höger.",
            "user_guide.drawings.section.list.li1": "Hantera struktur — visa radera- och lägg till-kontroller i trädet",
            "user_guide.drawings.section.list.li2": "+ Ny ritning — öppna lådan för uppladdning",
            "user_guide.drawings.section.list.li3": "+ Hus i strukturpanelen — skapa hus",
            "user_guide.drawings.section.list.shot": "Ritningslista med strukturpanel",
            "user_guide.drawings.section.house.title": "3. Lägg till hus",
            "user_guide.drawings.section.house.li1": "Klicka + Hus högst upp i strukturpanelen.",
            "user_guide.drawings.section.house.li2": "Skriv husnamn, till exempel Hus A eller Byggnad 2.",
            "user_guide.drawings.section.house.li3": "Klicka Lägg till.",
            "user_guide.drawings.section.house.shot": "Fält för att lägga till hus",
            "user_guide.drawings.section.floor.title": "4. Lägg till våningar",
            "user_guide.drawings.section.floor.li1": "Klicka på huset i trädet så att det fälls ut.",
            "user_guide.drawings.section.floor.li2": "Klicka + Våning under huset.",
            "user_guide.drawings.section.floor.li3": "Skriv våningsnamn, till exempel 1:a våningen eller 2.",
            "user_guide.drawings.section.floor.li4": "Klicka Lägg till.",
            "user_guide.drawings.section.floor.li5": "Upprepa för fler våningar.",
            "user_guide.drawings.section.floor.p1":
              "Färgpunkter i trädet visar ritningstyp (arkitektur, ventilation, kök, annat).",
            "user_guide.drawings.section.floor.shot": "Fält för att lägga till våning under ett hus",
            "user_guide.drawings.section.floor.shot_tree": "Struktur med hus och våningar",
            "user_guide.drawings.section.upload.title": "5. Ladda upp ritning",
            "user_guide.drawings.section.upload.li1": "Välj våningen i strukturen (då förvalas hus och våning).",
            "user_guide.drawings.section.upload.li2": "Klicka + Ny ritning (eller Lägg till ritning här).",
            "user_guide.drawings.section.upload.li3": "Släpp PDF-filen i fältet, eller klicka Välj fil.",
            "user_guide.drawings.section.upload.li4":
              "Har PDF:en flera sidor: bläddra till rätt sida och bekräfta Använd sida N. Promang sparar en sida per ritning.",
            "user_guide.drawings.section.upload.li5": "Kontrollera Titel (kan läsas från filnamnet).",
            "user_guide.drawings.section.upload.li6":
              "Välj Ritningstyp (arkitektur, ventilation, kök eller annat).",
            "user_guide.drawings.section.upload.li7":
              "Kontrollera Placering (hus och våning). Använd Övriga om ritningen inte hör till en våning.",
            "user_guide.drawings.section.upload.li8": "Klicka Skapa ritning.",
            "user_guide.drawings.section.upload.shot_empty": "Låda för ny ritning före uppladdning",
            "user_guide.drawings.section.upload.shot_filled": "Ny ritning med PDF, typ och våning ifylld",
            "user_guide.drawings.section.done.title": "6. Klart",
            "user_guide.drawings.section.done.p1":
              "Ritningen visas som ett kort i listan, kopplad till hus och våning. Klicka på kortet för att öppna visaren (mått, markering, avvikelser och checklistor).",
            "user_guide.drawings.section.done.shot": "Ritningslista med uppladdad ritning",
            "user_guide.drawings.section.rules.title": "Regler att komma ihåg",
            "user_guide.drawings.section.rules.li1": "Ritningar ligger alltid i ett projekt.",
            "user_guide.drawings.section.rules.li2": "En ritning = en PDF-sida.",
            "user_guide.drawings.section.rules.li3":
              "Samma våning och samma typ kan bara ha en ritning. Uppladdning av dubblett ber om bekräftelse före ersättning.",
            "user_guide.drawings.section.rules.li4": "Ritningar utan våning läggs under Övriga.",

            "ai_skills.badge": "AI",
            "ai_skills.page_title": "AI skills",
            "ai_skills.subtitle":
              "Utbildning och riktlinjer för att använda AI i Promang — för alla inloggade användare.",
            "ai_skills.back_to_user_guide": "Tillbaka till användarguiden",
            "ai_skills.nav_label": "AI skills",
            "ai_skills.skill_badge": "Skill",
            "ai_skills.skill_badge_hint": "Strukturerad färdighet för AI och människor",
            "ai_skills.loading": "Laddar…",
            "ai_skills.load_error": "Kunde inte ladda dokumentet",
            "ai_skills.nav.overview": "Översikt",
            "ai_skills.nav.prompting_basics": "Prompting — grunderna",
            "ai_skills.nav.promang_ai_generator": "AI-generator i appen",
            "ai_skills.nav.microsoft_mail_ai": "Microsoft e-post AI",
            "ai_skills.nav.guide_flow_ai": "Guide flow och AI",
            "ai_skills.nav.cursor_for_promang": "Cursor för utvecklare",
            "ai_skills.hub_card.title": "AI skills — utbildning",
            "ai_skills.hub_card.description":
              "Så använder du AI säkert i Promang: prompting, generator, e-post och guider.",
            "ai_skills.nav.agent_integrations": "Agent — datamodeller (översikt)",
            "ai_skills.nav.agent_product": "Agent — produkt",
            "ai_skills.nav.agent_customer": "Agent — kund",
            "ai_skills.nav.agent_project": "Agent — projekt",
            "ai_skills.nav.agent_case": "Agent — ärende och poster",
            "ai_skills.nav.agent_tasks": "Agent — uppgifter (todos)",
            "ai_skills.nav.agent_hse_document": "Agent — HMS-dokument",
            "ai_skills.nav.agent_meeting_minutes": "Mötesprotokoll — AI",

            "dashboard.company_guide.hours_teaser_title": "Timmar och frånvaro",
            "dashboard.company_guide.hours_teaser_subtitle":
              "Uppstartsstatus och full guide finns i användarguiden — inte på startsidan.",
            "dashboard.company_guide.hours_teaser_cta": "Öppna status och guide",

            "user_guide.hours.back_to_hub": "Tillbaka till användarguiden",
            "user_guide.hours.checklist.badge": "Uppstart",
            "user_guide.hours.checklist.heading": "Status för uppsättning (Timmar-modulen)",
            "user_guide.hours.checklist.subtitle":
              "Endast synligt för administratörer. Varje rad länkar till inställningar eller mer information längre ned på sidan.",
            "user_guide.hours.badge": "Timmar och frånvaro",
            "user_guide.hours.title": "Timmar, frånvaro och arbetsschema",
            "user_guide.hours.purpose":
              "Guiden hjälper nya företag och administratörer att sätta upp frånvaro, ansvariga och arbetsschema. Checklistan på instrumentpanelen (endast admin) länkar hit för detaljer.",

            "user_guide.hours.section.registration.title": "Tidsregistrering i Promang",
            "user_guide.hours.section.registration.p1":
              "Projekttimmar ska kopplas till ett projekt och en projektrad (project activity). Det styr tidsregistrering i arbetsytan.",
            "user_guide.hours.section.registration.p2":
              "Äldre begrepp Activity och ActivityItem används i bakgrunden mot ekonomisystem (t.ex. Tripletex-synk). De är inte det du normalt väljer när du registrerar tid i gränssnittet.",
            "user_guide.hours.section.registration.p3":
              "Listor med «generella aktiviteter» under Timmar → Inställningar kan användas för administration men är inget separat krav i uppstartschecklistan på instrumentpanelen.",

            "user_guide.hours.section.visibility.title": "Vem ser vad?",
            "user_guide.hours.section.visibility.li1":
              "På startsidan visas bara en kort länk för administratörer när Timmar är aktiv. Full status och checklista finns här i användarguiden.",
            "user_guide.hours.section.visibility.li2":
              "Alla som har tillgång till Timmar → Inställningar ser den korta hjälpen högst upp på inställningssidan.",

            "user_guide.hours.section.steps.title": "Rekommenderad ordning",
            "user_guide.hours.section.steps.s1.title": "1. Frånvarotyper",
            "user_guide.hours.section.steps.s1.where": "Gå till Timmar → Inställningar → Frånvarotyper.",
            "user_guide.hours.section.steps.s1.b1":
              "Skapa typer som passar: semester, sjuk, egenanmälan, kompledighet, ledighet med mera.",
            "user_guide.hours.section.steps.s1.b2":
              "Frånvaro registreras mot dessa typer. Vem som godkänner egenanmälan beror på roller och vem ni sätter som frånvaroansvarig.",

            "user_guide.hours.section.steps.s2.title": "2. Ansvar för timmar och frånvaro",
            "user_guide.hours.section.steps.s2.where": "Gå till Timmar → Inställningar → Hantering av timmar och frånvaro.",
            "user_guide.hours.section.steps.s2.b1":
              "Timmar: välj gärna den som ska godkänna tidrapporter och följa upp avvikelser.",
            "user_guide.hours.section.steps.s2.b2":
              "Egenanmälan / frånvaro: välj den som ska hantera egenanmälningar (ofta HR eller närmaste chef).",
            "user_guide.hours.section.steps.s2.b3": "Sätt båda tidigt så medarbetare vet vem som följer upp.",

            "user_guide.hours.section.steps.s3.title": "3. Låsning av lönperiod (valfritt)",
            "user_guide.hours.section.steps.s3.where": "Gå till Timmar → Inställningar → Låsning av lönperiod.",
            "user_guide.hours.section.steps.s3.b1":
              "När rutinerna finns kan ni låsa månad vid periodslut och sätta utbetalningsdag enligt lön.",
            "user_guide.hours.section.steps.s3.b2":
              "Låsta perioder begränsar ändringar bakåt i tid; undantag hanteras av dem som har upplåsningsrättigheter där det är aktiverat.",

            "user_guide.hours.section.steps.s4.title": "4. Påminnelser om timmar (valfritt)",
            "user_guide.hours.section.steps.s4.where": "Gå till Timmar → Inställningar → Påminnelse om timmar.",
            "user_guide.hours.section.steps.s4.b1": "Slå på daglig påminnelse och sätt tider om ni vill påminna om tidsregistrering.",
            "user_guide.hours.section.steps.s4.b2":
              "Utgående e-post måste vara konfigurerad i drift (schemalagda jobbar) — fråga administratör eller leverantör om detta är aktivt.",

            "user_guide.hours.section.steps.s5.title": "5. Arbetsschema och sysselsättningsgrad",
            "user_guide.hours.section.steps.s5.where": "Använd Schema och användarprofiler under Användare.",
            "user_guide.hours.section.steps.s5.b1":
              "Varje anställd bör ha arbetsschema som stämmer med tjänsten — det påverkar förväntad tid och planering.",
            "user_guide.hours.section.steps.s5.b2": "Kalender och uppföljning av frånvaro förutsätter att detta finns på plats.",

            "user_guide.hours.section.public_holidays.title": "Röda dagar och normaltid",
            "user_guide.hours.section.public_holidays.p1":
              "Promang känner automatiskt igen norska helgdagar (1 maj, 17 maj, påsk m.m.). På sådana dagar är förväntad arbetstid normalt 0 timmar för anställda med mån–fre-schema.",
            "user_guide.hours.section.public_holidays.p2":
              "Du kan ändå registrera timmar på en röd dag när det faktiskt arbetats — formuläret visar ett informationsmeddelande men stoppar inte sparning.",
            "user_guide.hours.section.public_holidays.li1":
              "Timregistrering: blått meddelande med helgdagsnamn när datumet är röd dag.",
            "user_guide.hours.section.public_holidays.li2":
              "Månadsöversikt: normaltid visas netto (avdrag för röda dagar och registrerad frånvaro).",
            "user_guide.hours.section.public_holidays.li3":
              "Frånvaro: kan inte registreras på röda dagar (formuläret blockerar sådana datum).",
            "user_guide.hours.section.public_holidays.li4":
              "Tidsplan och kalender visar vilka dagar som är röda dagar under året.",

            "user_guide.hours.section.related.title": "Snabbvägar",
            "user_guide.hours.section.related.link_hours": "Timlista",
            "user_guide.hours.section.related.link_approval": "Godkännande av timmar",
            "user_guide.hours.section.related.link_absence": "Frånvaroöversikt",
            "user_guide.hours.section.related.link_monthly": "Månadsöversikt timmar",
            "user_guide.hours.section.related.link_work_schedule": "Min tidsplan (röda dagar)",
            "user_guide.hours.section.related.link_settings": "Inställningar för timmar",

            "user_guide.hours.section.more_help.title": "Mer hjälp",
            "user_guide.hours.section.more_help.p1":
              "Om något inte finns här kan resurscentrets FAQ eller support hjälpa vidare.",
            "user_guide.hours.section.more_help.faq_link": "Öppna FAQ i resurscentret",

            "Time Registration": "Tidsregistrering",
            "Registered hours": "Registrerade timmar",
            "Hours Overview": "Timmar Översikt",
            "Track and manage work hours": "Spåra och hantera arbetstimmar",
            "Select Employee": "Välj Anställd",
            "Set Date": "Sätt datum",
            "Today": "Idag",
            "Calendar": "Kalender",
      
            // Work Statistics translations
            "Work Statistics": "Arbetsstatistik",
            "Overview of your work hours and performance":
              "Översikt över dina arbetstimmar och prestation",
            "Something went wrong while loading work stats":
              "Något gick fel vid laddning av arbetsstatistik",
            "Could not load work statistics": "Kunde inte ladda arbetsstatistik",
            "No data available": "Ingen data tillgänglig",
            "No work statistics found for this user.":
              "Ingen arbetsstatistik hittades för denna användare.",
            "Expected This Week": "Förväntat denna vecka",
            "Worked This Week": "Arbetat denna vecka",
            "Worked This Month": "Arbetat denna månad",
            "Earned Time Off": "Intjänad ledighet",
            "Weekly Progress": "Veckans framsteg",
            "Hours worked this week": "Timmar arbetade denna vecka",
            "Remaining": "Återstående",
            "Overtime": "Övertid",
            "Weekly Goal": "Veckomål",
            "Completed": "Slutförd",
            "In Progress": "Pågående",
            "Under Target": "Under mål",
            "On Track": "På rätt spår",
            "Efficiency": "Effektivitet",
      
            // Vehicle translations
            "Vehicle handbook": "Fordonhandbok",
            "Check in to a vehicle to open its handbook from this menu.":
              "Checka in på ett fordon för att öppna handboken från den här menyn.",
            "Vehicle handbook could not be opened. Try again or contact an administrator.":
              "Fordonhandboken kunde inte öppnas. Försök igen eller kontakta en administratör.",
            "Go to trips": "Gå till resor",
            "Vehicle handbook entry subtitle":
              "Checka in och öppna sedan handboken för det fordon du är incheckad på.",
            "Vehicle handbook check in": "Checka in på fordon",
            "Vehicle handbook check in hint":
              "Välj ett fordon att checka in på; du skickas sedan till handboken.",
            "Vehicle handbook not a driver":
              "Du är inte registrerad som förare i företaget. Kontakta en administratör om du behöver körtillgång.",
            "Vehicle handbook no vehicles permission":
              "Du behöver behörighet till fordonslistan för att checka in här. Du kan fortfarande checka in från Resor eller instrumentpanelen om det finns.",
            "Vehicle Information": "Fordoninformation",
            "Number Plate": "Registreringsnummer",
            "VIN (Chassis Number)": "VIN (Chassisnummer)",
            "Make": "Märke",
            "Model": "Modell",
            "Model Year": "Årsmodell",
            "Body Style": "Karossstil",
            "Nickname": "Smeknamn",
            "Current Odometer (km)": "Nuvarande mätarställning (km)",
            "Statens Vegvesen Information": "Statens Vegvesen Information",
            "Norwegian Vehicle Authority Information": "Norska Vägverket Information",
            "Registration Date": "Registreringsdatum",
            "First Registration": "Första registrering",
            "Vehicle Type": "Fordonstyp",
            "Fuel Type": "Bränsletyp",
            "Engine Size (cc)": "Motoreffekt (cc)",
            "Power (kW)": "Effekt (kW)",
            "Inspection Information": "Besiktningsinformation",
            "EU-kontroll / Periodic Vehicle Inspection":
              "EU-kontroll / Periodisk fordonbesiktning",
            "Last Inspection Date": "Senaste besiktningsdatum",
            "Next Inspection Date": "Nästa besiktningsdatum",
            "Inspection Result": "Besiktningsresultat",
            "Inspection Station": "Besiktningsstation",
            "Insurance Information": "Försäkringsinformation",
            "Vehicle Insurance Details": "Fordonförsäkring Detaljer",
            "Insurance Company": "Försäkringsbolag",
            "Policy Number": "Policenummer",
            "Insurance Start Date": "Försäkring startdatum",
            "Insurance End Date": "Försäkring slutdatum",
            "Insurance Type": "Försäkringstyp",
            "Annual Premium (NOK)": "Årlig premie (NOK)",
            "Service Information": "Serviceinformation",
            "Maintenance and Service Details": "Underhåll och Service Detaljer",
            "Last Service Date": "Senaste servicedatum",
            "Next Service Date": "Nästa servicedatum",
            "Service Interval (km)": "Serviceintervall (km)",
            "Service Provider": "Serviceleverantör",
            "Warranty End Date": "Garanti slutdatum",
            "Warranty Type": "Garantityp",
            "Damage Reports": "Skaderapporter",
            "Vehicle Damage History": "Fordon Skadehistorik",
            "Damage reports will be implemented in the future":
              "Skaderapporter kommer att implementeras i framtiden",
            "Internal Controls": "Interna kontroller",
            "Company Internal Vehicle Controls":
              "Företagets Interna Fordonskontroller",
            "Last Internal Check": "Senaste interna kontroll",
            "Next Internal Check": "Nästa interna kontroll",
            "Safety Equipment Status": "Säkerhetsutrustning Status",
            "Vehicle Status": "Fordonstatus",
            "Trips": "Turer",
            "Service": "Service",
            "Documents": "Dokument",
            "Vehicle": "Fordon",
            "Vehicle Documents": "Fordon Dokument",
            "Manage vehicle documents and files": "Hantera fordon dokument och filer",
            "Vehicle Trips": "Fordon Turer",
            "vehicle.trips_stats.title": "Tur- och körsträckestatistik",
            "vehicle.trips_stats.subtitle": "Körsträcka baserad på registrerade turer för detta fordon",
            "vehicle.trips_stats.trip_count": "Antal turer",
            "vehicle.trips_stats.total_distance": "Total körsträcka",
            "vehicle.trips_stats.this_month": "Körsträcka denna månad",
            "vehicle.trips_stats.this_year": "Körsträcka i år",
            "vehicle.trips_stats.last_year": "Körsträcka förra året",
            "vehicle.trips_stats.estimated_this_year": "Uppskattad körsträcka i år",
            "vehicle.trips_stats.today": "Idag",
            "vehicle.trips_stats.this_week": "Denna vecka",
            "trips found": "turer hittade",
            "No trips found for this vehicle": "Inga turer hittade för detta fordon",
            "Vehicle safety and maintenance checklists":
              "Fordon säkerhet och underhåll checklistor",
            "Create Checklist": "Skapa checklista",
            "Last Internal Control": "Senaste interna kontroll",
            "Checklist Number": "Checklista nummer",
            "Items Approved": "Godkända punkter",
            "Checklist Items": "Checklista punkter",
            "Approved": "Godkänd",
            "Not Approved": "Inte godkänd",
            "No checklists found": "Inga checklistor hittade",
            "Get started by creating a new checklist":
              "Börja med att skapa en ny checklista",
            "Select Checklist Type": "Välj checklista typ",
            "Choose the type of checklist you want to create for this vehicle":
              "Välj typ av checklista du vill skapa för detta fordon",
            "Create a new checklist for this project":
              "Skapa en ny checklista för detta projekt",
            "Choose the type of checklist you want to create for this project":
              "Välj typ av checklista du vill skapa för detta projekt",
            "Project checklist title": "Projektchecklista #{{number}}{{suffix}}",
            "Customer checklist title": "Kundchecklista #{{number}}{{suffix}}",
            "Folder checklist title": "Mappchecklista #{{number}}{{suffix}}",
            "Generic new checklist title": "Checklista #{{number}} ({{date}})",
            "Report checklist default title": "Rapport {{number}} - {{address}}",
            "Choose the type of checklist you want to create for this report":
              "Välj typ av checklista du vill skapa för denna rapport",
            "Choose the type of checklist you want to create for this folder":
              "Välj typ av checklista du vill skapa för denna mapp",
            "Choose the type of checklist you want to create for this customer":
              "Välj typ av checklista du vill skapa för denna kund",
            "Choose the type of checklist you want to create":
              "Välj typ av checklista du vill skapa",
            "Checklist title placeholder": "Ange en titel för checklistan",
            "Checklist title edit hint":
              "Föreslås automatiskt — ändra titeln vid behov innan du väljer typ.",
            "Enter checklist title": "Ange checklista titel",
            "No checklist types available": "Inga checklista typer tillgängliga",
            "items": "punkter",
            "Basic Information": "Grundläggande information",
            "Enter checklist basic details":
              "Ange grundläggande detaljer för checklistan",
            "Define checklist items and requirements":
              "Definiera checklista punkter och krav",
            "Show all": "Visa alla",
            "Show in new tab": "Visa i ny fane",
      
            // Personalhåndbok translations
            "Personalhåndbok": "Personalhåndbok",
            "personalhåndbok.description":
              "Tilgang till företagets riktlinjer, säkerhetsprocedurer och anställdinformation",
            "Open": "Öppna",
            "HMS Guidelines": "Rutiner",
            "Safety procedures and guidelines": "Säkerhetsprocedurer och riktlinjer",
            "Instructions": "Riktlinjer",
            "Company policies and procedures": "Företagets riktlinjer och procedurer",
            "Instruction Chapters": "Riktlinjer - Kapitel",
            "Chapter": "Kapitel",
            "Create Chapter": "Skapa kapitel",
            "Update Chapter": "Uppdatera kapitel",
            "Chapter Number": "Kapitel nummer",
            "Parent Chapter": "Överordnat kapitel",
            "Sub Chapters": "Underkapitel",
            "No chapter number": "Inget kapitel nummer",
            "Colleagues": "Kolleger",
            "colleague_dialog.subtitle": "Kollega",
            "colleague_dialog.contact_title": "Kontaktinformation",
            "colleague_dialog.contact_missing": "Inget mobilnummer eller e-post är registrerat.",
            "colleague_dialog.mobile_work": "Jobbmobil",
            "colleague_dialog.mobile": "Privat mobil",
            "colleague_dialog.email": "E-post",
            "colleague_dialog.call": "Ring",
            "colleague_dialog.send_email": "Skicka e-post",
            "colleague_dialog.department": "Avdelning",
            "colleague_dialog.next_of_kin": "Anhörig",
            "colleague_dialog.employee_number": "Anställningsnummer",
            "colleague_dialog.close": "Stäng",
            "colleague_dialog.relationship.spouse": "Make/maka",
            "colleague_dialog.relationship.partner": "Partner",
            "colleague_dialog.relationship.parent": "Förälder",
            "colleague_dialog.relationship.child": "Barn",
            "colleague_dialog.relationship.sibling": "Syskon",
            "Hei": "Hej",
            "Team overview and contacts": "Team översikt och kontakter",
            "Recent HMS Guidelines": "Senaste Rutiner",
            "Recent Instructions": "Senaste Riktlinjer",
            "Recent KS/HMS Documents": "Senaste KS/HMS Dokument",
            "KS/HMS Documents": "KS/HMS Dokument",
            "employee_handbook.pending_read_ack_title":
              "KS/HMS: dokument som saknar bekräftelse",
            "employee_handbook.pending_read_ack_body":
              "Du har {count} dokument som inte bekräftats som lästa och förstådda. Öppna varje dokument och bekräfta, eller använd fullständig HMS/KS-vy.",
            "employee_handbook.all_documents_acknowledged":
              "Du har bekräftat alla KS/HMS-dokument du har tillgång till (läst och förstått).",
            "employee_handbook.read_status_acknowledged": "Läst och bekräftad",
            "employee_handbook.read_status_pending": "Saknar bekräftelse",
            "employee_handbook.read_status_creator_exempt": "Författare (undantagen)",
            "employee_handbook.go_to_documents_tab": "Gå till KS/HMS-dokument",
            "employee_handbook.forms_tab": "Formulär och mallar",
            "employee_handbook.forms_tab_mobile": "Formulär",
            "employee_handbook.forms_tab_subtitle": "Ifyllbara HMS-formulär — skapa och fyll i direkt utan att leta i dokumentträdet.",
            "employee_handbook.forms_tab_search": "Sök formulär eller mall…",
            "employee_handbook.forms_tab_empty": "Inga ifyllbara formulär är registrerade i personalhandboken ännu.",
            "employee_handbook.forms_tab_no_results": "Inga formulär matchar sökningen.",
            "employee_handbook.forms_tab_info": "Mer info",
            "employee_handbook.forms_tab_overview_hint": "Tryck för snabb åtkomst",
            "employee_handbook.open_full_document": "Öppna full sida (HMS/KS)",
            "employee_handbook.other_chapter_documents": "Andra dokument i kapitel",
            "employee_handbook.other_chapter_documents_hint":
              "Tillhörande rutin, kundinformation eller andra bilagor i samma kapitel.",
            "dashboard_report.handbook_read_incomplete":
              "{pending} av {total} KS/HMS-dokument saknar bekräftelse som läst/förstått.",
            "dashboard_report.handbook_register_absence_subtitle":
              "Registrera frånvaro och skicka till behandling.",
            "employee_handbook.stat_line_pending":
              "{count} dokument saknar fortfarande bekräftelse som läst och förstått.",
            "Kapitler": "Kapitel",
            "Dokumenter uten kapittel": "Dokument utan kapitel",
            "Dokumenter som ikke er tilknyttet noe kapittel": "Dokument som inte är kopplade till något kapitel",
            "Søk etter dokumenter...": "Sök efter dokument...",
            "Fant {count} dokumenter": "Hittade {count} dokument",
            "Ingen dokumenter funnet": "Inga dokument hittades",
            "Prøv å endre søkeordene dine": "Försök ändra dina sökord",
            "Laster dokument...": "Laddar dokument...",
            "Ingen innhold tilgjengelig": "Inget innehåll tillgängligt",
            "Dokumenter uten bransje": "Dokument utan bransch",
            "Dokumenter uten kategori": "Dokument utan kategori",
            "Dokumenter uten bransje og kategori": "Dokument utan bransch och kategori",
            "No chapter": "Inget kapitel",
            "Employee Handbook": "Anställd Handbok",
      
            // Deviation Template translations
            "deviation.template": "Avvik mal",
            "deviation.template.select": "Velg mal",
            "deviation.template.select.description":
              "Velg en mal for å gjøre det enklere å registrere avviket",
            "deviation.template.standard": "Standard avvik",
            "deviation.template.standard.description": "Vanlig avviksregistrering",
            "deviation.form.type_category_hint":
              "Välj den kategori som bäst beskriver denna avvikelse.",
            "deviation.form.search_types": "Sök bland avvikelsetyper…",
            "deviation.form.no_matching_types": "Inga träffar bland typerna",
            "deviation.template.incident_injury": "Uønsket hendelse - Skade",
            "deviation.template.incident_injury.description":
              "Strukturert skjema for registrering av uønsket hendelse med skade",
            "deviation.template.back": "← Tilbake til maler",
      
            // Event description translations
            "deviation.event.description": "Hendelsesbeskrivelse",
            "deviation.event.description.title": "Hendelsesbeskrivelse",
            "deviation.event.description.subtitle": "Beskriv hendelsen som skjedde",
            "deviation.event.date": "Dato for hendelse",
            "deviation.event.time": "Tidspunkt",
            "deviation.event.description.field": "Beskrivelse av hendelsen",
            "deviation.event.description.placeholder":
              "Beskriv detaljert hva som skjedde...",
            "deviation.event.involved_persons": "Involverte personer",
            "deviation.event.witnesses": "Vitner",
      
            // Location translations
            "deviation.location": "Hvor skjedde hendelsen",
            "deviation.location.title": "Hvor skjedde hendelsen",
            "deviation.location.subtitle": "Angi sted og avdeling",
            "deviation.location.place": "Sted",
            "deviation.location.department": "Avdeling",
            "deviation.location.building": "Bygg/Område",
            "deviation.location.room_area": "Rom/Område",
            "deviation.location.details": "Mer detaljert beskrivelse av stedet",
            "deviation.location.details.placeholder":
              "Beskriv stedet mer detaljert...",
      
            // Categorization translations
            "deviation.categorization": "Kategorisering",
            "deviation.categorization.title": "Kategorisering av hendelsen",
            "deviation.categorization.subtitle":
              "Kategoriser hendelsen for å gjøre det enklere å analysere og følge opp",
            "deviation.categorization.category": "Kategori",
            "deviation.categorization.severity": "Alvorlighetsgrad",
            "deviation.categorization.immediate_cause": "Umiddelbar årsak",
            "deviation.categorization.underlying_cause": "Underliggende årsak",
            "deviation.categorization.details": "Mer detaljert kategorisering",
            "deviation.categorization.details.placeholder":
              "Beskriv kategoriseringen mer detaljert...",
      
            // Event categories
            "deviation.category.law_violation": "Avvik lov",
            "deviation.category.regulation_violation": "Avvik forskrift",
            "deviation.category.procedure_violation": "Brudd på rutine",
            "deviation.category.process_violation": "Brudd på prosedyre",
            "deviation.category.training_violation": "Brudd på opplæring",
            "deviation.category.information": "Informasjon",
            "deviation.category.other": "Annet",
      
            // Treatment translations
            "deviation.treatment": "Behandling",
            "deviation.treatment.title": "Behandling av hendelsen",
            "deviation.treatment.subtitle":
              "Vurder om årsakanalyse og strakstiltak er nødvendig",
            "deviation.treatment.root_cause_analysis": "Årsakanalyse",
            "deviation.treatment.immediate_actions": "Strakstiltak",
            "deviation.treatment.root_cause_analysis.details": "Årsakanalyse",
            "deviation.treatment.root_cause_analysis.placeholder":
              "Beskriv årsakanalysen...",
            "deviation.treatment.immediate_actions.details": "Strakstiltak",
            "deviation.treatment.immediate_actions.placeholder":
              "Beskriv strakstiltakene...",
            "deviation.treatment.suggested_actions": "Forslag til tiltak",
            "deviation.treatment.suggested_actions.placeholder":
              "Beskriv forslag til tiltak...",
      
            // Action translations
            "deviation.action": "Tiltak",
            "deviation.action.title": "Opprett tiltak",
            "deviation.action.subtitle":
              "Opprett og planlegg konkrete tiltak basert på analysen",
            "deviation.action.title.field": "Tiltak tittel",
            "deviation.action.deadline": "Frist",
            "deviation.action.responsible": "Ansvarlig person",
            "deviation.action.department": "Avdeling",
            "deviation.action.location": "Sted",
            "deviation.action.category": "Kategori",
            "deviation.action.description": "Beskrivelse av tiltak",
            "deviation.action.description.placeholder":
              "Beskriv tiltaket detaljert...",
            "deviation.action.health_service_cooperation":
              "Samarbeid med bedrifthelsetjenesten",
            "deviation.action.cost": "Kostnad (NOK)",
            "deviation.action.documents": "Dokumenter",
            "deviation.action.related_elements": "Tilknyttede elementer",
      
            // Action categories
            "deviation.action.category.safety": "Sikkerhet",
            "deviation.action.category.quality": "Kvalitet",
            "deviation.action.category.environment": "Miljø",
            "deviation.action.category.procedure": "Prosedyre",
            "deviation.action.category.training": "Opplæring",
            "deviation.action.category.maintenance": "Vedlikehold",
            "deviation.action.category.equipment": "Utstyr",
            "deviation.action.category.communication": "Kommunikasjon",
            "deviation.action.category.other": "Annet",
      
            // Action statuses
            "deviation.action.status.planned": "Planlagt",
            "deviation.action.status.started": "Påbegynt",
            "deviation.action.status.in_progress": "Under arbeid",
            "deviation.action.status.completed": "Fullført",
            "deviation.action.status.cancelled": "Kansellert",
            "deviation.action.status.on_hold": "På vent",
      
            // Action priorities
            "deviation.action.priority.low": "Lav",
            "deviation.action.priority.medium": "Medium",
            "deviation.action.priority.high": "Høy",
            "deviation.action.priority.critical": "Kritisk",
      
            // Form validation messages
            "deviation.event.description.required": "Hendelsesbeskrivelse er påkrevd",
            "deviation.location.required": "Sted er påkrevd",
            "deviation.category.required": "Kategori er påkrevd",
            "deviation.action.title.required": "Tiltak tittel er påkrevd",
            "deviation.action.description.required": "Beskrivelse er påkrevd",
            "deviation.action.category.required": "Kategori er påkrevd",
            "deviation.action.deadline.required": "Frist er påkrevd",
            "deviation.action.responsible.required": "Ansvarlig person er påkrevd",
      
            // Success/Error messages
            "deviation.template.saved": "Data ble lagret!",
            "deviation.action.created": "Tiltak ble opprettet!",
            "deviation.template.save_error": "Noe gikk galt. Kunne ikke lagre data!",
            "deviation.action.create_error":
              "Noe gikk galt. Kunne ikke opprette tiltak!",
      
            // Navigation
            "deviation.previous": "Forrige",
            "deviation.next": "Neste",
            "deviation.complete": "Fullfør",
            "deviation.reset": "Nullstill",
            "deviation.create_action": "Opprett tiltak",
            "deviation.saving": "Lagrer...",
      
            // Action creation dialog
            "deviation.action.create.question": "Ønsker du å opprette tiltak?",
            "deviation.action.create.description":
              "Du kan opprette konkrete tiltak med frist, ansvarlig person og beskrivelse.",
            "deviation.action.create.yes": "Ja, opprett tiltak",
            "deviation.action.create.no": "Nei, ikke nå",
            "deviation.action.notes": "Notater om tiltak (valgfritt)",
            "deviation.action.notes.placeholder":
              "Legg til notater om tiltak hvis nødvendig...",
            "chemical.inventory": "Kemikalieförteckning",
            "chemical.inventory.description": "Hantera kemikalier och säkerhetsdatablad",
            "chemical.inventory.new": "Nytt ämne",
            "chemical.inventory.create_with_ai": "Skapa med AI",
            "chemical.inventory.create_manual": "Fyll i manuellt",
            "chemical.inventory.create_manual_lead": "Ange namn, CAS och övriga fält själv.",
            "chemical.inventory.ai_choose_lead": "Ladda upp FDV eller datablad så fyller AI i ämnesregistret. Du godkänner innan det sparas.",
            "chemical.inventory.ai_upload_lead": "Dra in eller välj PDF (säkerhetsdatablad, FDV eller produktdatablad). Analysen startar automatiskt.",
            "chemical.inventory.ai_drop_title": "Släpp filen här, eller klicka för att välja",
            "chemical.inventory.ai_file_too_large": "Filen är för stor. Maximal storlek är 20 MB.",
            "chemical.inventory.ai_file_invalid": "Ogiltig filtyp. Välj PDF eller bild (JPG, PNG).",
            "chemical.inventory.ai_analyzing": "Analyserar dokumentet…",
            "chemical.inventory.ai_ready": "Utkast från databladet är klart. Kontrollera fälten innan du skapar.",
            "chemical.inventory.ai_ready_partial": "Analysen lyckades, men namn eller CAS saknas. Fyll i manuellt och kontrollera innan du sparar.",
            "chemical.inventory.ai_empty": "Analysen lyckades, men kunde inte härleda formulärdata från dokumentet. Fyll i manuellt, eller prova ett datablad med läsbar text.",
            "chemical.inventory.ai_empty_unreadable": "Analysen lyckades, men den extraherade texten var för kort eller oläsbar (ofta en skannad PDF utan OCR). Fyll i manuellt, eller ladda upp ett datablad med läsbar text.",
            "chemical.inventory.ai_failed": "Kunde inte analysera dokumentet. Prova en annan PDF eller fyll i manuellt.",
            "chemical.inventory.ai_back": "Tillbaka",
            "chemical.inventory.ai_review_hint": "Fälten är ifyllda från det uppladdade databladet. Kontrollera och spara.",
            "chemical.inventory.edit": "Redigera ämne",
            "chemical.inventory.delete": "Ta bort ämne",
            "chemical.inventory.create": "Skapa kemikalieförteckning",
            "chemical.inventory.update": "Uppdatera kemikalieförteckning",
            "chemical.inventory.search": "Sök i kemikalieförteckningen…",
            "chemical.inventory.no_results": "Inga ämnen hittades",
            "chemical.inventory.add_from_product": "Lägg till från produkt",
            "chemical.inventory.basic_info": "Grundläggande information",
            "chemical.inventory.safety_info": "Säkerhetsinformation",
            "chemical.inventory.supplier_info": "Leverantörsinformation",
            "chemical.inventory.documents": "Dokument",
            "chemical.inventory.notes": "Anteckningar",
            "chemical.inventory.history": "Historik",
            "chemical.inventory.hazard_symbols": "Farosymboler",
            "chemical.inventory.hms_level": "HMS-nivå",
            "chemical.inventory.cas_number": "CAS-nummer",
            "chemical.inventory.chemical_formula": "Kemisk formel",
            "chemical.inventory.molecular_weight": "Molekylvikt",
            "chemical.inventory.purity": "Renhet",
            "chemical.inventory.physical_state": "Fysiskt tillstånd",
            "chemical.inventory.color": "Färg",
            "chemical.inventory.odor": "Lukt",
            "chemical.inventory.hazard_statements": "Faroangivelser",
            "chemical.inventory.precautionary_statements": "Skyddsangivelser",
            "chemical.inventory.signal_word": "Signalord",
            "chemical.inventory.first_aid": "Första hjälpen",
            "chemical.inventory.personal_protection": "Personlig skyddsutrustning",
            "chemical.inventory.version": "Version",
            "chemical.inventory.status": "Status",
            "chemical.inventory.last_review_date": "Senaste granskning",
            "chemical.inventory.next_review_date": "Nästa granskning",
            "chemical.inventory.hms_level.1": "Låg risk",
            "chemical.inventory.hms_level.2": "Medelrisk",
            "chemical.inventory.hms_level.3": "Hög risk",
            "chemical.inventory.hms_level.4": "Kritisk risk",
            "chemical.inventory.status.active": "Aktiv",
            "chemical.inventory.status.inactive": "Inaktiv",
            "chemical.inventory.status.archived": "Arkiverad",
            "chemical.inventory.document_type.safety_data_sheet": "Säkerhetsdatablad",
            "chemical.inventory.load_error": "Kunde inte läsa kemikalieförteckningen",
            "chemical.inventory.sds_attach_error": "Ämnet skapades, men säkerhetsdatabladet kopplades inte. Öppna ämnet och ladda upp SDS.",
            "chemical.inventory.deleted": "Kemikalieförteckningen togs bort",
            "chemical.inventory.delete_error": "Kunde inte ta bort kemikalieförteckningen",
            "chemical.inventory.delete_confirm": "Är du säker på att du vill ta bort detta ämne?",
            "chemical.inventory.list_subtitle": "Översikt över kemikalier och ämnen (ISO 14001, ISO 45001)",
            "chemical.inventory.filters": "Filter",
            "chemical.inventory.filter_by_status": "Filtrera efter status",
            "chemical.inventory.no_brand": "Inget märke",
            "chemical.inventory.view": "Visa",
            "chemical.inventory.showing": "Visar",
            "chemical.inventory.of": "av",
            "chemical.inventory.results": "resultat",
            "chemical.inventory.previous": "Föregående",
            "chemical.inventory.next": "Nästa",
            "chemical.inventory.not_specified": "Inte angivet",
            "chemical.inventory.review_state.overdue": "Förfallen",
            "chemical.inventory.review_state.due_soon": "Snart",
            "chemical.inventory.review_state.ok": "I tid",
            "chemical.inventory.reviewed_by": "Granskad av",
            "chemical.inventory.open": "Öppna",
            "chemical.inventory.actions": "Åtgärder",
            "chemical.inventory.pdf": "Ladda ner PDF",
            "chemical.inventory.pdf_ready": "PDF nedladdad",
            "chemical.inventory.pdf_failed": "Kunde inte ladda ner PDF",
            "chemical.inventory.revisions": "Revisioner",
            "chemical.inventory.new_revision": "Ny revision",
            "chemical.inventory.publish_review": "Publicera granskning",
            "chemical.inventory.change_summary": "Ändringssammanfattning",
            "chemical.inventory.change_summary_required": "Ändringssammanfattning krävs",
            "chemical.inventory.revision_created": "Ny revision skapades",
            "chemical.inventory.revision_create_error": "Kunde inte skapa revision",
            "chemical.inventory.review_published": "Granskning publicerades",
            "chemical.inventory.review_publish_error": "Kunde inte publicera granskning",
            "chemical.inventory.history_empty": "Ingen historik ännu",
            "chemical.inventory.revision": "Revision",
            "chemical.inventory.revision_line": "Revision {{version}} · nästa granskning {{date}}",
            "chemical.inventory.next_review_missing": "inte satt",
            "chemical.inventory.added_from_product": "Produkten lades till i kemikalieförteckningen",
            "chemical.inventory.add_from_product_error": "Kunde inte lägga till i kemikalieförteckningen",
            "chemical.inventory.adding": "Lägger till…",
            "chemical.inventory.created_for_product": "Kemikalieförteckning skapad",
            "chemical.inventory.view_details": "Visa detaljer",
            "chemical.inventory.handbook_card": "Kemikalier, farosymboler och SDS",
            "chemical.inventory.sds_download": "Ladda ner säkerhetsdatablad",
            "chemical.inventory.sds_missing": "Ingen SDS tillgänglig",
            "chemical.inventory.risk_tab.register": "Riskregister",
            "chemical.inventory.risk_tab.matrix": "Riskmatris",
            "chemical.inventory.risk_tab.sja": "SJA",
            "chemical.inventory.risk_tab.climate": "Klimatrisk",
            "chemical.inventory.risk_tab.protective": "Skyddsrundor",
            "chemical.inventory.hazard.category.physical": "Fysiska faror",
            "chemical.inventory.hazard.category.health": "Hälsofaror",
            "chemical.inventory.hazard.category.environmental": "Miljöfaror",
            "chemical.inventory.hazard.explosive": "Explosiv",
            "chemical.inventory.hazard.explosive_desc": "Kan explodera vid värme, stöt, friktion eller kontakt med andra ämnen",
            "chemical.inventory.hazard.flammable": "Brandfarlig",
            "chemical.inventory.hazard.flammable_desc": "Kan antändas av flamma, gnista, värme eller annan tändkälla",
            "chemical.inventory.hazard.oxidizing": "Oxiderande",
            "chemical.inventory.hazard.oxidizing_desc": "Kan orsaka eller intensifiera brand vid kontakt med brännbara material",
            "chemical.inventory.hazard.corrosive": "Frätande",
            "chemical.inventory.hazard.corrosive_desc": "Kan orsaka allvarliga brännskador på hud och ögon",
            "chemical.inventory.hazard.toxic": "Giftig",
            "chemical.inventory.hazard.toxic_desc": "Kan orsaka allvarlig skada eller död vid förtäring, inandning eller hudkontakt",
            "chemical.inventory.hazard.harmful": "Skadlig",
            "chemical.inventory.hazard.harmful_desc": "Kan orsaka skada vid förtäring, inandning eller hudkontakt",
            "chemical.inventory.hazard.irritant": "Irriterande",
            "chemical.inventory.hazard.irritant_desc": "Kan orsaka hudirritation eller ögonskada",
            "chemical.inventory.hazard.environmental": "Miljöfarlig",
            "chemical.inventory.hazard.environmental_desc": "Kan skada vattenmiljö eller andra miljöer",
            "chemical.inventory.settings.title": "Inställningar för kemikalieförteckning",
            "chemical.inventory.settings.intro": "Styr vem som ser förteckningen, vem som är ansvarig och revisionsintervall.",
            "chemical.inventory.settings.visibility": "Synlighet för anställda",
            "chemical.inventory.settings.visibility_choose": "Välj synlighet",
            "chemical.inventory.settings.visibility_all_active": "Alla aktiva anställda",
            "chemical.inventory.settings.visibility_hse_roles_only": "Endast HMS-roller",
            "chemical.inventory.settings.responsible": "Ansvariga",
            "chemical.inventory.settings.responsible_empty": "Ingen ansvarig vald",
            "chemical.inventory.settings.choose_responsible": "Välj ansvariga",
            "chemical.inventory.settings.review_interval": "Standardintervall för revision (månader)",
            "chemical.inventory.settings.sds_stale": "SDS föråldras efter (månader)",
            "chemical.inventory.settings.require_sds": "Kräv säkerhetsdatablad",
            "chemical.inventory.settings.auto_create": "Skapa automatiskt från produkter",
            "chemical.inventory.settings.review_reminder": "Påminnelse om granskning",
            "chemical.inventory.settings.saved": "Inställningarna sparades",
            "chemical.inventory.settings.save_error": "Kunde inte spara inställningarna",
            "chemical.inventory.settings.load_error": "Kunde inte läsa inställningarna",
            "company_guide.chemical_inventory.heading": "Uppstart kemikalieförteckning",
            "company_guide.chemical_inventory.subtitle": "Sätt ansvarig, synlighet och revisionsintervall innan ni använder förteckningen.",
            "company_guide.chemical_inventory.loading": "Laddar…",
            "company_guide.chemical_inventory.load_error": "Kunde inte läsa inställningarna.",
            "company_guide.chemical_inventory.link.settings": "Öppna inställningar",
            "company_guide.chemical_inventory.task.responsible.title": "Ansvarig",
            "company_guide.chemical_inventory.task.responsible.warn": "Ingen ansvarig är vald",
            "company_guide.chemical_inventory.task.responsible.ok": "Ansvarig är satt",
            "company_guide.chemical_inventory.task.visibility.title": "Synlighet",
            "company_guide.chemical_inventory.task.visibility.warn": "Synlighet för anställda är inte vald",
            "company_guide.chemical_inventory.task.visibility.ok": "Synlighet är satt",
            "company_guide.chemical_inventory.task.interval.title": "Revisionsintervall",
            "company_guide.chemical_inventory.task.interval.warn": "Revisionsintervall saknas",
            "company_guide.chemical_inventory.task.interval.ok": "Revisionsintervall är satt",
            "dashboard.company_guide.alert_chemical_title": "Kemikalieförteckningen saknar uppstart",
            "dashboard.company_guide.alert_chemical_subtitle": "{{count}} uppgifter kvar",
            "user_guide.chemical_inventory.title": "Kemikalieförteckning",
            "user_guide.chemical_inventory.badge": "Företagsinställning",
            "user_guide.chemical_inventory.back_to_hub": "Tillbaka till användarguiden",
            "user_guide.chemical_inventory.purpose": "Checklista för ansvar, synlighet och revision av kemikalier.",
            "user_guide.chemical_inventory.section.why.title": "Varför detta är viktigt",
            "user_guide.chemical_inventory.section.why.p1": "Kemikalieförteckningen ger anställda farosymboler, första hjälpen och SDS. Sätt ansvarig och synlighet så att listan hålls uppdaterad.",
            "user_guide.hub.card.chemical_inventory.title": "Kemikalieförteckning",
            "user_guide.hub.card.chemical_inventory.description": "Ansvar, synlighet och revisionsintervall för kemikalier.",
      
            // HSE Event Form - Additional translations
            "Hendelsesdato": "Händelsedatum",
            "Hendelsestid": "Händelsetid",
            "Involverte personer beskrivelse":
              "Lista alla personer involverade i händelsen",
            "Vitner beskrivelse": "Lista eventuella vittnen till händelsen",
            "Umiddelbar årsak beskrivelse":
              "Beskriv den omedelbara orsaken till händelsen",
            "Underliggende årsak beskrivelse":
              "Beskriv den underliggande orsaken till händelsen",
            "Kategorisering beskrivelse": "Beskriv kategoriseringen mer detaljerat",
            "Årsakanalyse beskrivelse": "Beskriv orsaksanalysen",
            "Strakstiltak beskrivelse": "Beskriv omedelbara åtgärder som vidtogs",
            "Forslag til tiltak beskrivelse":
              "Beskriv förslag till åtgärder för att förhindra återkommande",
            "Tilknyttede elementer beskrivelse":
              "Länka till relaterade kunder, projekt, anställda och mappar",
            "Dokumenter beskrivelse": "Ladda upp relevanta dokument och filer",
            "Velg avdeling": "Välj avdelning",
            "Velg involverte personer": "Välj involverade personer",
            "Andre involverte personer": "Andra involverade personer",
            "Andre involverte personer beskrivelse":
              "Beskriv andra personer involverade i händelsen",
            "Beskriv andre involverte personer...":
              "Beskriv andra involverade personer...",
            "Søk etter personer...": "Sök efter personer...",
            "personer valgt": "personer valda",
            "Ingen personer funnet": "Inga personer hittades",
            "Valgte personer": "Valda personer",
            "Ingen personer tilgjengelig": "Inga personer tillgängliga",
            "Fjern alle": "Ta bort alla",
            "Legg til person": "Lägg till person",
            "Personer": "Personer",
            "Søk i personer...": "Sök bland personer...",
            "Velg personer": "Välj personer",
            "Ingen personer valgt": "Inga personer valda",
            "Personer valgt": "Personer valda",
            "Bekreft": "Bekräfta",
      
            // HSE Action Form translations
            "Korrigerende tiltak": "Corrective Action",
            "Forebyggende tiltak": "Preventive Action",
            "Type tiltak": "Action Type",
            "Prioritet": "Priority",
            "Lav": "Low",
            "Medium": "Medium",
            "Høy": "High",
            "Kritisk": "Critical",
            "Venter": "Pending",
            "Under arbeid": "In Progress",
            "Fullført": "Completed",
            "Kansellert": "Cancelled",
            "Frist": "Due Date",
            "Kostnadsestimat": "Cost Estimate",
            "Implementeringsnotater": "Implementation Notes",
            "Tiltak ble opprettet": "Action was created",
            "Kunne ikke opprette tiltak": "Could not create action",
      
            // Departments translations - Norwegian
            "Avdelinger": "Avdelinger",
            "Ny avdeling": "Ny avdeling",
            "Rediger avdeling": "Rediger avdeling",
            "Søk i avdelinger...": "Søk i avdelinger...",
            "Filtrer avdelinger": "Filtrer avdelinger",
            "Alle avdelinger": "Alle avdelinger",
            "Ingen avdelinger": "Ingen avdelinger",
            "Kom i gang ved å opprette en ny avdeling.": "Kom i gang ved å opprette en ny avdeling.",
            "Navn": "Navn",
            "Nummer": "Nummer",
            "Synkronisert": "Synkronisert",
            "Ikke synkronisert": "Ikke synkronisert",
            "Aktiv": "Aktiv",
            "Inaktiv": "Inaktiv",
            "Rediger": "Rediger",
            "Avbryt": "Avbryt",
      
            // Report admin menu (Norwegian)
            "report.admin.title": "Admin",
            "report.admin.status": "Rapportstatus",
            "report.admin.status_desc": "Under prosess, prosessert, fakturert",
            "report.admin.reset": "Reset",
            "report.admin.reset_desc": "Nullstill rapport-moduler",
            "report.admin.view_main_report": "Vis hovedrapport",
            "report.admin.view_sequel": "Gå til oppfølger",
            "report.admin.view_case": "Vis sak",
            "report.admin.create_case": "Opprett sak",
            "report.admin.create_case_desc": "Opprett eller knytt sak for oppfølging av rapport",
            "report.admin.case_dialog_title": "Oppfølging av rapport",
            "report.admin.create_sequel": "Opprett oppfølger",
            "report.admin.create_sequel_desc": "Opprett ny rapport som oppfølger",
            "report.admin.create_order": "Skapa order",
            "report.admin.create_order_desc": "Skapa en order från denna rapport (timmar, mil, rader)",
            "report.admin.open_mentions": "Åpne sak hvor rapport er nevnt",
            "report.admin.open_mentions_desc": "Se saker og notater som nevner rapporten",
            "report.admin.mentions_dialog_title": "Rapport nevnt i",
            "report.admin.mentioned_at": "Nevnt",
            "report.admin.no_mentions": "Rapporten er ikke nevnt andre steder",

            "report.dev.title": "Dev",
            "report.dev.variables_v2": "Variabler V2",
            "report.dev.variables_v2_desc": "Redigera rapportvariabler (grupperad editor)",

            "report.variables.legacy.headingOnly": "Variabler",
            "report.variables.legacy.headingTagged": "Variabler (äldre)",
            "report.variables.legacy.saving": "Sparar...",
            "report.variables.legacy.save": "Spara variabler",
            "report.variables.orphaned.title": "Ofullständiga huvudvariabler",
            "report.variables.orphaned.body":
              "Dessa är markerade som huvudvariabler men saknar typgrupp. Koppla till en typgrupp eller ta bort dem.",
            "report.variables.ungrouped.heading": "Variabler utan grupp",
            "report.variables.groups.heading": "Grupper",
            "report.variables.newSystem.title": "Variabler",
            "report.variables.createTypeGroup": "Skapa typgrupp",
            "report.variables.createGroup": "Skapa grupp",
            "report.variables.sketch.tablist": "Variabler (skiss)",
            "report.variables.sketch.groupTablist": "Grupper och översikt",
            "report.variables.sketch.navGroupLabel": "Grupp",
            "report.variables.sketch.navVariableTypeLabel": "Variabeltyp",
            "report.variables.sketch.typeTablist": "Variabeltyper",
            "report.variables.sketch.noTypesInGroup": "Inga variabeltyper här ännu.",
            "report.variables.sketch.ungroupedTab": "Utan grupp",
            "report.variables.sketch.ungroupedTabSub": "{{count}} variabeltyper",
            "report.variables.sketch.pickVariableType": "Välj en variabeltyp i flikraden ovan.",
            "report.variables.sketch.addGroup": "Lägg till grupp",
            "report.variables.sketch.groupNoTypes": "Inga typgrupper",
            "report.variables.sketch.unitsNotSet": "Mätenhet ej satt",
            "report.variables.sketch.untitledGroup": "Utan namn",
            "report.variables.sketch.measureLabel": "Mät",
            "report.variables.sketch.projectedShort": "Proj.",
            "report.variables.sketch.variableTypeFallback": "Variabeltyp",
            "report.variables.sketch.tabOrphaned": "Ofullständiga",
            "report.variables.sketch.tabOrphanedSub": "{{count}} huvudvariabler",
            "report.variables.sketch.tabLegacySub": "Äldre format",
            "report.variables.sketchTab.legacy": "Äldre",
            "report.variables.sketch.emptyAll":
              "Inga grupper eller fria variabeltyper ännu. Använd knapparna ovan.",
            "report.variables.sketch.groupTabEmpty":
              "Inga typgrupper i denna flik ännu. Lägg till huvudvariabel.",
            "report.variables.sketch.editGroup": "Redigera grupp",
            "report.variables.sketch.addMainVariable": "Huvudvariabel",
            "report.variables.sketch.addAnotherMainVariable": "Lägg till ny huvudvariabel i gruppen",
            "report.variables.sketch.typeGroupUngrouped": "Typgrupp (utan grupp)",
            "report.variables.sketch.deleteGroupAria": "Ta bort grupp",
            "report.variables.sketch.structureMenuTrigger": "Grupp och struktur",
            "report.variables.sketch.structureMenuAria": "Grupp och struktur — fler åtgärder",
            "report.variables.sketch.deleteGroupMenu": "Ta bort grupp",
            "report.variables.sketch.addVariable": "Lägg till variabel",
            "report.variables.sketch.addBulkVariables": "Lägg till variabler i bulk",
            "report.variables.sketch.editTypeGroupAria": "Redigera variabeltyp",
            "report.variables.sketch.deleteTypeGroupAria": "Ta bort variabeltyp",
            "report.variables.sketch.typeGroupMoreAria": "Fler åtgärder för variabeltypen",
            "report.variables.sketch.editTypeGroupMenu": "Redigera variabeltyp",
            "report.variables.sketch.deleteTypeGroupMenu": "Ta bort variabeltyp",
            "report.variables.sketch.measurements": "Mätningar",
            "report.variables.sketch.editVariable": "Redigera",
            "report.variables.sketch.editVariableAria": "Redigera variabel",
            "report.variables.sketch.deleteVariable": "Ta bort",
            "report.variables.sketch.deleteVariableAria": "Ta bort variabel",
            "report.variables.sketch.variableRowMenuAria": "Åtgärder för variabel",
            "report.variables.sketch.noSubvariablesYet": "Inga variabler ännu",
            "report.variables.sketch.actionSheetClose": "Stäng",
            "report.variables.sketch.openVariableActionsAria": "Visa åtgärder för variabel",
            "report.variables.sketch.variableActionsTitle": "Variabel",
            "report.variables.sketch.variableActionsHint": "Välj en åtgärd nedan.",
            "report.variables.sketch.rowProjected": "Projicerat:",
            "report.variables.sketch.rowPreMeasurement": "Före mätning:",
            "report.variables.sketch.rowMeasured": "Mätt:",
            "report.variables.sketch.globalTotalsHeading": "Summa per variabeltyp (alla grupper)",
            "report.variables.sketch.globalStatTotalLabel": "Summa",
            "report.variables.sketch.globalSumProjected": "Proj. (totalt)",
            "report.variables.sketch.globalSumPre": "För-mätning (totalt)",
            "report.variables.sketch.globalSumMeasured": "Mätt (totalt)",
            "report.variables.sketch.tabSumProjected": "Σ Proj.",
            "report.variables.sketch.tabSumPre": "Σ För",
            "report.variables.sketch.tabSumMeasured": "Σ Mätt",
            "report.variables.sketch.cardTotalPrefix": "TOTAL",
            "report.variables.sketch.totalsProjRow": "Proj. totalt",
            "report.variables.sketch.totalsPreRow": "För totalt",
            "report.variables.sketch.totalsMeasRow": "Mätt totalt",
            "report.variables.sketch.newGroup": "Ny grupp",
            "report.variables.sketch.typeGroupShort": "Typgrupp",
            "report.variables.sketch.tableColVariable": "Variabel",
            "report.variables.sketch.tableColProj": "Proj.",
            "report.variables.sketch.tableColPre": "För",
            "report.variables.sketch.tableColMeas": "Mätt",
            "report.variables.sketch.tableColLsSuffix": "(l/s)",
            "report.variables.sketch.bulkAddShort": "Bulk-add",
            "report.variables.sketch.fabNoType": "Skapa en typgrupp innan du lägger till variabler.",
            "report.variables.sketch.statusMeasuredOnly": "Mätt",
            "report.variables.sketch.statusGood": "Bra",
            "report.variables.sketch.statusCheck": "Kontrollera",
            "report.variables.sketchEditor.statusMeasured": "Mätt",
            "report.variables.sketchEditor.statusGood": "Bra matchning",
            "report.variables.sketchEditor.statusGoodSub": "Mätt värde ligger inom acceptabelt intervall",
            "report.variables.sketchEditor.statusCheck": "Kontrollera avvikelse",
            "report.variables.sketchEditor.statusCheckSub": "Mätt avviker mer än 15 % från projicerat",
            "report.variables.sketchEditor.refRequired": "Referens krävs",
            "report.variables.sketchEditor.saveError": "Kunde inte spara",
            "report.variables.sketchEditor.measureError": "Kunde inte spara mätning",
            "report.variables.sketchEditor.saved": "Sparat",
            "report.variables.sketchEditor.noGroup": "Utan grupp",
            "report.variables.sketchEditor.measuredActual": "Mätt (faktiskt)",
            "report.variables.sketchEditor.cancel": "Avbryt",
            "report.variables.sketchEditor.saving": "Sparar…",
            "report.variables.sketchEditor.saveChanges": "Spara ändringar",
            "report.variables.sketchEditor.deleteSubvariable": "Ta bort undervariabel",
            "report.variables.sketchEditor.deleteSubvariableHint":
              "Endast denna undervariabel tas bort. Huvudvariabeln och typgruppen finns kvar.",
            "report.variables.sketchEditor.deleteSubvariableConfirm":
              "Ta bort undervariabeln «{{reference}}»? Mätningar och värden raderas permanent.",
            "report.variables.sketchEditor.subvariableDeleted": "Undervariabel borttagen",
            "report.variables.sketchEditor.subvariableDeleteError": "Kunde inte ta bort variabeln",
            "report.variables.sketchEditor.deleteSubvariableCancel": "Avbryt",
            "report.variables.sketchEditor.deleteSubvariableWorking": "Tar bort…",
            "report.variables.sketchEditor.deleteSubvariableConfirmAction": "Ta bort permanent",
            "report.variables.sketchEditor.measuredHint":
              "Uppdaterar senaste mätning vid sparning. Använd ”Lägg till mätning” nedan för fler mätpunkter.",
            "report.variables.sketchEditor.addMeasurementHeading": "Lägg till ny mätning",
            "report.variables.sketchEditor.addMeasurementValue": "Mätvärde",
            "report.variables.sketchEditor.addMeasurementButton": "Lägg till",
            "report.variables.sketchEditor.addingMeasurement": "Lägger till…",
            "report.variables.sketchEditor.measurementAdded": "Mätning tillagd",
            "report.variables.sketchEditor.measurementInvalid": "Ange ett giltigt mätvärde",
            "report.variables.sketchEditor.historyHeading": "Mätningshistorik ({{count}})",
            "report.variables.sketchEditor.historyLoading": "Laddar mätningar…",
            "report.variables.sketchEditor.historyEmpty": "Inga mätningar registrerade",
            "report.variables.sketchEditor.historyLoadError": "Kunde inte ladda mätningar",
            "report.variables.sketchEditor.historyColValue": "Värde",
            "report.variables.sketchEditor.historyColDate": "Datum/tid",
            "report.variables.sketchEditor.tabMeasurements": "Mätningar",
            "report.variables.sketchEditor.tabDetails": "Värden",
            "report.variables.sketchEditor.tabsAria": "Variabelredigerare – flikar",
            "report.variables.sketchEditor.measurementsIntro": "Lägg till ett mätvärde eller bläddra i historiken.",
            "report.variables.sketchEditor.detailsIntro": "Referens och fält som sparas tillsammans.",
            "report.variables.sketchEditor.goToDetails": "Redigera referens och övriga värden →",
            "report.variables.sketchEditor.close": "Stäng",
            "report.variables.sketchEditor.addMeasurementPlaceholder": "Värde",
            "report.variables.sketchEditor.measuredHintDetails":
              "Uppdaterar senaste mätning om du sparar ett nytt värde här. Nya mätpunkter läggs till under Mätningar.",
            "report.variables.measurementDialog.title": "Mätningar",
            "report.variables.measurementDialog.variableFallback": "Variabel",
            "report.variables.measurementDialog.contextHeading": "Underlag",
            "report.variables.measurementDialog.reference": "Referens",
            "report.variables.measurementDialog.measurementUnit": "Mätenhet",
            "report.variables.measurementDialog.projectedUnit": "Projicerad enhet",
            "report.variables.measurementDialog.projectedLabel": "Projicerat",
            "report.variables.measurementDialog.preMeasurementLabel": "Före mätning",
            "report.variables.measurementDialog.latestHeading": "Senaste mätning",

            // Cases list - new view (Norwegian)
            "Use list view": "Bruk listevisning",
            "Use new view": "Bruk ny visning",
            "Switch to classic list view": "Bytt til klassisk listevisning",
            "Switch to compact editable table view": "Bytt til kompakt redigerbar tabellvisning",
            "Status updated": "Status oppdatert",
            "Could not update status": "Kunne ikke oppdatere status",
            "Due date updated": "Frist oppdatert",
            "Could not update due date": "Kunne ikke oppdatere frist",
            "Priority updated": "Prioritet oppdatert",
            "Could not update priority": "Kunne ikke oppdatere prioritet",
            "Last update": "Siste oppdatering",
            "No updates yet": "Ingen oppdateringer ennå",
            "Add update": "Legg til oppdatering",
            "Write an update...": "Skriv en oppdatering...",
            "Gå til bruker": "Gå til bruker",
            "Bruker": "Bruker",
            "Ansatt": "Ansatt",
            "Update added": "Oppdatering lagt til",
            "Could not add update": "Kunne ikke legge til oppdatering",
            "Open case": "Åpne sak",
            "View full": "Vis full",
            "No title": "Mangler tittel",
            "Case type": "Sakstype",
            "Labels": "Etiketter",
            "No labels defined": "Ingen etiketter definert",
            "Statistics": "Statistikk",
            "Cases by label": "Saker per etikett",
            "No labels with cases yet": "Ingen etiketter med saker ennå",
            "Label administration": "Etikettadministrasjon",
            "All modules": "Alle moduler",
            "Cases": "Ärenden",
            "Projects": "Projekt",
            "Customers": "Kunder",
            "Customer List": "Kundlista",
            "Tasks": "Uppgifter",
            "Add label": "Legg til etikett",
            "Scope module": "Modul",
            "Sort order": "Sortering",
            "Name is required": "Navn er påkrevd",
            "Are you sure you want to delete this label?": "Er du sikker på at du vil slette denne etiketten?",
            "Lagrer...": "Lagrer...",
            "Oppretter...": "Oppretter...",
            "Lagre endringer": "Lagre endringer",
            "Opprett avdeling": "Opprett avdeling",
            "Navn er påkrevd": "Navn er påkrevd",
            "Kunne ikke laste avdelinger": "Kunne ikke laste avdelinger",
            "Avdeling opprettet": "Avdeling opprettet",
            "Kunne ikke opprette avdeling": "Kunne ikke opprette avdeling",
            "Avdeling oppdatert": "Avdeling oppdatert",
            "Kunne ikke oppdatere avdeling": "Kunne ikke oppdatere avdeling",
            "avdelinger valgt": "avdelinger valgt",
            "avdeling valgt": "avdeling valgt",

            // Microsoft / Outlook
            "microsoft.explain.title": "Vad innebär anslutningen?",
            "microsoft.explain.company.1":
              "Kopplar företagets huvudmejl (t.ex. post@foretag.se) till Microsoft så att Promang kan läsa och hantera inkommande mejl för ärenden.",
            "microsoft.explain.company.2":
              "Ger underlag för att skapa och uppdatera ärenden från mejltrådar.",
            "microsoft.explain.company.3":
              "Kräver administratörsbehörighet och samtycke i Microsoft för den valda inkorgen.",
            "microsoft.explain.company.4":
              "Hemligheter och tokenutbyte sker endast i Promang API — inte i webbläsaren.",
            "microsoft.explain.company.5":
              "Att skicka mejl och AI-funktioner mot företagsmejl kommer när lagring av tokens är klar på servern.",
            "microsoft.explain.user.1":
              "Kopplar ditt eget Microsoft- / Outlook-konto till Promang-användaren du är inloggad som.",
            "microsoft.explain.user.2":
              "Gör det möjligt att skicka mejl från din adress där det är aktiverat i Promang, och att använda AI/kontext från din mejl.",
            "microsoft.explain.user.3":
              "Du måste vara inloggad i Promang innan du klickar «Anslut Microsoft».",
            "microsoft.explain.user.4":
              "Mejladressen i Microsoft bör matcha din användare där det är praktiskt möjligt.",
            "microsoft.explain.user.5":
              "Du kan när som helst koppla från under Inställningar eller på sidan Microsoft / Outlook.",
            "microsoft.company.page_title": "Microsoft — företagsmejl",
            "microsoft.company.page_subtitle": "Koppla företagets huvudmejl (admin).",
            "microsoft.company.card_title": "Företagsmejl (Microsoft 365)",
            "microsoft.company.subtitle": "För gemensam inkorg och ärenden för företagets räkning.",
            "microsoft.user.page_title": "Microsoft / Outlook",
            "microsoft.user.page_subtitle": "Koppla ditt Microsoft-konto till denna Promang-användare.",
            "microsoft.user.card_title": "Ditt Outlook-konto",
            "microsoft.user.subtitle":
              "Mejl skickas från ditt konto när det stöds; ger också kontext till AI och ärenden.",
            "microsoft.user.settings_section_title": "Microsoft / Outlook",
            "microsoft.user.settings_section_intro":
              "Koppla Microsoft till kontot du är inloggad med. Detta är inte samma som «Logga in med Microsoft» på inloggningssidan — du stannar i Promang och ger åtkomst till mejl för funktioner i instrumentpanelen.",
            "user.settings.signature.section_title": "Signatur",
            "user.settings.signature.section_hint":
              "Används när du signerar offerter, avtal och andra dokument.",
            "user.settings.signature.empty": "Ingen signatur uppladdad",
            "user.settings.signature.preview_alt": "Din signatur",
            "user.settings.signature.remove": "Ta bort signatur",
            "user.settings.signature.saved": "Signatur sparad",
            "user.settings.signature.save_error": "Kunde inte spara signatur",
            "offers.setup_prompt.dismiss": "Gör senare",
            "offers.setup_prompt.signature.title": "Ladda upp din signatur",
            "offers.setup_prompt.signature.body":
              "Rekommenderas för offerter: ladda upp signatur under användarinställningar så den kan användas på dokument och PDF.",
            "offers.setup_prompt.signature.body_force":
              "Signatur saknas. Ladda upp den innan du signerar eller exporterar PDF.",
            "offers.setup_prompt.signature.cta": "Öppna inställningar",
            "offers.setup_prompt.admin.title": "Företagets offertinställningar",
            "offers.setup_prompt.admin.body":
              "{{count}} rekommenderade offertinställningar saknas eller är avstängda.",
            "offers.setup_prompt.admin.cta": "Öppna offertinställningar",
            "microsoft.user.open_full_page": "Öppna egen sida för anslutning",
            "microsoft.user.calendar_heading": "Kalender för händelser",
            "microsoft.user.calendar_intro":
              "Alla kalendrar du kan öppna i Outlook för detta konto visas (egna och delade). Välj var Promang ska skapa händelser. Använd sök om du har många kalendrar.",
            "microsoft.user.calendar_refresh": "Hämta kalendrar",
            "microsoft.user.calendar_need_refresh":
              "Anslut Microsoft med refresh-token (fullständig koppling) för att hämta kalendrar.",
            "microsoft.user.calendar_select_label": "Kalender",
            "microsoft.user.calendar_none": "Ingen vald",
            "microsoft.user.calendar_choose": "Sök …",
            "microsoft.user.calendar_modal_title": "Välj kalender",
            "microsoft.user.calendar_modal_close": "Stäng",
            "microsoft.user.calendar_modal_hint":
              "Sök på namn eller ägarens e-post. Delade kalendrar märks; skrivskyddade kan inte sparas för händelsesynk.",
            "microsoft.user.calendar_search_placeholder": "Sök kalendrar …",
            "microsoft.user.calendar_search_empty": "Inga kalendrar matchar sökningen.",
            "microsoft.user.calendar_modal_empty": "Microsoft returnerade inga kalendrar.",
            "microsoft.user.calendar_badge_own": "Din",
            "microsoft.user.calendar_badge_shared": "Delad",
            "microsoft.user.calendar_badge_readonly": "Skrivskyddad",
            "microsoft.user.calendar_readonly_hint":
              "Den här kalendern är skrivskyddad i Microsoft. Välj en du kan redigera för att synka händelser.",
            "microsoft.user.calendar_readonly_save":
              "Kan inte spara en skrivskyddad kalender för händelser. Välj en kalender du kan redigera.",
            "microsoft.user.calendar_current": "Tidigare vald: {{name}}{{email}}",
            "microsoft.user.calendar_save": "Spara kalender",
            "microsoft.user.calendar_saved": "Kalender sparad.",
            "microsoft.user.calendar_save_failed": "Kunde inte spara kalender.",
            "microsoft.user.calendar_load_failed": "Kunde inte hämta kalendrar.",
            "microsoft.user.personal_mail_ai.title": "Din brevlåda — AI-regler och bearbetning",
            "microsoft.user.personal_mail_ai.intro":
              "Konfigurera sortering, manuella regler, AI-routning och kör bearbetning för din länkade Microsoft-brevlåda — samma alternativ som delade företagsinkorgar. Ärenden och kunder skapas i aktuellt företag.",
            "microsoft.user.personal_mail_ai.no_permission":
              "Din roll inkluderar inte personlig inkorg-AI. Be en administratör tilldela rollen «microsoft_personal_mail_ai» för detta företag eller ge dig adminåtkomst.",
            "microsoft.user.personal_mail_ai.forbidden_toast": "Du har inte behörighet till dessa inställningar.",
            "microsoft.user.personal_mail_ai.load_failed": "Kunde inte hämta inställningar för e-post-AI.",
            "microsoft.user.personal_mail_ai.no_refresh":
              "Anslut Microsoft med refresh-token (full e-postlänk) för att läsa meddelanden och köra bearbetning.",
            "microsoft.user.personal_mail_ai.connect_first":
              "Anslut Microsoft ovan för att konfigurera regler, AI-routning och bearbetning för din egen brevlåda.",
            "microsoft.status.loading": "Läser in status…",
            "microsoft.status.api_pending":
              "API för att spara tokens rullas fortfarande ut. Du kan fortfarande slutföra inloggning hos Microsoft; kontakta administratör om något misslyckas.",
            "microsoft.status.connected": "Ansluten",
            "microsoft.action.disconnect": "Koppla från",
            "microsoft.action.connect_microsoft": "Anslut Microsoft",
            "microsoft.action.redirect_hint":
              "Du skickas till Microsoft för att godkänna åtkomst, sedan tillbaka till Promang.",
            "microsoft.toast.login_required": "Du måste vara inloggad i Promang för att koppla.",
            "microsoft.toast.missing_env": "Microsoft är inte konfigurerat på servern.",
            "microsoft.toast.start_failed": "Kunde inte starta Microsoft-anslutning.",
            "microsoft.toast.disconnected": "Frånkopplad.",
            "microsoft.toast.disconnect_failed": "Kunde inte koppla från.",
            "microsoft.callback.working": "Slutför anslutning…",
            "microsoft.callback.error_microsoft": "Microsoft avbröt eller misslyckades.",
            "microsoft.callback.missing_params": "Saknar code eller state från Microsoft.",
            "microsoft.callback.success_login": "Inloggad med Microsoft.",
            "microsoft.callback.success_link": "Microsoft-kontot är anslutet.",
            "microsoft.callback.api_not_ready": "API är inte redo för detta steg ännu.",
            "microsoft.callback.exchange_failed": "Kunde inte slutföra anslutningen.",
            "microsoft.callback.unknown_intent": "Okänd anslutningstyp.",
            "microsoft.callback.title": "Microsoft och Promang",
            "microsoft.callback.subtitle_loading":
              "Slutför säker anslutning. Det tar vanligtvis några sekunder.",
            "microsoft.callback.success_title": "Anslutning klar",
            "microsoft.callback.error_title": "Något gick fel",
            "microsoft.callback.redirecting_note": "Skickar dig tillbaka till Promang …",
            "microsoft.callback.continue_now": "Gå till Promang nu",
            "microsoft.callback.back_to_promang": "Tillbaka till Promang",
            "microsoft.callback.back_to_login": "Tillbaka till inloggning",
            "microsoft.callback.debug_heading": "Teknisk detalj (felsökning)",
            "microsoft.callback.wait_hint": "Stäng inte den här fliken medan vi slutför.",
            "microsoft.login.or": "eller",
            "microsoft.login.redirecting": "Omdirigerar…",
            "microsoft.login.with_microsoft": "Logga in med Microsoft",
            // Login page (split-screen design + loading system)
            "auth.login.title": "Logga in",
            "auth.login.subtitle": "Använd ditt arbetskonto för att fortsätta.",
            "auth.login.email_label": "E-post",
            "auth.login.email_placeholder": "namn@foretag.se",
            "auth.login.password_label": "Lösenord",
            "auth.login.show_password": "Visa lösenord",
            "auth.login.hide_password": "Dölj lösenord",
            "auth.login.remember_me": "Kom ihåg mig",
            "auth.login.forgot_password": "Glömt lösenord?",
            "auth.login.submit": "Logga in",
            "auth.login.submitting": "Loggar in …",
            "auth.login.success": "Inloggad",
            "auth.login.email_required": "E-post krävs",
            "auth.login.email_invalid": "Måste vara en giltig e-post",
            "auth.login.password_required": "Lösenord krävs",
            "auth.login.brand_heading": "Projekt, planer och team — samlade.",
            "auth.login.brand_subtitle": "Plattformen som håller hela organisationen i takt.",
            "auth.login.brought_by": "Brought to you by",
            "auth.boot.initializing": "Förbereder arbetsytan",
            "auth.boot.syncing": "Synkroniserar dina moduler",
            "auth.boot.securing": "Upprättar säker anslutning",
            "auth.boot.finalizing": "Slutför — nästan klart",
            "auth.boot.secure_session": "säker session",
            "auth.session_expired.title": "Sessionen har gått ut",
            "auth.session_expired.message":
              "Av säkerhetsskäl loggades du ut. Logga in igen för att fortsätta där du slutade.",
            "auth.session_expired.login": "Logga in igen",
            "auth.session_expired.cancel": "Avbryt",
            "microsoft.test_mail.button": "Skicka testmejl till mig själv",
            "microsoft.test_mail.hint":
              "Skickar ett meddelande från den kopplade inkorgen till samma adress, för att verifiera Mail.Send och token.",
            "microsoft.test_mail.success": "Testmejl skickat. Kontrollera inkorgen.",
            "microsoft.test_mail.failed": "Kunde inte skicka testmejl.",
            "microsoft.callback.promang_session_required": "Din Promang-session kunde inte verifieras. Logga in i Promang och starta Microsoft-anslutningen igen.",
    "microsoft.ai_mailboxes.connection.checking": "Kontrollerar Microsoft-åtkomst …",
    "microsoft.ai_mailboxes.connection.available": "Microsoft-åtkomsten är kontrollerad. Sändningsbehörighet kontrolleras vid sändning.",
    "microsoft.ai_mailboxes.connection.reauth_required": "Microsoft-åtkomsten har upphört eller återkallats. Anslut igen.",
    "microsoft.ai_mailboxes.connection.access_denied": "Ingen åtkomst till brevlådan. Kontrollera behörigheterna i Microsoft 365 och anslut med rätt konto.",
    "microsoft.ai_mailboxes.connection.unavailable": "Kunde inte kontrollera åtkomst. Försök igen senare.",
    "microsoft.ai_mailboxes.connection.disconnected": "Microsoft är inte anslutet.",
    "microsoft.ai_mailboxes.connection.reconnect": "Anslut Microsoft igen",
    "microsoft.ai_mailboxes.connection.check": "Kontrollera åtkomst",
    "microsoft.ai_mailboxes.connection.test_accepted": "Microsoft har accepterat testmeddelandet för sändning. Leveransen är inte bekräftad.",
    "microsoft.ai_mailboxes.connection.unknown": "Resultatet är okänt. Kontrollera brevlådan innan du skickar ett nytt test. Inget automatiskt nytt försök görs.",
    "microsoft.ai_mailboxes.title": "Delade inkorgar för AI",
            "microsoft.ai_mailboxes.admin_page_title": "Delade inkorgar (Microsoft 365)",
            "microsoft.ai_mailboxes.admin_page_subtitle":
              "Registrera delade adresser, koppla Microsoft, visa inkorg och ställ in hur e-post ska hanteras (sortering, ärenden, arkiv, autosvar, signatur, regler). Behandling och valfri flytt till Archive/Arkiv körs när jobbet är på eller du använder «Kör behandling» (inte simulering).",
            "microsoft.ai_mailboxes.intro":
              "Registrera delade adresser (t.ex. post@, service@). Varje inkorg måste kopplas till Microsoft så att Promang kan läsa inkorgen och skicka test via Graph.",
            "microsoft.ai_mailboxes.how_link_works":
              "Logga in som dig själv (t.ex. du@foretag.se) — inte som den delade adressen. Delade postlådor (t.ex. post@…) har oftast inget eget lösenord. Använd ett konto som redan kan öppna den delade inkorgen i Outlook (full åtkomst / delegat). Promang sparar refresh-token för inloggningen; Graph läser/skickar för adressen på raden.",
            "microsoft.ai_mailboxes.mail_safety_dev_notice":
              "Med **Arkivera efter hantering** på flyttar Promang hanterade meddelanden till mappen **Archive** eller **Arkiv** (Graph), även i utveckling — bara när behandling körs med riktiga åtgärder (inte simulering). Annars läser vi inkorgen för visning. «Kör behandling», schemalagt jobb och test kan skicka e-post (t.ex. vidarebefordran) via Graph — använd «Simulera jobb» för att testa utan utskick och utan flytt.",
            "microsoft.ai_mailboxes.linked_as": "Microsoft kopplat som {{email}}",
            "microsoft.ai_mailboxes.not_linked": "Inte kopplat till Microsoft — koppla för att läsa inkorg och skicka test.",
            "microsoft.ai_mailboxes.connect_microsoft": "Anslut Microsoft",
            "microsoft.ai_mailboxes.disconnect_microsoft": "Koppla från Microsoft",
            "microsoft.ai_mailboxes.send_test": "Skicka testmejl",
            "microsoft.ai_mailboxes.go_to_mailbox": "Gå till postlåda",
            "microsoft.ai_mailboxes.go_to_mailbox_hint":
              "Öppnar Outlook på webben för denna adress i en ny flik (mappar: inkorg, arkiv m.m.). Du måste vara inloggad i Microsoft i webbläsaren med ett konto som har åtkomst till postlådan.",
            "microsoft.ai_mailboxes.go_to_mailbox_missing_email": "Ingen postadress att öppna.",
            "microsoft.ai_mailboxes.multi_inbox_hint":
              "Du kan ha flera inkorgar öppna samtidigt. Öppna ett meddelande i Promang för att läsa innehåll och se behandlingslogg i flikar.",
            "microsoft.ai_mailboxes.reader.title": "Meddelande (Promang)",
            "microsoft.ai_mailboxes.reader.close": "Stäng",
            "microsoft.ai_mailboxes.reader.tab_message": "Innehåll",
            "microsoft.ai_mailboxes.reader.tab_reply_draft": "AI svarutkast",
            "microsoft.ai_mailboxes.reader.tab_logs": "Behandlingslogg",
            "microsoft.ai_mailboxes.reader.reply_draft_hint":
              "Redigerar utkastets brödtext i Outlook (HTML). Vid skickning behålls tråden under din text.",
            "microsoft.ai_mailboxes.reader.reply_draft_load_failed": "Kunde inte läsa svarutkast.",
            "microsoft.ai_mailboxes.reader.reply_draft_saved": "Utkast sparat.",
            "microsoft.ai_mailboxes.reader.reply_draft_save": "Spara utkast",
            "microsoft.ai_mailboxes.reader.reply_draft_saving": "Sparar…",
            "microsoft.ai_mailboxes.reader.reply_draft_none": "Inget AI svarutkast för detta meddelande.",
            "microsoft.ai_mailboxes.reader.field_from": "Från",
            "microsoft.ai_mailboxes.reader.field_to": "Till",
            "microsoft.ai_mailboxes.reader.field_cc": "Kopia",
            "microsoft.ai_mailboxes.reader.field_date": "Mottaget",
            "microsoft.ai_mailboxes.reader.attachments_notice":
              "Meddelandet har bilagor. Filer visas inte här — använd Outlook på webben om du behöver ladda ner.",
            "microsoft.ai_mailboxes.reader.body_iframe_title": "E-postinnehåll",
            "microsoft.ai_mailboxes.reader.no_body": "Inget innehåll.",
            "microsoft.ai_mailboxes.reader.load_failed": "Kunde inte läsa meddelandet.",
            "microsoft.ai_mailboxes.reader.inbox_only_hint":
              "Listan visar bara inkorg. För arkiv, skräppost och andra mappar, använd Outlook på webben (länk nedan) vid behov.",
            "microsoft.ai_mailboxes.reader.folder_hint":
              "Du kan välja Arkiv, Skickat och andra mappar i postlådelistan ovan. Använd Outlook på webben (länk nedan) för full mapphantering vid behov.",
            "microsoft.ai_mailboxes.reader.open_in_owa": "Öppna postlåda i Outlook på webben…",
            "microsoft.ai_mailboxes.reader.open_short": "Öppna",
            "microsoft.ai_mailboxes.reader.open_tooltip":
              "Öppna i Promang: läs e-post och se behandlingslogg (flikar).",
            "microsoft.ai_mailboxes.show_inbox": "E-postmappar",
            "microsoft.ai_mailboxes.inbox_requires_link": "Anslut Microsoft för denna adress först.",
            "microsoft.ai_mailboxes.no_messages": "Inga meddelanden i denna mapp (eller mappen är tom).",
            "microsoft.ai_mailboxes.messages_failed": "Kunde inte läsa meddelanden för denna mapp.",
            "microsoft.ai_mailboxes.process_folder_hint":
              "Markera meddelanden nedan och simulera eller kör behandling. Det schemalagda jobbet behandlar fortfarande bara inkorgen om du inte ändrar det separat.",
            "microsoft.ai_mailboxes.folder.select_label": "Mapp",
            "microsoft.ai_mailboxes.folder.group_shortcuts": "Genvägar",
            "microsoft.ai_mailboxes.folder.group_tree": "Alla mappar",
            "microsoft.ai_mailboxes.folder.loading_tree": "Läser in mappar…",
            "microsoft.ai_mailboxes.folder.folders_failed": "Kunde inte läsa mappar.",
            "microsoft.ai_mailboxes.folder.seg_inbox": "Inkorg",
            "microsoft.ai_mailboxes.folder.seg_archive": "Arkiv",
            "microsoft.ai_mailboxes.folder.seg_sentitems": "Skickat",
            "microsoft.ai_mailboxes.folder.seg_deleteditems": "Borttaget",
            "microsoft.ai_mailboxes.folder.seg_junkemail": "Skräppost",
            "microsoft.ai_mailboxes.folder.seg_drafts": "Utkast",
            "microsoft.ai_mailboxes.folder.seg_outbox": "Utkorg",
            "microsoft.ai_mailboxes.col.received": "Mottagen",
            "microsoft.ai_mailboxes.col.from": "Från",
            "microsoft.ai_mailboxes.col.subject": "Ämne",
            "microsoft.ai_mailboxes.microsoft_disconnected": "Microsoft frånkopplat för denna inkorg.",
            "microsoft.ai_mailboxes.microsoft_disconnect_failed": "Kunde inte koppla från Microsoft.",
            "microsoft.ai_mailboxes.shared_test_ok": "Testmejl skickat.",
            "microsoft.ai_mailboxes.shared_test_failed": "Kunde inte skicka testmejl.",
            "microsoft.ai_mailboxes.email_label": "E-postadress",
            "microsoft.ai_mailboxes.email_placeholder": "post@foretag.se",
            "microsoft.ai_mailboxes.add": "Lägg till",
            "microsoft.ai_mailboxes.empty": "Inga adresser tillagda ännu.",
            "microsoft.ai_mailboxes.remove": "Ta bort",
            "microsoft.ai_mailboxes.added": "Adressen har lagts till.",
            "microsoft.ai_mailboxes.add_failed": "Kunde inte lägga till adressen.",
            "microsoft.ai_mailboxes.removed": "Adressen har tagits bort.",
            "microsoft.ai_mailboxes.remove_failed": "Kunde inte ta bort adressen.",
            "microsoft.ai_mailboxes.load_failed": "Kunde inte läsa in adresser.",
            "microsoft.ai_mailboxes.email_required": "Ange en e-postadress.",
            "microsoft.ai_mailboxes.settings.toggle": "Inställningar",
            "microsoft.ai_mailboxes.settings.heading": "E-posthantering",
            "microsoft.ai_mailboxes.settings.intro":
              "Dessa val gäller endast denna postlåda. Inkorgslistan använder sortering från Graph direkt efter sparning.",
            "microsoft.ai_mailboxes.settings.processing_job_title": "Jobb: behandla inkorg",
            "microsoft.ai_mailboxes.settings.processing_job_hint":
              "När «På» sparas kan schemalagd körning (t.ex. Heroku Scheduler + `rake microsoft:enqueue_ai_mailbox_processing`) behandla upp till 50 senaste meddelanden och köra regler (inkl. vidarebefordran som textavisering). Testa säkert med «Simulera jobb» i inkorgslistan.",
            "microsoft.ai_mailboxes.settings.processing_job_off": "Av",
            "microsoft.ai_mailboxes.settings.processing_job_on": "På",
            "microsoft.ai_mailboxes.settings.mail_sort": "Sortering i inkorg",
            "microsoft.ai_mailboxes.settings.sort_received_desc": "Nyast först",
            "microsoft.ai_mailboxes.settings.sort_received_asc": "Äldst först",
            "microsoft.ai_mailboxes.settings.sort_subject_asc": "Ämne A–Ö",
            "microsoft.ai_mailboxes.settings.auto_create_case": "Skapa ärende för ny e-post (när aktiverat i Promang)",
            "microsoft.ai_mailboxes.settings.auto_create_case_hint":
              "När funktionen släpps används undantagen nedan för att undvika ärenden från reklam, nyhetsbrev m.m.",
            "microsoft.ai_mailboxes.settings.skip_promotional_hint": "Markera sannolik reklam/nyhetsbrev som inte ska bli ärende (rekommenderas)",
            "microsoft.ai_mailboxes.settings.ignore_subject_keywords": "Skapa inte ärende om ämnet innehåller (komma eller radbrytning)",
            "microsoft.ai_mailboxes.settings.ignore_subject_placeholder": "t.ex. reklam, unsubscribe, newsletter",
            "microsoft.ai_mailboxes.settings.ignore_from_domains": "Skapa inte ärende om avsändardomän är (komma eller radbrytning)",
            "microsoft.ai_mailboxes.settings.ignore_domains_placeholder": "t.ex. mailchimp.com, sendgrid.net",
            "microsoft.ai_mailboxes.settings.archive_after_processing": "Arkivera efter hantering",
            "microsoft.ai_mailboxes.settings.archive_hint":
              "Flyttar hanterad e-post från inkorg till **Archive** eller **Arkiv** via Microsoft Graph efter lyckad hantering (manuell regel eller AI). Gäller även utveckling — kräver att behandling körs med riktiga åtgärder, inte «Simulera jobb».",
            "microsoft.ai_mailboxes.settings.auto_reply_enabled": "Automatiskt svar efter nytt ärende (kundförfrågan)",
            "microsoft.ai_mailboxes.settings.auto_reply_body_ph":
              "HTML-innehåll (valfritt). Platshållare: %{case_number}, %{sak}. Tomt fält ger standardtext med ärendenummer.",
            "microsoft.ai_mailboxes.settings.auto_reply_note":
              "När autosvar är på svarar Promang i samma e-posttråd (Graph reply), inte som nytt meddelande. Svarsraden får [SAK-<nummer>]. Signatur HTML läggs till om den är satt.",
            "microsoft.ai_mailboxes.settings.signature_html": "Signatur (HTML)",
            "microsoft.ai_mailboxes.settings.signature_ph": "<p>Med vänliga hälsningar<br/>…</p>",
            "microsoft.ai_mailboxes.settings.rules_heading": "Regler",
            "microsoft.ai_mailboxes.settings.rules_intro":
              "Matcha på ämne eller e-postadress och välj Arkivera eller Vidarebefordra (till vald adress). Reglerna körs före AI-routing och ärendeskapande. Äldre matchtyper (innehåller / domän) finns kvar.",
            "microsoft.ai_mailboxes.settings.rules_forward_hint":
              "Vidarebefordran skickar meddelandet till den angivna adressen (samma mönster som «Vidarebefordra okänd post»).",
            "microsoft.ai_mailboxes.settings.add_rule": "Lägg till regel",
            "microsoft.ai_mailboxes.settings.no_rules": "Inga anpassade regler ännu.",
            "microsoft.ai_mailboxes.settings.rule_name": "Namn",
            "microsoft.ai_mailboxes.settings.rule_match": "Match",
            "microsoft.ai_mailboxes.settings.rule_value": "Värde",
            "microsoft.ai_mailboxes.settings.rule_action": "Åtgärd",
            "microsoft.ai_mailboxes.settings.rule_on": "På",
            "microsoft.ai_mailboxes.settings.remove_rule": "Ta bort regel",
            "microsoft.ai_mailboxes.settings.match_subject": "Ämne (innehåller)",
            "microsoft.ai_mailboxes.settings.match_email": "E-post (från-adress)",
            "microsoft.ai_mailboxes.settings.match_subject_contains": "Ämne innehåller",
            "microsoft.ai_mailboxes.settings.match_subject_equals": "Ämne är lika (exakt)",
            "microsoft.ai_mailboxes.settings.match_from_domain": "Från-domän",
            "microsoft.ai_mailboxes.settings.match_from_contains": "Från-adress innehåller",
            "microsoft.ai_mailboxes.settings.action_archive": "Arkivera",
            "microsoft.ai_mailboxes.settings.action_skip_case": "Skapa inte ärende",
            "microsoft.ai_mailboxes.settings.action_forward_to": "Vidarebefordra",
            "microsoft.ai_mailboxes.settings.rule_forward_to_email": "Vidarebefordra till (e-post)",
            "microsoft.ai_mailboxes.settings.rule_forward_to_placeholder": "t.ex. 123@foretag.se",
            "microsoft.ai_mailboxes.settings.save": "Spara inställningar",
            "microsoft.ai_mailboxes.settings.saved": "Inställningar sparade.",
            "microsoft.ai_mailboxes.settings.save_failed": "Kunde inte spara inställningar.",
            "microsoft.ai_mailboxes.settings.ai_routing_heading": "AI-routing",
            "microsoft.ai_mailboxes.settings.ai_routing_hint":
              "Välj vad som ska hända per e-posttyp. Inställningarna sparas som JSON i bakgrunden. När routing är på används OpenAI/Grok (miljövariabler) för klassificering om tillgängligt — annars heuristik. Manuella regler har företräde.",
            "microsoft.ai_mailboxes.settings.ai_routing_invalid_json": "Ogiltig JSON för AI-routing.",
            "microsoft.ai_mailboxes.settings.ai_routing_raw_json": "Redigera som rå JSON (avancerat)",
            "microsoft.ai_mailboxes.settings.ai_routing_raw_json_hint":
              "Formuläret och JSON är likvärdiga. När du stänger av rå JSON läses texten in i formuläret (måste vara giltig JSON).",
            "microsoft.ai_mailboxes.ai_routing.master_enable": "Aktivera AI-routing och automatiska åtgärder",
            "microsoft.ai_mailboxes.ai_routing.master_hint":
              "Av: meddelanden klassificeras fortfarande för visning, men inga automatiska AI-åtgärder körs.",
            "microsoft.ai_mailboxes.ai_routing.reply_draft_title": "AI-utkast för svar (Outlook)",
            "microsoft.ai_mailboxes.ai_routing.reply_draft_desc":
              "Efter lyckad kundförfrågan eller ärendesvar skapas ett svarutkast i din Microsoft-postlåda. Du skickar när du är nöjd.",
            "microsoft.ai_mailboxes.ai_routing.reply_draft_enable": "Skapa AI-genererat svarutkast vid bearbetning",
            "microsoft.ai_mailboxes.ai_routing.reply_draft_requires_ai":
              "Slå på «Aktivera AI-routing» ovan för att använda detta (klassificering och ärende måste köras först).",
            "microsoft.ai_mailboxes.ai_routing.provider_label": "Klassificeringsleverantör",
            "microsoft.ai_mailboxes.ai_routing.provider_chatgpt": "ChatGPT (OpenAI)",
            "microsoft.ai_mailboxes.ai_routing.provider_grok": "Grok (xAI)",
            "microsoft.ai_mailboxes.ai_routing.model_label": "Modell (valfritt)",
            "microsoft.ai_mailboxes.ai_routing.model_placeholder": "t.ex. gpt-4o-mini",
            "microsoft.ai_mailboxes.ai_routing.model_hint": "Tomt = standard från server/miljö.",
            "microsoft.ai_mailboxes.ai_routing.action_label": "Åtgärd",
            "microsoft.ai_mailboxes.ai_routing.action_none": "Ingenting (bara klassificera)",
            "microsoft.ai_mailboxes.ai_routing.action_forward": "Vidarebefordra till e-post",
            "microsoft.ai_mailboxes.ai_routing.action_move_archive": "Flytta till arkivmapp",
            "microsoft.ai_mailboxes.ai_routing.action_move_junk": "Flytta till skräppost",
            "microsoft.ai_mailboxes.ai_routing.action_delete_graph": "Radera i Microsoft (Graph)",
            "microsoft.ai_mailboxes.ai_routing.action_move_folder": "Flytta till vald mapp",
            "microsoft.ai_mailboxes.ai_routing.action_create_case": "Skapa ärende i Promang",
            "microsoft.ai_mailboxes.ai_routing.action_append_case_note": "Lägg till ärendelinje (CAS / ärendenr)",
            "microsoft.ai_mailboxes.ai_routing.action_customer_communication": "Registrera som kundkommunikation på ärende",
            "microsoft.ai_mailboxes.ai_routing.action_reply_draft_only": "Bara logga kommunikation (och AI svarutkast om aktiverat)",
            "microsoft.ai_mailboxes.ai_routing.forward_to_label": "Vidarebefordra till (e-post)",
            "microsoft.ai_mailboxes.ai_routing.folder_optional_label": "Mappnamn (valfritt)",
            "microsoft.ai_mailboxes.ai_routing.folder_optional_hint": "Tomt använder standard (Archive / Junk Email).",
            "microsoft.ai_mailboxes.ai_routing.folder_placeholder_archive": "Archive",
            "microsoft.ai_mailboxes.ai_routing.folder_placeholder_junk": "Junk Email",
            "microsoft.ai_mailboxes.ai_routing.folder_name_label": "Mappens visningsnamn",
            "microsoft.ai_mailboxes.ai_routing.folder_placeholder_order": "Order",
            "microsoft.ai_mailboxes.ai_routing.folder_order_hint": "Mappen måste finnas i Microsoft-postlådan.",
            "microsoft.ai_mailboxes.ai_routing.cat_promotional_title": "Reklam / nyhetsbrev",
            "microsoft.ai_mailboxes.ai_routing.cat_promotional_desc": "Typisk massutsändning.",
            "microsoft.ai_mailboxes.ai_routing.cat_order_title": "Orderbekräftelse",
            "microsoft.ai_mailboxes.ai_routing.cat_order_desc": "Beställningar och orderdokument.",
            "microsoft.ai_mailboxes.ai_routing.cat_inquiry_title": "Ny kundförfrågan",
            "microsoft.ai_mailboxes.ai_routing.cat_inquiry_desc": "Allmän förfrågan utan befintligt ärendenummer i tråden.",
            "microsoft.ai_mailboxes.ai_routing.cat_inquiry_auto_reply_note":
              "Autosvar och signatur ställs in längre upp på sidan.",
            "microsoft.ai_mailboxes.ai_routing.cat_supplier_cas_title": "Leverantör (CAS-referens)",
            "microsoft.ai_mailboxes.ai_routing.cat_supplier_cas_desc":
              "Matchar ärende via CAS-token eller Promang-ärendenummer i innehållet. Fyll i «vid ingen träff».",
            "microsoft.ai_mailboxes.ai_routing.forward_unmatched_label": "Vid ingen träff — vidarebefordra till (e-post)",
            "microsoft.ai_mailboxes.ai_routing.forward_unmatched_hint": "Rekommenderas så mejl inte blir utan ärende.",
            "microsoft.ai_mailboxes.ai_routing.cas_reference_label": "Fast CAS-referens (valfritt)",
            "microsoft.ai_mailboxes.ai_routing.cas_reference_hint": "Bara om referensen inte finns i mejlet.",
            "microsoft.ai_mailboxes.ai_routing.case_number_fallback_label": "Fast ärendenummer (valfritt)",
            "microsoft.ai_mailboxes.ai_routing.case_number_fallback_hint": "Numerisk del, t.ex. 1234, om den inte hittas i text.",
            "microsoft.ai_mailboxes.ai_routing.cat_case_reply_title": "Svar på befintligt ärende",
            "microsoft.ai_mailboxes.ai_routing.cat_case_reply_desc": "Mejl som verkar gälla öppet ärende (SAK-nr i tråden).",
            "microsoft.ai_mailboxes.ai_routing.cat_project_title": "Projektkorrespondens",
            "microsoft.ai_mailboxes.ai_routing.cat_project_desc":
              "Mejl från känd kund/part om framdrift, avvikelser, byggledning m.m. — inte ny generell kundförfrågan.",
            "microsoft.ai_mailboxes.ai_routing.cat_project_reply_draft_note":
              "Kräver att avsändaren matchar en kund i Promang. Aktivera «AI svarutkast» ovan för utkast i Outlook.",
            "microsoft.ai_mailboxes.ai_routing.json_preview_toggle": "Visa JSON som sparas (endast läsning)",
            "microsoft.ai_mailboxes.process_inbox_hint":
              "Välj ett eller flera meddelanden och kör behandling (simulering skickar ingen e-post; «Kör» kan skicka vidarebefordran när en regel matchar).",
            "microsoft.ai_mailboxes.process_select_all": "Välj alla",
            "microsoft.ai_mailboxes.process_clear_selection": "Rensa val",
            "microsoft.ai_mailboxes.process_select_column": "Välj",
            "microsoft.ai_mailboxes.process_select_row": "Välj meddelande",
            "microsoft.ai_mailboxes.process_simulate": "Simulera jobb",
            "microsoft.ai_mailboxes.process_run": "Kör behandling",
            "microsoft.ai_mailboxes.process_need_selection": "Välj minst ett meddelande i listan.",
            "microsoft.ai_mailboxes.process_run_confirm":
              "Detta kan skicka riktig e-post (vidarebefordran) när regler matchar. Fortsätta?",
            "microsoft.ai_mailboxes.process_ok_simulated":
              "Simulering klar för {{count}} meddelande(n). Vidarebefordringsregler som skulle triggats: {{sim}}. «Skapa inte ärende»-träffar: {{skips}}.",
            "microsoft.ai_mailboxes.process_ok_executed":
              "Behandling klar för {{count}} meddelande(n). Vidarebefordran skickad: {{sent}}. «Skapa inte ärende»-träffar: {{skips}}.",
            "microsoft.ai_mailboxes.process_failed": "Kunde inte behandla valda meddelanden.",
            "microsoft.ai_mailboxes.processing_log.open_tooltip": "Visa behandlingslogg (utveckling)",
            "microsoft.ai_mailboxes.processing_log.title": "Behandlingslogg",
            "microsoft.ai_mailboxes.processing_log.close": "Stäng",
            "microsoft.ai_mailboxes.processing_log.load_failed": "Kunde inte läsa behandlingslogg.",
            "microsoft.ai_mailboxes.processing_log.empty":
              "Inga sparade körningar för detta meddelande ännu. Använd Simulera / Kör behandling, eller vänta på schemalagt jobb.",
            "microsoft.ai_mailboxes.processing_log.dry_run": "Simulering",
            "microsoft.ai_mailboxes.processing_log.live_run": "Skarp körning",
            "microsoft.ai_mailboxes.processing_log.failed": "Misslyckades",
            "microsoft.ai_mailboxes.processing_log.ok": "OK",
            "microsoft.ai_mailboxes.processing_log.ai_category": "Klassificering",
            "microsoft.ai_mailboxes.processing_log.confidence": "konfidens",
            "microsoft.ai_mailboxes.processing_log.actions": "Åtgärder",
            "microsoft.ai_mailboxes.processing_log.raw_json": "Rådata (JSON)",
            "microsoft.ai_mailboxes.processing_log.col_dev": "Logg",
            "microsoft.ai_mailboxes.processing_log.sum.ai_classification":
              "AI: {{category}} ({{source}}, konfidens {{confidence}})",
            "microsoft.ai_mailboxes.processing_log.sum.forward_dry": "Vidarebefordran (simulering) → {{to}}",
            "microsoft.ai_mailboxes.processing_log.sum.forward_sent": "Vidarebefordrat → {{to}}",
            "microsoft.ai_mailboxes.processing_log.sum.forward_failed":
              "Vidarebefordran misslyckades → {{to}}: {{error}}",
            "microsoft.ai_mailboxes.processing_log.sum.move_dry": "Flytt (simulering){{target}}",
            "microsoft.ai_mailboxes.processing_log.sum.move_ok": "Flyttat → {{folder}}",
            "microsoft.ai_mailboxes.processing_log.sum.move_failed": "Flytt misslyckades: {{error}}",
            "microsoft.ai_mailboxes.processing_log.sum.skip_case": "Regel: skapa inte ärende",
            "microsoft.ai_mailboxes.processing_log.sum.skip_case_unused": "skip_case (ej tillämpad)",
            "microsoft.ai_mailboxes.processing_log.sum.archive_dry": "Regel: arkivera (simulering)",
            "microsoft.ai_mailboxes.processing_log.sum.archive_ok": "Regel: arkiverad{{folder}}",
            "microsoft.ai_mailboxes.processing_log.sum.archive_failed": "Regel: arkivering misslyckades: {{error}}",
            "microsoft.ai_mailboxes.processing_log.sum.ai_routing_skipped": "AI-routing hoppades över: {{reason}}",
            "microsoft.ai_mailboxes.processing_log.sum.unknown_fallback_sent": "Okänd post vidarebefordrad → {{to}}",
            "microsoft.ai_mailboxes.processing_log.sum.unknown_fallback_dry": "Okänd post vidarebefordran (simulering) → {{to}}",
            "microsoft.ai_mailboxes.processing_log.sum.unknown_fallback_failed": "Okänd post: vidarebefordran misslyckades ({{error}})",
            "microsoft.ai_mailboxes.processing_log.sum.system_copy_forward": "Promang-kopia vidarebefordrad → {{to}}",
            "microsoft.ai_mailboxes.processing_log.sum.system_copy_archive": "Promang-kopia arkiverad{{folder}}",
            "microsoft.ai_mailboxes.processing_log.sum.system_copy_none": "Promang-kopia: ingen åtgärd (inget nytt ärende)",
            "microsoft.ai_mailboxes.processing_log.sum.system_copy_already": "Promang-kopia: redan behandlad",
            "microsoft.ai_mailboxes.processing_log.sum.generic_error": "{{type}}: {{error}}",
            "microsoft.ai_mailboxes.processing_log.sum.generic_not_applied": "{{type}}: ej utförd",
            "subscription.ai_usage.loading": "Laddar…",
            "subscription.ai_usage.title": "AI-användning och uppskattning",
            "subscription.ai_usage.subtitle":
              "Tokenanvändning, vägledande kostnad och uppskattad sparad tid för företaget (endast lyckade AI-anrop).",
            "subscription.ai_usage.period.this_month": "Denna månad",
            "subscription.ai_usage.period.this_year": "Detta år",
            "subscription.ai_usage.period.last_30_days": "Senaste 30 dagarna",
            "subscription.ai_usage.period.last_12_months": "Senaste 12 månaderna",
            "subscription.ai_usage.load_failed": "Kunde inte hämta AI-användningsstatistik.",
            "subscription.ai_usage.forbidden": "Du har inte åtkomst till AI-användning för detta företag.",
            "subscription.ai_usage.empty": "Ingen AI-användning registrerad under perioden.",
            "subscription.ai_usage.tokens": "Tokens (totalt)",
            "subscription.ai_usage.calls_ok": "Lyckade anrop",
            "subscription.ai_usage.calls_fail": "Misslyckade anrop",
            "subscription.ai_usage.estimated_cost": "Uppskattad kostnad (NOK)",
            "subscription.ai_usage.cost_hint":
              "Intern uppskattning: {{rate}} NOK per 1M tokens. Inte en faktura — faktisk leverantörspris kan skilja sig.",
            "subscription.ai_usage.time_saved": "Uppskattad sparad tid",
            "subscription.ai_usage.time_hint":
              "Ungefärliga manuella minuter per lyckat anrop, per funktionstyp. Endast för översikt.",
            "subscription.ai_usage.minutes_only": "{{minutes}} min",
            "subscription.ai_usage.hours_minutes": "{{hours}} h {{minutes}} min",
            "subscription.ai_usage.by_feature": "Per funktion",
            "subscription.ai_usage.col_feature": "Funktion",
            "subscription.ai_usage.col_calls": "Anrop",
            "subscription.ai_usage.col_tokens": "Tokens",
            "subscription.ai_usage.col_cost": "Uppsk. NOK",
            "subscription.ai_usage.col_time": "Uppsk. sparad tid",
            "subscription.ai_usage.monthly_overview": "Per månad (i perioden)",
            "subscription.ai_usage.feature.microsoft_ai_mailbox_classify": "AI-inkorg — klassificering",
            "subscription.ai_usage.feature.microsoft_ai_mailbox_case_title": "AI-inkorg — ärendetitel",
            "subscription.ai_usage.feature.service_report_invoice_description_generate":
              "Servicerapport — fakturapunkter",
            "subscription.ai_usage.feature.service_report_invoice_description_format_report":
              "Servicerapport — HTML-format",
            "subscription.ai_usage.feature.ai_generator_todo": "Uppgifter — AI-assistent",
            "subscription.ai_usage.feature.ai_generator_hse_document": "HMS/KS — AI-fält i dokument",
            "subscription.ai_usage.feature.ai_generator_meeting_minutes": "Mötesprotokoll — AI-agenda",
            "subscription.ai_usage.feature.other": "{{feature}}",

            "todo.pageTitle": "Uppgifter",
            "todo.sidebarTitle": "Todo",
            "todo.settingsTitle": "Uppgiftsinställningar",
            "todo.backToTasks": "Tillbaka till uppgifter",
            "todo.settingsTemplatesTitle": "Mall för delade företagsuppgifter",
            "todo.settingsTemplatesHelp": "Skapa återkommande uppgifter för befattningar eller valda användare. När en mottagare markerar uppgiften som klar avslutas den för alla. Valfri länk till HMS/KS-dokument för rutiner.",
            "todo.settingsTemplatesHelpCompact": "Skapa mallar med titel och HMS-dokument. Expandera för befattningar, mottagare och upprepning.",
            "todo.settingsManagePositions": "Hantera företagsbefattningar",
            "todo.settingsTitlePlaceholder": "T.ex. Gå igenom skyddsrond",
            "todo.settingsAddDescription": "Lägg till beskrivning",
            "todo.settingsShowDetails": "Visa detaljer",
            "todo.settingsHideDetails": "Dölj detaljer",
            "todo.settingsListHint": "Klicka på en mall för att redigera. Sorterad efter kategori och befattning.",
            "todo.settingsUntitled": "Utan titel",
            "todo.settingsNoSummary": "Inga detaljer angivna ännu",
            "todo.settingsEditTemplate": "Redigera mall",
            "todo.settingsNewTemplate": "Ny mall",
            "todo.settingsCompactSummary": "Sammanfattning",
            "todo.settingsNotSet": "Ej angiven",
            "todo.settingsAssigneeCount": "{{count}} mottagare",
            "todo.settingsDueOffsetSummary": "+{{days}} dagar förfall",
            "todo.settingsNoPositionsHint": "Inga företagsbefattningar ännu. Lägg till dem under Företagsinställningar.",
            "todo.settingsDueOffsetDays": "Förfaller (dagar efter skapande)",
            "todo.settingsWorkingPositions": "Befattningar",
            "todo.settingsAssignees": "Mottagare",
            "todo.settingsAddAssignees": "Lägg till användare",
            "todo.settingsHseDocument": "HMS/KS-dokument (valfritt)",
            "todo.settingsTemplateActive": "Mall aktiv",
            "todo.settingsTemplateInactive": "Inaktiv",
            "todo.settingsTemplateInactiveHint": "Denna mall skapar inte nya uppgifter längre.",
            "todo.settingsSpawnNow": "Skapa uppgifter nu",
            "todo.settingsSpawning": "Skapar…",
            "todo.settingsRemoveTemplate": "Ta bort mall",
            "todo.settingsAddTemplate": "Lägg till mall",
            "todo.settingsSave": "Spara inställningar",
            "todo.settingsSaving": "Sparar…",
            "todo.settingsSaved": "Uppgiftsinställningar sparade",
            "todo.settingsLoadError": "Kunde inte ladda uppgiftsinställningar",
            "todo.settingsSaveError": "Kunde inte spara uppgiftsinställningar",
            "todo.confirmClose.title": "Spara ändringar?",
            "todo.confirmClose.text": "Du har osparade ändringar. Vill du spara innan du stänger?",
            "todo.confirmClose.keepEditing": "Fortsätt redigera",
            "todo.confirmClose.closeWithoutSaving": "Stäng utan att spara",
            "todo.confirmClose.saveAndClose": "Spara och stäng",
            "todo.settingsSpawnSuccess": "Delade uppgifter skapade",
            "todo.settingsSpawnError": "Kunde inte skapa uppgifter från mall",
            "todo.sharedTaskLabel": "Delad företagsuppgift",
            "todo.sharedTaskBadge": "Delad",
            "todo.sharedTaskEnabled": "Delad uppgift",
            "todo.sharedTaskDisabled": "Personlig uppgift",
            "todo.sharedTaskActiveBadge": "Delat läge på",
            "todo.sharedTaskActiveHint": "Delat läge är aktiverat. Uppgiften tilldelas valda användare och sparas som företagsmall.",
            "todo.sharedFromTemplateInfo": "Delad företagsuppgift från mall. Status sätts automatiskt och kan inte ändras manuellt.",
            "todo.sharedFromAssigneesInfo": "Delad företagsuppgift eftersom uppgiften har flera mottagare (minst två). Status sätts automatiskt.",
            "todo.taskAssigneesLabel": "Mottagare",
            "todo.taskAssigneesHint": "Lägg till anställda som ska se uppgiften i sin inbox. Med två eller fler mottagare blir uppgiften automatiskt delad företagsuppgift (admin).",
            "todo.propertyInfoAria": "Mer information om {{label}}",
            "todo.createAddAssignees": "Lägg till mottagare",
            "todo.moduleTagsLabel": "Moduler",
            "todo.moduleTagsAdd": "Lägg till modul",
            "todo.systemLinksLabel": "Systemlänkar",
            "todo.mobileNav.ariaLabel": "Uppgiftsmeny",
            "todo.mobileNav.todo": "Todo",
            "todo.mobileNav.today": "Dagens",
            "todo.mobileNav.priority": "Prioritet",
            "todo.mobileNav.newTask": "Ny uppgift",
            "todo.mobileNav.mine": "Mina",
            "todo.mobileNav.journal": "Journal",
            "todo.mobileNav.settings": "Inställningar",
            "todo.sharedTaskDuplicateError": "En liknande delad företagsuppgift finns redan. Ändra titel, HMS-dokument eller mottagare.",
            "todo.sharedTaskDeleteAdminOnly": "Endast företagsadministratör kan ta bort delade företagsuppgifter.",
            "todo.sharedCompletionAny": "Klar när en mottagare slutför",
            "todo.sharedAssigneeCount": "{{count}} mottagare",
            "todo.settingsPositionsTitle": "Befattningar och mottagare",
            "todo.settingsPositionsHelp": "Spara befattningar (t.ex. Administrator) och välj en användare som får alla uppgifter för befattningen. Utan vald användare matchas alla anställda med befattningen.",
            "todo.settingsPositionNamePlaceholder": "Befattningsnamn, t.ex. Administrator",
            "todo.settingsCategoryPlaceholder": "Kategori, t.ex. HMS",
            "todo.settingsAddPosition": "Spara befattning",
            "todo.settingsPositionExists": "Befattningen finns redan",
            "todo.settingsRouteAllTasks": "Alla uppgifter → välj användare",
            "todo.settingsRouteToUser": "Alla uppgifter → {{name}}",
            "todo.settingsClearRoute": "Ta bort routing",
            "todo.settingsCategory": "Kategori",
            "todo.settingsCopyCategoryPositionsHint": "Välj kategori…",
            "todo.settingsCopyCategoryPositions": "Hämta befattningar från kategori",
            "todo.employeePositionsTitle": "Företagsbefattningar",
            "todo.employeePositionsHelp": "Hantera företagsbefattningar under Företagsinställningar. De används i uppgiftsmallar och anställningar.",
            "todo.employeePositionName": "Befattning",
            "todo.employeePositionAdd": "Lägg till befattning",
            "todo.employeePositionRemove": "Ta bort befattning",
            "todo.employeePositionCount": "{{count}} anställda med befattningen",
            "todo.tabTasks": "Uppgifter",
            "todo.filterTodayPlan": "Dagens plan",
            "todo.loadingMoreTodos": "Laddar fler uppgifter…",
            "todo.loadMoreError": "Kunde inte ladda fler uppgifter.",
            "todo.filterAll": "Alla",
            "todo.filterActive": "Aktiva",
            "todo.filterFinished": "Klara",
            "todo.filterMine": "Mina uppgifter",
            "todo.newTask": "Ny uppgift",
            "todo.emptyState": "Inga uppgifter ännu. Tryck",
            "todo.loadError": "Kunde inte ladda uppgifter.",
            "todo.loadingTasks": "Laddar uppgifter…",
            "todo.groupBy": "Gruppera efter",
            "todo.taskCountOne": "uppgift",
            "todo.taskCountOther": "uppgifter",
            "todo.due": "Förfaller",
            "todo.todayPlanBadge": "Dagens plan",
            "todo.taskDetails": "Uppgiftsdetaljer",
            "todo.createTitle": "Ny uppgift",
            "todo.createTitlePlaceholder": "Titel",
            "todo.titleMaxLength": "Max {{max}} tecken (2 rader i listan)",
            "todo.createSubmit": "Skapa uppgift",
            "todo.createSubmitHint": "för att skapa",
            "todo.descriptionLabel": "Beskrivning",
            "todo.addDescription": "Lägg till beskrivning",
            "todo.descriptionAdded": "Beskrivning tillagd",
            "todo.hideDescription": "Dölj",
            "todo.descriptionPlaceholder": "Lägg till beskrivning…",
            "todo.propertiesLabel": "Egenskaper",
            "todo.statusLabel": "Status",
            "todo.priorityLabel": "Prioritet",
            "todo.moduleLabel": "Modul",
            "todo.moduleKind.project": "Projekt",
            "todo.moduleKind.customer": "Kund",
            "todo.moduleKind.tag": "Etikett",
            "todo.moduleKind.shared": "Delad",
            "todo.peopleLabel": "Personer",
            "todo.linksLabel": "Länkar",
            "todo.statusTimeline": "Status-tidslinje",
            "todo.activityLabel": "Aktivitet",
            "todo.deleteTask": "Ta bort uppgift",
            "todo.priorityUrgent": "Brådskande",
            "todo.priorityHigh": "Hög",
            "todo.priorityMed": "Medium",
            "todo.priorityLow": "Låg",
            "todo.statusDoing": "Pågår",
            "todo.statusTodo": "Att göra",
            "todo.statusDone": "Klar",
            "todo.reopen": "Öppna igen",
            "todo.markDone": "Markera som klar",
            "todo.setDate": "Välj datum",
            "todo.remindMe": "Påminn mig",
            "todo.toggleOn": "På",
            "todo.toggleOff": "Av",
            "todo.untitledTask": "Uppgift utan titel",
            "todo.hasDescription": "Har beskrivning",
            "todo.hasReminder": "Har påminnelse",
            "todo.lockedAbsence": "Uppgiften är kopplad till frånvaro som måste godkännas eller avslås först.",
            "todo.lockedItemList": "Denna varulisteuppgift måste slutföras i varuhantering.",
            "todo.customerLink": "Kund",
            "todo.projectLink": "Projekt",
            "todo.absenceLink": "Frånvaro",
            "todo.itemListLink": "Varulista",
            "todo.activityWhoUser": "Användare",
            "todo.activityEmpty": "Ingen aktivitet ännu.",
            "todo.activityCreated": "skapade uppgiften",
            "todo.activityFinished": "slutförde uppgiften",
            "todo.activityUpdated": "uppdaterade uppgiften",
            "todo.toastCreated": "Uppgift skapad",
            "todo.toastCreateFailed": "Kunde inte skapa uppgift",
            "todo.toastUpdateFailed": "Kunde inte spara ändringar",
            "todo.toastDeleted": "Uppgift borttagen",
            "todo.toastDeleteFailed": "Kunde inte ta bort uppgift",
            "todo.toastStatusFailed": "Kunde inte uppdatera status",
            "todo.nextDueTitle": "Uppgiften är försenad",
            "todo.nextDueHint": "Nästa förfallodatum räknas från idag, inte från det gamla förfallna datumet. Justera datumet om du vill.",
            "todo.nextDueLabel": "Nästa förfallodatum",
            "todo.nextDueConfirm": "Slutför och sätt datum",
            "todo.confirmDelete": "Ta bort denna uppgift?",
            "todo.dateToday": "Idag",
            "todo.dateTomorrow": "Imorgon",
            "todo.dateNextWeek": "Nästa vecka",
            "todo.dateInThreeDays": "Om 3 dagar",
            "todo.reminderInOneHour": "Om 1 timme",
            "todo.reminderThisEvening": "I kväll",
            "todo.reminderTomorrowMorning": "Imorgon bitti",
            "todo.reminderNextWeekMorning": "Nästa vecka (mån 09:00)",
            "todo.dateCustom": "Anpassat",
            "todo.clear": "Rensa",
            "todo.dateTimeToday": "Idag, {{time}}",
            "todo.dateTimeDaysAgo": "för {{count}} d sedan",
            "todo.dueDate": "Förfallodatum",
            "todo.reminder": "Påminnelse",
            "todo.onTodayPlan": "På dagens plan",
            "todo.recurrence": "Upprepa vid slutförande",
            "todo.recurrenceNone": "Ingen",
            "todo.recurrenceDaily": "Dagligen",
            "todo.recurrenceWeekdays": "Vardagar",
            "todo.recurrenceWeekly": "Veckovis",
            "todo.recurrenceMonthly": "Månadsvis",
            "todo.estimatedHours": "Uppskattade timmar",
            "todo.labels": "Etiketter",
            "todo.aiAssistant": "AI-assistent",
            "todo.hoursAvailable": "Timmar tillgängliga idag (för dagsplan)",
            "todo.aiSuggestions": "Förslag",
            "todo.aiEstimate": "Tidsestimat",
            "todo.aiPlan": "Dagsplan",
            "todo.aiResultTitle": "AI-resultat",
            "todo.aiLoading": "Genererar…",
            "todo.aiError": "Kunde inte hämta AI-förslag.",
            "todo.hseDocumentTaskManualFinish":
              "HMS/KS-dokumentuppgifter slutförs genom att bekräfta att dokumentet är läst och förstått.",
            "todo.hseDocumentTaskComplete":
              "Slutför här för att bekräfta att du har läst och förstått dokumentet.",
            "todo.hseDocumentTaskCannotReopen":
              "HMS/KS-dokumentuppgifter kan inte öppnas igen från att-göra-listan.",
            "todo.hseDocumentOpenLink": "Öppna HMS/KS-dokument",
            "hse.document.acknowledge_read": "Jag bekräftar att jag har läst och förstått",
            "hse.document.acknowledge_read_submitting": "Registrerar…",
            "hse.document.acknowledge_read_success": "Registrerat som läst/förstått",
            "hse.document.acknowledge_read_error": "Kunde inte registrera läst/förstått",
            "hse.document.acknowledge_read_hint":
              "När du har gått igenom innehållet, bekräfta här. Uppgiften i att-göra-listan slutförs automatiskt.",
            "hse.document.acknowledge_read_done": "Du är registrerad som att ha läst och förstått denna version.",
            "hse.document.approval_stuck_retry_hint":
              "Godkänningen verkar ha stannat innan versionen publicerades. Klicka på «Godkänn version» igen för att slutföra.",
            "hse.document.file_missing": "Bifogad fil kunde inte hittas.",
            "hse.document.file_processing": "Filen bearbetas fortfarande. Försök igen om en stund.",
            "hse.document.file_failed": "Filuppladdningen misslyckades. Ladda upp dokumentet igen.",
            "hse.document.open_file": "Öppna fil",
            "hse.document.download_file": "Ladda ner fil",
            "hse.document.attached_file": "Bifogad fil",
            "hse.upload.save_first": "Spara först för att ladda upp dokument.",
            "hse.documents.json.open_dialog": "JSON / AI",
            "hse.documents.json.dialog_title": "HMS/KS-dokument — JSON och AI",
            "hse.documents.json.tab_json": "Klistra in JSON",
            "hse.documents.json.tab_ai_guide": "AI-instruktioner",
            "hse.documents.json.hint":
              "Klistra in JSON från AI eller redigera manuellt. Skapar dokument som utkast och kan skapa ny Bransch, Kategori och Kapitel vid behov.",
            "hse.documents.json.current_structure": "Nuvarande Bransch / Kategori / Kapitel",
            "hse.documents.json.existing_documents": "Befintliga dokument (duplicera inte)",
            "hse.documents.json.loading_documents": "laddar…",
            "hse.documents.json.copy_json": "Kopiera JSON",
            "hse.documents.json.copy_success": "JSON kopierad",
            "hse.documents.json.reload_blank": "Töm mall",
            "hse.documents.json.reload_success": "Tom mall laddad",
            "hse.documents.json.insert_sample": "Infoga exempel",
            "hse.documents.json.apply": "Importera till Promang",
            "hse.documents.json.importing": "Importerar…",
            "hse.documents.json.imported":
              "Importerat: {{documents}} dokument, {{chapters}} kapitel, {{categories}} kategorier, {{disciplines}} branscher",
            "hse.documents.json.import_failed": "Import misslyckades",
            "hse.documents.json.clipboard_failed": "Kunde inte kopiera till urklipp",
            "hse.documents.json.ai_guide_intro":
              "Kopiera instruktionerna nedan till ChatGPT, Claude eller annan AI. Klistra sedan in JSON-svaret under fliken Klistra in JSON. Instruktionen visar företagets nuvarande kapitel.",
            "hse.documents.json.copy_ai_guide": "Kopiera AI-instruktioner",
            "hse.documents.json.ai_guide_copied": "AI-instruktioner kopierade",
            "hse.documents.json.generate_with_ai": "Generera med AI",
            "hse.documents.json.ai_parse_error": "Kunde inte läsa AI-svar som JSON",
            "hse.documents.json.ai_apply_success": "{{count}} dokument inlagda från AI — kontrollera och importera",
            "hse.documents.json.error_empty": "JSON är tom",
            "hse.documents.json.error_invalid_json": "Ogiltig JSON",
            "hse.documents.json.error_invalid_shape": "Ogiltig JSON-struktur",
            "hse.documents.json.error_no_valid_items": "Inga giltiga dokument eller struktur i JSON",
            "hse.documents.json.error_too_many_documents": "För många dokument (max 50)",
            "hse.documents.json.create_missing": "Skapa saknad Bransch/Kategori/Kapitel",
            "hse.documents.json.create_missing_hint":
              "Av som standard — återanvänd befintlig struktur. Aktivera bara vid behov.",
            "hse.documents.json.atomic": "Atomisk import (rulla tillbaka vid fel)",
            "hse.documents.json.dropped_rows":
              "{{count}} rad(er) hoppades över före import: {{detail}}",
            "hse.documents.json.result_title": "Importresultat",
            "hse.documents.json.result_hint":
              "Utkast syns inte alltid i listan för icke-admin — öppna via länkarna nedan.",
            "hse.documents.json.result_no_docs": "Inga dokument skapades (endast struktur eller fel).",
            "hse.digest.hub_tab": "Veckovis HMS-e-post",
            "hse.digest.title": "Veckovis HMS-e-post",
            "hse.digest.hub_intro":
              "Skicka en veckovis översikt över nya händelser, nya HMS/KS-dokument och olästa dokument. Av som standard.",
            "hse.digest.load_failed": "Kunde inte läsa inställningar för HMS-e-post",
            "hse.digest.saved": "Inställningar sparade",
            "hse.digest.save_failed": "Kunde inte spara inställningar för HMS-e-post",
            "hse.digest.enabled.title": "Veckovis utskick",
            "hse.digest.enabled.description":
              "När detta är på får berörda användare ett e-postmeddelande på vald veckodag och klockslag (Europe/Oslo).",
            "hse.digest.enabled.toggle": "Skicka veckovis HMS-e-post",
            "hse.digest.schedule.title": "Tidpunkt",
            "hse.digest.schedule.description": "E-posten skickas en gång per vecka på vald dag och timme.",
            "hse.digest.weekday": "Veckodag",
            "hse.digest.weekday.sunday": "Söndag",
            "hse.digest.weekday.monday": "Måndag",
            "hse.digest.weekday.tuesday": "Tisdag",
            "hse.digest.weekday.wednesday": "Onsdag",
            "hse.digest.weekday.thursday": "Torsdag",
            "hse.digest.weekday.friday": "Fredag",
            "hse.digest.weekday.saturday": "Lördag",
            "hse.digest.hour": "Klockslag",
            "hse.digest.timezone": "Tidszon",
            "hse.digest.timezone_value": "Europe/Oslo",
            "hse.digest.last_sent": "Senast skickad {{date}}",
            "hse.digest.last_sent_never": "Inte skickad ännu",
            "hse.digest.content.title": "Innehåll",
            "hse.digest.content.intro": "E-posten kan innehålla dessa avsnitt. Tomma avsnitt utelämnas.",
            "hse.digest.content.events": "Nya händelser",
            "hse.digest.content.documents": "Nya dokument",
            "hse.digest.content.unread": "Dokument du inte har läst",
            "hse.document_read_overview.title": "Läst / förstått",
            "hse.document_read_overview.subtitle":
              "Översikt över vem som har bekräftat att de har läst och förstått HMS/KS-dokument.",
            "hse.document_read_overview.back_to_documents": "Tillbaka till dokument",
            "hse.document_read_overview.summary_pending": "Saknar bekräftelse",
            "hse.document_read_overview.summary_acknowledged": "Läst och bekräftad",
            "hse.document_read_overview.summary_documents": "Dokument",
            "hse.document_read_overview.summary_employees": "Anställda",
            "hse.document_read_overview.search": "Sök",
            "hse.document_read_overview.search_placeholder": "Sök efter anställd, e-post eller dokument…",
            "hse.document_read_overview.filter_document": "Dokument",
            "hse.document_read_overview.all_documents": "Alla dokument",
            "hse.document_read_overview.filter_all": "Alla",
            "hse.document_read_overview.filter_pending": "Saknar bekräftelse",
            "hse.document_read_overview.filter_acknowledged": "Läst och bekräftad",
            "hse.document_read_overview.filter_exempt": "Undantagen",
            "hse.document_read_overview.view_employees": "Anställda",
            "hse.document_read_overview.view_documents": "Dokument",
            "hse.document_read_overview.empty": "Inga träffar",
            "hse.document_read_overview.col_employee": "Anställd",
            "hse.document_read_overview.col_pending": "Saknas",
            "hse.document_read_overview.col_acknowledged": "Bekräftad",
            "hse.document_read_overview.unknown_user": "Okänd användare",
            "hse.document_read_overview.former_employee": "Tidigare anställd",
            "hse.document_read_overview.unknown_document": "Okänt dokument",
            "hse.document_read_overview.col_document": "Dokument",
            "hse.document_read_overview.status_acknowledged": "Läst och bekräftad",
            "hse.document_read_overview.status_exempt": "Författare (undantagen)",
            "hse.document_read_overview.status_pending": "Saknar bekräftelse",
            "hse.document_read_overview.filter_employee": "Anställd",
            "hse.document_read_overview.filter_status": "Status",
            "hse.document_read_overview.filter_acknowledged_from": "Bekräftad från",
            "hse.document_read_overview.filter_acknowledged_to": "Bekräftad till",
            "hse.document_read_overview.print_action": "Exportera PDF",
            "hse.document_read_overview.print_title": "Läst / förstått per användare",
            "hse.document_read_overview.print_dialog_title": "Exportera översikt per användare",
            "hse.document_read_overview.print_dialog_intro":
              "Välj vilka rader som ska tas med. Listan grupperas per anställd och laddas ner som PDF.",
            "hse.document_read_overview.print_scope": "Omfattning",
            "hse.document_read_overview.print_scope_pending": "Endast inte läst/förstått",
            "hse.document_read_overview.print_scope_acknowledged": "Endast läst/bekräftad",
            "hse.document_read_overview.print_scope_all": "Alla",
            "hse.document_read_overview.print_submit": "Ladda ner PDF",
            "hse.document_read_overview.print_cancel": "Avbryt",
            "hse.document_read_overview.print_empty": "Inga rader att exportera med valt filter.",
            "hse.document_read_overview.print_generated_at": "Genererad {{date}}",
            "hse.document_read_overview.print_col_date": "Datum",
            "hse.dashboard.title": "HMS & KS",
            "hse.dashboard.subtitle": "Översikt över KPI, uppgifter, aviseringar och senaste händelser",
            "hse.dashboard.kpi.title": "KPI-översikt",
            "hse.dashboard.kpi.events": "Händelser",
            "hse.dashboard.kpi.deviations": "Avvikelser",
            "hse.dashboard.kpi.unread_docs": "Olästa dokument",
            "hse.dashboard.kpi.unread_docs.info":
              "Godkända HMS/KS-dokument som du inte har bekräftat som lästa och förstådda. Författare är undantagna.",
            "hse.dashboard.kpi.unread_docs.info_aria": "Så räknas olästa dokument",
            "hse.dashboard.kpi.open_actions": "Öppna åtgärder",
            "hse.dashboard.kpi.open_actions.info":
              "Åtgärder som inte är slutförda eller avbrutna. Öppna händelsen för att följa upp.",
            "hse.dashboard.kpi.open_actions.info_aria": "Så räknas öppna åtgärder",
            "hse.dashboard.kpi.overdue": "Förfallen",
            "hse.dashboard.kpi.overdue.info":
              "Åtgärder med deadline före idag som inte är slutförda.",
            "hse.dashboard.kpi.overdue.info_aria": "Så räknas förfallna åtgärder",
            "hse.dashboard.tasks.title": "Mina uppgifter",
            "hse.dashboard.tasks.empty": "Inga öppna uppgifter just nu.",
            "hse.dashboard.tasks.kind.action": "Åtgärd",
            "hse.dashboard.tasks.kind.acknowledgement": "Läsbekräftelse",
            "hse.dashboard.tasks.kind.task": "Uppgift",
            "hse.dashboard.tasks.overdue": "Förfallen",
            "hse.dashboard.tasks.due": "Deadline {{date}}",
            "hse.dashboard.alerts.title": "Aviseringar",
            "hse.dashboard.alerts.empty": "Inga aviseringar.",
            "hse.dashboard.alerts.overdue_actions": "{{count}} förfallna åtgärder",
            "hse.dashboard.alerts.unread_docs": "{{count}} dokument väntar på läsbekräftelse",
            "hse.dashboard.alerts.due_soon": "{{count}} åtgärder förfaller snart",
            "hse.dashboard.alerts.critical_events": "{{count}} kritiska händelser",
            "hse.dashboard.events.title": "Senaste händelser",
            "hse.dashboard.events.empty": "Inga händelser att visa.",
            "hse.dashboard.events.view_all": "Visa alla",
            "hse.dashboard.org_charts.title": "Organisationsschema",
            "hse.dashboard.org_charts.view_all": "Visa alla",
            "hse.dashboard.org_charts.empty": "Inga organisationsscheman hittades",
            "hse.dashboard.org_charts.revision": "Revision {{number}}",
            "hse.dashboard.org_charts.approved": "Godkänd {{date}}",
            "hse.dashboard.org_charts.view": "Visa",
            "hse.dashboard.org_charts.pdf": "PDF",
            "hse.dashboard.org_charts.pdf_success": "PDF exporterad",
            "hse.dashboard.org_charts.pdf_error": "Kunde inte exportera PDF",
            "hse.dashboard.error": "Kunde inte läsa HMS-översikten.",
            "hse.dashboard.error_toast": "Något gick fel när HMS-översikten laddades.",
            "hse.dashboard.retry": "Försök igen",
            "hse.dashboard.see_all": "Visa alla",
            "hse.document_read_overview.export_loading": "Skapar PDF…",
            "hse.document_read_overview.export_error": "Kunde inte skapa PDF. Försök igen.",
            "hse.tiltak.title": "Åtgärder",
            "hse.tiltak.subtitle": "Uppföljning, nya rutiner och dokumentåtgärder i HMS",
            "hse.tiltak.form_subtitle": "Titel, ansvarig och deadline är det viktigaste. Resten kan fyllas i efteråt.",
            "hse.tiltak.view_subtitle": "Uppföljningsåtgärd i HMS",
            "hse.tiltak.new": "Ny åtgärd",
            "hse.tiltak.open": "Öppna",
            "hse.tiltak.edit": "Redigera åtgärd",
            "hse.tiltak.export_pdf": "Ladda ner PDF",
            "hse.tiltak.col_actions": "Åtgärder",
            "hse.tiltak.create": "Skapa åtgärd",
            "hse.tiltak.save": "Spara åtgärd",
            "hse.tiltak.cancel": "Avbryt",
            "hse.tiltak.start": "Starta",
            "hse.tiltak.complete": "Slutför",
            "hse.tiltak.created": "Åtgärd skapad",
            "hse.tiltak.updated": "Åtgärd uppdaterad",
            "hse.tiltak.started": "Åtgärd startad",
            "hse.tiltak.completed": "Åtgärd slutförd",
            "hse.tiltak.save_failed": "Kunde inte spara åtgärden",
            "hse.tiltak.load_failed": "Kunde inte läsa åtgärder",
            "hse.tiltak.empty": "Inga åtgärder ännu. Skapa den första.",
            "hse.tiltak.search": "Sök",
            "hse.tiltak.search_placeholder": "Sök efter titel eller beskrivning…",
            "hse.tiltak.filter_all": "Alla",
            "hse.tiltak.col_title": "Titel",
            "hse.tiltak.col_type": "Typ",
            "hse.tiltak.col_assignee": "Ansvarig",
            "hse.tiltak.col_deadline": "Deadline",
            "hse.tiltak.col_status": "Status",
            "hse.tiltak.status_overdue": "Förfallen",
            "hse.tiltak.field.title": "Titel",
            "hse.tiltak.field.description": "Beskrivning",
            "hse.tiltak.field.action_type": "Typ av åtgärd",
            "hse.tiltak.field.category": "Kategori",
            "hse.tiltak.field.priority": "Prioritet",
            "hse.tiltak.field.status": "Status",
            "hse.tiltak.field.deadline": "Deadline",
            "hse.tiltak.field.assignee": "Ansvarig",
            "hse.tiltak.field.event": "Kopplad händelse",
            "hse.tiltak.field.document": "Kopplat dokument",
            "hse.tiltak.event_none": "Ingen händelse",
            "hse.tiltak.linked_event": "Öppna händelsen",
            "hse.tiltak.linked_document": "Öppna dokumentet",
            "hse.tiltak.view_for_event": "Visa åtgärder för händelsen",
            "hse.tiltak.error_title": "Skriv en kort titel",
            "hse.tiltak.error_deadline": "Välj en deadline",
            "hse.tiltak.error_assignee": "Välj vem som äger åtgärden",
            "hse.tiltak.error_document": "Välj dokumentet åtgärden gäller",
            "hse.tiltak.type.generic": "Uppföljning",
            "hse.tiltak.type.new_routine": "Ny rutin",
            "hse.tiltak.type.linked_document": "Dokumentåtgärd",
            "hse.tiltak.category.safety": "Säkerhet",
            "hse.tiltak.category.quality": "Kvalitet",
            "hse.tiltak.category.environment": "Miljö",
            "hse.tiltak.category.procedure": "Rutin / procedur",
            "hse.tiltak.category.training": "Utbildning",
            "hse.tiltak.category.maintenance": "Underhåll",
            "hse.tiltak.category.equipment": "Utrustning",
            "hse.tiltak.category.communication": "Kommunikation",
            "hse.tiltak.category.other": "Annat",
            "hse.tiltak.priority.low": "Låg",
            "hse.tiltak.priority.medium": "Medel",
            "hse.tiltak.priority.high": "Hög",
            "hse.tiltak.priority.critical": "Kritisk",
            "hse.tiltak.status.planned": "Planerad",
            "hse.tiltak.status.started": "Påbörjad",
            "hse.tiltak.status.in_progress": "Pågår",
            "hse.tiltak.status.completed": "Slutförd",
            "hse.tiltak.status.cancelled": "Avbruten",
            "hse.tiltak.status.on_hold": "Pausad",
            "hse.tiltak.info.title.title": "Titel",
            "hse.tiltak.info.title.body": "En kort mening som beskriver vad som ska göras, till exempel «Uppdatera brandrutin» eller «Följ upp tillbud i lagret».",
            "hse.tiltak.info.description.title": "Beskrivning",
            "hse.tiltak.info.description.body": "Vad ska göras, varför, och när det är klart. Håll det konkret så den ansvariga vet nästa steg.",
            "hse.tiltak.info.action_type.title": "Typ av åtgärd",
            "hse.tiltak.info.action_type.body": "Uppföljning är en vanlig åtgärd efter en händelse. Ny rutin skapar eller ändrar ett fast arbetssätt. Dokumentåtgärd knyter arbetet till ett HMS-dokument.",
            "hse.tiltak.info.category.title": "Kategori",
            "hse.tiltak.info.category.body": "Hjälper er att sortera åtgärder efter tema (säkerhet, kvalitet, miljö, rutin, utbildning).",
            "hse.tiltak.info.priority.title": "Prioritet",
            "hse.tiltak.info.priority.body": "Kritisk och hög bör ha kort deadline. Medel och låg kan vänta om mer allvarliga åtgärder är öppna.",
            "hse.tiltak.info.status.title": "Status",
            "hse.tiltak.info.status.body": "Planerad = inte startad. Påbörjad/pågår = någon arbetar med den. Slutförd = klar. Pausad = tillfälligt stoppad.",
            "hse.tiltak.info.deadline.title": "Deadline",
            "hse.tiltak.info.deadline.body": "Datumet åtgärden ska vara klar. Förfallna åtgärder syns tydligt i listan.",
            "hse.tiltak.info.assignee.title": "Ansvarig",
            "hse.tiltak.info.assignee.body": "Personen som äger åtgärden. Företaget kan sätta en standardansvarig under HMS-inställningar.",
            "hse.tiltak.info.event.title": "Kopplad händelse",
            "hse.tiltak.info.event.body": "Valfritt. Används när åtgärden kommer från en olycka, tillbud, avvikelse eller observation.",
            "hse.tiltak.info.document.title": "Kopplat dokument",
            "hse.tiltak.info.document.body": "Valfritt, men krävs för dokumentåtgärder. Välj rutinen eller dokumentet som ska skapas eller uppdateras.",
            "hse.tiltak.print_action": "Skriv ut",
            "hse.tiltak.print_title": "Åtgärdslista",
            "hse.tiltak.print_dialog_title": "Skriv ut åtgärder",
            "hse.tiltak.print_dialog_intro": "Välj vilka åtgärder som ska vara med. Listan följer filtren du redan har satt.",
            "hse.tiltak.print_scope": "Omfattning",
            "hse.tiltak.print_scope_open": "Öppna åtgärder",
            "hse.tiltak.print_scope_overdue": "Förfallna åtgärder",
            "hse.tiltak.print_scope_completed": "Slutförda åtgärder",
            "hse.tiltak.print_scope_all": "Alla åtgärder i listan",
            "hse.tiltak.print_submit": "Skriv ut",
            "hse.tiltak.print_cancel": "Avbryt",
            "hse.tiltak.print_empty": "Inga åtgärder att skriva ut med valt filter.",
            "hse.tiltak.print_generated_at": "Genererad {{date}}",
            "hse.tiltak.pdf_failed": "Kunde inte ladda ner PDF för åtgärden",
            "hse.settings.hub_tab": "HMS-modul",
            "hse.settings.title": "Företagsinställningar för HMS",
            "hse.settings.hub_intro": "Anpassa vilka delar av HMS företaget använder, vem som är ansvarig och hur ofta systemet ska granskas.",
            "hse.settings.load_failed": "Kunde inte läsa HMS-inställningar",
            "hse.settings.saved": "HMS-inställningar sparade",
            "hse.settings.save_failed": "Kunde inte spara HMS-inställningar",
            "hse.settings.print_action": "Skriv ut / PDF",
            "hse.settings.modules.title": "Moduler i bruk",
            "hse.settings.modules.description": "Stäng av det företaget inte använder. Innehållet finns kvar, ni markerar bara vad som är aktivt.",
            "hse.settings.modules.tiltak": "Åtgärder",
            "hse.settings.modules.tiltak_help": "Uppföljning, nya rutiner och dokumentåtgärder.",
            "hse.settings.modules.events": "Händelser",
            "hse.settings.modules.events_help": "Avvikelser, tillbud, olyckor och observationer.",
            "hse.settings.modules.documents": "Dokument",
            "hse.settings.modules.documents_help": "Handbok, rutiner och läst/förstått.",
            "hse.settings.modules.competency": "Kompetens",
            "hse.settings.modules.competency_help": "Krav, kurser och utbildningsplan.",
            "hse.settings.modules.evaluation": "Utvärdering",
            "hse.settings.modules.evaluation_help": "Internrevision och ledningens genomgång.",
            "hse.settings.modules.risk": "Risk och SJA",
            "hse.settings.modules.risk_help": "Riskregister, SJA och kemikalieförteckning.",
            "hse.settings.modules.sja": "SJA",
            "hse.settings.modules.sja_help": "Säker jobb-analys innan arbetet startar.",
            "hse.settings.modules.goals": "Mål",
            "hse.settings.modules.goals_help": "Årliga HMS-mål, fokusområden och godkännande.",
            "hse.settings.responsible.title": "HMS-ansvarig",
            "hse.settings.responsible.description": "Standardperson som föreslås på nya åtgärder.",
            "hse.settings.responsible.info_title": "HMS-ansvarig",
            "hse.settings.responsible.info_body": "Företagets fasta HMS-kontakt. Nya åtgärder föreslår personen som ansvarig, men ni kan byta per åtgärd.",
            "hse.settings.cadence.title": "Granskningsintervall",
            "hse.settings.cadence.description": "Hur ofta ledningen ska granska HMS-systemet.",
            "hse.settings.cadence.info_title": "Granskningsintervall",
            "hse.settings.cadence.info_body": "ISO 9001/45001 förväntar sig regelbunden granskning. 12 månader är vanligt. Välj 3 eller 6 månader vid hög risk eller många ändringar.",
            "hse.settings.cadence.3": "Var 3:e månad",
            "hse.settings.cadence.6": "Var 6:e månad",
            "hse.settings.cadence.12": "Var 12:e månad",
            "hse.settings.tiltak_defaults.title": "Standard för åtgärder",
            "hse.settings.tiltak_defaults.description": "Används när någon skapar en ny åtgärd utan att fylla i allt själv.",
            "hse.settings.tiltak_defaults.info_title": "Standard för åtgärder",
            "hse.settings.tiltak_defaults.info_body": "Standarddeadline räknar dagar från i dag. Godkännande betyder att någon måste bekräfta åtgärden innan den stängs.",
            "hse.settings.tiltak_defaults.due_days": "Standarddeadline (dagar)",
            "hse.settings.tiltak_defaults.require_approval": "Kräv godkännande innan åtgärd stängs",
            "hse.settings.pdf_failed": "Kunde inte ladda ner PDF",
            "hse.settings.safety_rep.hub_tab": "Skyddsombud",
            "hse.settings.safety_rep.title": "Skyddsombud",
            "hse.settings.safety_rep.hub_intro": "Vem som är skyddsombud och eventuella suppleanter. Krävs för internkontroll.",
            "hse.settings.safety_rep.description": "Välj företagets skyddsombud. Personen får avisering när HMS-upplägget saknas.",
            "hse.settings.safety_rep.who": "Skyddsombud",
            "hse.settings.safety_rep.info_title": "Skyddsombud",
            "hse.settings.safety_rep.info_body": "Arbetsmiljölagen kräver skyddsombud. Sätt huvudpersonen här och lägg till suppleanter vid behov.",
            "hse.settings.safety_rep.deputies_title": "Suppleanter",
            "hse.settings.safety_rep.deputies_description": "Suppleanter kan träda in när skyddsombudet är borta.",
            "hse.settings.safety_rep.deputies_empty": "Inga suppleanter är satta.",
            "hse.settings.safety_rep.add_deputy": "Lägg till suppleant",
            "hse.settings.safety_rep.remove_deputy": "Ta bort suppleant",
            "hse.settings.risk.hub_tab": "Risk",
            "hse.settings.risk.title": "Riskhantering",
            "hse.settings.risk.hub_intro": "Hur företaget hanterar risk, standardkategorier och vem som är ansvarig.",
            "hse.settings.risk.handling_title": "Hur risk hanteras",
            "hse.settings.risk.handling_description": "Välj arbetssätt. Det styr vad som föreslås i riskregister och SJA.",
            "hse.settings.risk.handling_info_title": "Riskhantering",
            "hse.settings.risk.handling_info_body": "Register + SJA är vanligt. Välj SJA först vid kortvarigt arbete, eller bara register för övergripande risker.",
            "hse.settings.risk.handling.register_and_sja": "Register och SJA",
            "hse.settings.risk.handling.sja_first": "SJA först",
            "hse.settings.risk.handling.register_only": "Bara register",
            "hse.settings.risk.handling.custom": "Egen beskrivning",
            "hse.settings.risk.handling_notes_placeholder": "Beskriv hur ni bedömer och följer upp risk…",
            "hse.settings.risk.categories_title": "Riskkategorier",
            "hse.settings.risk.categories_description": "Standardkategorier kommer från API. Stäng av dem ni inte använder, eller lägg till egna.",
            "hse.settings.risk.categories_loading": "Läser kategorier…",
            "hse.settings.risk.categories_load_failed": "Kunde inte läsa riskkategorier",
            "hse.settings.risk.categories_save_failed": "Kunde inte spara riskkategori",
            "hse.settings.risk.category_add": "Lägg till",
            "hse.settings.risk.category_name": "Nytt kategorinamn",
            "hse.settings.risk.category_system": "Standard",
            "hse.settings.risk.category_delete": "Ta bort kategori",
            "hse.settings.risk.category_added": "Kategori tillagd",
            "hse.settings.risk.category_deleted": "Kategori borttagen",
            "hse.settings.risk.assessors_title": "Riskbedömare",
            "hse.settings.risk.assessors_description": "Personer som kan bedöma risk utöver HMS-ansvarig.",
            "hse.settings.risk.assessors_empty": "Inga bedömare är satta.",
            "hse.settings.risk.add_assessor": "Lägg till bedömare",
            "hse.settings.risk.remove_assessor": "Ta bort bedömare",
            "hse.settings.risk.category.health_safety": "Hälsa och säkerhet",
            "hse.settings.risk.category.environmental": "Yttre miljö",
            "hse.settings.risk.category.quality": "Kvalitet",
            "hse.settings.risk.category.financial": "Ekonomi",
            "hse.settings.risk.category.operational": "Drift",
            "hse.settings.risk.category.reputational": "Anseende",
            "hse.settings.risk.category.legal_compliance": "Regelverk",
            "hse.settings.risk.category.climate_related": "Klimat",
            "hse.settings.risk.skip_requires_reason": "Kräv motivering när risk hoppas över",
            "hse.settings.risk.skip_requires_reason_help": "Gäller SJA och riskbedömning när någon väljer att inte fylla i.",
            "hse.settings.risk.responsible_title": "Ansvarig för risk",
            "hse.settings.risk.responsible_description": "Personen som äger riskregister och SJA-uppföljning.",
            "hse.settings.ai.hub_tab": "AI",
            "hse.settings.ai.title": "AI-förslag",
            "hse.settings.ai.hub_intro": "Slå på förslag och välj standardbransch för HMS-innehåll.",
            "hse.settings.ai.description": "Förslag kan hjälpa med mål, dokument och åtgärder. Inget skickas utan att någon ber om det.",
            "hse.settings.ai.info_title": "AI i HMS",
            "hse.settings.ai.info_body": "När förslaget är på kan Promang föreslå text utifrån vald bransch. Företaget styr om det används.",
            "hse.settings.ai.enable": "Tillåt AI-förslag i HMS",
            "hse.settings.ai.enable_help": "Gäller mål, dokumentutkast och liknande hjälp.",
            "hse.settings.ai.discipline_title": "Standardbransch",
            "hse.settings.ai.discipline_description": "Används som utgångspunkt när AI föreslår HMS-innehåll.",
            "hse.settings.ai.discipline_none": "Ingen standard",
            "hse.settings.ai.configured_ok": "AI-nyckel är satt.",
            "hse.settings.ai.configured_missing": "AI är på, men nyckeln saknas i miljön.",
            "hse.setup.banner.title": "HMS-upplägg saknas",
            "hse.setup.banner.subtitle": "{{count}} punkt(er) bör fyllas i (ansvarig eller skyddsombud).",
            "hse.setup.banner.settings": "Öppna inställningar",
            "hse.setup.banner.guide": "Öppna guide",
            "hse.goals.title": "Mål",
            "hse.goals.subtitle": "Mål för {{year}}",
            "hse.goals.filter.year": "År",
            "hse.goals.load_failed": "Kunde inte läsa mål",
            "hse.goals.saved": "Mål sparat",
            "hse.goals.save_failed": "Kunde inte spara mål",
            "hse.goals.created": "Mål skapat",
            "hse.goals.deleted": "Mål borttaget",
            "hse.goals.delete_failed": "Kunde inte ta bort mål",
            "hse.goals.title_required": "Målet måste ha en titel.",
            "hse.goals.print": "Skriv ut",
            "hse.goals.open": "Öppna",
            "hse.goals.export_pdf": "Ladda ner PDF",
            "hse.goals.exporting": "Laddar ner PDF…",
            "hse.goals.export_failed": "Kunde inte ladda ner PDF",
            "hse.goals.status.draft": "Utkast",
            "hse.goals.status.proposed": "Föreslaget",
            "hse.goals.status.approved": "Godkänt",
            "hse.goals.status.active": "Aktivt",
            "hse.goals.status.completed": "Slutfört",
            "hse.goals.status.cancelled": "Avbrutet",
            "hse.goals.purpose.title": "Syfte med målen",
            "hse.goals.purpose.help": "Tryck på en bricka för att skapa ett mål. Redigera på plats efteråt.",
            "hse.goals.purpose.placeholder": "Valfri ifyllnad…",
            "hse.goals.purpose.chips.health_safety": "Säkra hälsa och säkerhet",
            "hse.goals.purpose.chips.prevent_harm": "Förebygga skada och miljöskada",
            "hse.goals.purpose.chips.systematic": "Systematisk förbättring",
            "hse.goals.purpose.chips.training": "Utbildning och medverkan",
            "hse.goals.purpose.chips.environment": "Ta hand om yttre miljö",
            "hse.goals.focus.title": "Fokusområden",
            "hse.goals.focus.help": "Kom överens om målen för året. Använd mallarna och redigera på plats.",
            "hse.goals.focus.add": "Eget mål",
            "hse.goals.focus.empty": "Inga fokusområden ännu. Tryck på en mall för att börja.",
            "hse.goals.focus.untitled": "Utan titel",
            "hse.goals.focus.title_placeholder": "Titel",
            "hse.goals.focus.description_placeholder": "Vad ska uppnås?",
            "hse.goals.focus.tiltak": "Koppla åtgärd (valfritt)",
            "hse.goals.focus.tiltak_none": "Ingen åtgärd",
            "hse.goals.focus.tiltak_link": "Öppna åtgärd",
            "hse.goals.focus.done": "Spara",
            "hse.goals.focus.cancel": "Avbryt",
            "hse.goals.focus.edit": "Redigera",
            "hse.goals.focus.remove": "Ta bort",
            "hse.goals.focus.templates.physical.title": "Fysisk arbetsmiljö",
            "hse.goals.focus.templates.physical.description": "Inga personskador eller materiella skador. Städade och trygga arbetsplatser.",
            "hse.goals.focus.templates.hse_work.title": "HMS-arbetet",
            "hse.goals.focus.templates.hse_work.description": "Följa internkontroll, utbildning och systematisk förbättring.",
            "hse.goals.focus.templates.absence.title": "Sjukfrånvaro och närvaro",
            "hse.goals.focus.templates.absence.description": "Hålla sjukfrånvaron under avtalad nivå och följa upp tidigt.",
            "hse.goals.focus.templates.vision.title": "Övergripande visioner",
            "hse.goals.focus.templates.vision.description": "Knyta avdelningsmål till riskbedömning och daglig drift.",
            "hse.goals.focus.templates.psychosocial.title": "Psykosocial miljö",
            "hse.goals.focus.templates.psychosocial.description": "Tryggt samtalsklimat, tydligt ledarskap och nolltolerans mot trakasserier.",
            "hse.goals.focus.templates.environment.title": "Yttre miljö",
            "hse.goals.focus.templates.environment.description": "Minska avfall, utsläpp och onödig resursanvändning.",
            "hse.goals.focus.templates.competency.title": "Kompetens",
            "hse.goals.focus.templates.competency.description": "Rätt kompetens på plats innan arbetet startar.",
            "hse.goals.approve.title": "Godkänn och signera",
            "hse.goals.approve.help": "Godkänn och signera varje mål när ledningen är överens.",
            "hse.goals.approve.place": "Ort",
            "hse.goals.approve.place_placeholder": "T.ex. Oslo",
            "hse.goals.approve.place_required": "Fyll i ort före godkännande.",
            "hse.goals.approve.status": "Status",
            "hse.goals.approve.draft": "Inte godkänd ännu",
            "hse.goals.approve.approved_on": "Godkänd {{date}}",
            "hse.goals.approve.action": "Godkänn",
            "hse.goals.approve.saved": "Mål godkänt",
            "hse.goals.sign.action": "Signera",
            "hse.goals.sign.saved": "Mål signerat",
            "hse.goals.sign.signed_on": "Signerat {{date}}",
            "hse.risk.title": "Risk och SJA",
            "hse.risk.subtitle": "Register, matris, SJA och klimatrisk — korta fält, inte ISO-essä.",
            "hse.risk.new": "Ny risk",
            "hse.risk.more": "Fler val",
            "hse.risk.more_header": "Välj åtgärd",
            "hse.risk.delete": "Ta bort risk",
            "hse.risk.deleted": "Risken togs bort",
            "hse.risk.delete_confirm": "Ta bort «{{title}}»?",
            "hse.risk.nav.campaigns": "Riskbedömningar",
            "hse.risk.campaigns.title": "Riskbedömningar",
            "hse.risk.campaigns.subtitle": "Övergripande per år — sedan riskerna.",
            "hse.risk.campaigns.search": "Sök i riskbedömningar…",
            "hse.risk.campaigns.empty": "Inga riskbedömningar ännu. Skapa 2027 eller ett eget namn.",
            "hse.risk.campaigns.col.name": "Riskbedömning",
            "hse.risk.campaigns.col.year": "År",
            "hse.risk.campaigns.col.updated": "Senast ändrad",
            "hse.risk.campaigns.col.progress": "Risker bedömda",
            "hse.risk.campaigns.col.department": "Avdelning",
            "hse.risk.campaigns.unspecified": "Ospecificerad",
            "hse.risk.campaign.new": "Ny riskbedömning",
            "hse.risk.campaign.year": "År",
            "hse.risk.campaign.title_optional": "Titel (valfritt)",
            "hse.risk.campaign.title_placeholder": "Övergripande riskbedömning {{year}}",
            "hse.risk.campaign.created": "Riskbedömning skapad",
            "hse.risk.campaign.deleted": "Riskbedömning borttagen",
            "hse.risk.campaign.delete": "Ta bort riskbedömning",
            "hse.risk.campaign.delete_confirm": "Ta bort «{{title}}»? Riskerna ligger kvar i registret.",
            "hse.risk.campaign.save_failed": "Kunde inte spara riskbedömningen",
            "hse.risk.campaign.load_failed": "Kunde inte hämta riskbedömningar",
            "hse.risk.campaign.add_risk": "Lägg till risk",
            "hse.risk.campaign.risks_title": "Risker och utmaningar",
            "hse.risk.campaign.progress_label": "{{done}}/{{total}} bedömda",
            "hse.risk.fields.description_placeholder": "Vad gör att detta kan vara en utmaning hos er?",
            "hse.risk.suggest.campaign_hint": "Förslagen sparas som utkast i den här riskbedömningen.",
            "hse.risk.suggest.created": "{{count}} utkast tillagda",
            "hse.guide.see": "Se vägledning",
            "hse.guide.badge": "Vägledning",
            "hse.guide.open_full": "Öppna hela HMS-guiden",
            "hse.guide.risk.title": "Riskbedömning",
            "hse.guide.risk.lead": "Börja med en övergripande bedömning för året. Lägg sedan till risker och åtgärder.",
            "hse.guide.risk.step1": "Skapa en riskbedömning för året, till exempel 2027.",
            "hse.guide.risk.step2": "Bedöm varje risk: titel, konsekvens och nivå.",
            "hse.guide.risk.step3": "Vid måttlig eller högre: koppla eller skapa en åtgärd.",
            "hse.guide.sja.title": "SJA",
            "hse.guide.sja.lead": "Säker jobb-analys för en konkret uppgift — kort och innan arbetet startar.",
            "hse.guide.sja.step1": "Skapa SJA med titel och arbetsplats.",
            "hse.guide.sja.step2": "Lägg in steg och faror, eller använd en mall.",
            "hse.guide.sja.step3": "Skicka in och få godkännande före jobbet.",
            "hse.guide.chemical.title": "Kemikalieförteckning",
            "hse.guide.chemical.lead": "Håll koll på kemikalier, datablad och genomgång.",
            "hse.guide.chemical.step1": "Registrera ämne och ladda upp datablad.",
            "hse.guide.chemical.step2": "Koppla plats och skyddsutrustning.",
            "hse.guide.chemical.step3": "Gå igenom och publicera när något ändras.",
            "hse.guide.protective.title": "Skyddsrundor",
            "hse.guide.protective.lead": "Planera rundor, notera fynd och följ upp åtgärder.",
            "hse.guide.protective.step1": "Skapa runda med område och deltagare.",
            "hse.guide.protective.step2": "Gå igenom kontrollpunkter på plats.",
            "hse.guide.protective.step3": "Skapa åtgärder på avvikelser och ladda ner PDF.",
            "hse.guide.evaluation.title": "Utvärdering",
            "hse.guide.evaluation.lead": "Revision, ledningens genomgång och KPI — kort status, inte en essä.",
            "hse.guide.evaluation.step1": "Välj typ: internrevision eller ledningens genomgång.",
            "hse.guide.evaluation.step2": "Registrera fynd och koppla åtgärder.",
            "hse.guide.evaluation.step3": "Följ KPI och stäng när ledningen är enig.",
            "hse.guide.tiltak.title": "Åtgärder",
            "hse.guide.tiltak.lead": "En åtgärd, en ansvarig, en deadline. Koppla till risk, händelse eller utvärdering.",
            "hse.guide.tiltak.step1": "Skriv vad som ska göras och vem som äger det.",
            "hse.guide.tiltak.step2": "Sätt deadline och starta när arbetet börjar.",
            "hse.guide.tiltak.step3": "Markera klart när risken är reducerad.",
            "hse.guide.goals.title": "Mål",
            "hse.guide.goals.lead": "Årets HMS-mål. Korta formuleringar, godkännande och valfri åtgärdslänk.",
            "hse.guide.goals.step1": "Välj år och använd mallar eller egna mål.",
            "hse.guide.goals.step2": "Godkänn när ledningen är enig.",
            "hse.guide.goals.step3": "Koppla åtgärder där det behövs.",
            "hse.risk.edit": "Redigera risk",
            "hse.risk.save": "Spara",
            "hse.risk.saving": "Sparar…",
            "hse.risk.cancel": "Avbryt",
            "hse.risk.exclude": "Ska inte bedömas",
            "hse.risk.created": "Risk sparad",
            "hse.risk.updated": "Risk uppdaterad",
            "hse.risk.excluded_saved": "Markerad som ska inte bedömas",
            "hse.risk.save_failed": "Kunde inte spara risken",
            "hse.risk.load_failed": "Kunde inte läsa risker",
            "hse.risk.empty": "Inga risker ännu. Börja med vanliga utmaningar eller en egen.",
            "hse.risk.search": "Sök risker…",
            "hse.risk.error_title": "Skriv en kort titel",
            "hse.risk.error_level": "Välj risknivå",
            "hse.risk.form_subtitle": "Titel, konsekvens och nivå. Utökad bedömning och filer är valfritt.",
            "hse.risk.pdf": "Ladda ner PDF",
            "hse.risk.pdf_loading": "Skapar PDF…",
            "hse.risk.pdf_ready": "PDF nedladdad",
            "hse.risk.open": "Öppna",
            "hse.risk.actions": "Åtgärder",
            "hse.risk.pdf_failed": "Kunde inte ladda ner PDF",
            "hse.risk.pdf_empty": "Ingen risk att exportera",
            "hse.risk.nav.aria": "Risksidor",
            "hse.risk.nav.register": "Register",
            "hse.risk.nav.matrix": "Matris",
            "hse.risk.nav.sja": "SJA",
            "hse.risk.nav.climate": "Klimatrisk",
            "hse.risk.nav.chemical": "Kemikalieförteckning",
            "hse.risk.nav.protective": "Skyddsrond",
            "hse.risk.hub.register": "Riskregister",
            "hse.risk.hub.register_hint": "Bedömda och exkluderade risker.",
            "hse.risk.hub.matrix": "Riskmatris",
            "hse.risk.hub.matrix_hint": "5×5 översikt över sannolikhet och konsekvens.",
            "hse.risk.hub.sja": "SJA",
            "hse.risk.hub.sja_hint": "{{count}} SJA i listan.",
            "hse.risk.hub.climate": "Klimatrisk",
            "hse.risk.hub.climate_hint": "Fysiska risker och omställningsrisker.",
            "hse.risk.hub.chemical": "Kemikalieförteckning",
            "hse.risk.hub.chemical_hint": "Kemikalier och datablad.",
            "hse.risk.hub.protective": "Skyddsrond",
            "hse.risk.hub.protective_hint": "Ronder och skyddsutrustning.",
            "hse.risk.hub.recent": "Senast uppdaterad",
            "hse.risk.hub.see_all": "Öppna registret",
            "hse.risk.register.title": "Riskregister",
            "hse.risk.register.subtitle": "Alla bedömda risker. «Ska inte bedömas» ligger längst ner.",
            "hse.risk.excluded.title": "Ska inte bedömas",
            "hse.risk.excluded.hint": "Utmaningar ni valt att inte bedöma nu.",
            "hse.risk.view.title": "Risk",
            "hse.risk.view.subtitle": "Kort bedömning och kopplade åtgärder",
            "hse.risk.view.updated": "Senast ändrad {{date}}",
            "hse.risk.add.common": "Vanliga utmaningar",
            "hse.risk.add.common_hint": "Välj tema och en relevant utmaning, bedöm sedan i dialogen.",
            "hse.risk.add.custom": "Egen",
            "hse.risk.add.custom_hint": "Välj kategori och skriv egen titel.",
            "hse.risk.add.pick_theme": "Välj tema",
            "hse.risk.add.pick_category": "Välj kategori",
            "hse.risk.assess.title": "Bedöm risk",
            "hse.risk.assess.required_hint": "Fält markerade med * måste fyllas i",
            "hse.risk.assess.how_to": "Låg = sällan och liten skada. Måttlig = kan hända och ge frånvaro. Hög = sannolik eller allvarlig.",
            "hse.risk.assess.tiltak_prompt": "Vid måttlig eller högre risk bör ni lägga till en riskreducerande åtgärd.",
            "hse.risk.assess.extended": "Utökad bedömning",
            "hse.risk.assess.files": "Filer",
            "hse.risk.assess.files_empty": "Inga filer bifogade.",
            "hse.risk.fields.title": "Titel",
            "hse.risk.fields.category": "Kategori",
            "hse.risk.fields.description": "Beskrivning",
            "hse.risk.fields.consequence": "Konsekvens",
            "hse.risk.fields.consequence_placeholder": "Vad kan detta leda till hos er?",
            "hse.risk.fields.level": "Hur stor är risken?",
            "hse.risk.fields.level_placeholder": "Välj nivå",
            "hse.risk.fields.status": "Status",
            "hse.risk.fields.work_task": "Arbetsuppgift",
            "hse.risk.fields.cause": "Utlösande orsak",
            "hse.risk.fields.existing": "Befintliga åtgärder",
            "hse.risk.fields.history": "Historik",
            "hse.risk.fields.likelihood": "Sannolikhet",
            "hse.risk.fields.consequence_score": "Konsekvens (1–5)",
            "hse.risk.fields.choose": "Välj",
            "hse.risk.level.unset": "Inte bedömd",
            "hse.risk.level.very_low": "Mycket låg",
            "hse.risk.level.low": "Låg",
            "hse.risk.level.moderate": "Måttlig",
            "hse.risk.level.high": "Hög",
            "hse.risk.level.very_high": "Mycket hög",
            "hse.risk.status.draft": "Utkast",
            "hse.risk.status.assessed": "Bedömd",
            "hse.risk.status.excluded": "Ska inte bedömas",
            "hse.risk.status.closed": "Stängd",
            "hse.risk.category.safety": "Säkerhet",
            "hse.risk.category.physical": "Fysisk",
            "hse.risk.category.psychosocial": "Psykosocialt",
            "hse.risk.category.organizational": "Organisatorisk",
            "hse.risk.category.environmental": "Miljö",
            "hse.risk.category.chemical": "Kemisk",
            "hse.risk.category.climate": "Klimat",
            "hse.risk.theme.electrical": "Elektriskt",
            "hse.risk.theme.fire": "Brand",
            "hse.risk.theme.fall": "Fall",
            "hse.risk.theme.tools": "Verktyg",
            "hse.risk.theme.chemical": "Kemikalier",
            "hse.risk.theme.psychosocial": "Psykosocialt",
            "hse.risk.theme.organizational": "Organisation",
            "hse.risk.theme.climate": "Klimat",
            "hse.risk.catalog.electric_shock": "Elektrisk stöt och strömgenomgång",
            "hse.risk.catalog.electric_shock_consequence": "Brännskada, hjärtstopp eller frånvaro efter arbete på anläggning.",
            "hse.risk.catalog.live_work": "Arbete nära spänning",
            "hse.risk.catalog.live_work_consequence": "Stöt eller ljusbåge om avstånd och säkring brister.",
            "hse.risk.catalog.fire_hot_work": "Brand och hetarbete",
            "hse.risk.catalog.fire_hot_work_consequence": "Brand i byggnad eller material, rökskada.",
            "hse.risk.catalog.flammable": "Brandfarliga vätskor och gas",
            "hse.risk.catalog.flammable_consequence": "Explosion eller brand vid läcka och tändkälla.",
            "hse.risk.catalog.fall_from_height": "Fall från höjd",
            "hse.risk.catalog.fall_from_height_consequence": "Allvarlig personskada vid arbete på höjd.",
            "hse.risk.catalog.slip_trip": "Fall, snubbling och halt underlag",
            "hse.risk.catalog.slip_trip_consequence": "Brott, stukning eller frånvaro.",
            "hse.risk.catalog.cuts": "Skärsår och stick",
            "hse.risk.catalog.cuts_consequence": "Skärsår, infektion eller funktionsbortfall.",
            "hse.risk.catalog.machinery": "Maskiner och rörliga delar",
            "hse.risk.catalog.machinery_consequence": "Klämning, skärsår eller amputation.",
            "hse.risk.catalog.chemical_exposure": "Kemikalieexponering",
            "hse.risk.catalog.chemical_exposure_consequence": "Frätskada, allergi eller långtidsskada.",
            "hse.risk.catalog.dust_fume": "Damm och rök",
            "hse.risk.catalog.dust_fume_consequence": "Luftvägsbesvär och nedsatt arbetsförmåga.",
            "hse.risk.catalog.conflicts": "Konflikter",
            "hse.risk.catalog.conflicts_consequence": "Sjukfrånvaro, dåligt samarbete och fel i arbetet.",
            "hse.risk.catalog.workload": "Hög arbetsbelastning",
            "hse.risk.catalog.workload_consequence": "Utmattning och fler fel.",
            "hse.risk.catalog.human_error": "Mänskligt fel",
            "hse.risk.catalog.human_error_consequence": "Felhandling som ger skada eller avvikelse.",
            "hse.risk.catalog.communication": "Kommunikation",
            "hse.risk.catalog.communication_consequence": "Missförstånd som ger olycka eller kvalitetsfel.",
            "hse.risk.catalog.competence": "Saknad kompetens",
            "hse.risk.catalog.competence_consequence": "Fel utförande för att utbildning saknas.",
            "hse.risk.catalog.extreme_weather": "Extremväder",
            "hse.risk.catalog.extreme_weather_consequence": "Stopp i arbete, skada på material eller person.",
            "hse.risk.catalog.heat_cold": "Värme och kyla",
            "hse.risk.catalog.heat_cold_consequence": "Värmeslag, förfrysning eller nedsatt förmåga.",
            "hse.risk.scale.likelihood.1": "Mycket sällan",
            "hse.risk.scale.likelihood.2": "Sällan",
            "hse.risk.scale.likelihood.3": "Möjligt",
            "hse.risk.scale.likelihood.4": "Sannolikt",
            "hse.risk.scale.likelihood.5": "Nästan säkert",
            "hse.risk.scale.consequence.1": "Försumbar",
            "hse.risk.scale.consequence.2": "Liten",
            "hse.risk.scale.consequence.3": "Måttlig",
            "hse.risk.scale.consequence.4": "Allvarlig",
            "hse.risk.scale.consequence.5": "Katastrofal",
            "hse.risk.info.title.title": "Titel",
            "hse.risk.info.title.body": "Kort namn på utmaningen, till exempel «Elektrisk stöt».",
            "hse.risk.info.description.title": "Beskrivning",
            "hse.risk.info.description.body": "Vad gör att detta kan vara en utmaning hos er?",
            "hse.risk.info.category.title": "Kategori",
            "hse.risk.info.category.body": "Hjälper er att sortera. Säkerhet, fysisk, psykosocial, organisatorisk, miljö, kemisk eller klimat.",
            "hse.risk.info.consequence.title": "Konsekvens",
            "hse.risk.info.consequence.body": "Vad kan hända hos er — skada, frånvaro, brand eller stopp. Håll det kort.",
            "hse.risk.info.level.title": "Risknivå",
            "hse.risk.info.level.body": "Helhetsbedömning. Måttlig och högre bör ha åtgärd. Använd utökad bedömning för 1–5-tal till matrisen.",
            "hse.risk.info.matrix.title": "Sannolikhet och konsekvens",
            "hse.risk.info.matrix.body": "Valfritt. 1–5 för varje. Produkten placerar risken i 5×5-matrisen.",
            "hse.risk.info.tiltak.title": "Åtgärder",
            "hse.risk.info.tiltak.body": "Koppla befintlig åtgärd eller skapa ny. Ny åtgärd skickas till /hse/tiltak med risken som källa.",
            "hse.risk.info.climate.title": "Klimatrisk",
            "hse.risk.info.climate.body": "Kort titel på en fysisk risk eller omställningsrisk, till exempel extremväder på anläggning.",
            "hse.risk.info.sja.title": "SJA",
            "hse.risk.info.sja.body": "Säker jobb-analys för ett konkret jobb. Steg och faror kan fyllas i efter titeln.",
            "hse.risk.tiltak.how": "Hur arbetar ni med detta?",
            "hse.risk.tiltak.new": "Ny åtgärd",
            "hse.risk.tiltak.create": "Skapa åtgärd",
            "hse.risk.tiltak.link_existing": "Lägg till befintlig åtgärd",
            "hse.risk.tiltak.link": "Koppla",
            "hse.risk.tiltak.linked": "Åtgärd kopplad",
            "hse.risk.tiltak.empty": "Inga åtgärder kopplade ännu.",
            "hse.risk.tiltak.count": "{{count}} åtgärder",
            "hse.risk.tiltak.save_first": "Spara risken innan du kopplar åtgärder.",
            "hse.risk.tiltak.choose_assignee": "Välj ansvarig",
            "hse.risk.tiltak.title_from_risk": "Minska risk: {{title}}",
            "hse.risk.matrix.title": "Riskmatris",
            "hse.risk.matrix.subtitle": "Sannolikhet (rad) × konsekvens (kolumn).",
            "hse.risk.matrix.likelihood": "Sannolikhet",
            "hse.risk.matrix.legend": "Grönt = låg, gult = måttlig, orange/rött = hög. Klicka titeln för detaljer.",
            "hse.risk.sja.title": "Säker jobb-analys",
            "hse.risk.sja.subtitle": "Skapa, lista och visa SJA.",
            "hse.risk.sja.new": "Ny SJA",
            "hse.risk.sja.edit": "Redigera SJA",
            "hse.risk.sja.form_subtitle": "Titel och jobbtyp först. Steg och faror kan fyllas i efteråt.",
            "hse.risk.sja.view_title": "SJA",
            "hse.risk.sja.view_subtitle": "Steg och faror för jobbet",
            "hse.risk.sja.empty": "Inga SJA ännu.",
            "hse.risk.sja.load_failed": "Kunde inte läsa SJA",
            "hse.risk.sja.created": "SJA skapad",
            "hse.risk.sja.updated": "SJA uppdaterad",
            "hse.risk.sja.work_type": "Jobbtyp",
            "hse.risk.sja.work_type.routine": "Rutinarbete",
            "hse.risk.sja.work_type.non_routine": "Icke-rutin",
            "hse.risk.sja.work_type.maintenance": "Underhåll",
            "hse.risk.sja.work_type.construction": "Bygg / anläggning",
            "hse.risk.sja.work_type.emergency": "Nöd",
            "hse.risk.sja.work_type.special": "Special",
            "hse.risk.sja.status.draft": "Utkast",
            "hse.risk.sja.status.pending_approval": "Väntar godkännande",
            "hse.risk.sja.status.approved": "Godkänd",
            "hse.risk.sja.status.in_use": "I bruk",
            "hse.risk.sja.status.archived": "Arkiverad",
            "hse.risk.sja.location": "Plats",
            "hse.risk.sja.steps": "Steg",
            "hse.risk.sja.add_step": "Lägg till steg",
            "hse.risk.sja.step_n": "Steg {{n}}",
            "hse.risk.sja.step_placeholder": "Vad görs i detta steg?",
            "hse.risk.sja.hazards_placeholder": "Faror, en per rad",
            "hse.risk.sja.hazards": "Faror",
            "hse.risk.climate.title": "Klimatrisk",
            "hse.risk.climate.subtitle": "Korta bedömningar av klimat och omställning.",
            "hse.risk.climate.new": "Ny klimatrisk",
            "hse.risk.climate.empty": "Inga klimatrisker ännu.",
            "hse.risk.climate.load_failed": "Kunde inte läsa klimatrisk",
            "hse.risk.climate.created": "Klimatrisk skapad",
            "hse.risk.climate.updated": "Klimatrisk uppdaterad",
            "hse.risk.climate.edit": "Redigera klimatrisk",
            "hse.risk.climate.horizon_label": "Tidshorisont",
            "hse.risk.climate.category.physical_risks": "Fysiska risker",
            "hse.risk.climate.category.transition_risks": "Omställningsrisker",
            "hse.risk.climate.category.regulatory_risks": "Regulatorisk",
            "hse.risk.climate.category.market_risks": "Marknad",
            "hse.risk.climate.category.reputational_risks": "Anseende",
            "hse.risk.climate.horizon.short_term": "Kort sikt (0–2 år)",
            "hse.risk.climate.horizon.medium_term": "Medellång (3–5 år)",
            "hse.risk.climate.horizon.long_term": "Lång sikt (6–10 år)",
            "hse.risk.climate.horizon.very_long_term": "Mycket lång (10+ år)",
            "hse.risk.level.lav": "Låg",
            "hse.risk.level.moderat": "Måttlig",
            "hse.risk.level.hoy": "Hög",
            "hse.risk.level.kritisk": "Kritisk",
            "hse.risk.status.suggested": "Föreslagen",
            "hse.risk.status.in_progress": "Pågår",
            "hse.risk.status.skipped": "Ska inte bedömas",
            "hse.risk.category.sikkerhet": "Säkerhet",
            "hse.risk.category.organisatorisk": "Organisatorisk",
            "hse.risk.category.psykososialt": "Psykosocialt",
            "hse.risk.category.fysisk": "Fysisk",
            "hse.risk.category.kjemisk": "Kemisk",
            "hse.risk.category.ergonomisk": "Ergonomisk",
            "hse.risk.category.miljo": "Miljö",
            "hse.risk.add.suggest": "Föreslå från bransch",
            "hse.risk.add.suggest_hint": "AI föreslår vanliga utmaningar för bransch eller fack.",
            "hse.risk.suggest.hint": "Ange bransch och/eller fack. Förslagen sparas som utkast ni kan bedöma.",
            "hse.risk.suggest.industry": "Bransch",
            "hse.risk.suggest.fag": "Fack",
            "hse.risk.suggest.run": "Föreslå risker",
            "hse.risk.suggest.working": "Föreslår…",
            "hse.risk.suggest.error_industry": "Ange bransch eller fack",
            "hse.risk.suggest.empty": "Inga förslag den här gången",
            "hse.risk.suggest.failed": "Kunde inte föreslå risker",
            "hse.risk.setup.title": "HMS-uppsättning saknas",
            "hse.risk.setup.responsible": "HMS-ansvarig är inte satt",
            "hse.risk.setup.verneombud": "Skyddsombud är inte satt",
            "hse.risk.setup.categories": "Riskkategorier saknas",
            "hse.risk.setup.ai_key": "AI är på, men nyckel saknas",
            "hse.risk.sja.submit": "Skicka till godkännande",
            "hse.risk.sja.approve": "Godkänn",
            "hse.risk.sja.submitted": "SJA skickad till godkännande",
            "hse.risk.sja.approved": "SJA godkänd",
            "hse.sja.submit": "Skicka till godkännande",
            "hse.sja.approve": "Godkänn",
            "hse.sja.approve_verneombud": "Godkänn som skyddsombud",
            "hse.sja.approve_leader": "Godkänn som ledare",
            "hse.sja.submitted": "SJA skickad till godkännande",
            "hse.sja.approved": "SJA godkänd",
            "hse.sja.status_follows_approval": "Status sätts när skyddsombud eller ledare godkänner. Den kan inte väljas fritt.",
            "hse.sja.template.pick": "Stegmal",
            "hse.sja.template.hint": "Välj en sparad mall eller en befintlig SJA i stället för att skriva alla steg själv.",
            "hse.sja.template.placeholder": "Välj stegmal",
            "hse.sja.template.apply": "Använd mall",
            "hse.sja.template.applying": "Lägger in…",
            "hse.sja.template.applied": "Steg från mallen har lagts in",
            "hse.sja.template.loading": "Laddar mallar…",
            "hse.sja.template.empty": "Inga stegmallar ännu. Skriv stegen, eller använd en tidigare SJA när den finns.",
            "hse.sja.template.empty_steps": "Mallen har inga steg att lägga in.",
            "hse.sja.template.load_failed": "Kunde inte läsa stegmalen",
            "hse.sja.template.untitled": "Utan titel",
            "hse.sja.approve_daglig_leder": "Godkänn som VD",
            "hse.sja.approve_annen_leder": "Godkänn som annan ledare",
            "hse.sja.role.verneombud": "Skyddsombud",
            "hse.sja.role.daglig_leder": "VD",
            "hse.sja.role.annen_leder": "Annan ledare",
            "hse.sja.approval.title": "Godkännande",
            "hse.sja.approval.pending": "Väntar på",
            "hse.sja.approval.empty": "Inga godkännanden väntar.",
            "hse.sja.not_editable": "SJA kan bara redigeras som utkast.",
            "hse.settings.other_manager.title": "Annan ledare",
            "hse.settings.other_manager.description": "Personen som godkänner SJA som annan ledare. Tomt = HMS-ansvarig används.",
            "todo.journalTitle": "Dagbok",
            "todo.journalDate": "Datum",
            "todo.journalHint": "Anteckningar för vald dag (HTML). Sparas automatiskt.",
            "todo.journalHintRich":
              "Markera text för att formatera (Notion-stil). Du kan klistra in HTML från webben eller OneNote — osäker kod tas bort vid sparning.",
            "todo.journalPlaceholder": "Skriv anteckningar för denna dag…",
            "todo.journalFullscreen": "Helskärm",
            "todo.journalExitFullscreen": "Stäng helskärm",
            "todo.journalOpenInFullscreen": "Du redigerar i helskärm. Stäng det fönstret när du är klar.",
            "todo.journalSaveError": "Kunde inte spara dagbok.",
            "todo.journalImageTitle": "Bild",
            "todo.journalImageWidth": "Bredd",
            "todo.journalImageWidthHint": "Pixlar (320) eller procent (50 %).",
            "todo.journalImageHeight": "Höjd",
            "todo.journalImageHeightPlaceholder": "Valfritt (tomt = automatiskt)",
            "todo.journalImageAlt": "Beskrivning (alt-text)",
            "todo.journalImageSizePresets": "Snabbstorlek",
            "todo.journalImageOriginal": "Återställ storlek",
            "todo.journalImageAlign": "Justering",
            "todo.journalImageAlignLeft": "Vänster",
            "todo.journalImageAlignCenter": "Centrera",
            "todo.journalImageAlignRight": "Höger",
            "todo.journalImageApply": "Verkställ",
            "todo.journalImageRemove": "Ta bort bild",
            "todo.digestTitle": "E-postpåminnelser",
            "todo.digestMorning": "Morgon (ca 07:00, din tidszon)",
            "todo.digestEvening": "Kväll (ca 17:00)",
            "todo.digestTimezone": "Tidszon",
            "todo.digestSaved": "Inställningar sparade",
            "todo.digestSaveError": "Kunde inte spara e-postinställningar.",
            "todo.prevDay": "Föregående dag",
            "todo.nextDay": "Nästa dag",
            "todo.today": "Idag",
            "richTextEditor.contextMenu.ariaLabel": "Åtgärder för formaterad text",
            "richTextEditor.contextMenu.cut": "Klipp ut",
            "richTextEditor.contextMenu.copy": "Kopiera",
            "richTextEditor.contextMenu.paste": "Klistra in",
            "richTextEditor.contextMenu.insertImage": "Infoga bild…",
            "richTextEditor.contextMenu.moveSelectionToPage": "Flytta markering till sida…",
            "richTextEditor.contextMenu.createPageWithSelection": "Ny sida från markering…",
            "richTextEditor.contextMenu.handlerMissing": "Anslut en hanterare i förälderkomponenten för att aktivera den här åtgärden.",
            "richTextEditor.table.insert": "Infoga tabell",
            "richTextEditor.table.hint": "Lägger till en redigerbar 3 x 3-tabell.",
            "richTextEditor.table.defaultHeader": "Kolumn",
            "automile.checkoutConfirmTitle": "Checka ut från fordon?",
            "automile.checkoutConfirmMessage": "Är du säker på att du vill checka ut? Fordonet blir tillgängligt för andra förare.",
            "automile.checkoutConfirm": "Ja, checka ut",
            "automile.checkoutCancel": "Avbryt",
            "automile.checkInDriver": "Checka in förare",
            "automile.checkOutVehicle": "Checka ut förare",
            "automile.linkUser": "Koppla användare",
            "automile.selectEmployee": "Välj medarbetare",
            "automile.noVehiclesAvailable": "Inga lediga fordon (aktiva och utan incheckad förare).",
            "automile.settingsHint": "Slutför Automile under Företag → Integrationer.",
            "automile.driverNeedsSync": "Föraren måste synkas med Automile före incheckning.",
            "automile.onlyAvailableVehiclesSubtitle": "Endast aktiva fordon utan incheckad förare visas.",
            "automile.noDriversFreeForCheckin": "Inga förare utan incheckat fordon (med kopplad användare).",
            "automile.adminVehiclePickerSubtitle":
              "Alla aktiva fordon visas. Om fordonet är incheckat på någon annan flyttas det till den här föraren när du väljer det (för flåtansvariga).",
            "automile.noActiveVehiclesForFleet": "Inga aktiva fordon hittades.",
            "automile.vehicleOccupiedBadge": "Incheckad — omtilldelning checkar ut nuvarande förare först",
            "automile.userName": "Användare / Namn",
            "automile.checkedIntoVehicle": "Incheckad i fordon",
            "automile.distanceDriven": "Körd sträcka",
            "automile.notCheckedIn": "Inte incheckad",
            "automile.noUserLinked": "Ingen användare kopplad",
            "automile.from": "Från",
            "automile.to": "Till",
            "Drivers": "Förare",
            "Driver": "Förare",
            "Module": "Modul",
            "Distance": "Sträcka",

            "tool.open": "Öppna",
            "tool.back_to_overview": "Tillbaka till verktyg",
            "tool.assigned_user_column": "Tilldelad",
            "tool.assignment_heading": "Tilldelning",
            "tool.assignment_hint":
              "Tilldela verktyget till en medarbetare eller ta bort tilldelning (retur).",
            "tool.assigned_to": "Tilldelad till",
            "tool.not_assigned": "Ej tilldelad",
            "tool.assign_user": "Tilldela användare",
            "tool.reassign_user": "Byt innehavare",
            "tool.return_from_user": "Ta bort tilldelning (retur)",
            "tool.assign_saved": "Tilldelning uppdaterad",
            "tool.return_saved": "Verktyget returnerat",
            "tool.notes_heading": "Verktygsanteckningar",
            "tool.notes_hint":
              "Interna anteckningar om verktyget (visas inte i journal/service).",
            "tool.notes_placeholder": "Skriv anteckningar…",
            "tool.save_notes": "Spara anteckningar",
            "tool.notes_saved": "Anteckningar sparade",
            "tool.completed_service_intervals": "Genomförda serviceintervall",
            "tool.completed_service_intervals_hint":
              "Journalposter med status slutförd och «service» i titeln (samma regel som nästa service).",
            "tool.no_completed_service_intervals":
              "Inga genomförda serviceintervall är registrerade ännu.",
            "tool.journal_other_hint":
              "Övriga journalposter (aktiva, uppföljning, icke-service m.m.).",
            "tool.journal_empty_hint": "Skapa en journalpost för service eller anteckningar.",
            "tool.journal_no_other_entries": "Inga övriga journalposter.",
            "tool.print_label": "Skriv ut skylt / etikett",
            "tool.usage_history_heading": "Utlåningshistorik",
            "tool.usage_history_hint":
              "Vem som haft verktyget, hur många dagar (kalenderdagar, första och sista räknas), och om perioden avslutades med retur eller överlämning till annan användare.",
            "tool.usage_history_empty":
              "Ingen historik ännu. Historik skapas när du tilldelar, byter användare eller returnerar verktyget.",
            "tool.usage_user": "Användare",
            "tool.usage_from": "Från",
            "tool.usage_to": "Till",
            "tool.usage_days": "Dagar",
            "tool.usage_outcome": "Avslutning",
            "tool.usage_status": "Status",
            "tool.usage_status_active": "Aktivt lån",
            "tool.usage_status_ended": "Avslutad",
            "tool.usage_reason.return": "Returnerad (otilldelad)",
            "tool.usage_reason.reassign": "Överlämnad till annan användare",
            "tool.employee_tools_title": "Verktyg",
            "tool.employee_tools_intro_title": "Dina tilldelade verktyg",
            "tool.employee_tools_intro":
              "En enkel översikt över verktyg som är registrerade på dig, med tilldelningsdatum och nyckelinformation.",
            "tool.employee_tools_short": "Dina tilldelade verktyg.",
            "tool.employee_tools_loading": "Laddar verktyg...",
            "tool.employee_tools_load_error": "Kunde inte ladda verktyg.",
            "tool.employee_tools_empty_title": "Inga tilldelade verktyg",
            "tool.employee_tools_empty": "Det finns inga verktyg registrerade på dig.",
            "tool.employee_tools_assigned_on": "Tagen i bruk",
            "tool.employee_tools_unknown_date": "Okänt datum",
            "tool.employee_tools_no_service": "Ingen planerad service",
            "tool.employee_tools_days_held": "{{count}} dagar i bruk",

            // SaveBar / auto-save
            "Saving": "Lagrer",
            "Save": "Lagre",
            "Error saving changes": "Feil ved lagring",
            "Changes saved successfully": "Endringer lagret",
            "You have unsaved changes": "Du har ulagrede endringer",
            "Could not save": "Kunne ikke lagre",

            "platformBroadcast.scheduledLabel": "Planerad uppdatering",
            "platformBroadcast.countdownPrefix": "Om {{time}}",
            "platformBroadcast.scheduledOverdue": "Starttid är nådd — spara ditt arbete",
            "platformBroadcast.activeNoticesRegion": "Aktiva Promang-meddelanden",
            "platformBroadcast.noticeWarningTag": "Varning",
            "platformBroadcast.noticeInfoTag": "Info",
            "platformBroadcast.updatingTitle": "Promang uppdateras",
            "platformBroadcast.updatingHint": "Vi är snart tillbaka. Tack för ditt tålamod.",
            "platformBroadcast.updatingAdminHint":
              "Administratör: När utrullningen är klar, använd skiftnyckeln nere till höger och välj «Bekräfta att Promang har uppdaterats».",
            "platformBroadcast.dev.menuAria": "Plattform dev-meny",
            "platformBroadcast.dev.noActiveUpdate": "Ingen aktiv underhållssession.",
            "platformBroadcast.dev.statusLine": "{{phase}}: {{title}}",
            "platformBroadcast.dev.scheduleUpdate": "Planera uppdatering",
            "platformBroadcast.dev.startMaintenance": "Starta underhåll (uppdatering pågår)",
            "platformBroadcast.dev.confirmComplete": "Bekräfta att Promang har uppdaterats",
            "platformBroadcast.dev.addNotice": "Lägg till meddelande (info / varning)",
            "platformBroadcast.dev.manageNotices": "Hantera meddelanden",
            "platformBroadcast.dev.fieldTitle": "Titel",
            "platformBroadcast.dev.fieldDescription": "Beskrivning",
            "platformBroadcast.dev.fieldScheduledAt": "Tid för uppdatering",
            "platformBroadcast.dev.fieldExpectedEnd": "Förväntat kl. ca.",
            "platformBroadcast.dev.fieldKind": "Typ",
            "platformBroadcast.dev.kindInfo": "Info",
            "platformBroadcast.dev.kindWarning": "Varning",
            "platformBroadcast.dev.cancel": "Avbryt",
            "platformBroadcast.dev.save": "Spara",
            "platformBroadcast.dev.start": "Starta",
            "platformBroadcast.dev.close": "Stäng",
            "platformBroadcast.dev.maintenanceHint": "Användare ser helskärmsläget «Promang uppdateras» med nedräkning.",
            "platformBroadcast.dev.validationTitleTime": "Ange titel och tid.",
            "platformBroadcast.dev.validationTitle": "Ange titel.",
            "platformBroadcast.dev.invalidTime": "Ogiltig tid.",
            "platformBroadcast.dev.saved": "Planerad uppdatering sparad.",
            "platformBroadcast.dev.maintenanceStarted": "Underhåll startat.",
            "platformBroadcast.dev.confirmCompletePrompt": "Bekräfta att uppdateringen är klar och rensa denna runda för alla?",
            "platformBroadcast.dev.confirmed": "Bekräftat.",
            "platformBroadcast.dev.noticeCreated": "Meddelande skapat.",
            "platformBroadcast.dev.noticeHidden": "Meddelande dolt.",
            "platformBroadcast.dev.noticeShown": "Meddelande visas igen.",
            "platformBroadcast.dev.requestFailed": "Begäran misslyckades.",
            "platformBroadcast.dev.historyHint": "Dölj meddelanden när problemet är löst. Historik sparas i databasen.",
            "platformBroadcast.dev.recentUpdates": "Senaste planerade uppdateringar",
            "platformBroadcast.dev.allNotices": "Alla meddelanden",
            "platformBroadcast.dev.hidden": "dolt",
            "platformBroadcast.dev.hide": "Dölj",
            "platformBroadcast.dev.show": "Visa",
            "platformBroadcast.dev.roleViewMenu": "Simulera rollvy (endast UI)",
            "platformBroadcast.dev.sentryReporting": "Skicka fel till Sentry",
            "platformBroadcast.dev.sentryReportingHint":
              "Av som standard i utveckling. Tystar den här webbläsaren och API-fel från dina anrop.",
            "platformBroadcast.dev.sentryReportingOn": "Sentry-rapportering aktiverad.",
            "platformBroadcast.dev.sentryReportingOff": "Sentry-rapportering inaktiverad.",
            "platformBroadcast.dev.roleViewTitle": "Hur Promang ser ut för dig",
            "platformBroadcast.dev.roleViewTabPresets": "Förval",
            "platformBroadcast.dev.roleViewTabCustom": "Anpassad (som användaradmin)",
            "platformBroadcast.dev.roleViewHintCustom":
              "Samma reglage som under Företag → Användare. Tryck «Verkställ simulering» längst ner när du är klar.",
            "platformBroadcast.dev.roleViewCustomApply": "Verkställ simulering",
            "platformBroadcast.dev.roleViewHint":
              "Gäller bara den här webbläsaren: meny, ruttgarder, RoleOnly och relaterade hooks. API:et använder fortfarande dina riktiga behörigheter.",
            "platformBroadcast.dev.roleViewApply": "Verkställ",
            "platformBroadcast.dev.roleViewReset": "Rensa simulering",
            "platformBroadcast.dev.roleViewResetNow": "Rensa simulering",
            "platformBroadcast.dev.roleViewActiveBanner":
              "Rollsimulering är på — gränssnittet speglar inte dina riktiga rättigheter.",
            "platformBroadcast.dev.roleViewToastApplied": "Rollsimulering uppdaterad.",
            "platformBroadcast.dev.roleViewToastReset": "Rollsimulering borttagen.",
            "platformBroadcast.dev.roleViewPreset.off.label": "Riktiga behörigheter",
            "platformBroadcast.dev.roleViewPreset.off.description":
              "Använd roller från servern (standard).",
            "platformBroadcast.dev.roleViewPreset.none.label": "Inga roller",
            "platformBroadcast.dev.roleViewPreset.none.description":
              "Tom rollista — nästan inga moduler i menyn.",
            "platformBroadcast.dev.roleViewPreset.hours_time_only.label":
              "Endast tidrapportering",
            "platformBroadcast.dev.roleViewPreset.hours_time_only.description":
              "Timmodul med registrering/redigering av egna timmar — inte godkännande, inställningar eller frånvaro.",
            "platformBroadcast.dev.roleViewPreset.hours_extended.label":
              "Timmar + godkännande och frånvaro",
            "platformBroadcast.dev.roleViewPreset.hours_extended.description":
              "Bred timprofil: listor, godkännande, läsning av inställningar, frånvaroregistrering.",
            "platformBroadcast.dev.roleViewPreset.service_field.label":
              "Service i fält",
            "platformBroadcast.dev.roleViewPreset.service_field.description":
              "Fokus på serviceöversikt och rapporter; begränsad avtalstillgång.",
            "platformBroadcast.dev.roleViewPreset.projects_participant.label":
              "Projektdeltagare",
            "platformBroadcast.dev.roleViewPreset.projects_participant.description":
              "Projekt och arbetsorder med typiska utföraråtgärder.",
            "platformBroadcast.dev.roleViewPreset.project_leader_all.label":
              "Projektledare (alla projekt)",
            "platformBroadcast.dev.roleViewPreset.project_leader_all.description":
              "Projektadministratör med full åtkomst till alla projekt och arbetsorder.",
            "platformBroadcast.dev.roleViewPreset.project_leader_selected.label":
              "Projektledare (valda projekt)",
            "platformBroadcast.dev.roleViewPreset.project_leader_selected.description":
              "Projektroller utan full företagsadministration; full åtkomst ges per projekt.",
            "Send Offer": "Skicka offert",
            "Choose recipient, offer PDF version and customer message before sending.":
              "Välj mottagare, PDF-version och kundmeddelande innan offerten skickas.",
            "Offer sending has been queued. You will be notified when it's complete.":
              "Offertsändningen har lagts i kö. Du får besked när den är klar.",
            "Something went wrong. Could not send offer.":
              "Något gick fel. Det gick inte att skicka offerten.",
            "Offer Type": "Offerttyp",
            "Internal offer": "Intern offert",
            "Customer offer": "Kundoffert",
            "Open selected offer PDF": "Öppna vald offert-PDF",
            "PDF preview will be available when the selected offer type is generated.":
              "PDF-förhandsvisning blir tillgänglig när vald offerttyp har genererats.",
            "Message to customer": "Meddelande till kund",
            "Offer sent successfully!": "Offerten har skickats.",
            "Offer sending queued...": "Offertsändningen har lagts i kö...",
            "Generating PDF and sending offer...":
              "Genererar PDF och skickar offert...",
            "Failed to send offer": "Det gick inte att skicka offerten",
            "Failed to send offer. Please try again.":
              "Det gick inte att skicka offerten. Försök igen.",
            "Request timed out. Please check the offer status manually.":
              "Begäran tog för lång tid. Kontrollera offertstatus manuellt.",
            "publicAppointment.title": "Bekräfta avtalet",
            "publicAppointment.subtitle": "Gå igenom uppgifterna och bekräfta att tiden fortfarande passar.",
            "publicAppointment.sectionAppointment": "Avtal",
            "publicAppointment.sectionWork": "Uppdraget",
            "publicAppointment.reportType": "Typ av uppdrag",
            "publicAppointment.serviceAddress": "Uppdragsadress",
            "publicAppointment.workDescription": "Beskrivning av uppdraget",
            "publicAppointment.timeExactHint": "Vi planerar att komma ungefär vid denna tid.",
            "publicAppointment.timeWindowHint": "Vi kommer någon gång inom denna tidsram.",
            "publicAppointment.reportNumber": "Uppdrag / rapportnr.",
            "publicAppointment.date": "Datum",
            "publicAppointment.time": "Tid",
            "publicAppointment.companyFallback": "Leverantör",
            "publicAppointment.confirmHint":
              "När du bekräftar registrerar vi avtalet som accepterat. Vid ändringsbehov, kontakta oss via telefon eller e-post.",
            "publicAppointment.termsAcceptPlain":
              "Genom att bekräfta avtalet godkänner du våra villkor för användning av tjänster, försäljning och serviceavtal.",
            "publicAppointment.termsAcceptPrefix": "Genom att bekräfta avtalet godkänner du våra ",
            "publicAppointment.termsAcceptLink": "villkor för användning av tjänster, försäljning och serviceavtal",
            "publicAppointment.termsAcceptSuffix": ".",
            "publicAppointment.confirmButton": "Bekräfta avtalet",
            "publicAppointment.submitting": "Bekräftar…",
            "publicAppointment.successTitle": "Tack — avtalet är bekräftat",
            "publicAppointment.successBody": "Du kan stänga sidan. Vid ändringar, kontakta företaget direkt.",
            "publicAppointment.alreadyConfirmed": "Detta avtal är redan bekräftat.",
            "publicAppointment.loadFailed": "Vi kunde inte hitta avtalet. Länken kan vara ogiltig eller utgången.",
            "publicAppointment.confirmFailed": "Vi kunde inte registrera bekräftelsen. Försök igen eller kontakta oss.",
            "publicAppointment.missingToken": "Bekräftelselänken saknar nödvändig information.",

            // Standalone documentation journals
            "journal.page_title": "Journaler",
            "journal.journals": "Journaler",
            "journal.hero_subtitle":
              "Skapa flera journaler för dokumentation på anställda, kunder, projekt eller fristående.",
            "journal.all_journals": "Alla journaler",
            "journal.all_journals_subtitle": "Alla journaler i företaget.",
            "journal.section_subtitle": "Dokumentation med text och bilder.",
            "journal.new_journal": "Ny journal",
            "journal.no_journals": "Inga journaler ännu",
            "journal.no_journals_hint": "Skapa en journal för att börja dokumentera.",
            "journal.color": "Färg",
            "journal.new_entry": "Ny post",
            "journal.entry_placeholder": "Skriv en post… (text och bilder)",
            "journal.entry_added": "Post tillagd",
            "journal.entry_save_failed": "Kunde inte spara posten",
            "journal.entry_delete_confirm": "Ta bort denna post?",
            "journal.unknown_author": "Okänd",
            "journal.pin": "Fäst",
            "journal.unpin": "Lossa",
            "journal.save_failed": "Kunde inte spara journalen",
            "journal.print": "Skriv ut",
            "journal.printing": "Genererar…",
            "journal.print_failed": "Kunde inte generera PDF",
            "journal.search_placeholder": "Sök i journaler…",
            "journal.documentation.no_entries": "Inga poster.",

            "meeting_minutes": "Mötesprotokoll",
            "meeting_minutes.list": "Mötesprotokoll",
            "meeting_minutes.hero_subtitle": "Protokoll för medarbetarsamtal, projektmöten och andra möten. Använd mallar, skicka till deltagare och exportera PDF.",
            "meeting_minutes.editor_subtitle": "Välj typ, deltagare och ev. en mall. Första mötet skapas automatiskt.",
            "meeting_minutes.filter.all_types": "Alla typer",
            "meeting_minutes.copy_suffix": "Kopia",
            "meeting_minutes.status.draft": "Pågår",
            "meeting_minutes.date.today": "I dag",
            "meeting_minutes.send_to_participants": "Skicka till anställda och deltagare",
            "meeting_minutes.export_pdf": "Exportera PDF",
            "meeting_minutes.new": "Nytt mötesprotokoll",
            "meeting_minutes.edit": "Redigera mötesprotokoll",
            "meeting_minutes.search": "Sök mötesprotokoll…",
            "meeting_minutes.no_results": "Inga mötesprotokoll hittades",
            "meeting_minutes.meeting_date": "Mötesdatum",
            "meeting_minutes.meeting_type": "Mötestyp",
            "meeting_minutes.type.employee_interview": "Medarbetarsamtal",
            "meeting_minutes.type.project_meeting": "Projektmöte",
            "meeting_minutes.type.other": "Annat möte",
            "meeting_minutes.employee": "Anställd",
            "meeting_minutes.select_employee": "Välj anställd",
            "meeting_minutes.participants": "Deltagare",
            "meeting_minutes.select_participants": "Välj deltagare",
            "meeting_minutes.project": "Projekt",
            "meeting_minutes.select_project": "Välj projekt",
            "meeting_minutes.title": "Titel",
            "meeting_minutes.description": "Beskrivning",
            "meeting_minutes.meeting_number": "Möte #",
            "meeting_minutes.templates": "Mallar",
            "meeting_minutes.templates.list": "Mallar",
            "meeting_minutes.templates.hero_subtitle": "Återanvänd agenda för samtal, projektmöten och tavlamöten.",
            "meeting_minutes.templates.editor_subtitle": "Lägg till punkter och inlägg som laddas när du skapar ett möte.",
            "meeting_minutes.templates.empty_start": "Börja med tom agenda",
            "meeting_minutes.templates.no_points": "Inga punkter i mallen",
            "meeting_minutes.templates.will_load": "Laddar {{count}} punkter från mallen",
            "meeting_minutes.templates.agenda": "Agenda i mallen",
            "meeting_minutes.templates.save_from_meeting": "Spara som mall",
            "meeting_minutes.templates.saved_from_meeting": "Mötet sparades som mall",
            "meeting_minutes.templates.save_from_meeting_error": "Kunde inte spara mall",
            "meeting_minutes.templates.new": "Ny mall",
            "meeting_minutes.templates.edit": "Redigera mall",
            "meeting_minutes.templates.search": "Sök mallar…",
            "meeting_minutes.templates.no_results": "Inga mallar hittades",
            "meeting_minutes.templates.use_template": "Använd mall",
            "meeting_minutes.created": "Mötesprotokoll skapat",
            "meeting_minutes.updated": "Mötesprotokoll uppdaterat",
            "meeting_minutes.deleted": "Mötesprotokoll raderat",
            "meeting_minutes.delete_confirm": "Vill du radera detta mötesprotokoll?",
            "meeting_minutes.meetings": "Möten",
            "meeting_minutes.create_error": "Kunde inte skapa mötesprotokoll",
            "meeting_minutes.update_error": "Kunde inte uppdatera mötesprotokoll",
            "meeting_minutes.delete_error": "Kunde inte radera mötesprotokoll",
            "meeting_minutes.load_error": "Kunde inte ladda mötesprotokoll",
            "meeting_minutes.template.created": "Mall skapad",
            "meeting_minutes.template.updated": "Mall uppdaterad",
            "meeting_minutes.template.deleted": "Mall raderad",
            "meeting_minutes.template.create_error": "Kunde inte skapa mall",
            "meeting_minutes.template.update_error": "Kunde inte uppdatera mall",
            "meeting_minutes.template.delete_error": "Kunde inte radera mall",
            "meeting_minutes.template.delete_confirm": "Vill du radera denna mall?",
            "meeting_minutes.template.load_error": "Kunde inte ladda mall",
            "meeting_minutes.json.open_dialog": "JSON / AI-instruktion",
            "meeting_minutes.json.generate_with_ai": "Generera agenda med AI",
            "meeting_minutes.json.dialog_title": "Mötesprotokoll JSON",
            "meeting_minutes.json.tab_json": "JSON",
            "meeting_minutes.json.tab_ai_guide": "AI-instruktion",
            "meeting_minutes.json.hint": "Klistra in eller redigera agenda-JSON. Ersätt eller lägg till.",
            "meeting_minutes.json.replace_groups": "Ersätt alla punkter",
            "meeting_minutes.json.append_groups": "Lägg till längst ner",
            "meeting_minutes.json.copy_json": "Kopiera JSON",
            "meeting_minutes.json.reload_from_editor": "Ladda från editorn",
            "meeting_minutes.json.insert_sample": "Infoga exempel",
            "meeting_minutes.json.apply": "Använd i editorn",
            "meeting_minutes.json.copy_success": "JSON kopierad",
            "meeting_minutes.json.reload_success": "JSON laddad från editorn",
            "meeting_minutes.json.clipboard_failed": "Kunde inte kopiera",
            "meeting_minutes.json.applied": "Lade in {{count}} punkter",
            "meeting_minutes.json.ai_guide_intro": "Kopiera instruktionen och klistra in i ChatGPT, Cursor eller en annan modell.",
            "meeting_minutes.json.copy_ai_guide": "Kopiera AI-instruktion",
            "meeting_minutes.json.ai_guide_copied": "AI-instruktion kopierad",
            "meeting_minutes.json.ai_parse_error": "Kunde inte läsa AI-JSON",
            "meeting_minutes.json.ai_apply_success": "Lade in {{count}} AI-punkter",
            "meeting_minutes.json.error_empty": "Tom JSON",
            "meeting_minutes.json.error_invalid_json": "Ogiltig JSON",
            "meeting_minutes.json.error_no_groups_array": "Saknar groups-array",
            "meeting_minutes.json.error_no_valid_groups": "Inga giltiga punkter i JSON",
            "meeting_minutes.json.error_create_group_failed": "Kunde inte skapa punkt från JSON",
            "meeting_minutes.json.error_create_entry_failed": "Kunde inte skapa inlägg från JSON",
            "meeting_minutes.add_meeting": "Lägg till möte",
            "meeting_minutes.add_first_meeting": "Lägg till första mötet",
            "meeting_minutes.no_meetings": "Inga möten ännu",
            "meeting_minutes.points": "punkter",
            "meeting_minutes.add_point": "Lägg till punkt",
            "meeting_minutes.point.title": "Punkttitel",
            "meeting_minutes.point.description": "Punktbeskrivning",
            "meeting_minutes.point.untitled": "Utan titel",
            "meeting_minutes.point.edit": "Redigera punkt",
            "meeting_minutes.entry.description": "Beskrivning",
            "meeting_minutes.entry.deadline": "Deadline",
            "meeting_minutes.entry.responsible": "Ansvarig",
            "meeting_minutes.entry.add": "Lägg till inlägg",
            "meeting_minutes.entry.remove": "Ta bort",
            "meeting_minutes.meeting.created": "Möte skapat",
            "meeting_minutes.meeting.create_error": "Kunde inte skapa möte",
            "meeting_minutes.meeting.load_error": "Kunde inte ladda möte",
            "meeting_minutes.meeting.finished": "Klart",
            "meeting_minutes.meeting.mark_finished": "Markera som klart",
            "meeting_minutes.meeting.marked_finished": "Mötet markerades som klart",
            "meeting_minutes.meeting.mark_finished_error": "Kunde inte markera mötet som klart",
            "meeting_minutes.meeting.mark_finished_title": "Markera mötet som klart?",
            "meeting_minutes.meeting.mark_finished_body": "Mötet markeras som klart och kan inte längre redigeras. Redigeringsläget stängs av, och punkter och inlägg kan inte ändras på den här sidan efteråt.",
            "meeting_minutes.actions.open": "Åtgärder",
            "meeting_minutes.meeting.no_points": "Inga punkter ännu",
            "meeting_minutes.meeting.no_points_add_first": "Inga punkter ännu. Lägg till första punkten för att komma igång.",
            "meeting_minutes.meeting.copy_from_previous": "Kopiera från föregående möte",
            "meeting_minutes.meeting.no_copy": "Kopiera inte",
            "meeting_minutes.meeting.no_template": "Använd ingen mall",
            "meeting_minutes.employee.add_manual": "Lägg till manuell deltagare",
            "meeting_minutes.employee.manual_name": "Namn",
            "meeting_minutes.employee.manual_email": "E-post",
            "meeting_minutes.employee.manual_mobile": "Mobil",
            "meeting_minutes.meetings_created_separately": "Möten skapas separat. Gå till möteslistan för att lägga till nya möten.",
            "meeting_minutes.group.delete_confirm": "Vill du radera denna grupp?",
            "meeting_minutes.group.deleted": "Grupp raderad",
            "meeting_minutes.group.delete_error": "Kunde inte radera grupp",
            "meeting_minutes.group.delete": "Radera grupp",
            "meeting_minutes.group.created": "Grupp skapad",
            "meeting_minutes.group.updated": "Grupp uppdaterad",
            "meeting_minutes.changes_saved": "Ändringar sparade",
            "meeting_minutes.send": "Skicka protokoll",
            "meeting_minutes.send_success": "Protokollet skickades",
            "meeting_minutes.send_partial": "Skickat till {{sent}} mottagare. {{failed}} misslyckades.",
            "meeting_minutes.from_previous_meeting": "Från föregående möte",
            "meeting_minutes.entry.create_error": "Kunde inte skapa inlägg",
            "meeting_minutes.entry.update_error": "Kunde inte uppdatera inlägg",
            "meeting_minutes.entry.delete_error": "Kunde inte radera inlägg",
            "meeting_minutes.entry.delete_confirm": "Vill du radera detta inlägg?",
            "meeting_minutes.point.create_error": "Kunde inte skapa punkt",
            "meeting_minutes.errors.stale": "Mötet har ändrats av någon annan. Utkastet är sparat. Hämta senaste versionen innan du sparar igen.",
            "meeting_minutes.point.update_error": "Kunde inte uppdatera punkt",

            // Text documents (letters / agreements)
            "textDocuments.title": "Dokument",
            "textDocuments.new": "Nytt dokument",
            "textDocuments.create": "Skapa",
            "textDocuments.edit": "Redigera dokument",
            "textDocuments.untitled": "Utan titel",
            "textDocuments.title_placeholder": "T.ex. uppsägning, avtal, informationsbrev…",
            "textDocuments.template": "Mall",
            "textDocuments.template_hint": "Välj en befintlig mall som utgångspunkt (valfritt).",
            "textDocuments.choose_template": "Välj mall",
            "textDocuments.change_template": "Byt",
            "textDocuments.remove_template": "Ta bort mall",
            "textDocuments.hero_subtitle":
              "Skapa brev, avtal och uppsägningar. Skriv ut med eller utan signaturfält, och skicka för digital signering.",
            "textDocuments.search_placeholder": "Sök dokument…",
            "textDocuments.empty": "Inga dokument ännu.",
            "textDocuments.standalone": "Fristående",
            "textDocuments.section_subtitle": "Brev, avtal och andra dokument.",
            "textDocuments.status.draft": "Utkast",
            "textDocuments.status.final": "Klar",
            "textDocuments.include_signature": "Inkludera signaturfält vid utskrift",
            "textDocuments.editor_placeholder": "Skriv dokumentet här…",
            "textDocuments.print": "Skriv ut",
            "textDocuments.save_failed": "Kunde inte spara dokumentet",
            "textDocuments.save_before_print": "Spara dokumentet före utskrift",
            "textDocuments.print_failed": "Kunde inte generera PDF",
            "textDocuments.signing": "Digital signering",
            "textDocuments.signature.signers": "Signaturer",
            "textDocuments.signature.signers_hint":
              "Lägg till vem som ska signera. Välj anställd för att hämta namn, befattning och personnummer automatiskt till Posten-signering. Annars fyll i personnummer eller både e-post och mobil.",
            "textDocuments.signature.select_employee": "Välj anställd",
            "textDocuments.signature.manual_entry": "Fyll i manuellt",
            "textDocuments.signature.loading_employee": "Hämtar anställdinformation…",
            "textDocuments.signature.employee_posten_hint":
              "Personnummer, e-post och mobil hämtas från anställningen vid sändning till Posten Signering.",
            "textDocuments.signature.employee_linked": "Anställd vald – identitet hämtas från anställningen",
            "textDocuments.signature.signing_requires_signers":
              "Aktivera «Inkludera signaturfält vid utskrift» och lägg till minst en undertecknare för att skicka via Posten.",
            "textDocuments.signature.signing_uses_configured_signers":
              "Följande signaturer från dokumentet skickas till Posten Signering:",
            "textDocuments.signature.signing_missing_identity":
              "Varje undertecknare måste vara en vald anställd, ha personnummer, eller ha både e-post och mobil.",
            "textDocuments.signature.name": "Namn",
            "textDocuments.signature.name_placeholder": "T.ex. Anna Andersson",
            "textDocuments.signature.job_title": "Befattning",
            "textDocuments.signature.job_title_placeholder": "T.ex. VD",
            "textDocuments.signature.field_label": "Fältnamn",
            "textDocuments.signature.field_label_placeholder": "T.ex. Signatur / Ort och datum",
            "textDocuments.signature.national_identity_number": "Personnummer / D-nummer",
            "textDocuments.signature.national_identity_number_placeholder": "11 siffror",
            "textDocuments.signature.email": "E-post",
            "textDocuments.signature.email_placeholder": "namn@foretag.se",
            "textDocuments.signature.mobile": "Mobil",
            "textDocuments.signature.mobile_placeholder": "+46 70 000 00 00",
            "textDocuments.signature.add_signer": "Lägg till undertecknare",
            "textDocuments.signature.remove_signer": "Ta bort undertecknare",

            "documentForms.templates.title": "Dokumentmallar",
            "documentForms.templates.subtitle": "Bygg ifyllbara dokumentmallar med fält, checklistor och tabeller",
            "documentForms.templates.new": "Ny mall",
            "documentForms.templates.edit": "Redigera mall",
            "documentForms.templates.empty": "Inga mallar hittades",
            "documentForms.templates.meta": "Malldetaljer",
            "documentForms.templates.number_prefix": "Arkivprefix",
            "documentForms.templates.number_prefix_placeholder": "t.ex. SJA",
            "documentForms.templates.number_prefix_hint": "Används för numrering i arkivet: SJA #1, SJA #2 … Tomt = första ordet i titeln.",
            "documentForms.created_with_reference": "Skapad {{reference}}",
            "documentForms.templates.editor_hint": "Lägg till block och konfigurera ifyllbara fält",
            "documentForms.templates.print": "Skriv ut mall",
            "documentForms.templates.save_before_print": "Spara mallen före utskrift",
            "documentForms.forms.title": "Ifyllda dokument",
            "documentForms.forms.subtitle": "Dokument skapade från mallar",
            "documentForms.forms.empty": "Inga dokument hittades",
            "documentForms.new": "Nytt dokument",
            "documentForms.edit": "Redigera dokument",
            "documentForms.create": "Skapa",
            "documentForms.created": "Dokument skapat",
            "documentForms.save_failed": "Kunde inte spara dokument",
            "documentForms.template": "Mall",
            "documentForms.choose_template": "Välj mall",
            "documentForms.form_title": "Dokumenttitel",
            "documentForms.search_placeholder": "Sök...",
            "documentForms.include_signature": "Inkludera signaturblock i PDF",
            "documentForms.mark_final": "Markera som klar",
            "documentForms.print": "Skriv ut / PDF",
            "documentForms.save_before_print": "Spara dokumentet före utskrift",
            "documentForms.print_failed": "Kunde inte generera PDF",
            "documentForms.status.draft": "Utkast",
            "documentForms.status.final": "Klar",
            "documentForms.table.add_row": "Lägg till rad",
            "documentForms.categories.all": "Alla kategorier",
            "documentForms.categories.new": "Ny kategori",
            "documentForms.categories.name": "Kategorinamn",
            "documentForms.categories.description": "Beskrivning",
            "documentForms.categories.label": "Kategori",
            "documentForms.categories.uncategorized": "Okategoriserad",
            "documentForms.builder.blocks": "Block",
            "documentForms.builder.empty": "Inga block ännu",
            "documentForms.builder.empty_hint": "Lägg till block från paletten till vänster",
            "documentForms.builder.select_block": "Välj ett block för att redigera egenskaper",
            "documentForms.blocks.heading": "Rubrik",
            "documentForms.blocks.paragraph": "Stycke",
            "documentForms.blocks.callout": "Infobox",
            "documentForms.blocks.divider": "Avgränsare",
            "documentForms.blocks.text_field": "Textfält",
            "documentForms.blocks.textarea": "Lång text",
            "documentForms.blocks.number": "Nummer",
            "documentForms.blocks.date": "Datum",
            "documentForms.blocks.checkbox": "Kryssruta",
            "documentForms.blocks.select": "Rullgardinsmeny",
            "documentForms.blocks.checklist": "Checklista",
            "documentForms.blocks.table": "Tabell",
            "documentForms.blocks.signature": "Signatur",
            "documentForms.props.level": "Nivå",
            "documentForms.props.label": "Etikett",
            "documentForms.props.placeholder": "Platshållare",
            "documentForms.props.required": "Obligatorisk",
            "documentForms.props.variant": "Variant",
            "documentForms.props.info": "Info",
            "documentForms.props.warning": "Varning",
            "documentForms.props.options": "Alternativ (ett per rad)",
            "documentForms.props.items": "Checklistpunkter",
            "documentForms.props.add_item": "Lägg till punkt",
            "documentForms.props.column_label": "Kolumnrubrik",
            "documentForms.props.add_column": "Lägg till kolumn",
            "documentForms.props.allow_add_rows": "Tillåt att lägga till rader vid ifyllning",

            "documentForms.archive.title": "Dokumentarkiv",
            "documentForms.archive.subtitle": "Inskickade och utkast — grupperade per mall",
            "documentForms.archive.empty": "Inga ifyllda dokument i arkivet ännu",
            "documentForms.archive.stats": "{{forms}} dokument i {{templates}} mallar",
            "documentForms.archive.count": "{{count}} dokument",
            "documentForms.archive.view_for_template": "Visa arkiv ({{count}})",
            "documentForms.archive.hse_link": "HMS-dokument",
            "documentForms.archive.clear_filter": "Visa alla mallar",
            "documentForms.archive.unknown_template": "Okänd mall",
            "documentForms.hse.title": "HMS-dokumentregister",
            "documentForms.hse.description": "Registrera mallen som styrt formulär (SKJ) i HMS-dokument. Ifyllda instanser ligger i dokumentarkivet.",
            "documentForms.hse.register": "Registrera i HMS-dokument",
            "documentForms.hse.registered": "Registrerad i HMS-dokument",
            "documentForms.hse.register_failed": "Kunde inte registrera i HMS",
            "documentForms.hse.save_template_first": "Spara mallen före registrering i HMS",
            "documentForms.hse.open_document": "Öppna HMS-dokument",
            "documentForms.hse.system_category": "Systemkategori (HMS/KS/REG …)",
            "documentForms.hse.category_required": "Välj kategori och kapitel för HMS-placering",
            "documentForms.hse.update_placement": "Uppdatera placering i HMS",
            "documentForms.hse.fill_form": "Fyll i formulär",
            "documentForms.hse.fillable_template_title": "Ifyllbar formulärmall",
            "documentForms.hse.fillable_template_description": "Detta dokument är kopplat till en mall. Skapa och fyll i ett nytt formulär — det sparas i dokumentarkivet.",
            "documentForms.hse.fillable_badge": "Ifyllbart formulär",
            "documentForms.json.open_dialog": "JSON / AI",
            "documentForms.json.dialog_title": "JSON och AI för dokumentmall",
            "documentForms.json.tab_json": "Klistra in JSON",
            "documentForms.json.tab_ai_guide": "AI-instruktioner",
            "documentForms.json.hint": "Klistra in JSON från ChatGPT eller annan AI, eller redigera befintlig mall. Stöder { \"blocks\": [...] } eller full mall med title och description.",
            "documentForms.json.replace_blocks": "Ersätt alla block",
            "documentForms.json.append_blocks": "Lägg till längst ner",
            "documentForms.json.copy_json": "Kopiera JSON",
            "documentForms.json.reload_from_builder": "Ladda från mallbyggaren",
            "documentForms.json.insert_sample": "Infoga exempel",
            "documentForms.json.apply": "Använd JSON",
            "documentForms.json.applied": "{{count}} block importerade",
            "documentForms.json.copy_success": "JSON kopierad",
            "documentForms.json.reload_success": "JSON laddad från mallbyggaren",
            "documentForms.json.clipboard_failed": "Kunde inte kopiera till urklipp",
            "documentForms.json.ai_guide_intro": "Kopiera instruktionerna nedan till ChatGPT, Claude eller annan AI. Klistra sedan in JSON-svaret under fliken Klistra in JSON.",
            "documentForms.json.copy_ai_guide": "Kopiera AI-instruktioner",
            "documentForms.json.ai_guide_copied": "AI-instruktioner kopierade",
            "documentForms.json.generate_with_ai": "Generera med AI",
            "documentForms.json.ai_parse_error": "Kunde inte läsa AI-svar som JSON",
            "documentForms.json.ai_apply_success": "{{count}} block tillagda från AI",
            "documentForms.json.error_empty": "JSON-fältet är tomt",
            "documentForms.json.error_invalid_json": "Ogiltig JSON — kontrollera syntax",
            "documentForms.json.error_no_blocks_array": "Ingen blocks-array hittades i JSON",
            "documentForms.json.error_no_valid_blocks": "Inga giltiga block efter import",
        "Oppdatering": "Uppdatering",
        "Innlegg": "Uppdatering",
        "status_update.mine_title": "Mina uppdateringar",
        "status_update.mine_search_placeholder": "Sök i mina uppdateringar…",
        "status_update.mine_empty": "Du har inga uppdateringar ännu.",
        "status_update.mine_empty_search": "Inga träffar för sökningen.",
        "status_update.mine_load_more": "Ladda mer",
        "status_update.mine_untitled": "Utan titel",
        "status_update.mine_no_subject_link": "Kunde inte öppna länkad post.",
        "status_update.mine_company_scope": "Företag",
        "status_update.subject_project": "Projekt",
        "status_update.subject_customer": "Kund",
        "status_update.subject_work_order": "Arbetsorder",
        "status_update.subject_project_activity": "Projektaktivitet",
        "status_update.unavailable_title": "Uppdatering är inte tillgänglig",
        "status_update.unavailable_description": "Modulen eller API:et har inte rullats ut ännu, eller är tillfälligt otillgänglig. Försök igen senare.",
        "status_update.unavailable_nav_hint": "Uppdatering är inte tillgänglig just nu",
        "status_update.load_error": "Kunde inte ladda uppdateringar.",
        "status_update.load_more_error": "Kunde inte ladda fler uppdateringar.",
        "status_update.delete_failed": "Kunde inte ta bort uppdateringen.",
        "status_update.save_failed": "Kunde inte spara uppdateringen.",
        "status_update.saved": "Uppdateringen sparades",
        "status_update.edit": "Redigera",
        "status_update.save": "Spara",
        "status_update.cancel": "Avbryt",
        "status_update.edited": "redigerad",
        "status_update.mentioned_here": "Nämnd här",
        "status_update.search_placeholder": "Sök i uppdateringar…",
        "status_update.search_empty": "Inga träffar för sökningen.",
        "status_update.retry": "Försök igen",
        "work_order.redesign.status_updates_title": "Uppdatering",
        "work_order.redesign.status_updates_meta": "Status, foton och uppföljning",
        "notes.legacy_title": "Tidigare anteckningar",
        "notes.legacy_hint": "Äldre anteckningar och foton (endast läsning). Nya uppdateringar skrivs under Uppdatering.",
        "project.activities.status_updates_title": "Uppdatering",
        "Skriv oppdatering": "Skriv uppdatering",
        "Skriv innlegg": "Skriv uppdatering",
        "Skriv en oppdatering… bruk @ for å nevne, / for å koble modul": "Skriv en uppdatering… använd @ för att nämna, / för att koppla modul",
        "Skriv et innlegg… bruk @ for å nevne, / for å koble modul": "Skriv en uppdatering… använd @ för att nämna, / för att koppla modul",
        "Tittel (valgfritt)": "Titel (valfritt)",
        "Tittel": "Titel",
        "Legg til tittel": "Lägg till titel",
        "Alle med tilgang": "Alla med åtkomst",
        "Kun admin": "Endast admin",
        "Kun meg": "Bara jag",
        "Publiser": "Publicera",
        "Sender…": "Skickar…",
        "Publisert": "Publicerat",
        "Ingen oppdateringer ennå. Skriv den første!": "Inga uppdateringar ännu. Skriv den första!",
        "Ingen innlegg ennå. Skriv det første!": "Inga uppdateringar ännu. Skriv den första!",
        "Slette denne oppdateringen?": "Radera den här uppdateringen?",
        "Slette dette innlegget?": "Radera den här uppdateringen?",
        "Slett": "Radera",
        "Clear": "Rensa",
        "Velg…": "Välj…",
        "Skriv litt tekst eller legg til vedlegg for å publisere": "Skriv lite text eller lägg till bilaga för att publicera",
        "Kunne ikke publisere oppdateringen": "Kunde inte publicera uppdateringen",
        "Kunne ikke publisere innlegget": "Kunde inte publicera uppdateringen",
        "oppdatering.subject_optional_hint": "Projekt eller kund är valfritt. AI kan föreslå projekt utifrån texten.",
        "Dikter": "Diktera",
        "Tekst": "Text",
        "Dikter oppdatering": "Diktera uppdatering",
        "Dikter innlegg": "Diktera uppdatering",
        "Hvordan vil du legge inn oppdateringen?": "Hur vill du lägga in uppdateringen?",
        "Trykk for å stoppe opptaket. Teksten vises etterpå.": "Tryck för att stoppa inspelningen. Texten visas efteråt.",
        "Bytt metode": "Byt metod",
        "Foreslå": "Föreslå",
        "Foreslå oppgaver": "Föreslå uppgifter",
        "Foreslåtte oppgaver": "Föreslagna uppgifter",
        "Velg hvilke som skal opprettes": "Välj vilka som ska skapas",
        "Hopp over": "Hoppa över",
        "Opprett valgte": "Skapa valda",
        "Oppretter…": "Skapar…",
        "AI-forslag": "AI-förslag",
        "oppdatering.suggestion_add": "Lägg till",
        "oppdatering.suggestion_dismiss": "Dölj förslag",
        "oppdatering.todos_created": "{{count}} uppgift(er) skapade",
        "oppdatering.todos_create_failed": "Kunde inte skapa {{count}} uppgift(er)",
        "oppdatering.todos_publish_first": "Du kan skapa uppgifter innan du publicerar.",
        "oppdatering.todo_created_badge": "Skapad",
        "oppdatering.todos_created_section": "Skapade uppgifter",
        "oppdatering.hours_title": "Föreslagna timmar",
        "oppdatering.hours_hint": "Välj vilka som ska registreras",
        "oppdatering.hours_created": "{{count}} tidsregistrering(ar) skapade",
        "oppdatering.hours_create_failed": "Kunde inte registrera {{count}} tidsregistrering(ar)",
        "oppdatering.hours_created_section": "Registrerade timmar",
        "oppdatering.hours_created_badge": "Registrerad",
        "oppdatering.hours_col_project": "Projekt",
        "oppdatering.hours_col_activity": "Aktivitet",
        "oppdatering.hours_col_description": "Beskrivning",
        "oppdatering.hours_col_time": "Timmar",
        "oppdatering.hours_col_date": "Datum",
        "oppdatering.hours_missing_project": "Välj projekt",
        "oppdatering.hours_missing_activity": "Välj aktivitet",
        "oppdatering.hours_open": "Öppna tidrapport",
        "oppdatering.new_draft": "Ny uppdatering",
        "oppdatering.already_published": "Redan publicerad — starta en ny uppdatering",
        "Lukk": "Stäng",
        "Stopp": "Stoppa",
        "Stopp opptak": "Stoppa inspelning",
        "Tolker…": "Transkriberar…",
        "Opptak støttes ikke i denne nettleseren.": "Inspelning stöds inte i den här webbläsaren.",
        "Kunne ikke transkribere lyden.": "Kunde inte transkribera ljudet.",
        "Fikk ikke tilgang til mikrofonen.": "Kunde inte komma åt mikrofonen.",
        "Fjern vedlegg": "Ta bort bilaga",
        // --- offer sidebar / route titles (exact t(title) keys) ---
        "Tilbud": "Offerter",
        "Oversikt": "Översikt",
        "Nytt tilbud": "Ny offert",
        "Offer": "Offert",
        "Offers": "Offerter",
        "Kalkyler": "Kalkyler",
        "Kalkyle": "Kalkyl",
        "Ny Kalkyle": "Ny kalkyl",
        "Timesatser": "Timpriser",
        "Timesats": "Timpris",
        "Ny Timesats": "Nytt timpris",
        "Maler": "Mallar",
        "Innstillinger": "Inställningar",
        "Templates": "Mallar",
        "Settings": "Inställningar",
        // --- offer redesign recovery keys ---
        "offers.list.title": "Offerter",
        "offers.list.subtitle": "Översikt över alla offerter och kalkyler",
        "offers.list.new": "Ny offert",
        "offers.list.import_quantity_list": "Importera mängdförteckning",
        "offers.list.import_coming_soon": "Importera mängdförteckning kommer snart.",
        "offers.list.search_placeholder": "Sök offerter...",
        "offers.list.active_only": "Aktiva offerter",
        "offers.list.offer_fallback": "Offert #{{id}}",
        "offers.list.valid_to": "Giltig till",
        "offers.list.columns.offer": "Offert",
        "offers.list.columns.customer": "Kund",
        "offers.list.columns.responsible": "Ansvarig",
        "offers.list.columns.project": "Projekt",
        "offers.list.columns.status": "Status",
        "offers.list.columns.revision": "Rev.",
        "offers.list.columns.sum": "Summa",
        "offers.list.columns.margin": "TB%",
        "offers.list.columns.updated": "Senast ändrad",
        "offers.list.empty": "Inga offerter hittades",
        "offers.list.error": "Kunde inte ladda offerter",
        "offers.stats.total_sales": "Total försäljning",
        "offers.stats.count": "Antal",
        "offers.stats.sent": "Skickad",
        "offers.stats.accepted": "Accepterad",
        "offers.stats.margin": "TB%",
        "offers.status.none": "Ingen",
        "offers.status.new": "Ny",
        "offers.status.sent": "Skickad",
        "offers.status.accepted": "Accepterad",
        "offers.status.rejected": "Avvisad",
        "offers.status.expired": "Utgången",
        "offers.status.cancelled": "Annullerad",
        "offers.info.title": "Titel",
        "offers.info.offer_number": "Offertnummer",
        "offers.info.offer_date": "Offertdatum",
        "offers.info.not_set": "Inte satt",
        "offers.info.not_assigned": "Inte tilldelat",
        "offers.info.copy": "Kopiera",
        "offers.info.valid_from": "Giltig från",
        "offers.info.valid_to": "Giltig till",
        "offers.info.currency": "Valuta",
        "offers.info.draft_revision": "Utkastrevision",
        "offers.info.accepted_revision": "Accepterad revision",
        "offers.info.none": "Ingen",
        "offers.convert.to_project": "Konvertera till projekt",
        "offers.convert.open_project": "Öppna projekt",
        "offers.convert.converting": "Konverterar…",
        "offers.convert.success": "Offerten konverterades till projekt.",
        "offers.convert.already_linked": "Offerten är redan kopplad till ett projekt.",
        "offers.convert.order_created": "Order {{order_number}} skapades från offerten.",
        "offers.convert.failed": "Kunde inte konvertera offerten till projekt.",
        "offers.errors.not_authorized": "Du har inte behörighet att utföra denna åtgärd på offerten.",
        "offers.errors.revision_locked": "Offerten är godkänd och låst. Skapa en ny revision för att redigera kalkylen.",
        "offers.send.failed": "Något gick fel. Kunde inte skicka offerten.",
        "offers.send.success": "Offerten har skickats",
        "offers.send.timeout": "Begäran tog för lång tid. Kontrollera offerstatus manuellt.",
        "offers.send.status_unconfirmed": "Utskicket är inte bekräftat ännu. Starta inte en ny leverans.",
        "offers.send.status_unconfirmed_hint": "Vi behåller samma sändningsförsök. Använd «Kontrollera status» — det skapar inte ett nytt e-postmeddelande.",
        "offers.send.check_status": "Kontrollera status",
        "offers.send.status_check_resumed": "Kontrollerar status för samma sändningsförsök …",
        "offers.send.mailed_needs_followup": "E-post har skickats, men revisionen behöver uppföljning.",
        "offers.send.mailed_needs_followup_hint": "E-postmeddelandet har redan skickats. Använd «Slutför revision» — samma sändningsförsök återupptas utan nytt e-postmeddelande.",
        "offers.send.sent_needs_attention": "E-post har skickats, men revisionen behöver uppföljning.",
        "offers.send.finish_revision": "Slutför revision",
        "offers.send.queued": "Offerten ligger i kö för utskick …",
        "offers.send.retry": "Utskicket misslyckades. Försök igen.",
        "offers.send.title": "Skicka offert",
        "offers.send.subtitle": "Välj mottagare, PDF-format och meddelande innan utskick.",
        "offers.send.revision_lock_note": "När du skickar offerten låses den aktuella revisionen. Efter utskick kan den inte ändras.",
        "offers.send.success_with_revision": "Offerten skickades (revision {{number}}).",
        "offers.history.revisions_title": "Revisioner",
        "offers.history.revisions_subtitle": "Skickade och utkastrevisioner för denna offert.",
        "offers.history.revisions_pending_api": "Full revisionslista visas när API för revisioner är klart.",
        "offers.history.revisions_empty": "Inga revisioner ännu.",
        "offers.history.revisions_empty_hint": "Ett utkast skapas automatiskt när du öppnar den här fliken. Du kan också skapa utkast manuellt, eller skicka offerten till kunden för att låsa en revision.",
        "offers.history.ensure_draft_cta": "Skapa utkastrevision",
        "offers.history.ensure_draft_success": "Utkastrevisionen är klar.",
        "offers.history.ensure_draft_failed": "Kunde inte skapa utkastrevision.",
        "offers.history.compare_need_two": "Jämförelse kräver minst två revisioner.",
        "offers.history.revisions_error": "Kunde inte hämta revisioner.",
        "offers.history.revision_number": "Revision {{number}}",
        "offers.history.revision_id_fallback": "ID {{id}}",
        "offers.history.submit_review_hint": "Skicka utkastet till intern kontroll med",
        "offers.history.send_lock_hint": "«Skicka offert» till kunden låser den aktuella revisionen.",
        "offers.history.send_lock_cta": "Skicka offert",
        "offers.history.approval_tab_hint": "Godkännande och kundens acceptans hanteras under fliken Godkännande.",
        "offers.history.lines_count": "{{count}} rader",
        "offers.history.amount": "Belopp",
        "offers.history.locked": "Låst",
        "offers.history.locked_at": "Låst",
        "offers.history.submitted_for_review_at": "Skickad till kontroll",
        "offers.history.reviewer": "Granskare",
        "offers.history.is_accepted": "Accepterad",
        "offers.history.open_pdf": "Öppna PDF",
        "offers.history.pdf_failed": "Kunde inte öppna PDF för revisionen.",
        "offers.history.accept": "Acceptera",
        "offers.history.restore_calc": "Återställ kalkyl",
        "offers.history.restore_calc_confirm": "Ersätt utkastets kalkyl med det låsta trädet från revision {{number}}? Osparade kalkyländringar går förlorade.",
        "offers.history.restore_calc_success": "Kalkyl återställd från revision {{number}}",
        "offers.history.restore_calc_failed": "Kunde inte återställa kalkyl från revision",
        "offers.history.restore_calc_note": "Återställde kalkyl från revision {{number}}",
        "offers.history.accept_success": "Revision {{number}} accepterades.",
        "offers.history.accept_failed": "Kunde inte acceptera revisionen.",
        "offers.history.revision_status.draft": "Utkast",
        "offers.history.revision_status.pending_review": "Till kontroll",
        "offers.history.revision_status.approved": "Godkänd",
        "offers.history.revision_status.issued": "Utfärdad",
        "offers.history.revision_status.sent": "Skickad",
        "offers.history.revision_status.accepted": "Accepterad",
        "offers.history.revision_status.rejected": "Avvisad",
        "offers.history.revision_status.superseded": "Ersatt",
        "offers.history.send_title": "Utskickshistorik",
        "offers.history.send_subtitle": "Översikt över varje gång denna offert har skickats.",
        "offers.history.send_empty": "Ingen utskickshistorik ännu.",
        "offers.history.send_empty_hint": "När du skickar offerten visas den här.",
        "offers.history.sent_to": "Skickad till {{recipient}}",
        "offers.history.sent_by": "Skickad av",
        "offers.history.status_delivered": "Levererad",
        "offers.history.status_pending": "Väntar",
        "offers.history.status_failed": "Misslyckades",
        "offers.approval.title": "Godkännande krävs",
        "offers.approval.subtitle": "Kontrollera nyckeltal och godkänn eller avvisa revisionen innan utskick och kundens acceptans.",
        "offers.approval.unavailable": "Godkännande är inte tillgängligt förrän revisioner är aktiverade för företaget.",

        "offers.settings.title": "Inställningar för offerter",
        "offers.settings.subtitle": "Välj vilka offertverktyg som ska vara tillgängliga för företaget.",
        "offers.settings.intro":
          "Dessa val styr flikar och arbetsflöde i offertmodulen. Rekommenderade val är markerade. Ändringar gäller hela företaget direkt.",
        "offers.settings.open_guide": "Öppna uppstartsguide för offerter",
        "offers.settings.recommended": "Rekommenderas",
        "offers.settings.saved": "Inställning sparad",
        "offers.settings.load_error": "Kunde inte läsa offertinställningar",
        "offers.settings.save_error": "Kunde inte spara inställningen",
        "offers.settings.groups.workflow": "Arbetsflöde",
        "offers.settings.groups.workflow_hint": "Checklista, intern kontroll och godkännande före utskick.",
        "offers.settings.groups.calculation": "Kalkyl",
        "offers.settings.groups.calculation_hint": "Ny kalkylmotor, formler, modulbyggare och mallar.",
        "offers.settings.groups.document": "Dokument",
        "offers.settings.groups.document_hint": "Offertdokument och AI-hjälp till text.",
        "offers.settings.groups.import": "Import och projekt",
        "offers.settings.groups.import_hint": "Mängdförteckning, anbud och konvertering till projekt.",
        "offers.settings.groups.overview": "Översikt",
        "offers.settings.groups.overview_hint": "Ny översikt och versionering av mallar.",
        "offers.settings.groups.other": "Övrigt",
        "offers.settings.groups.other_hint": "",
        "offers.settings.flags.offer_revisions.title": "Revisioner och godkännande",
        "offers.settings.flags.offer_revisions.description":
          "Ger flikarna Godkännande och Revisioner. Intern kontroll innan offerten skickas till kunden.",
        "offers.settings.flags.offer_checklist.title": "Checklista",
        "offers.settings.flags.offer_checklist.description":
          "Visar checklista-fliken på offerten så ni kan kvalitetssäkra före utskick.",
        "offers.settings.flags.offer_checklist_required_on_send.title": "Kräv checklista före utskick",
        "offers.settings.flags.offer_checklist_required_on_send.description":
          "Blockerar utskick till kunden tills checklistan är klar. Slå på efter att checklista används.",
        "offers.settings.flags.offer_calculation_v2.title": "Kalkyl v2",
        "offers.settings.flags.offer_calculation_v2.description":
          "Noggrannare summor (kostnad, täckningsbidrag och TG%) från servern. Rekommenderas.",
        "offers.settings.flags.offer_safe_formula_engine.title": "Säker formelmotor",
        "offers.settings.flags.offer_safe_formula_engine.description":
          "Tillåter bara enkla räkneformler i kalkyltyper, utan osäker kodkörning.",
        "offers.settings.flags.offer_module_builder.title": "Modulbyggare",
        "offers.settings.flags.offer_module_builder.description":
          "Visuell graf för sammansatta kalkylmoduler (aggregat, kanal och liknande).",
        "offers.settings.flags.offer_calculation_templates.title": "Kalkylmallar",
        "offers.settings.flags.offer_calculation_templates.description":
          "Utökat mallbibliotek. Att lägga till och spara kalkylmallar i en offert fungerar alltid.",
        "offers.settings.flags.offer_calculation_template_versions.title": "Versioner av kalkylmallar",
        "offers.settings.flags.offer_calculation_template_versions.description":
          "Historik och återställning av kalkylmallar.",
        "offers.settings.flags.offer_document_builder.title": "Dokumentbyggare",
        "offers.settings.flags.offer_document_builder.description":
          "Bygg offertdokumentet med textblock, förbehåll och visning mot kund.",
        "offers.settings.flags.offer_document_ai.title": "AI i dokument",
        "offers.settings.flags.offer_document_ai.description":
          "AI-hjälp till text och analys av bilagor. Kräver att dokumentbyggaren är på.",
        "offers.settings.flags.offer_import_v2.title": "Import av mängdförteckning",
        "offers.settings.flags.offer_import_v2.description":
          "Importera rader till kalkylen från fil, med produktmatchning.",
        "offers.settings.flags.offer_inquiries.title": "Anbud med flera förfrågare",
        "offers.settings.flags.offer_inquiries.description":
          "Hantera flera förfrågare på samma anbud.",
        "offers.settings.flags.offer_project_conversion_v2.title": "Konvertering till projekt",
        "offers.settings.flags.offer_project_conversion_v2.description":
          "Nytt flöde för att skapa projekt från accepterad offert.",
        "offers.settings.flags.offer_v2_overview.title": "Ny översikt",
        "offers.settings.flags.offer_v2_overview.description":
          "Rikare översikt med nyckeltal för täckningsbidrag och status.",
        "offers.settings.flags.offer_template_versions.title": "Versioner av offertmallar",
        "offers.settings.flags.offer_template_versions.description":
          "Historik för hela offertmallar, inte bara kalkylen.",
        "offers.approval.empty": "Ingen revision att hantera ännu.",
        "offers.approval.empty_hint": "Skapa eller redigera offerten för att få ett utkast. Använd «Skicka till kontroll» för intern granskning.",
        "offers.approval.approvers_title": "Godkännare",
        "offers.approval.approvers_mvp_note": "Flera godkännare och stegvis flöde kommer senare. Du godkänner med din egen användare.",
        "offers.approval.approvers_one_step_note": "Godkännande i ett steg: vald granskare visas här. Du godkänner med din egen användare när du har behörighet.",
        "offers.approval.approver_you": "Du",
        "offers.approval.approver_unassigned": "Ingen granskare vald",
        "offers.approval.approver_role": "Offertbehörighet",
        "offers.approval.approver_pending": "Väntar",
        "offers.approval.approver_done": "Klart",
        "offers.approval.approver_idle": "Redo",
        "offers.approval.pending_review_hint": "Revisionen har skickats till intern kontroll och kan godkännas.",
        "offers.approval.pending_review_hint_reviewer": "Revisionen har skickats till kontroll ({{reviewer}}) och kan godkännas.",
        "offers.approval.section_internal_title": "Internt godkännande",
        "offers.approval.section_internal_subtitle": "Intern kontroll, godkännande och avvisning. En godkänd revision låses — vidare redigering kräver en ny revision.",
        "offers.approval.section_customer_title": "Kundgodkännande",
        "offers.approval.section_customer_subtitle": "Skicka offerten till kunden och registrera kundens acceptans.",
        "offers.approval.approved_at_hint": "En tidigare revision är godkänd internt. Du arbetar nu på ett nytt utkast.",
        "offers.approval.approved_locked_hint": "Revisionen är godkänd och låst. Skapa en ny revision för att redigera vidare.",
        "offers.approval.reopen_cta": "Skapa ny revision",
        "offers.approval.reopen_success": "Ny revision skapad baserad på revision {{number}}.",
        "offers.approval.reopen_failed": "Kunde inte skapa en ny revision.",
        "offers.approval.reopen_note": "Återöppnad för redigering från revision {{number}}",
        "offers.create_revision.title": "Skapa ny revision",
        "offers.create_revision.intro":
          "Välj hur du vill gå vidare. En ny revision är rätt när du ska ändra den här offerten vidare — inte när du behöver en helt ny offert.",
        "offers.create_revision.bullet_based_on":
          "Den nya revisionen baseras på senaste låsta revision (based_on).",
        "offers.create_revision.bullet_locked":
          "Den godkända/skickade revisionen förblir låst och oförändrad.",
        "offers.create_revision.bullet_draft":
          "Du får ett redigerbart utkast som blir gällande draft.",
        "offers.create_revision.bullet_kalkyle":
          "Kalkylen låses upp för redigering på det nya utkastet.",
        "offers.create_revision.based_on_label":
          "Ny revision skapas baserad på låst revision {{number}}.",
        "offers.create_revision.choose_label": "Vad vill du göra?",
        "offers.create_revision.option_revision_title": "Skapa ny revision av den här offerten",
        "offers.create_revision.option_revision_hint":
          "Behåller offertnr. och historik. Rekommenderas efter intern godkännande eller utskick.",
        "offers.create_revision.option_copy_title": "Kopiera som ny offert",
        "offers.create_revision.option_copy_hint":
          "Bättre när du behöver en separat offert (annan kund, projekt eller variant).",
        "offers.create_revision.option_blank_title": "Starta tom offert",
        "offers.create_revision.option_blank_hint":
          "När du inte ska bygga vidare på innehållet här.",
        "offers.create_revision.already_draft":
          "Offerten har redan ett redigerbart utkast. Använd det, eller kopiera som ny offert.",
        "offers.create_revision.already_draft_hint":
          "Du har redan ett utkast. Ny revision behövs inte — fortsätt redigera, eller välj kopia/tom offert nedan.",
        "offers.create_revision.missing_locked":
          "Hittade ingen låst revision att basera en ny revision på.",
        "offers.create_revision.confirm": "Skapa revision",
        "offers.create_revision.confirm_copy": "Gå till kopiering",
        "offers.create_revision.confirm_blank": "Öppna ny offert",
        "offers.approval.approve": "Godkänn",
        "offers.approval.reject": "Avvisa",
        "offers.approval.accept": "Registrera acceptans",
        "offers.approval.send": "Skicka till kontroll",
        "offers.approval.key_figures": "Nyckeltal",
        "offers.approval.discount": "Rabatt",
        "offers.approval.workflow_hint": "Flöde: intern kontroll → godkänn (låses) → skapa ny revision vid behov → skicka offert till kund → registrera acceptans. Detaljer och PDF finns under Revisioner.",
        "offers.approval.approve_success": "Revision {{number}} godkändes och låstes.",
        "offers.approval.approve_failed": "Kunde inte godkänna revisionen.",
        "offers.approval.reject_success": "Revision {{number}} avvisades.",
        "offers.approval.reject_failed": "Kunde inte avvisa revisionen.",
        "offers.approval.api_unavailable": "Godkännande-API är inte tillgängligt ännu. Försök igen senare.",
        "offers.approval.confirm_approve_title": "Bekräfta godkännande",
        "offers.approval.confirm_approve_body": "Godkänn revision {{number}}? Revisionen låses. För att redigera vidare måste du skapa en ny revision.",
        "offers.approval.confirm_approve_submit": "Ja, godkänn",
        "offers.approval.confirm_accept_title": "Bekräfta kundacceptans",
        "offers.approval.confirm_accept_body": "Registrera att kunden har accepterat revision {{number}}?",
        "offers.approval.confirm_accept_submit": "Ja, registrera acceptans",
        "offers.approval.reject_dialog_title": "Avvisa revision",
        "offers.approval.reject_dialog_body": "Avvisa revision {{number}}. Beskriv vad som måste ändras innan offerten kan godkännas igen.",
        "offers.approval.reject_reason_label": "Vad måste ändras?",
        "offers.approval.reject_reason_placeholder": "T.ex. justera mängder, rätta priser, lägg till montage…",
        "offers.approval.reject_reason_required": "Du måste beskriva vad som måste ändras.",
        "offers.approval.reject_confirm": "Avvisa revision",
        "offers.approval.warning.low_dg": "Täckningsgrad ({{value}}) är under gränsen ({{threshold}} %).",
        "offers.approval.warning.low_dg_short": "Under gränsen {{threshold}} %",
        "offers.approval.warning.negative_margin": "Negativt täckningsbidrag — kontrollera kalkylen före godkännande.",
        "offers.approval.warning.no_lines": "Offerten saknar både kalkyl och kundrader.",
        "offers.approval.warning.lines_materialize_on_approve": "Kundrader materialiseras från kalkylen vid godkännande/sändning (ADR-005).",
        "offers.diff.title": "Jämför revisioner",
        "offers.diff.locked_calc_title": "Låst kalkyl",
        "offers.diff.locked_calc_hint": "Snapshot från revisionen — live kalkyl påverkar inte den här vyn.",
        "offers.diff.locked_calc_from": "Låst kalkyl · rev. {{number}} (från)",
        "offers.diff.locked_calc_to": "Låst kalkyl · rev. {{number}} (till)",
        "offers.diff.no_locked_calc": "Ingen kalkyl-snapshot i den här revisionen (äldre sändning före REV-001).",
        "offers.diff.no_locked_calc_public": "Ingen kalkyl-snapshot i den här revisionen.",
        "offers.diff.subtitle": "Se skillnader i ekonomi och rader mellan två revisioner.",
        "offers.diff.toggle_show": "Jämför",
        "offers.diff.toggle_hide": "Dölj jämförelse",
        "offers.diff.from": "Från",
        "offers.diff.to": "Till",
        "offers.diff.metric": "Nyckeltal",
        "offers.diff.change": "Ändring",
        "offers.diff.offer_total": "Offertsumma",
        "offers.diff.contribution_margin": "Täckningsbidrag",
        "offers.diff.contribution_margin_percent": "Täckningsgrad",
        "offers.diff.no_change": "Ingen ändring",
        "offers.diff.lines_title": "Radändringar",
        "offers.diff.added": "Tillagd",
        "offers.diff.removed": "Borttagen",
        "offers.diff.changed": "Ändrad",
        "offers.diff.no_line_changes": "Inga ändringar i raderna.",
        "offers.diff.unchanged_count": "{{count}} oförändrade rader",
        "offers.diff.untitled_line": "Utan titel",
        "offers.diff.field.quantity": "Antal",
        "offers.diff.field.sales_price": "Pris",
        "offers.diff.field.line_total": "Summa",
        "offers.diff.field.title": "Titel",
        "offers.diff.field.description": "Beskrivning",
        "offers.diff.error": "Kunde inte hämta revisionerna för jämförelse.",
        "offers.diff.empty": "Välj två revisioner att jämföra.",
        "offers.diff.same_revision": "Välj två olika revisioner för att se skillnader.",
        "offers.overview.kpi.total": "Offertsumma",
        "offers.overview.kpi.cost": "Kostnad",
        "offers.overview.kpi.contribution_margin": "Täckningsbidrag",
        "offers.overview.kpi.contribution_margin_percent": "Täckningsgrad",
        "offers.overview.kpi.probability": "Sannolikhet",
        "offers.overview.kpi.cost.info_aria": "Information om kostnad",
        "offers.overview.kpi.cost.info_body": "Kostnad är total kostpris för offerten. Värdet hämtas från sparad cost_total på offerten när den finns, annars summeras den från kalkyler (offer_calculation_v2) eller uppskattas från rader (kostpris × mängd). Detta ligger till grund för täckningsbidrag och täckningsgrad.",
        "offers.overview.kpi.contribution_margin.info_aria": "Information om täckningsbidrag",
        "offers.overview.kpi.contribution_margin.info_body": "Täckningsbidrag (DB) är försäljningssumma minus kostnad. När offerten har sparat contribution_margin används det. Annars summeras eller härleds värdet från kalkylerna, eller uppskattas som försäljning minus kostnad.",
        "offers.overview.kpi.contribution_margin_percent.info_aria": "Information om täckningsgrad",
        "offers.overview.kpi.contribution_margin_percent.info_body": "Täckningsgrad (DG%) är täckningsbidraget i procent av försäljningssumman. När contribution_margin_percent är sparat på offerten används det. Annars beräknas det som DB ÷ försäljning × 100 från kalkyl- eller uppskattade värden.",
        "offers.overview.kpi.probability.info_aria": "Information om sannolikhet",
        "offers.overview.kpi.probability.info_body": "Sannolikhet är förväntad vinstchans för offerten (0–100 %). Värdet sätts på offerten när fältet används. Det beräknas inte automatiskt från kalkyl eller rader.",
        "offers.overview.kpi.probability_empty_hint": "Inte satt",
        "offers.overview.authoritative_hint": "Serverberäknad",
        "offers.overview.estimate_hint": "Uppskattning",
        "offers.overview.negative_margin": "Negativt täckningsbidrag",
        "offers.overview.activity.title": "Aktivitet",
        "offers.overview.activity.empty": "Ingen aktivitet ännu",
        "offers.overview.activity.revision_status": "Revision {{number}} – {{status}}",
        "offers.overview.activity.converted": "Konverterad till projekt",
        "offers.overview.activity.created": "Offert skapad",
        "offers.overview.activity.today": "Idag",
        "offers.overview.activity.yesterday": "Igår",
        "offers.overview.activity.days_ago": "{{count}} dagar",
        "offers.overview.activity.with_actor": "{{text}} av {{actor}}",
        "offers.inquiries.title": "Förfrågningar / anbud",
        "offers.inquiries.subtitle": "Flera förfrågande bolag på samma offert. Kalkyl och revision delas.",
        "offers.inquiries.add": "Ny förfrågan",
        "offers.inquiries.add_title": "Ny förfrågan",
        "offers.inquiries.edit": "Redigera",
        "offers.inquiries.edit_title": "Redigera förfrågan",
        "offers.inquiries.delete": "Ta bort",
        "offers.inquiries.delete_title": "Ta bort förfrågan",
        "offers.inquiries.delete_confirm": "Är du säker på att du vill ta bort denna förfrågan?",
        "offers.inquiries.empty": "Inga förfrågningar ännu.",
        "offers.inquiries.no_contact": "Ingen kontaktperson",
        "offers.inquiries.due": "Deadline",
        "offers.inquiries.created": "Förfrågan skapad",
        "offers.inquiries.updated": "Förfrågan uppdaterad",
        "offers.inquiries.deleted": "Förfrågan borttagen",
        "offers.inquiries.save_failed": "Kunde inte spara förfrågan.",
        "offers.inquiries.delete_failed": "Kunde inte ta bort förfrågan.",
        "offers.inquiries.validation.company_required": "Välj förfrågande bolag från kundregistret.",
        "offers.inquiries.fields.company": "Förfrågande bolag",
        "offers.inquiries.fields.contact_name": "Kontaktperson",
        "offers.inquiries.fields.contact_email": "E-post",
        "offers.inquiries.fields.contact_phone": "Telefon",
        "offers.inquiries.fields.status": "Status",
        "offers.inquiries.fields.due_at": "Deadline",
        "offers.inquiries.fields.notes": "Anteckningar",
        "offers.inquiries.change_status": "Ändra status",
        "offers.inquiries.status_title": "Ändra status",
        "offers.inquiries.status_updated": "Status uppdaterad",
        "offers.inquiries.status.requested": "Efterfrågad",
        "offers.inquiries.status.in_progress": "Pågående",
        "offers.inquiries.status.offered": "Offerterad",
        "offers.inquiries.status.declined": "Avböjd",
        "offers.inquiries.status.won": "Vunnen",
        "offers.inquiries.status.lost": "Förlorad",
        "offers.banner.offer": "Offert",
        "offers.banner.new": "Ny offert",
        "offers.banner.revision": "Rev.",
        "offers.banner.project": "Projekt",
        "offers.banner.responsible": "Ansvarig",
        "offers.banner.total": "Offertsumma",
        "offers.banner.valid_to": "Giltig till",
        "offers.banner.edit": "Redigera",
        "offers.banner.send": "Skicka till kontroll",
        "offers.banner.send_offer": "Skicka offert",
        "offers.menu.send_offer": "Skicka offert",
        "offers.menu.create_revision": "Skapa ny revision",
        "offers.banner.pdf": "PDF",
        "offers.banner.pdf_simple": "PDF — enkelt",
        "offers.banner.pdf_document": "PDF — dokument",
        "offers.banner.print_current": "Skriv ut ({{layout}})",
        "offers.banner.print_other": "Annan layout ({{layout}})",
        "offers.banner.convert": "Konvertera",
        "offers.banner.more": "Fler åtgärder",
        "offers.banner.copy": "Kopiera",
        "offers.banner.delete": "Ta bort",
        "offers.banner.tabs": "Flikar",
        "offers.banner.copy_coming": "Kopiering av offerter kommer snart.",
        "offers.submit_review.title": "Skicka till kontroll",
        "offers.submit_review.description": "Markera revisionen som klar för intern granskning. Detta skickar inte offerten till kunden.",
        "offers.submit_review.reviewer_label": "Granskare (valfritt)",
        "offers.submit_review.reviewer_optional_hint": "Du kan bekräfta utan att välja granskare.",
        "offers.submit_review.confirm": "Skicka till kontroll",
        "offers.submit_review.success": "Skickad till kontroll",
        "offers.submit_review.failed": "Kunde inte skicka till kontroll.",
        "offers.submit_review.missing_revision": "Hittade ingen utkastrevision att skicka till kontroll.",
        "offers.tabs.calculation": "Kalkyl",
        "offers.tabs.overview": "Översikt",
        "offers.tabs.lines": "Kundvy",
        "offers.tabs.update_snapshot": "Uppdatera snapshot",
        "offers.template_wizard.title": "Anpassa mall före inläsning",
        "offers.template_wizard.hint": "Svara på parametrarna mallen frågar om. Sedan laddas kalkylen med dina värden.",
        "offers.template_wizard.empty": "Denna mall har inga parametrar — den laddas direkt.",
        "offers.template_wizard.apply": "Ladda mall",
        "offers.template_wizard.root_section": "Huvudkalkyl",
        "offers.tabs.advanced_menu": "Avancerat",
        "offers.tabs.enable_legacy_edit": "Tillåt legacy-radredigering",
        "offers.tabs.legacy_edit_banner": "Avancerad snapshot-redigering — inte daglig offertbyggnad. Bygg i kalkylen; detta skapar bara tillfälliga kundrader.",
        "offers.tabs.legacy_edit_locked_hint": "Kundvyn styrs från kalkyl + presentation. Aktivera legacy under Avancerat vid behov.",
        "offers.pricing.open_button": "Prismetod…",
        "offers.pricing.dialog_title": "Prismetod (påslag / mål-TG)",
        "offers.pricing.dialog_hint": "Separera påslag (kost × (1+p)) från mål-TG (kost / (1−TG)). Legacy «Påslag %» är försäljningsjustering.",
        "offers.pricing.method": "Metod",
        "offers.pricing.method_legacy": "Legacy surcharge (standard)",
        "offers.pricing.method_markup": "Påslag på kost",
        "offers.pricing.method_target_margin": "Mål-täckningsgrad",
        "offers.pricing.method_fixed_sales": "Fast försäljningspris",
        "offers.pricing.rate_percent": "Procent",
        "offers.pricing.price_status": "Prisstatus",
        "offers.pricing.status_estimated": "Estimerad",
        "offers.pricing.status_missing": "Saknas",
        "offers.pricing.status_confirmed_zero": "Bekräftad noll",
        "offers.pricing.surcharge_disabled_hint": "Inaktiverad medan prismetod är satt",
        "offers.presentation.open_button": "Presentation…",
        "offers.presentation.dialog_title": "Presentation för kund / PDF",
        "offers.presentation.dialog_hint": "En offerkalkyl. Radkalkyler visas som grupper. Välj endast summa eller visa underrader — inte flera rotkalkyler.",
        "offers.presentation.default_group": "Standard för grupper / rotkalkyl",
        "offers.presentation.default_nested": "Standard för radkalkyler",
        "offers.presentation.show_product_info": "Visa produktinfo under rader",
        "offers.presentation.show_product_info_hint": "Gäller när barn visas. Av = endast titel/pris, utan produktbeskrivning.",
        "offers.presentation.include_product_short": "Inkludera kort produktbeskrivning",
        "offers.presentation.include_product_short_hint": "Skrivs till presentationsregler och tilbudskalkylerna. Visar produktens short_description i kundvy och PDF när fältet är ifyllt.",
        "offers.presentation.tab.structure": "Struktur",
        "offers.presentation.tab.document": "Dokument",
        "offers.presentation.tab.lines": "Rader",
        "offers.presentation.include_notes": "Visa anteckningar i offerten",
        "offers.presentation.include_notes_hint": "Anteckningar från kalkylen (textrader och modulanteckningar). Av = dolda i kundvyn. Per anteckning styrs också med «Visa i offerten» på raden.",
        "offers.presentation.fields_heading": "Fält som visas på rader",
        "offers.presentation.field.description": "Beskrivning",
        "offers.presentation.field.quantity": "Antal",
        "offers.presentation.field.unit": "Enhet",
        "offers.presentation.field.unit_price": "Enhetspris",
        "offers.presentation.field.product_image": "Produktbild",
        "offers.presentation.field.product_url": "Produktlänk",
        "offers.presentation.lines_hint": "Dölj hela raden, eller stäng av enskilda fält. Bara rader som finns i kalkylen visas här — inte företagsmallar som inte används.",
        "offers.presentation.line_visible": "Synlig",
        "offers.presentation.line_fallback": "Rad {{n}}",
        "offers.presentation.empty_lines": "Inga kalkylrader ännu — bygg innehållet under Kalkyl först.",
        "offers.presentation.overview_only_hint": "Kundvyn visar bara det som lagts till i kalkylen. En kalkylmall som inte ligger som rad i översikten visas inte.",
        "offers.presentation.kind.group": "Grupp",
        "offers.presentation.kind.root_calc": "Offerkalkyl",
        "offers.presentation.kind.nested_calculation": "Radkalkyl",
        "offers.presentation.empty_tree": "Inga grupper eller kalkyler ännu — bygg struktur i Kalkyl först.",
        "offers.presentation.mode.show_children": "Visa underrader",
        "offers.presentation.mode.sum_only": "Endast summa",
        "offers.presentation.mode.hide": "Dölj",
        "offers.presentation.cancel": "Avbryt",
        "offers.presentation.save": "Spara",
        "offers.presentation.saving": "Sparar…",
        "offers.presentation.save_success": "Presentationsregler sparade",
        "offers.presentation.save_failed": "Kunde inte spara presentationsregler",
        "offers.tabs.document": "Dokument",
        "offers.tabs.attachments": "Bilagor",
        "offers.tabs.checklist": "Checklista",
        "offers.tabs.revisions": "Revisioner",
        "offers.tabs.approval": "Godkännande",
        "offers.tabs.history": "Historik",
        "offers.activity.filters.all": "Alla",
        "offers.activity.filters.kalkyle": "Kalkyl",
        "offers.activity.filters.linjer": "Rader",
        "offers.activity.filters.grupper": "Grupper",
        "offers.activity.filters.dokument": "Dokument",
        "offers.activity.filters.revisjoner": "Revisioner",
        "offers.activity.filters.import": "Import",
        "offers.activity.filters.godkjenning": "Godkännande",
        "offers.activity.filters.system": "System",
        "offers.activity.groups.this_week": "Denna vecka",
        "offers.activity.groups.last_week": "Förra veckan",
        "offers.activity.groups.older": "Äldre",
        "offers.activity.system_actor": "System",
        "offers.activity.empty_title": "Ingen aktivitet ännu",
        "offers.activity.empty_hint": "När något händer med offerten — kalkyl, revisioner, import eller godkännande — visas det här.",
        "offers.activity.error": "Kunde inte hämta aktivitetshistorik.",
        "offers.activity.error_unauthorized": "Du har inte behörighet till aktivitetshistorik.",
        "offers.activity.loading": "Laddar aktivitet…",
        "offers.activity.badge.rev": "Rev. {{number}}",
        "offers.activity.badge.version": "v{{from}} → v{{to}}",
        "offers.activity.badge.matched": "{{matched}} / {{rows}} matchade",
        "offers.activity.time.just_now": "Just nu",
        "offers.activity.time.minutes_ago": "{{count}} min sedan",
        "offers.activity.time.today_at": "Idag {{time}}",
        "offers.activity.time.yesterday_at": "Igår {{time}}",
        "offers.activity.time.days_ago": "{{count}} dagar sedan",
        "offers.activity.actions.compare_revisions": "Jämför revisioner →",
        "offers.activity.actions.view_import_log": "Visa importlogg →",
        "offers.activity.actions.open_revision": "Öppna revision →",
        "offers.activity.actions.open_related": "Öppna →",
        "offers.activity.actions.import_coming": "Import öppnas från kalkylfliken. Detaljerad logg kommer snart.",
        "offers.activity.events.unknown.title": "Aktivitet",
        "offers.activity.events.offer_created.title": "Offert skapad",
        "offers.activity.events.offer_created.title_template": "Offert skapad från mall",
        "offers.activity.events.offer_created.description": "Offerten skapades.",
        "offers.activity.events.offer_created.description_template": "Mall: {{title}}",
        "offers.activity.events.revision_created.title": "Revision {{revision_number}} skapad",
        "offers.activity.events.revision_created.description": "Revision {{revision_number}} skapades.",
        "offers.activity.events.revision_created.description_based": "Baserad på Revision {{based_on}}. {{lines}} rader registrerade.",
        "offers.activity.events.revision_approved.title": "Revision {{revision_number}} godkänd",
        "offers.activity.events.revision_approved.title_named": "Revision {{number}} godkänd",
        "offers.activity.events.revision_approved.description": "Revision {{revision_number}} godkändes internt.",
        "offers.activity.events.revision_approved.description_empty": "Godkänd utan kommentarer.",
        "offers.activity.events.revision_rejected.title": "Revision {{revision_number}} avvisad",
        "offers.activity.events.revision_rejected.description": "Revision {{revision_number}} avvisades.",
        "offers.activity.events.revision_rejected.description_with_note": "Revision {{revision_number}} avvisades: {{note}}",
        "offers.activity.events.revision_sent.title": "Revision {{revision_number}} skickad",
        "offers.activity.events.revision_sent.description": "Revision {{revision_number}} skickades till kunden.",
        "offers.activity.events.revision_submitted_for_review.title": "Revision {{revision_number}} skickad till kontroll",
        "offers.activity.events.revision_submitted_for_review.title_named": "Revision {{number}} skickad till kontroll",
        "offers.activity.events.revision_submitted_for_review.description": "Revision {{revision_number}} skickades till intern kontroll.",
        "offers.activity.events.revision_accepted.title": "Revision {{revision_number}} accepterad",
        "offers.activity.events.revision_accepted.description": "Kunden accepterade revision {{revision_number}}.",
        "offers.activity.events.calc_version_created.title": "Kalkylversion skapad",
        "offers.activity.events.calc_version_created.title_named": "{{title}} uppdaterad",
        "offers.activity.events.calc_version_created.description": "En ny kalkylversion sparades.",
        "offers.activity.events.calc_version_created.description_bump": "Version v{{from}} → v{{to}}.",
        "offers.activity.events.import_applied.title": "Mängdlista importerad",
        "offers.activity.events.import_applied.title_file": "Mängdlista importerad ({{filename}})",
        "offers.activity.events.import_applied.description": "En import tillämpades på kalkylen.",
        "offers.activity.events.import_applied.description_stats": "{{applied}} rader importerade. {{matched}} av {{rows}} matchade produktkatalogen.",
        "offers.edit.currency_option.NOK": "NOK — Norska kronor",
        "offers.edit.currency_option.SEK": "SEK — Svenska kronor",
        "offers.edit.currency_option.DKK": "DKK — Danska kronor",
        "offers.edit.currency_option.EUR": "EUR — Euro",
        "offers.edit.currency_option.USD": "USD — Amerikanska dollar",
        "offers.edit.currency_coming_soon": "kommer snart",
        "offers.edit.currency_hint": "Endast NOK kan väljas just nu.",
        "offers.help.open": "Hjälp",
        "offers.help.eyebrow": "Offertmodul",
        "offers.help.title": "Så fungerar offerter",
        "offers.help.intro": "En offert har flera flikar med olika roller. Här är en kort översikt — se dokumentationen för detaljer.",
        "offers.help.calc_vs_lines_title": "Kalkyl vs offertrader",
        "offers.help.calc_vs_lines_body": "Kalkylen är intern kostnads-/försäljningsberäkning (manuell, timmar, produkter, beräkningar). Offertrader är det kunden ser — ofta genererade från kalkylen, med synlighet per rad.",
        "offers.help.doc_vs_attachments_title": "Dokument vs bilagor",
        "offers.help.doc_vs_attachments_body": "Dokument är själva offertdokumentet (struktur, försättsblad, sektioner). Bilagor är extra filer som följer med offerten.",
        "offers.help.revisions_title": "Revisioner, godkännande och historik",
        "offers.help.revisions_body": "Revisioner hanterar utkast, PDF och diff. Godkännande är intern approve/reject och kundaccept. Historik är tidslinjen över vad som hänt.",
        "offers.help.grouping_title": "Gruppering och numrering",
        "offers.help.grouping_body": "Grupper kan ha fack/bransch och hierarkiska nummer (t.ex. Ventilation 1.0, Aggregat 1.1). Skapa och byt namn under Offertrader.",
        "offers.help.link_module": "Moduldocs",
        "offers.help.link_screens": "Skärmspecifikation",
        "offers.help.link_calculations": "Kalkyldokumentation",
        "offers.help.link_document": "Dokumentstruktur",
        "offers.groups.discipline": "Fack/bransch",
        "offers.groups.save_failed": "Kunde inte spara grupper.",
        "offers.groups.saved": "Grupper sparade.",
        "offers.groups.prompt_child_title": "Titel på undergrupp",
        "offers.groups.prompt_top_title": "Grupptitel (t.ex. Ventilation)",
        "offers.groups.add_top": "Ny grupp",
        "offers.groups.add_child": "Ny undergrupp",
        "offers.groups.rename": "Byt namn",
        "offers.groups.edit": "Redigera grupp",
        "offers.groups.delete": "Ta bort grupp",
        "offers.groups.delete_confirm": "Ta bort strukturgruppen «{{title}}»? Rader i gruppen blir kvar utan grupp.",
        "offers.groups.delete_confirm_with_children": "Ta bort «{{title}}» och {{count}} undergrupp(er)? Rader blir kvar utan grupp.",
        "offers.groups.edit_hint": "Dubbelklicka eller använd pennan för att redigera",
        "offers.groups.dialog_title_create": "Ny strukturgrupp",
        "offers.groups.dialog_title_edit": "Redigera strukturgrupp",
        "offers.groups.field_title": "Titel",
        "offers.groups.field_description": "Beskrivning",
        "offers.groups.field_discipline": "Fack",
        "offers.groups.field_parent": "Välj överordnad grupp. Tom = toppnivå.",
        "offers.groups.field_number": "Nummer",
        "offers.groups.field_group_type": "Grupptyp",
        "offers.groups.group_type_default": "Ej angiven",
        "offers.groups.group_type_discipline": "Fack",
        "offers.groups.group_type_section": "Sektion",
        "offers.groups.parent_root": "Toppnivå (rot)",
        "offers.groups.move_to": "Flytta till…",
        "offers.groups.save": "Spara",
        "offers.groups.cancel": "Avbryt",
        "offers.groups.empty_title": "Inga grupper ännu",
        "offers.groups.empty_hint": "Använd «Ny struktur» i radeditorn eller + i strukturpanelen för att skapa fackgrupper (1.0, 1.1, …).",
        "offers.groups.title_required": "Titel krävs.",
        "offers.groups.panel_title": "Fack och grupper",
        "offers.groups.panel_hint": "Redigeras i kalkylfliken strukturpanel (nummer 1.0, 1.1, …).",
        "offers.groups.saving": "Sparar…",
        "offers.groups.save_rename": "Spara",
        "offers.groups.selected": "Vald grupp",
        "offers.groups.select_hint": "Välj en grupp i trädet, eller lägg till ny.",
        "offers.groups.untitled": "Utan titel",
        "offers.groups.rename_hint": "Dubbelklicka för att byta namn",
        "offers.groups.ungrouped": "Utan grupp",
        "offers.groups.move_line": "Flytta till grupp",
        "offers.groups.folder_aria": "Mapp {{name}}",
        "offers.help.open_short": "Hjälp",
        "offers.activity.events.currency_changed.title": "Valuta ändrad ({{from}} → {{to}})",
        "offers.activity.events.currency_changed.description": "Offertvaluta ändrades från {{from}} till {{to}}.",
        "offers.activity.events.document_structure_changed.title": "Dokumentstruktur uppdaterad",
        "offers.activity.events.document_structure_changed.description": "Block i utgående dokument ändrades.",
        "offers.activity.events.template_loaded.title": "Mall laddad",
        "offers.activity.events.template_loaded.title_named": "Mall laddad: {{title}}",
        "offers.activity.events.template_loaded.description": "Innehåll laddades från en mall.",
        "offers.activity.events.lines_changed.title": "Offertrader ändrade",
        "offers.activity.events.lines_changed.description": "{{created}} tillagda, {{updated}} uppdaterade, {{deleted}} borttagna.",
        "offers.activity.events.groups_changed.title": "Grupper ändrade",
        "offers.activity.events.groups_changed.description": "{{created}} tillagda, {{updated}} uppdaterade, {{deleted}} borttagna.",
        "offers.activity.events.lines_generated.title": "Rader genererade från kalkyl",
        "offers.activity.events.lines_generated.title_count": "{{count}} rader genererade från kalkyl",
        "offers.activity.events.lines_generated.description": "Kundvända offertrader genererades från kalkylen.",
        "offers.activity.events.lines_generated_from_calculation.title": "Rader genererade från kalkyl",
        "offers.activity.events.lines_generated_from_calculation.description": "Kundvända offertrader genererades från kalkylen.",
        "offers.activity.events.offer_accepted.title": "Offert accepterad",
        "offers.activity.events.offer_accepted.description": "Offerten accepterades.",
        "offers.activity.events.calculation_lines_changed.title": "Kalkylrader ändrade",
        "offers.activity.events.calculation_lines_changed.description": "Rader i kalkylen uppdaterades.",
        "offers.tabs.lines_coming_title": "Offertrader kommer snart",
        "offers.tabs.lines_coming_desc": "Redigering av offertrader flyttas hit i en senare uppdatering.",
        "offers.tabs.document_coming_title": "Dokument kommer snart",
        "offers.tabs.document_coming_desc": "Försättsblad och dokumentupplägg för offerten flyttas hit i en senare uppdatering.",
        "offers.tabs.lines_intro": "Kundvända rader, text, kalkyler och grupperingar som visas på offerten.",
        "offers.tabs.lines_customer_hint": "Kundens vy — genererad från kalkylen. Interna priser och detaljering döljs.",
        "offers.tabs.lines_customer_hint_public": "Kundens vy — genererad från kalkylen. Interna priser och detaljering döljs.",
        "offers.tabs.lines_view.label": "Visningsval",
        "offers.tabs.lines_view.hint": "Visningsval styr hur raderna grupperas för kund/PDF. Inkludering (inkl./valfri/dold) på varje rad avgör om kunden ser den.",
        "offers.tabs.lines_view.per_calc": "Per kalkyl",
        "offers.tabs.lines_view.kapittel": "Kapitel",
        "offers.tabs.lines_view.flat": "Platt lista",
        "offers.tabs.lines_view.kundegrupper": "Endast kundgrupper",
        "offers.tabs.lines_view.ungrouped": "Utan grupp",
        "offers.tabs.generate_from_calculation": "Generera från kalkyl",
        "offers.tabs.generate_from_calculation_success": "Offertrader genererade från kalkyl.",
        "offers.tabs.generate_from_calculation_failed": "Kunde inte generera offertrader från kalkyl.",
        "offers.tabs.generate_from_calculation_empty": "Ingen kalkyl att generera från. Lägg till en kalkyl först.",
        "offers.tabs.columns.chapter": "Kapitel / beskrivning",
        "offers.tabs.columns.qty": "Antal",
        "offers.tabs.columns.unit": "Enh.",
        "offers.tabs.columns.unit_price": "Enhetspris",
        "offers.tabs.columns.line_sum": "Radsumma",
        "offers.tabs.columns.visible": "Synlig",
        "offers.tabs.lines_empty_title": "Inga kundrader än",
        "offers.tabs.lines_empty_desc": "Bygg offerten i kalkylen. Kundvyn genereras automatiskt — manuell redigering finns under Avancerat.",
        "offers.printLinesPreview.toggle": "Förhandsgranska rader",
        "offers.printLinesPreview.edit_mode": "Redigera",
        "offers.printLinesPreview.empty": "Inga synliga rader för kunden",
        "offers.printLinesPreview.empty_no_lines": "Inga erbjudanderader ännu",
        "offers.printLinesPreview.empty_all_hidden": "Alla rader är dolda för kunden",
        "offers.printLinesPreview.empty_hint": "Lägg till rader, eller generera från kalkylen. Sätt inkludering till «Inkluderad» för att visa dem här.",
        "offers.printLinesPreview.empty_hidden_hint": "{{count}} rad(er) är dolda. Ändra inkludering under Redigera för att visa dem för kunden.",
        "offers.printLinesPreview.total": "Summa exkl. moms",
        "offers.printLinesPreview.mode_hint": "Så visas raderna på PDF/utskrift (kundens vy).",
        "offers.printLinesPreview.mode_hint_document": "Utskriften är det utformade dokumentet till vänster — samma PDF som kunden får. Radtabellen är prisavsnittet.",
        "offers.tabs.calculation_use_template": "Från mall",
        "offers.tabs.calculation_new": "Ny kalkyl",
        "offers.tabs.calculation_empty": "Inga kalkyler ännu",
        "offers.tabs.calculation_empty_hint": "Kalkyl är valfritt. Du kan fortsätta med offertrader utan, eller lägga till en kalkyl om du behöver den.",
        "offers.tabs.calculation_added": "Kalkyl tillagd i offerten",
        "offers.tabs.calculation_load_failed": "Kunde inte ladda kalkyl",
        "offers.tabs.calculation_save_failed": "Kunde inte spara kalkylen. Ändringen är inte sparad ännu.",
        "offers.tabs.calculation_conflict": "Kalkylen har ändrats i en annan flik eller av en annan användare. Raderade rader behålls lokalt — ladda om innan du sparar igen.",
        "offers.tabs.calculation_conflict_resolve_hint": "Autosparning är pausad. Välj «Använd mina» för att spara dina lokala ändringar ovanpå serverversionen, eller «Använd senaste sparade version» för att kasta lokala ändringar.",
        "offers.tabs.calculation_conflict_use_mine": "Använd mina",
        "offers.tabs.calculation_conflict_blocked": "Lös konflikten innan du sparar eller skickar.",
        "offers.tabs.calculation_conflict_server_unavailable": "Kunde inte hämta senaste sparade versionen. Försök «Använd senaste sparade versionen» igen, eller «Använd mina».",
        "offers.tabs.calculation_locked_title": "Kalkylen är skrivskyddad",
        "offers.tabs.calculation_locked_hint": "Offerten är godkänd av granskare och låst. Skapa en ny revision under Godkännande för att redigera vidare.",
        "offers.tabs.calculation_locked_save": "Kunde inte spara — offerten är låst. Skapa en ny revision för att redigera kalkylen.",
        "offers.tabs.calculation_locked_empty": "Ingen kalkyl att visa. Skapa en ny revision för att bygga kalkyl.",
        "offers.tabs.calculation_removed": "Kalkyl borttagen",
        "offers.tabs.calculation_remove": "Ta bort",
        "offers.tabs.calculation_remove_confirm": "Är du säker på att du vill ta bort den här kalkylen från offerten?",
        "offers.tabs.calculation_select_title": "Välj kalkyl",
        "offers.tabs.calculation_select_template_title": "Välj kalkylmall",
        "offers.tabs.calculation_select_template_as_line": "Välj kalkylmall som rad",
        "offers.tabs.calculation_select_template_replace": "Ladda in kalkylmall på kalkylsidan",
        "offers.tabs.calculation_select_template_attach": "Koppla kalkylmall till rad",
        "offers.tabs.calculation_replace_template_confirm": "Ersätt innehållet på kalkylsidan med den valda mallen? Befintliga rader ersätts.",
        "offers.tabs.calculation_template_loaded": "Kalkylmall inläst",
        "offers.tabs.calculation_line_added": "Kalkylmall tillagd som rad i kalkylen",
        "offers.tabs.calculation_untitled": "Kalkyl {{n}}",
        "offers.tabs.calculation_page_title": "Kalkyl",
        "offers.tabs.calculation_creating": "Skapar kalkyl…",
        "offers.menu.save_as": "Spara som ny offert",
        "offers.menu.overwrite": "Skriv över befintlig offert",
        "offers.menu.save_as_template": "Spara som offertmall",
        "offers.menu.save_to_template": "Uppdatera offertmall…",
        "offers.menu.template_versions": "Versionshistorik (mall)",
        "offers.save_as.title": "Spara som ny offert",
        "offers.save_as.description": "Skapa en kopia av denna offert som en ny, oberoende offert.",
        "offers.save_as.reference_label": "Referens (valfritt)",
        "offers.save_as.reference_placeholder": "T.ex. titel på den nya offerten",
        "offers.save_as.customer_label": "Kund (valfritt)",
        "offers.save_as.project_label": "Projekt (valfritt)",
        "offers.save_as.confirm": "Spara som ny offert",
        "offers.save_as.success": "Offerten sparades som en ny offert",
        "offers.save_as.failed": "Kunde inte spara som ny offert",
        "offers.overwrite.title": "Skriv över befintlig offert",
        "offers.overwrite.warning": "Denna åtgärd skriver över innehållet i den valda offerten med innehållet i denna offert. Detta kan inte ångras.",
        "offers.overwrite.search_placeholder": "Sök efter offerter …",
        "offers.overwrite.no_results": "Inga offerter hittades",
        "offers.overwrite.confirm_label": "Skriv «{{number}}» för att bekräfta",
        "offers.overwrite.confirm": "Skriv över offert",
        "offers.overwrite.success": "Offert {{number}} skrevs över",
        "offers.overwrite.failed": "Kunde inte skriva över offerten",
        "offers.save_as_template.title": "Spara som offertmall",
        "offers.save_as_template.description": "Spara innehållet i denna offert som en ny offertmall för framtida offerter.",
        "offers.save_as_template.reference_label": "Referens (valfritt)",
        "offers.save_as_template.reference_placeholder": "Namn på mallen",
        "offers.save_as_template.change_note_label": "Kommentar till versionen (valfritt)",
        "offers.save_as_template.confirm": "Spara som mall",
        "offers.save_as_template.success": "Offerten sparades som offertmall",
        "offers.save_as_template.failed": "Kunde inte spara offerten som mall",
        "offers.save_to_template.title": "Uppdatera offertmall",
        "offers.save_to_template.description": "Välj en befintlig offertmall som ska uppdateras med innehållet i denna offert.",
        "offers.save_to_template.search_placeholder": "Sök efter offertmallar …",
        "offers.save_to_template.no_results": "Inga offertmallar hittades",
        "offers.save_to_template.change_note_label": "Kommentar till versionen (valfritt)",
        "offers.save_to_template.confirm": "Uppdatera mall",
        "offers.save_to_template.success": "Offertmallen uppdaterades",
        "offers.save_to_template.failed": "Kunde inte uppdatera offertmallen",
        "offers.versions.title": "Versionshistorik",
        "offers.versions.template_title": "Versionshistorik (mall)",
        "offers.versions.load_failed": "Kunde inte ladda versionshistorik",
        "offers.versions.unavailable": "Versionshistorik är inte tillgänglig ännu.",
        "offers.versions.empty": "Inga versioner registrerade ännu",
        "offers.versions.empty_hint": "Versioner skapas automatiskt när ändringar sparas.",
        "offers.versions.restore": "Återställ",
        "offers.versions.confirm_restore": "Bekräfta återställning",
        "offers.versions.restore_success": "Versionen återställdes",
        "offers.versions.restore_failed": "Kunde inte återställa versionen",
        "offers.versions.version_number": "Version {{number}}",
        "offers.versions.by": "Av {{name}}",
        "offers.templates.versions.title": "Versionshistorik för offertmall",
        "offers.calculation.versions.title": "Versionshistorik",
        "offers.calculation.template_actions.menu_label": "Mall",
        "offers.calculation.template_actions.versions": "Mallversioner",
        "offers.calculation.template_actions.versions_title": "Mallversioner",
        "offers.calculation.template_actions.update_template": "Uppdatera mall",
        "offers.calculation.template_actions.update_description": "Uppdatera kalkylmallen med innehållet i denna offertspecifika kalkyl. Ändringen gäller för all framtida användning av mallen.",
        "offers.calculation.template_actions.update_confirm": "Uppdatera mall",
        "offers.calculation.template_actions.update_success": "Kalkylmallen uppdaterades",
        "offers.calculation.template_actions.update_failed": "Kunde inte uppdatera kalkylmallen",
        "offers.calculation.template_actions.save_new_template": "Spara som ny mall",
        "offers.calculation.template_actions.save_new_description": "Spara denna kalkyl som en helt ny kalkylmall.",
        "offers.calculation.template_actions.save_new_confirm": "Spara som ny mall",
        "offers.calculation.template_actions.save_new_success": "Kalkylen sparades som ny mall",
        "offers.calculation.template_actions.save_new_failed": "Kunde inte spara kalkylen som ny mall",
        "offers.calculation.template_actions.title_label": "Namn på ny mall",
        "offers.calculation.template_actions.title_placeholder": "T.ex. Standard elarbete",
        "offers.calculation.template_actions.title_required": "Du måste ange ett namn på den nya mallen",
        "offers.calculation.template_actions.change_note_label": "Kommentar till versionen (valfritt)",
        "offers.calculation.template_actions.change_note_placeholder": "Vad ändrades?",
        "offers.calculation.selector.title": "Välj kalkylmall",
        "offers.calculation.selector.title_multiple": "Välj kalkylmallar",
        "offers.calculation.selector.search_placeholder": "Sök kalkylmallar…",
        "offers.calculation.selector.loading": "Laddar kalkylmallar…",
        "offers.calculation.selector.error": "Kunde inte ladda kalkylmallar",
        "offers.calculation.selector.empty": "Inga kalkylmallar ännu",
        "offers.calculation.selector.empty_hint": "Företagets mallar skapas under Offerter → Kalkyler, eller genom att spara kalkylen du arbetar med som mall.",
        "offers.calculation.selector.empty_search": "Inga mallar matchar sökningen",
        "offers.calculation.selector.create_template": "Skapa mall",
        "offers.calculation.selector.load_more": "Ladda fler mallar",
        "offers.calculation.selector.selected_count": "{{count}} valda",
        "offers.calculation.selector.clear": "Rensa val",
        "offers.calculation.selector.close": "Stäng",
        "offers.calculation.selector.total": "Totalt",
        "offers.calculation.selector.type": "Typ",
        "offers.calculation.selector.untitled": "Kalkyl #{{id}}",
        "offers.calculation.nested.edit_title": "Redigera kalkyl: {{title}}",
        "offers.calculation.nested.eyebrow": "Redigera kalkyl",
        "offers.calculation.nested.offer_only_hint": "Ändringar gäller bara denna offert. Företagsmallen uppdateras inte.",
        "offers.calculation.nested.save": "Spara",
        "offers.calculation.nested.save_success": "Kalkylen sparades för denna offert",
        "offers.calculation.nested.tab_products": "Produkter och fält",
        "offers.calculation.nested.tab_notes": "Anteckningar",
        "offers.calculation.nested.tab_display": "Visning",
        "offers.calculation.nested.tab_builder": "Modulbyggare",
        "offers.calculation.nested.products_panel_hint": "Koppla rader till produkter i registret och uppdatera priser. Detta är huvudytan för dagligt arbete på linjekalkylen.",
        "offers.calculation.nested.no_product_catalogs": "Inga produktlistnoder i den här modulen ännu. Lägg till «Produktlista» i modulbyggaren.",
        "offers.calculation.nested.unit_total_label": "Enhetssumma (modul)",
        "offers.calculation.nested.unit_total_hint": "Radsumma i offerten = antal × denna enhetssumma.",
        "offers.calculation.nested.notes_heading": "Anteckningar i modul",
        "offers.calculation.nested.notes_panel_hint": "Redigera modulanteckningar och välj vad som ska visas i offerten/PDF. Ordningen här styr ordningen i offertexten.",
        "offers.calculation.nested.notes_offer_text_hint": "Valfri kundtext för hela modulen (visas i offerten när den är ifylld).",
        "offers.calculation.nested.notes_empty": "Inga anteckningsnoder i modulen ännu. Lägg till «Anteckning» i modulbyggaren.",
        "offers.calculation.nested.notes_item_label": "Anteckning {{n}}",
        "offers.calculation.nested.notes_body_placeholder": "Skriv anteckningstexten…",
        "offers.calculation.nested.notes_show_in_offer_hint": "Iklickad = texten blir kundtext i offerten/PDF. Synlig som standard.",
        "offers.calculation.nested.tab_lines": "Rader",
        "offers.calculation.nested.display.panel_hint": "Styr hur den här kalkylen, underliggande moduler/rader och produkter visas för kunden och i PDF. Innehåll och priser redigeras i de andra flikarna.",
        "offers.calculation.nested.display.structure_heading": "Struktur för kunden",
        "offers.calculation.nested.display.structure_hint": "Välj om kunden ser underrader, endast summa, eller om noden döljs. Sparas i offertens presentationsregler.",
        "offers.calculation.nested.display.structure_needs_offer": "Strukturregler kräver att kalkylen är kopplad till en offert.",
        "offers.calculation.nested.display.show_product_info_hint": "Gäller hela offerten när underrader visas. Av = endast titel/pris utan produktbeskrivning.",
        "offers.calculation.nested.display.content_heading": "Innehåll i offert/PDF",
        "offers.calculation.nested.display.content_hint": "Befintliga show_*-fält på den här kalkylen.",
        "offers.calculation.nested.display.show_hours": "Visa timantal",
        "offers.calculation.nested.display.show_hours_hint": "Visa timmar för den här kalkylen i offert/PDF.",
        "offers.calculation.nested.display.show_quantities": "Visa mängder",
        "offers.calculation.nested.display.show_quantities_hint": "Visa mängder för rader under den här kalkylen.",
        "offers.calculation.nested.display.show_products": "Visa produkter",
        "offers.calculation.nested.display.show_products_hint": "Visa produktrader i offert/PDF.",
        "offers.calculation.nested.display.show_setup_only": "Endast uppsättning (titel/summa)",
        "offers.calculation.nested.display.show_setup_only_hint": "När på: endast titel, beskrivning och delsumma — inte produkter eller timberäkning.",
        "offers.calculation.nested.display.show_quantities_offer_item": "Endast mängd på offertrad",
        "offers.calculation.nested.display.show_quantities_offer_item_hint": "Dölj antal på underliggande produkter; visa mängd på offertraden.",
        "offers.calculation.nested.display.include_product_short": "Inkludera kort produktbeskrivning",
        "offers.calculation.nested.display.include_product_short_hint": "Visa produktens short_description när bild/URL visas.",
        "offers.calculation.nested.display.products_heading": "Produktrader",
        "offers.calculation.nested.display.products_hint": "Synlighet per rad (bild, URL, timmar) sparad på raden.",
        "offers.calculation.nested.display.product_line_fallback": "Produktrad {{n}}",
        "offers.calculation.nested.display.line_show_hours": "Visa timmar på raden",
        "offers.calculation.nested.display.notes_heading": "Anteckningssynlighet",
        "offers.calculation.nested.display.notes_hint": "Samma show_in_offer som under Anteckningar — här bara synlighet, inte textinnehåll.",
        "offers.calculation.nested.this_calculation": "Denna kalkyl",
        "offers.calculation.nested.structure_heading": "Kalkylstruktur",
        "offers.calculation.nested.structure_hint": "Nästlade kalkylmallar under denna rad. Öppna för att redigera rekommenderade fält och struktur på varje nivå.",
        "offers.calculation.nested.edit_structure": "Redigera",
        "offers.calculation.nested.back_in_tree": "Tillbaka",
        "offer.calculation.line.insert_title": "Rekommenderade fält",
        "offer.calculation.line.insert_hint": "Fält mallen lämnar öppna för redigering. Öppna kalkyl-dialogen för produkter och priser.",
        "offer.calculation.line.insert_locked": "Alla fält är låsta i mallen. Öppna modulbyggaren för att redigera.",
        "offer.calculation.line.open_builder": "Öppna kalkyl",
        "offer.calculation.line.products_in_builder": "Produkter redigeras under Produkter och fält.",
        "offer.calculation.line.products_jump": "Gå till produktlista",
        "offer.calculation.line.insert_needs_attention": "Rekommenderade fält har inte gåtts igenom ännu",
        "offer.calculation.line.insert_done": "Klar",
        "offer.calculation.line.qty_times_unit": "Antal × enhetspris: {{formula}}",
        "offer.calculation.line.module_notes_count": "{{count}} anteckning i modul",
        "offer.calculation.line.module_notes_count_plural": "{{count}} anteckningar i modul",
        "offers.calculation.save_template_dialog.title": "Spara kalkylmall?",
        "offers.calculation.save_template_dialog.description": "Du redigerar en kalkylmall från en offert. Vill du även uppdatera mallen, eller bara spara ändringarna för denna offert?",
        "offers.calculation.save_template_dialog.update_template": "Uppdatera mall",
        "offers.calculation.save_template_dialog.update_template_hint": "Ändringarna gäller för all framtida användning av denna mall.",
        "offers.calculation.save_template_dialog.offer_only": "Endast för denna offert",
        "offers.calculation.save_template_dialog.offer_only_hint": "Ändringarna sparas endast för denna offert. Mallen förblir oförändrad.",
        "offers.calculation.save_template_dialog.save_failed": "Kunde inte spara kalkylen",
        "offers.tabs.document_intro": "Det utgående offertdokumentet — struktur och förhandsvisning för utskick och PDF. Detta är inte en generell fillista.",
        "offers.documentBuilder.structure_title": "Dokumentstruktur",
        "offers.documentBuilder.add_block": "+ Lägg till block",
        "offers.documentBuilder.move_up": "Flytta upp",
        "offers.documentBuilder.move_down": "Flytta ner",
        "offers.documentBuilder.saving": "Sparar…",
        "offers.documentBuilder.saved": "Sparat",
        "offers.documentBuilder.blocks.cover": "Försättsblad",
        "offers.documentBuilder.blocks.letter": "Offertbrev",
        "offers.documentBuilder.blocks.project_description": "Projektbeskrivning",
        "offers.documentBuilder.blocks.scope": "Leveransomfattning",
        "offers.documentBuilder.blocks.price": "Pris",
        "offers.documentBuilder.blocks.alternatives": "Alternativ",
        "offers.documentBuilder.blocks.attachments": "Bilagor",
        "offers.documentBuilder.blocks.signature": "Signatur",
        "offers.documentBuilder.blocks.custom_text": "Egen text",
        "offers.documentBuilder.preview.label": "Förhandsvisning",
        "offers.documentBuilder.preview.title_prefix": "Offert:",
        "offers.documentBuilder.preview.untitled": "Utan titel",
        "offers.documentBuilder.preview.rev": "Rev. {{rev}}",
        "offers.documentBuilder.preview.price_label": "Offertsumma exkl. moms",
        "offers.documentBuilder.preview.attachments_placeholder": "Bilagor listas i det färdiga dokumentet. Ladda upp filer under fliken Bilagor.",
        "offers.documentBuilder.preview.empty_section": "Ingen text ännu",
        "offers.documentBuilder.preview.alternatives_hint": "Alternativ och valfria tillägg ingår inte i offertsumman om de inte väljs.",
        "offers.documentBuilder.preview.alternative_selected": "Valt i offerten",
        "offers.documentBuilder.preview.alternative_option": "Alternativ",
        "offers.documentBuilder.preview.optional_extras": "Valfria tillägg",
        "offers.documentBuilder.editor.title_label": "Titel",
        "offers.documentBuilder.editor.body_label": "Text",
        "offers.documentBuilder.editor.body_placeholder": "Skriv innehåll för den här sektionen…",
        "offers.documentBuilder.editor.title_placeholder": "Blockets titel",
        "offers.documentBuilder.editor.custom_section": "Eget textblock",
        "offers.documentBuilder.editor.price_hint": "Priset hämtas live från offertsumman (exkl. moms) och kan inte redigeras här.",
        "offers.documentBuilder.editor.attachments_hint": "Detta block är en sektion i dokumentstrukturen. Filer hanteras under fliken Bilagor.",
        "offers.documentBuilder.editor.offer_edit_sourced_hint": "Texten redigeras under «Redigera offert → Projektbeskrivning».",
        "offers.documentBuilder.editor.alternatives_hint": "Alternativ hämtas automatiskt från rader med alternativgrupp eller rollen «valfri». Du kan lägga till inledningstext under Avancerad layout vid behov.",
        "offers.documentBuilder.preview.page_break": "Sidbrytning",
        "offers.documentBuilder.preview.refresh": "Uppdatera förhandsvisning",
        "offers.documentBuilder.preview.showing_saved": "Visar sparad version",
        "offers.documentBuilder.preview.loading": "Laddar förhandsvisning…",
        "offers.documentBuilder.preview.pdf_failed": "Kunde inte ladda PDF-förhandsvisning",
        "offers.documentBuilder.preview.empty_live": "Ingen PDF att visa ännu. Uppdatera förhandsvisningen när dokumentet är sparat.",
        "offers.documentBuilder.preview.show_html_mock": "Visa HTML-skiss",
        "offers.documentBuilder.preview.show_live_pdf": "Visa live-PDF",
        "offers.documentBuilder.editor.inspector_title": "Blockinställningar",
        "offers.documentBuilder.editor.inspector_subtitle": "{{type}} — innehåll och inställningar för denna sektion",
        "offers.documentBuilder.editor.settings_title": "Inställningar",
        "offers.documentBuilder.editor.enabled_label": "Aktiv",
        "offers.documentBuilder.editor.enabled_hint": "Visa denna sektion i dokumentet",
        "offers.documentBuilder.editor.show_in_pdf_label": "Visa i PDF",
        "offers.documentBuilder.editor.show_in_pdf_hint": "Inkludera sektionen när offerten exporteras till PDF",
        "offers.documentBuilder.editor.page_break_label": "Sidbrytning före",
        "offers.documentBuilder.editor.page_break_hint": "Starta denna sektion på en ny sida i PDF:en",
        "offers.documentBuilder.editor.heading_level_label": "Rubriknivå",
        "offers.documentBuilder.editor.heading_level_none": "Ingen",
        "offers.documentBuilder.editor.visibility_label": "Synlighet",
        "offers.documentBuilder.editor.visibility_all": "Överallt",
        "offers.documentBuilder.editor.visibility_pdf_only": "Endast PDF",
        "offers.documentBuilder.editor.visibility_screen_only": "Endast skärm",
        "offers.documentBuilder.editor.advanced_layout": "Avancerad layout",
        "offers.documentBuilder.editor.padding_label": "Inre marginal (padding)",
        "offers.documentBuilder.editor.margin_label": "Yttre marginal (margin)",
        "offers.documentBuilder.editor.side_top": "Topp",
        "offers.documentBuilder.editor.side_right": "Höger",
        "offers.documentBuilder.editor.side_bottom": "Botten",
        "offers.documentBuilder.editor.side_left": "Vänster",
        "offers.documentBuilder.editor.load_template": "Läs in Promang-mall",
        "offers.documentBuilder.editor.cover.settings_title": "Försättsbladsinställningar",
        "offers.documentBuilder.editor.cover.subtitle_label": "Undertitel",
        "offers.documentBuilder.editor.cover.subtitle_placeholder": "Skriv en undertitel för försättsbladet…",
        "offers.documentBuilder.editor.cover.show_customer_label": "Visa kund",
        "offers.documentBuilder.editor.cover.show_offer_date_label": "Visa offertdatum",
        "offers.documentBuilder.editor.cover.image_hint": "Försättsbladsbilden anges i Försättsblad-sektionen nedan och återanvänds automatiskt för detta block.",
        "offers.documentBuilder.editor.letter.settings_title": "Brevinställningar",
        "offers.documentBuilder.editor.letter.greeting_label": "Hälsning",
        "offers.documentBuilder.editor.letter.greeting_placeholder": "T.ex. \"Hej,\"",
        "offers.documentBuilder.editor.letter.signoff_label": "Avslutning",
        "offers.documentBuilder.editor.letter.signoff_placeholder": "T.ex. \"Med vänlig hälsning\"",
        "offers.documentBuilder.editor.price.settings_title": "Prisinställningar",
        "offers.documentBuilder.editor.price.show_vat_label": "Visa moms",
        "offers.documentBuilder.editor.price.show_summary_table_label": "Visa sammanfattningstabell",
        "offers.documentBuilder.editor.price.note_label": "Anteckning",
        "offers.documentBuilder.editor.price.note_placeholder": "Valfri anteckning under priset…",
        "offers.documentBuilder.editor.signature.settings_title": "Signaturinställningar",
        "offers.documentBuilder.editor.signature.show_date_field_label": "Visa datumfält",
        "offers.documentBuilder.editor.signature.show_title_field_label": "Visa titelfält",
        "offers.documentBuilder.editor.signature.signatory_count_label": "Antal signaturer",
        "offers.tabs.attachments_intro": "Generella bilagor och dokumentation för offerten (Promang DocumentManager). Ladda upp filer här.",
        "offers.tabs.save_lines": "Spara rader",
        "offers.tabs.no_offer": "Offerten måste sparas innan du kan redigera detta.",
        "offers.edit.title": "Redigera offert",
        "offers.edit.tab.stamdata": "Stamdata",
        "offers.edit.tab.comments": "Kommentarer",
        "offers.edit.tab.project_description": "Projektbeskrivning",
        "offers.edit.customer": "Kund",
        "offers.edit.customer_required": "Kund krävs",
        "offers.edit.contact": "Kundkontakt",
        "offers.edit.project": "Projekt",
        "offers.edit.department": "Avdelning",
        "offers.edit.responsible": "Vår kontaktperson",
        "offers.edit.currency": "Valuta",
        "offers.edit.offer_title": "Titel",
        "offers.edit.offer_number": "Offertnummer",
        "offers.edit.reference": "Referens",
        "offers.edit.offer_date": "Offertdatum",
        "offers.edit.valid_from": "Giltig från",
        "offers.edit.valid_to": "Giltig till",
        "offers.edit.comment": "Kommentar",
        "offers.edit.comment_hint": "Används i det enkla PDF-upplägget.",
        "offers.edit.comment_placeholder": "Skriv en kommentar till offerten…",
        "offers.edit.project_description": "Projektbeskrivning",
        "offers.edit.project_description_hint": "Visas i dokumentupplägg och utskrift.",
        "offers.edit.project_description_placeholder": "Beskriv projektet…",
        "offers.edit.scope": "Omfattning / Leveransomfattning",
        "offers.edit.scope_hint": "Visas i dokumentupplägg och utskrift.",
        "offers.edit.scope_placeholder": "Beskriv omfattning och leverans…",
        "offers.edit.cancel": "Avbryt",
        "offers.edit.save": "Spara",
        "offers.edit.saving": "Sparar…",
        "offers.delete.confirm": "Denna offert tas bort permanent och kan inte återställas.",
        "offers.create.title": "Skapa offert",
        "offers.create.intro": "Fyll i grunduppgifterna för att starta en ny offert.",
        "offers.create.customer": "Kund",
        "offers.create.customer_required": "En kund måste väljas innan offerten kan skapas.",
        "offers.create.project": "Projekt",
        "offers.create.contact": "Kundkontakt",
        "offers.create.responsible": "Vår kontaktperson",
        "offers.create.reference": "Referens",
        "offers.create.description": "Beskrivning",
        "offers.create.cancel": "Avbryt",
        "offers.create.submit": "Skapa offert",
        "offers.create.creating": "Skapar…",
        "offers.create.success": "Offerten skapades.",
        "offers.create.failed": "Kunde inte skapa offerten.",
        "offers.checklist.title": "Checklista",
        "offers.checklist.intro": "Planera och följ upp punkterna för denna offert.",
        "offers.checklist.empty_title": "Ingen checklista har skapats",
        "offers.checklist.empty_description": "Skapa en checklista för att säkerställa att offerten är komplett innan den skickas.",
        "offers.checklist.create": "Skapa checklista",
        "offers.checklist.created": "Checklistan skapades.",
        "offers.checklist.create_error": "Kunde inte skapa checklistan.",
        "offers.checklist.load_error": "Kunde inte ladda checklistan.",
        "offers.checklist.save_error": "Kunde inte spara checklistan.",
        "offers.checklist.delete": "Ta bort checklista",
        "offers.checklist.deleted": "Checklistan togs bort.",
        "offers.checklist.delete_error": "Kunde inte ta bort checklistan.",
        "offers.checklist.delete_confirm": "Är du säker på att du vill ta bort checklistan?",
        "offers.checklist.unavailable": "Checklista är inte tillgänglig för denna offert.",
        "offers.checklist.type_label": "Checklisttyp",
        "offers.checklist.type_blank": "Tom checklista (utan mall)",
        "offers.checklist.types_loading": "Laddar typer…",
        "offers.checklist.type_hint": "Valfritt: välj en firmamall för att fylla punkter automatiskt.",
        "offers.send.checklist_required": "Företaget kräver checklista före sändning. Skapa checklista under fliken Checklista.",
        "offers.send.contact_load_failed": "Kunde inte hämta kontaktinformation",
        "offers.send.send_to": "Skicka till",
        "offers.send.me": "Mig",
        "offers.send.customer": "Kund",
        "offers.send.contact": "Kontakt",
        "offers.send.loading": "Laddar …",
        "offers.send.name": "Namn",
        "offers.send.email": "E-post",
        "offers.send.offer_type": "Offerttyp",
        "offers.send.internal_offer": "Intern offert",
        "offers.send.customer_offer": "Kundoffert",
        "offers.send.open_pdf": "Öppna vald offert-PDF",
        "offers.send.pdf_preview_pending": "PDF-förhandsvisning blir tillgänglig när vald offerttyp har genererats.",
        "offers.send.message": "Meddelande till kunden",
        "offers.send.close": "Stäng",
        "offers.send.sending": "Skickar …",
        "offers.send.submit": "Skicka",
        "offers.workspace.save_idle": "Inga osparade ändringar",
        "offers.workspace.conflict_resolve": "Välj värde för varje fält innan du sammanfogar",
        "offers.documentAi.attachments_title": "Bilagor",
        "offers.documentAi.attachments_intro": "Ladda upp och hantera dokument som hör till denna offert.",
        "offers.attachments.dropzone_title": "Dra och släpp filer här, eller klicka för att välja",
        "offers.attachments.dropzone_hint": "PDF, bilder, Word, Excel och fler format",
        "offers.attachments.drop_here": "Släpp filerna här",
        "offers.documentAi.title": "Dokumentgranskning",
        "offers.documentAi.intro": "Analysera en bilaga eller klistra in text. Förslagen måste godkännas innan de läggs till.",
        "offers.documentAi.document": "Välj bilaga",
        "offers.documentAi.select_document": "Välj dokument",
        "offers.documentAi.paste_text": "Eller klistra in text",
        "offers.documentAi.source_required": "Välj en bilaga eller klistra in text först.",
        "offers.documentAi.analyze": "Analysera dokument",
        "offers.documentAi.analyzing": "Analyserar…",
        "offers.documentAi.failed": "Kunde inte analysera dokumentet.",
        "offers.documentAi.summary": "Sammanfattning",
        "offers.documentAi.gaps": "Saknad information",
        "offers.documentAi.suggested_lines": "Föreslagna rader",
        "offers.documentAi.checklist_hints": "Förslag till checklista",
        "offers.documentAi.copy": "Kopiera valda",
        "offers.documentAi.copied": "Valda rader kopierades.",
        "offers.documentAi.copy_failed": "Kunde inte kopiera de valda raderna.",
        "offers.documentAi.apply_notes": "Lägg till i kommentar",
        "offers.documentAi.applied": "Valda rader lades till i kommentaren.",
        "offers.documentAi.apply_failed": "Kunde inte lägga till de valda raderna.",
        "offer.calculation.totals.summary_title": "Summor (från server)",
        "offer.calculation.totals.sales_total": "Försäljningstotal",
        "offer.calculation.totals.cost_total": "Kostnadstotal",
        "offer.calculation.totals.contribution_margin": "Täckningsbidrag",
        "offer.calculation.totals.contribution_margin_percent": "Täckningsgrad",
        "offer.calculation.totals.authoritative_hint": "Serverberäknat",
        "offer.calculation.totals.estimate_hint": "Uppskattning",
        "offer.calculation.line.total": "Radtotal",
        "offer.calculation.line.cost_total": "Radkostnad",
        "offer.calculation.line.price_source": "Priskälla",
        "offer.calculation.line.price_dated_at": "Prisdatum",
        "offer.calculation.import.title": "Importera mängder (CSV/Excel)",
        "offer.calculation.import.subtitle": "Ladda upp CSV eller Excel, kontrollera kapitel, produktmatchning, föreslaget pris/timmar och lägg till rader. Inget skrivs förrän du bekräftar.",
        "offer.calculation.import.upload": "Ladda upp",
        "offer.calculation.import.apply": "Lägg till i kalkyl",
        "offer.calculation.import.file_required": "Välj en CSV- eller Excel-fil först.",
        "offer.calculation.import.failed": "Kunde inte slutföra importen.",
        "offer.calculation.import.upload_success": "Filen är uppladdad och matchad.",
        "offer.calculation.import.apply_success": "{{count}} rader lades till i kalkylen.",
        "offer.calculation.import.job_status": "Status",
        "offer.calculation.import.confirm": "Bekräfta match",
        "offer.calculation.import.skip": "Hoppa över",
        "offer.calculation.import.col.confirm": "Bekräfta",
        "offer.calculation.import.col.sheet": "Blad",
        "offer.calculation.import.col.chapter": "Kapitel",
        "offer.calculation.import.col.sku": "Postnr",
        "offer.calculation.import.col.name": "Beskrivning",
        "offer.calculation.import.col.qty": "Antal",
        "offer.calculation.import.col.price": "Föreslaget pris",
        "offer.calculation.import.col.discount": "Rabatt",
        "offer.calculation.import.col.surcharge": "Påslag",
        "offer.calculation.import.col.hours": "Timmar",
        "offer.calculation.import.col.match": "Match",
        "offer.calculation.import.col.product": "Produkt",
        "offer.calculation.import.col.actions": "Åtgärder",
        "offer.calculation.import.counts.confirmed": "Bekräftade",
        "offer.calculation.import.counts.suggested": "Förslag",
        "offer.calculation.import.counts.unmatched": "Utan match",
        "offer.calculation.import.match_status.unmatched": "Ingen match",
        "offer.calculation.import.match_status.suggested": "Förslag",
        "offer.calculation.import.match_status.confirmed": "Bekräftad",
        "offer.calculation.import.match_status.skipped": "Överhoppad",
        "offer.calculation.import.match_status.applied": "Tillagd",
        "offer.calculation.workspace.title": "Kalkylarbetsyta",
        "offer.calculation.workspace.structure_title": "Struktur",
        "offer.calculation.workspace.add_structure": "Ny struktur",
        "offer.calculation.workspace.context_title": "Raddetaljer",
        "offer.calculation.workspace.properties": "Egenskaper",
        "offer.calculation.workspace.show_structure": "Visa struktur",
        "offer.calculation.workspace.hide_structure": "Dölj struktur",
        "offer.calculation.workspace.show_context": "Visa kontext",
        "offer.calculation.workspace.hide_context": "Dölj kontext",
        "offer.calculation.workspace.structure_empty_title": "Inga rader ännu",
        "offer.calculation.workspace.structure_empty_hint": "Lägg till en rad i mitten för att bygga strukturen.",
        "offer.calculation.workspace.context_empty_title": "Ingen rad vald",
        "offer.calculation.workspace.context_empty_hint": "Välj en rad i strukturen eller listan för att se detaljer här.",
        "offer.calculation.workspace.chapter_properties": "Kapitel",
        "offer.calculation.workspace.chapter_subtotal": "Kapitelsumma",
        "offer.calculation.workspace.chapter_lines": "{{count}} rad(er) i kapitel",
        "offer.calculation.workspace.lines_empty_title": "Inga rader",
        "offer.calculation.workspace.lines_empty_hint": "Klicka på «Ny manuell rad» för att lägga till första raden.",
        "offer.calculation.workspace.untitled_line": "Rad {{n}}",
        "offer.calculation.workspace.selected_line": "Vald rad {{n}}",
        "offer.calculation.workspace.edit_line": "Redigera rad",
        "offer.calculation.workspace.field.quantity": "Mängd",
        "offer.calculation.workspace.field.hours": "Timmar",
        "offer.calculation.workspace.field.cost_unit": "Kostpris/enhet",
        "offer.calculation.workspace.field.markup": "Påslag",
        "offer.calculation.workspace.field.sales_unit": "Försäljningspris/enhet",
        "offer.calculation.workspace.field.cost": "Kostnad",
        "offer.calculation.workspace.field.total": "Total",
        "offer.calculation.workspace.field.margin": "Täckningsgrad",
        "offer.calculation.workspace.override_title": "Manuell överskrivning",
        "offer.calculation.workspace.override_hint": "Raden har manuell prisöverskrivning.",
        "offer.calculation.workspace.validation_title": "Validering",
        "offer.calculation.workspace.source": "Källa",
        "offer.calculation.workspace.line_type.manual": "Manuell",
        "offer.calculation.workspace.line_type.product": "Produkt",
        "offer.calculation.workspace.line_type.hours": "Timmar",
        "offer.calculation.workspace.line_type.calculation": "Beräkning",
        "offer.calculation.workspace.line_type.note": "Anteckning",
        "offer.calculation.workspace.line_type.other": "Övrigt",
        "offer.calculation.workspace.col.line": "#",
        "offer.calculation.workspace.col.description": "Beskrivning",
        "offer.calculation.workspace.col.type": "Typ",
        "offer.calculation.workspace.col.quantity": "Mängd",
        "offer.calculation.workspace.col.unit": "Enhet",
        "offer.calculation.workspace.col.cost_price": "Kostpris",
        "offer.calculation.workspace.col.sales_price": "Försäljningspris",
        "offer.calculation.workspace.col.line_sum": "Radsumma",
        "offer.calculation.workspace.col.margin": "TB%",
        "offer.calculation.workspace.totals_cost": "Kostnad",
        "offer.calculation.workspace.totals_sales": "Offertsumma",
        "offer.calculation.workspace.totals_margin": "Täckningsbidrag",
        "offer.calculation.workspace.totals_margin_percent": "Täckningsgrad",
        "offer.calculation.workspace.col.unit_short": "Enh.",
        "offer.calculation.workspace.col.hours": "Timmar",
        "offer.calculation.workspace.col.cost": "Kostnad",
        "offer.calculation.workspace.col.markup": "Påslag",
        "offer.calculation.workspace.col.total": "Total",
        "offer.calculation.workspace.col.risk": "Risk",
        "offer.calculation.workspace.col.source": "Källa",
        "offer.calculation.workspace.columns": "Kolumner",
        "offer.calculation.workspace.settings": "Visningsinställningar",
        "offer.calculation.workspace.settings_aria": "Öppna visningsinställningar för täthet och kolumner",
        "offer.calculation.workspace.density": "Täthet",
        "offer.calculation.workspace.density.compact": "Kompakt",
        "offer.calculation.workspace.density.comfortable": "Bekväm",
        "offer.calculation.workspace.use_template": "Använd kalkylmall",
        "offer.calculation.workspace.load_page_template": "Ladda in kalkylmall",
        "offer.calculation.workspace.use_template_stub": "Kalkylmallar är inte tillgängliga ännu.",
        "offer.calculation.nested.blank_title": "Ny nestlad kalkyl",
        "offer.calculation.nested_source.title": "Använd kalkylmall",
        "offer.calculation.nested_source.hint": "Välj om du vill skapa en ny nestlad kalkyl, eller använda en befintlig företagsmall.",
        "offer.calculation.nested_source.new_title": "Ny",
        "offer.calculation.nested_source.new_hint": "Skapa en tom nestlad kalkyl (kalkyl i kalkyl) som du kan redigera.",
        "offer.calculation.nested_source.existing_title": "Befintlig",
        "offer.calculation.nested_source.existing_hint": "Välj en företagsmall och kopiera den som nestlad kalkyl. Mallen ändras inte.",
        "offer.calculation.nested_source.cancel": "Avbryt",
        "offer.calculation.workspace.save_status.idle": "Klar",
        "offer.calculation.workspace.save_status.pending": "Ändringar väntar…",
        "offer.calculation.workspace.save_status.saved": "Alla ändringar sparade",
        "offer.calculation.workspace.save_status.saving": "Sparar…",
        "offer.calculation.workspace.save_status.error": "Sparning misslyckades",
        "offer.calculation.workspace.missing_cost_line": "Kostpris saknas på denna rad.",
        "offer.calculation.workspace.missing_cost": "{{count}} rad(er) saknar kostpris",
        "offer.calculation.workspace.totals.material": "Materialkostnad",
        "offer.calculation.workspace.totals.labor": "Arbete",
        "offer.calculation.workspace.totals.module": "Modul",
        "offer.calculation.workspace.totals.hours_sum": "Summa timmar",
        "offer.calculation.workspace.totals.total_cost": "Total kostnad",
        "offer.calculation.workspace.totals.contribution": "Täckningsbidrag",
        "offer.calculation.workspace.totals.margin_rate": "Täckningsgrad",
        "offer.calculation.workspace.totals.offer_ex_vat": "Offertsumma exkl. moms",
        "offer.calculation.workspace.totals.compact": "Offertsumma exkl. moms: {{sales}} · TG {{dg}}",
        "offer.calculation.workspace.totals.collapse": "Dölj totalzon",
        "offer.calculation.workspace.totals.expand": "Visa totalzon",
        "offer.calculation.summary.title": "Kalkylsammanfattning",
        "offer.calculation.summary.subtitle": "Auktoritativa tal från API (BigDecimal)",
        "offer.calculation.summary.hours_total": "Summa timmar",
        "offer.calculation.summary.hours_by_role": "Timmar per roll",
        "offer.calculation.summary.material_cost": "Materialkostnad",
        "offer.calculation.summary.labor_cost": "Arbetskostnad",
        "offer.calculation.summary.cost_total": "Total kostnad",
        "offer.calculation.summary.db": "Täckningsbidrag (DB)",
        "offer.calculation.summary.dg": "Täckningsgrad (DG%)",
        "offer.calculation.summary.sales_total": "Offertsumma exkl. moms",
        "offer.calculation.summary.info_aria": "Hur beräknas {{label}}?",
        "offer.calculation.summary.role.montor": "Montör",
        "offer.calculation.summary.role.montasjeleder": "Montageledare",
        "offer.calculation.summary.role.prosjektleder": "Projektledare",
        "offer.calculation.summary.role.prosjektering": "Projektering",
        "offer.calculation.summary.role.innleid": "Inhyrd",
        "offer.calculation.summary.role_key_label": "Roll",
        "offer.calculation.summary.guide.hours.title": "Summa timmar",
        "offer.calculation.summary.guide.hours.body": "Summerar timmar per rad (quantity × hours) per roll via labor_role eller hours_by_role. Backend är auktoritativ.",
        "offer.calculation.summary.guide.material.title": "Materialkostnad",
        "offer.calculation.summary.guide.material.body": "Kostnad för produkt-/manuella rader (inte timmar). Från API summary.material_cost.",
        "offer.calculation.summary.guide.labor.title": "Arbetskostnad",
        "offer.calculation.summary.guide.labor.body": "Kostnad för timrader (line_type hours eller rader med timmar). Från summary.labor_cost.",
        "offer.calculation.summary.guide.cost.title": "Total kostnad",
        "offer.calculation.summary.guide.cost.body": "Samlad kostnad (material + arbete + modul). Med offer_calculation_v2 används lagrad cost_total från Offers::RecalculateCalculation.",
        "offer.calculation.summary.guide.db.title": "Täckningsbidrag (DB)",
        "offer.calculation.summary.guide.db.body": "DB = offertsumma − kostnad. Samma som contribution_margin från backend.",
        "offer.calculation.summary.guide.dg.title": "Täckningsgrad (DG%)",
        "offer.calculation.summary.guide.dg.body": "DG% = (DB / offertsumma) × 100. Noll när offertsumma är 0.",
        "offer.calculation.summary.guide.sales.title": "Offertsumma",
        "offer.calculation.summary.guide.sales.body": "Total försäljningssumma exkl. moms från kalkylrader (total_amount / summary.sales_total).",
        "offer.calculation.workspace.display_settings": "Visningsinställningar",

        "offer.calculation.workspace.bulk.select_all": "Välj alla rader",
        "offer.calculation.workspace.bulk.select_row": "Välj rad",
        "offer.calculation.workspace.bulk.delete_selected": "Ta bort valda",
        "offer.calculation.workspace.bulk.clear": "Rensa markering",
        "offer.calculation.workspace.bulk.delete_confirm": "Är du säker på att du vill ta bort {{count}} valda rader?",
        "offer.calculation.line_editor.standard_fields": "Standardfält",
        "offer.calculation.line_editor.quantity": "Antal / mängd",
        "offer.calculation.line_editor.hours_count": "Antal timmar",
        "offer.calculation.line_editor.sales_price_auto": "Försäljningspris (auto)",
        "offer.calculation.line_editor.cost_price_auto": "Kostpris (auto)",
        "offer.calculation.line_editor.show_in_offer": "Visa i offerten",
        "offer.calculation.line_editor.delete_confirm": "Är du säker på att du vill ta bort den här raden?",
        "offer.calculation.line_editor.hour_rate": "Timpris",
        "offer.calculation.line_editor.cost_hour_rate": "Kostnad per timme",
        "offer.calculation.line_editor.select_hour_rate": "Välj timtaxa",
        "offer.calculation.line_editor.hour_rate_from_catalog": "Hämtas från Timtaxor (/offers/hour-rates)",
        "offer.calculation.line_editor.no_hour_rates": "Inga timtaxor hittades.",
        "offer.calculation.line_editor.create_hour_rate": "Skapa ny timtaxa",
        "offer.calculation.line_editor.hours_section": "Tidsberäkning",
        "offer.calculation.line_editor.hide_hours": "Dölj",
        "offer.calculation.line_editor.add_hours": "Lägg till tidsberäkning",
        "offer.calculation.line_editor.hours_pricing_mode": "Hur ska tiden beräknas?",
        "offer.calculation.line_editor.hours_mode_product_plus_hours": "Tid utöver produktpris",
        "offer.calculation.line_editor.hours_mode_from_price": "Beräkna timmar utifrån pris (information, läggs inte till)",
        "offer.calculation.line_editor.hours_mode_product_plus_hours_hint": "Enhetspris = produktpris + timmar × timpris. Radbelopp = enhetspris × mängd.",
        "offer.calculation.line_editor.auto_calc_hours": "Beräkna timantal automatiskt",
        "offer.calculation.line_editor.from_sales_price": "Utifrån försäljningspris",
        "offer.calculation.line_editor.from_cost_price": "Utifrån kostpris",
        "offer.calculation.line_editor.hours_amount": "Timbelopp",
        "offer.calculation.line_editor.unit_with_hours": "Enhetspris med tid",
        "offer.calculation.line_editor.hours_focus_hint": "Endast tid — beskrivning, timmar och satser",
        "offer.calculation.line_editor.product_focus_hint": "Produkt, mängd och priser",
        "offer.calculation.line_editor.manual_focus_hint": "Fri beskrivning och belopp",
        "offer.calculation.line_editor.calculation_focus_hint": "Nästlad kalkyl / modul",
        "offer.calculation.line_editor.note_focus_hint": "Endast kund-/PDF-text — utan mängd eller pris",
        "offer.calculation.line_editor.note_text": "Anteckningstext",
        "offer.calculation.line_editor.select_product": "Välj produkt",
        "offer.calculation.line_editor.unit_hours": "Timme",
        "offer.calculation.line_editor.price_mode": "Prisberäkning",
        "offer.calculation.line_editor.price_mode_automatic": "Automatisk (från timmar)",
        "offer.calculation.line_editor.price_mode_custom": "Manuell",
        "offer.calculation.line_editor.hours_notes_section": "Anteckningar (kalkyler / produkter)",
        "offer.calculation.line_editor.hours_notes_hint": "På timrader sparas kalkyler och produkter bara som anteckningar — de påverkar inte pris eller product_id.",
        "offer.calculation.line_editor.add_calc_as_note": "Lägg till kalkyl som anteckning",
        "offer.calculation.line_editor.add_product_as_note": "Lägg till produkt som anteckning",
        "offer.calculation.line_editor.calcs_and_products": "Kalkyler och produkter",
        "offer.calculation.line_editor.line_n": "Rad {{n}}",
        "offer.calculation.line_editor.discount_pct": "Rabatt %",
        "offer.calculation.line_editor.surcharge_pct": "Påslag %",
        "offer.calculation.line_editor.display_options": "Visningsalternativ",
        "offer.calculation.line_editor.show_product_image_pdf": "Visa produktbild i PDF",
        "offer.calculation.line_editor.show_product_url_pdf": "Visa produkt-URL i PDF",
        "offer.calculation.line_editor.add_note": "Lägg till anteckning",
        "offer.calculation.line_editor.edit_note": "Redigera anteckning",
        "offer.calculation.line_editor.update_note": "Uppdatera",
        "offer.calculation.line_editor.notes_section": "Anteckningar",
        "offer.calculation.line_editor.note_title": "Titel",
        "offer.calculation.line_editor.note_title_placeholder": "Titel på anteckningen (valfritt)",
        "offer.calculation.line_editor.show_note_title": "Visa titel",
        "offer.calculation.line_editor.note_use_template_title": "Använd malltitel",
        "offer.calculation.line_editor.note_placeholder": "Skriv anteckning eller infoga en mall…",
        "offer.calculation.line_editor.note_template_button": "Mall",
        "offer.calculation.line_editor.note_from_template": "Mall: {{title}}",
        "offer.calculation.line_editor.shown_in_offer": "Visas i offerten",
        "offer.calculation.line_editor.delete_row": "Ta bort rad",
        "offer.calculation.module.result_hint_server": "Serverberäknad total (efter sparning). Redigera canvas för lokal förhandsvisning.",
        "offer.calculation.module.formula.assistant_subtitle_safe": "Välj en mall eller infoga variabler. Säkert läge stöder + − × ÷, IF, MIN, MAX, ROUND, SUM och modulreferenser.",
        "offer.calculation.module.formula.error.empty": "{{title}}: Formeln är tom",
        "offer.calculation.module.formula.error.division_by_zero": "{{title}}: Kan inte dela med noll",
        "offer.calculation.module.formula.error.unknown_variable": "{{title}}: Okänd variabel «{{name}}»",
        "offer.calculation.module.formula.error.invalid": "{{title}}: Formeln är ogiltig",
        "offer.calculation.module.formula.error.unsupported_chars": "{{title}}: Formeln innehåller tecken som inte stöds",
        "offer.calculation.module.formula.error.unsupported_function": "{{title}}: Okänd funktion. Tillåtna: IF, MIN, MAX, ROUND, SUM",
        "offer.calculation.module.formula.error.wrong_arity": "{{title}}: Funktionen har fel antal argument",
        "offer.calculation.module.formula.error.circular": "Cirkulär referens runt {{title}}",
        "offer.calculation.module.evaluation_order": "Beräkningsordning",
        "Processing": "Under behandling",
        "Closed": "Stängd",
        "case.view.new_case": "Nytt ärende",
        "case.view.close_case": "Stäng ärende",
        "cases.access.forbidden_title": "Ingen åtkomst",
        "cases.access.save_step": "Spara ärende",
        "cases.access.edit_forbidden": "Du har inte behörighet att redigera det här ärendet.",
        "cases.access.create_forbidden": "Du har inte behörighet att skapa ärenden.",
        "case.view.due": "Förfaller",
        "case.view.sent_email_to_employee": "skickade e-post till anställd",
        "case.summary.title": "AI-sammanfattning",
        "case.summary.updated": "Uppdaterad {{time}}",
        "case.summary.empty":
          "Sammanfattningen skapas automatiskt så snart det finns tillräckligt med innehåll i ärendet.",
        "case.summary.new_updates": "Nya uppdateringar",
        "case.summary.generating": "Uppdaterar …",
        "case.summary.error": "Kunde inte ladda sammanfattningen just nu.",
        "case.summary.disabled": "AI-sammanfattning är inte aktiverad",
        "case.summary.show_more": "Visa mer",
        "case.summary.show_less": "Visa mindre",
        "case.feed.activity._default": "uppdaterade ärendet",
        "case.feed.activity.ADDED._default": "la till en uppdatering",
        "case.feed.activity.ADDED.description": "la till en uppdatering",
        "case.feed.activity.ADDED.report": "la till en rapport i ärendet",
        "case.feed.activity.ADDED.service_agreement": "la till ett serviceavtal",
        "case.feed.activity.ADDED.project": "la till ett projekt",
        "case.feed.activity.ADDED.order": "la till en order",
        "case.feed.activity.ADDED.customer": "la till en kund",
        "case.feed.activity.ADDED.contact": "la till en kontakt",
        "case.feed.activity.ADDED.note": "la till en anteckning",
        "case.feed.activity.ADDED.customer_communication": "la till ett meddelande",
        "case.feed.activity.ADDED.phone": "la till ett telefonsamtal",
        "case.feed.activity.ADDED.employee": "la till en anställd",
        "case.feed.activity.ATTACHED._default": "la till en bilaga",
        "case.feed.activity.LINKED._default": "länkade till ärendet",
        "case.feed.activity.LINKED.report": "länkade en rapport till ärendet",
        "case.feed.activity.CREATE._default": "skapade ärendet",
        "case.feed.activity.CREATE.case": "skapade ärendet",
        "case.feed.activity.CREATE.report": "skapade en rapport",
        "case.feed.activity.CREATED._default": "skapade ärendet",
        "case.feed.activity.CREATED.case": "skapade ärendet",
        "case.feed.activity.UPDATE._default": "uppdaterade ärendet",
        "case.feed.activity.UPDATE.case": "uppdaterade det här ärendet",
        "case.feed.activity.UPDATED._default": "uppdaterade ärendet",
        "case.feed.activity.UPDATED.case": "uppdaterade det här ärendet",
        "case.feed.activity.CHANGED._default": "gjorde en ändring",
        "case.feed.activity.STATUS_UPDATE._default": "uppdaterade ärendets status",
        "case.feed.activity.DELETED._default": "raderade ett objekt",
        "case.feed.activity.FINISHED._default": "slutförde ärendet",
        "case.feed.activity.CLOSED._default": "stängde ärendet",
        "case.feed.activity.EMAIL_SENT_TO_EMPLOYEE._default": "skickade e-post till en anställd",
        "case.feed.activity.sent_sms_to_customer._default": "skickade SMS till kunden",
        "case.feed.activity.cancel_report_agreement._default": "avbröt ett avtal",
        "case.feed.activity.new_report_agreement._default": "skapade ett nytt avtal",
        "case.feed.activity.case_guide_run.request_info": "besvarade begärd information",
        "case.feed.activity.case_guide_run.completed": "slutförde en guide",
        "case.view.composer_placeholder": "Skriv en kommentar … använd @ för att nämna någon",
        "case.view.composer_open": "Skriv en kommentar",
        "case.empty.updates": "Inga uppdateringar ännu",
        "case.empty.hint": "Skriv en uppdatering nedan för att komma igång",
        "case.load.error_title": "Kunde inte ladda ärendet",
        "case.load.error_hint": "Något gick fel när ärendet skulle hämtas. Kontrollera anslutningen och försök igen.",
        "case.load.retry": "Försök igen",
        "case.feed.error_title": "Kunde inte ladda uppdateringar",
        "case.finish_after_prompt": "Vill du slutföra ärendet efteråt?",
        "Felter": "Fält",
        "Dokumenter": "Dokument",
        "Internt notat": "Intern notering",
        "Slipp filer her for å laste opp": "Släpp filer här för att ladda upp",
        "Attach file": "Bifoga fil",
        "Add image": "Lägg till bild",
        "Prioritering": "Prioritering",
        "Ctrl+Enter for å sende": "Ctrl+Enter för att skicka",
        "Remove": "Ta bort",
        "Dokument": "Dokument",
        "Handlinger": "Åtgärder",
        "Lukk sak": "Stäng ärende",
        "Saksbehandler": "Handläggare",
        "Forfallsdato": "Förfallodatum",
        "Kart": "Karta",
        "Åpne i Google Maps": "Öppna i Google Maps",
        "Åpne": "Öppna",
        "Vis mer": "Visa mer",
        "Vis mindre": "Visa mindre",
        "Select Priority": "Välj prioritet",
        "Phone Call": "Telefonsamtal",
        "duration": "Varaktighet",
        "Sak": "Ärende",
        "Kunde": "Kund",
        "Prosjekt": "Projekt",
        "Serviceavtale": "Serviceavtal",
        "Avtale": "Avtal",
        "Ordre": "Order",
        "Servicerapport": "Servicerapport",
        "Rapport": "Rapport",
        "Notat": "Notering",
        "Telefon": "Telefon",
        "SMS": "SMS",
        "E-post": "E-post",
        "Select status": "Välj status",
        "Moduler": "Moduler",
        "Kontakt": "Kontakt",
        "Ingen tilknyttede moduler": "Inga kopplade moduler",
        "Legg til modul": "Lägg till modul",
        "Service Report": "Servicerapport",
        "Service Agreement": "Serviceavtal",
        "Project": "Projekt",
        "Order": "Order",
        "Egendefinerte felter": "Anpassade fält",
        "Ingen felter ennå": "Inga fält ännu",
        "Legg til felt": "Lägg till fält",
        "Bilde": "Bild",

        "Human resources": "Human resources",
        "Ledige stillinger": "Lediga tjänster",
        "Employees": "Anställda",
        "Users": "Användare",

        "hr.employees.page_title": "Anställda",
        "hr.employees.hero.kicker": "Human resources",
        "hr.employees.hero.subtitle":
          "Visar endast användare som är anställda i företaget (aktiv anställning).",
        "hr.employees.section.title": "Anställda",
        "hr.employees.section.subtitle": "Filtrerat till aktiva anställningar",
        "hr.employees.section.kicker": "Employees",

        "hr.common.loading": "Laddar…",
        "hr.common.cancel": "Avbryt",
        "hr.common.create": "Skapa",
        "hr.common.save": "Spara",
        "hr.common.edit": "Redigera",
        "hr.common.delete": "Radera",
        "hr.common.close": "Stäng",
        "hr.common.back": "Tillbaka",
        "hr.common.open": "Öppna",
        "hr.common.yes": "Ja",
        "hr.common.no": "Nej",
        "hr.common.empty": "Inte ifyllt ännu",
        "hr.common.uploading": "Laddar upp…",
        "hr.common.all": "Alla",
        "hr.common.all_statuses": "Alla statusar",

        "hr.job_openings.title": "Lediga tjänster",
        "hr.job_openings.subtitle": "Hantera annonser, publik webbvisning och kandidater",
        "hr.job_openings.new": "Ny tjänst",
        "hr.job_openings.edit": "Redigera tjänst",
        "hr.job_openings.status": "Status",
        "hr.job_openings.candidates": "Kandidater",
        "hr.job_openings.on_website": "På webbplats",
        "hr.job_openings.search_placeholder": "Sök tjänster…",
        "hr.job_openings.empty_title": "Inga lediga tjänster ännu",
        "hr.job_openings.empty_body": "Skapa en tjänst för att starta rekryteringen.",
        "hr.job_openings.load_failed": "Kunde inte ladda tjänster",
        "hr.job_openings.create_failed": "Kunde inte skapa tjänst",
        "hr.job_openings.created": "Tjänst skapad",
        "hr.job_openings.updated": "Tjänst uppdaterad",
        "hr.job_openings.update_failed": "Kunde inte uppdatera tjänst",
        "hr.job_openings.deleted": "Tjänst raderad",
        "hr.job_openings.delete_failed": "Kunde inte radera tjänst",
        "hr.job_openings.delete_confirm": "Är du säker på att du vill arkivera denna tjänst?",
        "hr.job_openings.validation.title": "Titel krävs",
        "hr.job_openings.fields.title": "Titel",
        "hr.job_openings.fields.short_description": "Kort beskrivning",
        "hr.job_openings.fields.description": "Beskrivning",
        "hr.job_openings.fields.responsibilities": "Arbetsuppgifter",
        "hr.job_openings.fields.requirements": "Kvalifikationer",
        "hr.job_openings.fields.requirements_hint": "Checklista som visas i ansökningsformuläret på webbplatsen och när du lägger till kandidat manuellt.",
        "hr.job_openings.fields.requirements_add": "Lägg till kvalifikation",
        "hr.job_openings.fields.benefits": "Vi erbjuder",
        "hr.job_openings.fields.location": "Plats",
        "hr.job_openings.fields.employment_type": "Anställningsform",
        "hr.job_openings.fields.department": "Avdelning",
        "hr.job_openings.fields.salary_info": "Lön",
        "hr.job_openings.fields.work_percentage": "Tjänstegrad",
        "hr.job_openings.fields.deadline": "Sista ansökningsdag",
        "hr.job_openings.fields.starts_on": "Startdatum",
        "hr.job_openings.fields.contact_name": "Kontaktperson",
        "hr.job_openings.fields.contact_email": "Kontakt-e-post",
        "hr.job_openings.fields.contact_phone": "Kontakttelefon",
        "hr.job_openings.fields.contact_user": "Ansvarig kontakt",
        "hr.job_openings.fields.contact_user_hint": "Välj en anställd. Namn, e-post och telefon hämtas från profilen och visas på tjänsten. HR-ansvariga visas som «Andra kontakter».",
        "hr.job_openings.fields.contact_user_empty": "Ingen ansvarig kontakt är vald.",
        "hr.job_openings.fields.contact_user_pick": "Välj anställd",
        "hr.job_openings.fields.contact_user_change": "Byt anställd",
        "hr.job_openings.fields.contact_user_clear": "Ta bort",
        "hr.job_openings.fields.show_on_website": "Visa på webbplats",
        "hr.job_openings.hide_from_website": "Dölj från webbplats",
        "hr.job_openings.open_on_website": "Öppna på webbplats",
        "hr.job_openings.website_shown": "Tjänsten visas på webbplatsen",
        "hr.job_openings.website_hidden": "Tjänsten är dold från webbplatsen",
        "hr.job_openings.employment_types.full_time": "Heltid",
        "hr.job_openings.employment_types.part_time": "Deltid",
        "hr.job_openings.employment_types.temporary": "Tillfällig",
        "hr.job_openings.employment_types.internship": "Praktik",
        "hr.job_openings.employment_types.freelance": "Freelance",
        "hr.job_openings.statuses.draft": "Utkast",
        "hr.job_openings.statuses.published": "Publicerad",
        "hr.job_openings.statuses.closed": "Stängd",
        "hr.job_openings.statuses.archived": "Arkiverad",
        "hr.job_openings.sections.overview": "Nyckelinfo",
        "hr.job_openings.sections.description": "Om tjänsten",
        "hr.job_openings.sections.responsibilities": "Arbetsuppgifter",
        "hr.job_openings.sections.requirements": "Kvalifikationer",
        "hr.job_openings.sections.benefits": "Vi erbjuder",
        "hr.job_openings.sections.contact": "Kontakt",
        "hr.job_openings.sections.updates": "Uppdateringar",
        "hr.job_openings.sections.history": "Historik / Uppdateringar",
        "hr.job_openings.sections.history_hint": "Egna anteckningar på tjänsten, plus statusändringar på kandidater.",
        "hr.job_openings.json.open_dialog": "JSON / AI",
        "hr.job_openings.json.dialog_title": "Lediga tjänster — JSON och AI",
        "hr.job_openings.json.tab_json": "Klistra in JSON",
        "hr.job_openings.json.tab_ai_guide": "AI-instruktioner",
        "hr.job_openings.json.hint":
          "Klistra in eller ladda upp JSON. Skapar nya tjänster eller uppdaterar efter slug i företaget. Befintliga tjänster raderas inte. Kvalifikationer: föredra requirement_items [{id,text}] (slug-id, inte UUID). Kontakt väljs som anställd i Promang — hitta inte på namn, e-post eller telefon. Valfria kandidater kan ligga under applications med requirement_checks.",
        "hr.job_openings.json.existing_openings": "Befintliga tjänster (duplicera inte)",
        "hr.job_openings.json.loading": "laddar…",
        "hr.job_openings.json.copy_json": "Kopiera JSON",
        "hr.job_openings.json.copy_success": "JSON kopierad",
        "hr.job_openings.json.reload_blank": "Töm mall",
        "hr.job_openings.json.reload_success": "Tom mall inläst",
        "hr.job_openings.json.insert_sample": "Infoga exempel",
        "hr.job_openings.json.upload": "Ladda upp JSON",
        "hr.job_openings.json.file_loaded": "JSON-fil inläst",
        "hr.job_openings.json.file_failed": "Kunde inte läsa filen",
        "hr.job_openings.json.preview": "Förhandsgranska import",
        "hr.job_openings.json.preview_title": "Förhandsgranskning: {{count}} tjänst(er)",
        "hr.job_openings.json.preview_applications": "sökande",
        "hr.job_openings.json.preview_hint":
          "Inget är sparat än. Kontrollera listan och bekräfta för att importera till Promang.",
        "hr.job_openings.json.confirm_import": "Bekräfta import ({{count}})",
        "hr.job_openings.json.importing": "Importerar…",
        "hr.job_openings.json.imported":
          "Importerat: {{created}} nya, {{updated}} uppdaterade, {{applications}} sökande",
        "hr.job_openings.json.import_failed": "Import misslyckades",
        "hr.job_openings.json.clipboard_failed": "Kunde inte kopiera till urklipp",
        "hr.job_openings.json.ai_guide_intro":
          "Kopiera instruktionerna nedan till ChatGPT, Claude eller annan AI. Klistra sedan in JSON-svaret under fliken Klistra in JSON.",
        "hr.job_openings.json.copy_ai_guide": "Kopiera AI-instruktioner",
        "hr.job_openings.json.ai_guide_copied": "AI-instruktioner kopierade",
        "hr.job_openings.json.generate_with_ai": "Generera med AI",
        "hr.job_openings.json.ai_parse_error": "Kunde inte läsa AI-svar som JSON",
        "hr.job_openings.json.ai_apply_success":
          "{{count}} tjänst(er) inlagda från AI — kontrollera och importera",
        "hr.job_openings.json.error_empty": "JSON är tom",
        "hr.job_openings.json.error_invalid_json": "Ogiltig JSON",
        "hr.job_openings.json.error_invalid_shape": "Ogiltig JSON-struktur",
        "hr.job_openings.json.error_no_valid_items": "Inga giltiga tjänster i JSON",
        "hr.job_openings.json.error_too_many_openings": "För många tjänster (max 50)",
        "hr.job_openings.json.atomic": "Atomisk import (rulla tillbaka vid fel)",
        "hr.job_openings.json.dropped_rows":
          "{{count}} rad(er) hoppades över före import: {{detail}}",
        "hr.job_openings.json.result_title": "Importresultat",
        "hr.job_openings.json.result_hint": "Öppna tjänsterna nedan för att kontrollera text och pipeline.",
        "hr.job_openings.json.result_none": "Inga tjänster skapades eller uppdaterades.",

        "hr.candidates.title": "Kandidater",
        "hr.candidates.add": "Lägg till kandidat",
        "hr.candidates.empty": "Inga kandidater är registrerade på denna tjänst ännu.",
        "hr.candidates.pipeline": "Pipeline",
        "hr.candidates.total": "Totalt",
        "hr.candidates.documents": "Dokumentation",
        "hr.candidates.upload": "Ladda upp CV / fil",
        "hr.candidates.no_docs": "Inga dokument uppladdade.",
        "hr.candidates.created": "Kandidat tillagd",
        "hr.candidates.create_failed": "Kunde inte lägga till kandidat",
        "hr.candidates.updated": "Kandidat uppdaterad",
        "hr.candidates.update_failed": "Kunde inte uppdatera kandidat",
        "hr.candidates.deleted": "Kandidat raderad",
        "hr.candidates.delete_failed": "Kunde inte radera kandidat",
        "hr.candidates.delete_confirm": "Är du säker på att du vill radera denna kandidat?",
        "hr.candidates.docs_uploaded": "Dokument uppladdat",
        "hr.candidates.docs_upload_failed": "Kunde inte ladda upp dokument",
        "hr.candidates.validation.first_name": "Förnamn krävs",
        "hr.candidates.validation.last_name": "Efternamn krävs",
        "hr.candidates.validation.email": "Giltig e-post krävs",
        "hr.candidates.fields.first_name": "Förnamn",
        "hr.candidates.fields.last_name": "Efternamn",
        "hr.candidates.fields.email": "E-post",
        "hr.candidates.fields.phone": "Telefon",
        "hr.candidates.fields.city": "Ort",
        "hr.candidates.fields.linkedin": "LinkedIn",
        "hr.candidates.fields.cover_letter": "Ansökan",
        "hr.candidates.fields.requirements": "Kvalifikationer",
        "hr.candidates.fields.requirements_hint": "Kryssa i det som gäller.",
        "hr.candidates.fields.requirements_toggle_hint": "Kryssa i det som gäller. Texten kan inte ändras här.",
        "hr.candidates.fields.requirements_readonly_hint": "Kandidaten har fyllt i detta själv. Listan är skrivskyddad.",
        "hr.candidates.fields.requirements_add": "Lägg till kvalifikation",
        "hr.candidates.fields.notes": "Intern anteckning",
        "hr.candidates.fields.legacy_note": "Intern anteckning",
        "hr.candidates.fields.notes_hint": "Valfritt. Vidare uppföljning skrivs under Uppdatering efter att kandidaten är skapad.",
        "hr.candidates.sections.updates": "Uppdateringar",
        "hr.candidates.sections.history": "Historik / Uppdateringar",
        "hr.candidates.sections.history_hint": "Statusändringar loggas automatiskt. Skriv vidare uppföljning här.",
        "hr.candidates.sections.details": "Kontakt",
        "hr.candidates.not_found": "Kunde inte hitta kandidaten på denna tjänst.",
        "hr.candidates.load_failed": "Kunde inte ladda kandidaten",
        "hr.candidates.fields.source": "Källa",
        "hr.candidates.sources.manual": "Manuellt",
        "hr.candidates.sources.website": "Webbplats",
        "hr.candidates.sources.email": "E-post",
        "hr.candidates.sources.other": "Annat",
        "hr.candidates.fields.status": "Status",
        "hr.candidates.fields.applied_at": "Ansökt",
        "hr.candidates.statuses.new": "Ny",
        "hr.candidates.statuses.reviewing": "Under granskning",
        "hr.candidates.statuses.interview": "Intervju",
        "hr.candidates.statuses.offer": "Erbjudande",
        "hr.candidates.statuses.hired": "Anställd",
        "hr.candidates.statuses.rejected": "Avslagen",
        "hr.candidates.statuses.withdrawn": "Återtagen",

        "hr.settings.title": "HR-inställningar",
        "hr.settings.subtitle": "Ansvariga, webbformulär och aviseringar",
        "hr.settings.load_failed": "Kunde inte ladda HR-inställningar",
        "hr.settings.saved": "HR-inställningar sparade",
        "hr.settings.save_failed": "Kunde inte spara HR-inställningar",
        "hr.settings.form.title": "Ansökningsformulär på webbplats",
        "hr.settings.form.description": "Aktivera formuläret som skickas via public API, till exempel Airon-webbplatsen.",
        "hr.settings.form.toggle": "Aktivera formulär för extern webbplats",
        "hr.settings.form.toggle_hint": "När detta är av visas tjänster fortfarande, men sökande kan inte skicka formuläret.",
        "hr.settings.responsibles.title": "HR-ansvariga",
        "hr.settings.responsibles.description": "En eller flera personer får e-post vid ny ansökan, och en daglig sammanfattning av ändringar på öppna tjänster. Namn, e-post och telefon visas också på den offentliga platsannons- och ansökningssidan.",
        "hr.settings.responsibles.empty": "Inga HR-ansvariga har lagts till ännu.",
        "hr.settings.responsibles.add": "Lägg till ansvarig",
        "hr.settings.responsibles.remove": "Ta bort",
        "hr.settings.digest.title": "Daglig sammanfattning",
        "hr.settings.digest.description": "Statusändringar och andra kandidatuppdateringar samlas och skickas en gång per dag, endast för öppna tjänster. Nya ansökningar aviseras direkt.",
        "hr.settings.digest.hour": "Skicka sammanfattning kl. (Europe/Oslo)",

        "hse.evaluation.title": "Utvärdering",
        "hse.evaluation.subtitle": "KPI, internrevision, ledningens genomgång och kundnöjdhet",
        "hse.evaluation.restricted": "Begränsad åtkomst",
        "hse.evaluation.restricted_body": "Du har inte åtkomst till utvärderingsöversikten. Kontakta ledningen.",
        "hse.evaluation.back": "Tillbaka",
        "hse.evaluation.recent": "Senaste utvärderingar",
        "hse.evaluation.nav.kpi": "KPI",
        "hse.evaluation.nav.kpi_hint": "Nyckeltal och mätningar",
        "hse.evaluation.nav.audit_hint": "Kontrollera att rutinerna faktiskt följs",
        "hse.evaluation.nav.review_hint": "Ledningen bedömer om systemet fungerar",
        "hse.evaluation.nav.feedback": "Kundnöjdhet",
        "hse.evaluation.nav.feedback_hint": "Återkoppling och nöjdhet",
        "hse.evaluation.types.management_review": "Ledningens genomgång",
        "hse.evaluation.types.internal_audit": "Internrevision",
        "hse.evaluation.help.open": "Vad betyder {{term}}?",
        "hse.evaluation.help.management_review.title": "Ledningens genomgång",
        "hse.evaluation.help.management_review.body": "Ledningen går igenom HMS/KS-systemet med jämna mellanrum: fungerar det, vad måste ändras och vilka åtgärder ska följas upp? Krav i ISO 9001 och internkontrollregler.",
        "hse.evaluation.help.internal_audit.title": "Internrevision",
        "hse.evaluation.help.internal_audit.body": "En planerad kontroll av att företaget följer egna rutiner och lagar. Fynd dokumenteras och åtgärder skapas där något måste rättas.",
        "hse.evaluation.help.tiltak.title": "Åtgärd",
        "hse.evaluation.help.tiltak.body": "En konkret uppgift som ska rätta eller förebygga ett fynd. Har ansvarig, deadline och status.",
        "hse.evaluation.help.finding.title": "Fynd",
        "hse.evaluation.help.finding.body": "Något som upptäcktes i genomgången eller revisionen. Ett fynd kan kopplas till en eller flera åtgärder.",
        "hse.evaluation.list.title_reviews": "Ledningens genomgång",
        "hse.evaluation.list.title_audits": "Internrevision",
        "hse.evaluation.list.subtitle_reviews": "Planerade och genomförda ledningsgenomgångar",
        "hse.evaluation.list.subtitle_audits": "Planerade och genomförda internrevisioner",
        "hse.evaluation.list.search": "Sök i titel eller slutsats…",
        "hse.evaluation.list.empty": "Inga utvärderingar ännu. Skapa den första.",
        "hse.evaluation.list.load_failed": "Kunde inte ladda utvärderingar",
        "hse.evaluation.list.new_review": "Ny genomgång",
        "hse.evaluation.list.new_audit": "Ny revision",
        "hse.evaluation.list.findings_count": "{{count}} fynd",
        "hse.evaluation.fields.title": "Titel",
        "hse.evaluation.fields.description": "Beskrivning",
        "hse.evaluation.fields.status": "Status",
        "hse.evaluation.fields.type": "Typ",
        "hse.evaluation.fields.scheduled_on": "Planerad",
        "hse.evaluation.fields.conducted_on": "Genomförd",
        "hse.evaluation.fields.next_review_on": "Nästa",
        "hse.evaluation.fields.scope": "Omfattning",
        "hse.evaluation.fields.conclusion": "Slutsats",
        "hse.evaluation.fields.notes": "Anteckningar",
        "hse.evaluation.fields.lead": "Ledare",
        "hse.evaluation.fields.participants": "Deltagare",
        "hse.evaluation.fields.due_date": "Deadline",
        "hse.evaluation.statuses.draft": "Utkast",
        "hse.evaluation.statuses.planned": "Planerad",
        "hse.evaluation.statuses.in_progress": "Pågår",
        "hse.evaluation.statuses.completed": "Slutförd",
        "hse.evaluation.statuses.cancelled": "Avbruten",
        "hse.evaluation.severities.low": "Låg",
        "hse.evaluation.severities.medium": "Medel",
        "hse.evaluation.severities.high": "Hög",
        "hse.evaluation.severities.critical": "Kritisk",
        "hse.evaluation.form.new_review": "Ny genomgång",
        "hse.evaluation.form.edit_review": "Redigera genomgång",
        "hse.evaluation.form.new_audit": "Ny revision",
        "hse.evaluation.form.edit_audit": "Redigera revision",
        "hse.evaluation.form.save": "Spara",
        "hse.evaluation.form.saving": "Sparar…",
        "hse.evaluation.form.cancel": "Avbryt",
        "hse.evaluation.form.saved": "Utvärdering sparad",
        "hse.evaluation.form.save_failed": "Kunde inte spara utvärderingen",
        "hse.evaluation.form.title_required": "Titel krävs",
        "hse.evaluation.form.section.basics": "Underlag",
        "hse.evaluation.form.section.dates": "Datum",
        "hse.evaluation.form.section.people": "Personer",
        "hse.evaluation.form.section.conclusion": "Slutsats",
        "hse.evaluation.view.open": "Öppna",
        "hse.evaluation.view.edit": "Redigera",
        "hse.evaluation.view.findings": "Alla fynd",
        "hse.evaluation.view.report": "Rapport",
        "hse.evaluation.view.not_found": "Hittade inte utvärderingen",
        "hse.evaluation.view.no_conclusion": "Ingen slutsats är skriven ännu.",
        "hse.evaluation.findings.title": "Fynd",
        "hse.evaluation.findings.empty": "Inga fynd registrerade.",
        "hse.evaluation.findings.add": "Lägg till",
        "hse.evaluation.findings.title_placeholder": "Kort fynd",
        "hse.evaluation.findings.description_placeholder": "Vad observerades?",
        "hse.evaluation.findings.title_required": "Fynd behöver en titel",
        "hse.evaluation.findings.saved": "Fynd sparat",
        "hse.evaluation.findings.save_failed": "Kunde inte spara fynd",
        "hse.evaluation.findings.create_tiltak": "Skapa åtgärd",
        "hse.evaluation.participants.choose": "Välj deltagare",
        "hse.evaluation.participants.choose_one": "Välj person",
        "hse.evaluation.participants.chosen": "{{count}} valda",
        "hse.evaluation.participants.empty": "Inga deltagare registrerade",
        "hse.evaluation.tiltak": "Åtgärd",
        "hse.evaluation.tiltak.dialog_title": "Ny åtgärd",
        "hse.evaluation.tiltak.dialog_hint": "Skapa en åtgärd från detta fynd, eller öppna åtgärdssidan.",
        "hse.evaluation.tiltak.create": "Skapa åtgärd",
        "hse.evaluation.tiltak.created": "Åtgärd skapad",
        "hse.evaluation.tiltak.create_failed": "Kunde inte skapa åtgärd här. Öppna åtgärdssidan i stället.",
        "hse.evaluation.tiltak.title_required": "Åtgärd behöver en titel",
        "hse.evaluation.tiltak.open_page": "Öppna åtgärdssidan",
        "hse.evaluation.tiltak.open_existing": "Visa åtgärd",
        "hse.evaluation.statuses.closed": "Avslutad",
        "hse.evaluation.fields.held_on": "Genomförd",
        "hse.evaluation.fields.period_from": "Period från",
        "hse.evaluation.fields.period_to": "Period till",
        "hse.evaluation.fields.result": "Resultat",
        "hse.evaluation.fields.summary": "Sammanfattning",
        "hse.evaluation.fields.findings": "Fynd",
        "hse.evaluation.fields.conclusions": "Slutsats",
        "hse.evaluation.fields.responsible": "Ansvarig",
        "hse.evaluation.fields.responsible_required": "Välj ansvarig",
        "hse.evaluation.results.passed": "Godkänd",
        "hse.evaluation.results.failed": "Ej godkänd",
        "hse.evaluation.results.conditional": "Villkorad",
        "hse.evaluation.export_pdf": "Exportera PDF",
        "hse.evaluation.export_failed": "Kunde inte exportera PDF",
        "hse.evaluation.tiltak.from_review": "Åtgärder från denna genomgång",
        "hse.evaluation.tiltak.empty": "Inga åtgärder kopplade ännu",
        "hse.evaluation.tiltak.types.generic": "Generell",
        "hse.evaluation.tiltak.types.new_routine": "Ny rutin",
        "hse.evaluation.tiltak.types.linked_document": "Kopplat dokument",
        "hse.evaluation.tiltak.deadline_required": "Åtgärd behöver ett datum",
        "hse.evaluation.tiltak.responsible_required": "Åtgärd behöver en ansvarig",
        "hse.evaluation.tiltak.dialog_from_text": "Skapa en åtgärd från fynden i denna genomgång.",
        "hse.evaluation.fields.action_type": "Åtgärdstyp",
        "hse.evaluation.results.none": "Inte satt",
        "hse.evaluation.exporting": "Laddar PDF…",
        "hse.evaluation.tiltak.open_count": "{{count}} öppna åtgärder",
        "common.error_state.not_found.title": "Sidan hittades inte",
        "common.error_state.not_found.description": "Vi hittade inte det du sökte. Det kan ha tagits bort, flyttats eller så är adressen fel.",
        "common.error_state.forbidden.title": "Ingen åtkomst",
        "common.error_state.forbidden.description": "Du har inte åtkomst till den här sidan eller resursen.",
        "common.error_state.load_error.title": "Kunde inte ladda",
        "common.error_state.load_error.description": "Något gick fel när vi hämtade data. Kontrollera anslutningen och försök igen.",
        "common.unexpected_error": "Något gick fel. Försök igen.",
        "common.error_state.empty.title": "Inga träffar",
        "common.error_state.empty.description": "Det finns inga objekt att visa här ännu.",
        "common.error_state.action.back": "Tillbaka",
        "common.error_state.action.dashboard": "Till dashboard",
        "common.error_state.action.retry": "Försök igen",
        "common.error_state.action.home": "Till startsidan",
        "common.error_state.details_heading": "Detaljer",
        "hse.events.title": "Händelser",
        "hse.events.subtitle": "Avvikelser, tillbud, olyckor och observationer",
        "hse.events.search": "Sök händelser…",
        "hse.events.empty": "Inga händelser hittades",
        "hse.events.nav.aria": "Händelsetyper",
        "hse.events.tab.all": "Alla",
        "hse.events.tab.deviations": "Avvikelser",
        "hse.events.tab.near_misses": "Tillbud",
        "hse.events.tab.accidents": "Olyckor",
        "hse.events.tab.complaints": "Reklamationer",
        "hse.events.tab.observations": "Observationer",
        "hse.competency.nav.aria": "Kompetenssidor",
        "hse.competency.nav.my": "Min kompetens",
        "hse.competency.nav.definitions": "Definitioner",
        "hse.competency.nav.matrix": "Matris",
        "hse.competency.nav.roles": "Roller",
        "hse.competency.nav.employees": "Anställda",
        "hse.competency.nav.expiring": "Utgår",
        "hse.competency.nav.courses": "Kurser",
        "hse.competency.nav.training_plan": "Utbildningsplan",
        "hse.competency.nav.guide": "Guide",
        "hse.events.new": "Ny händelse",
        "hse.events.type.injury": "Skada",
        "hse.events.type.near_miss": "Tillbud",
        "hse.events.type.property_damage": "Materiellskada",
        "hse.events.type.environmental": "Miljöhändelse",
        "hse.events.type.other": "Annat",
        "hse.documents.title": "Dokument",
        "hse.documents.subtitle": "Styrande dokument med versionskontroll",
        "hse.documents.nav.aria": "Dokumenttyper",
        "hse.documents.tab.all": "Alla",
        "hse.documents.tab.policies": "Policyer",
        "hse.documents.tab.procedures": "Procedurer",
        "hse.documents.tab.instructions": "Instruktioner",
        "hse.documents.tab.forms": "Formulär",
        "hse.documents.tab.guidance": "Vägledningar",
        "hse.documents.tab.record": "Registreringar",
        "hse.documents.tab.template": "Mallar",
        "hse.documents.new": "Nytt dokument",
        "hse.actions.open": "Öppna",
        "hse.actions.edit": "Redigera",
        "hse.actions.export_pdf": "Exportera PDF",
        "hse.actions.export_pdf_loading": "Exporterar…",
        "hse.actions.export_pdf_success": "PDF nedladdad",
        "hse.actions.export_pdf_error": "Kunde inte exportera PDF",
        "hse.actions.approve": "Godkänn",
        "hse.actions.revisions": "Revisioner",
        "hse.actions.submit": "Skicka in",
        "hse.actions.close_event": "Stäng händelse",
        "hse.actions.delete": "Ta bort",
        "hse.events.delete_confirm": "Är du säker på att du vill ta bort den här händelsen?",
        "hse.events.deleted": "Händelsen togs bort",
        "hse.events.delete_error": "Kunde inte ta bort händelsen",
        "hse.events.submitted": "Händelsen skickades in",
        "hse.events.submit_error": "Kunde inte skicka in händelsen",
        "hse.events.closed": "Händelsen stängdes",
        "hse.events.close_error": "Kunde inte stänga händelsen",
        "hse.protective.title": "Skyddsrundor",
        "hse.protective.subtitle": "Skyddsrundor och personlig skyddsutrustning",
        "hse.protective.new": "Ny skyddsrunda",
        "hse.protective.search": "Sök skyddsrundor…",
        "hse.protective.empty": "Inga skyddsrundor hittades",
        "hse.protective.equipment_title": "Personlig skyddsutrustning",
        "hse.protective.equipment_empty": "Ingen skyddsutrustning hittades",
        "hse.protective.status.draft": "Utkast",
        "hse.protective.status.in_progress": "Pågår",
        "hse.protective.status.completed": "Genomförd",
        "hse.protective.status.closed": "Stängd",
        "hse.actions.menu": "Åtgärder",
        "hse.protective.open": "Öppna",
        "hse.protective.edit": "Redigera",
        "hse.protective.actions": "Åtgärder",
        "hse.protective.col_title": "Titel",
        "hse.protective.col_date": "Datum",
        "hse.protective.col_location": "Plats",
        "hse.protective.col_status": "Status",
        "hse.protective.field.description": "Beskrivning",
        "hse.protective.field.registered_by": "Registrerad av",
        "hse.protective.view_title": "Skyddsrunda",
        "hse.protective.view_subtitle": "Detaljer och resultat för skyddsrundan",
        "hse.protective.load_failed": "Kunde inte läsa skyddsrundan",
        "hse.protective.export_pdf": "Ladda ner PDF",
        "hse.protective.export_pdf_loading": "Laddar ner PDF…",
        "hse.protective.export_pdf_success": "PDF nedladdad",
        "hse.protective.export_pdf_error": "Kunde inte ladda ner PDF",

        // i18n hotfix 2026-09-07 — filled missing dotted keys
        "absence.overview.export_hint": "Ladda ner frånvaroöversikten som PDF.",
        "absence.overview.export_pdf": "Exportera PDF",
        "absence.overview.exporting": "Exporterar…",
        "absence.overview.pdf_export_failed": "Kunde inte exportera PDF",
        "absence.overview.pdf_exported": "PDF nedladdad",
        "absence.overview.pdf_too_small": "PDF-filen blev för liten. Försök igen.",
        "absence.overview.debug_export": "Exportera komptid-JSON",
        "absence.overview.debug_exporting": "Exporterar…",
        "absence.overview.debug_export_hint": "Ladda ner beräkningen för återstående komptid (timmar, formel och rader).",
        "absence.overview.debug_exported": "Komptid-JSON nedladdad",
        "absence.overview.debug_export_failed": "Kunde inte exportera komptid-JSON",
        "absence.stats.avspassering.title": "Komptid",
        "absence.stats.avspassering.earned_last_year": "Intjänat förra året",
        "absence.stats.avspassering.used_last_year": "Använt förra året",
        "absence.stats.avspassering.earned_this_year": "Intjänat i perioden",
        "absence.stats.avspassering.used_this_year": "Använt i perioden",
        "absence.stats.avspassering.remaining": "Återstående",
        "absence.stats.avspassering.guide_aria": "Så beräknas komptid",
        "absence.stats.avspassering.guide_title": "Så beräknas komptid",
        "absence.stats.avspassering.guide_body": "Återstående = (intjänat förra året − använt förra året) + (intjänat i perioden − använt i perioden).\n\nIntjänat är övertid per dag: registrerade timmar minus förväntad tid från arbetsschemat (skalat med tjänstgöringsgrad). Röda dagar och dagar utan planerad tid har förväntat 0.\n\nAnvänt är arbetstid på komptidsfrånvaro som inte är avslagen, klippt till perioden.\n\nBara föregående kalenderår förs över. Ladda ner JSON från översikten för att se alla rader.",
        "cases.create.user_assigned": "Ärende skapat och tilldelat",
        "cases.settings.notify.description": "Skicka e-post när ett nytt ärende kommer in automatiskt.",
        "cases.settings.notify.load_failed": "Kunde inte läsa aviseringsinställningar",
        "cases.settings.notify.loading": "Läser inställningar…",
        "cases.settings.notify.missing_email": "Ange en e-postadress för avisering.",
        "cases.settings.notify.no_company_email": "ingen företagsadress",
        "cases.settings.notify.override_hint": "Lämna tomt för att använda {{email}}.",
        "cases.settings.notify.override_label": "Annan aviseringsadress",
        "cases.settings.notify.save": "Spara",
        "cases.settings.notify.save_failed": "Kunde inte spara aviseringsinställningar",
        "cases.settings.notify.saved": "Aviseringsinställningar sparade",
        "cases.settings.notify.saving": "Sparar…",
        "cases.settings.notify.title": "Automatisk ärendeavisering",
        "cases.settings.notify.toggle": "Avisera vid nya ärenden",
        "cases.settings.notify.toggle_hint": "Skickar e-post när ett ärende skapas automatiskt.",
        "chemical.inventory.disposal_considerations": "Avfallshantering",
        "chemical.inventory.ecological_info": "Ekologisk information",
        "chemical.inventory.exposure_limits": "Exponeringsgränser",
        "chemical.inventory.fire_measures": "Brandbekämpningsåtgärder",
        "chemical.inventory.general_use": "Allmän användning",
        "chemical.inventory.general_use_risk": "Riskbedömning – allmän användning",
        "chemical.inventory.hazard_classification": "Faroklassificering",
        "chemical.inventory.location_specific_risk": "Platsspecifik riskbedömning",
        "chemical.inventory.per_operation_risk": "Riskbedömning – per arbetsmoment",
        "chemical.inventory.risk_assessment": "Riskbedömning",
        "chemical.inventory.risk_assessment_documents": "Dokument för riskbedömning",
        "chemical.inventory.spill_measures": "Åtgärder vid utsläpp",
        "chemical.inventory.stability_reactivity": "Stabilitet och reaktivitet",
        "chemical.inventory.storage_conditions": "Lagringsförhållanden",
        "chemical.inventory.storage_location": "Lagringsplats",
        "chemical.inventory.toxicological_info": "Toxikologisk information",
        "chemical.inventory.transport_info": "Transportinformation",
        "chemical.inventory.usage_instructions": "Bruksanvisning",
        "common.cancel": "Avbryt",
        "common.active": "Aktiv",
        "common.description": "Beskrivning",
        "common.no": "Nej",
        "common.yes": "Ja",
        "common.back": "Tillbaka",
        "common.close": "Stäng",
        "common.new": "Ny",
        "common.menu": "Meny",
        "common.edit": "Redigera",
        "common.delete": "Radera",
        "common.open": "Öppna",
        "common.details": "Detaljer",
        "common.none": "Ingen",
        "common.create": "Skapa",
        "common.creating": "Skapar…",
        "common.saving": "Sparar…",
        "common.update": "Uppdatera",
        "confirmation.sure": "Är du säker på att du vill",
        "connected.to.phonero.but.presence.not.available": "Ansluten till Phonero, men närvaro är inte tillgänglig.",
        "contact.customer.explanation": "Kontaktpersonen kopplas till kunden.",
        "contact.email": "E-post",
        "contact.mobile": "Mobil",
        "contact.name": "Namn",
        "contacts.create": "Ny kontakt",
        "crew.shift.week_of": "Vecka från",
        "customer.required": "Kund krävs",
        "customers.create": "Ny kund",
        "deviation.notification.failed_at": "Misslyckades",
        "deviation.notification.mode.digest": "Sammandrag",
        "deviation.notification.mode.immediate": "Omedelbart",
        "deviation.notification.scheduled_at": "Schemalagd",
        "deviation.notification.send_log_empty": "Inga utskick ännu.",
        "deviation.notification.send_log_title": "Sändlogg",
        "deviation.notification.sent_at": "Skickad",
        "deviation.notification.status.failed": "Misslyckades",
        "deviation.notification.status.cancelled": "Avbruten",
        "deviation.notification.status.scheduled": "Schemalagd",
        "deviation.email_failed.banner": "Utskick via e-post misslyckades. Öppna avvikelsen och skicka igen.",
        "deviation.email_failed.row": "E-post misslyckades",
        "deviation.description.title": "Beskrivning",
        "deviation.description.help": "Beskrivningen sparas på avvikelsen. Bilder och dokumentation ligger samlade under.",
        "deviation.description.placeholder": "Skriv vad som har hänt",
        "deviation.description.save": "Spara beskrivning",
        "deviation.description.saved": "Beskrivningen är sparad",
        "deviation.description.empty": "Ingen beskrivning är skriven ännu.",
        "deviation.description.legacy_title": "Tidigare förklaring",
        "deviation.description.legacy_help": "Det här är text från äldre avvikelsepunkter. Den ligger kvar och flyttas eller raderas inte.",
        "deviation.documents.help": "Ladda upp bilder och dokumentation. Från en ritning sparas både utsnitt och bild på avvikelsen.",
        "deviation.priority": "Prioritet",
        "deviation.item.consequence": "Konsekvens",
        "common.title": "Titel",
        "deviation.form.choose_who_should_own_this_deviation": "Velg hvem som skal eie dette avviket",
        "deviation.form.create": "Opprett",
        "deviation.form.create_deviation": "Opprett avvik",
        "deviation.form.deviation_type": "Avvikstype",
        "deviation.form.edit_deviation": "Rediger avvik",
        "deviation.form.no_email": "Ingen e-post",
        "deviation.form.no_employees_found": "Ingen ansatte funnet",
        "deviation.form.responsible_for_follow_up": "Ansvarlig for oppfølging",
        "deviation.form.responsible_user": "Ansvarlig bruker",
        "deviation.form.search_employees": "Søk ansatte",
        "deviation.form.select_deviation_type": "Velg avvikstype",
        "deviation.form.select_priority": "Velg prioritet",
        "deviation.form.select_responsible_user": "Velg ansvarlig bruker",
        "deviation.form.select_severity": "Velg alvorlighetsgrad",
        "deviation.form.selected": "Valgt",
        "deviation.form.update": "Oppdater",

        "vehicle.body_style": "Karosseri",
        "vehicle.current_odometer_km": "Nåværende kilometerstand (km)",
        "vehicle.edit_vehicle": "Rediger kjøretøy",
        "vehicle.engine_size_cc": "Motoreffekt (cc)",
        "vehicle.first_registration": "Første registrering",
        "vehicle.fuel_type": "Drivstofftype",
        "vehicle.inspection_information": "Besiktningsinformasjon",
        "vehicle.inspection_result": "Besiktningsresultat",
        "vehicle.inspection_station": "Besiktningsstasjon",
        "vehicle.last_inspection_date": "Siste besiktningsdato",
        "vehicle.last_ride": "Siste tur",
        "vehicle.last_service_date": "Siste servicedato",
        "vehicle.make": "Merke",
        "vehicle.model": "Modell",
        "vehicle.model_year": "Årsmodell",
        "vehicle.next_inspection_date": "Neste besiktningsdato",
        "vehicle.next_service_date": "Neste servicedato",
        "vehicle.nickname": "Kallenavn",
        "vehicle.norwegian": "Norsk",
        "vehicle.number_plate": "Registreringsnummer",
        "vehicle.power_kw": "Effekt (kW)",
        "vehicle.registration_date": "Registreringsdato",
        "vehicle.service_information": "Serviceinformasjon",
        "vehicle.service_interval_km": "Serviceintervall (km)",
        "vehicle.service_provider": "Serviceleverandør",
        "vehicle.statens_vegvesen_information": "Statens Vegvesen Informasjon",
        "vehicle.vehicle_handbook": "Kjøretøyhåndbok",
        "vehicle.vehicle_information": "Fordoninformasjon",
        "vehicle.vehicle_type": "Fordonstype",
        "vehicle.vin_chassis_number": "VIN (Chassisnummer)",
        "vehicle.warranty_end_date": "Garanti sluttdato",
        "vehicle.warranty_type": "Garantitype",

        "deviation.list.title": "Avvikelser",
        "deviation.list.statuses": "Statusar",
        "deviation.list.types": "Avvikelsetyper",
        "deviation.list.priorities": "Prioriteringar",
        "deviation.list.type": "Typ",
        "deviation.table.number": "Nummer",
        "deviation.table.deviation": "Avvikelse",
        "deviation.table.untitled": "Utan titel",
        "deviation.table.type_missing": "Typ saknas",
        "deviation.table.unlinked": "Ej kopplad",
        "deviation.table.status": "Status",
        "deviation.table.responsible": "Ansvarig",
        "deviation.table.unassigned": "Ej tilldelad",
        "deviation.table.created": "Skapad",
        "deviation.consequence.pick": "Välj typ av konsekvens",
        "deviation.consequence.dialog_title": "Konsekvens: {{type}}",
        "deviation.consequence.save": "Spara konsekvens",
        "deviation.consequence.type.1": "Ekonomisk",
        "deviation.consequence.type.2": "Framsteg",
        "deviation.consequence.type.3": "Säkerhet",
        "deviation.consequence.type.4": "Miljö",
        "deviation.consequence.type.5": "Kvalitet",
        "deviation.consequence.type.6": "Myndighet",
        "deviation.consequence.type.7": "Annat",
        "deviation.delete.action": "Radera",
        "deviation.delete.forbidden": "Du har inte behörighet att radera eller avsluta avvikelsen.",
        "deviation.delete.can_delete_title": "Avvikelsen kan raderas",
        "deviation.delete.can_delete_body": "Viktiga kopplingar är borttagna eller avslutade. Avvikelsen raderas.",
        "deviation.delete.close_title": "Avvikelsen kan inte raderas",
        "deviation.delete.close_body": "Du kan avsluta utan att färdigställa. Avvikelsen stängs, men markeras inte som färdigställd.",
        "deviation.delete.confirm_delete": "Radera avvikelsen",
        "deviation.delete.confirm_close": "Avsluta utan färdigställande",
        "deviation.delete.reasons": "Därför kan den inte raderas",
        "deviation.delete.closed": "Avvikelsen avslutades utan färdigställande",
        "deviation.delete.deleted": "Avvikelsen är raderad",
        "deviation.history.caption": "Här ser du vad som har gjorts med avvikelsen, bland annat arbetsorder och utskick.",
        "deviation.work_order.linked_banner": "Den här avvikelsen är kopplad till arbetsorder {{title}}.",
        "deviation.send.copy_always": "Alltid kopia",
        "deviation.send.copy_off": "Ingen kopia",
        "deviation.send.digest_hint": "Samlas och skickas i nästa sammandrag.",
        "deviation.send.immediate_hint": "Skickas direkt.",
        "deviation.send.failed": "Kunde inte skicka avvikelsen",
        "deviation.send.success_partial": "Vissa mottagare fick avvikelsen. Se sändloggen.",
        "deviation.send.success_scheduled": "Avvikelsen ligger i kö för utskick.",
        "deviation.send.success_sent": "Avvikelsen har skickats.",
        "deviation.settings.subtitle": "Avisering och utskick av avvikelser",
        "employee.contact.information": "Kontaktinformation",
        "employee.view.profile": "Visa profil",
        "employee.work.mobile": "Jobbmobil",
        "employee_selector.clear_all": "Rensa alla",
        "employee_selector.confirm": "Välj",
        "employee_selector.empty_hint": "Sök på namn eller e-post.",
        "employee_selector.load_error": "Kunde inte läsa anställda",
        "employee_selector.load_more": "Läs fler",
        "employee_selector.loading": "Läser…",
        "employee_selector.no_results": "Inga träffar",
        "employee_selector.search_placeholder": "Sök anställda…",
        "employee_selector.selected_count": "{{count}} valda",
        "employee_selector.title_multiple": "Välj anställda",
        "employee_selector.title_single": "Välj anställd",
        "error.fetching_communcations": "Kunde inte hämta kommunikation",
        "failed.to.create.communication": "Kunde inte skapa kommunikation",
        "failed.to.load.report": "Kunde inte läsa rapporten",
        "hours.resource_plan.planned_tasks": "Planerade uppgifter",
        "hours.resource_plan.table.planned": "Planerad",
        "hse_document_selector.all_documents": "Alla dokument",
        "hse_document_selector.no_documents": "Inga dokument",
        "hse_document_selector.recent": "Senaste",
        "hse_document_selector.search_placeholder": "Sök dokument…",
        "hse_document_selector.search_results": "Sökresultat",
        "image.select": "Välj bild",
        "inventory.count.add_items": "Lägg till artiklar",
        "inventory.count.add_items_bulk": "Lägg till flera artiklar",
        "inventory.count.add_products_bulk": "Lägg till flera produkter",
        "inventory.count.adding_products": "Lägger till produkter…",
        "inventory.count.bulk.no_valid_items": "Inga giltiga rader att lägga till.",
        "inventory.count.copy_all_products_from_storage": "Kopiera alla produkter från lager",
        "inventory.count.copy_all_products_info": "Kopierar alla produkter i lagret till räkningen.",
        "inventory.count.copy_from_count": "Kopiera från räkning",
        "inventory.count.copy_from_existing": "Kopiera från befintlig",
        "inventory.count.copy_options": "Kopieringsval",
        "inventory.count.create_and_copy": "Skapa och kopiera",
        "inventory.count.create_description": "Skapa en ny inventering.",
        "inventory.count.created": "Räkning skapad",
        "inventory.count.description": "Beskrivning",
        "inventory.count.item.approve_error": "Kunde inte godkänna raden",
        "inventory.count.item.approved": "Godkänd",
        "inventory.count.item.unapproved": "Ej godkänd",
        "inventory.count.item_number_placeholder": "Artikelnummer",
        "inventory.count.items_add_error": "Kunde inte lägga till artiklar",
        "inventory.count.items_added": "Artiklar tillagda",
        "inventory.count.none": "Inga räkningar",
        "inventory.count.product.add_error": "Kunde inte lägga till produkten",
        "inventory.count.product.found": "Produkt hittad",
        "inventory.count.product.no_exact_match": "Ingen exakt träff",
        "inventory.count.products_added": "Produkter tillagda",
        "inventory.count.unapproved": "Ej godkänd",
        "meeting_minutes.entry.deleted": "Post raderad",
        "microsoft.ai_mailboxes.ai_routing.create_case_and_reply_hint": "Skapar ärende och föreslår svar.",
        "microsoft.ai_mailboxes.settings.case_filters_replaced_body": "De gamla ärendefiltren har ersatts av nya regler.",
        "microsoft.ai_mailboxes.settings.case_filters_replaced_title": "Ärendefilter ersatta",
        "no.communications.found": "Ingen kommunikation hittades",
        "no.number": "Ingen",
        "offer.calculation.load_error": "Kunde inte läsa kalkylen",
        "order.date": "Orderdatum",
        "order.info": "Orderinformation",
        "order.number": "Ordernummer",
        "order.total": "Totalsumma",
        "order.save.success": "Ordern är sparad",
        "order.items.storage.automatic": "Automatiskt lager (störst saldo)",
        "order.items.storage.automatic_help": "Tomt lager fylls automatiskt vid leveransdatum eller faktura — lager med störst saldo för produkten.",
        "order.items.storage.active": "Aktivt lager: {{name}}",
        "order.items.pick_status.picked_delivered": "Plockat/levererat {{qty}}",
        "order.items.pick_status.not_picked": "Inte plockat",
        "order.items.pick_status.line_label": "Radstatus",
        "order.items.qty.ordered": "Beställt: {{qty}}",
        "order.items.qty.ordered_label": "Beställt",
        "order.items.qty.picked_delivered": "Plockat/levererat: {{qty}}",
        "order.items.qty.available": "Tillgängligt: {{qty}}",
        "order.items.qty.tracked": "I lager: {{qty}}",
        "order.items.warehouse_pick.open": "Lager och plock",
        "product.brands.create": "Nytt märke",
        "product.brands.edit": "Redigera märke",
        "product.edit": "Redigera produkt",
        "project.activities.duplicate": "Duplicera",
        "project.activities.duplicate_error": "Kunde inte duplicera aktiviteten",
        "project.activities.duplicated": "Aktivitet duplicerad",
        "project.activities.duplicating": "Duplicerar…",
        "project.activities.export_pdf": "Exportera PDF",
        "project.activities.export_pdf_error": "Kunde inte exportera PDF",
        "project.activities.export_pdf_loading": "Skapar PDF…",
        "project.activities.export_pdf_success": "PDF nedladdad",
        "project.activities.group_add_activity": "Lägg till aktivitet i gruppen",
        "project.activities.group_created": "Grupp skapad",
        "project.activities.group_delete": "Radera grupp",
        "project.activities.group_delete_confirm": "Radera den här gruppen? Aktiviteterna blir utan grupp.",
        "project.activities.group_delete_error": "Kunde inte radera gruppen",
        "project.activities.group_deleted": "Grupp raderad",
        "project.activities.group_drag": "Dra för att flytta",
        "project.activities.group_duplicate": "Duplicera grupp",
        "project.activities.group_duplicate_confirm": "Duplicera",
        "project.activities.group_duplicate_error": "Kunde inte duplicera gruppen",
        "project.activities.group_duplicate_hint": "Skapa en kopia av gruppen och aktiviteterna.",
        "project.activities.group_duplicate_name_suggestion": "{{name}} (kopia)",
        "project.activities.group_duplicated": "Grupp duplicerad",
        "project.activities.group_edit": "Redigera grupp",
        "project.activities.group_empty": "Inga aktiviteter i gruppen",
        "project.activities.group_load_error": "Kunde inte läsa grupper",
        "project.activities.group_new": "Ny grupp",
        "project.activities.group_reorder_error": "Kunde inte ändra ordning",
        "project.activities.group_save_error": "Kunde inte spara gruppen",
        "project.activities.group_title": "Grupptitel",
        "project.activities.group_title_placeholder": "Gruppens namn",
        "project.activities.group_title_required": "Grupptitel krävs",
        "project.activities.group_updated": "Grupp uppdaterad",
        "project.billing_plan.invoice": "Faktura",
        "project.description": "Beskrivning",
        "project.end_date": "Slutdatum",
        "project.hourly_costs": "Timkostnader",
        "project.hourly_costs.calculation": "Beräkning av timkostnader",
        "project.hourly_costs.missing_rate_warning": "Saknar giltig timkostnad för den här anställda",
        "project.hourly_costs.social_expenses": "Sociala avgifter (28%)",
        "project.hourly_costs.total_cost": "Total timkostnad",
        "project.hourly_costs.warning_title": "Varning: saknad timkostnad",
        "project.item_list.purchase_price": "Inköpspris",
        "project.item_list.sales_price": "Försäljningspris",
        "project.item_list.select_warehouse_description": "Välj lagret varorna ska tas från.",
        "project.manager.required": "Projektledare krävs",
        "project.name": "Projektnamn",
        "project.name.required": "Projektnamn krävs",
        "project.number": "Projektnummer",
        "project.order_line.a_account": "A-konto",
        "project.order_line.description": "Beskrivning",
        "project.required": "Projekt krävs",
        "project.settings": "Projektinställningar",
        "project.settings.default_due_days": "Standard 60 dagar",
        "project.settings.final_invoice_due_days": "Slutfaktura innestående förfallodagar",
        "project.start_date": "Startdatum",
        "project.supplier_invoices.create": "Skapa leverantörsfaktura",
        "project.supplier_invoices.error.title": "Fel på leverantörsfaktura",
        "project.supplier_invoices.overview": "Leverantörsfakturor",
        "project.supplier_invoices.status.approved": "Godkänd",
        "project.supplier_invoices.status.not_approved": "Ej godkänd",
        "project.supplier_invoices.status.overdue": "Förfallen",
        "project.supplier_invoices.status.paid": "Betald",
        "project.supplier_invoices.status.pending": "Väntar",
        "project.tripletex_sync.disabled": "Synkronisering avstängd för projekt med flera fakturor",
        "project.tripletex_sync.reason": "Projektet har fler än 1 faktura och är synkat med Tripletex",
        "project_activity.ungrouped": "Ogrupperad",
        "projects.create": "Nytt projekt",
        "projects.edit": "Redigera projekt",
        "quality.checklist.page.missingTitle": "Checklista utan titel",
        "quality.checklist.page.qualitySubtitle": "Kvalitetschecklista",
        "quality.checklist.page.reportSubtitle": "Rapportchecklista",
        "report.agreement.redesign.day_help": "Välj vilken dag avtalet gäller.",
        "report.agreement.redesign.next_day_time": "Nästa dag och tid",
        "report.agreement.redesign.next_settings": "Nästa inställningar",
        "report.agreement.redesign.step_day": "Dag",
        "report.finish.description": "Slutför och stäng rapporten.",
        "report.hours.description": "Timmar förda på rapporten.",
        "report.list.agreed_date": "Avtalat datum",
        "report.price_lines.confirm_delete": "Radera den här prisraden?",
        "report.variables.description": "Variabler på rapporten.",
        "report.write.description": "Skriv och fyll i rapporten.",
        "service.agreement_types": "Avtalstyper",
        "service.agreement_types.create": "Ny avtalstyp",
        "service.agreement_types.edit": "Redigera avtalstyp",
        "service.agreements.info.vat_excluded": "Priser är exklusive moms",
        "service.checklist_types.create": "Ny checklistetyp",
        "service.checklist_types.edit": "Redigera checklistetyp",
        "service.report_types": "Rapporttyper",
        "service.report_types.create": "Ny rapporttyp",
        "service.report_types.edit": "Redigera rapporttyp",
        "service.variable_types": "Variabeltyper",
        "service.variable_types.create": "Ny variabeltyp",
        "service.variable_types.edit": "Redigera variabeltyp",
        "storage.add": "Lägg till lager",
        "storage.create": "Nytt lager",
        "storage.edit": "Redigera lager",
        "title.required": "Titel krävs",
        "work_order.plan_modal.plan_description": "Planbeskrivning",
        "work_order.plan_modal.plan_description_placeholder": "Vad ska göras?",
        "work_order.plan_modal.plan_title_help": "Kort titel som visas i planen.",
        "community.feed.section.accepted": "Godkända av Promang",
        "community.feed.section.accepted_help": "Dessa förslag har godkänts och förblir synliga här efter admin-granskning.",
        "community.feed.section.open": "Öppna för omröstning",
        "operation_feedback.processing": "Behandlingen pågår.",
        "operation_feedback.hide": "Dölj förlopp",
        "operation_feedback.close": "Stäng",
        "operation_feedback.step.pending": "Väntar",
        "operation_feedback.step.running": "Pågår",
        "operation_feedback.step.completed": "Slutförd",
        "operation_feedback.step.already_applied": "Redan utförd",
        "operation_feedback.step.not_relevant": "Inte relevant",
        "operation_feedback.step.needs_fix": "Måste åtgärdas",
        "operation_feedback.step.not_done": "Inte utförd",
        "operation_feedback.step.failed": "Misslyckades",
        "operation_feedback.step.rolled_back": "Återställd",
        "operation_feedback.step.unconfirmed": "Inte bekräftad",
        "operation_feedback.step.cancelled": "Avbruten",
        "operation_feedback.saved_list_refresh_failed": "Sparad. Listan kunde inte uppdateras.",
        "operation_feedback.taking_longer": "Behandlingen tar längre tid. Vi kontrollerar status.",
        "operation_feedback.finish_report.title": "Slutför serviceuppdrag {{number}}",
        "operation_feedback.finish_report.step.preflight": "Obligatoriska uppgifter kontrollerade",
        "operation_feedback.finish_report.step.save": "Rapporten sparas",
        "operation_feedback.finish_report.step.finish_checklist": "Checklista uppdateras",
        "operation_feedback.finish_report.step.update_agreement": "Serviceavtal uppdateras",
        "operation_feedback.finish_report.step.refresh": "Uppdaterar vyn",
        "operation_feedback.finish_report.preflight_ok": "Förutsättningarna är uppfyllda.",
        "operation_feedback.finish_report.preflight_skipped": "Ingen förkontroll laddad.",
        "operation_feedback.finish_report.preflight_blocked": "Rapporten kan inte slutföras. Åtgärda kontrollpunkterna först.",
        "operation_feedback.finish_report.save_ok": "Rapporten sparades som slutförd.",
        "operation_feedback.finish_report.success": "Serviceuppdraget är slutfört.",
        "operation_feedback.finish_report.open_report": "Öppna rapport",
        "operation_feedback.create_reports.title": "Skapar serviceuppdrag för {{count}} underavtal",
        "operation_feedback.create_reports.step.preflight": "Kontrollerar val och leveransadress",
        "operation_feedback.create_reports.step.create": "Skapar serviceuppdrag",
        "operation_feedback.create_reports.step.refresh": "Uppdaterar vyn",
        "operation_feedback.create_reports.preflight_ok": "Val och adresser ser bra ut.",
        "operation_feedback.create_reports.preflight_no_selection": "Inga underavtal är valda.",
        "operation_feedback.create_reports.create_ok": "Skapade {{count}} serviceuppdrag.",
        "operation_feedback.create_reports.success": "{{count}} serviceuppdrag har skapats.",
        "operation_feedback.create_reports.atomic_failed": "Inga serviceuppdrag skapades.",
        "operation_feedback.create_reports.open_report": "Öppna rapport {{id}}",
        "operation_feedback.send_report.title": "Skickar serviceuppdrag {{number}}",
        "operation_feedback.send_report.step.preflight": "Kontrollerar mottagare och rapporttyp",
        "operation_feedback.send_report.step.queue": "Köar utskick",
        "operation_feedback.send_report.step.deliver": "Genererar PDF och skickar",
        "operation_feedback.send_report.step.refresh": "Uppdaterar vyn",
        "operation_feedback.send_report.preflight_ok": "Mottagare och rapporttyp ser bra ut.",
        "operation_feedback.send_report.preflight_missing_email": "E-postadress saknas.",
        "operation_feedback.send_report.preflight_missing_type": "Rapporttyp saknas.",
        "operation_feedback.send_report.preflight_missing_id": "Rapport-ID saknas.",
        "operation_feedback.send_report.queue_ok": "Utskick har lagts i kö.",
        "operation_feedback.send_report.deliver_sync": "Utskick slutfördes utan bakgrundsjobb.",
        "operation_feedback.send_report.deliver_queued": "Väntar i kö…",
        "operation_feedback.send_report.deliver_processing": "Genererar PDF och skickar…",
        "operation_feedback.send_report.deliver_ok": "Rapporten har skickats.",
        "operation_feedback.send_report.deliver_failed": "Utskick misslyckades.",
        "operation_feedback.send_report.deliver_poll_retry": "Statuskontroll misslyckades (försöker igen): {{message}}",
        "operation_feedback.send_report.deliver_timeout": "Utskick tog för lång tid. Kontrollera status manuellt.",
        "operation_feedback.send_report.success": "Serviceuppdraget har skickats.",
        "operation_feedback.send_report.open_report": "Öppna rapport",
        "operation_feedback.list_update_agreements.title": "Uppdaterar {{count}} serviceavtal",
        "operation_feedback.list_update_agreements.dialog_title": "Redigerar {{count}} avtal",
        "operation_feedback.list_update_agreements.step.preflight": "Kontrollerar urval",
        "operation_feedback.list_update_agreements.step.update": "Uppdaterar avtal",
        "operation_feedback.list_update_agreements.step.refresh": "Uppdaterar listan",
        "operation_feedback.list_update_agreements.preflight_ok": "{{count}} avtal är valda.",
        "operation_feedback.list_update_agreements.preflight_no_selection": "Inga avtal är valda.",
        "operation_feedback.list_update_agreements.update_ok": "{{count}} avtal har uppdaterats.",
        "operation_feedback.list_update_agreements.success": "{{count}} serviceavtal har uppdaterats.",
        "operation_feedback.list_update_agreements.confirm_title": "Är du säker?",
        "operation_feedback.list_update_agreements.confirm_body": "Du redigerar nu {{count}} avtal. Detta kan inte ångras.",
        "operation_feedback.list_update_reports.title": "Uppdaterar {{count}} serviceuppdrag",
        "operation_feedback.list_update_reports.dialog_title": "Redigerar {{count}} uppdrag",
        "operation_feedback.list_update_reports.step.preflight": "Kontrollerar urval",
        "operation_feedback.list_update_reports.step.update": "Uppdaterar uppdrag",
        "operation_feedback.list_update_reports.step.refresh": "Uppdaterar listan",
        "operation_feedback.list_update_reports.preflight_ok": "{{count}} uppdrag är valda.",
        "operation_feedback.list_update_reports.preflight_no_selection": "Inga uppdrag är valda.",
        "operation_feedback.list_update_reports.update_ok": "{{count}} uppdrag har uppdaterats.",
        "operation_feedback.list_update_reports.success": "{{count}} serviceuppdrag har uppdaterats.",
        "operation_feedback.list_update_reports.confirm_title": "Är du säker?",
        "operation_feedback.list_update_reports.confirm_body": "Du redigerar nu {{count}} uppdrag. Detta kan inte ångras.",
        "operation_feedback.create_next_job.title_report": "Skapar serviceuppdrag för avtal {{id}}",
        "operation_feedback.create_next_job.title_order": "Skapar order för avtal {{id}}",
        "operation_feedback.create_next_job.step.preflight": "Kontrollerar avtal",
        "operation_feedback.create_next_job.step.create_report": "Skapar serviceuppdrag",
        "operation_feedback.create_next_job.step.create_order": "Skapar order",
        "operation_feedback.create_next_job.step.refresh": "Uppdaterar vyn",
        "operation_feedback.create_next_job.preflight_ok": "Avtalet är klart.",
        "operation_feedback.create_next_job.preflight_failed": "Kan inte starta nästa jobb.",
        "operation_feedback.create_next_job.create_report_ok": "Serviceuppdrag skapades.",
        "operation_feedback.create_next_job.create_order_ok": "Order skapades.",
        "operation_feedback.create_next_job.success_report": "Serviceuppdraget har skapats.",
        "operation_feedback.create_next_job.success_order": "Ordern har skapats.",
        "operation_feedback.create_next_job.open_report": "Öppna rapport {{id}}",
        "operation_feedback.create_next_job.open_order": "Öppna order {{id}}",
        "operation_feedback.create_next_job.create_unconfirmed": "Skapandet är inte bekräftat. Kontrollera avtalet innan du försöker igen.",
        "operation_feedback.update_agreement_orderlines.title": "Sparar orderrader för avtal {{id}}",
        "operation_feedback.update_agreement_orderlines.step.preflight": "Kontrollerar avtal",
        "operation_feedback.update_agreement_orderlines.step.save": "Sparar orderrader",
        "operation_feedback.update_agreement_orderlines.step.refresh": "Uppdaterar vyn",
        "operation_feedback.update_agreement_orderlines.preflight_ok": "Avtalet är klart.",
        "operation_feedback.update_agreement_orderlines.preflight_failed": "Kan inte spara orderrader.",
        "operation_feedback.update_agreement_orderlines.save_ok": "Orderrader sparades.",
        "operation_feedback.update_agreement_orderlines.success": "Orderraderna har sparats.",
        "operation_feedback.copy_report.title": "Kopierar serviceuppdrag {{number}}",
        "operation_feedback.copy_report.step.preflight": "Kontrollerar rapport",
        "operation_feedback.copy_report.step.copy": "Kopierar rapport",
        "operation_feedback.copy_report.step.checklist": "Skapar checklista",
        "operation_feedback.copy_report.preflight_ok": "Rapporten är klar att kopieras.",
        "operation_feedback.copy_report.preflight_failed": "Kan inte kopiera rapporten.",
        "operation_feedback.copy_report.copy_ok": "Rapporten har kopierats.",
        "operation_feedback.copy_report.checklist_ok": "Checklista skapades.",
        "operation_feedback.copy_report.partial_checklist": "Rapporten kopierades, men checklistan kunde inte skapas.",
        "operation_feedback.copy_report.success": "Rapporten har kopierats.",
        "operation_feedback.copy_report.open_report": "Öppna rapport {{id}}",
        "operation_feedback.rectify_report.title": "Skapar uppföljare för {{number}}",
        "operation_feedback.rectify_report.step.preflight": "Kontrollerar rapport",
        "operation_feedback.rectify_report.step.create_sequel": "Skapar uppföljare",
        "operation_feedback.rectify_report.step.checklist": "Skapar checklista",
        "operation_feedback.rectify_report.preflight_ok": "Rapporten är klar.",
        "operation_feedback.rectify_report.preflight_failed": "Kan inte skapa uppföljare.",
        "operation_feedback.rectify_report.preflight_has_sequel": "Rapporten har redan en uppföljare.",
        "operation_feedback.rectify_report.create_ok": "Uppföljare skapades.",
        "operation_feedback.rectify_report.checklist_ok": "Checklista skapades.",
        "operation_feedback.rectify_report.partial_checklist": "Uppföljare skapades, men checklistan kunde inte skapas.",
        "operation_feedback.rectify_report.success": "Uppföljaren har skapats.",
        "operation_feedback.rectify_report.open_report": "Öppna rapport {{id}}",
        "operation_feedback.export_reports_excel.title": "Exporterar serviceuppdrag till Excel",
        "operation_feedback.export_reports_excel.step.preflight": "Kontrollerar filter",
        "operation_feedback.export_reports_excel.step.export": "Genererar Excel",
        "operation_feedback.export_reports_excel.preflight_ok": "Filter ser bra ut.",
        "operation_feedback.export_reports_excel.preflight_failed": "Kan inte starta export.",
        "operation_feedback.export_reports_excel.export_ok": "Excel är klar.",
        "operation_feedback.export_reports_excel.export_failed": "Kunde inte generera Excel.",
        "operation_feedback.export_reports_excel.success": "Excel-exporten är klar.",
        "operation_feedback.export_reports_excel.download": "Ladda ner Excel",
        "operation_feedback.generic_error": "Ett oväntat fel uppstod.",
        "operation_feedback.diagnostics.toggle": "Tekniska detaljer",
        "operation_feedback.diagnostics.loading": "Hämtar tekniska detaljer…",
        "operation_feedback.diagnostics.copy": "Kopiera feldetaljer",
        "operation_feedback.diagnostics.copied": "Kopierat",
        "operation_feedback.diagnostics.not_found": "Hittade inga tekniska detaljer för denna referens.",
        "operation_feedback.diagnostics.forbidden": "Du har inte åtkomst till tekniska detaljer.",
        "operation_feedback.diagnostics.load_failed": "Kunde inte hämta tekniska detaljer.",
    }
}
